(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
(function (global){(function (){
"use strict";

(function () {
  'use strict';

  global.$ = global.jQuery = require('jquery');
  require('input-placeholder-polyfill');
  require('object-fit-polyfill');
  require('what-input');
  require('foundation-sites');
  require('select2');
  require('select2/dist/js/i18n/fr');
  require('slick-carousel');

  // above all config & launch foundation
  Foundation.Interchange.SPECIAL_QUERIES.xxlarge_retina = 'only screen and (min-width: 1440px) and (-webkit-min-device-pixel-ratio: 2), ' + 'only screen and (min-width: 1440px) and (min--moz-device-pixel-ratio: 2), ' + 'only screen and (min-width: 1440px) and (-o-min-device-pixel-ratio: 2/1), ' + 'only screen and (min-width: 1440px) and (min-device-pixel-ratio: 2), ' + 'only screen and (min-width: 1440px) and (min-resolution: 192dpi), ' + 'only screen and (min-width: 1440px) and (min-resolution: 2dppx)';
  $(document).ready(function () {
    $(document).foundation();
  });

  /* Init views scripts
  /* -------------------------------------------------- */
  require('../../bundles/_layout/scripts/_layout');
  require('../../bundles/woocommerce/scripts/cart');
  require('../../bundles/woocommerce/scripts/product');
  require('../../bundles/woocommerce/scripts/configurator');

  /* Handle DOM ready event
  /* -------------------------------------------------- */
})();

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"../../bundles/_layout/scripts/_layout":3,"../../bundles/woocommerce/scripts/cart":4,"../../bundles/woocommerce/scripts/configurator":5,"../../bundles/woocommerce/scripts/product":6,"foundation-sites":7,"input-placeholder-polyfill":8,"jquery":9,"object-fit-polyfill":10,"select2":12,"select2/dist/js/i18n/fr":11,"slick-carousel":13,"what-input":15}],2:[function(require,module,exports){
"use strict";

(function () {
  'use strict';

  var notifier = {
    messages: [],
    init: function init() {
      $('#notifier').hide();
      $('body').on('notifier.showMessages', function () {
        notifier.showMessages();
      });
      $('body').on('notifier.hideMessages', function () {
        notifier.hideMessages();
      });
      $('#notifier .close-button').on('click', function () {
        notifier.hideMessages();
      });
    },
    showMessages: function showMessages() {
      if (notifier.messages.length > 0) {
        notifier.messages.forEach(function (message) {
          $('#notifier .messages-list').append('<li>' + message + '</li>');
        });
        $('#notifier').fadeIn(200);
      }
    },
    hideMessages: function hideMessages() {
      $('#notifier').hide();
      notifier.clearMessages();
    },
    addMessage: function addMessage(message) {
      notifier.messages.push(message);
      notifier.showMessages();
    },
    clearMessages: function clearMessages() {
      $('#notifier .messages-list').html('');
      notifier.messages = [];
    }
  };
  module.exports = notifier;
})();

},{}],3:[function(require,module,exports){
"use strict";

(function () {
  'use strict';

  // Remove the legacy in-house cookie consent cookie now handled by Complianz.
  document.cookie = 'conex-cookies=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
  var notifier = require('../../_components/scripts/notifier');

  /**
   * EVENTS
   */

  $(document).ready(function () {
    // Notifier behavior
    notifier.init();

    // @todo APPLY BG COLOR ON LOAD
    //var dataMainColor = $('#pa_revetement-exterieur').attr('data-maincolor');
    //setSelectedColor(dataMainColor);

    var select2ParamsLight = {
      minimumResultsForSearch: Infinity,
      // at least 20 results must be displayed
      language: "fr",
      allowClear: true,
      placeholder: $(this).attr('data-placeholder'),
      escapeMarkup: function escapeMarkup(m) {
        return m;
      }
    };
    var select2Params = {
      minimumResultsForSearch: Infinity,
      // at least 20 results must be displayed
      language: "fr",
      allowClear: true,
      placeholder: $(this).attr('data-placeholder'),
      escapeMarkup: function escapeMarkup(m) {
        return m;
      },
      templateResult: formatSelect,
      templateSelection: formatSelection
    };
    $(document).on('click', '.js--click-handle-link', function () {
      var link = $(this).attr('data-link');
      window.location.assign(link);
    });

    // Variations select inputs

    var $variationsSelect = $('.variations select');
    $variationsSelect.select2(select2Params);
    $variationsSelect.on('select2:unselecting', function () {
      $(this).data('unselecting', true);
    });
    $variationsSelect.on('select2:unselect', function () {
      unsetSelectedPicture();
    });
    $(document).on('select2:selecting.selectTooltipCleanup', '.variations select', function () {
      var $selectTooltips = $('.select2-container--open .select-tooltip.has-tip');
      if ($selectTooltips.length > 0) {
        $selectTooltips.foundation('_destroy');
      }
    });
    $variationsSelect.on('select2:opening', function (e) {
      if ($(this).data('unselecting')) {
        $(this).removeData('unselecting');
        e.preventDefault();
      }
    });
    $variationsSelect.on('select2:select', function (e) {
      syncSelectedVariationPreview($(e.params.data.element));
    });

    // Les cartes du configurateur mettent a jour le select natif sans
    // emettre select2:select. Ecouter aussi change permet de conserver la
    // synchronisation de l'image et de la couleur quel que soit le mode
    // de selection utilise.
    $variationsSelect.on('change.configuratorPreview', function () {
      syncSelectedVariationPreview($(this).find('option:selected'));
    });

    // Restaure aussi le rendu lors du retour sur une configuration deja
    // renseignee (navigation, panier ou rafraichissement de page).
    $variationsSelect.each(function () {
      syncSelectedVariationPreview($(this).find('option:selected'));
    });
    $(document).on('mouseenter', '.select2-img-itm img, .thumbnail.mini.zoomable, .rack-option-thumb img', function () {
      mouseEnterSelectedPicture(getPreviewPictureUrl($(this)));
    });
    $(document).on('mouseleave', '.select2-img-itm img, .thumbnail.mini.zoomable, .rack-option-thumb img', function () {
      mouseLeaveSelectedPicture();
    });

    // Extra options select inputs

    var $extraSelect = $('.extra-options select');
    $extraSelect.select2(select2ParamsLight);

    // Function for toogle menu on screen resize
    $(window).on('resize', function () {
      $('.menu-toggle').removeClass('is-active');
      if (!Foundation.MediaQuery.atLeast('xlarge')) {
        $('#desktop-top-bar').hide();
      }
    });
    $(document).on('mouseover', '.select2-container--open', function () {
      var $tooltipsToInit = $('.select-tooltip:not(.has-tip)');
      if ($tooltipsToInit.length > 0) {
        $tooltipsToInit.foundation();
      }
    });
  });

  /**
   * FUNCTIONS
   */

  var syncSelectedVariationPreview = function syncSelectedVariationPreview($option) {
    if (!$option || $option.length === 0) {
      return;
    }
    var dataImgSrc = $option.attr('data-imgsrc');
    if (typeof dataImgSrc !== "undefined") {
      setSelectedPicture(dataImgSrc);
    }
    var dataMainColor = $option.attr('data-maincolor');
    var $select = $option.closest('select');
    if ($('.configurator_preview').length > 0 && $select.find('option[data-maincolor]').length > 0) {
      setSelectedColor(typeof dataMainColor === 'undefined' ? '' : dataMainColor);
    }
  };
  var getPreviewPictureUrl = function getPreviewPictureUrl($image) {
    var url = $image.attr('data-preview-src') || $image.attr('data-full-src') || $image.attr('src') || '';
    return url.replace(/-\d+x\d+(\.(?:jpe?g|png|gif|webp)(?:\?.*)?)$/i, '$1');
  };
  var mouseEnterSelectedPicture = function mouseEnterSelectedPicture(url) {
    if (url !== 'undefined') {
      var $imgElt = $('.js--change-product-image');
      if ($imgElt.length > 0) {
        $imgElt.css('opacity', 0);
        $imgElt.attr('src', url);
        $imgElt.parent().addClass('zoom_full');
        $imgElt.stop().animate({
          'opacity': 1
        });
        $('.product-single__cat--content--container').stop().animate({
          'opacity': 0
        });
      }
    }
  };
  var mouseLeaveSelectedPicture = function mouseLeaveSelectedPicture() {
    var $imgElt = $('.js--change-product-image');
    if ($imgElt.length > 0) {
      $imgElt.css('opacity', 0);
      $imgElt.attr('src', $imgElt.attr('data-src-selected'));
      $imgElt.parent().removeClass('zoom_full');
      $('.product-single__cat--content--container').stop().animate({
        'opacity': 1
      });
      $imgElt.stop().animate({
        'opacity': 1
      });
    }
  };
  var setSelectedPicture = function setSelectedPicture(url) {
    if (url !== 'undefined') {
      var $imgElt = $('.js--change-product-image');
      if ($imgElt.length > 0) {
        if ($imgElt.hasClass('js--configurator_preview--img')) {
          unsetSelectedPicture();
        } else {
          $imgElt.attr('src', url);
          $imgElt.attr('data-src-selected', url);
          $imgElt.parent().removeClass('zoom_full');
          $('.product-single__cat--content--container').stop().animate({
            'opacity': 1
          });
        }
      }
    }
  };
  var setSelectedColor = function setSelectedColor(color) {
    var _configurators = $('.configurator_preview--front, .configurator_preview--side, .configurator_preview--back, .configurator_preview--side2, .configurator_preview--bottom, .configurator_preview--top');
    if (typeof color !== 'undefined') {
      _configurators.css('background-color', color);
    }
  };
  var unsetSelectedPicture = function unsetSelectedPicture() {
    var $imgElt = $('.js--change-product-image');
    if ($imgElt.length > 0) {
      $imgElt.css('opacity', 0);
      $imgElt.attr('src', $imgElt.attr('data-src-origin'));
      $imgElt.stop().animate({
        'opacity': 1
      });
      $imgElt.parent().removeClass('zoom_full');
      $('.product-single__cat--content--container').stop().animate({
        'opacity': 1
      });
    }
  };
  var formatSelect = function formatSelect(option, container) {
    var imgsrc = $(option.element).attr('data-imgsrc');
    var title = option.text;
    if (typeof $(option.element).parent().get(0) !== 'undefined' && $(option.element).parent().get(0).childElementCount === 2 && option.selected === true) {
      $(container).css('display', 'list-item');
      return 'Pas d\'autre combinaison possible avec les options choisies.';
    }
    if (imgsrc) {
      $(container).addClass('select2-img-itm');
      var $html = '<div data-tooltip data-click-open="false" title="' + title + '" class="select-tooltip">';
      $html += '<img src="' + imgsrc + '" alt="image ' + title + '"  class="thumbnail" />';
      $html += '</div>';
      return $html;
    } else {
      return title;
    }
  };
  var formatSelection = function formatSelection(option) {
    if ($(option.element).attr('data-imgsrc')) {
      return '<img src="' + $(option.element).attr('data-imgsrc') + '" alt="image ' + option.text + '"  class="thumbnail mini zoomable" /><span>' + option.text + '</span>';
    } else {
      return '<span>' + option.text + '</span>';
    }
  };
})();

},{"../../_components/scripts/notifier":2}],4:[function(require,module,exports){
"use strict";

/**
 * Handle blog javascript behavior
 */
(function () {
  'use strict';

  $(document).on('click', '.js--open-cart-preview', function (e) {
    e.preventDefault();
    $('.cart-preview').trigger('open');
  });
  $(document).on('open', '.cart-preview', function () {
    $('.cart-preview').removeClass('hide').fadeIn();
  });
  $(document).on('click', '.woocommerce-notices-wrapper .close-button', function () {
    $(this).parents('.woocommerce-notices-wrapper').fadeOut(function () {
      $(this).remove();
    });
  });
})();

},{}],5:[function(require,module,exports){
"use strict";

/**
 * Handle product price javascript behavior
 */
(function () {
  'use strict';

  var notifier = require('../../_components/scripts/notifier');

  /*
   * Global vars
   */

  // --- ZOOM RELATED VARS ---
  var maxZoomPx = 0;
  var currentZoom = 1;
  var maxZoom = 1; // 1 = 100%
  var minZoom = 0.5;
  var zoomStep = 0.1;

  // --- INPUT RELATED VARS ---
  var inputWidth = 0;
  var inputLength = 0;
  var inputHeight = 0;

  // --- FLIGHT CASE RELATED VARS ---
  var caseMaxSize = 0;
  var currentConfiguratorPartsSize = null;
  var isSwappingLengthWidth = false;
  var dimensionOrientationBlurTimer = null;
  var customCapHeightMin = 75;
  var customCapHeightDefault = 75;
  var valiseLightweightMaterialSlug = 'plastique-alveolaire-7mm';
  var valiseLightweightCapHeightMin = 38;
  var valiseStandardCapHeightMin = 48;
  var valiseCustomCapVisualOffset = 40;
  var valiseLastMaterialSlug = '';
  var valiseMaterialFlowSyncing = false;
  var valiseMaterialFamilySelector = '#valise_material_family';
  var valiseMaterialThicknessSelector = '#valise_panel_thickness';
  var valiseSideHandleMinimumHeight = 190;
  var valiseTrolleyMinimumHeight = 200;
  var valiseTrolleyHandleClearance = 145;
  var valiseHingedCapSlug = 'capot-sur-charnieres';
  var valiseRemovableCapSlug = 'capot-amovible';
  var customCapHeightHingedMax = 150;
  var customCapHeightInputSelector = '#capot_height_mm';
  var customCapHeightLastValidValue = customCapHeightDefault;
  var isSyncingRackDimensions = false;
  var rackRefreshFrame = null;
  var rackPreviewUpdateTimer = null;
  var rackStandardWidthMm = 483;
  var rackUnitHeightMm = 44.45;
  var rackCaseHeightOffsetUnits = 1;
  var rackMinUnits = 2;
  var rackMaxUnits = 30;
  var rackDefaultUnits = 4;
  var rackDefaultDepthMm = 500;
  var rackMinUsableBodyLengthMm = 200;
  var rackFlatCapDepthMm = 40;
  var rackFlatCapPanelExtraMm = 20;
  var rackFlatCapDefaultClearanceMm = 0;
  var rackCapDepthMinMm = 75;
  var rackCapDepthDefaultMm = 75;
  var rackCapDepthMaxMm = 1000;
  var rackCapDepthInputSelector = '#rack_cap_depth_mm';
  var rackRearCapDepthInputSelector = '#rack_rear_cap_depth_mm';
  var rackTotalLengthInputSelector = '#rack_total_length_mm';
  var rackCustomTotalLengthInitialized = false;
  var rackFlatCapPriceAdjustment = -50;
  var rackFlatCapAdditionalCapPrice = 50;
  var rackClassicAdditionalCapBaseUnits = 2;
  var rackClassicAdditionalCapBasePrice = 35;
  var rackClassicAdditionalCapUnitStepPrice = 5;
  var palletFootLengthMm = 150;
  var palletFootHeightMm = 102;
  var casterWheelHeightMm = 132;
  var casterSupportHeightMm = 18;
  var casterTotalHeightMm = casterWheelHeightMm + casterSupportHeightMm;
  var casterEndViewWidthMm = 149;
  var casterSideViewWidthMm = 183;
  var clocheDoubleCapLockerPairHeightThreshold = 1200;

  // --- FLIGHT CASE PARTS RELATED VARS ---
  var hingeSize = 0;
  var hingeFlatSize = 0;
  var holeSize = 0;
  var capSize = 0;
  var holderSize = 0;
  var cornerSize = 0;
  var handleSize = 0;
  var wheelSize = 0;
  var wheelHeight = 0;
  var capfixerSize = 0;
  var tagHolderSize = 0;
  var lockerfrontSize = 0;
  var locker2frontSize = 0;
  var braceSize = 0;

  // --- LOCKERS RELATED VARS ---
  var $lockerSelect;
  var $grenouilleSimple;
  var $grenouilleClef;
  var $papillon;

  /*
   * Functions
   */
  var normalizeDoubleClocheOptionRow = function normalizeDoubleClocheOptionRow() {
    var $row = $('tr.capot_double_cloche');
    if (!$row.length || $row.data('double-cloche-normalized')) {
      return;
    }
    var $checkbox = $('#capot_double_cloche');
    var $hidden = $row.find('input[type="hidden"][name="capot_double_cloche"]');
    if (!$checkbox.length) {
      return;
    }
    var labelText = $.trim($row.text()) || 'Option capot double pour cloche';
    var $labelCell = $('<td class="label leftside"><label class="label-tag">Option du capot</label></td>');
    var $valueCell = $('<td class="value leftside"></td>');
    var $optionLabel = $('<label for="capot_double_cloche" class="label-tag checkbox" style="display:inline; margin-right: 10px;"></label>');
    $checkbox.detach();
    $hidden.detach();
    if ($hidden.length) {
      $valueCell.append($hidden);
    }
    $optionLabel.append($checkbox).append(' ' + labelText);
    $valueCell.append($optionLabel);
    $row.empty().append($labelCell).append($valueCell).data('double-cloche-normalized', true);
  };
  var isRackConfigurator = function isRackConfigurator() {
    return $('body').hasClass('flight-case-type-rack') || $('body').hasClass('postid-313');
  };
  var isClocheConfigurator = function isClocheConfigurator() {
    return $('body').hasClass('flight-case-type-cloche') || $('body').hasClass('flight-case-cloche') || $('body').hasClass('postid-1711');
  };
  var isValiseConfigurator = function isValiseConfigurator() {
    return $('body').hasClass('flight-case-type-valise') || $('body').hasClass('postid-312');
  };
  var isValisePricingV2Enabled = function isValisePricingV2Enabled() {
    var enabled = window.configurator_options && window.configurator_options.valise_pricing_v2_enabled;
    return isValiseConfigurator() && (enabled === true || enabled === 1 || enabled === '1' || enabled === 'yes');
  };
  var getValiseCapTypeValue = function getValiseCapTypeValue() {
    var value = $('#pa_configurateur-type-de-capot').val();
    return value === valiseHingedCapSlug || value === valiseRemovableCapSlug ? value : '';
  };
  var getValiseConfiguratorPieceAssetUrl = function getValiseConfiguratorPieceAssetUrl(fileName) {
    var $image = $('.configurator_preview--artboard img[src*="/configurator-pieces/"], ' + '.configurator_preview--artboard img[data-lazy-src*="/configurator-pieces/"], ' + '.configurator_preview--artboard img[data-src*="/configurator-pieces/"]').first();
    var source = $image.attr('data-lazy-src') || $image.attr('data-src') || $image.attr('src') || '';
    var separatorIndex = source.lastIndexOf('/');
    return separatorIndex >= 0 ? source.slice(0, separatorIndex + 1) + fileName : '';
  };
  var prepareValiseCapTypeField = function prepareValiseCapTypeField() {
    if (!isValiseConfigurator()) {
      return;
    }
    var $capType = $('#pa_configurateur-type-de-capot');
    if (!$capType.length) {
      return;
    }
    var hingedImage = getValiseConfiguratorPieceAssetUrl('pivot.svg');
    var removableImage = getValiseConfiguratorPieceAssetUrl('locker2-medium.svg');
    var $hingedOption = $capType.find('option[value="' + valiseHingedCapSlug + '"]');
    var $removableOption = $capType.find('option[value="' + valiseRemovableCapSlug + '"]');
    $capType.find('option[value="capot-plat"]').remove();
    $hingedOption.text('Capot sur charnières');
    $removableOption.text('Capot amovible');
    if (hingedImage) {
      $hingedOption.attr('data-imgsrc', hingedImage);
    }
    if (removableImage) {
      $removableOption.attr('data-imgsrc', removableImage);
    }
    $capType.closest('tr').removeClass('hide').addClass('valise-cap-type-row');
    $capType.next('.select2').show();
    $capType.trigger('change.select2');
  };
  var applyValiseCapTypeVisualState = function applyValiseCapTypeVisualState() {
    if (!isValiseConfigurator()) {
      return;
    }

    // Preserve the historical hinged preview while the customer has not
    // chosen yet, without completing the WooCommerce attribute for them.
    setCapParts(getValiseCapTypeValue() || valiseHingedCapSlug);

    // The two end braces are part of the historical Valise geometry.
    // Keep them for both cap types; only pivots/stops are conditional.
    $('.configurator_preview--back .cap-parts-container > .configurator_preview-brace').css('display', '').css('opacity', '1');
  };
  var getFlightCaseAccessoryFamily = function getFlightCaseAccessoryFamily() {
    if ($('body').hasClass('flight-case-type-malle') || $('body').hasClass('postid-309')) {
      return 'malle';
    }
    if (isClocheConfigurator()) {
      return 'cloche';
    }
    return '';
  };
  var getMobilityAccessoryFamily = function getMobilityAccessoryFamily() {
    if (isRackConfigurator()) {
      return 'rack';
    }
    return getFlightCaseAccessoryFamily();
  };
  var getMobilityType = function getMobilityType() {
    if (isValiseConfigurator()) {
      return 'none';
    }
    var value = $('#wheels').val();
    if (value === 'wheels-1') {
      return 'wheels';
    }
    return value === 'pallet-feet' ? 'pallet-feet' : 'none';
  };
  var getMobilitySixPieceLengthMm = function getMobilitySixPieceLengthMm() {
    var configuredValue = window.configurator_options && window.configurator_options.mobility_six_piece_length_mm;
    var parsedValue = parseFloat(String(configuredValue || '').replace(',', '.'));
    return !isNaN(parsedValue) && parsedValue > 0 ? parsedValue : 1600;
  };
  var getMobilityPieceCount = function getMobilityPieceCount() {
    if (getMobilityType() === 'none') {
      return 0;
    }
    var parsedLength = parseFloat(inputLength);
    var parsedWidth = parseFloat(inputWidth);
    var normalizedLength = Math.max(isNaN(parsedLength) ? 0 : parsedLength, isNaN(parsedWidth) ? 0 : parsedWidth);
    return normalizedLength >= getMobilitySixPieceLengthMm() ? 6 : 4;
  };
  var prepareMobilityField = function prepareMobilityField() {
    if (isValiseConfigurator()) {
      return;
    }
    var $mobility = $('#wheels');
    if (!$mobility.length) {
      return;
    }
    var family = getMobilityAccessoryFamily();
    var wheelCodes = {
      rack: 'rack_wheel',
      malle: 'malle_wheel_standard',
      cloche: 'cloche_wheel_standard'
    };
    var palletEntry = family ? getRackCatalogAccessory(family + '_pallet_foot') : null;
    var wheelEntry = family && wheelCodes[family] ? getRackCatalogAccessory(wheelCodes[family]) : null;
    var palletImageUrl = palletEntry && palletEntry.image_url ? palletEntry.image_url : getValiseConfiguratorPieceAssetUrl('plots.svg');
    var wheelImageUrl = wheelEntry && wheelEntry.image_url ? wheelEntry.image_url : getValiseConfiguratorPieceAssetUrl(isRackConfigurator() ? 'wheel-rack.svg' : 'wheel.svg');
    var $wheelOption = $mobility.find('option[value="wheels-1"]');
    var $palletFeetOption = $mobility.find('option[value="pallet-feet"]');
    $mobility.find('option[value="wheels-0"]').text('Sans mobilité');
    $mobility.find('option[value="wheels-1"]').text('Roulettes');
    if (!$palletFeetOption.length) {
      $palletFeetOption = $('<option value="pallet-feet">Plots palettisables</option>').appendTo($mobility);
    } else {
      $palletFeetOption.text('Plots palettisables');
    }
    if (wheelImageUrl) {
      $wheelOption.attr('data-imgsrc', wheelImageUrl);
    }
    if (palletImageUrl) {
      $palletFeetOption.attr('data-imgsrc', palletImageUrl);
    }
    $mobility.closest('tr').addClass('mobility-option-row').find('th.label label, td.label label, .label-tag').first().text('Mobilité');
    $mobility.attr('data-placeholder', 'Mobilité').trigger('change.select2');
  };
  var escapeHtml = function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function (character) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#039;'
      }[character];
    });
  };
  var getRackConfiguratorOptionText = function getRackConfiguratorOptionText(key, fallback) {
    if (!window.configurator_options || typeof window.configurator_options[key] === 'undefined' || window.configurator_options[key] === '') {
      return fallback;
    }
    return window.configurator_options[key];
  };
  var getRackCatalogAccessory = function getRackCatalogAccessory(code) {
    var catalog = window.configurator_options && window.configurator_options.accessory_catalog;
    if (!catalog || !code) {
      return null;
    }
    if (catalog[code]) {
      return catalog[code];
    }
    if (Array.isArray(catalog)) {
      for (var index = 0; index < catalog.length; index++) {
        if (catalog[index] && catalog[index].code === code) {
          return catalog[index];
        }
      }
    }
    return null;
  };
  var getRackCatalogAccessoryLabel = function getRackCatalogAccessoryLabel(code, fallback) {
    var accessory = getRackCatalogAccessory(code);
    if (!accessory || !accessory.label) {
      return fallback;
    }
    return String(accessory.label).replace(/^Rack\s*-\s*/i, '');
  };
  var getRackCatalogAccessoryImageUrl = function getRackCatalogAccessoryImageUrl(code) {
    var accessory = getRackCatalogAccessory(code);
    return accessory && accessory.image_url ? accessory.image_url : '';
  };
  var buildRackRoundImageHtml = function buildRackRoundImageHtml(src, alt, extraClass) {
    if (!src) {
      return '';
    }
    return '<span class="rack-option-thumb ' + (extraClass || '') + '"><img src="' + escapeHtml(src) + '" data-preview-src="' + escapeHtml(src) + '" data-full-src="' + escapeHtml(src) + '" alt="' + escapeHtml(alt) + '" /></span>';
  };
  var buildRackRailOptionHtml = function buildRackRailOptionHtml(id, code, fallbackLabel) {
    var label = getRackCatalogAccessoryLabel(code, fallbackLabel);
    var imageUrl = getRackCatalogAccessoryImageUrl(code);
    return '<label class="rack-rail-fastener-option" for="' + id + '">' + '<input type="checkbox" id="' + id + '" class="rack-rail-fastener-input" name="' + id + '" value="yes" data-accessory-code="' + code + '" />' + buildRackRoundImageHtml(imageUrl, label, 'rack-option-thumb-small') + '<span class="rack-rail-fastener-label">' + escapeHtml(label) + '</span>' + '<span class="rack-rail-fastener-count">4 x U</span>' + '</label>';
  };
  var isRackSideHandlesEnabled = function isRackSideHandlesEnabled() {
    return isRackConfigurator() && $('#rack_side_handles').is(':checked');
  };
  var getRackSideHandlePositionValue = function getRackSideHandlePositionValue() {
    var value = $('input[name="rack_sidehandle_position"]:checked').val();
    return value || 'center-position';
  };
  var syncRackSideHandleOptionState = function syncRackSideHandleOptionState() {
    if (!isRackConfigurator()) {
      return;
    }
    var enabled = isRackSideHandlesEnabled();
    $('body').toggleClass('rack-side-handles-enabled', enabled);
    $('.rack-sidehandle-position').toggleClass('hide', !enabled);
    $('.rack-sidehandle-position input[name="rack_sidehandle_position"]').prop('disabled', !enabled);
    if (window.configurator_options) {
      window.configurator_options.rack_side_handles = enabled ? 'yes' : 'no';
      window.configurator_options.rack_side_handle_count = enabled ? 2 : 0;
      window.configurator_options.rack_side_handle_position = getRackSideHandlePositionValue();
    }
  };
  var getValiseSideHandleHeight = function getValiseSideHandleHeight() {
    return parseInt($('.height-input:first input[name="height_needed"]:first').val(), 10);
  };
  var isValiseSideHandleAvailable = function isValiseSideHandleAvailable() {
    var height = getValiseSideHandleHeight();
    return !isNaN(height) && height >= valiseSideHandleMinimumHeight;
  };
  var alignValiseSideHandlesToRenderedLowerBody = function alignValiseSideHandlesToRenderedLowerBody() {
    if (!isValisePricingV2Enabled() || !isValiseSideHandleAvailable() || !$('#valise_side_handles').is(':checked')) {
      return;
    }
    var $view = $('.configurator_preview--side.current-view').filter(function () {
      var rect = this.getBoundingClientRect();
      return rect.width > 0 && rect.height > 0;
    }).first();
    if (!$view.length) {
      return;
    }
    var capProfileNode = $view.find('.configurator_preview-cap svg').filter(function () {
      var rect = this.getBoundingClientRect();
      return rect.width > 0 && rect.height > 0;
    }).first().get(0);
    var bottomProfileNode = $view.find('.configurator_preview-hinge-bottom svg').filter(function () {
      var rect = this.getBoundingClientRect();
      return rect.width > 0 && rect.height > 0;
    }).first().get(0);
    if (!capProfileNode || !bottomProfileNode) {
      return;
    }
    var capProfileRect = capProfileNode.getBoundingClientRect();
    var bottomProfileRect = bottomProfileNode.getBoundingClientRect();
    var lowerBodyTop = capProfileRect.bottom;
    var lowerBodyBottom = bottomProfileRect.top;
    var lowerBodyHeight = lowerBodyBottom - lowerBodyTop;
    var viewRect = $view.get(0).getBoundingClientRect();
    var viewCssHeight = parseFloat($view.css('height'));
    var scaleY = viewCssHeight > 0 ? viewRect.height / viewCssHeight : 1;
    if (lowerBodyHeight <= 0) {
      return;
    }
    if (!scaleY || isNaN(scaleY)) {
      scaleY = 1;
    }
    $view.find('.configurator_preview-handle-center, .configurator_preview-handle-left, .configurator_preview-handle-right').filter(function () {
      var $handle = $(this);
      var rect = this.getBoundingClientRect();
      return rect.width > 0 && $handle.css('display') !== 'none' && !$handle.hasClass('hide');
    }).each(function () {
      var $handle = $(this);
      var $img = $handle.find('img').filter(function () {
        var $candidate = $(this);
        var rect = this.getBoundingClientRect();
        return rect.width > 0 && rect.height > 0 && $candidate.css('display') !== 'none' && !$candidate.hasClass('hide');
      }).first();
      if (!$img.length) {
        return;
      }
      var imgRect = $img.get(0).getBoundingClientRect();
      var currentTop = parseFloat($handle.css('top'));
      if (isNaN(currentTop) || !imgRect.height) {
        return;
      }
      var targetImageTop = lowerBodyTop + (lowerBodyHeight - imgRect.height) / 2;
      $handle.css('top', currentTop + (targetImageTop - imgRect.top) / scaleY + 'px');
    });
  };
  var refreshValiseSideHandleAlignment = function refreshValiseSideHandleAlignment() {
    if (!isValisePricingV2Enabled()) {
      return;
    }
    alignValiseSideHandlesToRenderedLowerBody();
    if (window.requestAnimationFrame) {
      window.requestAnimationFrame(alignValiseSideHandlesToRenderedLowerBody);
    }
    window.setTimeout(alignValiseSideHandlesToRenderedLowerBody, 120);
    window.setTimeout(alignValiseSideHandlesToRenderedLowerBody, 320);
  };
  var getValiseSideHandleCount = function getValiseSideHandleCount() {
    if (!isValisePricingV2Enabled() || !isValiseSideHandleAvailable() || !$('#valise_side_handles').is(':checked')) {
      return 0;
    }
    var width = parseInt($('.width-input:first input[name="width_needed"]:first').val(), 10);
    return !isNaN(width) && width >= 600 ? 4 : 2;
  };
  var syncValiseSideHandlePreview = function syncValiseSideHandlePreview() {
    if (!isValiseConfigurator()) {
      return;
    }
    var count = getValiseSideHandleCount();
    var $sideView = $('.configurator_preview--side');
    var $center = $sideView.find('.configurator_preview-handle-center');
    var $pair = $sideView.find('.configurator_preview-handle-left, .configurator_preview-handle-right');
    $center.addClass('hide').css('display', 'none');
    $pair.addClass('hide').css('display', 'none');
    if (count === 2) {
      $center.removeClass('hide').css('display', '');
    } else if (count === 4) {
      $pair.removeClass('hide').css('display', '');
    }
    refreshValiseSideHandleAlignment();
  };
  var syncValiseSideHandleOptionState = function syncValiseSideHandleOptionState() {
    if (!isValisePricingV2Enabled()) {
      return;
    }
    var $checkbox = $('#valise_side_handles');
    var $choice = $checkbox.closest('label');
    var available = isValiseSideHandleAvailable();
    var disabledTitle = 'Disponible a partir de ' + valiseSideHandleMinimumHeight + ' mm de hauteur interieure.';
    if (!available && $checkbox.is(':checked')) {
      $checkbox.prop('checked', false);
    }
    $checkbox.prop('disabled', !available).attr('aria-disabled', available ? 'false' : 'true').attr('title', available ? '' : disabledTitle);
    $choice.attr('title', available ? '' : disabledTitle).css({
      'opacity': available ? '' : '0.45',
      'cursor': available ? '' : 'not-allowed'
    });
    var count = getValiseSideHandleCount();
    var enabled = count > 0;
    var $positionRow = $('tr.sidehandle_position').first();
    var $positionInputs = $positionRow.find('input[name="sidehandle_position"]');
    var $positionFallback = $('#valise_sidehandle_position_fallback');
    var $cartForm = $positionRow.closest('form.cart');
    $('body').toggleClass('valise-side-handles-enabled', enabled);
    $('.valise-side-handle-count-note').remove();
    $('.configurator_preview-handle-surface').css('pointer-events', 'none');
    $positionRow.addClass('hide').hide().attr('aria-hidden', 'true');
    $positionInputs.prop('checked', false).prop('disabled', true);
    $positionInputs.filter('[value="center-position"]').prop('checked', true);
    if (!$positionFallback.length && $cartForm.length) {
      $('<input type="hidden" name="sidehandle_position" id="valise_sidehandle_position_fallback" value="center-position" />').appendTo($cartForm);
    } else {
      $positionFallback.val('center-position');
    }
    if (window.configurator_options) {
      window.configurator_options.valise_side_handles = enabled ? 'yes' : 'no';
      window.configurator_options.valise_side_handle_count = count;
      window.configurator_options.valise_main_handle_count = 1;
    }
    sideHandleHideShow(false);
    syncValiseSideHandlePreview();
  };
  var isValiseCustomCapHeightConfigurator = function isValiseCustomCapHeightConfigurator() {
    return $('body').hasClass('flight-case-type-valise');
  };
  var isCustomCapHeightConfigurator = function isCustomCapHeightConfigurator() {
    return $('body').hasClass('flight-case-type-malle') || $('body').hasClass('flight-case-cloche') || isValiseCustomCapHeightConfigurator();
  };
  var getValiseSelectedMaterialSlug = function getValiseSelectedMaterialSlug() {
    return $('#pa_configurateur-matiere').val() || '';
  };
  var getValiseMaterialFamilyFromNativeSlug = function getValiseMaterialFamilyFromNativeSlug(materialSlug) {
    switch (materialSlug) {
      case 'aluminium-alveole-10mm':
        return 'aluminium';
      case 'bouleau-multiplis-9mm':
        return 'bouleau';
      case 'plastique-alveolaire-7mm':
      case 'triplex-10mm':
        return 'plastique-alveolaire';
      default:
        return '';
    }
  };
  var getValiseMaterialThicknessFromNativeSlug = function getValiseMaterialThicknessFromNativeSlug(materialSlug) {
    if (materialSlug === 'plastique-alveolaire-7mm') {
      return '7';
    }
    if (materialSlug === 'triplex-10mm') {
      return '10';
    }
    return '';
  };
  var getValiseNativeMaterialSlugFromFlow = function getValiseNativeMaterialSlugFromFlow(family, thickness) {
    if (family === 'aluminium') {
      return 'aluminium-alveole-10mm';
    }
    if (family === 'bouleau') {
      return 'bouleau-multiplis-9mm';
    }
    if (family === 'plastique-alveolaire') {
      if (thickness === '7') {
        return 'plastique-alveolaire-7mm';
      }
      if (thickness === '10') {
        return 'triplex-10mm';
      }
    }
    return '';
  };
  var formatValiseMaterialFlowOption = function formatValiseMaterialFlowOption(option, container) {
    var $option = $(option.element);
    var imgsrc = $option.attr('data-imgsrc');
    if ($option.parent().is(valiseMaterialThicknessSelector) && option.id) {
      $(container).addClass('valise-thickness-select2-option');
      return $('<div class="valise-thickness-option"></div>').append($('<strong></strong>').text(option.id + ' mm')).append($('<span></span>').text(option.id === '7' ? 'Option légère' : 'Protection renforcée'));
    }
    if (!option.id || !imgsrc) {
      return option.text;
    }
    $(container).addClass('select2-img-itm');
    return $('<div class="select-tooltip" data-tooltip data-click-open="false"></div>').attr('title', option.text).append($('<img class="thumbnail" />').attr('src', imgsrc).attr('alt', 'image ' + option.text));
  };
  var formatValiseMaterialFlowSelection = function formatValiseMaterialFlowSelection(option) {
    var $option = $(option.element);
    var imgsrc = $option.attr('data-imgsrc');
    if (!imgsrc) {
      return $('<span></span>').text(option.text);
    }
    return $('<span class="valise-flow-selection"></span>').append($('<img class="thumbnail mini zoomable" />').attr('src', imgsrc).attr('alt', 'image ' + option.text)).append($('<span></span>').text(option.text));
  };
  var initValiseMaterialFlowSelect = function initValiseMaterialFlowSelect($select) {
    if (!$select.length || $select.data('select2')) {
      return;
    }
    var options = {
      minimumResultsForSearch: Infinity,
      language: 'fr',
      allowClear: true,
      placeholder: $select.attr('data-placeholder'),
      templateResult: formatValiseMaterialFlowOption,
      templateSelection: formatValiseMaterialFlowSelection
    };
    $select.select2(options);
    if ($select.is(valiseMaterialThicknessSelector)) {
      $select.on('select2:open.valiseThicknessCards', function () {
        $('.select2-container--open .select2-dropdown').addClass('valise-thickness-dropdown');
      });
    }
  };
  var setValiseColorPlaceholder = function setValiseColorPlaceholder() {
    var $covering = $('#pa_configurateur-revetement');
    var $firstOption = $covering.find('option:first');
    if (!$covering.length) {
      return;
    }
    $covering.attr('data-placeholder', 'Configurateur : couleur');
    $firstOption.text('Configurateur : couleur');
    $covering.next('.select2-container').find('.select2-selection__placeholder span').text('Configurateur : couleur');
    if (!$covering.val()) {
      $covering.next('.select2-container').find('.select2-selection__rendered').attr('title', 'Configurateur : couleur');
    }
  };
  var updateValiseColorLock = function updateValiseColorLock() {
    var family = $(valiseMaterialFamilySelector).val() || '';
    var thickness = $(valiseMaterialThicknessSelector).val() || '';
    var locked = !family || family === 'plastique-alveolaire' && !thickness;
    var $covering = $('#pa_configurateur-revetement');
    var $row = $covering.closest('tr');
    var $selection = $covering.next('.select2-container').find('.select2-selection');
    var $hint = $row.find('.js--valise-color-lock-hint');
    var hint = family === 'plastique-alveolaire' ? 'Choisissez d’abord l’épaisseur.' : 'Choisissez d’abord la matière.';
    $row.toggleClass('valise-color-locked', locked);
    $selection.attr('aria-disabled', locked ? 'true' : 'false');
    $selection.attr('tabindex', locked ? '-1' : '0');
    $hint.text(locked ? hint : '').toggle(locked);
  };
  var setValiseNativeMaterialFromFlow = function setValiseNativeMaterialFromFlow(materialSlug) {
    var $material = $('#pa_configurateur-matiere');
    var $covering = $('#pa_configurateur-revetement');
    valiseMaterialFlowSyncing = true;
    $covering.val('').trigger('change');
    $material.val(materialSlug).trigger('change');
    valiseMaterialFlowSyncing = false;
    window.setTimeout(function () {
      setValiseColorPlaceholder();
      updateValiseColorLock();
      updateRequiredConfiguratorSteps(false);
    }, 0);
  };
  var syncValiseMaterialFlowFromNative = function syncValiseMaterialFlowFromNative() {
    if (!isValiseCustomCapHeightConfigurator() || valiseMaterialFlowSyncing) {
      return;
    }
    var materialSlug = getValiseSelectedMaterialSlug();
    var family = getValiseMaterialFamilyFromNativeSlug(materialSlug);
    var thickness = getValiseMaterialThicknessFromNativeSlug(materialSlug);
    var $family = $(valiseMaterialFamilySelector);
    var $thickness = $(valiseMaterialThicknessSelector);
    var $thicknessRow = $('.js--valise-material-thickness-row');
    valiseMaterialFlowSyncing = true;
    $family.val(family).trigger('change.select2');
    $thickness.val(thickness).trigger('change.select2');
    $thicknessRow.toggleClass('hide', family !== 'plastique-alveolaire');
    valiseMaterialFlowSyncing = false;
    setValiseColorPlaceholder();
    updateValiseColorLock();
    updateValiseMaterialBenefitMessage();
  };
  var initValiseMaterialFlow = function initValiseMaterialFlow() {
    if (!isValiseCustomCapHeightConfigurator() || $(valiseMaterialFamilySelector).length) {
      return;
    }
    var $material = $('#pa_configurateur-matiere');
    var $nativeRow = $material.closest('tr');
    var $covering = $('#pa_configurateur-revetement');
    var $coveringRow = $covering.closest('tr');
    var aluminiumImage = $material.find('option[value="aluminium-alveole-10mm"]').attr('data-imgsrc') || '';
    var woodImage = $material.find('option[value="bouleau-multiplis-9mm"]').attr('data-imgsrc') || '';
    var plasticImage = $material.find('option[value="plastique-alveolaire-7mm"]').attr('data-imgsrc') || '';
    var plasticBlackImage = $material.find('option[value="triplex-10mm"]').attr('data-imgsrc') || plasticImage;
    var $familyRow = $('<tr class="valise-material-flow-row valise-material-family-row"></tr>');
    var $familyValue = $('<td class="value"></td>');
    var $family = $('<select id="valise_material_family" data-placeholder="Configurateur : matière"></select>');
    var $thicknessRow = $('<tr class="valise-material-flow-row valise-material-thickness-row js--valise-material-thickness-row hide"></tr>');
    var $thicknessValue = $('<td class="value"></td>');
    var $thickness = $('<select id="valise_panel_thickness" data-placeholder="Configurateur : épaisseur"></select>');
    if (!$material.length || !$covering.length) {
      return;
    }
    $family.append($('<option value="">Configurateur : matière</option>')).append($('<option value="aluminium">Aluminium alvéolé</option>').attr('data-imgsrc', aluminiumImage)).append($('<option value="bouleau">Bouleau multiplis</option>').attr('data-imgsrc', woodImage)).append($('<option value="plastique-alveolaire">Plastique alvéolaire</option>').attr('data-imgsrc', plasticImage));
    $thickness.append($('<option value="">Configurateur : épaisseur</option>')).append($('<option value="7">7 mm — option légère</option>').attr('data-imgsrc', plasticImage)).append($('<option value="10">10 mm — protection renforcée</option>').attr('data-imgsrc', plasticBlackImage));
    $familyValue.append('<div class="valise-flow-field-label">Matière</div>').append($family);
    $familyRow.append('<th class="label"><label for="valise_material_family">Matière</label></th>').append($familyValue);
    $thicknessValue.append('<div class="valise-flow-field-label">Épaisseur</div>').append($thickness);
    $thicknessRow.append('<th class="label"><label for="valise_panel_thickness">Épaisseur</label></th>').append($thicknessValue);
    $nativeRow.addClass('valise-native-material-row');
    $familyRow.insertBefore($nativeRow);
    $thicknessRow.insertAfter($familyRow);
    $coveringRow.addClass('valise-color-row');
    $coveringRow.find('td.value').prepend('<div class="valise-flow-field-label">Couleur</div>');
    $coveringRow.find('td.value').append('<div class="valise-color-lock-hint js--valise-color-lock-hint" aria-live="polite"></div>');
    initValiseMaterialFlowSelect($family);
    initValiseMaterialFlowSelect($thickness);
    setValiseColorPlaceholder();
    syncValiseMaterialFlowFromNative();
    $family.on('change.valiseMaterialFlow', function (event) {
      var family;
      if (valiseMaterialFlowSyncing) {
        return;
      }
      event.stopPropagation();
      family = $family.val() || '';
      valiseMaterialFlowSyncing = true;
      $thickness.val('').trigger('change.select2');
      $thicknessRow.toggleClass('hide', family !== 'plastique-alveolaire');
      valiseMaterialFlowSyncing = false;
      setValiseNativeMaterialFromFlow(getValiseNativeMaterialSlugFromFlow(family, ''));
    });
    $thickness.on('change.valiseMaterialFlow', function (event) {
      if (valiseMaterialFlowSyncing) {
        return;
      }
      event.stopPropagation();
      setValiseNativeMaterialFromFlow(getValiseNativeMaterialSlugFromFlow($family.val() || '', $thickness.val() || ''));
    });
    $(document).off('.valiseMaterialFlow');
    $(document).on('change.valiseMaterialFlow', '#pa_configurateur-matiere', function () {
      if (valiseMaterialFlowSyncing) {
        return;
      }
      window.setTimeout(syncValiseMaterialFlowFromNative, 0);
    });
    $(document).on('woocommerce_update_variation_values.valiseMaterialFlow reset_data.valiseMaterialFlow', '.variations_form', function () {
      if (valiseMaterialFlowSyncing) {
        return;
      }
      window.setTimeout(syncValiseMaterialFlowFromNative, 0);
    });
  };
  var isValiseLightweightMaterialSelected = function isValiseLightweightMaterialSelected() {
    return getValiseSelectedMaterialSlug() === valiseLightweightMaterialSlug;
  };
  var getValiseCustomCapHeightMin = function getValiseCustomCapHeightMin() {
    return isValiseLightweightMaterialSelected() ? valiseLightweightCapHeightMin : valiseStandardCapHeightMin;
  };
  var getValiseCornerProfileSize = function getValiseCornerProfileSize() {
    return isValiseLightweightMaterialSelected() ? 20 : 30;
  };
  var getCustomCapHeightMin = function getCustomCapHeightMin() {
    return isValiseCustomCapHeightConfigurator() ? getValiseCustomCapHeightMin() : customCapHeightMin;
  };
  var getCustomCapHeightDefault = function getCustomCapHeightDefault() {
    return isValiseCustomCapHeightConfigurator() ? getValiseCustomCapHeightMin() : customCapHeightDefault;
  };
  var isCustomCapHeightLocked = function isCustomCapHeightLocked() {
    return !isValiseCustomCapHeightConfigurator() && $('#pa_configurateur-type-de-capot').val() === 'capot-plat';
  };
  var isHingedCustomCapSelected = function isHingedCustomCapSelected() {
    return $('body').hasClass('flight-case-type-malle') && $('#pa_configurateur-type-de-capot').val() === 'capot-sur-charnieres';
  };
  var getCustomCapHeightBaseMax = function getCustomCapHeightBaseMax() {
    var min = getCustomCapHeightMin();
    var height = parseInt($('.height-input:first input[name="height_needed"]:first').val(), 10);
    if (isNaN(height)) {
      height = isValiseCustomCapHeightConfigurator() ? (getCustomCapHeightDefault() + valiseCustomCapVisualOffset) * 2 : min * 2;
    }
    if (isValiseCustomCapHeightConfigurator()) {
      return Math.max(min, Math.floor(height / 2) - valiseCustomCapVisualOffset);
    }
    return Math.max(min, Math.floor(height / 2));
  };
  var getCustomCapHeightMax = function getCustomCapHeightMax() {
    var min = getCustomCapHeightMin();
    if (isCustomCapHeightLocked()) {
      return min;
    }
    var max = getCustomCapHeightBaseMax();
    if (isHingedCustomCapSelected()) {
      max = Math.min(max, customCapHeightHingedMax);
    }
    return max;
  };
  var getHingedCapHeightLimitMessage = function getHingedCapHeightLimitMessage() {
    return "Capot sur charnières : hauteur maximum <b>150 mm</b>. Pour un capot plus haut, choisissez <b>capot amovible</b>.";
  };
  var updateCustomCapHeightLimitMessage = function updateCustomCapHeightLimitMessage(visible) {
    var $message = $('.js--capot-height-limit-message');
    if (!$message.length) {
      return;
    }
    if (visible) {
      $message.html(getHingedCapHeightLimitMessage()).removeClass('hide').show();
    } else {
      $message.empty().addClass('hide').hide();
    }
  };
  var updateValiseCapHeightRuleMessage = function updateValiseCapHeightRuleMessage() {
    if (!isValiseCustomCapHeightConfigurator()) {
      return;
    }
    var materialSlug = getValiseSelectedMaterialSlug();
    var min = getValiseCustomCapHeightMin();
    var cornerSize = getValiseCornerProfileSize();
    var $row = $(customCapHeightInputSelector).closest('.capot-height-input');
    var $message = $row.find('.js--valise-cap-rule');
    var message;
    $('.js--capot-height-min').text(min);
    if (!$message.length) {
      $message = $('<div class="valise-cap-rule js--valise-cap-rule" aria-live="polite"></div>');
      $row.find('.capot-height-inputs').append($message);
    }
    if (!materialSlug) {
      message = '<strong>Minimum provisoire : ' + min + ' mm.</strong> ' + 'Avec le panneau léger 7 mm, le minimum passera automatiquement à 38 mm.';
    } else {
      message = '<strong>Minimum avec votre panneau : ' + min + ' mm.</strong> ' + 'Cornières ' + cornerSize + ' × ' + cornerSize + ' mm et 8 ' + (cornerSize === 30 ? 'coins boule medium' : 'petits coins boule 20 × 20 mm') + ' sélectionnés automatiquement.';
    }
    $message.html(message);
  };
  var updateValiseMaterialBenefitMessage = function updateValiseMaterialBenefitMessage() {
    if (!isValiseCustomCapHeightConfigurator()) {
      return;
    }
    var $material = $('#pa_configurateur-matiere');
    var $valueCell = $('.js--valise-material-thickness-row td.value');
    var $message = $valueCell.find('.js--valise-material-benefit');
    if (!$valueCell.length) {
      $valueCell = $material.closest('td.value');
      $message = $valueCell.find('.js--valise-material-benefit');
    }
    if (!$message.length) {
      $message = $('<div class="valise-material-benefit js--valise-material-benefit" aria-live="polite"></div>');
      $valueCell.append($message);
    }
    if (isValiseLightweightMaterialSelected()) {
      $message.html('<strong>Option légère</strong><span>Idéale si la valise est souvent portée. Le plastique alvéolaire est lavable et résiste à l’eau.</span>').show();
    } else {
      $message.empty().hide();
    }
  };
  var initCustomCapHeightField = function initCustomCapHeightField() {
    if (!isCustomCapHeightConfigurator() || $(customCapHeightInputSelector).length !== 0) {
      return;
    }
    var $heightRow = $('#price_calculator tr.height-input:first');
    if (!$heightRow.length) {
      return;
    }
    var min = getCustomCapHeightMin();
    var defaultHeight = getCustomCapHeightDefault();
    var $row = $('<tr class="price-table-row capot-height-input"></tr>');
    var $labelCell = $('<td></td>');
    var $valueCell = $('<td class="capot-height-inputs"></td>');
    var capHeightLabel = isValiseCustomCapHeightConfigurator() ? 'Hauteur visible du capot' : 'Hauteur du capot';
    var capHeightDetails = isValiseCustomCapHeightConfigurator() ? '(hors profils aluminium / min <span class="js--capot-height-min">' + min + '</span> mm / max <span class="js--capot-height-max"></span> mm)' : '(min ' + min + ' mm / max <span class="js--capot-height-max"></span> mm)';
    var $label = $('<label for="capot_height_mm">' + capHeightLabel + '<div class="text-normal text-lowercase">' + capHeightDetails + '</div></label>');
    var $limitMessage = $('<div class="custom-cap-height-limit-message js--capot-height-limit-message" aria-live="polite"></div>');
    var $input = $('<input type="number" name="capot_height_mm" id="capot_height_mm" value="' + defaultHeight + '" min="' + min + '" step="1" autocomplete="off" />');
    $labelCell.append($label).append($limitMessage);
    $valueCell.append($input);
    $row.append($labelCell).append($valueCell);
    $heightRow.after($row);
    customCapHeightLastValidValue = defaultHeight;
    syncCustomCapHeightField(false);
  };
  var restoreInitialValiseCustomCapHeight = function restoreInitialValiseCustomCapHeight() {
    if (!isValiseCustomCapHeightConfigurator()) {
      return;
    }
    var $input = $(customCapHeightInputSelector);
    if (!$input.length || $input.data('customCapHeightUserEdited')) {
      return;
    }
    var defaultHeight = getCustomCapHeightDefault();
    $input.val(defaultHeight);
    customCapHeightLastValidValue = defaultHeight;
    syncCustomCapHeightField(false);
    setCaseValues();
    refreshSelectedHandlePositions();
    exceptionTrolley();
  };
  var syncCustomCapHeightField = function syncCustomCapHeightField(notify, options) {
    var min = getCustomCapHeightMin();
    if (!isCustomCapHeightConfigurator()) {
      return min;
    }
    options = options || {};
    var $input = $(customCapHeightInputSelector);
    var locked = isCustomCapHeightLocked();
    var max = getCustomCapHeightMax();
    var baseMax = getCustomCapHeightBaseMax();
    var hingedCapLimitApplies = !locked && isHingedCustomCapSelected() && baseMax > customCapHeightHingedMax;
    updateCustomCapHeightLimitMessage(hingedCapLimitApplies);
    var rawValue;
    var value;
    if (!$input.length) {
      return customCapHeightLastValidValue;
    }
    if (locked) {
      $input.val(min);
    }
    $input.prop('readonly', locked);
    $input.attr('aria-disabled', locked ? 'true' : 'false');
    $input.attr('title', locked ? 'La hauteur du capot est fixe avec un capot plat.' : '');
    $input.closest('.capot-height-input').css({
      'opacity': locked ? '0.45' : '',
      'cursor': locked ? 'not-allowed' : ''
    });
    $input.css({
      'background-color': locked ? '#f2f2f2' : '',
      'cursor': locked ? 'not-allowed' : ''
    });
    $input.attr('min', min);
    $input.attr('max', max);
    $('.js--capot-height-max').text(max);
    updateValiseCapHeightRuleMessage();
    rawValue = $.trim($input.val());
    value = parseInt(rawValue, 10);
    if (options.allowPartial && (rawValue === '' || isNaN(value) || value < min || value > max)) {
      return customCapHeightLastValidValue;
    }
    if (isNaN(value)) {
      value = customCapHeightLastValidValue || getCustomCapHeightDefault();
    }
    if (value < min) {
      value = min;
    }
    if (value > max) {
      value = max;
      if (notify) {
        if (hingedCapLimitApplies) {
          exceptionNotification(getHingedCapHeightLimitMessage());
        } else if (isValiseCustomCapHeightConfigurator()) {
          exceptionNotification('Hauteur visible du capot ajustée : maximum <b>' + max + ' mm</b>, afin que le capot complet, profils compris, ne dépasse pas la moitié de la hauteur du flight case.');
        } else {
          exceptionNotification('Hauteur de capot ajustée : elle ne peut pas dépasser <b>la moitié de la hauteur du flight case</b>.');
        }
      }
    }
    if (parseInt($input.val(), 10) !== value) {
      $input.val(value);
    }
    customCapHeightLastValidValue = value;
    if (window.configurator_options) {
      window.configurator_options.capot_height_mm = value;
    }
    return value;
  };
  var isCustomCapHeightFieldReady = function isCustomCapHeightFieldReady() {
    var $input = $(customCapHeightInputSelector);
    var min = getCustomCapHeightMin();
    var max = getCustomCapHeightMax();
    var rawValue = $.trim($input.val());
    var value = parseInt(rawValue, 10);
    return rawValue !== '' && !isNaN(value) && value >= min && value <= max;
  };
  var syncValisePanelRuleFromSelection = function syncValisePanelRuleFromSelection() {
    if (!isValiseCustomCapHeightConfigurator()) {
      return;
    }
    var materialSlug = getValiseSelectedMaterialSlug();
    var $input = $(customCapHeightInputSelector);
    var currentValue = parseInt($input.val(), 10);
    var previousWasLightweight = valiseLastMaterialSlug === valiseLightweightMaterialSlug;
    var isLightweight = materialSlug === valiseLightweightMaterialSlug;
    var min = getValiseCustomCapHeightMin();
    var minCaseHeight = (min + valiseCustomCapVisualOffset) * 2;
    var $heightInput = $('.height-input:first input[name="height_needed"]:first');
    var caseHeight = parseInt($heightInput.val(), 10);
    var adjustedUp = false;
    var caseHeightAdjustedUp = false;
    if ($input.length) {
      if (isLightweight && !previousWasLightweight && (!valiseLastMaterialSlug || currentValue === valiseStandardCapHeightMin)) {
        $input.val(valiseLightweightCapHeightMin);
        $input.removeData('customCapHeightUserEdited');
      } else if (!isNaN(currentValue) && currentValue < min) {
        $input.val(min);
        adjustedUp = true;
      }
    }
    $heightInput.attr('min', minCaseHeight);
    if (!isNaN(caseHeight) && caseHeight < minCaseHeight) {
      $heightInput.val(minCaseHeight);
      caseHeightAdjustedUp = true;
    }
    valiseLastMaterialSlug = materialSlug;
    syncCustomCapHeightField(false);
    updateValiseMaterialBenefitMessage();
    updateValiseCapHeightRuleMessage();
    setCaseValues();
    refreshSelectedHandlePositions();
    exceptionTrolley();
    if (adjustedUp || caseHeightAdjustedUp) {
      var adjustmentDetails = adjustedUp ? 'Hauteur visible du capot ajustée à <b>' + min + ' mm</b>.' : '';
      if (caseHeightAdjustedUp) {
        adjustmentDetails += (adjustmentDetails ? '<br>' : '') + 'Hauteur totale ajustée à <b>' + minCaseHeight + ' mm</b> pour conserver un corps de valise compatible.';
      }
      exceptionNotification(adjustmentDetails);
    }
    $('#conex-calculated-price').trigger('wc-measurement-price-calculator-product-price-change');
  };
  var getCustomCapHeightDisplaySize = function getCustomCapHeightDisplaySize() {
    return parseFloat(getElementDisplaySize(syncCustomCapHeightField(false)));
  };
  var getMalleCustomCapHeightDeltaMm = function getMalleCustomCapHeightDeltaMm() {
    return Math.max(0, syncCustomCapHeightField(false) - customCapHeightMin);
  };
  var getMalleLegacyCapProfileTopMm = function getMalleLegacyCapProfileTopMm() {
    return (capSize || 42) * 2.12;
  };
  var getMalleVisualCapProfileTopDisplaySize = function getMalleVisualCapProfileTopDisplaySize() {
    return parseFloat(getElementDisplaySize(getMalleLegacyCapProfileTopMm() + getMalleCustomCapHeightDeltaMm()));
  };
  var getMinHeightForTwoMalleVerticalCapLockers = function getMinHeightForTwoMalleVerticalCapLockers() {
    if (!$('body').hasClass('flight-case-type-malle')) {
      return 600;
    }
    return 600 + Math.max(0, syncCustomCapHeightField(false) - customCapHeightMin);
  };
  var getCustomCapProfileTopDisplaySize = function getCustomCapProfileTopDisplaySize() {
    if ($('body').hasClass('flight-case-type-malle')) {
      return getMalleVisualCapProfileTopDisplaySize();
    }
    return getCustomCapHeightDisplaySize();
  };
  var getMalleCapTopDisplaySize = function getMalleCapTopDisplaySize(defaultCapTop) {
    if (!$('body').hasClass('flight-case-type-malle') || !isCustomCapHeightConfigurator()) {
      return defaultCapTop;
    }
    return defaultCapTop + parseFloat(getElementDisplaySize(getMalleCustomCapHeightDeltaMm()));
  };
  var getCustomCapSafeHandleTopPercent = function getCustomCapSafeHandleTopPercent(basePercent) {
    if (!isCustomCapHeightConfigurator() || isValiseCustomCapHeightConfigurator()) {
      return basePercent;
    }
    var caseHeight = parseInt($('.height-input:first input[name="height_needed"]:first').val(), 10);
    var capHeight = syncCustomCapHeightField(false);
    var capVisualHeight = capHeight;
    if (isNaN(caseHeight) || caseHeight <= 0 || isNaN(capHeight)) {
      return basePercent;
    }
    if ($('body').hasClass('flight-case-type-malle')) {
      capVisualHeight = (capSize || 42) * 3.12 + getMalleCustomCapHeightDeltaMm();
    }
    var linePercent = $('body').hasClass('flight-case-cloche') ? 100 - capHeight / caseHeight * 100 : capVisualHeight / caseHeight * 100;
    var handleHalfPercent = 10;
    var displayedCaseHeight = getCaseDisplayHeight();
    var displayedHandleSize = parseFloat(getElementDisplaySize(handleSize || 160));
    if (displayedCaseHeight > 0 && !isNaN(displayedHandleSize)) {
      handleHalfPercent = displayedHandleSize / displayedCaseHeight * 100 / 2;
    }
    var clearancePercent = Math.max(4, handleHalfPercent + 3);
    if ($('body').hasClass('flight-case-type-malle') && displayedCaseHeight > 0) {
      var displayedLockerSize = parseFloat(getElementDisplaySize(locker2frontSize || 128));
      if (!isNaN(displayedLockerSize)) {
        clearancePercent = Math.max(clearancePercent, displayedLockerSize / displayedCaseHeight * 100 + 3);
      }
    }
    if ($('body').hasClass('flight-case-cloche')) {
      return Math.max(12, Math.min(basePercent, linePercent - clearancePercent));
    }
    return Math.min(88, Math.max(basePercent, linePercent + clearancePercent));
  };
  var getMalleStandardFrontHandleMinimumLowerHeight = function getMalleStandardFrontHandleMinimumLowerHeight() {
    return 220;
  };
  var isMalleStandardFrontHandleAvailable = function isMalleStandardFrontHandleAvailable() {
    if (!$('body').hasClass('flight-case-type-malle') || !isCustomCapHeightConfigurator()) {
      return true;
    }
    var caseHeight = parseInt($('.height-input:first input[name="height_needed"]:first').val(), 10);
    var capHeight = syncCustomCapHeightField(false);
    if (isNaN(caseHeight) || caseHeight <= 0 || isNaN(capHeight)) {
      return true;
    }
    return caseHeight - capHeight >= getMalleStandardFrontHandleMinimumLowerHeight();
  };
  var syncMalleStandardFrontHandleAvailability = function syncMalleStandardFrontHandleAvailability(showNotice) {
    var $frontHandle = $('#handle_customs_add-sidehandle');
    if (!$frontHandle.length) {
      return true;
    }
    var available = isMalleStandardFrontHandleAvailable();
    var disabledTitle = 'Diminuez la hauteur du capot pour conserver au moins ' + getMalleStandardFrontHandleMinimumLowerHeight() + ' mm sur la partie basse.';
    var $label = $frontHandle.closest('label');
    if (!available && $frontHandle.is(':checked')) {
      $frontHandle.prop('checked', false);
      sideHandleHideShow(false);
      checkSideHandleLabel($frontHandle);
      setNbrHandles();
    }
    $frontHandle.prop('disabled', !available);
    $frontHandle.attr('title', available ? '' : disabledTitle);
    $label.css({
      'opacity': available ? '' : '0.45',
      'cursor': available ? '' : 'not-allowed'
    });
    return available;
  };
  var ensureCustomCapHandlePreviewElements = function ensureCustomCapHandlePreviewElements() {
    if ($('.configurator_preview-cap-handle').length !== 0) {
      return;
    }
    var $sourceImg = $('.configurator_preview-handle img:first');
    var $surfaceImg = $('.configurator_preview-handle-surface img:first');
    if (!$sourceImg.length) {
      return;
    }
    if (!$surfaceImg.length) {
      var sourceHandleSrc = $sourceImg.attr('src') || $sourceImg.prop('src') || '';
      var surfaceHandleSrc = sourceHandleSrc.replace('handle-black.svg', 'handle-surface.svg').replace('handle.svg', 'handle-surface.svg');
      var surfaceHandleBlackSrc = sourceHandleSrc.replace('handle-black.svg', 'handle-surface-black.svg').replace('handle.svg', 'handle-surface-black.svg');
      if (surfaceHandleSrc !== sourceHandleSrc) {
        $surfaceImg = $('<img alt="Poignée surface">').attr('src', surfaceHandleSrc).attr('data-black', surfaceHandleBlackSrc);
      }
    }
    var createHandle = function createHandle(type, position) {
      var $handle = $('<div class="configurator_preview-cap-handle configurator_preview-cap-handle-' + type + ' configurator_preview-cap-handle-' + position + '" data-cap-handle-type="' + type + '" data-cap-handle-position="' + position + '"></div>');
      var $img = $sourceImg.clone();
      $img.removeAttr('style data-show-for data-hide-for').removeClass('hide').addClass('configurator_preview-cap-handle-img-normal');
      $handle.append($img);
      if (type === 'front' && $surfaceImg.length) {
        var $surfaceHandleImg = $surfaceImg.clone();
        $surfaceHandleImg.removeAttr('style data-show-for data-hide-for').removeClass('hide').addClass('configurator_preview-cap-handle-img-surface');
        $handle.append($surfaceHandleImg);
      }
      return $handle;
    };
    $('.configurator_preview--front, .configurator_preview--back').each(function () {
      var $view = $(this);
      $view.append(createHandle('front', 'left'));
      $view.append(createHandle('front', 'center'));
      $view.append(createHandle('front', 'right'));
    });
    $('.configurator_preview--side').each(function () {
      var $view = $(this);
      $view.append(createHandle('side', 'left'));
      $view.append(createHandle('side', 'center'));
      $view.append(createHandle('side', 'right'));
    });
  };
  var getCustomCapHandleDimension = function getCustomCapHandleDimension(value) {
    value = parseInt(value, 10);
    return isNaN(value) ? 0 : value;
  };
  var getCustomCapHandleDisplayWidth = function getCustomCapHandleDisplayWidth() {
    var displayWidth = parseFloat(getElementDisplaySize(handleSize || 160));
    if (isNaN(displayWidth) || displayWidth <= 0) {
      displayWidth = parseFloat($('.js--set-handle-size:first').css('width')) || 0;
    }
    return displayWidth;
  };
  var getCustomCapSurfaceHandleDisplayWidth = function getCustomCapSurfaceHandleDisplayWidth() {
    var displayWidth = parseFloat(getElementDisplaySize(140));
    if (isNaN(displayWidth) || displayWidth <= 0) {
      displayWidth = parseFloat($('.configurator_preview-handle-surface img:first').css('width')) || 0;
    }
    return displayWidth;
  };
  var getCustomCapHandleImageRatio = function getCustomCapHandleImageRatio(selector, fallbackRatio) {
    var sourceImg = $(selector)[0];
    if (sourceImg && sourceImg.naturalWidth > 0 && sourceImg.naturalHeight > 0) {
      return sourceImg.naturalHeight / sourceImg.naturalWidth;
    }
    return fallbackRatio;
  };
  var getCenteredCustomCapHandleTop = function getCenteredCustomCapHandleTop(capStartY, capEndY, handleHeight, clearance) {
    var capAvailableHeight = Math.max(0, capEndY - capStartY);
    var handleTop = capStartY + (capAvailableHeight - handleHeight) / 2;
    if (capAvailableHeight >= handleHeight + clearance * 2) {
      handleTop = Math.min(capEndY - handleHeight - clearance, Math.max(capStartY + clearance, handleTop));
    }
    return handleTop;
  };
  var getRelativeCustomCapViewScaleY = function getRelativeCustomCapViewScaleY(viewNode) {
    var viewTransform = window.getComputedStyle(viewNode).transform;
    var scaleY = 1;
    if (viewTransform && viewTransform !== 'none') {
      var transformValues = viewTransform.match(/matrix\(([^)]+)\)/);
      if (transformValues && transformValues[1]) {
        var matrixValues = transformValues[1].split(',').map(function (value) {
          return parseFloat(value);
        });
        if (matrixValues.length >= 4 && matrixValues[3]) {
          scaleY = Math.abs(matrixValues[3]);
        } else if (matrixValues.length && matrixValues[0]) {
          scaleY = Math.abs(matrixValues[0]);
        }
      }
    }
    return scaleY || 1;
  };
  var getRelativeCustomCapViewEdge = function getRelativeCustomCapViewEdge($view, selector, edge) {
    var viewNode = $view.get(0);
    var node = $view.find(selector).get(0);
    if (!viewNode || !node || !viewNode.getBoundingClientRect || !node.getBoundingClientRect) {
      return null;
    }
    var viewRect = viewNode.getBoundingClientRect();
    var nodeRect = node.getBoundingClientRect();
    var scaleY = getRelativeCustomCapViewScaleY(viewNode);
    if (!viewRect.width || !viewRect.height || !nodeRect.width && !nodeRect.height) {
      return null;
    }
    return ((edge === 'bottom' ? nodeRect.bottom : nodeRect.top) - viewRect.top) / scaleY;
  };
  var getMalleCustomCapHandleBand = function getMalleCustomCapHandleBand(defaultStartY, defaultEndY) {
    var $view = $('.configurator_preview--front.current-view, .configurator_preview--back.current-view, .configurator_preview--side.current-view').filter(function () {
      var rect = this.getBoundingClientRect();
      return rect.width > 0 && rect.height > 0;
    }).first();
    if (!$view.length) {
      return {
        start: defaultStartY,
        end: defaultEndY
      };
    }
    var topProfileBottom = getRelativeCustomCapViewEdge($view, '.configurator_preview-hinge-top svg', 'bottom');
    var capProfileTop = getRelativeCustomCapViewEdge($view, '.configurator_preview-cap svg', 'top');
    if (topProfileBottom === null || capProfileTop === null || capProfileTop <= topProfileBottom) {
      return {
        start: defaultStartY,
        end: defaultEndY
      };
    }
    return {
      start: topProfileBottom,
      end: capProfileTop
    };
  };
  var getClocheCustomCapHandleBand = function getClocheCustomCapHandleBand(defaultStartY, defaultEndY) {
    var $view = $('.configurator_preview--front.current-view, .configurator_preview--back.current-view, .configurator_preview--side.current-view').filter(function () {
      var rect = this.getBoundingClientRect();
      return rect.width > 0 && rect.height > 0;
    }).first();
    if (!$view.length) {
      return {
        start: defaultStartY,
        end: defaultEndY
      };
    }
    var capProfileBottom = getRelativeCustomCapViewEdge($view, '.configurator_preview-cap svg', 'bottom');
    var bottomProfileTop = getRelativeCustomCapViewEdge($view, '.configurator_preview-hinge-bottom svg', 'top');
    if (capProfileBottom === null || bottomProfileTop === null || bottomProfileTop <= capProfileBottom) {
      return {
        start: defaultStartY,
        end: defaultEndY
      };
    }
    return {
      start: capProfileBottom,
      end: bottomProfileTop
    };
  };
  var getCustomCapHandleMetrics = function getCustomCapHandleMetrics() {
    var capDisplayHeight = getCustomCapHeightDisplaySize();
    var caseDisplayHeight = getCaseDisplayHeight();
    var isCloche = $('body').hasClass('flight-case-cloche');
    if (!isCloche && $('body').hasClass('flight-case-type-malle')) {
      capDisplayHeight = getMalleVisualCapProfileTopDisplaySize();
    }
    var lineY = isCloche ? caseDisplayHeight - capDisplayHeight : capDisplayHeight;
    var capStartY = isCloche ? lineY : 0;
    var capEndY = isCloche ? caseDisplayHeight : lineY;
    if (isCloche) {
      var clocheCapHandleBand = getClocheCustomCapHandleBand(capStartY, capEndY);
      capStartY = clocheCapHandleBand.start;
      capEndY = clocheCapHandleBand.end;
    } else if ($('body').hasClass('flight-case-type-malle')) {
      var malleCapHandleBand = getMalleCustomCapHandleBand(capStartY, capEndY);
      capStartY = malleCapHandleBand.start;
      capEndY = malleCapHandleBand.end;
    }
    var capAvailableHeight = Math.max(0, capEndY - capStartY);
    var normalDisplayWidth = getCustomCapHandleDisplayWidth();
    var normalDisplayHeight = normalDisplayWidth * getCustomCapHandleImageRatio('.configurator_preview-handle img:first', 303.6 / 456.7);
    var surfaceDisplayWidth = getCustomCapSurfaceHandleDisplayWidth();
    var surfaceDisplayHeight = surfaceDisplayWidth * getCustomCapHandleImageRatio('.configurator_preview-handle-surface img:first', 234.4 / 397);
    var normalClearance = Math.max(8, normalDisplayHeight * 0.12);
    var surfaceClearance = Math.max(4, surfaceDisplayHeight * 0.08);
    var capRailClearance = parseFloat(getElementDisplaySize(capSize || 42));
    var normalComfortClearance = Math.max(normalClearance, capRailClearance || normalClearance);
    var normalMinimumClearance = Math.max(2, parseFloat(getElementDisplaySize(3)) || 2);
    var normalHasVerticalRoom = capAvailableHeight >= normalDisplayHeight + normalMinimumClearance;
    // Une poignée de capot reste encastrée, quelle que soit la projection.
    var frontUsesSurfaceHandle = false;
    return {
      capDisplayHeight: capDisplayHeight,
      caseDisplayHeight: caseDisplayHeight,
      capStartY: capStartY,
      capEndY: capEndY,
      capAvailableHeight: capAvailableHeight,
      handleDisplayWidth: normalDisplayWidth,
      handleDisplayHeight: normalDisplayHeight,
      handleTop: getCenteredCustomCapHandleTop(capStartY, capEndY, normalDisplayHeight, normalClearance),
      normalDisplayWidth: normalDisplayWidth,
      normalDisplayHeight: normalDisplayHeight,
      normalHandleTop: getCenteredCustomCapHandleTop(capStartY, capEndY, normalDisplayHeight, normalComfortClearance),
      surfaceDisplayWidth: surfaceDisplayWidth,
      surfaceDisplayHeight: surfaceDisplayHeight,
      surfaceHandleTop: getCenteredCustomCapHandleTop(capStartY, capEndY, surfaceDisplayHeight, surfaceClearance),
      hasVerticalRoom: normalHasVerticalRoom,
      frontHasRoom: normalHasVerticalRoom,
      sideHasRoom: normalHasVerticalRoom,
      frontUsesSurfaceHandle: frontUsesSurfaceHandle
    };
  };
  var isCustomCapHandleAvailable = function isCustomCapHandleAvailable() {
    if (!isCustomCapHeightConfigurator()) {
      return false;
    }
    var metrics = getCustomCapHandleMetrics();
    return metrics.frontHasRoom || metrics.sideHasRoom;
  };
  var isCustomCapFrontHandleAvailable = function isCustomCapFrontHandleAvailable() {
    return isCustomCapHeightConfigurator() && getCustomCapHandleMetrics().frontHasRoom;
  };
  var isCustomCapSideHandleAvailable = function isCustomCapSideHandleAvailable() {
    return isCustomCapHeightConfigurator() && getCustomCapHandleMetrics().sideHasRoom;
  };
  var syncCustomCapHandleOptions = function syncCustomCapHandleOptions() {
    var $frontInput = $('#cap_handle_customs_add-cap-fronthandle');
    var $sideInput = $('#cap_handle_customs_add-cap-sidehandle');
    var frontAvailable = isCustomCapFrontHandleAvailable();
    var sideAvailable = isCustomCapSideHandleAvailable();
    if (!$frontInput.length && !$sideInput.length) {
      return false;
    }
    var syncInputState = function syncInputState($input, available, disabledTitle) {
      if (!$input.length) {
        return;
      }
      if (!available && $input.is(':checked')) {
        $input.prop('checked', false);
      }
      $input.prop('disabled', !available);
      $input.attr('title', available ? '' : disabledTitle);
      var $label = $input.closest('label');
      $label.css({
        'opacity': available ? '' : '0.45',
        'cursor': available ? '' : 'not-allowed'
      });
    };
    syncInputState($frontInput, frontAvailable, 'Augmentez la hauteur du capot pour ajouter des poignées en façade.');
    syncInputState($sideInput, sideAvailable, 'Augmentez la hauteur du capot pour ajouter des poignées latérales.');
    return frontAvailable || sideAvailable;
  };
  var getCustomCapHandleCount = function getCustomCapHandleCount() {
    var count = 0;
    var threshold = 625;
    if ($('#cap_handle_customs_add-cap-fronthandle').is(':checked') && isCustomCapFrontHandleAvailable()) {
      count += getCustomCapHandleDimension(inputLength) <= threshold ? 2 : 4;
    }
    if ($('#cap_handle_customs_add-cap-sidehandle').is(':checked') && isCustomCapSideHandleAvailable()) {
      count += getCustomCapHandleDimension(inputWidth) <= threshold ? 2 : 4;
    }
    return count;
  };
  var customCapHandleCollisionTimer = null;
  var storeCustomCapHardwareCollisionBaseline = function storeCustomCapHardwareCollisionBaseline($elements, overwrite) {
    $elements.each(function () {
      var $element = $(this);
      if (overwrite || typeof $element.data('customCapCollisionBaseLeft') === 'undefined') {
        $element.data('customCapCollisionBaseLeft', this.style.left || '');
        $element.data('customCapCollisionBaseRight', this.style.right || '');
      }
    });
  };
  var resetCustomCapHardwareCollisionOffsets = function resetCustomCapHardwareCollisionOffsets() {
    $('.configurator_preview--front, .configurator_preview--back, .configurator_preview--side').each(function () {
      var $view = $(this);
      var $elements = $view.find('.configurator_preview-cap-handle, ' + '.cap-parts-container > .configurator_preview-locker-front-left, ' + '.cap-parts-container > .configurator_preview-locker-front-right, ' + '.cap-parts-container > .configurator_preview-locker2-front-left, ' + '.cap-parts-container > .configurator_preview-locker2-front-right');
      $elements.each(function () {
        var $element = $(this);
        var baseLeft = $element.data('customCapCollisionBaseLeft');
        var baseRight = $element.data('customCapCollisionBaseRight');
        if (typeof baseLeft !== 'undefined') {
          this.style.left = baseLeft;
          this.style.right = baseRight;
        }
      });
    });
  };
  var getVisibleCustomCapHardwareImage = function getVisibleCustomCapHardwareImage($container) {
    if (!$container.length || Number($container.css('opacity')) === 0) {
      return $();
    }
    return $container.find('img').filter(function () {
      var rect = this.getBoundingClientRect();
      var style = window.getComputedStyle(this);
      return rect.width > 0 && rect.height > 0 && style.display !== 'none' && style.visibility !== 'hidden' && Number(style.opacity || 1) > 0;
    }).first();
  };
  var getCustomCapHardwareHorizontalDirection = function getCustomCapHardwareHorizontalDirection(element, viewNode) {
    var direction = 1;
    var node = element;
    while (node && node !== viewNode) {
      var transform = window.getComputedStyle(node).transform;
      if (transform && transform !== 'none' && window.DOMMatrixReadOnly) {
        try {
          if (new window.DOMMatrixReadOnly(transform).a < 0) {
            direction *= -1;
          }
        } catch (error) {
          // Un transform non matriciel ne doit pas bloquer le configurateur.
        }
      }
      node = node.parentElement;
    }
    return direction;
  };
  var shiftCustomCapHardwareByPageDelta = function shiftCustomCapHardwareByPageDelta($element, $view, pageDelta) {
    if (!$element.length || !pageDelta) {
      return;
    }
    var viewNode = $view.get(0);
    var element = $element.get(0);
    var viewRect = viewNode.getBoundingClientRect();
    var viewWidth = Number(window.getComputedStyle(viewNode).width.replace('px', '')) || viewNode.offsetWidth || 1;
    var scaleX = viewRect.width / viewWidth;
    var direction = getCustomCapHardwareHorizontalDirection(element, viewNode);
    var computedLeft = Number(window.getComputedStyle(element).left.replace('px', ''));
    if (!scaleX || !isFinite(scaleX)) {
      scaleX = 1;
    }
    if (!isFinite(computedLeft)) {
      computedLeft = element.offsetLeft || 0;
    }
    $element.css({
      left: computedLeft + pageDelta / (scaleX * direction) + 'px',
      right: 'auto'
    });
  };
  var resolveCustomCapHandleCollisionForView = function resolveCustomCapHandleCollisionForView($view) {
    var viewNode = $view.get(0);
    if (!viewNode || !isCustomCapHeightConfigurator()) {
      return;
    }
    var viewRect = viewNode.getBoundingClientRect();
    var viewWidth = Number(window.getComputedStyle(viewNode).width.replace('px', '')) || viewNode.offsetWidth || 1;
    var scaleX = viewRect.width / viewWidth;
    var desiredGap = (Number(getElementDisplaySize(10)) || 10) * (scaleX || 1);
    var $handles = $view.find('.configurator_preview-cap-handle').filter(function () {
      return getVisibleCustomCapHardwareImage($(this)).length > 0;
    });
    if (!$handles.length || $handles.length > 2) {
      return;
    }
    var handleItems = $handles.map(function () {
      var $container = $(this);
      var $image = getVisibleCustomCapHardwareImage($container);
      return {
        $container: $container,
        rect: $image.get(0).getBoundingClientRect()
      };
    }).get().sort(function (left, right) {
      return left.rect.left - right.rect.left;
    });
    var $lockerContainers = $view.find('.cap-parts-container > .configurator_preview-locker-front-left, ' + '.cap-parts-container > .configurator_preview-locker-front-right, ' + '.cap-parts-container > .configurator_preview-locker2-front-left, ' + '.cap-parts-container > .configurator_preview-locker2-front-right').filter(function () {
      return getVisibleCustomCapHardwareImage($(this)).length > 0;
    });
    if ($lockerContainers.length < 2) {
      return;
    }
    var lockerItems = $lockerContainers.map(function () {
      var $container = $(this);
      var $image = getVisibleCustomCapHardwareImage($container);
      return {
        $container: $container,
        rect: $image.get(0).getBoundingClientRect()
      };
    }).get().sort(function (left, right) {
      return left.rect.left - right.rect.left;
    });
    var leftHandle = handleItems[0];
    var rightHandle = handleItems[handleItems.length - 1];
    var leftLocker = lockerItems[0];
    var rightLocker = lockerItems[lockerItems.length - 1];

    // Sous 626 mm, une seule poignée de capot reste centrée. Les deux
    // fermoirs standards s'écartent alors de façon symétrique autour
    // d'elle au lieu de toucher ses coins.
    if (handleItems.length === 1) {
      var centerHandle = handleItems[0];
      var centerVerticalGapLeft = Math.max(centerHandle.rect.top - leftLocker.rect.bottom, leftLocker.rect.top - centerHandle.rect.bottom);
      var centerVerticalGapRight = Math.max(centerHandle.rect.top - rightLocker.rect.bottom, rightLocker.rect.top - centerHandle.rect.bottom);
      if (centerVerticalGapLeft >= desiredGap && centerVerticalGapRight >= desiredGap) {
        return;
      }
      var centerLeftGap = centerHandle.rect.left - leftLocker.rect.right;
      var centerRightGap = rightLocker.rect.left - centerHandle.rect.right;
      var centerLockerShift = Math.max(0, desiredGap - centerLeftGap, desiredGap - centerRightGap);
      if (!centerLockerShift) {
        return;
      }
      shiftCustomCapHardwareByPageDelta(leftLocker.$container, $view, -centerLockerShift);
      shiftCustomCapHardwareByPageDelta(rightLocker.$container, $view, centerLockerShift);
      return;
    }
    var verticalGapLeft = Math.max(leftHandle.rect.top - leftLocker.rect.bottom, leftLocker.rect.top - leftHandle.rect.bottom);
    var verticalGapRight = Math.max(rightHandle.rect.top - rightLocker.rect.bottom, rightLocker.rect.top - rightHandle.rect.bottom);
    if (verticalGapLeft >= desiredGap && verticalGapRight >= desiredGap) {
      return;
    }
    var leftGap = leftHandle.rect.left - leftLocker.rect.right;
    var rightGap = rightLocker.rect.left - rightHandle.rect.right;
    var requiredShift = Math.max(0, desiredGap - leftGap, desiredGap - rightGap);
    if (!requiredShift) {
      return;
    }
    var centralGap = rightHandle.rect.left - leftHandle.rect.right;
    var maximumHandleShift = Math.max(0, (centralGap - desiredGap) / 2);
    var handleShift = Math.min(requiredShift / 2, maximumHandleShift);
    var lockerShift = requiredShift - handleShift;
    var visibleLeftRail = $view.find('.configurator_preview-hinge-left svg').filter(function () {
      var rect = this.getBoundingClientRect();
      return rect.width > 0 && rect.height > 0;
    }).first();
    var visibleRightRail = $view.find('.configurator_preview-hinge-right svg').filter(function () {
      var rect = this.getBoundingClientRect();
      return rect.width > 0 && rect.height > 0;
    }).first();
    if (visibleLeftRail.length && visibleRightRail.length) {
      var innerLeft = visibleLeftRail.get(0).getBoundingClientRect().right;
      var innerRight = visibleRightRail.get(0).getBoundingClientRect().left;
      var maximumLockerShift = Math.max(0, Math.min(leftLocker.rect.left - innerLeft, innerRight - rightLocker.rect.right));
      if (lockerShift > maximumLockerShift) {
        var remainingLockerShift = maximumLockerShift;
        var remainingHandleShift = requiredShift - remainingLockerShift;
        if (remainingHandleShift <= maximumHandleShift) {
          lockerShift = remainingLockerShift;
          handleShift = remainingHandleShift;
        }
      }
    }
    shiftCustomCapHardwareByPageDelta(leftHandle.$container, $view, handleShift);
    shiftCustomCapHardwareByPageDelta(rightHandle.$container, $view, -handleShift);
    shiftCustomCapHardwareByPageDelta(leftLocker.$container, $view, -lockerShift);
    shiftCustomCapHardwareByPageDelta(rightLocker.$container, $view, lockerShift);
  };
  var refreshCustomCapHandleCollisionLayout = function refreshCustomCapHandleCollisionLayout() {
    resetCustomCapHardwareCollisionOffsets();
    $('.configurator_preview--front, .configurator_preview--back, .configurator_preview--side').each(function () {
      resolveCustomCapHandleCollisionForView($(this));
    });
  };
  var scheduleCustomCapHandleCollisionLayout = function scheduleCustomCapHandleCollisionLayout() {
    if (!isCustomCapHeightConfigurator()) {
      return;
    }
    if (customCapHandleCollisionTimer) {
      window.clearTimeout(customCapHandleCollisionTimer);
    }
    refreshCustomCapHandleCollisionLayout();
    if (window.requestAnimationFrame) {
      window.requestAnimationFrame(refreshCustomCapHandleCollisionLayout);
    }
    customCapHandleCollisionTimer = window.setTimeout(refreshCustomCapHandleCollisionLayout, 140);
  };
  var positionCustomCapHandles = function positionCustomCapHandles() {
    resetCustomCapHardwareCollisionOffsets();
    ensureCustomCapHandlePreviewElements();
    var $handles = $('.configurator_preview-cap-handle');
    if (!$handles.length) {
      syncCustomCapHandleOptions();
      return;
    }
    var metrics = getCustomCapHandleMetrics();
    syncCustomCapHandleOptions();
    var frontEnabled = metrics.frontHasRoom && $('#cap_handle_customs_add-cap-fronthandle').is(':checked');
    var sideEnabled = metrics.sideHasRoom && $('#cap_handle_customs_add-cap-sidehandle').is(':checked');
    var threshold = 625;
    $handles.css({
      'display': 'none',
      'position': 'absolute',
      'z-index': 35
    });
    $handles.find('img').css({
      'display': 'none',
      'left': 0,
      'position': 'absolute',
      'top': 0,
      'height': 'auto'
    });
    var showCapHandle = function showCapHandle($handle, useSurface, transformValue) {
      var $selectedImg = useSurface ? $handle.find('.configurator_preview-cap-handle-img-surface:first') : $handle.find('.configurator_preview-cap-handle-img-normal:first');
      var displayWidth = useSurface ? metrics.surfaceDisplayWidth : metrics.normalDisplayWidth;
      var handleTop = useSurface ? metrics.surfaceHandleTop : metrics.normalHandleTop;
      if (!$selectedImg.length) {
        $selectedImg = $handle.find('.configurator_preview-cap-handle-img-normal:first');
        displayWidth = metrics.normalDisplayWidth;
        handleTop = metrics.normalHandleTop;
        useSurface = false;
      }
      $handle.css({
        'display': 'block',
        'top': handleTop + 'px',
        'width': displayWidth
      });
      $selectedImg.css({
        'display': 'block',
        'width': displayWidth,
        'transform': transformValue
      });
    };
    var positionHandlesForView = function positionHandlesForView($view, type, enabled, dimension, viewWidth, useSurface) {
      var normalizedDimension = getCustomCapHandleDimension(dimension);
      var useCenter = normalizedDimension <= threshold;
      var inset = normalizedDimension >= 1500 ? 0.20 : normalizedDimension >= 1000 ? 0.10 : 0;
      var $left = $view.find('.configurator_preview-cap-handle-' + type + '.configurator_preview-cap-handle-left');
      var $center = $view.find('.configurator_preview-cap-handle-' + type + '.configurator_preview-cap-handle-center');
      var $right = $view.find('.configurator_preview-cap-handle-' + type + '.configurator_preview-cap-handle-right');
      if (!enabled) {
        return;
      }
      if (useCenter) {
        $center.css({
          'left': viewWidth / 2 + 'px',
          'right': 'auto'
        });
        showCapHandle($center, useSurface, 'translateX(-50%)');
      } else {
        $left.css({
          'left': viewWidth * inset + 'px',
          'right': 'auto'
        });
        $right.css({
          'left': 'auto',
          'right': viewWidth * inset + 'px'
        });
        showCapHandle($left, useSurface, 'translateX(55%)');
        showCapHandle($right, useSurface, 'translateX(-55%)');
      }
    };
    positionHandlesForView($('.configurator_preview--front'), 'front', frontEnabled, inputLength, getCaseDisplayLength(), metrics.frontUsesSurfaceHandle);
    positionHandlesForView($('.configurator_preview--back'), 'front', frontEnabled, inputLength, getCaseDisplayLength(), metrics.frontUsesSurfaceHandle);
    positionHandlesForView($('.configurator_preview--side'), 'side', sideEnabled, inputWidth, getCaseDisplayWidth(), false);
    storeCustomCapHardwareCollisionBaseline($handles, true);
    storeCustomCapHardwareCollisionBaseline($('.configurator_preview--front .cap-parts-container > .configurator_preview-locker-front-left, ' + '.configurator_preview--front .cap-parts-container > .configurator_preview-locker-front-right, ' + '.configurator_preview--front .cap-parts-container > .configurator_preview-locker2-front-left, ' + '.configurator_preview--front .cap-parts-container > .configurator_preview-locker2-front-right, ' + '.configurator_preview--back .cap-parts-container > .configurator_preview-locker-front-left, ' + '.configurator_preview--back .cap-parts-container > .configurator_preview-locker-front-right, ' + '.configurator_preview--back .cap-parts-container > .configurator_preview-locker2-front-left, ' + '.configurator_preview--back .cap-parts-container > .configurator_preview-locker2-front-right, ' + '.configurator_preview--side .cap-parts-container > .configurator_preview-locker-front-left, ' + '.configurator_preview--side .cap-parts-container > .configurator_preview-locker-front-right, ' + '.configurator_preview--side .cap-parts-container > .configurator_preview-locker2-front-left, ' + '.configurator_preview--side .cap-parts-container > .configurator_preview-locker2-front-right'), true);
  };
  var groupCustomCapOptions = function groupCustomCapOptions() {
    if (!isCustomCapHeightConfigurator()) {
      return;
    }
    var $heightRow = $('tr.capot-height-input');
    var $capRows = $('tr.cap_handle_customs, tr.capot_double_cloche, tr.config_capot_supl');
    var $dimensionsTable = $('#price_calculator');
    if (!$heightRow.length || !$dimensionsTable.length) {
      return;
    }
    var $panel = $('.custom-cap-options-panel');
    var $tbody;
    if (!$panel.length) {
      $panel = $('<table class="extra-options thwepo_variable custom-cap-options-panel"><tbody></tbody></table>');
    }
    var $baseOptionsTable = $('.variations_form table.variations:first');
    var $insertAfter = $baseOptionsTable.length ? $baseOptionsTable : $dimensionsTable;
    if ($panel.prev()[0] !== $insertAfter[0]) {
      $panel.insertAfter($insertAfter);
    }
    $tbody = $panel.find('tbody:first');
    if (!$tbody.length) {
      $tbody = $('<tbody></tbody>');
      $panel.append($tbody);
    }
    if (!$tbody.find('.custom-cap-options-heading').length) {
      $tbody.append('<tr class="custom-cap-options-heading"><td colspan="2"><label class="label-tag">Options du capot</label></td></tr>');
    }
    $tbody.append($heightRow);
    $capRows.each(function () {
      $tbody.append($(this));
    });
  };
  var getRackSideHandlesAccessoryRowHtml = function getRackSideHandlesAccessoryRowHtml() {
    return '' + '<tr class="rack-side-handles-row rack-side-handles-accessory-row">' + '<td class="label"><label for="rack_side_handles">Poign&eacute;es lat&eacute;rales</label></td>' + '<td class="value rack-config-inputs rack-side-handle-inputs">' + '<label class="rack-side-handle-choice" for="rack_side_handles"><input type="checkbox" name="rack_side_handles" id="rack_side_handles" value="yes" /> Ajouter des poign&eacute;es lat&eacute;rales</label>' + '<div class="rack-sidehandle-position hide">' + '<span class="rack-sidehandle-position-title">Position des poign&eacute;es lat&eacute;rales</span>' + '<label for="rack_sidehandle_position_bottom"><input type="radio" name="rack_sidehandle_position" id="rack_sidehandle_position_bottom" value="bottom-position" /> En bas</label>' + '<label for="rack_sidehandle_position_center"><input type="radio" name="rack_sidehandle_position" id="rack_sidehandle_position_center" value="center-position" checked="checked" /> Au milieu</label>' + '<label for="rack_sidehandle_position_top"><input type="radio" name="rack_sidehandle_position" id="rack_sidehandle_position_top" value="top-position" /> En haut</label>' + '</div>' + '</td>' + '</tr>';
  };
  var ensureRackSideHandlesAccessoryRow = function ensureRackSideHandlesAccessoryRow($extraOptionsTable) {
    if (!isRackConfigurator() || $('#rack_side_handles').length) {
      return;
    }
    $extraOptionsTable = $extraOptionsTable && $extraOptionsTable.length ? $extraOptionsTable : $('table.extra-options').not('.custom-cap-options-panel').first();
    if (!$extraOptionsTable.length) {
      return;
    }
    var $tbody = $extraOptionsTable.find('tbody:first');
    if (!$tbody.length) {
      $tbody = $('<tbody></tbody>');
      $extraOptionsTable.append($tbody);
    }
    var $row = $(getRackSideHandlesAccessoryRowHtml());
    var $typeMontageRow = $tbody.find('tr').filter(function () {
      return $.trim($(this).text()).toLowerCase().indexOf('type de montage') !== -1;
    }).first();
    if ($typeMontageRow.length) {
      $row.insertBefore($typeMontageRow);
    } else {
      $tbody.prepend($row);
    }
  };
  var getValiseSideHandlesAccessoryRowHtml = function getValiseSideHandlesAccessoryRowHtml() {
    return '' + '<tr class="flightcase_customs thwepo_checkboxgroup valise-side-handles-row valise-side-handles-accessory-row">' + '<td class="label leftside"><label class="label-tag" for="valise_side_handles">Poign&eacute;es lat&eacute;rales</label></td>' + '<td class="value leftside valise-side-handle-inputs">' + '<label class="valise-side-handle-choice label-tag checkbox" for="valise_side_handles" style="display:inline; margin-right: 10px;"><input type="checkbox" class="thwepo-input-field input-checkbox" name="valise_side_handles" id="valise_side_handles" value="yes" /> Ajouter des poign&eacute;es lat&eacute;rales</label>' + '</td>' + '</tr>';
  };
  var ensureValiseSideHandlesAccessoryRow = function ensureValiseSideHandlesAccessoryRow($extraOptionsTable) {
    if (!isValisePricingV2Enabled() || $('#valise_side_handles').length) {
      return;
    }
    $extraOptionsTable = $extraOptionsTable && $extraOptionsTable.length ? $extraOptionsTable : $('table.extra-options').not('.custom-cap-options-panel').first();
    if (!$extraOptionsTable.length) {
      return;
    }
    var $tbody = $extraOptionsTable.find('tbody:first');
    if (!$tbody.length) {
      $tbody = $('<tbody></tbody>');
      $extraOptionsTable.append($tbody);
    }
    var $row = $(getValiseSideHandlesAccessoryRowHtml());
    var $positionRow = $tbody.find('tr.sidehandle_position').first();
    var $typeMontageRow = $tbody.find('tr').filter(function () {
      return $.trim($(this).text()).toLowerCase().indexOf('type de montage') !== -1;
    }).first();
    if ($positionRow.length) {
      $row.insertBefore($positionRow);
    } else if ($typeMontageRow.length) {
      $row.insertBefore($typeMontageRow);
    } else {
      $tbody.prepend($row);
    }
    syncValiseSideHandleOptionState();
  };
  var hideRackSideLockersOption = function hideRackSideLockersOption($extraOptionsTable) {
    var $sideLockersRow;
    var $sideLockersInput;
    if (!isRackConfigurator()) {
      return;
    }
    $sideLockersRow = $('#side_lockers_field');
    if (!$sideLockersRow.length && $extraOptionsTable && $extraOptionsTable.length) {
      $sideLockersRow = $extraOptionsTable.find('#side_lockers_field');
    }
    if (!$sideLockersRow.length) {
      return;
    }
    $sideLockersInput = $sideLockersRow.find('#side_lockers_side-lockers');
    $sideLockersInput.prop('checked', false).prop('disabled', true).closest('label').addClass('hide rack-hidden-option').hide().attr('aria-hidden', 'true');
  };
  var prepareConfiguratorFormLayout = function prepareConfiguratorFormLayout() {
    var $priceCalculator = $('#price_calculator');
    var $baseOptionsTable = $('.variations_form table.variations:first');
    var $extraOptionsTable = $('table.extra-options').not('.custom-cap-options-panel').first();
    var $baseTitle = $('.configurator-section-title--base');
    var $accessoriesTitle = $('.configurator-section-title--accessories');
    $priceCalculator.addClass('configurator-dimensions-panel');
    $baseOptionsTable.addClass('configurator-base-options-panel');
    $extraOptionsTable.addClass('configurator-accessories-panel');
    hideRackSideLockersOption($extraOptionsTable);
    ensureRackSideHandlesAccessoryRow($extraOptionsTable);
    ensureValiseSideHandlesAccessoryRow($extraOptionsTable);
    if ($baseOptionsTable.length) {
      $priceCalculator.insertBefore($baseOptionsTable);
      if (!$baseTitle.length) {
        $baseTitle = $('<div class="configurator-section-title configurator-section-title--base">Configuration de base</div>');
      }
      $baseTitle.insertBefore($baseOptionsTable);
    }
    if ($extraOptionsTable.length) {
      if (!$accessoriesTitle.length) {
        $accessoriesTitle = $('<div class="configurator-section-title configurator-section-title--accessories">Accessoires et personnalisations</div>');
      }
      $accessoriesTitle.insertBefore($extraOptionsTable);
    }
  };
  var getRequiredConfiguratorSelects = function getRequiredConfiguratorSelects() {
    return $('.variations_form table.variations:first select').filter(function () {
      var $select = $(this);
      var $row = $select.closest('tr');
      return !$select.prop('disabled') && $row.length && !$row.hasClass('hide') && $row.is(':visible');
    });
  };
  var getRequiredConfiguratorSelectLabel = function getRequiredConfiguratorSelectLabel($select) {
    var label = $.trim($select.find('option:first').text() || $select.attr('data-placeholder') || 'ce champ');
    label = label.replace(/^Configurateur\s*:\s*/i, '');
    label = $.trim(label.replace(/\s+/g, ' '));
    return label || 'ce champ';
  };
  var ensureRequiredConfiguratorStepAction = function ensureRequiredConfiguratorStepAction() {
    var $baseTitle = $('.configurator-section-title--base');
    var $action = $baseTitle.find('.js--configurator-next-step-action');
    if (!$baseTitle.length) {
      return $();
    }
    if (!$action.length) {
      $action = $('<button type="button" class="configurator-next-step-action js--configurator-next-step-action hide">' + '<span class="configurator-next-step-action__eyebrow">Étape suivante</span>' + '<span class="configurator-next-step-action__label"></span>' + '</button>');
      $baseTitle.append($action);
    }
    return $action;
  };
  var focusRequiredConfiguratorSelect = function focusRequiredConfiguratorSelect($select, openSelect) {
    var $row = $select.closest('tr');
    var rowTop;
    var rowBottom;
    var viewportTop;
    var viewportBottom;
    var scrollFrame = 0;
    var stableFrames = 0;
    var lastScrollTop = -1;
    var openNextSelect = function openNextSelect() {
      var $firstMissing;
      if (!openSelect || !$select.data('select2') || $select.prop('disabled') || !$row.is(':visible')) {
        return;
      }
      $firstMissing = getRequiredConfiguratorSelects().filter(function () {
        return $.trim($(this).val() || '') === '';
      }).first();
      if (!$firstMissing.length || $firstMissing[0] !== $select[0] || $('.select2-container--open').length) {
        return;
      }
      $select.select2('open');
    };
    var _openWhenScrollIsStable = function openWhenScrollIsStable() {
      var currentScrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
      if (Math.abs(currentScrollTop - lastScrollTop) < 1) {
        stableFrames += 1;
      } else {
        stableFrames = 0;
        lastScrollTop = currentScrollTop;
      }
      scrollFrame += 1;
      if (stableFrames >= 3 || scrollFrame >= 45) {
        openNextSelect();
        return;
      }
      window.requestAnimationFrame(_openWhenScrollIsStable);
    };
    if (!$row.length || !$row.is(':visible')) {
      return;
    }
    rowTop = $row.offset().top;
    rowBottom = rowTop + $row.outerHeight();
    viewportTop = $(window).scrollTop();
    viewportBottom = viewportTop + $(window).height();
    if (rowTop < viewportTop + 140 || rowBottom > viewportBottom - 80) {
      // The customer explicitly asked to reach this step. Use the browser's
      // single scrolling root so closing Select2 cannot restore a competing
      // html/body position and make the page jump on the following choice.
      $row[0].scrollIntoView({
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        block: 'center'
      });
      window.requestAnimationFrame(_openWhenScrollIsStable);
    } else {
      window.setTimeout(openNextSelect, 80);
    }
  };
  var updateRequiredConfiguratorSteps = function updateRequiredConfiguratorSteps() {
    var $selects = getRequiredConfiguratorSelects();
    var $baseTitle = $('.configurator-section-title--base');
    var $stepAction = ensureRequiredConfiguratorStepAction();
    var $missing;
    var $next;
    var nextId;
    var nextLabel;
    $selects.each(function () {
      var $select = $(this);
      var $row = $select.closest('tr');
      var $container = $select.next('.select2-container');
      $row.removeClass('configurator-missing-required configurator-required-current').removeAttr('aria-current');
      $container.removeClass('configurator-missing-required configurator-required-current');
    });
    $baseTitle.removeClass('configurator-section-title--needs-selection').removeAttr('data-required-next');
    $stepAction.addClass('hide').removeAttr('aria-label data-target-select');
    $missing = $selects.filter(function () {
      return $.trim($(this).val() || '') === '';
    });
    if (!$missing.length) {
      return;
    }
    $missing.each(function () {
      var $select = $(this);
      var $row = $select.closest('tr');
      var $container = $select.next('.select2-container');
      $row.addClass('configurator-missing-required');
      $container.addClass('configurator-missing-required');
    });
    $next = $missing.first();
    nextId = $next.attr('id');
    nextLabel = getRequiredConfiguratorSelectLabel($next);
    $next.closest('tr').addClass('configurator-required-current').attr('aria-current', 'step');
    $next.next('.select2-container').addClass('configurator-required-current');
    $baseTitle.addClass('configurator-section-title--needs-selection').attr('data-required-next', 'À compléter : ' + nextLabel);
    if ($stepAction.length && nextId) {
      $stepAction.removeClass('hide').attr({
        'aria-label': 'Choisir : ' + nextLabel,
        'data-target-select': nextId
      }).find('.configurator-next-step-action__label').text('Choisir : ' + nextLabel + ' →');
    }
  };
  var initRequiredConfiguratorSteps = function initRequiredConfiguratorSteps() {
    var updateTimer = null;
    var scheduleUpdate = function scheduleUpdate(delay) {
      window.clearTimeout(updateTimer);
      updateTimer = window.setTimeout(function () {
        updateRequiredConfiguratorSteps();
      }, typeof delay === 'number' ? delay : 180);
    };
    $(document).off('.configuratorRequiredSteps');
    $(document).on('change.configuratorRequiredSteps select2:select.configuratorRequiredSteps select2:clear.configuratorRequiredSteps select2:unselect.configuratorRequiredSteps', '.variations_form table.variations:first select', function () {
      // Keep the page stable after a choice. The highlighted CTA lets
      // the customer open the next step deliberately.
      scheduleUpdate(180);
    });
    $(document).on('click.configuratorRequiredSteps', '.js--configurator-next-step-action', function () {
      var targetId = $(this).attr('data-target-select');
      var target = targetId ? document.getElementById(targetId) : null;
      if (target) {
        focusRequiredConfiguratorSelect($(target), true);
      }
    });
    $(document).on('reset_data.configuratorRequiredSteps woocommerce_update_variation_values.configuratorRequiredSteps', '.variations_form', function () {
      scheduleUpdate(180);
    });
    scheduleUpdate(0);
  };
  var getValiseCustomCapHeightProgress = function getValiseCustomCapHeightProgress() {
    if (!isValiseCustomCapHeightConfigurator()) {
      return 0;
    }
    var max = getCustomCapHeightBaseMax();
    var value = syncCustomCapHeightField(false);
    var defaultHeight = getCustomCapHeightDefault();
    if (value <= defaultHeight || max <= defaultHeight) {
      return 0;
    }
    return Math.max(0, Math.min(1, (value - defaultHeight) / (max - defaultHeight)));
  };
  var applyValiseCustomCapHeightToVisuals = function applyValiseCustomCapHeightToVisuals() {
    var caseHeight = parseInt($('.height-input:first input[name="height_needed"]:first').val(), 10);
    var capHeight = syncCustomCapHeightField(false);
    if (isNaN(caseHeight) || caseHeight <= 0 || isNaN(capHeight)) {
      return;
    }

    // The Valise field is the visible cap height. Keep the historical
    // separation position by adding the aluminium profile allowance.
    var visualCapHeight = capHeight + valiseCustomCapVisualOffset;
    var seamPercent = Math.max(0, Math.min(50, visualCapHeight / caseHeight * 100));
    var steelplatePercent = Math.min(95, seamPercent + 17);
    var mainHandlePercent = 55 - 5 * getValiseCustomCapHeightProgress();
    var $verticalViews = $('.configurator_preview--top, .configurator_preview--side, .configurator_preview--back');
    var seamParts = ['.cap-parts-container > .configurator_preview-cap.js--set-cap-height', '.cap-parts-container > .configurator_preview-brace', '.cap-parts-container > .configurator_preview-capfixer', '.cap-parts-container > .configurator_preview--pivot-container', '.cap-parts-container > .configurator_preview--arretoir-container', '.cap-parts-container > .valise-removable-back-lockers', '.configurator_preview-fermoir-grenouille--top', '.configurator_preview-fermoir-grenouille-clef--top', '.configurator_preview-fermoir-papillon--top', '.configurator_preview-fermoir-grenouille--side', '.configurator_preview-fermoir-grenouille-clef--side', '.configurator_preview-fermoir-papillon--side'].join(', ');
    $verticalViews.find(seamParts).css('top', seamPercent + '%');
    $verticalViews.find('.configurator_preview-steelplate').css({
      'top': steelplatePercent + '%',
      'transform': ''
    });
    $verticalViews.find('.configurator_preview-handle-surface, .configurator_preview-handle-leather, .configurator_preview-handle-retractable').css('top', mainHandlePercent + '%');
  };
  var applyCustomCapHeightToVisuals = function applyCustomCapHeightToVisuals() {
    if (!isCustomCapHeightConfigurator()) {
      return;
    }
    if (isValiseCustomCapHeightConfigurator()) {
      applyValiseCustomCapHeightToVisuals();
      return;
    }
    var capTranslateRatio = 2.12;
    var capLineTop = getCustomCapProfileTopDisplaySize();
    var defaultCapLineTop = parseFloat(getElementDisplaySize(capSize * capTranslateRatio));
    var topOffset = capLineTop - defaultCapLineTop;
    var steelplateOffset = $('body').hasClass('flight-case-cloche') ? -topOffset : topOffset;
    var $capContainers = $('.cap-parts-container');
    $capContainers.children('.configurator_preview-cap.js--set-cap-height').css({
      'height': getElementDisplaySize(capSize),
      'top': topOffset + 'px'
    });
    $capContainers.children('.configurator_preview-brace, .configurator_preview-locker, .configurator_preview-locker2, .configurator_preview-capfixer, .configurator_preview--pivot-container, .configurator_preview--arretoir-container').css('top', topOffset + 'px');
    $('.configurator_preview-steelplate').css('transform', 'translateY(' + steelplateOffset + 'px)');
  };
  var getRackMeasurementInputs = function getRackMeasurementInputs() {
    return {
      length: $('.length-input:first input[name="length_needed"]:first'),
      width: $('.width-input:first input[name="width_needed"]:first'),
      height: $('.height-input:first input[name="height_needed"]:first')
    };
  };
  var getRackMode = function getRackMode() {
    return $('input[name="rack_type"]:checked').val() === 'custom' ? 'custom' : 'rack-19';
  };
  var getRackCapDepthLimits = function getRackCapDepthLimits() {
    var min = parseInt(getRackConfiguratorOptionText('rack_cap_depth_min_mm', rackCapDepthMinMm), 10);
    var defaultValue = parseInt(getRackConfiguratorOptionText('rack_cap_depth_default_mm', rackCapDepthDefaultMm), 10);
    var max = parseInt(getRackConfiguratorOptionText('rack_cap_depth_max_mm', rackCapDepthMaxMm), 10);
    min = isNaN(min) ? rackCapDepthMinMm : Math.max(rackCapDepthMinMm, min);
    max = isNaN(max) || max <= 0 ? rackCapDepthMaxMm : Math.max(min, max);
    defaultValue = isNaN(defaultValue) ? rackCapDepthDefaultMm : Math.max(min, Math.min(max, defaultValue));
    return {
      min: min,
      defaultValue: defaultValue,
      max: max
    };
  };
  var getRackCapDepthFromInput = function getRackCapDepthFromInput(selector, normalizeInput) {
    var limits = getRackCapDepthLimits();
    var $input = $(selector);
    var depth = parseInt($input.val(), 10);
    if (isNaN(depth)) {
      depth = limits.defaultValue;
    }
    depth = Math.max(limits.min, Math.min(limits.max, depth));
    if ($input.length && normalizeInput !== false) {
      $input.val(depth);
    }
    return depth;
  };

  // Historical compatibility: rack_cap_depth_mm remains the front cap depth.
  var getRackCapDepth = function getRackCapDepth(normalizeInput) {
    return getRackCapDepthFromInput(rackCapDepthInputSelector, normalizeInput);
  };
  var getRackRearCapDepth = function getRackRearCapDepth(normalizeInput) {
    return getRackCapDepthFromInput(rackRearCapDepthInputSelector, normalizeInput);
  };
  var getRackCapCount = function getRackCapCount() {
    if (!isRackConfigurator() || $('#pa_configurateur-type-de-capot').val() === 'capot-plat') {
      return 0;
    }
    return $('#rack_left_cap').is(':checked') ? 2 : 1;
  };
  var getRackCapDepthExtraMm = function getRackCapDepthExtraMm() {
    if (getRackCapCount() === 0) {
      return 0;
    }
    return getRackCapDepth() + ($('#rack_left_cap').is(':checked') ? getRackRearCapDepth() : 0);
  };
  var getRackCapVisualDepthExtraMm = function getRackCapVisualDepthExtraMm() {
    return getRackCapDepthExtraMm();
  };
  var getRackCapVisualDepthExtraDisplaySize = function getRackCapVisualDepthExtraDisplaySize() {
    var displaySize = parseFloat(getElementDisplaySize(getRackCapVisualDepthExtraMm()));
    return isNaN(displaySize) ? 0 : displaySize;
  };
  var isRackFlatCapSelected = function isRackFlatCapSelected() {
    return isRackConfigurator() && $('#pa_configurateur-type-de-capot').val() === 'capot-plat';
  };
  var getRackFlatCapClearance = function getRackFlatCapClearance(selector) {
    var $input = $(selector);
    var value = parseInt($input.val(), 10);
    if (isNaN(value)) {
      value = rackFlatCapDefaultClearanceMm;
    }
    value = Math.max(0, Math.min(1000, value));
    if ($input.length) {
      $input.val(value);
    }
    return value;
  };
  var getRackFlatFrontClearanceMm = function getRackFlatFrontClearanceMm() {
    return getRackFlatCapClearance('#rack_flat_front_clearance_mm');
  };
  var getRackFlatRearClearanceMm = function getRackFlatRearClearanceMm() {
    return $('#rack_left_cap').is(':checked') ? getRackFlatCapClearance('#rack_flat_rear_clearance_mm') : 0;
  };
  var getRackFlatCapDepthExtraMm = function getRackFlatCapDepthExtraMm() {
    if (!isRackFlatCapSelected()) {
      return 0;
    }
    var extra = rackFlatCapDepthMm + getRackFlatFrontClearanceMm();
    if ($('#rack_left_cap').is(':checked')) {
      extra += rackFlatCapDepthMm + getRackFlatRearClearanceMm();
    }
    return extra;
  };
  var getRackFlatCapPanelExtraMm = function getRackFlatCapPanelExtraMm() {
    return isRackFlatCapSelected() ? rackFlatCapPanelExtraMm : 0;
  };
  var getRackCapLengthContributionsMm = function getRackCapLengthContributionsMm(normalizeCapInputs) {
    var hasRearCap = $('#rack_left_cap').is(':checked');
    var front = 0;
    var rear = 0;
    if (isRackFlatCapSelected()) {
      front = rackFlatCapDepthMm + getRackFlatFrontClearanceMm();
      rear = hasRearCap ? rackFlatCapDepthMm + getRackFlatRearClearanceMm() : 0;
    } else {
      front = getRackCapDepth(normalizeCapInputs);
      rear = hasRearCap ? getRackRearCapDepth(normalizeCapInputs) : 0;
    }
    return {
      front: front,
      rear: rear,
      total: front + rear
    };
  };
  var syncRackLengthModel = function syncRackLengthModel(inputs, isRack19, rack19BodyLength, normalizeCapInputs) {
    var $totalInput = $(rackTotalLengthInputSelector);
    var $totalRow = $('.rack-custom-total-length-row');
    var $status = $('.rack-custom-body-length-status');
    var contributions = getRackCapLengthContributionsMm(normalizeCapInputs);
    var totalLength = 0;
    var bodyLength = 0;
    var isValid = true;
    var validationMessage = '';
    $totalRow.toggleClass('hide', isRack19);
    $totalInput.prop('disabled', isRack19);
    inputs.length.prop('readonly', !isRack19);
    if (isRack19) {
      bodyLength = parseInt(rack19BodyLength, 10);
      bodyLength = isNaN(bodyLength) ? rackDefaultDepthMm : bodyLength;
      totalLength = bodyLength + contributions.total;
      $totalInput.removeClass('is-invalid').attr('aria-invalid', 'false');
      $status.removeClass('is-invalid').text('');
      $('body').removeClass('rack-custom-body-length-invalid');
      if ($totalInput.length && $totalInput[0].setCustomValidity) {
        $totalInput[0].setCustomValidity('');
      }
    } else {
      var postedTotalLength = parseInt($totalInput.val(), 10);
      if (!rackCustomTotalLengthInitialized) {
        if (isNaN(postedTotalLength)) {
          var currentBodyLength = parseInt(inputs.length.val(), 10);
          currentBodyLength = isNaN(currentBodyLength) ? rackMinUsableBodyLengthMm : currentBodyLength;
          postedTotalLength = currentBodyLength + contributions.total;
          $totalInput.val(postedTotalLength);
        }
        rackCustomTotalLengthInitialized = true;
      }
      totalLength = parseInt($totalInput.val(), 10);
      bodyLength = isNaN(totalLength) ? 0 : totalLength - contributions.total;
      isValid = !isNaN(totalLength) && bodyLength >= rackMinUsableBodyLengthMm;
      $totalInput.attr({
        min: contributions.total + rackMinUsableBodyLengthMm,
        step: 1,
        'aria-describedby': 'rack_custom_body_length_status',
        'aria-invalid': isValid ? 'false' : 'true'
      }).toggleClass('is-invalid', !isValid);
      inputs.length.val(bodyLength);
      if (isNaN(totalLength)) {
        validationMessage = 'Renseignez la longueur intérieure totale du rack.';
        $status.text(validationMessage);
      } else {
        $status.text('Longueur utile du corps (hors capots) : ' + bodyLength + ' mm' + (isValid ? '' : ' — minimum ' + rackMinUsableBodyLengthMm + ' mm. Augmentez la longueur totale ou réduisez la profondeur des capots.'));
        if (!isValid) {
          validationMessage = 'La longueur utile du corps du rack doit être d’au moins ' + rackMinUsableBodyLengthMm + ' mm.';
        }
      }
      $status.toggleClass('is-invalid', !isValid);
      $('body').toggleClass('rack-custom-body-length-invalid', !isValid);
      if ($totalInput.length && $totalInput[0].setCustomValidity) {
        $totalInput[0].setCustomValidity(validationMessage);
      }
    }
    return {
      mode: isRack19 ? 'rack-19' : 'custom',
      totalLengthMm: totalLength,
      usableBodyLengthMm: bodyLength,
      minUsableBodyLengthMm: rackMinUsableBodyLengthMm,
      minTotalLengthMm: contributions.total + rackMinUsableBodyLengthMm,
      frontCapContributionMm: contributions.front,
      rearCapContributionMm: contributions.rear,
      totalCapContributionMm: contributions.total,
      valid: isValid
    };
  };
  var getRackSideVisualDisplayWidth = function getRackSideVisualDisplayWidth(baseDisplayWidth) {
    if (!isRackConfigurator()) {
      return baseDisplayWidth;
    }
    var flatCapDisplaySize = parseFloat(getElementDisplaySize(getRackFlatCapDepthExtraMm()));
    return baseDisplayWidth + getRackCapVisualDepthExtraDisplaySize() + (isNaN(flatCapDisplaySize) ? 0 : flatCapDisplaySize);
  };
  var getRackUnits = function getRackUnits() {
    var units = parseInt($('#rack_units').val(), 10);
    if (isNaN(units)) {
      units = rackDefaultUnits;
    }
    units = Math.max(rackMinUnits, Math.min(rackMaxUnits, units));
    $('#rack_units').val(units);
    return units;
  };
  var getRackDepth = function getRackDepth() {
    var depth = parseInt($('#rack_depth_mm').val(), 10);
    if (isNaN(depth)) {
      depth = rackDefaultDepthMm;
    }
    depth = Math.max(200, Math.min(1200, depth));
    $('#rack_depth_mm').val(depth);
    return depth;
  };
  var getRackHeightFromUnits = function getRackHeightFromUnits(units) {
    return Math.round((units + rackCaseHeightOffsetUnits) * rackUnitHeightMm);
  };
  var buildRackNumberStepperHtml = function buildRackNumberStepperHtml(options) {
    return '<div class="rack-number-stepper-control">' + '<button type="button" class="rack-number-stepper rack-number-stepper-minus" data-rack-step-target="#' + options.id + '" data-rack-step="-1" aria-label="' + options.decreaseLabel + '">-</button>' + '<input type="number" name="' + options.name + '" id="' + options.id + '" value="' + options.value + '" min="' + options.min + '" max="' + options.max + '" step="' + options.step + '" autocomplete="off" />' + '<button type="button" class="rack-number-stepper rack-number-stepper-plus" data-rack-step-target="#' + options.id + '" data-rack-step="1" aria-label="' + options.increaseLabel + '">+</button>' + '</div>';
  };
  var syncRackNumberStepperControls = function syncRackNumberStepperControls() {
    $('.rack-number-stepper-control').each(function () {
      var $control = $(this);
      var $input = $control.find('input[type="number"]:first');
      var value = parseInt($input.val(), 10);
      var min = parseInt($input.attr('min'), 10);
      var max = parseInt($input.attr('max'), 10);
      if (!$input.length || isNaN(value)) {
        return;
      }
      $control.find('.rack-number-stepper-minus').prop('disabled', !isNaN(min) && value <= min);
      $control.find('.rack-number-stepper-plus').prop('disabled', !isNaN(max) && value >= max);
    });
  };
  var applyRackNumberStep = function applyRackNumberStep($button) {
    var $input = $($button.data('rack-step-target'));
    var step = parseInt($button.data('rack-step'), 10);
    var value = parseInt($input.val(), 10);
    var min = parseInt($input.attr('min'), 10);
    var max = parseInt($input.attr('max'), 10);
    if (!$input.length || isNaN(step)) {
      return;
    }
    if (isNaN(value)) {
      value = isNaN(min) ? 0 : min;
    }
    value += step;
    if (!isNaN(min)) {
      value = Math.max(min, value);
    }
    if (!isNaN(max)) {
      value = Math.min(max, value);
    }
    $input.val(value).trigger('input').trigger('change').focus();
    syncRackNumberStepperControls();
  };
  var replaceConfiguratorPieceFilename = function replaceConfiguratorPieceFilename(src, filename) {
    if (!src) {
      return '';
    }
    return src.replace(/[^\/?#]+(\?.*)?$/, function (match, query) {
      return filename + (query || '');
    });
  };
  var getConfiguratorImageRealSrc = function getConfiguratorImageRealSrc($img) {
    var src = $img.attr('data-lazy-src') || $img.attr('data-src') || $img.attr('data-ori') || $img.attr('src') || '';
    if (src.indexOf('data:image/svg+xml') === 0) {
      src = $img.attr('data-lazy-src') || $img.attr('data-src') || '';
    }
    return src || $img.attr('src') || '';
  };
  var syncHandleImageVariant = function syncHandleImageVariant($images, useSmallHandle, cachePrefix) {
    var allBlack = $('#customs_all-black').is(':checked');
    var normalSrcAttr = 'data-' + cachePrefix + '-handle-normal-src';
    var normalBlackAttr = 'data-' + cachePrefix + '-handle-normal-black';
    $images.each(function () {
      var $img = $(this);
      var src = getConfiguratorImageRealSrc($img);
      var blackSrc = $img.attr('data-black') || '';
      if (!$img.attr(normalSrcAttr)) {
        var normalSrc = src.replace('handle-black-petit-black.svg', 'handle.svg').replace('handle-petit.svg', 'handle.svg').replace('handle-black.svg', 'handle.svg');
        var normalBlackSrc = (blackSrc || normalSrc.replace('handle.svg', 'handle-black.svg')).replace('handle-black-petit-black.svg', 'handle-black.svg').replace('handle-petit.svg', 'handle-black.svg');
        $img.attr(normalSrcAttr, normalSrc);
        $img.attr(normalBlackAttr, normalBlackSrc);
      }
      var nextSrc = $img.attr(normalSrcAttr);
      var nextBlackSrc = $img.attr(normalBlackAttr);
      if (useSmallHandle) {
        nextSrc = nextSrc.replace('handle.svg', 'handle-petit.svg');
        nextBlackSrc = nextBlackSrc.replace('handle-black.svg', 'handle-black-petit-black.svg');
      }
      $img.attr('data-black', nextBlackSrc);
      $img.attr('data-ori', nextSrc);
      $img.attr('data-lazy-src', allBlack ? nextBlackSrc : nextSrc);
      $img.attr('src', allBlack ? nextBlackSrc : nextSrc);
    });
  };
  var syncRackHandleVariant = function syncRackHandleVariant(units, isRack19) {
    if (!isRackConfigurator()) {
      return;
    }
    syncHandleImageVariant($('.configurator_preview--artboard .configurator_preview-handle.js--set-handle-size img'), isRack19 && parseInt(units, 10) < 4, 'rack');
  };
  var getClocheHandleBodyPercent = function getClocheHandleBodyPercent() {
    if (!isClocheConfigurator() || !isCustomCapHeightConfigurator()) {
      return null;
    }
    var caseHeight = parseInt($('.height-input:first input[name="height_needed"]:first').val(), 10);
    var capHeight = syncCustomCapHeightField(false);
    if (isNaN(caseHeight) || caseHeight <= 0 || isNaN(capHeight)) {
      return null;
    }
    return Math.max(0, 100 - capHeight / caseHeight * 100);
  };
  var getClocheBaseHandleBandPercent = function getClocheBaseHandleBandPercent(side) {
    var bodyPercent = getClocheHandleBodyPercent();
    var fallbackBand = {
      start: 0,
      end: bodyPercent === null ? 100 : bodyPercent
    };
    if (!side) {
      return fallbackBand;
    }
    var $view = $('.' + side + ':first');
    if (!$view.length) {
      return fallbackBand;
    }
    var topProfileBottom = getRelativeCustomCapViewEdge($view, '.configurator_preview-hinge-top svg', 'bottom');
    var capProfileTop = getRelativeCustomCapViewEdge($view, '.configurator_preview-cap svg', 'top');
    var viewHeight = getCaseDisplayHeight();
    if (topProfileBottom === null || capProfileTop === null || capProfileTop <= topProfileBottom || viewHeight <= 0) {
      return fallbackBand;
    }
    return {
      start: topProfileBottom / viewHeight * 100,
      end: capProfileTop / viewHeight * 100
    };
  };
  var getClocheBaseHandleDisplayHeight = function getClocheBaseHandleDisplayHeight(useSmallHandle) {
    var displayWidth = parseFloat(getElementDisplaySize(handleSize || 160));
    var imageRatio = useSmallHandle ? 234.2 / 441.2 : 303.6 / 456.7;
    if (isNaN(displayWidth) || displayWidth <= 0) {
      displayWidth = parseFloat($('.js--set-handle-size:first').css('width')) || 0;
    }
    return displayWidth * imageRatio;
  };
  var getClocheBaseHandleBandCandidates = function getClocheBaseHandleBandCandidates() {
    var candidates = [];
    $.each(['configurator_preview--front', 'configurator_preview--back', 'configurator_preview--side'], function (index, side) {
      var $view = $('.' + side + ':first');
      if (!$view.length) {
        return;
      }
      var rect = $view.get(0).getBoundingClientRect();
      if (!rect.width || !rect.height || $view.css('display') === 'none') {
        return;
      }
      candidates.push(getClocheBaseHandleBandPercent(side));
    });
    if (!candidates.length) {
      candidates.push(getClocheBaseHandleBandPercent('configurator_preview--front'));
    }
    return candidates;
  };
  var shouldUseSmallClocheHandle = function shouldUseSmallClocheHandle() {
    var caseHeight = parseInt($('.height-input:first input[name="height_needed"]:first').val(), 10);
    var handleBands = getClocheBaseHandleBandCandidates();
    var caseDisplayHeight = getCaseDisplayHeight();
    if (!isNaN(caseHeight) && caseHeight <= 250) {
      return true;
    }
    if (caseDisplayHeight <= 0) {
      return false;
    }
    var normalDisplayHeight = getClocheBaseHandleDisplayHeight(false);
    var clearance = Math.max(4, parseFloat(getElementDisplaySize(12)) || 4);
    for (var i = 0; i < handleBands.length; i++) {
      var handleBand = handleBands[i];
      var bodyDisplayHeight = caseDisplayHeight * Math.max(0, handleBand.end - handleBand.start) / 100;
      if (bodyDisplayHeight > 0 && normalDisplayHeight + clearance * 2 > bodyDisplayHeight) {
        return true;
      }
    }
    return false;
  };
  var syncClocheBaseHandleImageOffset = function syncClocheBaseHandleImageOffset(useSmallHandle) {
    if (!isClocheConfigurator()) {
      return;
    }
    var displayHeight = getClocheBaseHandleDisplayHeight(useSmallHandle);
    if (displayHeight <= 0 || isNaN(displayHeight)) {
      return;
    }
    $('.configurator_preview--artboard .configurator_preview-handle.js--set-handle-size img').css('top', -(displayHeight / 2) + 'px');
  };
  var syncClocheHandleVariant = function syncClocheHandleVariant() {
    if (!isClocheConfigurator()) {
      return;
    }
    var useSmallHandle = shouldUseSmallClocheHandle();
    syncHandleImageVariant($('.configurator_preview--artboard .configurator_preview-handle.js--set-handle-size img'), useSmallHandle, 'cloche');
    syncClocheBaseHandleImageOffset(useSmallHandle);
  };
  var getClocheBaseHandleTopPercent = function getClocheBaseHandleTopPercent(positionValue, fallbackPercent, side) {
    var handleBand = getClocheBaseHandleBandPercent(side);
    var availablePercent = Math.max(0, handleBand.end - handleBand.start);
    var caseDisplayHeight = getCaseDisplayHeight();
    if (availablePercent <= 0 || caseDisplayHeight <= 0) {
      return getCustomCapSafeHandleTopPercent(fallbackPercent);
    }
    var positionRatio = 0.5;
    if (positionValue === 'top-position') {
      positionRatio = 0.25;
    } else if (positionValue === 'bottom-position') {
      positionRatio = 0.75;
    }
    var useSmallHandle = shouldUseSmallClocheHandle();
    var handleHalfPercent = getClocheBaseHandleDisplayHeight(useSmallHandle) / caseDisplayHeight * 100 / 2;
    var clearancePercent = Math.max(4, parseFloat(getElementDisplaySize(8)) || 4) / caseDisplayHeight * 100;
    var centeredPercent = handleBand.start + availablePercent * positionRatio;
    var minPercent = handleBand.start + handleHalfPercent + clearancePercent;
    var maxPercent = handleBand.end - handleHalfPercent - clearancePercent;
    if (maxPercent < minPercent) {
      return handleBand.start + availablePercent / 2;
    }
    return Math.min(maxPercent, Math.max(minPercent, centeredPercent));
  };
  var syncRackLowLatchVariant = function syncRackLowLatchVariant(units, isRack19) {
    if (!isRackConfigurator()) {
      return;
    }
    var useLowLatch = isRack19 && parseInt(units, 10) < 4;
    var lowLatchFilename = 'fermoir-L903-7336-face.svg';
    var allBlack = $('#customs_all-black').is(':checked');
    var $latchImages = $('.configurator_preview--artboard .configurator_preview-locker2 img, ' + '.configurator_preview--artboard .configurator_preview-fermoir-papillon--top img, ' + '.configurator_preview--artboard .configurator_preview-fermoir-papillon--front img, ' + '.configurator_preview--artboard .configurator_preview-fermoir-papillon--side img');
    $latchImages.each(function () {
      var $img = $(this);
      var src = getConfiguratorImageRealSrc($img);
      var blackSrc = $img.attr('data-black') || '';
      if (!$img.attr('data-rack-latch-normal-src')) {
        $img.attr('data-rack-latch-normal-src', src);
        $img.attr('data-rack-latch-normal-black', blackSrc || src);
      }
      var nextSrc = $img.attr('data-rack-latch-normal-src');
      var nextBlackSrc = $img.attr('data-rack-latch-normal-black');
      $img.toggleClass('rack-low-latch', useLowLatch);
      if (useLowLatch) {
        nextSrc = replaceConfiguratorPieceFilename(nextSrc, lowLatchFilename);
        nextBlackSrc = replaceConfiguratorPieceFilename(nextBlackSrc || nextSrc, lowLatchFilename);
      }
      $img.attr('data-black', nextBlackSrc);
      $img.attr('data-ori', nextSrc);
      $img.attr('data-lazy-src', allBlack ? nextBlackSrc : nextSrc);
      $img.attr('src', allBlack ? nextBlackSrc : nextSrc);
    });
  };
  var setRackMeasurementInputAttributes = function setRackMeasurementInputAttributes(inputs, isRack19) {
    $.each(inputs, function (key, $input) {
      if (!$input.length) {
        return;
      }
      if (!$input.data('rack-default-min')) {
        $input.data('rack-default-min', $input.attr('min') || '');
        $input.data('rack-default-max', $input.attr('max') || '');
        $input.data('rack-default-step', $input.attr('step') || '');
      }
    });
    if (isRack19) {
      inputs.length.attr({
        'min': 1,
        'max': 2500,
        'step': 1
      });
      inputs.width.attr({
        'min': 1,
        'max': 1200,
        'step': 1
      });
      inputs.height.attr({
        'min': 1,
        'max': getRackHeightFromUnits(rackMaxUnits),
        'step': 1
      });
      return;
    }
    $.each(inputs, function (key, $input) {
      if (!$input.length) {
        return;
      }
      $input.attr('min', $input.data('rack-default-min'));
      $input.attr('max', $input.data('rack-default-max'));
      $input.attr('step', $input.data('rack-default-step'));
    });
  };
  var ensureRackConfiguratorFields = function ensureRackConfiguratorFields() {
    if (!isRackConfigurator() || $('#rack_type_19').length !== 0) {
      return;
    }
    var $lengthRow = $('#price_calculator tr.length-input:first');
    if (!$lengthRow.length) {
      return;
    }
    var rack19NoteText = getRackConfiguratorOptionText('rack_19_note_text', 'Rack 19" : avec rails rack 19 pouces.');
    var rack19NoteImage = getRackConfiguratorOptionText('rack_19_note_image_url', getRackCatalogAccessoryImageUrl('rack_rail_19'));
    var rackCustomNoteText = getRackConfiguratorOptionText('rack_custom_note_text', 'Rack configurable : sans rails rack 19 pouces.');
    var rackCapDepthLimits = getRackCapDepthLimits();
    var rackRailAccessoriesTitle = '<div class="rack-rail-fastener-title">Choisissez vos accessoires de rack</div>';
    var rackRearRailNote = '<div class="rack-type-note-main rack-rear-rail-note">' + buildRackRoundImageHtml(rack19NoteImage, rack19NoteText, 'rack-type-rail-thumb') + '<span class="rack-type-note-text">' + escapeHtml(rack19NoteText) + '</span></div>';
    var rackRailOptions = buildRackRailOptionHtml('rack_square_nuts', 'rack_square_nut', 'Ecrous carres') + buildRackRailOptionHtml('rack_black_pozi_screws_12', 'rack_black_pozi_screw_12', 'Vis Pozi noires 12 mm') + buildRackRailOptionHtml('rack_black_pozi_screws_16', 'rack_black_pozi_screw_16', 'Vis Pozi noires 16 mm') + buildRackRailOptionHtml('rack_plastic_washers', 'rack_plastic_washer', 'Rondelles plastique');
    var rackRearRailOptions = buildRackRailOptionHtml('rack_rear_square_nuts', 'rack_square_nut', 'Ecrous carres') + buildRackRailOptionHtml('rack_rear_black_pozi_screws_12', 'rack_black_pozi_screw_12', 'Vis Pozi noires 12 mm') + buildRackRailOptionHtml('rack_rear_black_pozi_screws_16', 'rack_black_pozi_screw_16', 'Vis Pozi noires 16 mm') + buildRackRailOptionHtml('rack_rear_plastic_washers', 'rack_plastic_washer', 'Rondelles plastique');
    var rows = '' + '<tr class="price-table-row rack-config-row rack-type-input">' + '<td><label>Type de rack</label></td>' + '<td class="rack-config-inputs rack-type-inputs">' + '<label class="rack-type-choice" for="rack_type_19"><input type="radio" id="rack_type_19" name="rack_type" value="rack-19" checked="checked" /> Rack 19&quot;</label>' + '<label class="rack-type-choice" for="rack_type_custom"><input type="radio" id="rack_type_custom" name="rack_type" value="custom" /> Rack configurable</label>' + '<div class="rack-type-note rack-type-note-19"><div class="rack-type-note-main">' + buildRackRoundImageHtml(rack19NoteImage, rack19NoteText, 'rack-type-rail-thumb') + '<span class="rack-type-note-text">' + escapeHtml(rack19NoteText) + '</span></div><div class="rack-rail-fastener-options">' + rackRailAccessoriesTitle + rackRailOptions + '</div></div>' + '<div class="rack-type-note rack-type-note-custom hide">' + escapeHtml(rackCustomNoteText) + '</div>' + '</td>' + '</tr>' + '<tr class="price-table-row rack-config-row rack-19-row">' + '<td><label for="rack_units">Hauteur du rack<div class="text-normal text-lowercase">(en unités U)</div></label></td>' + '<td class="rack-config-inputs">' + buildRackNumberStepperHtml({
      id: 'rack_units',
      name: 'rack_units',
      value: rackDefaultUnits,
      min: rackMinUnits,
      max: rackMaxUnits,
      step: 1,
      decreaseLabel: 'Diminuer la hauteur du rack',
      increaseLabel: 'Augmenter la hauteur du rack'
    }) + '</td>' + '</tr>' + '<tr class="price-table-row rack-config-row rack-19-row">' + '<td><label for="rack_depth_mm">Profondeur du rack<div class="text-normal text-lowercase">(hors capots)</div></label></td>' + '<td class="rack-config-inputs"><input type="number" name="rack_depth_mm" id="rack_depth_mm" value="' + rackDefaultDepthMm + '" min="200" max="1200" step="1" autocomplete="off" /></td>' + '</tr>' + '<tr class="price-table-row rack-config-row rack-classic-cap-depth-row rack-classic-front-cap-depth-row">' + '<td><label for="rack_cap_depth_mm">Profondeur du capot avant<div class="text-normal text-lowercase">(min ' + rackCapDepthLimits.min + ' mm / max ' + rackCapDepthLimits.max + ' mm)</div></label></td>' + '<td class="rack-config-inputs"><input type="number" name="rack_cap_depth_mm" id="rack_cap_depth_mm" value="' + rackCapDepthLimits.defaultValue + '" min="' + rackCapDepthLimits.min + '" max="' + rackCapDepthLimits.max + '" step="1" autocomplete="off" /></td>' + '</tr>' + '<tr class="price-table-row rack-config-row rack-left-cap-row">' + '<td><label for="rack_left_cap">Capot arrière</label></td>' + '<td class="rack-config-inputs"><label class="rack-left-cap-choice" for="rack_left_cap"><input type="checkbox" name="rack_left_cap" id="rack_left_cap" value="yes" /> Ajouter un capot arrière</label><div class="rack-rear-rail-fastener-options rack-rail-fastener-options hide">' + rackRearRailNote + rackRailAccessoriesTitle + rackRearRailOptions + '</div></td>' + '</tr>' + '<tr class="price-table-row rack-config-row rack-classic-cap-depth-row rack-classic-rear-cap-depth-row hide">' + '<td><label for="rack_rear_cap_depth_mm">Profondeur du capot arrière<div class="text-normal text-lowercase">(min ' + rackCapDepthLimits.min + ' mm / max ' + rackCapDepthLimits.max + ' mm)</div></label></td>' + '<td class="rack-config-inputs"><input type="number" name="rack_rear_cap_depth_mm" id="rack_rear_cap_depth_mm" value="' + rackCapDepthLimits.defaultValue + '" min="' + rackCapDepthLimits.min + '" max="' + rackCapDepthLimits.max + '" step="1" autocomplete="off" /></td>' + '</tr>' + '<tr class="price-table-row rack-config-row rack-flat-cap-clearance-row rack-flat-cap-front-row hide">' + '<td><label for="rack_flat_front_clearance_mm">Dégagement avant<div class="text-normal text-lowercase">(mm)</div></label></td>' + '<td class="rack-config-inputs"><input type="number" name="rack_flat_front_clearance_mm" id="rack_flat_front_clearance_mm" value="' + rackFlatCapDefaultClearanceMm + '" min="0" max="1000" step="1" autocomplete="off" /></td>' + '</tr>' + '<tr class="price-table-row rack-config-row rack-flat-cap-clearance-row rack-flat-cap-rear-row hide">' + '<td><label for="rack_flat_rear_clearance_mm">Dégagement arrière<div class="text-normal text-lowercase">(mm)</div></label></td>' + '<td class="rack-config-inputs"><input type="number" name="rack_flat_rear_clearance_mm" id="rack_flat_rear_clearance_mm" value="' + rackFlatCapDefaultClearanceMm + '" min="0" max="1000" step="1" autocomplete="off" /></td>' + '</tr>' + '<tr class="price-table-row rack-config-row rack-custom-total-length-row hide">' + '<td><label for="rack_total_length_mm">Longueur intérieure totale<div class="text-normal text-lowercase">(capots compris)</div></label></td>' + '<td class="rack-config-inputs"><input type="number" name="rack_total_length_mm" id="rack_total_length_mm" value="" step="1" autocomplete="off" aria-describedby="rack_custom_body_length_status" /><div id="rack_custom_body_length_status" class="rack-custom-body-length-status" role="status" aria-live="polite"></div></td>' + '</tr>';
    $lengthRow.before(rows);
  };
  var hideRackFixedVariationRows = function hideRackFixedVariationRows() {
    if (!isRackConfigurator()) {
      return;
    }
    var $capType = $('#pa_configurateur-type-de-capot');
    if ($capType.length) {
      $capType.find('option[value="capot-sur-charnieres"]').remove();
      $capType.find('option[value="capot-amovible"]').text('Capot classique');
      $capType.find('option[value="capot-plat"]').text('Capot plat');
      if (!$capType.val() || $capType.val() === 'capot-sur-charnieres') {
        $capType.val('capot-amovible');
      }
      $capType.closest('tr').removeClass('hide rack-fixed-variation-row').addClass('rack-cap-type-row');
      $capType.next('.select2').show();
      $capType.trigger('change.select2');
    }
    var $corners = $('#pa_configurateur-coins');
    if ($corners.length) {
      $corners.closest('tr').removeClass('hide rack-fixed-variation-row').addClass('rack-corner-type-row');
      $corners.next('.select2').show();
    }
  };
  var getRackFlatCapDimensionsValid = function getRackFlatCapDimensionsValid() {
    var inputs = getRackMeasurementInputs();
    var lengthValue = parseInt(inputs.length.val(), 10);
    var widthValue = parseInt(inputs.width.val(), 10);
    if (isNaN(lengthValue) || isNaN(widthValue)) {
      return true;
    }
    return lengthValue <= 1200 && widthValue <= 600;
  };
  var syncRackCapTypeAvailability = function syncRackCapTypeAvailability() {
    if (!isRackConfigurator()) {
      return;
    }
    var $capType = $('#pa_configurateur-type-de-capot');
    var $flatCapOption = $capType.find('option[value="capot-plat"]');
    if (!$flatCapOption.length) {
      return;
    }
    $flatCapOption.prop('disabled', !getRackFlatCapDimensionsValid());
    $capType.trigger('change.select2');
  };
  var syncRackCornerAvailability = function syncRackCornerAvailability() {
    if (!isRackConfigurator()) {
      return;
    }
    var $corners = $('#pa_configurateur-coins');
    if (!$corners.length) {
      return;
    }
    var isFlatCap = $('#pa_configurateur-type-de-capot').val() === 'capot-plat';
    $corners.closest('tr').removeClass('hide rack-fixed-variation-row').addClass('rack-corner-type-row');
    $corners.next('.select2').show();
    if (isFlatCap) {
      $corners.val('coins-plats');
      $corners.find('option').prop('disabled', true);
      $corners.find('option[value="coins-plats"]').prop('disabled', false);
    } else {
      $corners.find('option').prop('disabled', false);
      if (!$corners.val()) {
        $corners.val('coins-boules');
      }
    }
    $corners.trigger('change.select2');
  };
  var syncRackMousseAvailability = function syncRackMousseAvailability() {
    if (!isRackConfigurator()) {
      return;
    }
    var $mousse = $('#pa_configurateur-moussage');
    if (!$mousse.length) {
      return;
    }
    var isRack19 = getRackMode() === 'rack-19';
    var $row = $mousse.closest('tr');
    var $select2 = $mousse.next('.select2');
    if (isRack19) {
      $mousse.val('sans-mousse');
      $mousse.find('option').prop('disabled', true);
      $mousse.find('option[value="sans-mousse"]').prop('disabled', false);
      $row.addClass('hide rack-mousse-locked-row');
      $select2.hide();
    } else {
      $mousse.find('option').prop('disabled', false);
      $row.removeClass('hide rack-mousse-locked-row');
      $select2.show();
    }
    $mousse.trigger('change.select2');
  };
  var syncRackWheelsAvailability = function syncRackWheelsAvailability() {
    if (!isRackConfigurator()) {
      return;
    }
    var $wheels = $('#wheels');
    if (!$wheels.length) {
      return;
    }
    $wheels.closest('tr').removeClass('hide');
    $wheels.next('.select2').show();
  };
  var syncRackFlatCapClearanceFields = function syncRackFlatCapClearanceFields() {
    if (!isRackConfigurator()) {
      return;
    }
    var isFlatCap = isRackFlatCapSelected();
    var hasRearCap = $('#rack_left_cap').is(':checked');
    $('.rack-flat-cap-front-row').toggleClass('hide', !isFlatCap);
    $('.rack-flat-cap-rear-row').toggleClass('hide', !isFlatCap || !hasRearCap);
  };
  var syncRackClassicCapDepthField = function syncRackClassicCapDepthField() {
    if (!isRackConfigurator()) {
      return;
    }
    var isFlatCap = isRackFlatCapSelected();
    var hasRearCap = $('#rack_left_cap').is(':checked');
    var limits = getRackCapDepthLimits();
    var $frontInput = $(rackCapDepthInputSelector);
    var $rearInput = $(rackRearCapDepthInputSelector);
    $('.rack-classic-front-cap-depth-row').toggleClass('hide', isFlatCap);
    $('.rack-classic-rear-cap-depth-row').toggleClass('hide', isFlatCap || !hasRearCap);
    $frontInput.attr({
      min: limits.min,
      max: limits.max,
      step: 1
    }).prop('disabled', isFlatCap);
    $rearInput.attr({
      min: limits.min,
      max: limits.max,
      step: 1
    }).prop('disabled', isFlatCap || !hasRearCap);
    if (!isFlatCap) {
      getRackCapDepth();
      if (hasRearCap) {
        getRackRearCapDepth();
      }
    }
  };
  var syncRackOptionAvailability = function syncRackOptionAvailability() {
    syncRackMousseAvailability();
    syncRackCapTypeAvailability();
    syncRackCornerAvailability();
    syncRackWheelsAvailability();
    syncRackClassicCapDepthField();
    syncRackFlatCapClearanceFields();
  };
  var syncRackConfigurator = function syncRackConfigurator(updateMeasurements) {
    if (!isRackConfigurator()) {
      return;
    }
    var inputs = getRackMeasurementInputs();
    var mode = getRackMode();
    var isRack19 = mode === 'rack-19';
    var units = getRackUnits();
    var depth = getRackDepth();
    var rackHeight = getRackHeightFromUnits(units);
    var $widthLabel = inputs.width.closest('tr').find('label:first');
    $('body').toggleClass('rack-mode-19', isRack19).toggleClass('rack-mode-custom', !isRack19);
    setRackMeasurementInputAttributes(inputs, isRack19);
    $('.rack-19-row').toggle(isRack19);
    // Rack configurable uses the dedicated total-length field. The legacy
    // measurement input stays active for pricing/submission as derived body length.
    inputs.length.closest('tr').hide();
    inputs.width.closest('tr').toggle(!isRack19);
    inputs.height.closest('tr').toggle(!isRack19);
    if ($widthLabel.length && !$widthLabel.data('rack-default-html')) {
      $widthLabel.data('rack-default-html', $widthLabel.html());
    }
    if ($widthLabel.length) {
      if (isRack19) {
        $widthLabel.html('Profondeur du rack<div class="text-normal text-lowercase">(hors capots)</div>');
      } else {
        $widthLabel.html($widthLabel.data('rack-default-html'));
      }
    }
    if (isRack19 && updateMeasurements !== false) {
      isSyncingRackDimensions = true;
      inputs.length.val(depth);
      inputs.width.val(rackStandardWidthMm);
      inputs.height.val(rackHeight);
      inputs.length.add(inputs.width).add(inputs.height).trigger('input').trigger('change');
      isSyncingRackDimensions = false;
    }
    var rackLengthState = syncRackLengthModel(inputs, isRack19, depth);
    syncRackOptionAvailability();
    var hasRearCap = $('#rack_left_cap').is(':checked');
    var rackSideHandleDepth = parseInt(getRackDepthDimension(), 10);
    var rackSideHandlesEnabled = isRackSideHandlesEnabled();
    $('body').toggleClass('rack-single-cap-long-depth', !hasRearCap && !isNaN(rackSideHandleDepth) && rackSideHandleDepth > 600);
    syncRackSideHandleOptionState();
    $('.rack-type-note-19').toggleClass('hide', !isRack19);
    $('.rack-type-note-custom').toggleClass('hide', isRack19);
    $('.rack-rail-fastener-options').toggleClass('hide', !isRack19);
    $('.rack-rear-rail-fastener-options').toggleClass('hide', !isRack19 || !hasRearCap);
    $('.rack-type-note-19 .rack-rail-fastener-input').prop('disabled', !isRack19);
    $('.rack-rear-rail-fastener-options .rack-rail-fastener-input').prop('disabled', !isRack19 || !hasRearCap);
    if (!isRack19) {
      $('.rack-rail-fastener-input').prop('checked', false);
    }
    if (!isRack19 || !hasRearCap) {
      $('.rack-rear-rail-fastener-options .rack-rail-fastener-input').prop('checked', false);
    }
    syncRackHandleVariant(units, isRack19);
    syncRackLowLatchVariant(units, isRack19);
    syncRackNumberStepperControls();
    if (window.configurator_options) {
      window.configurator_options.rack_type = mode;
      window.configurator_options.rack_units = isRack19 ? units : '';
      window.configurator_options.rack_depth_mm = isRack19 ? depth : '';
      var rearCapSelected = $('#rack_left_cap').is(':checked');
      window.configurator_options.rack_left_cap = rearCapSelected ? 'yes' : 'no';
      window.configurator_options.rack_square_nuts = isRack19 && $('#rack_square_nuts').is(':checked') ? 'yes' : 'no';
      window.configurator_options.rack_black_pozi_screws = 'no';
      window.configurator_options.rack_black_pozi_screws_12 = isRack19 && $('#rack_black_pozi_screws_12').is(':checked') ? 'yes' : 'no';
      window.configurator_options.rack_black_pozi_screws_16 = isRack19 && $('#rack_black_pozi_screws_16').is(':checked') ? 'yes' : 'no';
      window.configurator_options.rack_plastic_washers = isRack19 && $('#rack_plastic_washers').is(':checked') ? 'yes' : 'no';
      window.configurator_options.rack_rear_square_nuts = isRack19 && rearCapSelected && $('#rack_rear_square_nuts').is(':checked') ? 'yes' : 'no';
      window.configurator_options.rack_rear_black_pozi_screws = 'no';
      window.configurator_options.rack_rear_black_pozi_screws_12 = isRack19 && rearCapSelected && $('#rack_rear_black_pozi_screws_12').is(':checked') ? 'yes' : 'no';
      window.configurator_options.rack_rear_black_pozi_screws_16 = isRack19 && rearCapSelected && $('#rack_rear_black_pozi_screws_16').is(':checked') ? 'yes' : 'no';
      window.configurator_options.rack_rear_plastic_washers = isRack19 && rearCapSelected && $('#rack_rear_plastic_washers').is(':checked') ? 'yes' : 'no';
      window.configurator_options.rack_rail_fasteners_per_unit = 4;
      window.configurator_options.rack_side_handles = rackSideHandlesEnabled ? 'yes' : 'no';
      window.configurator_options.rack_side_handle_count = rackSideHandlesEnabled ? 2 : 0;
      window.configurator_options.rack_side_handle_position = getRackSideHandlePositionValue();
      var rackUsesClassicCaps = !isRackFlatCapSelected();
      var frontCapDepth = rackUsesClassicCaps ? getRackCapDepth() : 0;
      var rearCapDepth = rackUsesClassicCaps && rearCapSelected ? getRackRearCapDepth() : 0;
      window.configurator_options.rack_cap_depth_mm = frontCapDepth;
      window.configurator_options.rack_front_cap_depth_mm = frontCapDepth;
      window.configurator_options.rack_rear_cap_depth_mm = rearCapDepth;
      window.configurator_options.rack_total_cap_depth_mm = frontCapDepth + rearCapDepth;
      window.configurator_options.rack_cap_depth_min_mm = getRackCapDepthLimits().min;
      window.configurator_options.rack_cap_depth_max_mm = getRackCapDepthLimits().max;
      window.configurator_options.rack_flat_front_clearance_mm = isRackFlatCapSelected() ? getRackFlatFrontClearanceMm() : 0;
      window.configurator_options.rack_flat_rear_clearance_mm = isRackFlatCapSelected() && $('#rack_left_cap').is(':checked') ? getRackFlatRearClearanceMm() : 0;
      window.configurator_options.rack_flat_cap_depth_extra_mm = getRackFlatCapDepthExtraMm();
      window.configurator_options.rack_flat_cap_panel_extra_mm = getRackFlatCapPanelExtraMm();
      window.configurator_options.rack_total_length_mm = rackLengthState.totalLengthMm;
      window.configurator_options.rack_usable_body_length_mm = rackLengthState.usableBodyLengthMm;
      window.configurator_options.rack_min_usable_body_length_mm = rackLengthState.minUsableBodyLengthMm;
      window.configurator_options.rack_min_total_length_mm = rackLengthState.minTotalLengthMm;
      window.configurator_options.rack_front_cap_length_contribution_mm = rackLengthState.frontCapContributionMm;
      window.configurator_options.rack_rear_cap_length_contribution_mm = rackLengthState.rearCapContributionMm;
      window.configurator_options.rack_total_cap_length_contribution_mm = rackLengthState.totalCapContributionMm;
      window.configurator_options.rack_usable_body_length_valid = rackLengthState.valid ? 'yes' : 'no';
      window.configurator_options.rack_total_length_includes_caps = isRack19 ? 'no' : 'yes';
    }
    syncRackCapPricing();
  };
  var markRackPreviewUpdating = function markRackPreviewUpdating(isShrinking, isGrowing) {
    if (!isRackConfigurator()) {
      return;
    }
    var $body = $('body').addClass('rack-preview-updating');
    if (isShrinking) {
      $body.addClass('rack-preview-shrinking');
    } else if (isGrowing) {
      $body.removeClass('rack-preview-shrinking');
    }
    window.clearTimeout(rackPreviewUpdateTimer);
    rackPreviewUpdateTimer = window.setTimeout(function () {
      $('body').removeClass('rack-preview-updating rack-preview-shrinking');
    }, 260);
  };
  var syncRackCapPreview = function syncRackCapPreview() {
    if (!isRackConfigurator()) {
      return;
    }
    var showLeftCap = $('#rack_left_cap').is(':checked');
    var $rightCapContainer = $('.cap-parts-container-capot-rack-right-side-view');
    var $leftCapContainer = $('.cap-parts-container-capot-rack-left-side-view');
    var $rackCapContainers = $rightCapContainer.add($leftCapContainer);
    $rackCapContainers.find('.configurator_preview-locker2-malle-front-side-top, ' + '.configurator_preview-locker2-malle-front-side-bottom').css('transition', rackSideCapLockerLayoutTransition);
    var capLength = getCaseDisplayHeight();
    var topBraceDisplaySize = parseFloat(getElementDisplaySize(braceSize || 34));
    var topBraceOffset = isNaN(topBraceDisplaySize) ? 18 : topBraceDisplaySize * 1.16;
    var rackHeightMm = parseInt($('.height-input:first input[name="height_needed"]:first').val(), 10);
    var lockerDisplaySize = parseFloat(getElementDisplaySize(shouldUseLargeRackCapLockersForHeight() ? 128 : locker2frontSize || 102));
    var useSingleLocker = isNaN(rackHeightMm) ? capLength < lockerDisplaySize * 1.6 : rackHeightMm < getMinHeightForTwoMalleVerticalCapLockers();
    var topLockerPosition = useSingleLocker ? Math.max(0, (capLength - lockerDisplaySize) / 2) : capLength * 0.20;
    var bottomLockerPosition = capLength * 0.62;
    var isFlatCap = $('#pa_configurateur-type-de-capot').val() === 'capot-plat';
    var useLargeRackCapLocker = shouldUseLargeRackCapLockersForHeight() || getRackDepthDimension() >= 800;
    var frontCapDepthMm = getRackCapDepth();
    var rearCapDepthMm = showLeftCap ? getRackRearCapDepth() : 0;
    var frontCapDepthDeltaDisplay = parseFloat(getElementDisplaySize(Math.max(0, frontCapDepthMm - rackCapDepthDefaultMm)));
    var rearCapDepthDeltaDisplay = parseFloat(getElementDisplaySize(Math.max(0, rearCapDepthMm - rackCapDepthDefaultMm)));
    var frontCapDepthDisplay = parseFloat(getElementDisplaySize(frontCapDepthMm));
    var rearCapDepthDisplay = parseFloat(getElementDisplaySize(rearCapDepthMm));
    var capProfileDisplayWidth = parseFloat(getElementDisplaySize(capSize || 42));
    var rackTopEdgeInset = parseFloat(getElementDisplaySize(hingeSize || 30)) / 2;
    frontCapDepthDeltaDisplay = isNaN(frontCapDepthDeltaDisplay) ? 0 : frontCapDepthDeltaDisplay;
    rearCapDepthDeltaDisplay = isNaN(rearCapDepthDeltaDisplay) ? 0 : rearCapDepthDeltaDisplay;
    frontCapDepthDisplay = isNaN(frontCapDepthDisplay) ? 0 : frontCapDepthDisplay;
    rearCapDepthDisplay = isNaN(rearCapDepthDisplay) ? 0 : rearCapDepthDisplay;
    capProfileDisplayWidth = isNaN(capProfileDisplayWidth) ? 0 : capProfileDisplayWidth;
    rackTopEdgeInset = isNaN(rackTopEdgeInset) ? 0 : rackTopEdgeInset;
    $('body').toggleClass('rack-cap-single-large-locker', !isFlatCap && useSingleLocker && useLargeRackCapLocker);
    $('.configurator_preview-rack-cap').css('display', 'none');
    $('.cap-parts-container-capot-malle-side:not(.cap-parts-container-capot-malle-side-front-view):not(.cap-parts-container-capot-malle-side-back-view) .configurator_preview-cap-malle-side').css('display', 'none');
    $rackCapContainers.find('.js--set-malle-front-side-cap-length').css({
      'top': '0px',
      'width': capLength + 'px'
    });
    $rackCapContainers.find('.configurator_preview-locker2-malle-front-side-top').css('top', topLockerPosition + 'px');
    $rackCapContainers.find('.configurator_preview-locker2-malle-front-side-bottom').css('top', bottomLockerPosition + 'px');
    $rackCapContainers.find('.configurator_preview-brace-malle-front-side-top').css('top', topBraceOffset + 'px');
    $rightCapContainer.children('.configurator_preview-cap-malle-front-side, .configurator_preview-locker2-malle-front-side-top, .configurator_preview-locker2-malle-front-side-bottom, .configurator_preview-brace-malle-front-side-top, .configurator_preview-brace-malle-front-side-bottom').css({
      left: 'auto',
      right: frontCapDepthDeltaDisplay + 'px'
    });
    $leftCapContainer.children('.configurator_preview-cap-malle-front-side, .configurator_preview-locker2-malle-front-side-top, .configurator_preview-locker2-malle-front-side-bottom, .configurator_preview-brace-malle-front-side-top, .configurator_preview-brace-malle-front-side-bottom').css({
      left: rearCapDepthDeltaDisplay + 'px',
      right: 'auto'
    });
    var $rackTopFrontSeparation = $('.configurator_preview-rack-top-cap-separation--front');
    var $rackTopRearSeparation = $('.configurator_preview-rack-top-cap-separation--rear');
    var frontTopSeparationOffset = Math.max(0, frontCapDepthDisplay - capProfileDisplayWidth / 2);
    var rearTopSeparationOffset = Math.max(0, rearCapDepthDisplay - capProfileDisplayWidth / 2);
    $rackTopFrontSeparation.css({
      display: isFlatCap ? 'none' : 'block',
      bottom: rackTopEdgeInset + 'px',
      height: 'auto',
      left: 'auto',
      right: frontTopSeparationOffset + 'px',
      top: rackTopEdgeInset + 'px',
      width: capProfileDisplayWidth + 'px'
    });
    $rackTopRearSeparation.css({
      display: !isFlatCap && showLeftCap ? 'block' : 'none',
      bottom: rackTopEdgeInset + 'px',
      height: 'auto',
      left: rearTopSeparationOffset + 'px',
      right: 'auto',
      top: rackTopEdgeInset + 'px',
      width: capProfileDisplayWidth + 'px'
    });
    var setRackCapDisplay = function setRackCapDisplay($container, show) {
      $container.css('display', show ? 'block' : 'none');
      $container.find('.configurator_preview-cap-malle-front-side').css('display', show ? 'block' : 'none');
      $container.find('.configurator_preview-locker2-malle-front-side-top').css('display', show ? 'block' : 'none');
      $container.find('.configurator_preview-locker2-malle-front-side-bottom').css('display', show && !useSingleLocker ? 'block' : 'none');
      $container.find('.configurator_preview-brace-malle-front-side-top, .configurator_preview-brace-malle-front-side-bottom').css('display', show ? 'block' : 'none');
    };
    setRackCapDisplay($rightCapContainer, !isFlatCap);
    setRackCapDisplay($leftCapContainer, !isFlatCap && showLeftCap);
    storeRackSideCapLockerCollisionBaseline(true);
    refreshRackSideHandleLockerCollisions();
  };
  var init = function init() {
    var _labelCalculator = '<thead><tr><td><label class="calc_part_label">Dimensions intérieures du flightcase :</label></td></tr></thead>';
    var _labelCalculated = '<tfoot><tr><td colspan="3"><label class="calc_part_label">Dimensions extérieures du flightcase :</label></td></tr><tr class="js--ext-dimensions-values"><td>Longueur : <span class="js--ext-length"></span></td><td>Largeur : <span class="js--ext-width"></span></td><td>Hauteur : <span class="js--ext-height"></span></td></tr><tr class="js--ext-dimensions-pending hide"><td colspan="3">Choisissez d’abord la matière pour calculer les dimensions extérieures.</td></tr></tfoot>';
    var $price_calculator = $('#price_calculator');
    var $customs_engraving = $('#customs_engraving');
    $price_calculator.prepend(_labelCalculator);
    $price_calculator.append(_labelCalculated);
    $price_calculator.find('tr.total-amount td:first').text('Surface totale (m²)');
    ensureRackConfiguratorFields();
    prepareValiseCapTypeField();
    prepareMobilityField();
    prepareConfiguratorFormLayout();
    checkEngraving($customs_engraving);
    normalizeDoubleClocheOptionRow();
    initCustomCapHeightField();
    groupCustomCapOptions();
    prepareConfiguratorFormLayout();
    initRequiredConfiguratorSteps();
    if (isValiseCustomCapHeightConfigurator()) {
      $(document).one('wc_variation_form.valiseMaterialFlowInit', '.variations_form', function () {
        initValiseMaterialFlow();
        updateRequiredConfiguratorSteps(false);
      });
      window.setTimeout(function () {
        initValiseMaterialFlow();
        updateRequiredConfiguratorSteps(false);
      }, 250);
    }
    if (isRackConfigurator()) {
      hideRackFixedVariationRows();
      setCapParts($('#pa_configurateur-type-de-capot').val() || 'capot-amovible');
    } else if ($('body').hasClass('flight-case-type-cloche') || $('body').hasClass('flight-case-cloche')) {
      $('#pa_configurateur-type-de-capot').val('capot-amovible');
      setCapParts('capot-amovible');
    } else if ($('body').hasClass('flight-case-type-valise')) {
      applyValiseCapTypeVisualState();
    } else {
      setCapParts('capot-sur-charnieres');
    }
    if ($('body').hasClass('flight-case-type-valise')) {
      setCapParts('poignee-de-surface');
      setCapParts('fermoir-grenouille-simple');
      var $valiseFrontHandleOption = $('#handle_customs_add-sidehandle');
      $valiseFrontHandleOption.prop('checked', false).prop('disabled', true);
      sideHandleHideShow(false);
      $valiseFrontHandleOption.closest('tr').remove();
      syncValiseSideHandleOptionState();
    } else {
      sideHandleHideShow(false);
      checkSideHandleLabel($('#handle_customs_add-sidehandle'));
      displayTagHolder($('#customs_label-holder').is(':checked'));
      sideLockersHideShow();
      checkAirflowLabel($('#customs_airflow'));
    }
    doubleCapHideShow($('#capot_double_cloche').is(':checked'));
    malleCapHideShow();
    syncRackCornerAvailability();
    setCapParts($('#pa_configurateur-coins').val() || 'coins-boules');
    applyFlatCapVisualState();
    setMinDimensions();
  };
  var setMinDimensions = function setMinDimensions() {
    if (isRackConfigurator()) {
      var rackInputs = getRackMeasurementInputs();
      if (rackInputs.length.val() === '') {
        rackInputs.length.val(rackStandardWidthMm);
      }
      if (rackInputs.width.val() === '') {
        rackInputs.width.val(rackDefaultDepthMm);
      }
      if (rackInputs.height.val() === '') {
        rackInputs.height.val(getRackHeightFromUnits(rackDefaultUnits));
      }
      syncRackConfigurator(true);
    } else if ($('body').hasClass('flight-case-type-valise')) {
      var lenInput = $('.length-input:first input[name="length_needed"]:first');
      var widInput = $('.width-input:first input[name="width_needed"]:first');
      var heiInput = $('.height-input:first input[name="height_needed"]:first');
      if (lenInput.val() === '') {
        lenInput.val(600);
      }
      if (widInput.val() === '') {
        widInput.val(400);
      }
      if (heiInput.val() === '') {
        heiInput.val(350);
      }
    } else {
      $('#price_calculator .wc-measurement-inputs input').each(function () {
        var _input = $(this);
        if (_input.val() === '') {
          _input.val(800);
        }
      });
    }
    initConfigurator();
  };
  var initConfigurator = function initConfigurator() {
    var configuratorLaunched = false;
    var launchConfigurator = function launchConfigurator() {
      if (configuratorLaunched) {
        return;
      }
      configuratorLaunched = true;
      syncRackConfigurator(true);
      setCaseValues();
      $('.js--loader-configurator').fadeOut(200, function () {
        if (isRackConfigurator()) {
          changeConfiguratorView('side');
        } else if ($('body').hasClass('flight-case-type-valise')) {
          changeConfiguratorView('top');
        } else {
          $('.js--front-configurator').fadeIn().removeClass('hide');
        }
        refreshDoubleClocheParts();
        syncRackCapPreview();
        if (isRackConfigurator()) {
          window.setTimeout(function () {
            syncRackConfigurator(true);
            setCaseValues();
            $('#conex-calculated-price').trigger('wc-measurement-price-calculator-product-price-change');
          }, 250);
        }
      });
    };
    if (document.readyState === 'complete') {
      launchConfigurator();
    } else {
      $(window).one('load', launchConfigurator);
      window.setTimeout(launchConfigurator, 800);
    }
    var hasValidCaseDimensions = function hasValidCaseDimensions() {
      var dimensionInputs = [$('.length-input:first input[name="length_needed"]:first'), $('.width-input:first input[name="width_needed"]:first'), $('.height-input:first input[name="height_needed"]:first')];
      for (var i = 0; i < dimensionInputs.length; i++) {
        var $input = dimensionInputs[i];
        var value = parseFloat($input.val());
        var min = parseFloat($input.attr('min'));
        var max = parseFloat($input.attr('max'));
        if (isNaN(value) || value <= 0) {
          return false;
        }
        if (!isNaN(min) && value < min) {
          return false;
        }
        if (!isNaN(max) && max > 0 && value > max) {
          return false;
        }
      }
      return true;
    };
    var refreshConfiguratorFromDimensions = function refreshConfiguratorFromDimensions() {
      if (isSyncingRackDimensions) {
        return;
      }
      if (!hasValidCaseDimensions()) {
        return;
      }
      syncRackConfigurator(false);
      syncCustomCapHeightField(true);
      setCaseValues();
      setNbrLockers();
      checkHandlesLockersCompatibility();
      if (isRackConfigurator()) {
        syncRackCapPricing();
        $('#conex-calculated-price').trigger('wc-measurement-price-calculator-product-price-change');
      }
    };
    $(document).on('input change', '#length_needed, #width_needed, #height_needed', refreshConfiguratorFromDimensions);
    $(document).on('input', customCapHeightInputSelector, function (e) {
      if (isValiseCustomCapHeightConfigurator() && e.originalEvent) {
        $(this).data('customCapHeightUserEdited', true);
      }
      syncCustomCapHeightField(false, {
        allowPartial: true
      });
      if (!isCustomCapHeightFieldReady()) {
        return;
      }
      setCaseValues();
      refreshSelectedHandlePositions();
      setNbrLockers();
      checkHandlesLockersCompatibility();
      refreshDoubleClocheParts();
      if (isValiseCustomCapHeightConfigurator()) {
        exceptionTrolley();
      }
    });
    $(document).on('change blur', customCapHeightInputSelector, function () {
      syncCustomCapHeightField(true);
      setCaseValues();
      refreshSelectedHandlePositions();
      setNbrLockers();
      checkHandlesLockersCompatibility();
      refreshDoubleClocheParts();
      if (isValiseCustomCapHeightConfigurator()) {
        exceptionTrolley();
      }
    });
    var runRackConfiguratorRefresh = function runRackConfiguratorRefresh() {
      syncRackConfigurator(true);
      exceptionCapotPlat();
      setCaseValues();
      syncRackCapPricing();
      setNbrHandles();
      setNbrLockers();
      checkHandlesLockersCompatibility();
      $('#conex-calculated-price').trigger('wc-measurement-price-calculator-product-price-change');
    };
    var refreshRackSideHandlePositionAfterDeferredUpdates = function refreshRackSideHandlePositionAfterDeferredUpdates() {
      if (!isRackConfigurator()) {
        return;
      }
      var applyRackSideHandlePosition = function applyRackSideHandlePosition() {
        if (!isRackSideHandlesEnabled()) {
          return;
        }
        adjustMalleCapHandlePositions();
        setHandlePosition(getRackSideHandlePositionValue(), 'configurator_preview--front');
        setHandlePosition(getRackSideHandlePositionValue(), 'configurator_preview--back');
        refreshRackHandlePairGaps();
      };
      window.setTimeout(applyRackSideHandlePosition, 0);
      window.setTimeout(applyRackSideHandlePosition, 180);
      window.setTimeout(applyRackSideHandlePosition, 450);
    };
    var refreshRackConfiguratorFromControls = function refreshRackConfiguratorFromControls() {
      var requestFrame = window.requestAnimationFrame || function (callback) {
        return window.setTimeout(callback, 16);
      };
      var cancelFrame = window.cancelAnimationFrame || window.clearTimeout;
      var rackInputs = getRackMeasurementInputs();
      var currentRackHeight = parseInt(rackInputs.height.val(), 10);
      var nextRackHeight = currentRackHeight;
      var nextRackUnits = parseInt($('#rack_units').val(), 10);
      if (getRackMode() === 'rack-19') {
        if (isNaN(nextRackUnits)) {
          nextRackUnits = rackDefaultUnits;
        }
        nextRackUnits = Math.max(rackMinUnits, Math.min(rackMaxUnits, nextRackUnits));
        nextRackHeight = getRackHeightFromUnits(nextRackUnits);
      }
      var isShrinking = !isNaN(currentRackHeight) && !isNaN(nextRackHeight) && nextRackHeight < currentRackHeight;
      var isGrowing = !isNaN(currentRackHeight) && !isNaN(nextRackHeight) && nextRackHeight > currentRackHeight;
      if (rackRefreshFrame !== null) {
        cancelFrame.call(window, rackRefreshFrame);
        rackRefreshFrame = null;
      }
      markRackPreviewUpdating(isShrinking, isGrowing);
      if (isShrinking) {
        runRackConfiguratorRefresh();
        return;
      }
      rackRefreshFrame = requestFrame(function () {
        rackRefreshFrame = null;
        runRackConfiguratorRefresh();
      });
    };
    $(document).on('change', '#rack_black_pozi_screws_12, #rack_black_pozi_screws_16, #rack_rear_black_pozi_screws_12, #rack_rear_black_pozi_screws_16', function () {
      if (!$(this).is(':checked')) {
        return;
      }
      var groupSelector = this.id.indexOf('rack_rear_') === 0 ? '#rack_rear_black_pozi_screws_12, #rack_rear_black_pozi_screws_16' : '#rack_black_pozi_screws_12, #rack_black_pozi_screws_16';
      $(groupSelector).not(this).prop('checked', false);
    });
    var syncRackCustomDerivedBodyLength = function syncRackCustomDerivedBodyLength(event) {
      if (!isRackConfigurator() || getRackMode() !== 'custom') {
        return;
      }
      var normalizeCapInputs = !(event && event.type === 'input' && $(event.target).is('#rack_cap_depth_mm, #rack_rear_cap_depth_mm'));
      syncRackLengthModel(getRackMeasurementInputs(), false, getRackDepth(), normalizeCapInputs);

      // Les écouteurs tarifaires peuvent être enregistrés avant ce
      // synchroniseur dans le bundle. Rejouer le calcul au tour suivant
      // garantit qu'ils lisent toujours le corps déjà dérivé du total.
      window.setTimeout(function () {
        $('#conex-calculated-price').trigger('wc-measurement-price-calculator-product-price-change');
      }, 0);
    };

    // Keep the internal body length coherent before the pricing listeners
    // consume it. Full visual refresh stays frame-throttled below.
    $(document).on('input change', 'input[name="rack_type"], #rack_total_length_mm, #rack_left_cap, #rack_flat_front_clearance_mm, #rack_flat_rear_clearance_mm', syncRackCustomDerivedBodyLength);
    $(document).on('input change blur', '#rack_cap_depth_mm, #rack_rear_cap_depth_mm', syncRackCustomDerivedBodyLength);
    $(document).on('change select2:select', '#pa_configurateur-type-de-capot', syncRackCustomDerivedBodyLength);
    $(document).on('input change', 'input[name="rack_type"], #rack_units, #rack_left_cap, #rack_flat_front_clearance_mm, #rack_flat_rear_clearance_mm, .rack-rail-fastener-input', refreshRackConfiguratorFromControls);
    $(document).on('click', '.rack-number-stepper', function (e) {
      e.preventDefault();
      applyRackNumberStep($(this));
    });
    $(document).on('input change', '.rack-number-stepper-control input[type="number"]', syncRackNumberStepperControls);
    $(document).on('input change', '#rack_side_handles, input[name="rack_sidehandle_position"]', function () {
      refreshRackConfiguratorFromControls();
      refreshRackSideHandlePositionAfterDeferredUpdates();
    });
    $(document).on('input change', '#valise_side_handles', function () {
      syncValiseSideHandleOptionState();
      setNbrHandles();
    });
    $(document).on('input change', '#width_needed', function () {
      if (!isValisePricingV2Enabled()) {
        return;
      }
      window.setTimeout(setNbrHandles, 0);
    });
    $(document).on('input change blur', '#height_needed', function () {
      if (!isValisePricingV2Enabled()) {
        return;
      }
      window.setTimeout(setNbrHandles, 0);
    });
    $(document).on('input change blur', '#rack_total_length_mm', refreshRackConfiguratorFromControls);
    $(document).on('change blur', '#rack_depth_mm, #rack_cap_depth_mm, #rack_rear_cap_depth_mm, #rack_flat_front_clearance_mm, #rack_flat_rear_clearance_mm', refreshRackConfiguratorFromControls);
    $(document).on('change select2:select', '.variations_form table.variations:first select', function () {
      if (!isRackConfigurator()) {
        return;
      }
      window.setTimeout(function () {
        syncRackConfigurator(true);
        setCaseValues();
        $('#conex-calculated-price').trigger('wc-measurement-price-calculator-product-price-change');
      }, 0);
    });
    $(document).off('.valisePanelRule');
    $(document).on('change.valisePanelRule select2:select.valisePanelRule', '#pa_configurateur-matiere', function () {
      window.setTimeout(syncValisePanelRuleFromSelection, 0);
    });
    $(document).on('click', '.js--zoomIn', function (e) {
      e.preventDefault();
      changeConfiguratorZoom('zoomIn');
    });
    $(document).on('click', '.js--zoomOut', function (e) {
      e.preventDefault();
      changeConfiguratorZoom('zoomOut');
    });
    $(document).on('click', '.js--changeConfiguratorView', function (e) {
      e.preventDefault();
      changeConfiguratorView($(this).attr('data-view-to-show'));
    });
    var doubleClocheViewportRefreshTimer = null;
    var doubleClocheViewportPollingInterval = 150;
    var doubleClocheViewportPollingDuration = 5000;
    var getDoubleClocheViewportSignature = function getDoubleClocheViewportSignature() {
      var $view = $('.js--configurator-view.current-view').filter(function () {
        var rect = this.getBoundingClientRect();
        return rect.width > 0 && rect.height > 0;
      }).first();
      var viewNode = $view.get(0);
      var artboardNode = $view.closest('.configurator_preview--artboard').get(0);
      if (!viewNode || !artboardNode) {
        return '';
      }
      var getNodeSignature = function getNodeSignature(node) {
        var rect = node.getBoundingClientRect();
        var style = window.getComputedStyle(node);
        return [rect.left, rect.top, rect.width, rect.height, style.width, style.height, style.transform, style.transformOrigin, style.zoom || ''].join(':');
      };
      return getNodeSignature(viewNode) + '|' + getNodeSignature(artboardNode);
    };
    var startDoubleClocheViewportPolling = function startDoubleClocheViewportPolling() {
      window.clearTimeout(doubleClocheViewportRefreshTimer);
      doubleClocheViewportRefreshTimer = null;
      if (!isClocheConfigurator() || !$('#capot_double_cloche').is(':checked')) {
        return;
      }
      var lastSignature = getDoubleClocheViewportSignature();
      var pollingDeadline = Date.now() + doubleClocheViewportPollingDuration;
      var _poll = function poll() {
        if (!isClocheConfigurator() || !$('#capot_double_cloche').is(':checked') || Date.now() > pollingDeadline) {
          doubleClocheViewportRefreshTimer = null;
          return;
        }
        var currentSignature = getDoubleClocheViewportSignature();
        if (currentSignature !== lastSignature) {
          lastSignature = currentSignature;
          refreshDoubleClocheParts();
        }
        doubleClocheViewportRefreshTimer = window.setTimeout(_poll, doubleClocheViewportPollingInterval);
      };
      doubleClocheViewportRefreshTimer = window.setTimeout(_poll, doubleClocheViewportPollingInterval);
    };
    $(window).on('resize orientationchange', function () {
      setCaseValues();
      startDoubleClocheViewportPolling();
    });
  };
  var setConfiguratorGlobalsVars = function setConfiguratorGlobalsVars() {
    var lengthInput = $('.length-input:first input[name="length_needed"]:first');
    var widthInput = $('.width-input:first input[name="width_needed"]:first');
    var heightInput = $('.height-input:first input[name="height_needed"]:first');

    // set zoomed max authorised size
    maxZoomPx = $('.configurator_preview--artboard:first').width();

    // get flight case values
    var getDisplayMax = function getDisplayMax($input) {
      var defaultMax = $input.data('rack-default-max');
      var maxValue = isRackConfigurator() && defaultMax ? defaultMax : $input.attr('max');
      var parsedMax = parseFloat(maxValue);
      return isNaN(parsedMax) ? 0 : parsedMax;
    };
    caseMaxSize = Math.min(getDisplayMax(heightInput), getDisplayMax(lengthInput), getDisplayMax(widthInput));

    // get input values
    inputWidth = parseInt(widthInput.val());
    inputLength = parseInt(lengthInput.val());
    inputHeight = parseInt(heightInput.val());
    var rackDepthDimension = getRackDepthDimension();
    var rackFaceDimension = getRackFaceDimension();
    var rackSizingDimension = isRackConfigurator() ? rackDepthDimension : inputLength;
    var applyRackHandleLayout = function applyRackHandleLayout() {
      if (!isRackConfigurator()) {
        return;
      }
      var setViewHandleMode = function setViewHandleMode($view, useCenter) {
        if (useCenter) {
          $view.find('.configurator_preview-handle-center').removeClass('hide').css('display', '');
          $view.find('.configurator_preview-handle-left, .configurator_preview-handle-right').addClass('hide').css('display', 'none');
        } else {
          $view.find('.configurator_preview-handle-center').addClass('hide').css('display', 'none');
          $view.find('.configurator_preview-handle-left, .configurator_preview-handle-right').removeClass('hide').css('display', '');
        }
      };
      setViewHandleMode($('.configurator_preview--side'), getRackSideHandlesUseCenter());
      if (isRackSideHandlesEnabled()) {
        setViewHandleMode($('.configurator_preview--front, .configurator_preview--back'), getRackFrontBackHandlesUseCenter());
      } else {
        $('.configurator_preview--front, .configurator_preview--back').find('.configurator_preview-handle-center, .configurator_preview-handle-left, .configurator_preview-handle-right').addClass('hide').css('display', 'none');
      }
    };
    if ($('body').hasClass('flight-case-type-valise')) {
      currentConfiguratorPartsSize = 'valise';
      setConfiguratorPartsSize(currentConfiguratorPartsSize, false);
      if (isValisePricingV2Enabled()) {
        syncValiseSideHandleOptionState();
      } else if (Math.min(inputWidth) < 600) {
        $('.js--side-configurator .configurator_preview-handle-center').removeClass('hide');
        $('.js--side-configurator .configurator_preview-handle-right').addClass('hide');
        $('.js--side-configurator .configurator_preview-handle-left').addClass('hide');
      } else {
        $('.js--side-configurator .configurator_preview-handle-center').addClass('hide');
        $('.js--side-configurator .configurator_preview-handle-right').removeClass('hide');
        $('.js--side-configurator .configurator_preview-handle-left').removeClass('hide');
      }
    } else {
      // Flight case elements
      if (Math.min(rackSizingDimension) >= 600) {
        currentConfiguratorPartsSize = 'large';
        setConfiguratorPartsSize(currentConfiguratorPartsSize);
      }
      if (Math.min(inputWidth) >= 1000) {
        $('.configurator_preview--side .configurator_preview-handle-left').css('left', '10%');
        $('.configurator_preview--side .configurator_preview-handle-right').css('right', '10%');
      }
      if (Math.min(inputWidth) < 1000) {
        $('.configurator_preview--side .configurator_preview-handle-left').css('left', '0');
        $('.configurator_preview--side .configurator_preview-handle-right').css('right', '0');
      }
      if (Math.min(inputLength) >= 1000) {
        $('.configurator_preview--back .configurator_preview-handle-left, .configurator_preview--front .configurator_preview-handle-left').css('left', '10%');
        $('.configurator_preview--back .configurator_preview-handle-right, .configurator_preview--front .configurator_preview-handle-right').css('right', '10%');
      }
      if (Math.min(inputLength) >= 1500) {
        $('.configurator_preview--back .configurator_preview-handle-left, .configurator_preview--front .configurator_preview-handle-left').css('left', '20%');
        $('.configurator_preview--back .configurator_preview-handle-right, .configurator_preview--front .configurator_preview-handle-right').css('right', '20%');
      }
      if (Math.min(inputLength) < 1000) {
        $('.configurator_preview--back .configurator_preview-handle-left, .configurator_preview--front .configurator_preview-handle-left').css('left', '0');
        $('.configurator_preview--back .configurator_preview-handle-right, .configurator_preview--front .configurator_preview-handle-right').css('right', '0');
      }
      if (Math.min(rackSizingDimension) >= 425 && Math.min(rackSizingDimension) < 600) {
        currentConfiguratorPartsSize = 'medium';
        setConfiguratorPartsSize(currentConfiguratorPartsSize);
      }
      if (Math.min(rackSizingDimension) < 425) {
        currentConfiguratorPartsSize = 'small';
        setConfiguratorPartsSize(currentConfiguratorPartsSize);
      }
      if (Math.min(inputHeight) < 450) {
        if (Math.min(rackSizingDimension) < 425) {
          currentConfiguratorPartsSize = 'small';
        } else {
          currentConfiguratorPartsSize = 'medium';
        }
        setConfiguratorPartsSize(currentConfiguratorPartsSize, false);
      }
      if (Math.min(inputWidth) < 600) {
        $('.js--side-configurator .configurator_preview-handle-center').removeClass('hide');
        $('.js--side-configurator .configurator_preview-handle-right').addClass('hide');
        $('.js--side-configurator .configurator_preview-handle-left').addClass('hide');
      }
      var $mobility = $('select#wheels');
      var mobilityValue = $mobility.val();
      var mobilityWasReset = false;
      if (Math.min(inputWidth, inputLength) < 300) {
        if (mobilityValue === 'wheels-1' || mobilityValue === 'pallet-feet') {
          exceptionNotification('Impossible de mettre ' + (mobilityValue === 'pallet-feet' ? 'des plots palettisables' : 'des roulettes') + ' sur un flightcase inférieur à <b>300mm de longueur ou de largeur</b>');
          mobilityWasReset = true;
        }
        $mobility.val('wheels-0').prop('disabled', true);
      } else {
        $mobility.prop('disabled', false);
      }
      if (mobilityWasReset) {
        $mobility.trigger('change');
      } else {
        $mobility.trigger('change.select2');
      }
      var frontChecked = $('input[value="config-capot-avant"]').is(':checked');
      var sideChecked = $('input[value="config-capot-lat"]').is(':checked');
      if (frontChecked) {
        $('.configurator_preview-locker2-malle-front-left').removeClass('small-container').css('display', 'none');
        $('.configurator_preview-locker2-malle-front-right').css('display', 'none');
      }
      if (sideChecked) {
        if (Math.min(inputHeight) < getMinHeightForTwoMalleVerticalCapLockers()) {
          $('.configurator_preview-locker2-malle-side-vertical-top').addClass('small-container');
          $('.configurator_preview-locker2-malle-side-vertical-bottom').css('display', 'none');
        } else {
          $('.configurator_preview-locker2-malle-side-vertical-top').removeClass('small-container');
          $('.configurator_preview-locker2-malle-side-vertical-bottom').css('display', 'block');
        }
      }
      applyRackHandleLayout();
    }
  };
  var getCasterWheelAssetDisplaySpec = function getCasterWheelAssetDisplaySpec(assetUrl, rackAsset) {
    var normalizedAssetUrl = String(assetUrl || '').toLowerCase();
    if (normalizedAssetUrl.indexOf('wheel2') !== -1) {
      return {
        width: casterEndViewWidthMm,
        imageHeight: rackAsset ? 132.2 : casterTotalHeightMm
      };
    }
    if (normalizedAssetUrl.indexOf('wheel4') !== -1) {
      return {
        width: casterSideViewWidthMm,
        imageHeight: rackAsset ? 132.8 : 150.8
      };
    }
    return {
      width: casterSideViewWidthMm,
      imageHeight: rackAsset ? 136.1 : 154
    };
  };
  var applyCasterWheelDimensions = function applyCasterWheelDimensions($wheelElements, wheelSelected) {
    var rackAsset = isRackConfigurator();
    var containerHeightMm = rackAsset ? casterWheelHeightMm : casterTotalHeightMm;
    var rackSupportOffset = rackAsset && wheelSelected ? -getElementDisplaySize(casterSupportHeightMm) : '';
    $wheelElements.each(function () {
      var $wheel = $(this);
      var $image = $wheel.find('img').first();
      var spec = getCasterWheelAssetDisplaySpec($image.attr('src'), rackAsset);
      $wheel.css({
        width: getElementDisplaySize(spec.width),
        height: getElementDisplaySize(containerHeightMm),
        bottom: rackSupportOffset
      });
      $image.css({
        width: getElementDisplaySize(spec.width),
        height: getElementDisplaySize(spec.imageHeight),
        maxWidth: 'none'
      });
    });
  };
  var setConfiguratorPartsSize = function setConfiguratorPartsSize(size) {
    var considerHandles = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    switch (size) {
      case 'large':
        hingeSize = 30;
        hingeFlatSize = 10;
        holeSize = 80;
        capSize = 42;
        holderSize = casterSupportHeightMm;
        handleSize = 160;
        tagHolderSize = 250;
        wheelSize = casterEndViewWidthMm;
        wheelHeight = casterTotalHeightMm;
        capfixerSize = 36;
        lockerfrontSize = 300;
        locker2frontSize = 128;
        braceSize = 30;
        if ($('#pa_configurateur-coins').val() === 'coins-boules') {
          cornerSize = 72;
        } else {
          cornerSize = 50;
        }
        $('.js--showfor-case-small').addClass('hide');
        $('.js--showfor-case-medium').addClass('hide');
        $('.js--showfor-case-large').removeClass('hide');
        $('.configurator_preview-locker2-front-left').removeClass('small-container');
        $('.configurator_preview-locker2-malle-front-left').removeClass('small-container');
        $('.configurator_preview-locker2-malle-side-vertical-top').removeClass('small-container');
        if (considerHandles) {
          $('.configurator_preview-handle-center').addClass('hide');
          $('.configurator_preview-handle-left').removeClass('hide');
          $('.configurator_preview-handle-right').removeClass('hide');
        }
        break;
      case 'medium':
        hingeSize = 30;
        hingeFlatSize = 10;
        holeSize = 80;
        capSize = 42;
        holderSize = casterSupportHeightMm;
        handleSize = 160;
        tagHolderSize = 250;
        wheelSize = casterEndViewWidthMm;
        wheelHeight = casterTotalHeightMm;
        capfixerSize = 36;
        lockerfrontSize = 202;
        locker2frontSize = 102;
        braceSize = 30;
        if ($('#pa_configurateur-coins').val() === 'coins-boules') {
          cornerSize = 58;
        } else {
          cornerSize = 50;
        }
        $('.js--showfor-case-large').addClass('hide');
        $('.js--showfor-case-small').addClass('hide');
        $('.js--showfor-case-medium').removeClass('hide');
        $('.configurator_preview-locker2-front-left').removeClass('small-container');
        $('.configurator_preview-locker2-malle-front-left').removeClass('small-container');
        $('.configurator_preview-locker2-malle-side-vertical-top').removeClass('small-container');
        if (considerHandles) {
          $('.configurator_preview-handle-center').removeClass('hide');
          $('.configurator_preview-handle-right').addClass('hide');
          $('.configurator_preview-handle-left').addClass('hide');
        }
        break;
      case 'small':
        hingeSize = 30;
        hingeFlatSize = 10;
        holeSize = 80;
        capSize = 42;
        holderSize = casterSupportHeightMm;
        handleSize = 160;
        tagHolderSize = 250;
        wheelSize = casterEndViewWidthMm;
        wheelHeight = casterTotalHeightMm;
        capfixerSize = 36;
        lockerfrontSize = 202;
        locker2frontSize = 102;
        braceSize = 30;
        if ($('#pa_configurateur-coins').val() === 'coins-boules') {
          cornerSize = 58;
        } else {
          cornerSize = 50;
        }
        $('.js--showfor-case-large').addClass('hide');
        $('.js--showfor-case-medium').addClass('hide');
        $('.js--showfor-case-small').removeClass('hide');
        $('.configurator_preview-locker2-front-left').addClass('small-container');
        $('.configurator_preview-locker2-malle-front-left').addClass('small-container');
        $('.configurator_preview-locker2-malle-side-vertical-top').addClass('small-container');
        if (considerHandles) {
          $('.configurator_preview-handle-center').removeClass('hide');
          $('.configurator_preview-handle-right').addClass('hide');
          $('.configurator_preview-handle-left').addClass('hide');
        }
        break;
      case 'valise':
        var useMediumValiseCorners = getValiseCornerProfileSize() === 30;

        // Expose le profil visuel courant pour ajuster les pièces qui
        // doivent rester dégagées des cornières 30 x 30.
        $('body').toggleClass('valise-corners-30', useMediumValiseCorners);

        // Dimensions fabricant : poignée Penn Elcom H2001.
        // Les SVG longitudinaux incluent le corps de 500 mm et la
        // poignée terminale de 67 mm ; la vue en bout mesure 255 mm.
        $('.js--top-configurator .js--set-handle-trolley img, .js--back-configurator .js--set-handle-trolley img').css({
          width: getElementDisplaySize(567),
          // Le SVG longitudinal ne remplit que 85,35 % de sa hauteur.
          // Une boîte de 30,5 mm donne donc 26 mm réellement visibles.
          height: getElementDisplaySize(30.5)
        });
        $('.js--side-configurator .js--set-handle-trolley img').css({
          width: getElementDisplaySize(255),
          // Le SVG transversal remplit 98,48 % de sa hauteur.
          height: getElementDisplaySize(26.4)
        });

        // Dimensions fabricant : roulette d'angle Penn Elcom W8675.
        // Les dimensions de boîte compensent les marges transparentes
        // des SVG afin que la pièce visible mesure réellement 104 mm
        // de haut (et 70 mm de large dans la vue de profil).
        $('.js--side-configurator .js--set-wheel-angle img').css({
          width: getElementDisplaySize(80.5),
          height: getElementDisplaySize(112.4)
        });
        $('.js--top-configurator .js--set-wheel-angle img, .js--back-configurator .js--set-wheel-angle img').css({
          width: getElementDisplaySize(117),
          height: getElementDisplaySize(111.7)
        });
        $('.configurator_preview-pieds-plast--top img').css('width', getElementDisplaySize(56.75));
        $('.configurator_preview-pieds-plast--back img').css('width', getElementDisplaySize(56.75));
        hingeSize = getValiseCornerProfileSize();
        hingeFlatSize = hingeSize / 2;
        holeSize = 80;
        capSize = 42;
        holderSize = casterSupportHeightMm;
        handleSize = 160;
        tagHolderSize = 250;
        wheelSize = casterEndViewWidthMm;
        wheelHeight = casterTotalHeightMm;
        capfixerSize = 36;
        lockerfrontSize = 202;
        locker2frontSize = 102;
        braceSize = 30;
        cornerSize = useMediumValiseCorners ? 58 : 45;

        // Les profils 30 x 30 utilisent le coin boule medium. Le profil
        // léger 20 x 20 conserve le coin spécifique à la valise.
        $('.js--valise-corner-20').toggleClass('hide', useMediumValiseCorners).css('display', useMediumValiseCorners ? 'none' : '');
        $('.js--valise-corner-30').toggleClass('hide', !useMediumValiseCorners).css('display', useMediumValiseCorners ? '' : 'none');

        // Valise : Handle Top Size
        $('.configurator_preview-handle-retractable img').css('width', getElementDisplaySize(260));
        $('.configurator_preview-handle-leather img').css('width', getElementDisplaySize(150));
        $('.configurator_preview-handle-surface img').css('width', getElementDisplaySize(140));

        // Valise : Handle Front Size
        $('.configurator_preview-handle-retractable--front img').css('width', getElementDisplaySize(260));
        $('.configurator_preview-handle-leather--front img').css('width', getElementDisplaySize(150));
        $('.configurator_preview-handle-surface--front img').css('width', getElementDisplaySize(140));

        // Valise : Handle Side Size
        $('.configurator_preview-handle-retractable--side img').css('width', getElementDisplaySize(12));
        $('.configurator_preview-handle-leather--side img').css('width', getElementDisplaySize(34));
        $('.configurator_preview-handle-surface--side img').css('width', getElementDisplaySize(24));

        // Valise : Locker Top Size
        $('.configurator_preview-fermoir-grenouille--top img').css('width', getElementDisplaySize(50));
        $('.configurator_preview-fermoir-grenouille-clef--top img').css('width', getElementDisplaySize(46));
        $('.configurator_preview-fermoir-papillon--top img').css('width', getElementDisplaySize(101));

        // Valise : Locker Front Size
        $('.configurator_preview-fermoir-grenouille--front img').css('width', getElementDisplaySize(50));
        $('.configurator_preview-fermoir-grenouille-clef--front img').css('width', getElementDisplaySize(46));
        $('.configurator_preview-fermoir-papillon--front img').css('width', getElementDisplaySize(101));

        // Valise : Locker Side Size
        $('.configurator_preview-fermoir-grenouille--side img').css('width', getElementDisplaySize(15));
        $('.configurator_preview-fermoir-grenouille-clef--side img').css('width', getElementDisplaySize(13));
        $('.configurator_preview-fermoir-papillon--side img').css('width', getElementDisplaySize(24));
        setStopHinge(inputLength);
        break;
      default:
        console.log('size arg has to be large/medium/small/valise');
        break;
    }
    updateCornerPositionClass();
    var mobilityType = getMobilityType();
    var mobilityPieceCount = getMobilityPieceCount();
    var wheelSelected = mobilityType === 'wheels';
    var palletFeetSelected = mobilityType === 'pallet-feet';
    var hasSixMobilityPieces = mobilityPieceCount === 6;
    var $wheelElements = $('.js--set-wheel-size');
    var $palletFootElements = $('.js--set-pallet-foot-size');
    $wheelElements.css('display', wheelSelected ? 'block' : 'none');
    $palletFootElements.css('display', palletFeetSelected ? 'block' : 'none');
    $('.js--set-holder-height').css('display', wheelSelected || palletFeetSelected && isRackConfigurator() ? 'block' : 'none');
    $wheelElements.filter('.js--mobility-sixth-piece').css('display', wheelSelected && hasSixMobilityPieces ? 'block' : 'none');
    $palletFootElements.filter('.js--mobility-sixth-piece').css('display', palletFeetSelected && hasSixMobilityPieces ? 'block' : 'none');
    if (palletFeetSelected) {
      wheelHeight = palletFootHeightMm;
    } else if (!wheelSelected) {
      wheelHeight = 0;
      wheelSize = 0;
    }
    setPivots(inputLength);
    setNbrLockers();
    setNbrHandles();

    // Ext dimensions. A flight case cannot have a zero-thickness panel.
    // Until the customer chooses a material, do not present the interior
    // dimensions as if they were valid exterior dimensions.
    var exteriorDimensionsReady = !isRackConfigurator() || hasSelectedMaterialSize();
    var $exteriorDimensionsValues = $('.js--ext-dimensions-values');
    var $exteriorDimensionsPending = $('.js--ext-dimensions-pending');
    var jsExtHeight = $('.js--ext-height');
    jsExtHeight.parent().find('.wheelSelected, .mobilitySelected').remove();
    if (exteriorDimensionsReady) {
      $('.js--ext-length').html(parseInt(inputLength) + getExtLenDim() + 'mm');
      $('.js--ext-width').html(parseInt(inputWidth) + getExtWidDim() + 'mm');
      jsExtHeight.html(parseInt(inputHeight) + getExtHeiDim() + 'mm');
      $exteriorDimensionsValues.removeClass('hide');
      $exteriorDimensionsPending.addClass('hide');
      if (wheelSelected) {
        jsExtHeight.parent().append('<i class="wheelSelected"> (roulettes comprises)</i>');
      } else if (palletFeetSelected) {
        jsExtHeight.parent().append('<i class="mobilitySelected"> (plots palettisables compris)</i>');
      }
    } else {
      $('.js--ext-length, .js--ext-width, .js--ext-height').empty();
      $exteriorDimensionsValues.addClass('hide');
      $exteriorDimensionsPending.removeClass('hide');
    }
    if (window.configurator_options) {
      window.configurator_options.mobility_type = mobilityType;
      window.configurator_options.nbr_wheels = wheelSelected ? mobilityPieceCount : 0;
      window.configurator_options.nbr_pallet_feet = palletFeetSelected ? mobilityPieceCount : 0;
    }
    syncMalleAccessoryDetailCounts();

    // Elts sizes
    $('.js--set-hinge-width').css('width', getElementDisplaySize(hingeSize));
    $('.js--set-hingeflat-width').css('width', getElementDisplaySize(hingeFlatSize));
    $('.js--set-hinge-height').css('height', getElementDisplaySize(hingeSize));
    $('.js--set-hingeflat-height').css('height', getElementDisplaySize(hingeFlatSize));
    $('.js--set-tagholder-size').css('width', getElementDisplaySize(tagHolderSize));
    $('.js--set-hole-size').css('width', getElementDisplaySize(holeSize));
    $('.js--set-hole2-size').css('width', getElementDisplaySize(holeSize));
    $('.js--set-cap-height').css('height', getElementDisplaySize(capSize));
    applyCustomCapHeightToVisuals();
    $('.js--set-holder-height').css('height', getElementDisplaySize(holderSize));
    $('.js--set-corner-size').css('width', getElementDisplaySize(cornerSize));
    $('.js--set-cornerflat-size').css('width', getElementDisplaySize(cornerSize));
    $('.js--set-handle-size').css('width', getElementDisplaySize(handleSize));
    syncClocheHandleVariant();
    positionCustomCapHandles();
    $('.js--set-steelplate-size').css('width', getElementDisplaySize(65));
    applyCasterWheelDimensions($wheelElements, wheelSelected);
    $('.js--set-pallet-foot-size').css({
      width: getElementDisplaySize(palletFootLengthMm),
      height: getElementDisplaySize(palletFootHeightMm)
    });
    $('.js--set-capfixer-width').css('width', getElementDisplaySize(capfixerSize));
    $('.js--set-locker-front-size').css('width', getElementDisplaySize(lockerfrontSize));
    $('.js--set-locker2-front-size').css('width', getElementDisplaySize(locker2frontSize));
    syncRackCapPreview();
    if (!$('body').hasClass('flight-case-type-valise') && Math.min(inputLength) >= 600 && Math.min(inputLength) < 800) {
      $('.js--set-locker-front-size').css('width', getElementDisplaySize(202));
      $('.js--set-locker2-front-size').css('width', getElementDisplaySize(102));
      $('.js--set-locker-front-size, .js--set-locker2-front-size').find('.js--showfor-case-large').addClass('hide');
      $('.js--set-locker-front-size, .js--set-locker2-front-size').find('.js--showfor-case-medium').removeClass('hide');
      $('.js--set-locker-front-size').find('.js--showfor-case-small').addClass('hide');
      $('.js--set-locker2-front-size').find('.js--showfor-case-small').removeClass('hide');
    }
    $('.js--set-brace-size').css('width', getElementDisplaySize(braceSize));
    var capotAvantChecked = isRackConfigurator() || $('input[value="config-capot-avant"]').is(':checked');
    var capDisplaySize = parseFloat(getElementDisplaySize(capSize));
    var baseCapTop = getMalleCapTopDisplaySize(capDisplaySize * 3.12);
    var capLockerReferenceDimension = getCapLockerReferenceDimension();
    var sideCapLockerSize = capLockerReferenceDimension < 800 ? 102 : locker2frontSize;
    var sideCapLockerDisplaySize = parseFloat(getElementDisplaySize(sideCapLockerSize));
    var frontCapLockerSize = shouldUseLargeRackCapLockersForHeight() ? 128 : capLockerReferenceDimension < 800 ? 102 : locker2frontSize;
    var frontCapLockerDisplaySize = parseFloat(getElementDisplaySize(frontCapLockerSize));
    var currentCapHeightValue = syncCustomCapHeightField(false);
    var minHeightForTwoVerticalCapLockers = getMinHeightForTwoMalleVerticalCapLockers();
    var getMalleVerticalCapMetrics = function getMalleVerticalCapMetrics(capTop) {
      var profileTop = capTop - 1;
      var profileEnd = getCaseDisplayHeight();
      if (profileEnd <= profileTop) {
        profileEnd = getCaseDisplayHeight();
      }
      return {
        top: Math.max(0, profileTop),
        height: Math.max(0, profileEnd - profileTop)
      };
    };
    var getMalleVerticalLockerMetrics = function getMalleVerticalLockerMetrics(profile, lockerDisplaySize) {
      var edgeGap = capDisplaySize;
      var minLockerGap = Math.max(parseFloat(getElementDisplaySize(10)), edgeGap / 2);
      var centerY = profile.top + profile.height / 2 - lockerDisplaySize / 2;
      var topY = profile.top + lockerDisplaySize;
      var bottomY = profile.top + profile.height - lockerDisplaySize - edgeGap;
      var needsSingleLocker = profile.height < lockerDisplaySize * 2 + edgeGap + minLockerGap || bottomY < topY + lockerDisplaySize + minLockerGap;
      if (needsSingleLocker) {
        return {
          single: true,
          center: Math.max(profile.top, centerY)
        };
      }
      return {
        single: false,
        center: Math.max(profile.top, centerY),
        top: topY,
        bottom: bottomY
      };
    };
    var baseVerticalCap = getMalleVerticalCapMetrics(baseCapTop);
    var sideVerticalCap = baseVerticalCap;
    if (capotAvantChecked) {
      sideVerticalCap = getMalleVerticalCapMetrics(getCaseDisplayHeight() * 0.25);
    }
    $('.js--set-malle-side-cap-length').css({
      'width': sideVerticalCap.height + 'px',
      'top': sideVerticalCap.top + 'px'
    });
    $('.js--set-malle-front-side-cap-length').css({
      'width': baseVerticalCap.height + 'px',
      'top': baseVerticalCap.top + 'px'
    });
    var sideChecked = $('input[value="config-capot-lat"]').is(':checked');
    setMalleSideCapLockerSize(sideCapLockerSize);

    // Keep malle cap lockers clear of the existing cap hardware.
    if (sideChecked) {
      var sideLockerMetrics = getMalleVerticalLockerMetrics(sideVerticalCap, sideCapLockerDisplaySize);
      if (Math.min(inputHeight) < minHeightForTwoVerticalCapLockers || sideLockerMetrics.single) {
        $('.configurator_preview-locker2-malle-side-vertical-top').css({
          'top': sideLockerMetrics.center + 'px',
          'display': 'block'
        });
        $('.configurator_preview-locker2-malle-side-vertical-bottom').css('display', 'none');
      } else {
        $('.configurator_preview-locker2-malle-side-vertical-top').css({
          'top': sideLockerMetrics.top + 'px',
          'display': 'block'
        });
        $('.configurator_preview-locker2-malle-side-vertical-bottom').css({
          'top': sideLockerMetrics.bottom + 'px',
          'display': 'block'
        });
      }
    } else {
      $('.configurator_preview-locker2-malle-side-vertical-top').css('display', 'none');
      $('.configurator_preview-locker2-malle-side-vertical-bottom').css('display', 'none');
    }
    setMalleFrontCapLockerSize(frontCapLockerSize);
    if (capotAvantChecked) {
      var frontLockerMetrics = getMalleVerticalLockerMetrics(baseVerticalCap, frontCapLockerDisplaySize);
      if (Math.min(inputHeight) < minHeightForTwoVerticalCapLockers || frontLockerMetrics.single) {
        $('.configurator_preview-locker2-malle-front-side-top').css({
          'top': frontLockerMetrics.center + 'px',
          'display': 'block'
        });
        $('.configurator_preview-locker2-malle-front-side-bottom').css('display', 'none');
      } else {
        $('.configurator_preview-locker2-malle-front-side-top').css({
          'top': frontLockerMetrics.top + 'px',
          'display': 'block'
        });
        $('.configurator_preview-locker2-malle-front-side-bottom').css({
          'top': frontLockerMetrics.bottom + 'px',
          'display': 'block'
        });
      }
    } else {
      $('.configurator_preview-locker2-malle-front-side-top').css('display', 'none');
      $('.configurator_preview-locker2-malle-front-side-bottom').css('display', 'none');
    }
  };
  var syncMalleAccessoryDetailCounts = function syncMalleAccessoryDetailCounts() {
    if (isRackConfigurator() || !window.configurator_options) {
      return;
    }
    var family = getFlightCaseAccessoryFamily();
    var detailFamilies = ['malle', 'cloche'];
    var detailSuffixes = ['parts_size', 'locker_large_count', 'locker_medium_count', 'cap_locker_medium_count', 'handle_standard_count', 'wheel_standard_count', 'corner_ball_large_count', 'corner_ball_medium_count', 'corner_flat_count', 'brace_count'];
    detailFamilies.forEach(function (detailFamily) {
      detailSuffixes.forEach(function (suffix) {
        window.configurator_options[detailFamily + '_' + suffix] = suffix === 'parts_size' ? '' : 0;
      });
    });
    if (family !== 'malle' && family !== 'cloche') {
      return;
    }
    var partSize = currentConfiguratorPartsSize || '';
    var lockerCount = parseConfiguratorOptionNumber(window.configurator_options.nbr_lockers, 0);
    var handleCount = parseConfiguratorOptionNumber(window.configurator_options.nbr_handles, 0);
    var wheelCount = parseConfiguratorOptionNumber(window.configurator_options.nbr_wheels, 0);
    var cornerType = $('#pa_configurateur-coins').val() || 'coins-boules';
    var cornerCount = 8;
    var capCount = 0;
    var heightValue = parseInt($('.height-input:first input[name="height_needed"]:first').val(), 10);
    var capLockersPerCap = !isNaN(heightValue) && heightValue < getMinHeightForTwoMalleVerticalCapLockers() ? 1 : 2;
    if (family === 'malle') {
      if ($('input[value="config-capot-avant"]').is(':checked')) {
        capCount += 1;
      }
      if ($('input[value="config-capot-lat"]').is(':checked')) {
        capCount += 1;
      }
    } else if ($('#capot_double_cloche').is(':checked')) {
      capCount = 1;
    }
    window.configurator_options[family + '_parts_size'] = partSize;
    window.configurator_options[family + '_locker_large_count'] = partSize === 'large' ? lockerCount : 0;
    window.configurator_options[family + '_locker_medium_count'] = partSize === 'large' ? 0 : lockerCount;
    window.configurator_options[family + '_cap_locker_medium_count'] = capCount * capLockersPerCap;
    window.configurator_options[family + '_handle_standard_count'] = handleCount;
    window.configurator_options[family + '_wheel_standard_count'] = wheelCount;
    window.configurator_options[family + '_corner_ball_large_count'] = cornerType === 'coins-boules' && partSize === 'large' ? cornerCount : 0;
    window.configurator_options[family + '_corner_ball_medium_count'] = cornerType === 'coins-boules' && partSize !== 'large' ? cornerCount : 0;
    window.configurator_options[family + '_corner_flat_count'] = cornerType === 'coins-plats' ? cornerCount : 0;
    window.configurator_options[family + '_brace_count'] = capCount * 2;
  };
  var setNbrLockers = function setNbrLockers() {
    if (isValisePricingV2Enabled()) {
      window.configurator_options.nbr_lockers = 2;
      window.configurator_options.valise_locker_count = 2;
      $('#conex-calculated-price').trigger('wc-measurement-price-calculator-product-price-change');
      return;
    }
    switch (currentConfiguratorPartsSize) {
      case 'large':
        window.configurator_options.nbr_lockers = $('#side_lockers_side-lockers').is(':checked') ? 8 : 4;
        break;
      case 'medium':
        window.configurator_options.nbr_lockers = $('#side_lockers_side-lockers').is(':checked') ? 6 : 4;
        break;
      case 'small':
        window.configurator_options.nbr_lockers = $('#side_lockers_side-lockers').is(':checked') ? 4 : 2;
        break;
    }
    var frontChecked = $('input[value="config-capot-avant"]').is(':checked');
    var sideChecked = $('input[value="config-capot-lat"]').is(':checked');
    var inputHeight = parseInt($('.height-input:first input[name="height_needed"]:first').val());
    var capHasReducedLockers = (frontChecked || sideChecked) && Math.min(inputHeight) < getMinHeightForTwoMalleVerticalCapLockers();
    $('input[value="config-capot-avant"], input[value="config-capot-lat"]').each(function () {
      var $capInput = $(this);
      var originalBasePrice = $capInput.attr('data-malle-cap-original-price');
      if (typeof originalBasePrice === 'undefined') {
        originalBasePrice = $capInput.attr('data-price');
        $capInput.attr('data-malle-cap-original-price', originalBasePrice);
      }
      var capFallbackPrice = parseFloat(originalBasePrice);
      var capCatalogCode = $capInput.val() === 'config-capot-avant' ? 'malle_cap_front' : $capInput.val() === 'config-capot-lat' ? 'malle_cap_side' : '';
      var capPrice = capCatalogCode ? getConfiguratorAccessoryUnitPrice(capCatalogCode, isNaN(capFallbackPrice) ? 0 : capFallbackPrice) : capFallbackPrice;
      capPrice = isNaN(capPrice) ? 0 : capPrice;
      $capInput.attr('data-malle-cap-base-price', capPrice.toString());
      if (capHasReducedLockers) {
        capPrice = Math.max(0, capPrice + getConfiguratorAccessoryUnitPrice('malle_cap_single_locker_discount', -25));
      }
      $capInput.attr('data-price', capPrice.toString());
    });
    syncMalleAccessoryDetailCounts();
    $('#conex-calculated-price').trigger('wc-measurement-price-calculator-product-price-change');
  };
  var getRackFrontBackHandlesUseCenter = function getRackFrontBackHandlesUseCenter() {
    if (!isRackConfigurator()) {
      return false;
    }
    if (isRackSideHandlesEnabled()) {
      return false;
    }
    var rackLength = parseInt(inputLength, 10);
    return !isNaN(rackLength) && rackLength < 430;
  };
  var setNbrHandles = function setNbrHandles() {
    if (isValisePricingV2Enabled()) {
      var valiseSideHandleCount = getValiseSideHandleCount();
      window.configurator_options.nbr_handles = valiseSideHandleCount;
      window.configurator_options.valise_main_handle_count = 1;
      window.configurator_options.valise_side_handle_count = valiseSideHandleCount;
      syncValiseSideHandleOptionState();
      $('#conex-calculated-price').trigger('wc-measurement-price-calculator-product-price-change');
      return;
    }
    var nbr_handles = 4;
    var capHandleCenterThreshold = 625;
    var frontCapChecked = $('input[value="config-capot-avant"]').is(':checked');
    var sideCapChecked = $('input[value="config-capot-lat"]').is(':checked');
    var sideWidthIsNarrow = parseInt(inputWidth, 10) < 600;
    var frontBackLengthIsNarrow = parseInt(inputLength, 10) < 600;
    var sideHandlesUseCenter = isRackConfigurator() ? getRackSideHandlesUseCenter() : sideWidthIsNarrow || frontCapChecked && parseInt(inputWidth, 10) <= capHandleCenterThreshold;
    var frontBackHandlesUseCenter = isRackConfigurator() ? getRackFrontBackHandlesUseCenter() : frontBackLengthIsNarrow || sideCapChecked && parseInt(inputLength, 10) <= capHandleCenterThreshold;
    var useGenericWidthHandleThreshold = !isRackConfigurator() || getRackMode() !== 'custom';
    if (useGenericWidthHandleThreshold && parseInt(inputWidth) < 600 || sideHandlesUseCenter) {
      nbr_handles = nbr_handles - 2;
    }
    var frontBackHandlesChecked = $('#handle_customs_add-sidehandle').is(':checked') && !$('#handle_customs_add-sidehandle').prop('disabled');
    if (frontBackHandlesChecked) {
      nbr_handles = nbr_handles + 4;
      if (parseInt(inputLength) < 600 || frontBackHandlesUseCenter) {
        nbr_handles = nbr_handles - 2;
      }
    }
    if (isRackConfigurator()) {
      var rackImplicitSideHandleCount = sideHandlesUseCenter ? 1 : 2;
      nbr_handles = Math.max(0, nbr_handles - rackImplicitSideHandleCount);
      if (isRackSideHandlesEnabled()) {
        nbr_handles = nbr_handles + 2;
      }
    }
    nbr_handles = nbr_handles + getCustomCapHandleCount();
    window.configurator_options.nbr_handles = nbr_handles;
    if (!isRackConfigurator()) {
      sideHandleHideShow(frontBackHandlesChecked);
      refreshSelectedHandlePositions();
    }
    syncMalleAccessoryDetailCounts();
    $('#conex-calculated-price').trigger('wc-measurement-price-calculator-product-price-change');
  };
  var getCaseDisplayLength = function getCaseDisplayLength() {
    return Math.floor(inputLength * (maxZoomPx / (1 / currentZoom)) / caseMaxSize);
  };
  var getCaseDisplayHeight = function getCaseDisplayHeight() {
    return Math.floor(inputHeight * (maxZoomPx / (1 / currentZoom)) / caseMaxSize);
  };
  var getCaseDisplayWidth = function getCaseDisplayWidth() {
    return Math.floor(inputWidth * (maxZoomPx / (1 / currentZoom)) / caseMaxSize);
  };
  var getRackDepthDimension = function getRackDepthDimension() {
    if (!isRackConfigurator()) {
      return inputLength;
    }
    var bodyLength = parseInt(getRackMeasurementInputs().length.val(), 10);
    return isNaN(bodyLength) ? 0 : Math.max(0, bodyLength);
  };
  var shouldUseLargeRackCapLockersForHeight = function shouldUseLargeRackCapLockersForHeight() {
    if (!isRackConfigurator() || isRackFlatCapSelected()) {
      return false;
    }
    var rackHeight = parseInt($('#height_needed').val(), 10);
    return !isNaN(rackHeight) && rackHeight >= 1200;
  };
  var getRackFaceDimension = function getRackFaceDimension() {
    return inputWidth;
  };
  var getRackDepthDisplayWidth = function getRackDepthDisplayWidth() {
    return Math.floor(getRackDepthDimension() * (maxZoomPx / (1 / currentZoom)) / caseMaxSize);
  };
  var getCapLockerReferenceDimension = function getCapLockerReferenceDimension() {
    return isRackConfigurator() ? getRackDepthDimension() : inputWidth;
  };
  var getElementDisplaySize = function getElementDisplaySize(elementSizemm) {
    return Number.parseFloat(elementSizemm * (maxZoomPx / (1 / currentZoom)) / caseMaxSize).toFixed(2);
  };
  var setMalleFrontCapLockerSize = function setMalleFrontCapLockerSize(frontCapLockerSize) {
    var $frontCapLockers = $('.configurator_preview-locker2-malle-front-side-top, .configurator_preview-locker2-malle-front-side-bottom');
    if (!$frontCapLockers.length) {
      return;
    }
    var useLargeRackLocker = shouldUseLargeRackCapLockersForHeight();
    var useMediumLocker = !useLargeRackLocker && getCapLockerReferenceDimension() < 800;
    $frontCapLockers.css('width', getElementDisplaySize(frontCapLockerSize));
    if (useMediumLocker) {
      $frontCapLockers.find('.js--showfor-case-large').addClass('hide');
      $frontCapLockers.find('.js--showfor-case-medium, .js--showfor-case-small').removeClass('hide');
    } else if (useLargeRackLocker || currentConfiguratorPartsSize === 'large') {
      $frontCapLockers.find('.js--showfor-case-large').removeClass('hide');
      $frontCapLockers.find('.js--showfor-case-medium, .js--showfor-case-small').addClass('hide');
    } else {
      $frontCapLockers.find('.js--showfor-case-large').addClass('hide');
      $frontCapLockers.find('.js--showfor-case-medium, .js--showfor-case-small').removeClass('hide');
    }
  };
  var setMalleSideCapLockerSize = function setMalleSideCapLockerSize(sideCapLockerSize) {
    var $sideCapLockers = $('.configurator_preview-locker2-malle-side-vertical-top, .configurator_preview-locker2-malle-side-vertical-bottom');
    if (!$sideCapLockers.length) {
      return;
    }
    var useMediumLocker = getCapLockerReferenceDimension() < 800;
    $sideCapLockers.css('width', getElementDisplaySize(sideCapLockerSize));
    if (useMediumLocker) {
      $sideCapLockers.find('.js--showfor-case-large').addClass('hide');
      $sideCapLockers.find('.js--showfor-case-medium, .js--showfor-case-small').removeClass('hide');
    } else if (currentConfiguratorPartsSize === 'large') {
      $sideCapLockers.find('.js--showfor-case-large').removeClass('hide');
      $sideCapLockers.find('.js--showfor-case-medium, .js--showfor-case-small').addClass('hide');
    } else {
      $sideCapLockers.find('.js--showfor-case-large').addClass('hide');
      $sideCapLockers.find('.js--showfor-case-medium, .js--showfor-case-small').removeClass('hide');
    }
  };
  var positionConfiguratorViewButton = function positionConfiguratorViewButton() {
    var $preview = $('.product-single__cat.configurator_preview:first');
    var $artboard = $preview.find('.configurator_preview--artboard:first');
    var $viewButton = $preview.find('.zoom-container:first');
    var previewNode = $preview.get(0);
    var artboardNode = $artboard.get(0);
    var buttonNode = $viewButton.get(0);
    var viewNode = $preview.find('.js--configurator-view.current-view').filter(function () {
      var rect = this.getBoundingClientRect();
      return rect.width > 0 && rect.height > 0;
    }).get(0);
    if (!previewNode || !buttonNode || !viewNode || !previewNode.getBoundingClientRect || !viewNode.getBoundingClientRect) {
      return;
    }
    $preview.css('min-height', '');
    $artboard.css('min-height', '');
    var previewRect = previewNode.getBoundingClientRect();
    var anchorNode = buttonNode.offsetParent || previewNode;
    var anchorRect = anchorNode.getBoundingClientRect();
    var viewRect = viewNode.getBoundingClientRect();
    var buttonHeight = $viewButton.outerHeight() || 34;
    var hasCurrentViewBottomHardware = function hasCurrentViewBottomHardware() {
      return $(viewNode).find('.js--set-wheel-size:visible, .js--set-pallet-foot-size:visible, .configurator_preview-wheel-angle--active:visible, .configurator_preview-wheel-angle--active img:visible, .configurator_preview-handle-trolley img:visible').filter(function () {
        var rect = this.getBoundingClientRect();
        return !$(this).closest('.hide').length && rect.width > 0 && rect.height > 0;
      }).length > 0;
    };
    var buttonViewGap = hasCurrentViewBottomHardware() ? 42 : 20;
    var getCurrentViewVisualRect = function getCurrentViewVisualRect() {
      var baseRect = viewNode.getBoundingClientRect();
      var visualRect = {
        top: baseRect.top,
        right: baseRect.right,
        bottom: baseRect.bottom,
        left: baseRect.left,
        width: baseRect.width,
        height: baseRect.height
      };
      $(viewNode).find('.js--set-wheel-size:visible, .js--set-pallet-foot-size:visible, .configurator_preview-wheel-angle--active:visible, .configurator_preview-wheel-angle--active img:visible, .configurator_preview-handle-trolley img:visible').each(function () {
        if ($(this).closest('.hide').length) {
          return;
        }
        var rect = this.getBoundingClientRect();
        if (!rect.width || !rect.height) {
          return;
        }
        visualRect.top = Math.min(visualRect.top, rect.top);
        visualRect.right = Math.max(visualRect.right, rect.right);
        visualRect.bottom = Math.max(visualRect.bottom, rect.bottom);
        visualRect.left = Math.min(visualRect.left, rect.left);
      });
      visualRect.width = visualRect.right - visualRect.left;
      visualRect.height = visualRect.bottom - visualRect.top;
      return visualRect;
    };
    var visualRect = getCurrentViewVisualRect();
    if (!previewRect.height || !anchorRect.height || !viewRect.height || !visualRect.height) {
      return;
    }
    var minViewTopGap = 8;
    var topOverflow = previewRect.top + minViewTopGap - visualRect.top;
    if (topOverflow > 0 && artboardNode) {
      $artboard.css('min-height', Math.ceil($artboard.outerHeight() + topOverflow * 2) + 'px');
      previewRect = previewNode.getBoundingClientRect();
      anchorRect = anchorNode.getBoundingClientRect();
      viewRect = viewNode.getBoundingClientRect();
      visualRect = getCurrentViewVisualRect();
    }
    var requiredPreviewHeight = visualRect.bottom - previewRect.top + buttonHeight + buttonViewGap + 16;
    if (requiredPreviewHeight > previewRect.height) {
      $preview.css('min-height', Math.ceil(requiredPreviewHeight) + 'px');
      previewRect = previewNode.getBoundingClientRect();
      anchorRect = anchorNode.getBoundingClientRect();
      viewRect = viewNode.getBoundingClientRect();
      visualRect = getCurrentViewVisualRect();
    }
    var topOffset = visualRect.bottom - anchorRect.top + buttonViewGap;
    var maxOffset = previewRect.bottom - anchorRect.top - buttonHeight - 12;
    var minOffset = previewRect.top - anchorRect.top + 12;
    topOffset = Math.max(minOffset, Math.min(topOffset, maxOffset));
    $viewButton.css('top', Math.round(topOffset) + 'px');
  };
  var refreshConfiguratorViewButtonPosition = function refreshConfiguratorViewButtonPosition() {
    positionConfiguratorViewButton();
    if (window.requestAnimationFrame) {
      window.requestAnimationFrame(positionConfiguratorViewButton);
    }
    window.setTimeout(positionConfiguratorViewButton, 120);
    window.setTimeout(positionConfiguratorViewButton, 320);
  };
  var setCaseValues = function setCaseValues() {
    var _frontConfigurator = $('.js--front-configurator:first');
    var _sideConfigurator = $('.js--side-configurator:first');
    //var _side2Configurator = $('.js--side2-configurator:first');
    //var _bottomConfigurator = $('.js--bottom-configurator:first');
    var _topConfigurator = $('.js--top-configurator:first');
    var _backConfigurator = $('.js--back-configurator:first');
    setConfiguratorGlobalsVars();
    var _caseDisplayWidth = getCaseDisplayWidth();
    var _caseDisplayHeight = getCaseDisplayHeight();
    var _caseDisplayLength = getCaseDisplayLength();
    var _rackSideBaseDisplayWidth = isRackConfigurator() ? getRackDepthDisplayWidth() : _caseDisplayWidth;
    var _rackSideDisplayWidth = getRackSideVisualDisplayWidth(_rackSideBaseDisplayWidth);
    if (isRackConfigurator()) {
      // rack front/back show rack face width, while side/top show rack depth.
      _frontConfigurator.css('width', _caseDisplayWidth);
      _frontConfigurator.css('height', _caseDisplayHeight);
      _topConfigurator.css('width', _rackSideDisplayWidth);
      _topConfigurator.css('height', _caseDisplayWidth);
    } else if ($('body').hasClass('flight-case-type-valise')) {
      // front -- same as back
      _frontConfigurator.css('width', _caseDisplayLength);
      _frontConfigurator.css('height', _caseDisplayWidth);
      // top -- same as bottom
      _topConfigurator.css('width', _caseDisplayLength);
      _topConfigurator.css('height', _caseDisplayHeight);
    } else {
      // front -- same as back
      _frontConfigurator.css('width', _caseDisplayLength);
      _frontConfigurator.css('height', _caseDisplayHeight);
      // top -- same as bottom
      _topConfigurator.css('width', _caseDisplayLength);
      _topConfigurator.css('height', _caseDisplayWidth);
    }
    // side -- same as side2
    _sideConfigurator.css('width', _rackSideDisplayWidth);
    _sideConfigurator.css('height', _caseDisplayHeight);
    // back -- same as front
    _backConfigurator.css('width', isRackConfigurator() ? _caseDisplayWidth : _caseDisplayLength);
    _backConfigurator.css('height', _caseDisplayHeight);
    changeConfiguratorZoom('auto');
    refreshSelectedHandlePositions();
    refreshDoubleClocheParts();
    syncRackCapPreview();
    refreshRackHandlePairGaps();
    scheduleCustomCapHandleCollisionLayout();
    refreshConfiguratorViewButtonPosition();
  };
  var getExtLenDim = function getExtLenDim() {
    var _extraLength = 0;
    _extraLength = _extraLength + getDataSize("#pa_configurateur-matiere") * 2;
    _extraLength = _extraLength + getDataSize("#pa_configurateur-moussage") * 2;
    if (isRackConfigurator()) {
      _extraLength = _extraLength + getRackCapDepthExtraMm() + getRackFlatCapDepthExtraMm();
    }
    return _extraLength;
  };
  var getExtWidDim = function getExtWidDim() {
    var _extraWidth = 0;
    _extraWidth = _extraWidth + getDataSize("#pa_configurateur-matiere") * 2;
    _extraWidth = _extraWidth + getDataSize("#pa_configurateur-moussage") * 2;
    return _extraWidth;
  };
  var getExtHeiDim = function getExtHeiDim() {
    var _extraHeight = 0;
    _extraHeight = _extraHeight + getDataSize("#pa_configurateur-matiere") * 2;
    _extraHeight = _extraHeight + getDataSize("#pa_configurateur-moussage") * 2;
    _extraHeight = _extraHeight + wheelHeight;
    return _extraHeight;
  };
  var getDataSize = function getDataSize(selectID) {
    if ($(selectID).length > 0 && typeof $(selectID).find(':selected').attr('data-size') !== 'undefined') {
      var _dataSize = $(selectID).find(':selected').attr('data-size');
      var parsedDataSize = parseFloat(String(_dataSize).replace(',', '.'));
      return isNaN(parsedDataSize) ? 0 : parsedDataSize;
    } else {
      return 0;
    }
  };
  var hasSelectedMaterialSize = function hasSelectedMaterialSize() {
    var $material = $('#pa_configurateur-matiere');
    var $selected = $material.find(':selected');
    var rawSize = $selected.attr('data-size');
    var parsedSize = parseFloat(String(rawSize || '').replace(',', '.'));
    return $material.length > 0 && String($material.val() || '') !== '' && typeof rawSize !== 'undefined' && !isNaN(parsedSize) && parsedSize > 0;
  };
  var changeConfiguratorZoom = function changeConfiguratorZoom(ZoomInOut) {
    switch (ZoomInOut) {
      case 'zoomIn':
        if (currentZoom < maxZoom) {
          currentZoom = currentZoom + zoomStep;
          setCaseValues();
          return true;
        } else {
          console.log('ZoomInOut(param) : max zoom reached');
          return false;
        }
        break;
      case 'zoomOut':
        if (currentZoom > minZoom) {
          currentZoom = currentZoom - zoomStep;
          setCaseValues();
          return true;
        } else {
          console.log('ZoomInOut(param) : min zoom reached');
          return false;
        }
        break;
      case 'auto':
        // set transform: scale on the configurator block for better rendering automatically
        var _caseDisplayWidth = getCaseDisplayWidth();
        var _caseDisplayHeight = getCaseDisplayHeight();
        var _caseDisplayLength = getCaseDisplayLength();
        var _rackSideDisplayWidth = isRackConfigurator() ? getRackSideVisualDisplayWidth(getRackDepthDisplayWidth()) : _caseDisplayWidth;
        var _rackFrontBackDisplayWidth = isRackConfigurator() ? _caseDisplayWidth : _caseDisplayLength;
        var _rackTopDisplayWidth = isRackConfigurator() ? _rackSideDisplayWidth : _caseDisplayLength;
        var currentViewWheel = $('.current-view .js--set-wheel-size:visible, .current-view .js--set-pallet-foot-size:visible').first();
        var _translateWheels = '';
        if (currentViewWheel.length > 0) {
          _caseDisplayWidth = _caseDisplayWidth + currentViewWheel.width();
          _caseDisplayHeight = _caseDisplayHeight + currentViewWheel.width();
          _caseDisplayLength = _caseDisplayLength + currentViewWheel.width();
          _rackSideDisplayWidth = _rackSideDisplayWidth + currentViewWheel.width();
          _rackFrontBackDisplayWidth = _rackFrontBackDisplayWidth + currentViewWheel.width();
          _rackTopDisplayWidth = _rackTopDisplayWidth + currentViewWheel.width();

          // translate flight case to center the configurator with wheels
          _translateWheels = ' translate(0, -' + Math.floor(currentViewWheel.width() / 2) + 'px)';
        }
        var _scaleSizeHeight = currentZoom * maxZoomPx / _caseDisplayHeight;
        var _scaleSizeWidth = currentZoom * maxZoomPx / _caseDisplayWidth;
        var _scaleSizeLength = currentZoom * maxZoomPx / _caseDisplayLength;
        var _scaleSizeRackSideWidth = currentZoom * maxZoomPx / _rackSideDisplayWidth;
        var _scaleSizeRackFrontBackWidth = currentZoom * maxZoomPx / _rackFrontBackDisplayWidth;
        var _scaleSizeRackTopWidth = currentZoom * maxZoomPx / _rackTopDisplayWidth;
        var scaleRatioFront = Math.min(_scaleSizeRackFrontBackWidth, _scaleSizeHeight);
        var scaleRatioSide = Math.min(_scaleSizeRackSideWidth, _scaleSizeHeight);
        var scaleRatioTop = Math.min(_scaleSizeWidth, _scaleSizeRackTopWidth);
        var sideTransform = 'scale(' + scaleRatioSide + ')' + _translateWheels;
        if (isRackConfigurator() && document.body.classList.contains('rack-back-mirror-view')) {
          sideTransform = 'scale(-' + scaleRatioSide + ', ' + scaleRatioSide + ')' + _translateWheels;
        }
        $('.js--front-configurator').css('transform', 'scale(' + scaleRatioFront + ')' + _translateWheels);
        $('.js--back-configurator').css('transform', 'scale(' + scaleRatioFront + ')' + _translateWheels);
        $('.js--side-configurator').css('transform', sideTransform);
        $('.js--top-configurator').css('transform', 'scale(' + scaleRatioTop + ')');
        console.log('ZoomInOut(param) : automatically set zoom used by configurator');
        return true;
      default:
        console.log('ZoomInOut(param) : param must be "auto", "zoomIn" or "zoomOut"');
        return false;
    }
  };
  var updateTrolleyAndWheelAngleClasses = function updateTrolleyAndWheelAngleClasses(view) {
    var wheelsLeft = $('.configurator_preview-wheel-angle--side-left, .configurator_preview-wheel-angle--front-left, .configurator_preview-wheel-angle--back-left');
    var wheelsRight = $('.configurator_preview-wheel-angle--side-right, .configurator_preview-wheel-angle--front-right, .configurator_preview-wheel-angle--back-right');

    // Réinitialise les classes de position dynamique des roulettes
    wheelsLeft.removeClass('configurator_preview-wheel-angle--active');
    wheelsRight.removeClass('configurator_preview-wheel-angle--active');

    // Applique selon la vue
    switch (view) {
      case 'side':
        $('.configurator_preview-wheel-angle--side-left').addClass('configurator_preview-wheel-angle--active');
        $('.configurator_preview-wheel-angle--side-right').addClass('configurator_preview-wheel-angle--active');
        break;
      case 'front':
        $('.configurator_preview-wheel-angle--front-left').addClass('configurator_preview-wheel-angle--active');
        $('.configurator_preview-wheel-angle--front-right').addClass('configurator_preview-wheel-angle--active');
        break;
      case 'back':
        $('.configurator_preview-wheel-angle--back-left').addClass('configurator_preview-wheel-angle--active');
        $('.configurator_preview-wheel-angle--back-right').addClass('configurator_preview-wheel-angle--active');
        break;
      case 'top':
        $('.configurator_preview-wheel-angle--front-left').addClass('configurator_preview-wheel-angle--active');
        break;
    }
  };
  var changeConfiguratorView = function changeConfiguratorView(view) {
    $('.js--configurator-view').addClass('hide');
    var _changeViewButton = $('.js--changeConfiguratorView');
    var _changeViewLabel = $('.js--view-label');
    $('.configurator_preview .current-view').removeClass('current-view');
    $('body').removeClass('rack-back-mirror-view');
    switch (view) {
      case 'front':
        $('.js--front-configurator').fadeIn().removeClass('hide').addClass('current-view');
        _changeViewButton.attr('data-view-to-show', $('body').hasClass('flight-case-type-valise') ? 'top' : 'side');
        if ($('body').hasClass('flight-case-type-valise')) {
          _changeViewLabel.html('Vue de dessus');
        } else if (isRackConfigurator()) {
          _changeViewLabel.html('Vue de côté');
        } else {
          _changeViewLabel.html('Vue de face');
        }
        updateTrolleyAndWheelAngleClasses(view);
        break;
      case 'side':
        $('.js--side-configurator').fadeIn().removeClass('hide').addClass('current-view');
        _changeViewButton.attr('data-view-to-show', 'back');
        _changeViewLabel.html(isRackConfigurator() ? 'Vue de face' : 'Vue de côté');
        updateTrolleyAndWheelAngleClasses(view);
        break;
      case 'back':
        if (isRackConfigurator()) {
          $('.js--side-configurator').fadeIn().removeClass('hide').addClass('current-view');
          $('body').addClass('rack-back-mirror-view');
        } else {
          $('.js--back-configurator').fadeIn().removeClass('hide').addClass('current-view');
        }
        _changeViewButton.attr('data-view-to-show', $('body').hasClass('flight-case-type-valise') ? 'front' : 'top');
        _changeViewLabel.html('Vue de derrière');
        updateTrolleyAndWheelAngleClasses(view);
        break;
      case 'top':
        $('.js--top-configurator').fadeIn().removeClass('hide').addClass('current-view');
        _changeViewButton.attr('data-view-to-show', $('body').hasClass('flight-case-type-valise') ? 'side' : 'front');
        if ($('body').hasClass('flight-case-type-valise')) {
          _changeViewLabel.html('Vue de face');
        } else {
          _changeViewLabel.html('Vue de dessus');
        }
        updateTrolleyAndWheelAngleClasses(view);
        break;
      default:
        break;
    }
    if (isRackConfigurator()) {
      changeConfiguratorZoom('auto');
      if (document.body.classList.contains('rack-back-mirror-view')) {
        var $rackSideConfigurator = $('.js--side-configurator');
        var currentSideTransform = $rackSideConfigurator[0] ? $rackSideConfigurator[0].style.transform : '';
        var scaleMatch = currentSideTransform.match(/scale\((-?[0-9.]+)/);
        var translateMatch = currentSideTransform.match(/translate\([^)]*\)/);
        var rackSideScale = scaleMatch ? Math.abs(parseFloat(scaleMatch[1])) : 1;
        if (!isNaN(rackSideScale) && rackSideScale > 0) {
          $rackSideConfigurator.css('transform', 'scale(-' + rackSideScale + ', ' + rackSideScale + ')' + (translateMatch ? ' ' + translateMatch[0] : ''));
        }
      }
    }
    refreshSelectedHandlePositions();
    window.setTimeout(refreshSelectedHandlePositions, 120);
    refreshDoubleClocheParts();
    scheduleCustomCapHandleCollisionLayout();
    syncRackCapPreview();
    refreshConfiguratorViewButtonPosition();
    if (isRackConfigurator() && document.body.classList.contains('rack-back-mirror-view')) {
      window.setTimeout(function () {
        changeConfiguratorZoom('auto');
        refreshConfiguratorViewButtonPosition();
      }, 160);
    }
  };
  var setPivots = function setPivots(inputLength) {
    var pivotContainerWidth = getElementDisplaySize(parseInt(inputLength) + getExtLenDim());
    if ($('.js--set-locker-front-size').length > 0) {
      pivotContainerWidth = pivotContainerWidth - 2 * $('.js--set-locker-front-size').width();
    }
    var pivotContainerHeight = getElementDisplaySize(38.5);
    var minNeededSpace = 200;
    var pivotIMG = $('.js--pivot-points--img:first')[0].outerHTML;
    var numberPivots = Math.floor(pivotContainerWidth / getElementDisplaySize(minNeededSpace));
    $('.js--pivot-points').css('height', pivotContainerHeight);
    $('.js--pivot-points').removeClass('hide').css('width', pivotContainerWidth + 'px');
    $('.js--pivot-points--img:not(:first)').remove();
    if ($('body').hasClass('flight-case-type-valise') && numberPivots === 1) {
      numberPivots = 2;
    }
    if (numberPivots > 0) {
      $('.js--pivot-points').removeClass('hide');
      for (var i = 1; i < numberPivots; i++) {
        $('.js--pivot-points').append(pivotIMG);
      }
    } else {
      $('.js--pivot-points').addClass('hide');
    }
  };
  var setStopHinge = function setStopHinge(inputLength) {
    var stopHingeContainerWidth = getElementDisplaySize(parseInt(inputLength) + getExtLenDim());
    if ($('.js--set-locker-front-size').length > 0) {
      stopHingeContainerWidth = stopHingeContainerWidth - 2 * $('.js--set-locker-front-size').width();
    }
    var stopHingeContainerHeight = getElementDisplaySize(91.5);
    var minNeededSpace = 300;
    var stopHingeIMG = $('.js--stop-hinge--img')[0].outerHTML;
    var numberStops = Math.floor(stopHingeContainerWidth / getElementDisplaySize(minNeededSpace));
    $('.js--stop-hinge').css('height', stopHingeContainerHeight);
    $('.js--stop-hinge').removeClass('hide').css('width', stopHingeContainerWidth + 'px');
    $('.js--stop-hinge--img:not(:first)').remove();
    if (numberStops > 0) {
      $('.js--stop-hinge').removeClass('hide');
      for (var i = 1; i < numberStops; i++) {
        $('.js--stop-hinge').append(stopHingeIMG);
      }
    } else {
      $('.js--stop-hinge').addClass('hide');
    }
  };
  var checkEngraving = function checkEngraving($checkbox_engraving) {
    if ($checkbox_engraving.length !== 0) {
      var $wrapper = $('.flightcase_customs.textarea_wrapper');
      if ($checkbox_engraving.is(':checked')) {
        $wrapper.removeClass('hide');
      } else {
        $wrapper.addClass('hide').find('textarea:first').val('');
      }
    }
  };
  var wheelsHideShow = function wheelsHideShow() {
    setCaseValues();
    refreshConfiguratorViewButtonPosition();
    window.setTimeout(refreshConfiguratorViewButtonPosition, 700);
  };
  var sideHandleHideShow = function sideHandleHideShow(isCheck) {
    var $views = $('.configurator_preview--front, .configurator_preview--back, .configurator_preview--top');
    var $handles = $views.find('.configurator_preview-handle');
    if (!isCheck) {
      $handles.addClass('hide').css('display', 'none');
      return;
    }
    if (isClocheConfigurator()) {
      var lengthValue = parseInt($('.length-input:first input[name="length_needed"]:first').val(), 10);
      var useCenterHandle = !isNaN(lengthValue) && lengthValue < 600;
      var handleSelector = useCenterHandle ? '.configurator_preview-handle-center' : '.configurator_preview-handle-left, .configurator_preview-handle-right';
      $handles.addClass('hide').css('display', 'none');
      $views.find(handleSelector).removeClass('hide').css('display', '');
      return;
    }
    $handles.removeClass('hide').css('display', '');
  };
  var setDoubleClocheParts = function setDoubleClocheParts() {
    var isChecked = $('#capot_double_cloche').is(':checked');
    var $doubleParts = $('.configurator_preview-double-cloche');
    if (!$doubleParts.length) {
      return;
    }
    if (!isChecked) {
      $doubleParts.css('display', 'none');
      return;
    }
    var capThickness = parseFloat(getElementDisplaySize(capSize));
    var frontWidth = getCaseDisplayLength();
    var frontHeight = getCaseDisplayHeight();
    var topWidth = getCaseDisplayLength();
    var topHeight = getCaseDisplayWidth();
    var doubleClocheHeight = parseInt($('.height-input:first input[name="height_needed"]:first').val(), 10);
    var useFaceBackLockerPair = !isNaN(doubleClocheHeight) && doubleClocheHeight > clocheDoubleCapLockerPairHeightThreshold;
    var profileTop = capThickness * 3.12;
    var profileBottomGap = capThickness * 1.05;
    var getRelativeCssScaleY = function getRelativeCssScaleY(viewNode) {
      var viewRect = viewNode.getBoundingClientRect();
      var viewCssHeight = parseFloat(window.getComputedStyle(viewNode).height);
      var scaleY = viewCssHeight > 0 ? viewRect.height / viewCssHeight : 1;
      if (!scaleY || isNaN(scaleY)) {
        scaleY = 1;
      }
      return scaleY;
    };
    var getRelativeCssEdge = function getRelativeCssEdge($view, selector, edge) {
      var viewNode = $view.get(0);
      var node = $view.find(selector).get(0);
      if (!viewNode || !node || !viewNode.getBoundingClientRect || !node.getBoundingClientRect) {
        return null;
      }
      var viewRect = viewNode.getBoundingClientRect();
      var nodeRect = node.getBoundingClientRect();
      var scaleY = getRelativeCssScaleY(viewNode);
      if (!viewRect.width || !viewRect.height || !nodeRect.width && !nodeRect.height) {
        return null;
      }
      return ((edge === 'bottom' ? nodeRect.bottom : nodeRect.top) - viewRect.top) / scaleY;
    };
    var getRelativeCssCenterY = function getRelativeCssCenterY($view, $node) {
      var viewNode = $view.get(0);
      var node = $node.get(0);
      if (!viewNode || !node || !viewNode.getBoundingClientRect || !node.getBoundingClientRect) {
        return null;
      }
      var viewRect = viewNode.getBoundingClientRect();
      var nodeRect = node.getBoundingClientRect();
      var scaleY = getRelativeCssScaleY(viewNode);
      if (!viewRect.width || !viewRect.height || !nodeRect.width && !nodeRect.height) {
        return null;
      }
      return (nodeRect.top + nodeRect.height / 2 - viewRect.top) / scaleY;
    };
    var frontProfileBottomOffset = 10;
    var getFrontBackProfileMetrics = function getFrontBackProfileMetrics($view) {
      var renderedProfileTop = getRelativeCssEdge($view, '.configurator_preview-hinge-top', 'bottom');
      var $renderedBottomRail = $view.find('.configurator_preview-cap svg:visible:first');
      var renderedProfileBottom;
      if (!$renderedBottomRail.length) {
        $renderedBottomRail = $view.find('.configurator_preview-cap svg:first');
      }
      renderedProfileBottom = getRelativeCssCenterY($view, $renderedBottomRail);

      // Une projection avant/arrière peut être masquée pendant que
      // l'autre est active. Elles ont la même géométrie : utiliser la
      // projection visible comme repère évite de retomber sur une
      // hauteur théorique qui dépasse l'aperçu responsive plafonné.
      if (renderedProfileBottom === null) {
        var $visibleProfileView = $('.configurator_preview--front:visible, .configurator_preview--back:visible').first();
        var $visibleBottomRail = $visibleProfileView.find('.configurator_preview-cap svg:visible:first');
        renderedProfileBottom = getRelativeCssCenterY($visibleProfileView, $visibleBottomRail);
      }
      var capHeightDisplay = getCustomCapHeightDisplaySize();
      var geometricProfileBottom = frontHeight - capHeightDisplay - capThickness;
      var profileStart = renderedProfileTop !== null ? Math.max(0, renderedProfileTop - 1) : Math.max(0, parseFloat(getElementDisplaySize(hingeSize)) - 1);
      var profileEnd = renderedProfileBottom !== null ? renderedProfileBottom : !isNaN(geometricProfileBottom) ? geometricProfileBottom + frontProfileBottomOffset : frontHeight - profileTop + frontProfileBottomOffset;
      if (profileEnd <= profileStart) {
        profileEnd = frontHeight - profileTop + frontProfileBottomOffset;
      }
      return {
        top: profileStart,
        length: Math.max(0, profileEnd - profileStart)
      };
    };
    var frontProfile = getFrontBackProfileMetrics($('.configurator_preview--front:first'));
    var backProfile = getFrontBackProfileMetrics($('.configurator_preview--back:first'));
    var $topView = $('.configurator_preview--top:first');
    var renderedTopRailTop = getRelativeCssEdge($topView, '.configurator_preview-hinge-top', 'top');
    var renderedTopRailBottom = getRelativeCssEdge($topView, '.configurator_preview-hinge-top', 'bottom');
    var renderedTopBottomRailTop = getRelativeCssEdge($topView, '.configurator_preview-hinge-bottom', 'top');
    var renderedTopBottomRailBottom = getRelativeCssEdge($topView, '.configurator_preview-hinge-bottom', 'bottom');
    var topProfileTop = renderedTopRailTop !== null && renderedTopRailBottom !== null ? (renderedTopRailTop + renderedTopRailBottom) / 2 : profileTop;
    var topProfileBottom = renderedTopBottomRailTop !== null && renderedTopBottomRailBottom !== null ? (renderedTopBottomRailTop + renderedTopBottomRailBottom) / 2 : null;
    var topProfileLength = topProfileBottom !== null ? Math.max(0, topProfileBottom - topProfileTop) : Math.max(0, topHeight - profileTop - profileBottomGap);
    var topRailCenterY = getRelativeCssCenterY($topView, $topView.find('.configurator_preview-hinge-top:first'));
    var bottomRailCenterY = getRelativeCssCenterY($topView, $topView.find('.configurator_preview-hinge-bottom:first'));
    var topCapCenterY = topRailCenterY !== null && bottomRailCenterY !== null ? (topRailCenterY + bottomRailCenterY) / 2 : null;
    var lockerSize = Math.min(inputLength, inputWidth) < 800 || currentConfiguratorPartsSize !== 'large' ? 102 : locker2frontSize;
    var lockerDisplaySize = parseFloat(getElementDisplaySize(lockerSize));
    var braceDisplaySize = parseFloat(getElementDisplaySize(braceSize));
    var useMediumLocker = lockerSize === 102;
    var setVerticalCapProfile = function setVerticalCapProfile($profile, viewWidth, top, length) {
      $profile.css({
        'display': 'block',
        'height': capThickness + 'px',
        'left': viewWidth / 2 + capThickness / 2 + 'px',
        'top': top + 'px',
        'width': length + 'px'
      });
    };
    var setCenteredHorizontalLocker = function setCenteredHorizontalLocker($locker, viewWidth, centerY) {
      $locker.css({
        'display': 'block',
        'left': viewWidth / 2 - lockerDisplaySize / 2 + 'px',
        'top': centerY + 'px',
        'width': lockerDisplaySize + 'px'
      });
    };
    var getFaceBackLockerPairPositions = function getFaceBackLockerPairPositions(profile) {
      var edgeGap = capThickness;
      var minLockerGap = Math.max(parseFloat(getElementDisplaySize(10)), edgeGap / 2);
      var center = profile.top + profile.length / 2;
      var top = profile.top + profile.length * 0.25;
      var bottom = profile.top + profile.length * 0.75;
      if (bottom < top + lockerDisplaySize + minLockerGap) {
        return {
          top: Math.max(profile.top, center),
          bottom: null
        };
      }
      return {
        top: top,
        bottom: bottom
      };
    };
    var setCenteredTopBrace = function setCenteredTopBrace($brace, viewWidth, centerY) {
      $brace.css({
        'display': 'block',
        'left': viewWidth / 2 - braceDisplaySize / 2 + 'px',
        'top': centerY + 'px',
        'width': braceDisplaySize + 'px'
      });
    };
    var alignTopLockerToCapCenter = function alignTopLockerToCapCenter() {
      if (useFaceBackLockerPair || topCapCenterY === null) {
        return;
      }
      var $topLocker = $('.configurator_preview-locker2-double-cloche-top:first');
      var $topLockerImg = $topLocker.find('img:not(.hide):visible:first');
      if (!$topLockerImg.length) {
        $topLockerImg = $topLocker.find('img:not(.hide):first');
      }
      if (!$topLocker.length || !$topLockerImg.length) {
        return;
      }
      var lockerImageCenterY = getRelativeCssCenterY($topView, $topLockerImg);
      var lockerTop = parseFloat($topLocker.css('top'));
      if (lockerImageCenterY === null || isNaN(lockerTop)) {
        return;
      }
      $topLocker.css('top', lockerTop + topCapCenterY - lockerImageCenterY + 'px');
    };
    setVerticalCapProfile($('.configurator_preview-cap-double-cloche-front'), frontWidth, frontProfile.top, frontProfile.length);
    setVerticalCapProfile($('.configurator_preview-cap-double-cloche-back'), frontWidth, backProfile.top, backProfile.length);
    setVerticalCapProfile($('.configurator_preview-cap-double-cloche-top'), topWidth, topProfileTop, topProfileLength);
    var frontLockerTop = frontProfile.top + frontProfile.length / 2;
    var backLockerTop = backProfile.top + backProfile.length / 2;
    var frontBraceCenterY = frontProfile.top + capThickness / 2;
    var backBraceCenterY = backProfile.top + capThickness / 2;
    var topTopBraceCenterY = topProfileTop + braceDisplaySize * 1.1;
    var topBottomBraceCenterY = (topProfileBottom !== null ? topProfileBottom : topProfileTop + topProfileLength) + braceDisplaySize * 1.1;
    var topLockerCenterY = topHeight * 0.31;
    setCenteredTopBrace($('.configurator_preview-brace-double-cloche-front'), frontWidth, frontBraceCenterY);
    setCenteredTopBrace($('.configurator_preview-brace-double-cloche-back'), frontWidth, backBraceCenterY);
    setCenteredTopBrace($('.configurator_preview-brace-double-cloche-top-top'), topWidth, topTopBraceCenterY);
    setCenteredTopBrace($('.configurator_preview-brace-double-cloche-top-bottom'), topWidth, topBottomBraceCenterY);
    var $frontPrimaryLocker = $('.configurator_preview-locker2-double-cloche-front-primary');
    var $frontSecondaryLocker = $('.configurator_preview-locker2-double-cloche-front-secondary');
    var $backPrimaryLocker = $('.configurator_preview-locker2-double-cloche-back-primary');
    var $backSecondaryLocker = $('.configurator_preview-locker2-double-cloche-back-secondary');
    var $topLocker = $('.configurator_preview-locker2-double-cloche-top');
    if (useFaceBackLockerPair) {
      var frontLockerPairPositions = getFaceBackLockerPairPositions(frontProfile);
      var backLockerPairPositions = getFaceBackLockerPairPositions(backProfile);
      setCenteredHorizontalLocker($frontPrimaryLocker, frontWidth, frontLockerPairPositions.top);
      setCenteredHorizontalLocker($backPrimaryLocker, frontWidth, backLockerPairPositions.top);
      if (frontLockerPairPositions.bottom !== null) {
        setCenteredHorizontalLocker($frontSecondaryLocker, frontWidth, frontLockerPairPositions.bottom);
      } else {
        $frontSecondaryLocker.css('display', 'none');
      }
      if (backLockerPairPositions.bottom !== null) {
        setCenteredHorizontalLocker($backSecondaryLocker, frontWidth, backLockerPairPositions.bottom);
      } else {
        $backSecondaryLocker.css('display', 'none');
      }
      $topLocker.css('display', 'none');
    } else {
      setCenteredHorizontalLocker($frontPrimaryLocker, frontWidth, frontLockerTop);
      setCenteredHorizontalLocker($backPrimaryLocker, frontWidth, backLockerTop);
      $frontSecondaryLocker.add($backSecondaryLocker).css('display', 'none');
      setCenteredHorizontalLocker($topLocker, topWidth, topLockerCenterY);
    }

    // La vue de dessus montre uniquement la jonction des deux cloches.
    // Les fermoirs restent visibles sur les faces avant et arriere.
    $topLocker.css('display', 'none');
    if (useMediumLocker) {
      $('.configurator_preview-locker2-double-cloche').find('.js--showfor-case-large').addClass('hide');
      $('.configurator_preview-locker2-double-cloche').find('.js--showfor-case-medium, .js--showfor-case-small').removeClass('hide');
    } else {
      $('.configurator_preview-locker2-double-cloche').find('.js--showfor-case-large').removeClass('hide');
      $('.configurator_preview-locker2-double-cloche').find('.js--showfor-case-medium, .js--showfor-case-small').addClass('hide');
    }
    alignTopLockerToCapCenter();
  };
  var refreshDoubleClocheParts = function refreshDoubleClocheParts() {
    setDoubleClocheParts();
    if (window.requestAnimationFrame) {
      window.requestAnimationFrame(function () {
        setDoubleClocheParts();
      });
    } else {
      window.setTimeout(setDoubleClocheParts, 0);
    }
    window.setTimeout(setDoubleClocheParts, 80);
    window.setTimeout(setDoubleClocheParts, 250);
    window.setTimeout(setDoubleClocheParts, 600);
  };
  var doubleCapHideShow = function doubleCapHideShow(isChecked) {
    $('.configurator_preview-double-cloche').css('display', isChecked ? 'block' : 'none');
    refreshDoubleClocheParts();
  };
  var blackParts = function blackParts($backPartsInput) {
    if ($backPartsInput.is(':checked')) {
      $(".configurator_preview--artboard img[data-black]").each(function () {
        var _currentSrc = $(this).attr("src");
        var _blackSrc = $(this).attr("data-black");
        $(this).attr('data-ori', _currentSrc);
        $(this).attr('src', _blackSrc);
      });
      $(".configurator_preview--artboard .hinge-svg").addClass('hide');
      $(".configurator_preview--artboard .hinge-svg-black").fadeIn().removeClass('hide');
    } else {
      $(".configurator_preview--artboard img[data-black]").each(function () {
        $(this).attr('src', $(this).attr('data-ori'));
      });
      $(".configurator_preview--artboard .hinge-svg").fadeIn().removeClass('hide');
      $(".configurator_preview--artboard .hinge-svg-black").addClass('hide');
    }
  };
  var updateCornerPositionClass = function updateCornerPositionClass() {
    $(".configurator_preview-corner").each(function () {
      var $corner = $(this);
      var $mediumCorner = $corner.find("img[src*=corner-medium], img[data-black*=corner-black-medium]");
      var mediumVisible = $mediumCorner.length !== 0 && !$mediumCorner.hasClass("hide") && $mediumCorner.css("display") !== "none" && parseFloat($mediumCorner.css("opacity")) !== 0;
      $corner.toggleClass("configurator_preview-corner--medium", mediumVisible);
    });
  };
  var setCapParts = function setCapParts(selectValue) {
    var $elements = $('.configurator_preview--artboard *[data-show-for], .configurator_preview--artboard *[data-hide-for]');
    if (isRackConfigurator() && (selectValue === 'coins-plats' || selectValue === 'coins-boules')) {
      $('body').toggleClass('rack-coins-plats', selectValue === 'coins-plats').toggleClass('rack-coins-boules', selectValue === 'coins-boules');
    }
    showHideParts($elements, selectValue);
    updateCornerPositionClass();
  };
  var showHideParts = function showHideParts($elements, type) {
    $elements.each(function () {
      var showFor = $(this).attr('data-show-for').split(",");
      var hideFor = $(this).attr('data-hide-for').split(",");
      if ($.inArray(type, showFor) !== -1) {
        $(this).css('display', '').css('opacity', '1');
      }
      if ($.inArray(type, hideFor) !== -1) {
        $(this).css('display', 'none').css('opacity', '0');
      }
    });
  };
  var applyFlatCapVisualState = function applyFlatCapVisualState() {
    var isFlatCap = $('#pa_configurateur-type-de-capot').val() === 'capot-plat';
    var $topPreview = $('.configurator_preview--top');
    var $flatCapPreview = isRackConfigurator() ? $('.configurator_preview--front') : $topPreview;
    var restorePreview = function restorePreview($preview) {
      $preview.find('.configurator_preview-corner img').css('display', '').css('opacity', '1');
      $preview.find('.configurator_preview-hinge').css('opacity', '');
      $preview.find('.configurator_preview-hingeflat').css('opacity', '');
    };
    var activatePreview = function activatePreview($preview) {
      $preview.find('.configurator_preview-corner img').css('display', 'none').css('opacity', '0');
      $preview.find('.configurator_preview-hinge').css('opacity', 0);
      $preview.find('.configurator_preview-hingeflat').css('opacity', 1);
    };
    var syncRackTopFlatCorners = function syncRackTopFlatCorners() {
      if (!isRackConfigurator()) {
        return;
      }
      $topPreview.find('.configurator_preview-cornerflat, .configurator_preview-hole, .configurator_preview-hole2').css('display', 'none').css('opacity', '0');
      if (isFlatCap) {
        $topPreview.find('.configurator_preview-corner img[data-show-for="coins-boules"]').css('display', 'none').css('opacity', '0');
        $topPreview.find('.configurator_preview-corner img[data-show-for="coins-plats"]').css('display', '').css('opacity', '1');
      }
    };
    if (isFlatCap) {
      activatePreview($flatCapPreview);
      syncRackTopFlatCorners();
      $('.js--set-handle-size').css('transform', isRackConfigurator() ? '' : 'translateY(-20px)');
      $('.configurator_preview--front').addClass('flatcap-chosen');
    } else {
      restorePreview($flatCapPreview);
      syncRackTopFlatCorners();
      $('.js--set-handle-size').css('transform', '');
      $('.configurator_preview--front').removeClass('flatcap-chosen');
      setCapParts($('#pa_configurateur-coins').val() || 'coins-boules');
    }
  };
  var checkSideHandleLabel = function checkSideHandleLabel($sideHandle) {
    var $wrapper = $('label[for="handle_customs_rotate-handle"]:first');
    if ($sideHandle.is(':checked')) {
      $wrapper.removeClass('hide');
    } else {
      $wrapper.addClass('hide').find('input').prop('checked', false);
    }
  };
  var refreshVentilationQtySelectLabel = function refreshVentilationQtySelectLabel() {
    var $select = $('#ventilation_qty');
    if ($select.length === 0) {
      return;
    }
    var selectedLabel = $.trim($select.find('option:selected').text());
    var $renderedLabel = $('#select2-ventilation_qty-container');
    if ($renderedLabel.length !== 0 && selectedLabel !== '') {
      $renderedLabel.text(selectedLabel).attr('title', selectedLabel);
    }
  };
  var checkAirflowLabel = function checkAirflowLabel($airflow) {
    var $wrapper = $('tr.flightcase_customs_ventilation_qty, tr.flightcase_customs_ventilation');
    if ($airflow.is(':checked')) {
      var $ventilationQty = $('#ventilation_qty');
      if ($ventilationQty.val() === 'aucune grille' || !$ventilationQty.val()) {
        var firstVentilationQtyValue = $ventilationQty.find('option').filter(function () {
          return $(this).val() !== 'aucune grille';
        }).first().val();
        if (firstVentilationQtyValue) {
          $ventilationQty.val(firstVentilationQtyValue).trigger('change');
        }
      }
      $wrapper.removeClass('hide');
      refreshVentilationQtySelectLabel();
      window.setTimeout(refreshVentilationQtySelectLabel, 0);
      window.setTimeout(refreshVentilationQtySelectLabel, 50);
    } else {
      $wrapper.addClass('hide');
      $('#ventilation_qty').val('aucune grille').trigger('change');
      refreshVentilationQtySelectLabel();
    }
  };
  var setHandlePosition = function setHandlePosition(value, side) {
    var $selector = $('.' + side + ' .configurator_preview-handle, .' + side + ' .configurator_preview-handle-retractable, .' + side + ' .configurator_preview-handle-surface, .' + side + ' .configurator_preview-handle-leather');
    var topPercent = 50;
    if (isClocheConfigurator()) {
      switch (value) {
        case 'top-position':
          topPercent = 20;
          break;
        case 'center-position':
          topPercent = 40;
          break;
        case 'bottom-position':
          topPercent = 55;
          break;
      }
    } else if (isValiseCustomCapHeightConfigurator()) {
      var progress = getValiseCustomCapHeightProgress();
      switch (value) {
        case 'top-position':
          topPercent = 27 - 17 * progress;
          break;
        case 'center-position':
          topPercent = 50 - 22 * progress;
          break;
        case 'bottom-position':
          topPercent = 70;
          break;
      }
    } else {
      switch (value) {
        case 'top-position':
          topPercent = 37.5;
          break;
        case 'center-position':
          topPercent = 50;
          break;
        case 'bottom-position':
          topPercent = 65;
          break;
      }
    }
    syncClocheHandleVariant();
    if (isClocheConfigurator()) {
      topPercent = getClocheBaseHandleTopPercent(value, topPercent, side);
    } else if (!isRackConfigurator()) {
      topPercent = getCustomCapSafeHandleTopPercent(topPercent);
    }
    $selector.css('top', topPercent + '%');
  };
  var alignMalleBaseHandlesToRenderedLowerBody = function alignMalleBaseHandlesToRenderedLowerBody() {
    if (!$('body').hasClass('flight-case-type-malle') || !isCustomCapHeightConfigurator()) {
      return;
    }
    var $view = $('.configurator_preview--front.current-view, .configurator_preview--back.current-view, .configurator_preview--side.current-view').filter(function () {
      var rect = this.getBoundingClientRect();
      return rect.width > 0 && rect.height > 0;
    }).first();
    if (!$view.length) {
      return;
    }
    var positionInputName = $view.hasClass('configurator_preview--side') ? 'sidehandle_position' : 'handle_position';
    if (positionInputName === 'handle_position' && !$('#handle_customs_add-sidehandle').is(':checked')) {
      return;
    }
    var positionValue = $('input[name="' + positionInputName + '"]:checked').val();
    var positionRatio = positionValue === 'top-position' ? 0.25 : positionValue === 'bottom-position' ? 0.75 : 0.5;
    var capProfileNode = $view.find('.configurator_preview-cap svg').filter(function () {
      var rect = this.getBoundingClientRect();
      return rect.width > 0 && rect.height > 0;
    }).first().get(0);
    var bottomProfileNode = $view.find('.configurator_preview-hinge-bottom svg').filter(function () {
      var rect = this.getBoundingClientRect();
      return rect.width > 0 && rect.height > 0;
    }).first().get(0);
    if (!capProfileNode || !bottomProfileNode) {
      return;
    }
    var capProfileRect = capProfileNode.getBoundingClientRect();
    var bottomProfileRect = bottomProfileNode.getBoundingClientRect();
    var lowerBodyTop = capProfileRect.bottom;
    var lowerBodyBottom = bottomProfileRect.top;
    var lowerBodyHeight = lowerBodyBottom - lowerBodyTop;
    if (lowerBodyHeight <= 0) {
      return;
    }
    var viewRect = $view.get(0).getBoundingClientRect();
    var viewCssHeight = parseFloat($view.css('height'));
    var viewCssWidth = parseFloat($view.css('width'));
    var scaleY = viewCssHeight > 0 ? viewRect.height / viewCssHeight : 1;
    var scaleX = viewCssWidth > 0 ? viewRect.width / viewCssWidth : 1;
    if (!scaleY || isNaN(scaleY)) {
      scaleY = 1;
    }
    if (!scaleX || isNaN(scaleX)) {
      scaleX = 1;
    }
    var isVisiblePreviewPart = function isVisiblePreviewPart(node) {
      var $node = $(node);
      var rect = node.getBoundingClientRect();
      return rect.width > 0 && rect.height > 0 && $node.css('display') !== 'none' && !$node.hasClass('hide');
    };
    var $visiblePrimaryLockerImages = $view.find('.configurator_preview-locker img, .configurator_preview-locker2 img').filter(function () {
      return isVisiblePreviewPart(this);
    }).filter(function () {
      return !$(this).closest('.configurator_preview-cap-malle-front, .configurator_preview-cap-malle-side').length;
    });
    var $visibleSupplementalObstacles = $view.find('.configurator_preview-cap-malle-front, .configurator_preview-cap-malle-side').find('img, svg').filter(function () {
      return isVisiblePreviewPart(this);
    });
    var leftBodyProfileNode = $view.find('.configurator_preview-hinge-left svg').filter(function () {
      var rect = this.getBoundingClientRect();
      return rect.width > 0 && rect.height > 0;
    }).first().get(0);
    var rightBodyProfileNode = $view.find('.configurator_preview-hinge-right svg').filter(function () {
      var rect = this.getBoundingClientRect();
      return rect.width > 0 && rect.height > 0;
    }).first().get(0);
    var bodyLeft = leftBodyProfileNode ? leftBodyProfileNode.getBoundingClientRect().right : viewRect.left;
    var bodyRight = rightBodyProfileNode ? rightBodyProfileNode.getBoundingClientRect().left : viewRect.right;
    var lockerClearance = Math.max(6, parseFloat(getElementDisplaySize(12)) || 0);
    var supplementalClearance = Math.max(12, lockerClearance);
    $view.find('.configurator_preview-handle').each(function () {
      var $handle = $(this);
      var $img = $handle.find('img').filter(function () {
        var $candidate = $(this);
        var rect = this.getBoundingClientRect();
        return rect.width > 0 && rect.height > 0 && $candidate.css('display') !== 'none' && !$candidate.hasClass('hide');
      }).first();
      if (!$img.length) {
        return;
      }
      $img.css('left', '0px');
      var imgRect = $img.get(0).getBoundingClientRect();
      var currentTopValue = $handle.css('top');
      var currentTop = parseFloat(currentTopValue);
      if (currentTopValue.indexOf('%') !== -1 && viewCssHeight > 0) {
        currentTop = currentTop / 100 * viewCssHeight;
      }
      if (isNaN(currentTop) || !imgRect.height) {
        return;
      }
      var availableTravel = Math.max(0, lowerBodyHeight - imgRect.height);
      var targetImageTop = lowerBodyTop + availableTravel * positionRatio;
      var minimumImageTop = lowerBodyTop;
      var maximumImageTop = lowerBodyBottom - imgRect.height;
      $visiblePrimaryLockerImages.each(function () {
        var lockerRect = this.getBoundingClientRect();
        var overlapsHorizontally = lockerRect.left < imgRect.right && lockerRect.right > imgRect.left;
        var crossesLowerBody = lockerRect.bottom > lowerBodyTop && lockerRect.top < lowerBodyBottom;
        if (overlapsHorizontally && crossesLowerBody) {
          minimumImageTop = Math.max(minimumImageTop, lockerRect.bottom + lockerClearance);
        }
      });
      targetImageTop = Math.min(maximumImageTop, Math.max(targetImageTop, minimumImageTop));
      $handle.css('top', currentTop + (targetImageTop - imgRect.top) / scaleY + 'px');
      imgRect = $img.get(0).getBoundingClientRect();
      if (!$visibleSupplementalObstacles.length || bodyRight <= bodyLeft) {
        return;
      }
      var obstacleRects = [];
      $visibleSupplementalObstacles.each(function () {
        var obstacleRect = this.getBoundingClientRect();
        if (obstacleRect.bottom > imgRect.top && obstacleRect.top < imgRect.bottom) {
          obstacleRects.push(obstacleRect);
        }
      });
      if (!obstacleRects.length) {
        return;
      }
      var minimumDeltaX = bodyLeft + supplementalClearance - imgRect.left;
      var maximumDeltaX = bodyRight - supplementalClearance - imgRect.right;
      var candidateDeltas = [0];
      var bestDeltaX = null;
      $.each(obstacleRects, function (index, obstacleRect) {
        candidateDeltas.push(obstacleRect.left - supplementalClearance - imgRect.right);
        candidateDeltas.push(obstacleRect.right + supplementalClearance - imgRect.left);
      });
      $.each(candidateDeltas, function (index, deltaX) {
        if (deltaX < minimumDeltaX || deltaX > maximumDeltaX) {
          return;
        }
        var shiftedLeft = imgRect.left + deltaX;
        var shiftedRight = imgRect.right + deltaX;
        var blocked = false;
        $.each(obstacleRects, function (obstacleIndex, obstacleRect) {
          if (shiftedRight > obstacleRect.left - supplementalClearance && shiftedLeft < obstacleRect.right + supplementalClearance) {
            blocked = true;
            return false;
          }
        });
        if (!blocked && (bestDeltaX === null || Math.abs(deltaX) < Math.abs(bestDeltaX))) {
          bestDeltaX = deltaX;
        }
      });
      if (bestDeltaX !== null && Math.abs(bestDeltaX) > 0.1) {
        $img.css('left', bestDeltaX / scaleX + 'px');
      }
    });
  };
  var refreshMalleBaseHandleAlignment = function refreshMalleBaseHandleAlignment() {
    alignMalleBaseHandlesToRenderedLowerBody();
    if (window.requestAnimationFrame) {
      window.requestAnimationFrame(alignMalleBaseHandlesToRenderedLowerBody);
    }
    window.setTimeout(alignMalleBaseHandlesToRenderedLowerBody, 120);
  };
  var adjustRackHandlePairGap = function adjustRackHandlePairGap($view, minGap) {
    if (!isRackConfigurator() || !$view.length) {
      return;
    }
    var $left = $view.find('.configurator_preview-handle-left:first');
    var $right = $view.find('.configurator_preview-handle-right:first');
    var $leftImage = $left.find('img:first');
    var $rightImage = $right.find('img:first');
    if (!$left.length || !$right.length || !$leftImage.length || !$rightImage.length) {
      return;
    }
    if ($left.hasClass('hide') || $right.hasClass('hide') || $left.closest('.hide').length || $right.closest('.hide').length) {
      return;
    }
    if (!$leftImage.is(':visible') || !$rightImage.is(':visible')) {
      return;
    }
    var viewRect = $view.get(0).getBoundingClientRect();
    var leftRect = $leftImage.get(0).getBoundingClientRect();
    var rightRect = $rightImage.get(0).getBoundingClientRect();
    if (!viewRect.width || !leftRect.width || !rightRect.width) {
      return;
    }
    var visualLeftRect = leftRect.left <= rightRect.left ? leftRect : rightRect;
    var visualRightRect = leftRect.left <= rightRect.left ? rightRect : leftRect;
    var currentGap = visualRightRect.left - visualLeftRect.right;
    if (currentGap >= minGap) {
      return;
    }
    var getInsetPercent = function getInsetPercent($handle, propertyName) {
      var value = $handle.get(0).style[propertyName] || '';
      if (!value || value === 'auto') {
        value = $handle.css(propertyName);
      }
      if (typeof value === 'string' && value.indexOf('%') !== -1) {
        var percent = parseFloat(value);
        return isNaN(percent) ? 0 : percent;
      }
      var px = parseFloat(value);
      if (isNaN(px) || !viewRect.width) {
        return 0;
      }
      return px / viewRect.width * 100;
    };
    var shiftPercent = (minGap - currentGap) / 2 / viewRect.width * 100;
    var minInsetPercent = -6;
    var nextLeftPercent = Math.max(minInsetPercent, getInsetPercent($left, 'left') - shiftPercent);
    var nextRightPercent = Math.max(minInsetPercent, getInsetPercent($right, 'right') - shiftPercent);
    $left.css('left', nextLeftPercent.toFixed(2) + '%');
    $right.css('right', nextRightPercent.toFixed(2) + '%');
  };
  var adjustRackHandlePairGaps = function adjustRackHandlePairGaps() {
    if (!isRackConfigurator()) {
      return;
    }
    var minGap = 10;
    if (isRackSideHandlesEnabled()) {
      adjustRackHandlePairGap($('.configurator_preview--front:first'), minGap);
      adjustRackHandlePairGap($('.configurator_preview--back:first'), minGap);
    }
  };
  var refreshRackHandlePairGaps = function refreshRackHandlePairGaps() {
    if (!isRackConfigurator()) {
      return;
    }
    adjustRackHandlePairGaps();
    if (window.requestAnimationFrame) {
      window.requestAnimationFrame(adjustRackHandlePairGaps);
    }
    window.setTimeout(adjustRackHandlePairGaps, 120);
    window.setTimeout(adjustRackHandlePairGaps, 320);
  };
  var refreshSelectedHandlePositions = function refreshSelectedHandlePositions() {
    var frontBackValue = $('input[name="handle_position"]:checked').val();
    var sideValue = $('input[name="sidehandle_position"]:checked').val();
    if (frontBackValue) {
      setHandlePosition(frontBackValue, 'configurator_preview--front');
      setHandlePosition(frontBackValue, 'configurator_preview--back');
    }
    if (sideValue) {
      setHandlePosition(sideValue, 'configurator_preview--side');
    }
    adjustMalleCapHandlePositions();
    refreshMalleBaseHandleAlignment();
    refreshRackHandlePairGaps();
    refreshValiseSideHandleAlignment();
  };
  var displayTagHolder = function displayTagHolder(isCheck) {
    var $tagHolder = $('.configurator_preview--top .configurator_preview-tagholder');
    if (isCheck) {
      $tagHolder.css('display', 'block');
    } else {
      $tagHolder.css('display', 'none');
    }
  };
  var setHandleRotate = function setHandleRotate(rotation, configuratorPreview) {
    var rotateLeft = "";
    var rotateRight = "";
    var rotateCenter = "";
    if (rotation.is(':checked')) {
      switch (configuratorPreview) {
        case 'configurator_preview--front':
          if (inputHeight > 600) {
            rotateLeft = "translateX(55%) rotate(-90deg) translateX(0%)";
            rotateCenter = "translateX(-50%) rotate(-90deg) translateX(0%)";
            rotateRight = "translateX(-55%) rotate(90deg) translateX(0%)";
          } else {
            rotateLeft = "translateX(55%) rotate(-90deg) translateX(-20%)";
            rotateCenter = "translateX(-50%) rotate(-90deg) translateX(-20%)";
            rotateRight = "translateX(-55%) rotate(90deg) translateX(20%)";
          }
          break;
        case 'configurator_preview--back':
          if (inputHeight > 600) {
            rotateLeft = "translateX(55%) rotate(-90deg) translateX(0%)";
            rotateCenter = "translateX(-50%) rotate(-90deg) translateX(0%)";
            rotateRight = "translateX(-55%) rotate(90deg) translateX(0%)";
          } else {
            rotateLeft = "translateX(55%) rotate(-90deg) translateX(-20%)";
            rotateCenter = "translateX(-50%) rotate(-90deg) translateX(-20%)";
            rotateRight = "translateX(-55%) rotate(90deg) translateX(20%)";
          }
          break;
        case 'configurator_preview--side':
          if (inputHeight > 600) {
            rotateLeft = "translateX(55%) rotate(-90deg) translateX(0%)";
            rotateCenter = "translateX(-50%) rotate(-90deg) translateX(0%)";
            rotateRight = "translateX(-55%) rotate(90deg) translateX(0%)";
          } else {
            rotateLeft = "translateX(55%) rotate(-90deg) translateX(20%)";
            rotateCenter = "translateX(-50%) rotate(-90deg) translateX(20%)";
            rotateRight = "translateX(-55%) rotate(90deg) translateX(-20%)";
          }
          break;
      }
    }
    $('.' + configuratorPreview + ' .configurator_preview-handle-left img').css('transform', rotateLeft);
    $('.' + configuratorPreview + ' .configurator_preview-handle-right img').css('transform', rotateRight);
    $('.' + configuratorPreview + ' .configurator_preview-handle-center img').css('transform', rotateCenter);
  };
  var sideLockersHideShow = function sideLockersHideShow() {
    var enabled = $('#side_lockers_side-lockers').is(':checked');
    var $sideLockers = $('.configurator_preview--side .configurator_preview-locker2').not('.configurator_preview-cap-malle-side, .configurator_preview-cap-malle-front');
    if (enabled) {
      $sideLockers.removeClass('hide');
    } else {
      $sideLockers.addClass('hide');
    }
  };
  var getRackUnitsFromCurrentDimensions = function getRackUnitsFromCurrentDimensions() {
    if (getRackMode() === 'rack-19') {
      return getRackUnits();
    }
    var parsedHeight = parseInt(inputHeight, 10);
    if (isNaN(parsedHeight)) {
      return NaN;
    }
    return Math.round(parsedHeight / rackUnitHeightMm - rackCaseHeightOffsetUnits);
  };
  var parseConfiguratorOptionNumber = function parseConfiguratorOptionNumber(value, fallback) {
    if (typeof fallback === 'undefined') {
      fallback = 0;
    }
    if (value === null || typeof value === 'undefined' || value === '') {
      return fallback;
    }
    var numberValue = parseFloat(String(value).replace(/\s/g, '').replace(',', '.'));
    return isNaN(numberValue) ? fallback : numberValue;
  };
  var getConfiguratorAccessoryOption = function getConfiguratorAccessoryOption(code) {
    var catalog = window.configurator_options && window.configurator_options.accessory_catalog;
    if (!catalog || !code) {
      return null;
    }
    if (catalog[code]) {
      return catalog[code];
    }
    if (Array.isArray(catalog)) {
      for (var index = 0; index < catalog.length; index++) {
        if (catalog[index] && catalog[index].code === code) {
          return catalog[index];
        }
      }
    }
    return null;
  };
  var getConfiguratorAccessoryUnitPrice = function getConfiguratorAccessoryUnitPrice(code, fallback) {
    var accessory = getConfiguratorAccessoryOption(code);
    if (!accessory || accessory.active === false || accessory.active === '0') {
      return fallback;
    }
    return parseConfiguratorOptionNumber(accessory.unit_price, fallback);
  };
  var getRackCapPricingUnits = function getRackCapPricingUnits() {
    var units;
    if (getRackMode() === 'rack-19') {
      units = getRackUnits();
    } else {
      var inputs = getRackMeasurementInputs();
      var parsedHeight = parseInt(inputs.height.val(), 10);
      units = isNaN(parsedHeight) ? NaN : Math.round(parsedHeight / rackUnitHeightMm - rackCaseHeightOffsetUnits);
    }
    if (isNaN(units)) {
      units = rackClassicAdditionalCapBaseUnits;
    }
    return Math.max(1, units);
  };
  var getRackClassicAdditionalCapPrice = function getRackClassicAdditionalCapPrice() {
    var units = Math.max(rackClassicAdditionalCapBaseUnits, getRackCapPricingUnits());
    var basePrice = getConfiguratorAccessoryUnitPrice('rack_cap_classic_left_base', rackClassicAdditionalCapBasePrice);
    var unitStepPrice = getConfiguratorAccessoryUnitPrice('rack_cap_classic_left_per_u', rackClassicAdditionalCapUnitStepPrice);
    return basePrice + (units - rackClassicAdditionalCapBaseUnits) * unitStepPrice;
  };
  var getRackCapPriceAdjustment = function getRackCapPriceAdjustment() {
    if (!isRackConfigurator()) {
      return 0;
    }
    var isFlatCap = $('#pa_configurateur-type-de-capot').val() === 'capot-plat';
    var hasLeftCap = $('#rack_left_cap').is(':checked');
    var flatCapAdjustment = getConfiguratorAccessoryUnitPrice('rack_cap_flat_adjustment', rackFlatCapPriceAdjustment);
    var flatCapLeftPrice = getConfiguratorAccessoryUnitPrice('rack_cap_flat_left', rackFlatCapAdditionalCapPrice);
    var price = isFlatCap ? flatCapAdjustment : 0;
    if (hasLeftCap) {
      price += isFlatCap ? flatCapLeftPrice : getRackClassicAdditionalCapPrice();
    }
    return price;
  };
  var getRackCapLockerPrice = function getRackCapLockerPrice() {
    var fallbackPrice = window.configurator_options ? parseConfiguratorOptionNumber(window.configurator_options.prix_fermoirs, 0) : 0;
    var rackDepth = parseInt(getRackDepthDimension(), 10);
    var rackUnits = getRackCapPricingUnits();
    if (!isNaN(rackUnits) && rackUnits < 4) {
      return getConfiguratorAccessoryUnitPrice('rack_locker_l903_7336', fallbackPrice);
    }
    if (shouldUseLargeRackCapLockersForHeight() || !isNaN(rackDepth) && rackDepth >= 800) {
      return getConfiguratorAccessoryUnitPrice('rack_locker_large', fallbackPrice);
    }
    return getConfiguratorAccessoryUnitPrice('rack_locker_medium', fallbackPrice);
  };
  var getRackCapLockerPricing = function getRackCapLockerPricing() {
    if (!isRackConfigurator() || $('#pa_configurateur-type-de-capot').val() === 'capot-plat') {
      return {
        count: 0,
        extraCount: 0,
        adjustment: 0
      };
    }
    var rackHeight = parseInt($('.height-input:first input[name="height_needed"]:first').val(), 10);
    var capCount = $('#rack_left_cap').is(':checked') ? 2 : 1;
    var lockersPerCap = !isNaN(rackHeight) && rackHeight >= getMinHeightForTwoMalleVerticalCapLockers() ? 2 : 1;
    var count = capCount * lockersPerCap;
    var extraCount = capCount * Math.max(0, lockersPerCap - 1);
    return {
      count: count,
      extraCount: extraCount,
      adjustment: extraCount * getRackCapLockerPrice()
    };
  };
  var syncRackCapPricing = function syncRackCapPricing() {
    if (!isRackConfigurator()) {
      return;
    }
    var price = getRackCapPriceAdjustment();
    if (window.configurator_options) {
      window.configurator_options.rack_cap_price_adjustment = price;
      var flatCapAdjustment = getConfiguratorAccessoryUnitPrice('rack_cap_flat_adjustment', rackFlatCapPriceAdjustment);
      window.configurator_options.rack_left_cap_price = $('#rack_left_cap').is(':checked') ? price - ($('#pa_configurateur-type-de-capot').val() === 'capot-plat' ? flatCapAdjustment : 0) : 0;
      var lockerPricing = getRackCapLockerPricing();
      window.configurator_options.rack_cap_locker_count = lockerPricing.count;
      window.configurator_options.rack_extra_locker_count = lockerPricing.extraCount;
      window.configurator_options.rack_extra_locker_price_adjustment = lockerPricing.adjustment;
    }
  };
  var getRackSideHandlesUseCenter = function getRackSideHandlesUseCenter() {
    if (!isRackConfigurator()) {
      return false;
    }
    var rackDepth = parseInt(getRackDepthDimension(), 10);
    var rackLength = parseInt(inputLength, 10);
    var rackUnits = getRackUnitsFromCurrentDimensions();
    if (getRackMode() === 'custom') {
      var rackTotalLength = parseInt($(rackTotalLengthInputSelector).val(), 10);
      var rackHandlePairThreshold = $('#rack_left_cap').is(':checked') ? 750 : 650;
      return isNaN(rackTotalLength) || rackTotalLength < rackHandlePairThreshold;
    }
    if (!isNaN(rackUnits) && rackUnits >= 1 && rackUnits <= 4) {
      return true;
    }
    return !isNaN(rackDepth) && rackDepth <= 600;
  };
  var getRackSideCenterHandleLeft = function getRackSideCenterHandleLeft() {
    if (!isRackConfigurator()) {
      return '50%';
    }
    var rackDepth = parseInt(getRackDepthDimension(), 10);
    var rackUnits = getRackUnitsFromCurrentDimensions();
    if (isNaN(rackDepth) || isNaN(rackUnits)) {
      return '50%';
    }
    if (rackUnits < 4 && rackDepth <= 420) {
      return '42%';
    }
    if (rackUnits >= 4 && rackDepth < 405) {
      return '40%';
    }
    return '50%';
  };
  var centerRackSidePreviewHandles = function centerRackSidePreviewHandles() {
    if (!isRackConfigurator()) {
      return;
    }
    $('.configurator_preview--side .configurator_preview-handle-center, .configurator_preview--side .configurator_preview-handle-left, .configurator_preview--side .configurator_preview-handle-right').css('top', '50%');
  };
  var getRackSingleCapSideHandleInsets = function getRackSingleCapSideHandleInsets(defaultInset) {
    if (!isRackConfigurator()) {
      return {
        left: defaultInset,
        right: defaultInset
      };
    }
    var rackDepth = parseInt(getRackDepthDimension(), 10);
    var useLongDepthSingleCapSpacing = !$('#rack_left_cap').is(':checked') && !isNaN(rackDepth) && rackDepth > 600;
    $('body').toggleClass('rack-single-cap-long-depth', useLongDepthSingleCapSpacing);
    if (!useLongDepthSingleCapSpacing) {
      return {
        left: defaultInset,
        right: defaultInset
      };
    }
    var maxHandleGapMm = 800;
    var leftSafetyOffsetMm = 160;
    var rightInsetMm = rackDepth >= 800 ? 150 : 100;
    var leftOffsetMm = Math.max(leftSafetyOffsetMm, rackDepth - rightInsetMm - maxHandleGapMm);
    var leftPercent = leftOffsetMm / rackDepth * 100;
    var rightPercent = rightInsetMm / rackDepth * 100;
    return {
      left: leftPercent.toFixed(2) + '%',
      right: Math.max(0, rightPercent).toFixed(2) + '%'
    };
  };
  var rackSideHandleLockerCollisionTimer = null;
  var rackSideHandleLayoutTransition = 'bottom 0.18s, height 0.18s, opacity 0.12s, top 0.18s, width 0.18s';
  var rackSideCapLockerLayoutTransition = 'bottom 0.18s, height 0.18s, opacity 0.12s, top 0.18s, width 0.18s';
  var getRackSideHandleContainers = function getRackSideHandleContainers() {
    return $('.configurator_preview--side:first').find('.configurator_preview-handle-center, ' + '.configurator_preview-handle-left, ' + '.configurator_preview-handle-right');
  };
  var getRackSideCapLockerContainers = function getRackSideCapLockerContainers() {
    return $('.configurator_preview--side:first').find('.cap-parts-container-capot-rack-left-side-view .configurator_preview-locker2-malle-front-side-top, ' + '.cap-parts-container-capot-rack-left-side-view .configurator_preview-locker2-malle-front-side-bottom, ' + '.cap-parts-container-capot-rack-right-side-view .configurator_preview-locker2-malle-front-side-top, ' + '.cap-parts-container-capot-rack-right-side-view .configurator_preview-locker2-malle-front-side-bottom');
  };
  var storeRackSideCapLockerCollisionBaseline = function storeRackSideCapLockerCollisionBaseline(overwrite) {
    getRackSideCapLockerContainers().each(function () {
      var $locker = $(this);
      if (overwrite || typeof $locker.data('rackHandleCollisionBaseLeft') === 'undefined') {
        $locker.data('rackHandleCollisionBaseLeft', this.style.left || '');
        $locker.data('rackHandleCollisionBaseRight', this.style.right || '');
      }
    });
  };
  var resetRackSideCapLockerCollisionOffsets = function resetRackSideCapLockerCollisionOffsets() {
    getRackSideCapLockerContainers().each(function () {
      var $locker = $(this);
      var baseLeft = $locker.data('rackHandleCollisionBaseLeft');
      var baseRight = $locker.data('rackHandleCollisionBaseRight');
      if (typeof baseLeft !== 'undefined') {
        this.style.left = baseLeft;
        this.style.right = baseRight;
      }
    });
  };
  var storeRackSideHandleCollisionBaseline = function storeRackSideHandleCollisionBaseline(overwrite) {
    getRackSideHandleContainers().each(function () {
      var $handle = $(this);
      if (overwrite || typeof $handle.data('rackLockerCollisionBaseLeft') === 'undefined') {
        $handle.data('rackLockerCollisionBaseLeft', this.style.left || '');
        $handle.data('rackLockerCollisionBaseRight', this.style.right || '');
        $handle.data('rackLockerCollisionBaseTransform', this.style.transform || '');
      }
    });
  };
  var resetRackSideHandleCollisionOffsets = function resetRackSideHandleCollisionOffsets() {
    var $handles = getRackSideHandleContainers();
    var inlineTransitions = [];
    $handles.each(function (index) {
      var $handle = $(this);
      var baseLeft = $handle.data('rackLockerCollisionBaseLeft');
      var baseRight = $handle.data('rackLockerCollisionBaseRight');
      var baseTransform = $handle.data('rackLockerCollisionBaseTransform');
      inlineTransitions[index] = this.style.transition || '';
      this.style.transition = 'none';
      if (typeof baseLeft !== 'undefined') {
        this.style.left = baseLeft;
        this.style.right = baseRight;
        this.style.transform = baseTransform || '';
      }
    });

    // Les poignées ont une transition de 180 ms sur left/right/transform.
    // Forcer la baseline sans animation garantit que les rectangles lus
    // juste après correspondent à la géométrie réelle, pas à un entre-deux.
    var sideNode = $('.configurator_preview--side:first').get(0);
    if (sideNode) {
      sideNode.offsetWidth;
    }
    $handles.each(function (index) {
      this.style.transition = inlineTransitions[index];
    });
    resetRackSideCapLockerCollisionOffsets();
  };
  var getRackSideVisibleHardwareItems = function getRackSideVisibleHardwareItems($containers) {
    return $containers.map(function () {
      var $container = $(this);
      var $image = getVisibleCustomCapHardwareImage($container);
      if (!$image.length || $container.hasClass('hide') || $container.closest('.hide').length) {
        return null;
      }
      return {
        $container: $container,
        rect: $image.get(0).getBoundingClientRect()
      };
    }).get().filter(function (item) {
      return item && item.rect.width > 0 && item.rect.height > 0;
    });
  };
  var getRackSideVisibleCapLockers = function getRackSideVisibleCapLockers($side, capSide) {
    return getRackSideVisibleHardwareItems($side.find('.cap-parts-container-capot-rack-' + capSide + '-side-view ' + '.configurator_preview-locker2-malle-front-side-top, ' + '.cap-parts-container-capot-rack-' + capSide + '-side-view ' + '.configurator_preview-locker2-malle-front-side-bottom'));
  };
  var getRackSideHandleRequiredPageDelta = function getRackSideHandleRequiredPageDelta(handleItem, lockerItems, desiredGap) {
    var handleCenter = handleItem.rect.left + handleItem.rect.width / 2;
    var requiredDelta = 0;
    $.each(lockerItems, function (index, lockerItem) {
      var verticalGap = Math.max(handleItem.rect.top - lockerItem.rect.bottom, lockerItem.rect.top - handleItem.rect.bottom);
      if (verticalGap >= desiredGap) {
        return;
      }
      var lockerCenter = lockerItem.rect.left + lockerItem.rect.width / 2;
      var currentGap;
      var nextDelta;
      if (lockerCenter < handleCenter) {
        currentGap = handleItem.rect.left - lockerItem.rect.right;
        nextDelta = Math.max(0, desiredGap - currentGap);
        requiredDelta = Math.max(requiredDelta, nextDelta);
      } else {
        currentGap = lockerItem.rect.left - handleItem.rect.right;
        nextDelta = -Math.max(0, desiredGap - currentGap);
        requiredDelta = Math.min(requiredDelta, nextDelta);
      }
    });
    return requiredDelta;
  };
  var shiftRackSidePairedHandleInward = function shiftRackSidePairedHandleInward($handle, insetProperty, pageDistance, $side, additive) {
    if (!$handle.length || !pageDistance || !$side.length) {
      return;
    }
    var sideNode = $side.get(0);
    var sideRect = sideNode.getBoundingClientRect();
    var sideWidth = Number(window.getComputedStyle(sideNode).width.replace('px', '')) || sideNode.offsetWidth || 1;
    var scaleX = sideRect.width / sideWidth;
    var logicalDirection = insetProperty === 'left' ? 1 : -1;
    var baseTransform = $handle.data('rackLockerCollisionBaseTransform') || '';
    var currentTransform = $handle.get(0).style.transform || '';
    var translationMatch = currentTransform.match(/translateX\((-?[0-9.]+)px\)/);
    var currentTranslation = additive && translationMatch ? Number(translationMatch[1]) : 0;
    var nextTranslation;
    if (!scaleX || !isFinite(scaleX)) {
      scaleX = 1;
    }
    if (!isFinite(currentTranslation)) {
      currentTranslation = 0;
    }
    nextTranslation = currentTranslation + Math.abs(pageDistance) / scaleX * logicalDirection;
    $handle.css('transform', (baseTransform ? baseTransform + ' ' : '') + 'translateX(' + nextTranslation + 'px)');
  };
  var adjustRackSideHandleLockerCollisions = function adjustRackSideHandleLockerCollisions() {
    if (!isRackConfigurator()) {
      return;
    }
    var $side = $('.configurator_preview--side:first');
    var sideNode = $side.get(0);
    if (!sideNode) {
      return;
    }
    var sideRect = sideNode.getBoundingClientRect();
    var sideWidth = Number(window.getComputedStyle(sideNode).width.replace('px', '')) || sideNode.offsetWidth || 1;
    var scaleX = sideRect.width / sideWidth;
    var gapInDisplayPixels = Number(getElementDisplaySize(10)) || 10;
    var desiredGap = gapInDisplayPixels * (scaleX || 1);
    var handleItems = getRackSideVisibleHardwareItems(getRackSideHandleContainers());
    var leftCapLockers = getRackSideVisibleCapLockers($side, 'left');
    var rightCapLockers = getRackSideVisibleCapLockers($side, 'right');
    var allCapLockers = leftCapLockers.concat(rightCapLockers);
    if (!sideRect.width || !handleItems.length || !allCapLockers.length) {
      $('body').removeClass('rack-side-handle-locker-no-fit');
      return;
    }
    if (handleItems.length === 1) {
      var centerHandle = handleItems[0];
      var minimumDelta = sideRect.left + desiredGap - centerHandle.rect.left;
      var maximumDelta = sideRect.right - desiredGap - centerHandle.rect.right;
      $.each(allCapLockers, function (index, lockerItem) {
        var verticalGap = Math.max(centerHandle.rect.top - lockerItem.rect.bottom, lockerItem.rect.top - centerHandle.rect.bottom);
        if (verticalGap >= desiredGap) {
          return;
        }
        var lockerCenter = lockerItem.rect.left + lockerItem.rect.width / 2;
        var handleCenter = centerHandle.rect.left + centerHandle.rect.width / 2;
        if (lockerCenter < handleCenter) {
          minimumDelta = Math.max(minimumDelta, lockerItem.rect.right + desiredGap - centerHandle.rect.left);
        } else {
          maximumDelta = Math.min(maximumDelta, lockerItem.rect.left - desiredGap - centerHandle.rect.right);
        }
      });
      var centerNoFit = minimumDelta > maximumDelta;
      var centerDelta = 0;
      if (!centerNoFit) {
        centerDelta = Math.max(minimumDelta, Math.min(maximumDelta, 0));
      }
      $('body').toggleClass('rack-side-handle-locker-no-fit', centerNoFit);
      if (!centerNoFit && Math.abs(centerDelta) > 0.1) {
        shiftCustomCapHardwareByPageDelta(centerHandle.$container, $side, centerDelta);
      }
      return;
    }
    var $leftHandle = $side.find('.configurator_preview-handle-left:first');
    var $rightHandle = $side.find('.configurator_preview-handle-right:first');
    var leftHandle = getRackSideVisibleHardwareItems($leftHandle)[0];
    var rightHandle = getRackSideVisibleHardwareItems($rightHandle)[0];
    if (!leftHandle || !rightHandle) {
      return;
    }
    var leftDelta = getRackSideHandleRequiredPageDelta(leftHandle, leftCapLockers, desiredGap);
    var rightDelta = getRackSideHandleRequiredPageDelta(rightHandle, rightCapLockers, desiredGap);
    var pairNoFit = false;
    if (Math.abs(leftDelta) > 0.1) {
      shiftRackSidePairedHandleInward(leftHandle.$container, 'left', leftDelta, $side);
    }
    if (Math.abs(rightDelta) > 0.1) {
      shiftRackSidePairedHandleInward(rightHandle.$container, 'right', rightDelta, $side);
    }

    // Sur la vue arrière, le miroir combine son échelle avec les
    // translations propres aux images de poignée. Deux courtes passes
    // résiduelles sur les rectangles effectivement rendus garantissent
    // la même marge qu'en vue de face, quelle que soit cette combinaison.
    for (var correctionPass = 0; correctionPass < 3; correctionPass++) {
      leftHandle = getRackSideVisibleHardwareItems($leftHandle)[0];
      rightHandle = getRackSideVisibleHardwareItems($rightHandle)[0];
      if (!leftHandle || !rightHandle) {
        break;
      }
      var residualLeftDelta = getRackSideHandleRequiredPageDelta(leftHandle, leftCapLockers, desiredGap);
      var residualRightDelta = getRackSideHandleRequiredPageDelta(rightHandle, rightCapLockers, desiredGap);
      if (Math.abs(residualLeftDelta) <= 0.1 && Math.abs(residualRightDelta) <= 0.1) {
        break;
      }
      if (Math.abs(residualLeftDelta) > 0.1) {
        shiftRackSidePairedHandleInward(leftHandle.$container, 'left', residualLeftDelta, $side, true);
      }
      if (Math.abs(residualRightDelta) > 0.1) {
        shiftRackSidePairedHandleInward(rightHandle.$container, 'right', residualRightDelta, $side, true);
      }
    }

    // Le miroir de la vue arrière inverse les deltas de page. Relire les
    // rectangles après application évite de conserver un faux état no-fit
    // alors que les poignées disposent bien de la marge demandée.
    var finalHandleItems = getRackSideVisibleHardwareItems($leftHandle.add($rightHandle)).sort(function (left, right) {
      return left.rect.left - right.rect.left;
    });
    if (finalHandleItems.length === 2) {
      var finalPairGap = finalHandleItems[1].rect.left - finalHandleItems[0].rect.right;
      if (finalPairGap < desiredGap && getRackMode() === 'custom' && !$('#rack_left_cap').is(':checked')) {
        // Les paires sont possibles plus tôt sur le Rack configurable.
        // Écarter seulement la poignée du côté sans capot, sans déplacer
        // le fermoir de sa jonction ni réduire sa marge avec la poignée.
        var freeHandleIndex = finalHandleItems[0].$container.get(0) === $leftHandle.get(0) ? 0 : 1;
        var freeHandle = finalHandleItems[freeHandleIndex];
        var freeHandleDirection = freeHandleIndex === 0 ? -1 : 1;
        var freeHandleCorrection = desiredGap - finalPairGap + 0.5;
        var freeHandleAvailable = freeHandleIndex === 0 ? freeHandle.rect.left - sideRect.left - desiredGap : sideRect.right - freeHandle.rect.right - desiredGap;
        if (freeHandleAvailable >= freeHandleCorrection) {
          shiftCustomCapHardwareByPageDelta(freeHandle.$container, $side, freeHandleDirection * freeHandleCorrection * getCustomCapHardwareHorizontalDirection(sideNode, sideNode.parentElement));
          finalHandleItems = getRackSideVisibleHardwareItems($leftHandle.add($rightHandle)).sort(function (left, right) {
            return left.rect.left - right.rect.left;
          });
          finalPairGap = finalHandleItems[1].rect.left - finalHandleItems[0].rect.right;
        }
      }
      if (finalPairGap < desiredGap && leftCapLockers.length && rightCapLockers.length) {
        // Un demi-pixel visuel de garde absorbe les arrondis entre
        // SVG, zoom et transform sans modifier la géométrie métier.
        var outwardCorrection = (desiredGap - finalPairGap) / 2 + 0.25;
        var lockerGroups = [leftCapLockers, rightCapLockers].sort(function (leftGroup, rightGroup) {
          var leftCenter = leftGroup.reduce(function (total, item) {
            return total + item.rect.left + item.rect.width / 2;
          }, 0) / leftGroup.length;
          var rightCenter = rightGroup.reduce(function (total, item) {
            return total + item.rect.left + item.rect.width / 2;
          }, 0) / rightGroup.length;
          return leftCenter - rightCenter;
        });
        var pairViewDirection = getRackMode() === 'custom' ? getCustomCapHardwareHorizontalDirection(sideNode, sideNode.parentElement) : 1;
        shiftCustomCapHardwareByPageDelta(finalHandleItems[0].$container, $side, -outwardCorrection * pairViewDirection);
        shiftCustomCapHardwareByPageDelta(finalHandleItems[1].$container, $side, outwardCorrection * pairViewDirection);
        $.each(lockerGroups[0], function (index, lockerItem) {
          shiftCustomCapHardwareByPageDelta(lockerItem.$container, $side, -outwardCorrection * pairViewDirection);
        });
        $.each(lockerGroups[1], function (index, lockerItem) {
          shiftCustomCapHardwareByPageDelta(lockerItem.$container, $side, outwardCorrection * pairViewDirection);
        });
        finalHandleItems = getRackSideVisibleHardwareItems($leftHandle.add($rightHandle)).sort(function (left, right) {
          return left.rect.left - right.rect.left;
        });
        finalPairGap = finalHandleItems[1].rect.left - finalHandleItems[0].rect.right;
      }
      pairNoFit = finalPairGap < desiredGap;
    }
    $('body').toggleClass('rack-side-handle-locker-no-fit', pairNoFit);
  };
  var refreshRackSideHandleLockerCollisions = function refreshRackSideHandleLockerCollisions() {
    if (!isRackConfigurator()) {
      return;
    }
    var applyRackSideHandleLockerLayout = function applyRackSideHandleLockerLayout() {
      resetRackSideHandleCollisionOffsets();
      adjustRackSideHandleLockerCollisions();
    };
    window.clearTimeout(rackSideHandleLockerCollisionTimer);
    applyRackSideHandleLockerLayout();
    if (window.requestAnimationFrame) {
      window.requestAnimationFrame(applyRackSideHandleLockerLayout);
    }
    rackSideHandleLockerCollisionTimer = window.setTimeout(applyRackSideHandleLockerLayout, 320);
  };
  var adjustMalleCapHandlePositions = function adjustMalleCapHandlePositions() {
    var setHandleDisplayMode = function setHandleDisplayMode($views, useCenter) {
      $views.each(function () {
        var $view = $(this);
        if (useCenter) {
          $view.find('.configurator_preview-handle-center').removeClass('hide').css('display', '');
          $view.find('.configurator_preview-handle-left, .configurator_preview-handle-right').addClass('hide').css('display', 'none');
        } else {
          $view.find('.configurator_preview-handle-center').addClass('hide').css('display', 'none');
          if (isRackConfigurator() || currentConfiguratorPartsSize === 'large') {
            $view.find('.configurator_preview-handle-left, .configurator_preview-handle-right').removeClass('hide').css('display', '');
          }
        }
      });
    };
    var $frontCapInput = $('input[value="config-capot-avant"]');
    var $sideCapInput = $('input[value="config-capot-lat"]');
    if (isRackConfigurator()) {
      var $rackSideHandles = getRackSideHandleContainers();

      // Poser d'abord la liste de transitions sans `transform`, puis
      // restaurer la baseline. Dans l'ordre inverse, le navigateur
      // démarre encore l'ancienne transition de 180 ms et le miroir
      // mesure une poignée à mi-chemin.
      $rackSideHandles.css('transition', rackSideHandleLayoutTransition);
      $rackSideHandles.css('transform', '');
      var rackSideNode = $('.configurator_preview--side:first').get(0);
      if (rackSideNode) {
        rackSideNode.offsetWidth;
      }
    }
    if (!$frontCapInput.length && !$sideCapInput.length) {
      if (isRackConfigurator()) {
        var rackSingleCapSideHandleInsets = getRackSingleCapSideHandleInsets('0');
        $('.configurator_preview--side .configurator_preview-handle-center').css({
          left: getRackSideCenterHandleLeft(),
          right: ''
        });
        $('.configurator_preview--front .configurator_preview-handle-center, .configurator_preview--back .configurator_preview-handle-center').css('left', '50%');
        $('.configurator_preview--side .configurator_preview-handle-left').css({
          left: rackSingleCapSideHandleInsets.left,
          right: ''
        });
        $('.configurator_preview--side .configurator_preview-handle-right').css({
          left: '',
          right: rackSingleCapSideHandleInsets.right
        });
        centerRackSidePreviewHandles();
        setHandleDisplayMode($('.configurator_preview--side'), getRackSideHandlesUseCenter());
        if (isRackSideHandlesEnabled()) {
          setHandleDisplayMode($('.configurator_preview--front, .configurator_preview--back'), getRackFrontBackHandlesUseCenter());
          setHandlePosition(getRackSideHandlePositionValue(), 'configurator_preview--front');
          setHandlePosition(getRackSideHandlePositionValue(), 'configurator_preview--back');
        } else {
          $('.configurator_preview--front, .configurator_preview--back').find('.configurator_preview-handle-center, .configurator_preview-handle-left, .configurator_preview-handle-right').addClass('hide').css('display', 'none');
        }
        storeRackSideHandleCollisionBaseline(true);
        refreshRackSideHandleLockerCollisions();
        refreshRackHandlePairGaps();
      }
      return;
    }
    var frontChecked = $frontCapInput.is(':checked');
    var sideChecked = $sideCapInput.is(':checked');
    var sideBaseInset = Math.min(inputWidth) >= 1000 ? '10%' : '0';
    var frontBackBaseInset = Math.min(inputLength) >= 1500 ? '20%' : Math.min(inputLength) >= 1000 ? '10%' : '0';
    var frontBackCapInset = Math.min(inputLength) >= 1500 ? '12%' : Math.min(inputLength) >= 1000 ? '10%' : '8%';
    var sideCapInset = Math.min(inputWidth) >= 1000 ? '10%' : '8%';
    var singleCapLockerMode = Math.min(inputHeight) < getMinHeightForTwoMalleVerticalCapLockers();
    var capHandleCenterThreshold = 625;
    var sideSingleLockerInset = Math.min(inputWidth) < 800 ? '10%' : Math.min(inputWidth) >= 1000 ? '18%' : '16%';
    var frontBackSingleLockerInset = Math.min(inputLength) < 800 ? '10%' : Math.min(inputLength) >= 1500 ? '18%' : '16%';
    var sideDoubleLockerInset = Math.min(inputWidth) < 800 ? '10%' : '16%';
    var frontBackDoubleLockerInset = Math.min(inputLength) < 800 ? '10%' : '16%';
    var sideHandleInset = frontChecked ? singleCapLockerMode ? sideSingleLockerInset : sideDoubleLockerInset : sideBaseInset;
    var frontBackHandleInset = sideChecked ? singleCapLockerMode ? frontBackSingleLockerInset : frontBackDoubleLockerInset : frontBackBaseInset;
    var sideWidthIsNarrow = parseInt(inputWidth, 10) < 600;
    var frontBackLengthIsNarrow = parseInt(inputLength, 10) < 600;
    var sideHandlesUseCenter = isRackConfigurator() ? getRackSideHandlesUseCenter() : sideWidthIsNarrow || frontChecked && Math.min(inputWidth) <= capHandleCenterThreshold;
    var frontBackHandlesUseCenter = isRackConfigurator() ? getRackFrontBackHandlesUseCenter() : frontBackLengthIsNarrow || sideChecked && Math.min(inputLength) <= capHandleCenterThreshold;
    var rackSingleCapSideHandleInsets = isRackConfigurator() ? getRackSingleCapSideHandleInsets(sideHandleInset) : {
      left: sideHandleInset,
      right: sideHandleInset
    };
    $('.configurator_preview--side .configurator_preview-handle-center').css({
      left: getRackSideCenterHandleLeft(),
      right: ''
    });
    $('.configurator_preview--front .configurator_preview-handle-center, .configurator_preview--back .configurator_preview-handle-center').css('left', '50%');
    $('.configurator_preview--side .configurator_preview-handle-left').css({
      left: rackSingleCapSideHandleInsets.left,
      right: ''
    });
    $('.configurator_preview--side .configurator_preview-handle-right').css({
      left: '',
      right: rackSingleCapSideHandleInsets.right
    });
    centerRackSidePreviewHandles();
    $('.configurator_preview--front .configurator_preview-handle-left, .configurator_preview--back .configurator_preview-handle-left').css('left', frontBackHandleInset);
    $('.configurator_preview--front .configurator_preview-handle-right, .configurator_preview--back .configurator_preview-handle-right').css('right', frontBackHandleInset);
    if (isRackConfigurator()) {
      setHandleDisplayMode($('.configurator_preview--side'), sideHandlesUseCenter);
    }
    if (isRackConfigurator() && !isRackSideHandlesEnabled()) {
      $('.configurator_preview--front, .configurator_preview--back').find('.configurator_preview-handle-center, .configurator_preview-handle-left, .configurator_preview-handle-right').addClass('hide').css('display', 'none');
    } else {
      if (isRackConfigurator()) {
        setHandleDisplayMode($('.configurator_preview--front, .configurator_preview--back'), frontBackHandlesUseCenter);
        setHandlePosition(getRackSideHandlePositionValue(), 'configurator_preview--front');
        setHandlePosition(getRackSideHandlePositionValue(), 'configurator_preview--back');
      } else {
        setHandleDisplayMode($('.configurator_preview--side'), sideHandlesUseCenter);
      }
    }
    if (!isRackConfigurator() && $('#handle_customs_add-sidehandle').is(':checked')) {
      setHandleDisplayMode($('.configurator_preview--front, .configurator_preview--back'), frontBackHandlesUseCenter);
    } else if (!isRackConfigurator()) {
      sideHandleHideShow(false);
    }
    storeRackSideHandleCollisionBaseline(true);
    refreshRackSideHandleLockerCollisions();
    refreshRackHandlePairGaps();
  };
  var handleExceptions = function handleExceptions() {
    $(document).on('change', '#length_needed, #width_needed, #height_needed, #rack_depth_mm, #rack_cap_depth_mm, #rack_rear_cap_depth_mm, #pa_configurateur-type-de-capot', function () {
      exceptionCapotPlat();
      checkHandlesLockersCompatibility();
    });
    $(document).on('change', '#length_needed, #width_needed, #height_needed', function (event) {
      runFlightRatioWhenDimensionFieldsBlurred(event);
    });
    $(document).on('blur', '#length_needed, #width_needed, #height_needed', function (event) {
      runFlightRatioWhenDimensionFieldsBlurred(event);
    });
    // trolley
    $(document).on('change', '#length_needed, #width_needed, #height_needed, #capot_height_mm, #pa_configurateur-trolley', function () {
      exceptionTrolley();
    });
    // exeception fermoir pap avec poignee
    $(document).on('change', '#length_needed, #pa_configurateur-fermoirs, #pa_configurateur-poignees', function () {
      checkHandlesLockersCompatibility();
    });
    $(document).on('change', '#height_needed', function () {
      exceptionHandlePositionEnabled();
      checkHandlesLockersCompatibility();
    });
    $(document).on('change', '#handle_customs_add-sidehandle', function () {
      exceptionHandlePositionEnabled();
    });
  };
  var exceptionNotification = function exceptionNotification(message) {
    $('body').trigger('notifier.hideMessages');
    notifier.addMessage(message);
  };
  var exceptionCapotPlat = function exceptionCapotPlat() {
    var $myInputCapot = $('#pa_configurateur-type-de-capot');
    var $myWidthValue = parseInt($('.width-input:first input[name="width_needed"]:first').val());
    var $myLengthValue = parseInt($('.length-input:first input[name="length_needed"]:first').val());
    //var $myHeightValue = parseInt($('.height-input:first input[name="height_needed"]:first').val());

    if ($myInputCapot.val() === 'capot-plat' && ($myWidthValue > 600 || $myLengthValue > 1200)) {
      exceptionNotification("Impossible de configurer un capot plat avec ces dimensions <br/><b>(Longueur : 1200mm, largeur 600mm maximum)</b>");
      $myInputCapot.val('capot-amovible').trigger('change');
    }
    syncRackCapTypeAvailability();
    var isRackFlatCap = isRackConfigurator();
    var useSingleFlatCapLocker = isRackFlatCap ? $myWidthValue <= 700 : $myLengthValue < 600;
    if (useSingleFlatCapLocker) {
      $(".configurator_preview-hole-top-left").css('left', '50%');
      $(".configurator_preview-hole-top-left img").css('transform', 'translate(-50%, 50%)');
      $(".configurator_preview-hole-top-right").css('display', 'none');
      if (isRackFlatCap) {
        $(".configurator_preview-hole2-bottom-left").css('left', '0');
        $(".configurator_preview-hole2-bottom-left img").css('transform', 'translate(100%, -400%)');
        $(".configurator_preview-hole2-bottom-right").css('display', '');
        $(".configurator_preview-hole2-bottom-right img").css('transform', 'translate(-100%, -400%)');
      } else {
        $(".configurator_preview-hole2-bottom-left").css('left', '50%');
        $(".configurator_preview-hole2-bottom-left img").css('transform', 'translate(-50%, -400%)');
        $(".configurator_preview-hole2-bottom-right").css('display', 'none');
      }
    } else {
      $(".configurator_preview-hole-top-left").css('left', '0');
      $(".configurator_preview-hole2-bottom-left").css('left', '0');
      $(".configurator_preview-hole-top-left img").css('transform', 'translate(100%, 50%)');
      $(".configurator_preview-hole2-bottom-left img").css('transform', 'translate(100%, -400%)');
      $(".configurator_preview-hole-top-right").css('display', '');
      $(".configurator_preview-hole2-bottom-right").css('display', '');
      $(".configurator_preview-hole2-bottom-right img").css('transform', 'translate(-100%, -400%)');
    }
  };

  // trolley exception
  var exceptionTrolley = function exceptionTrolley() {
    var $inputTrolley = $('#pa_configurateur-trolley');
    var width = parseInt($('.width-input:first input[name="width_needed"]').val(), 10);
    var length = parseInt($('.length-input:first input[name="length_needed"]').val(), 10);
    var height = parseInt($('.height-input:first input[name="height_needed"]').val(), 10);
    var capHeight = parseInt($(customCapHeightInputSelector).val(), 10);
    var isTrolley = $inputTrolley.val() === 'trolley-roul';

    // Adjust trolley option pricing for large cases
    var $trolleyOption = $inputTrolley.find('option[value="trolley-roul"]');
    if ($trolleyOption.length) {
      var basePrice = $trolleyOption.attr('data-price-default') || $trolleyOption.attr('data-price');
      $trolleyOption.attr('data-price-default', basePrice);
      if (length >= 900) {
        $trolleyOption.attr('data-price', 65);
      } else if (basePrice) {
        $trolleyOption.attr('data-price', basePrice);
      }
    }
    var minHeight = 0;
    var trolleyHandleMinHeight = 0;
    if (isValiseCustomCapHeightConfigurator()) {
      if (isNaN(capHeight)) {
        capHeight = getCustomCapHeightDefault();
      }
      minHeight = valiseTrolleyMinimumHeight;
      trolleyHandleMinHeight = capHeight + valiseCustomCapVisualOffset + valiseTrolleyHandleClearance;
    }
    var valid = width >= 310 && width <= 1000 && length >= 600 && length <= 2000;
    if (isTrolley && minHeight > 0 && (isNaN(height) || height < minHeight)) {
      valid = false;
    }
    if (isTrolley && !valid) {
      var msg = "Impossible de configurer un trolley avec ces dimensions <br/><b>(Longueur : 600 à 2000mm, largeur : 310 à 1000mm";
      if (minHeight > 0) {
        msg += ", hauteur : " + minHeight + "mm minimum";
      }
      msg += ")</b>";
      if (isValiseCustomCapHeightConfigurator()) {
        msg += "<br/><small>Les roulettes trolley sont disponibles à partir de 200 mm de hauteur. La poignée trolley est ajoutée uniquement si la longueur est inférieure à 900 mm et si la hauteur disponible le permet.</small>";
      }
      exceptionNotification(msg);
      $inputTrolley.val('any-trolley-roul').trigger('change');
    }
    var trolleyWithoutHandle = length >= 900;
    if (isValiseCustomCapHeightConfigurator() && trolleyHandleMinHeight > 0) {
      trolleyWithoutHandle = trolleyWithoutHandle || height < trolleyHandleMinHeight;
    }
    var hideHandle = !isTrolley || !valid || trolleyWithoutHandle;
    var hideWheel = !isTrolley || !valid;
    var hidePieds = !isTrolley || !valid;
    $('.js--set-handle-trolley').toggleClass('hide', hideHandle);
    $('.js--set-wheel-angle').toggleClass('hide', hideWheel);
    $('.js--set-pieds-plast').toggleClass('hide', hidePieds);
    var $trolleyOpt = $('#options_trolley_roulettes');
    if (isTrolley && valid && trolleyWithoutHandle) {
      $trolleyOpt.attr('data-price', 55).val(55);
    } else {
      $trolleyOpt.attr('data-price', 100).val(100);
    }
  };
  var isDimensionOrientationFieldFocused = function isDimensionOrientationFieldFocused() {
    return $(document.activeElement).is('#length_needed, #width_needed, #height_needed');
  };
  var runFlightRatioWhenDimensionFieldsBlurred = function runFlightRatioWhenDimensionFieldsBlurred(event) {
    clearTimeout(dimensionOrientationBlurTimer);
    if (event && $(event.relatedTarget).is('#length_needed, #width_needed, #height_needed')) {
      return;
    }
    dimensionOrientationBlurTimer = setTimeout(function () {
      if (!isDimensionOrientationFieldFocused()) {
        exceptionFlightRatio({
          force: true
        });
      }
    }, 200);
  };
  var exceptionFlightRatio = function exceptionFlightRatio(options) {
    options = options || {};
    if (isRackConfigurator() && getRackMode() === 'rack-19') {
      return;
    }
    if (isSwappingLengthWidth) {
      return;
    }
    var $myInputLength = $("#length_needed");
    var $myInputWidth = $("#width_needed");
    var lengthValue = parseInt($myInputLength.val(), 10);
    var widthValue = parseInt($myInputWidth.val(), 10);
    var maxPlateShortSide = 1224;
    var adjusted = false;
    var swapped = false;
    var limited = false;
    if (isNaN(widthValue) || isNaN(lengthValue)) {
      return;
    }

    // Rack axes describe the cap openings and must not be swapped.
    // Keep the independent panel-width limit below for custom racks.
    if (!isRackConfigurator() && widthValue > lengthValue) {
      if (!options.force && isDimensionOrientationFieldFocused()) {
        return;
      }
      $myInputLength.val(widthValue);
      $myInputWidth.val(lengthValue);
      widthValue = parseInt($myInputWidth.val(), 10);
      adjusted = true;
      swapped = true;
    }
    if (widthValue > maxPlateShortSide) {
      $myInputWidth.val(maxPlateShortSide);
      adjusted = true;
      limited = true;
    }
    if (!adjusted) {
      return;
    }
    isSwappingLengthWidth = true;
    if (limited) {
      exceptionNotification("Largeur ajustée : avec une plaque bois <b>2500 x 1250 mm</b>, la largeur maximale possible est <b>1224 mm</b>.");
    } else if (swapped) {
      exceptionNotification("Dimensions inversées automatiquement : la plus grande dimension a été placée en longueur pour respecter le sens de la plaque bois.");
    }
    setTimeout(function () {
      $myInputLength.add($myInputWidth).trigger("input").trigger("change");
      isSwappingLengthWidth = false;
    }, 0);
  };
  var exceptionHandlePositionEnabled = function exceptionHandlePositionEnabled() {
    if (isValisePricingV2Enabled()) {
      syncValiseSideHandleOptionState();
      return;
    }
    var $myHeightValue = parseInt($('.height-input:first input[name="height_needed"]:first').val());
    if ($myHeightValue >= 600) {
      $('.handle_position').removeClass('hide');
    } else {
      if ($('.handle_position').length > 0) {
        $('input#sidehandle_position_center-position').prop("checked", true).trigger("click");
        $('input#handle_position_center-position').prop("checked", true).trigger("click");
        $('.handle_position').addClass('hide');
      }
    }
  };
  var checkHandlesLockersCompatibility = function checkHandlesLockersCompatibility() {
    var length = parseInt($('.length-input:first input[name="length_needed"]:first').val());
    var width = parseInt($('.width-input:first input[name="width_needed"]:first').val(), 10);
    var height = parseInt($('.height-input:first input[name="height_needed"]:first').val(), 10);
    if (isNaN(width)) {
      width = 0;
    }
    if (isNaN(height)) {
      height = 0;
    }
    var handle = $('#pa_configurateur-poignees').val();
    var locker = $lockerSelect.val();
    var sideHandleChecked = $('#handle_customs_add-sidehandle').is(':checked');
    var $sideHandleRow = $('#handle_customs_add-sidehandle').closest('tr');
    var notice = "L’accessoire sélectionné est incompatible avec les dimensions. Il a été automatiquement remplacé ou désactivé.";
    syncMalleStandardFrontHandleAvailability(true);
    sideHandleChecked = $('#handle_customs_add-sidehandle').is(':checked');

    // Reset lockers availability
    $grenouilleSimple.prop('disabled', false);
    $grenouilleClef.prop('disabled', false);
    $papillon.prop('disabled', false);
    $lockerSelect.trigger('change.select2');

    // Height based restrictions
    if (height < 180) {
      $grenouilleSimple.prop('disabled', true);
      $papillon.prop('disabled', true);
      if (locker === 'fermoir-papillon' || locker === 'fermoir-grenouille-simple') {
        $lockerSelect.val('fermoir-grenouille-a-clef').trigger('change');
      } else {
        $lockerSelect.trigger('change.select2');
      }
    } else if (height < 200) {
      $papillon.prop('disabled', true);
      if (locker === 'fermoir-papillon') {
        $lockerSelect.val('fermoir-grenouille-a-clef').trigger('change');
      } else {
        $lockerSelect.trigger('change.select2');
      }
    }
    if (handle === 'poignee-retractable' && locker === 'fermoir-papillon' && length < 670) {
      $lockerSelect.val('fermoir-grenouille-a-clef').trigger('change');
      exceptionNotification(notice);
    }
    if ((handle === 'poignee-de-surface' || handle === 'poignee-cuir') && locker === 'fermoir-papillon' && length < 500) {
      $lockerSelect.val('fermoir-grenouille-a-clef').trigger('change');
      exceptionNotification(notice);
    }
    if (handle === 'poignee-retractable' && (locker === 'fermoir-grenouille-a-clef' || locker === 'fermoir-grenouille-simple') && length < 515) {
      $('#pa_configurateur-poignees').val('poignee-de-surface').trigger('change');
      exceptionNotification(notice);
    }
    if (height <= 350 && sideHandleChecked && locker === 'fermoir-papillon') {
      $lockerSelect.val('fermoir-grenouille-a-clef').trigger('change');
      exceptionNotification(notice);
    }
    if (height <= 310 && sideHandleChecked && (locker === 'fermoir-grenouille-a-clef' || locker === 'fermoir-grenouille-simple')) {
      $('#handle_customs_add-sidehandle').prop('checked', false).trigger('change');
      $sideHandleRow.addClass('hide');
      exceptionNotification(notice);
    } else {
      $sideHandleRow.removeClass('hide');
    }

    // Restrictions pour les capots supplémentaires (minimum 350mm de hauteur)
    var $capotAvant = $('input[value="config-capot-avant"]');
    var $capotLat = $('input[value="config-capot-lat"]');
    if (height < 350) {
      var needNotifyCapot = false;
      if ($capotAvant.is(':checked')) {
        $capotAvant.prop('checked', false).trigger('change');
        needNotifyCapot = true;
      }
      if ($capotLat.is(':checked')) {
        $capotLat.prop('checked', false).trigger('change');
        needNotifyCapot = true;
      }
      $capotAvant.prop('disabled', true);
      $capotLat.prop('disabled', true);
      $capotAvant.closest('label').css('opacity', '0.5');
      $capotLat.closest('label').css('opacity', '0.5');
      if (needNotifyCapot) {
        exceptionNotification("Impossible d'ajouter un capot supplémentaire (avant ou latéral) sur un flightcase <b>inférieur à 350mm de hauteur</b>.");
      }
    } else {
      $capotAvant.prop('disabled', false);
      $capotLat.prop('disabled', false);
      $capotAvant.closest('label').css('opacity', '1');
      $capotLat.closest('label').css('opacity', '1');
    }
    var capType = $('#pa_configurateur-type-de-capot').val();
    var effectiveCapType = capType || 'capot-sur-charnieres';
    var frontCapAllowed = effectiveCapType === 'capot-amovible' || effectiveCapType === 'capot-sur-charnieres';
    var sideCapAllowed = effectiveCapType === 'capot-amovible';
    if (!frontCapAllowed) {
      var notifyFrontCap = false;
      if ($capotAvant.is(':checked')) {
        $capotAvant.prop('checked', false).trigger('change');
        notifyFrontCap = true;
      }
      $capotAvant.prop('disabled', true);
      $capotAvant.closest('label').css('opacity', '0.5');
      if (notifyFrontCap) {
        exceptionNotification("Impossible d'ajouter un capot en façade avec un <b>capot plat</b>.");
      }
    } else if (width > 0 && width < 380) {
      var notifySmallFrontCap = false;
      if ($capotAvant.is(':checked')) {
        $capotAvant.prop('checked', false).trigger('change');
        notifySmallFrontCap = true;
      }
      $capotAvant.prop('disabled', true);
      $capotAvant.closest('label').css('opacity', '0.5');
      if (notifySmallFrontCap) {
        exceptionNotification("Impossible d'ajouter un capot en façade sur un flightcase <b>inférieur à 380mm de largeur</b>.");
      }
    }
    if (!sideCapAllowed) {
      var notifySideCap = false;
      if ($capotLat.is(':checked')) {
        $capotLat.prop('checked', false).trigger('change');
        notifySideCap = true;
      }
      $capotLat.prop('disabled', true);
      $capotLat.closest('label').css('opacity', '0.5');
      if (notifySideCap) {
        exceptionNotification("Impossible d'ajouter un capot latéral avec un <b>capot plat</b> ou un <b>capot sur charnières</b>. Choisissez un <b>capot amovible</b>.");
      }
    }
  };
  var malleCapHideShow = function malleCapHideShow() {
    if (isRackConfigurator()) {
      syncRackCapPreview();
      return;
    }
    var frontChecked = $('input[value="config-capot-avant"]').is(':checked');
    var sideChecked = $('input[value="config-capot-lat"]').is(':checked');
    var $malleCapFrontView = $('.cap-parts-container-capot-malle-front .configurator_preview-cap-malle-front');
    var $malleCapFrontSideView = $('.cap-parts-container-capot-malle-front-side-view .configurator_preview-cap-malle-front');
    var $malleCapSide = $('.cap-parts-container-capot-malle-side-front-view .configurator_preview-cap-malle-side, .cap-parts-container-capot-malle-side-back-view .configurator_preview-cap-malle-side');
    var $malleCapSideSideView = $('.cap-parts-container-capot-malle-side:not(.cap-parts-container-capot-malle-side-front-view):not(.cap-parts-container-capot-malle-side-back-view) .configurator_preview-cap-malle-side');
    var inputHeight = parseInt($('.height-input:first input[name="height_needed"]:first').val());
    $malleCapFrontView.css('display', 'none');
    $malleCapSideSideView.css('display', 'none');
    $('.configurator_preview-locker2-malle-front-left').removeClass('small-container');
    $('.configurator_preview-locker2-malle-front-right').css('display', 'none');
    $('.configurator_preview-locker2-malle-side-left').removeClass('small-container').css('display', 'none');
    $('.configurator_preview-locker2-malle-side-right').css('display', 'none');
    if (frontChecked) {
      $malleCapFrontSideView.css('display', 'block');
    } else {
      $malleCapFrontSideView.css('display', 'none');
    }
    if (sideChecked) {
      $malleCapSide.css('display', 'block');
      // Side capot vertical line depends on the remaining room below the cap height.
      if (inputHeight < getMinHeightForTwoMalleVerticalCapLockers()) {
        $('.configurator_preview-locker2-malle-side-vertical-top').addClass('small-container');
        $('.configurator_preview-locker2-malle-side-vertical-bottom').css('display', 'none');
      } else {
        $('.configurator_preview-locker2-malle-side-vertical-top').removeClass('small-container');
        $('.configurator_preview-locker2-malle-side-vertical-bottom').css('display', 'block');
      }
      $('.configurator_preview-locker2-malle-side-left').removeClass('small-container').css('display', 'none');
      $('.configurator_preview-locker2-malle-side-right').css('display', 'none');
    } else {
      $malleCapSide.css('display', 'none');
    }
  };

  /*
   * Events
   */
  $(document).ready(function () {
    if ($('body.single-configurator').length > 0) {
      init();
      handleExceptions();
      if (isValiseCustomCapHeightConfigurator()) {
        restoreInitialValiseCustomCapHeight();
        syncValisePanelRuleFromSelection();
        window.setTimeout(restoreInitialValiseCustomCapHeight, 250);
        window.setTimeout(restoreInitialValiseCustomCapHeight, 800);
        $(document).on('click.valiseCustomCapHeight', '.variations_form .reset_variations', function () {
          $(customCapHeightInputSelector).removeData('customCapHeightUserEdited');
          valiseLastMaterialSlug = '';
          window.setTimeout(function () {
            restoreInitialValiseCustomCapHeight();
            syncValisePanelRuleFromSelection();
          }, 0);
        });
        $(document).on('reset_data.valiseCustomCapHeight', '.variations_form', function () {
          valiseLastMaterialSlug = '';
          window.setTimeout(function () {
            prepareValiseCapTypeField();
            applyValiseCapTypeVisualState();
            restoreInitialValiseCustomCapHeight();
            syncValisePanelRuleFromSelection();
          }, 0);
        });
      }
      exceptionTrolley();
      setTimeout(function () {
        $('#pa_configurateur-trolley').trigger('change');
      });
      $('#conex-calculated-price').trigger('wc-measurement-price-calculator-product-price-change');

      // Initialize locker options
      $lockerSelect = $('#pa_configurateur-fermoirs');
      $grenouilleSimple = $lockerSelect.find('option[value="fermoir-grenouille-simple"]');
      $grenouilleClef = $lockerSelect.find('option[value="fermoir-grenouille-a-clef"]');
      $papillon = $lockerSelect.find('option[value="fermoir-papillon"]');
      checkHandlesLockersCompatibility();
      $(document).on('change select2:select', '#wheels', function () {
        wheelsHideShow();
        refreshConfiguratorViewButtonPosition();
        window.setTimeout(refreshConfiguratorViewButtonPosition, 700);
        $('#conex-calculated-price').trigger('wc-measurement-price-calculator-product-price-change');
      });
      $(document).on('woocommerce_update_variation_values.mobility', '.variations_form', function () {
        window.setTimeout(prepareMobilityField, 0);
      });
      $('#customs_all-black').on('change', function () {
        blackParts($(this));
      });
      $('#customs_engraving').on('change', function () {
        checkEngraving($(this));
      });
      $('#pa_configurateur-type-de-capot').on('change', function () {
        if (isValiseConfigurator()) {
          prepareValiseCapTypeField();
          applyValiseCapTypeVisualState();
        } else {
          setCapParts($(this).val());
        }
        syncCustomCapHeightField(true);
        if ($(this).val() === 'capot-plat') {
          $('#pa_configurateur-coins').val("coins-plats").trigger('change').next('.select2').hide();
        } else if (!isRackConfigurator()) {
          $('#pa_configurateur-coins').val("coins-boules").trigger('change').next('.select2').show();
        } else {
          $('#pa_configurateur-coins').next('.select2').show();
        }
        syncRackCornerAvailability();
        applyFlatCapVisualState();
        checkHandlesLockersCompatibility();
        malleCapHideShow();
        setCaseValues();
        setNbrLockers();
      });
      $('#pa_configurateur-poignees').on('change', function () {
        setCapParts($(this).val());
        checkHandlesLockersCompatibility();
      });
      $('#pa_configurateur-fermoirs').on('change', function () {
        setCapParts($(this).val());
        checkHandlesLockersCompatibility();
      });
      $('#pa_configurateur-coins').on('change', function () {
        if (isRackConfigurator() && $('#pa_configurateur-type-de-capot').val() === 'capot-plat' && $(this).val() !== 'coins-plats') {
          $(this).val('coins-plats').trigger('change.select2');
        }
        setCapParts($(this).val());
        applyFlatCapVisualState();
      });
      $('input[name="handle_position"]').on('click', function () {
        var value = $('input[name="handle_position"]:checked').val();
        setHandlePosition(value, 'configurator_preview--front');
        setHandlePosition(value, 'configurator_preview--back');
        adjustMalleCapHandlePositions();
        refreshMalleBaseHandleAlignment();
      });
      $('#customs_label-holder').on('click', function () {
        displayTagHolder($(this).is(':checked'));
      });
      $('input[name="sidehandle_position"]').on('click', function () {
        var value = $('input[name="sidehandle_position"]:checked').val();
        setHandlePosition(value, 'configurator_preview--side');
        adjustMalleCapHandlePositions();
        refreshMalleBaseHandleAlignment();
      });
      $('#handle_customs_rotate-handle').on('click', function () {
        setHandleRotate($(this), 'configurator_preview--front');
        setHandleRotate($(this), 'configurator_preview--back');
      });
      $('#handle_customs_rotate-sidehandle').on('click', function () {
        setHandleRotate($(this), 'configurator_preview--side');
      });
      $('#handle_customs_add-sidehandle').on('change', function () {
        sideHandleHideShow($(this).is(':checked'));
        checkSideHandleLabel($(this));
        setNbrHandles();
        refreshSelectedHandlePositions();
        checkHandlesLockersCompatibility();
      });
      $('#capot_double_cloche').on('change', function () {
        doubleCapHideShow($(this).is(':checked'));
        setCaseValues();
        setNbrLockers();
        scheduleCustomCapHandleCollisionLayout();
      });
      $('#cap_handle_customs_add-cap-sidehandle, #cap_handle_customs_add-cap-fronthandle').on('change', function () {
        positionCustomCapHandles();
        scheduleCustomCapHandleCollisionLayout();
        setNbrHandles();
        $('#conex-calculated-price').trigger('wc-measurement-price-calculator-product-price-change');
      });
      $('input[value="config-capot-avant"], input[value="config-capot-lat"]').on('change', function () {
        if ($(this).is(':checked')) {
          if ($(this).val() === 'config-capot-avant') {
            $('input[value="config-capot-lat"]').prop('checked', false);
          } else {
            $('input[value="config-capot-avant"]').prop('checked', false);
          }
        }
        malleCapHideShow();
        setCaseValues();
        setNbrLockers();
      });
      $('#customs_airflow').on('change', function () {
        checkAirflowLabel($(this));
      });
      $('#ventilation_qty').on('change change.select2', function () {
        refreshVentilationQtySelectLabel();
      });
      $('#side_lockers_side-lockers').on('change', function () {
        sideLockersHideShow();
        setNbrLockers();
        scheduleCustomCapHandleCollisionLayout();
      });
      $('#pa_configurateur-trolley').on('change', function () {
        //const isTrolley = $(this).val() === 'trolley-roul';

        // Affiche poignée + roulette
        // $('.js--set-handle-trolley, .js--set-wheel-angle').toggleClass('hide', !isTrolley);
        exceptionTrolley();
        $('#conex-calculated-price').trigger('wc-measurement-price-calculator-product-price-change');
      });
      $('input[type="number"]').on('change', function () {
        var $numberInput = $(this);
        var max = $numberInput.attr('max') * 1;
        var min = $numberInput.attr('min') * 1;
        if ($numberInput.is(customCapHeightInputSelector) && $.trim($numberInput.val()) === '') {
          $numberInput.val(customCapHeightLastValidValue || getCustomCapHeightDefault());
        }
        if (max > 0 && $numberInput.val() > max) {
          $numberInput.val($numberInput.attr('max'));
        }
        if (min > 0 && $numberInput.val() < min) {
          $numberInput.val($numberInput.attr('min'));
        }
      });
    }
  });
})();

},{"../../_components/scripts/notifier":2}],6:[function(require,module,exports){
"use strict";

/**
 * Handle product price javascript behavior
 */

(function () {
  'use strict';

  var validUrl = require('valid-url');

  /*
   * Global vars
   */
  var _variations = {};
  var _currentVariationMetas;
  var defaultMaxLength = 0;
  var defaultMaxWidth = 0;
  var defaultMaxHeight = 0;
  var $imgElt = '';
  var rackClassicCapDepthMinMm = 75;
  var rackClassicCapDepthMaxMm = 1000;
  var rackClassicCapDepthDefaultMm = 75;
  var rackClassicCapBandInsetMm = 10;
  var rackCustomBodyMinLengthMm = 200;
  var rackFlatCapDepthDefaultMm = 40;
  var rackLengthConsistencyToleranceMm = 0.01;

  /*
   * Functions
   */

  // Convertit en nombre ou renvoie 0 en cas d’erreur
  var getNumber = function getNumber(value) {
    var num = parseFloat(value);
    return isNaN(num) ? 0 : num;
  };
  var getConfiguratorAccessoryOption = function getConfiguratorAccessoryOption(code) {
    var catalog = window.configurator_options && window.configurator_options.accessory_catalog;
    if (!catalog || !code) {
      return null;
    }
    if (catalog[code]) {
      return catalog[code];
    }
    if (Array.isArray(catalog)) {
      for (var index = 0; index < catalog.length; index++) {
        if (catalog[index] && catalog[index].code === code) {
          return catalog[index];
        }
      }
    }
    return null;
  };
  var getConfiguratorAccessoryUnitPrice = function getConfiguratorAccessoryUnitPrice(code, fallback) {
    var accessory = getConfiguratorAccessoryOption(code);
    if (!accessory || accessory.active === false || accessory.active === '0') {
      return getNumber(fallback);
    }
    return getNumber(accessory.unit_price);
  };
  var valiseHandleCatalogCodeBySlug = {
    'poignee-de-surface': 'valise_handle_surface',
    'poignee-cuir': 'valise_handle_leather',
    'poignee-retractable': 'valise_handle_retractable'
  };
  var valiseLockerCatalogCodeBySlug = {
    'fermoir-grenouille-simple': 'valise_locker_frog_simple',
    'fermoir-grenouille-a-clef': 'valise_locker_frog_keyed',
    'fermoir-papillon': 'valise_locker_butterfly_lockable'
  };
  var getValiseCapType = function getValiseCapType() {
    var capType = $('#pa_configurateur-type-de-capot').val() || '';
    return capType === 'capot-amovible' || capType === 'capot-sur-charnieres' ? capType : '';
  };
  var valiseLegacyHiddenPriceFieldIds = {
    'options_trolley_roulettes': true,
    'poignee_cuir': true,
    'poignee_surface': true,
    'poignee_retractable': true,
    'fermoir_grenouille_clef': true,
    'fermoir_pap_cad': true,
    'fermoir_grenouille_simple': true
  };
  var valiseSideHandleMinimumHeight = 190;
  var valiseTrolleyHandleLengthLimit = 900;
  var valiseTrolleyCapVisualOffset = 40;
  var valiseTrolleyHandleClearance = 145;
  var valiseTrolleyFallbackCapHeight = 48;
  var getValiseSideHandleCount = function getValiseSideHandleCount() {
    if (!isValisePricingV2Enabled() || getNumber($('#height_needed').val()) < valiseSideHandleMinimumHeight || !$('#valise_side_handles').is(':checked')) {
      return 0;
    }
    return getNumber($('#width_needed').val()) >= 600 ? 4 : 2;
  };
  var valiseTrolleyHasHandle = function valiseTrolleyHasHandle() {
    var capHeight = getNumber($('#capot_height_mm').val());
    if (capHeight <= 0) {
      capHeight = valiseTrolleyFallbackCapHeight;
    }
    return getNumber($('#length_needed').val()) < valiseTrolleyHandleLengthLimit && getNumber($('#height_needed').val()) >= capHeight + valiseTrolleyCapVisualOffset + valiseTrolleyHandleClearance;
  };
  var getValiseTrolleyCatalogCode = function getValiseTrolleyCatalogCode() {
    if (!isValisePricingV2Enabled() || $('#pa_configurateur-trolley').val() !== 'trolley-roul') {
      return '';
    }
    return valiseTrolleyHasHandle() ? 'valise_trolley_kit_under_900' : 'valise_trolley_kit_from_900';
  };
  var getValiseV2AccessoryBreakdown = function getValiseV2AccessoryBreakdown() {
    var handleSlug = $('#pa_configurateur-poignees').val() || '';
    var lockerSlug = $('#pa_configurateur-fermoirs').val() || '';
    var capType = getValiseCapType();
    var removableCap = capType === 'capot-amovible';
    var hingedCap = capType === 'capot-sur-charnieres';
    var hasCapType = removableCap || hingedCap;
    var handleCode = valiseHandleCatalogCodeBySlug[handleSlug] || '';
    var lockerCode = valiseLockerCatalogCodeBySlug[lockerSlug] || '';
    var trolleyCode = getValiseTrolleyCatalogCode();
    var sideHandleCount = getValiseSideHandleCount();
    var handleCount = handleCode ? 1 : 0;
    var lockerCount = lockerCode && hasCapType ? removableCap ? 4 : 2 : 0;
    var trolleyCount = trolleyCode ? 1 : 0;
    var cornerCount = 8;
    var hingeCount = hingedCap ? 2 : 0;
    var cornerCode = isValiseLightweightPanelSelection() ? 'valise_corner_ball_20x20' : 'valise_corner_ball_medium';
    var handleUnitPrice = handleCode ? getConfiguratorAccessoryUnitPrice(handleCode, 0) : 0;
    var lockerUnitPrice = lockerCode ? getConfiguratorAccessoryUnitPrice(lockerCode, 0) : 0;
    var sideHandleUnitPrice = getConfiguratorAccessoryUnitPrice('valise_side_handle_standard', 0);
    var trolleyUnitPrice = trolleyCode ? getConfiguratorAccessoryUnitPrice(trolleyCode, 0) : 0;
    var cornerUnitPrice = getConfiguratorAccessoryUnitPrice(cornerCode, 0);
    var hingeUnitPrice = getConfiguratorAccessoryUnitPrice('valise_hinge', 0);
    var result = {
      cap_type: capType,
      handle_code: handleCode,
      handle_count: handleCount,
      handle_unit_price: handleUnitPrice,
      handle_price: handleCount * handleUnitPrice,
      locker_code: lockerCode,
      locker_count: lockerCount,
      locker_unit_price: lockerUnitPrice,
      locker_price: lockerCount * lockerUnitPrice,
      side_handle_code: 'valise_side_handle_standard',
      side_handle_count: sideHandleCount,
      side_handle_unit_price: sideHandleUnitPrice,
      side_handle_price: sideHandleCount * sideHandleUnitPrice,
      trolley_code: trolleyCode,
      trolley_count: trolleyCount,
      trolley_unit_price: trolleyUnitPrice,
      trolley_price: trolleyCount * trolleyUnitPrice,
      corner_code: cornerCode,
      corner_count: cornerCount,
      corner_unit_price: cornerUnitPrice,
      corner_price: cornerCount * cornerUnitPrice,
      hinge_count: hingeCount,
      hinge_unit_price: hingeUnitPrice,
      hinge_price: hingeCount * hingeUnitPrice
    };
    result.total = result.handle_price + result.locker_price + result.side_handle_price + result.trolley_price + result.corner_price + result.hinge_price;
    window.configurator_options.valise_handle_slug = handleSlug;
    window.configurator_options.valise_locker_slug = lockerSlug;
    window.configurator_options.valise_cap_type = result.cap_type;
    window.configurator_options.valise_main_handle_code = result.handle_code;
    window.configurator_options.valise_main_handle_count = result.handle_count;
    window.configurator_options.valise_main_handle_unit_price = result.handle_unit_price;
    window.configurator_options.valise_main_handle_price = result.handle_price;
    window.configurator_options.valise_locker_code = result.locker_code;
    window.configurator_options.valise_locker_count = result.locker_count;
    window.configurator_options.valise_locker_unit_price = result.locker_unit_price;
    window.configurator_options.valise_locker_price = result.locker_price;
    window.configurator_options.valise_side_handles = sideHandleCount > 0 ? 'yes' : 'no';
    window.configurator_options.valise_side_handle_count = result.side_handle_count;
    window.configurator_options.valise_side_handle_unit_price = result.side_handle_unit_price;
    window.configurator_options.valise_side_handle_price = result.side_handle_price;
    window.configurator_options.valise_trolley_code = result.trolley_code;
    window.configurator_options.valise_trolley_count = result.trolley_count;
    window.configurator_options.valise_trolley_unit_price = result.trolley_unit_price;
    window.configurator_options.valise_trolley_price = result.trolley_price;
    window.configurator_options.valise_corner_code = result.corner_code;
    window.configurator_options.valise_corner_count = result.corner_count;
    window.configurator_options.valise_corner_unit_price = result.corner_unit_price;
    window.configurator_options.valise_corner_price = result.corner_price;
    window.configurator_options.valise_hinge_count = result.hinge_count;
    window.configurator_options.valise_hinge_unit_price = result.hinge_unit_price;
    window.configurator_options.valise_hinge_price = result.hinge_price;
    window.configurator_options.valise_accessory_price = result.total;
    return result;
  };
  var neutralizeValiseLegacyHiddenPriceField = function neutralizeValiseLegacyHiddenPriceField($field) {
    var fieldId = $field.attr('id') || '';
    if (!isValisePricingV2Enabled() || !valiseLegacyHiddenPriceFieldIds[fieldId]) {
      return false;
    }
    if (typeof $field.attr('data-valise-legacy-price') === 'undefined') {
      $field.attr('data-valise-legacy-price', $field.attr('data-price') || '0');
    }
    window.configurator_options['valise_legacy_' + fieldId + '_price_skipped'] = getNumber($field.attr('data-valise-legacy-price'));
    $field.attr('data-price', '0').val('0');
    return true;
  };
  var getMalleCatalogCheckboxPrice = function getMalleCatalogCheckboxPrice($currentOption, fallback) {
    var family = getConfiguratorPriceFamily();
    if (family !== 'malle' && family !== 'cloche' && family !== 'rack') {
      return getNumber(fallback);
    }
    var optionValue = $currentOption.val() || '';
    var optionId = $currentOption.attr('id') || '';
    var code = '';
    var multiplier = 1;
    if (family === 'malle' && (optionValue === 'add-sidehandle' || optionId === 'handle_customs_add-sidehandle')) {
      code = 'malle_side_handles';
    } else if (family === 'rack' && (optionValue === 'side-lockers' || optionId === 'side_lockers_side-lockers')) {
      window.configurator_options.rack_side_lockers_price = 0;
      return 0;
    } else if (family === 'malle' && (optionValue === 'side-lockers' || optionId === 'side_lockers_side-lockers')) {
      code = 'malle_side_lockers';
    } else if (optionValue === 'with-lockers' || optionId === 'side_lockers_with-lockers') {
      code = family + '_lockable_locker_upgrade';
      multiplier = getNumber(window.configurator_options.nbr_lockers) || 4;
      if (family === 'rack') {
        if (Object.prototype.hasOwnProperty.call(window.configurator_options, 'rack_cap_locker_count')) {
          multiplier = getNumber(window.configurator_options.rack_cap_locker_count) * 2;
        } else {
          multiplier = getNumber(window.configurator_options.nbr_lockers) || 2;
        }
        window.configurator_options.rack_lockable_locker_count = multiplier;
      }
      if (isRackClocheReferencePricing()) {
        code = 'cloche_lockable_locker_upgrade';
        // Base Cloche simple, plus les fermoirs du second capot s'il
        // existe. Les compteurs physiques et le dessin restent Rack.
        var referenceLockers = getRackClocheReferenceAccessories().lockerCount;
        var rearLockers = rackHasRearCap() ? getNumber(window.configurator_options.rack_cap_locker_count) : 0;
        multiplier = referenceLockers + rearLockers;
        window.configurator_options.rack_lockable_locker_count = multiplier;
      }
    } else if (family === 'cloche' && optionId === 'capot_double_cloche') {
      code = 'cloche_double_cap';
    }
    if (!code) {
      return getNumber(fallback);
    }
    if (code === 'malle_side_handles' || code === 'malle_side_lockers') {
      var includedUnitPrice = getConfiguratorAccessoryUnitPrice(code, 0);
      var includedPrice = includedUnitPrice * multiplier;
      window.configurator_options[code + '_unit_price'] = includedUnitPrice;
      window.configurator_options[code + '_multiplier'] = multiplier;
      window.configurator_options[code + '_price'] = includedPrice;
      return includedPrice;
    }
    var accessory = getConfiguratorAccessoryOption(code);
    if (!accessory || accessory.active === false || accessory.active === '0') {
      return getNumber(fallback);
    }
    var unitPrice = getNumber(accessory.unit_price);
    var price = unitPrice * multiplier;
    window.configurator_options[code + '_unit_price'] = unitPrice;
    window.configurator_options[code + '_multiplier'] = multiplier;
    window.configurator_options[code + '_price'] = price;
    return price;
  };
  var getConfiguratorPriceFamily = function getConfiguratorPriceFamily() {
    if (isRackConfiguratorPriceContext()) {
      return 'rack';
    }
    if (isMalleConfiguratorPriceContext()) {
      return 'malle';
    }
    if (isClocheConfiguratorPriceContext()) {
      return 'cloche';
    }
    if (isValisePricingV2Enabled()) {
      return 'valise';
    }
    return '';
  };

  // Assiette commerciale uniquement : ne jamais modifier les axes, le corps
  // utile ou les compteurs physiques du Rack pour simuler une Cloche.
  // Le Rack 19 pouces et les capots plats gardent leurs calculs propres.
  var isRackClocheReferencePricing = function isRackClocheReferencePricing() {
    return isRackConfiguratorPriceContext() && getRackPricingType() === 'custom' && $('#pa_configurateur-type-de-capot').val() === 'capot-amovible';
  };
  var getRackClocheReferenceDimensions = function getRackClocheReferenceDimensions() {
    var state = getRackCustomLengthPricingState();
    var total = state.valid ? state.total_length_mm : 0;
    var width = getNumber($('input#width_needed').val());
    return {
      length: Math.max(total, width),
      width: Math.min(total, width),
      height: getNumber($('input#height_needed').val()),
      depth_extra: 0,
      panel_extra: 0,
      corrected: true,
      cloche_reference: true
    };
  };
  var getRackClocheReferenceAccessories = function getRackClocheReferenceAccessories() {
    var dimensions = getRackClocheReferenceDimensions();
    var small = dimensions.length < 425;
    var large = dimensions.length >= 600 && dimensions.height >= 450;
    var mobility = getSelectedMobilityType();
    var mobilityCount = mobility === 'none' ? 0 : dimensions.length >= getMobilitySixPieceLength() ? 6 : 4;
    var sideHandles = $('#rack_side_handles').is(':checked') ? 2 : 0;
    var result = {
      lockerCount: small ? 2 : 4,
      lockerCode: large ? 'cloche_locker_large' : 'cloche_locker_medium',
      handleCount: (dimensions.width < 600 ? 2 : 4) + sideHandles,
      cornerCount: 8,
      cornerCode: $('#pa_configurateur-coins').val() === 'coins-plats' ? 'cloche_corner_flat' : large ? 'cloche_corner_ball_large' : 'cloche_corner_ball_medium',
      braceCount: 0,
      wheelCount: mobility === 'wheels' ? mobilityCount : 0,
      palletFootCount: mobility === 'pallet-feet' ? mobilityCount : 0
    };
    window.configurator_options.rack_cloche_reference_dimensions = dimensions;
    window.configurator_options.rack_cloche_reference_accessories = result;
    return result;
  };
  var getClocheDoubleProfilePrice = function getClocheDoubleProfilePrice(profileUnitPrice) {
    var result = {
      applied: false,
      verticalLengthMm: 0,
      topLengthMm: 0,
      jointLengthMm: 0,
      profileCount: 2,
      totalLengthMm: 0,
      totalLengthM: 0,
      unitPrice: getNumber(profileUnitPrice),
      price: 0
    };
    if (isClocheConfiguratorPriceContext() && $('#capot_double_cloche').is(':checked')) {
      var heightMm = getNumber($('input#height_needed').val());
      var widthMm = getNumber($('input#width_needed').val());
      var capHeightMm = getNumber($('#capot_height_mm').val());
      if (heightMm > 0 && widthMm > 0 && capHeightMm > 0) {
        result.applied = true;
        result.verticalLengthMm = Math.max(0, heightMm - Math.min(capHeightMm, heightMm));
        result.topLengthMm = widthMm;
        result.jointLengthMm = result.verticalLengthMm * 2 + result.topLengthMm;
        // Le joint utilise deux extrusions physiques : une male et une femelle.
        result.totalLengthMm = result.jointLengthMm * result.profileCount;
        result.totalLengthM = result.totalLengthMm / 1000;
        result.price = result.totalLengthM * result.unitPrice;
      }
    }
    window.configurator_options.cloche_double_profile_applied = result.applied ? 'yes' : 'no';
    window.configurator_options.cloche_double_profile_vertical_length_mm = result.verticalLengthMm;
    window.configurator_options.cloche_double_profile_top_length_mm = result.topLengthMm;
    window.configurator_options.cloche_double_profile_joint_length_mm = result.jointLengthMm;
    window.configurator_options.cloche_double_profile_joint_length_m = result.jointLengthMm / 1000;
    window.configurator_options.cloche_double_profile_count = result.profileCount;
    window.configurator_options.cloche_double_profile_male_length_m = result.jointLengthMm / 1000;
    window.configurator_options.cloche_double_profile_female_length_m = result.jointLengthMm / 1000;
    window.configurator_options.cloche_double_profile_length_mm = result.totalLengthMm;
    window.configurator_options.cloche_double_profile_length_m = result.totalLengthM;
    window.configurator_options.cloche_double_profile_unit_price = result.unitPrice;
    window.configurator_options.cloche_double_profile_price = result.price;
    return result.price;
  };
  var getMobilitySixPieceLength = function getMobilitySixPieceLength() {
    var configuredThreshold = getNumber(window.configurator_options.mobility_six_piece_length_mm);
    return configuredThreshold > 0 ? configuredThreshold : 1600;
  };
  var getNormalizedMobilityLength = function getNormalizedMobilityLength() {
    return Math.max(getNumber($('input#length_needed').val()), getNumber($('input#width_needed').val()));
  };
  var getSelectedMobilityType = function getSelectedMobilityType() {
    var family = getConfiguratorPriceFamily();
    if (family !== 'rack' && family !== 'malle' && family !== 'cloche') {
      return 'none';
    }
    var $mobilityField = $('#wheels');
    var selectedValue = $mobilityField.length ? $mobilityField.val() || '' : '';
    if (selectedValue === 'pallet-feet') {
      return 'pallet-feet';
    }
    if (selectedValue === 'wheels-1') {
      return 'wheels';
    }
    if (selectedValue === 'wheels-0') {
      return 'none';
    }
    var configuredType = window.configurator_options.mobility_type;
    if (configuredType === 'wheels' || configuredType === 'pallet-feet') {
      return configuredType;
    }
    return getNumber(window.configurator_options.nbr_wheels) > 0 ? 'wheels' : 'none';
  };
  var syncMobilityPricingState = function syncMobilityPricingState() {
    var family = getConfiguratorPriceFamily();
    if (family !== 'rack' && family !== 'malle' && family !== 'cloche') {
      return {
        family: family,
        type: 'none',
        count: 0,
        wheelCount: getNumber(window.configurator_options.nbr_wheels),
        palletFootCount: 0
      };
    }
    var mobilityType = getSelectedMobilityType();
    var normalizedLength = getNormalizedMobilityLength();
    var sixPieceLength = getMobilitySixPieceLength();
    var pieceCount = mobilityType === 'none' ? 0 : normalizedLength >= sixPieceLength ? 6 : 4;
    var wheelCount = mobilityType === 'wheels' ? pieceCount : 0;
    var palletFootCount = mobilityType === 'pallet-feet' ? pieceCount : 0;
    window.configurator_options.mobility_type = mobilityType;
    window.configurator_options.mobility_normalized_length_mm = normalizedLength;
    window.configurator_options.mobility_six_piece_length_mm_applied = sixPieceLength;
    window.configurator_options.mobility_piece_count = pieceCount;
    window.configurator_options.nbr_wheels = wheelCount;
    window.configurator_options.nbr_pallet_feet = palletFootCount;
    if (family === 'malle' || family === 'cloche') {
      window.configurator_options[family + '_wheel_standard_count'] = wheelCount;
    }
    return {
      family: family,
      type: mobilityType,
      count: pieceCount,
      wheelCount: wheelCount,
      palletFootCount: palletFootCount
    };
  };
  var getPalletFeetPrice = function getPalletFeetPrice(mobilityState) {
    var state = mobilityState || syncMobilityPricingState();
    var family = state.family;
    if (state.type !== 'pallet-feet' || state.palletFootCount <= 0 || family !== 'rack' && family !== 'malle' && family !== 'cloche') {
      window.configurator_options.accessory_pallet_foot_code = '';
      window.configurator_options.accessory_pallet_foot_fixing_code = '';
      window.configurator_options.accessory_pallet_foot_unit_price = 0;
      window.configurator_options.accessory_pallet_foot_fixing_unit_price = 0;
      window.configurator_options.accessory_pallet_feet_price = 0;
      return 0;
    }
    var footUnitPrice = getConfiguratorAccessoryUnitPrice(family + '_pallet_foot', 0);
    var fixingUnitPrice = getConfiguratorAccessoryUnitPrice(family + '_pallet_foot_fixing', 0);
    var price = state.palletFootCount * (footUnitPrice + fixingUnitPrice);
    window.configurator_options.accessory_pallet_foot_code = family + '_pallet_foot';
    window.configurator_options.accessory_pallet_foot_fixing_code = family + '_pallet_foot_fixing';
    window.configurator_options.accessory_pallet_foot_unit_price = footUnitPrice;
    window.configurator_options.accessory_pallet_foot_fixing_unit_price = fixingUnitPrice;
    window.configurator_options.accessory_pallet_feet_price = price;
    return price;
  };
  var getMalleDetailedPiecePrice = function getMalleDetailedPiecePrice(items, fallbackCode, fallbackCount, fallbackUnitPrice) {
    var total = 0;
    var hasDetailedCount = false;
    for (var index = 0; index < items.length; index++) {
      var item = items[index];
      var count = getNumber(window.configurator_options[item.countKey]);
      if (count > 0) {
        hasDetailedCount = true;
        total += count * getConfiguratorAccessoryUnitPrice(item.code, fallbackUnitPrice);
      }
    }
    if (hasDetailedCount) {
      return total;
    }
    return getNumber(fallbackCount) * getConfiguratorAccessoryUnitPrice(fallbackCode, fallbackUnitPrice);
  };
  var foamCatalogCodeBySlug = {
    'sans-mousse': 'foam_none',
    'mousse-10mm': 'foam_ld29_10',
    'mousse-20': 'foam_ld29_20',
    'mousse-30': 'foam_ld29_30',
    'mousse-40': 'foam_ld29_40',
    'mousse-50': 'foam_ld29_50'
  };
  var getSelectedFoamSlug = function getSelectedFoamSlug() {
    var $mousse = $('#pa_configurateur-moussage');
    return $mousse.length ? $mousse.val() || '' : '';
  };
  var getSelectedFoamCatalogCode = function getSelectedFoamCatalogCode() {
    var slug = getSelectedFoamSlug();
    if (!slug) {
      return '';
    }
    if (foamCatalogCodeBySlug[slug]) {
      return foamCatalogCodeBySlug[slug];
    }
    return 'foam_' + slug.replace(/^mousse-/, '').replace(/[^a-z0-9]+/g, '_').replace(/^_|_$/g, '');
  };
  var getConfiguratorFoamArea = function getConfiguratorFoamArea() {
    var length = getNumber($('input#length_needed').val());
    var width = getNumber($('input#width_needed').val());
    var height = getNumber($('input#height_needed').val());
    if (isRackClocheReferencePricing()) {
      var reference = getRackClocheReferenceDimensions();
      length = reference.length;
      width = reference.width;
      height = reference.height;
    }
    if (length <= 0 || width <= 0 || height <= 0) {
      return 0;
    }
    return (length * width * 2 + length * height * 2 + width * height * 2) / 1000000;
  };
  var getConfiguratorFoamPrice = function getConfiguratorFoamPrice() {
    var foamSlug = getSelectedFoamSlug();
    var foamCode = getSelectedFoamCatalogCode();
    var area = 0;
    var unitPrice = 0;
    var priceBeforeCoefficient = 0;
    var coefficient = getNumber(window.configurator_options.foam_price_coefficient);
    var price = 0;
    if (coefficient <= 0) {
      coefficient = 1;
    }
    if (foamSlug && foamSlug !== 'sans-mousse' && foamCode) {
      area = getConfiguratorFoamArea();
      unitPrice = getConfiguratorAccessoryUnitPrice(foamCode, 0);
      priceBeforeCoefficient = area > 0 ? area * unitPrice : 0;
      price = priceBeforeCoefficient * coefficient;
    }
    window.configurator_options.mousse_slug = foamSlug;
    window.configurator_options.mousse_catalog_code = foamCode;
    window.configurator_options.mousse_area_m2 = area;
    window.configurator_options.mousse_unit_price_m2 = unitPrice;
    window.configurator_options.mousse_price_coefficient = coefficient;
    window.configurator_options.mousse_price_before_coefficient = priceBeforeCoefficient;
    window.configurator_options.mousse_price = price;
    return price;
  };
  var getCurrentVariationMeta = function getCurrentVariationMeta() {
    var currentVariationID = parseInt($('.woocommerce-variation-add-to-cart .variation_id').val(), 10);
    var currentVariation = null;
    if (isNaN(currentVariationID)) {
      return _currentVariationMetas || null;
    }
    $.each(_variations, function () {
      var variation = $(this)[0];
      if (variation.variation_id === currentVariationID) {
        currentVariation = variation;
        return false;
      }
    });
    return currentVariation || _currentVariationMetas || null;
  };
  var getVariationAttributeValue = function getVariationAttributeValue(variation, key) {
    if (!variation || !variation.attributes || typeof variation.attributes[key] === 'undefined' || variation.attributes[key] === null) {
      return '';
    }
    return variation.attributes[key].toString();
  };
  var findSansFoamVariation = function findSansFoamVariation(currentVariation) {
    var baseVariation = null;
    if (!currentVariation || !currentVariation.attributes) {
      return null;
    }
    $.each(_variations, function () {
      var candidate = $(this)[0];
      var matches = true;
      if (!candidate || !candidate.attributes || getVariationAttributeValue(candidate, 'attribute_pa_configurateur-moussage') !== 'sans-mousse') {
        return;
      }
      $.each(currentVariation.attributes, function (key, value) {
        if (key === 'attribute_pa_configurateur-moussage') {
          return;
        }
        if (getVariationAttributeValue(candidate, key) !== (value === null || typeof value === 'undefined' ? '' : value.toString())) {
          matches = false;
          return false;
        }
      });
      if (matches) {
        baseVariation = candidate;
        return false;
      }
    });
    return baseVariation;
  };
  var getFoamNeutralizedMeasurementAmount = function getFoamNeutralizedMeasurementAmount(amount) {
    var foamSlug = getSelectedFoamSlug();
    var currentVariation = null;
    var baseVariation = null;
    var currentUnitPrice = 0;
    var baseUnitPrice = 0;
    var neutralizedAmount = amount;
    window.configurator_options.mousse_variation_embedded_price_removed = 0;
    window.configurator_options.mousse_base_variation_id = '';
    if (!foamSlug || foamSlug === 'sans-mousse') {
      return amount;
    }
    currentVariation = getCurrentVariationMeta();
    baseVariation = findSansFoamVariation(currentVariation);
    if (!currentVariation || !baseVariation) {
      return amount;
    }
    currentUnitPrice = getNumber(currentVariation.display_price);
    baseUnitPrice = getNumber(baseVariation.display_price);
    if (currentUnitPrice <= 0 || baseUnitPrice <= 0) {
      return amount;
    }
    neutralizedAmount = amount * (baseUnitPrice / currentUnitPrice);
    window.configurator_options.mousse_variation_embedded_price_removed = amount - neutralizedAmount;
    window.configurator_options.mousse_base_variation_id = baseVariation.variation_id;
    window.configurator_options.mousse_variation_unit_price = currentUnitPrice;
    window.configurator_options.mousse_base_unit_price = baseUnitPrice;
    return neutralizedAmount;
  };
  var rackMaterialCatalogCodeBySelection = {
    'aluminium-alveole-10mm|aluminium-alveole': 'material_alucore_10',
    'bouleau-multiplis-9mm|brun-fonce-lisse': 'material_betonex_9_brun',
    'bouleau-multiplis-9mm|noir-lisse': 'material_betonex_9_noir',
    'bouleau-multiplis-9mm|blanc-lisse': 'material_betonex_9_blanc',
    'bouleau-multiplis-9mm|vinyle-bleu': 'material_vinyl_10_couleur',
    'bouleau-multiplis-9mm|vinyle-gris-clair': 'material_vinyl_10_couleur',
    'bouleau-multiplis-9mm|vinyle-gris-fonce': 'material_vinyl_10_couleur',
    'bouleau-multiplis-9mm|vinyle-jaune': 'material_vinyl_10_couleur',
    'bouleau-multiplis-9mm|vinyle-noir': 'material_vinyl_10_couleur',
    'bouleau-multiplis-9mm|vinyle-orange': 'material_vinyl_10_couleur',
    'bouleau-multiplis-9mm|vinyle-rouge': 'material_vinyl_10_couleur',
    'plastique-alveolaire-7mm|plastique-7mm-bleu': 'material_plastic_honeycomb_7',
    'plastique-alveolaire-7mm|plastique-7mm-rouge': 'material_plastic_honeycomb_7',
    'plastique-alveolaire-7mm|plastique-7mm-gris': 'material_plastic_honeycomb_7',
    'composite-alveolaire|triplex-noir': 'material_triplex_exalite_10',
    'triplex-10mm|triplex-noir': 'material_triplex_exalite_10',
    'composite-alveolaire|ultraflite': 'material_ultraflite_9_7'
  };
  var getFlightCaseMaterialCatalogCode = function getFlightCaseMaterialCatalogCode() {
    var materialSlug = $('#pa_configurateur-matiere').val() || '';
    var coveringSlug = $('#pa_configurateur-revetement').val() || '';
    return rackMaterialCatalogCodeBySelection[materialSlug + '|' + coveringSlug] || '';
  };
  var getRackMaterialCatalogCode = function getRackMaterialCatalogCode() {
    return getFlightCaseMaterialCatalogCode();
  };
  var getRackClassicCapDepthLimits = function getRackClassicCapDepthLimits() {
    var configuredMin = parseInt(window.configurator_options && window.configurator_options.rack_cap_depth_min_mm, 10);
    var configuredDefault = parseInt(window.configurator_options && window.configurator_options.rack_cap_depth_default_mm, 10);
    var configuredMax = parseInt(window.configurator_options && window.configurator_options.rack_cap_depth_max_mm, 10);
    var min = isNaN(configuredMin) ? rackClassicCapDepthMinMm : Math.max(rackClassicCapDepthMinMm, configuredMin);
    var max = isNaN(configuredMax) || configuredMax <= 0 ? rackClassicCapDepthMaxMm : Math.max(min, configuredMax);
    var defaultValue = isNaN(configuredDefault) ? rackClassicCapDepthDefaultMm : configuredDefault;
    return {
      min: min,
      defaultValue: Math.max(min, Math.min(max, defaultValue)),
      max: max
    };
  };
  var getRackClassicCapBandInsetMm = function getRackClassicCapBandInsetMm() {
    var configuredInset = parseInt(window.configurator_options && window.configurator_options.rack_cap_classic_band_inset_mm, 10);
    if (isNaN(configuredInset)) {
      configuredInset = rackClassicCapBandInsetMm;
    }
    return Math.max(0, Math.min(rackClassicCapDepthMinMm - 1, configuredInset));
  };
  var getRackClassicCapDepthMmForInput = function getRackClassicCapDepthMmForInput(inputSelector, optionKey) {
    var limits = getRackClassicCapDepthLimits();
    var $input = $(inputSelector);
    var configuredValue = window.configurator_options ? window.configurator_options[optionKey] : limits.defaultValue;
    var rawValue = $input.length ? $input.val() : configuredValue;
    var depth = parseInt(rawValue, 10);
    if (isNaN(depth)) {
      depth = limits.defaultValue;
    }
    depth = Math.max(limits.min, Math.min(limits.max, depth));
    if (window.configurator_options) {
      window.configurator_options[optionKey] = depth;
    }
    return depth;
  };
  var getRackClassicCapDepthMm = function getRackClassicCapDepthMm() {
    return getRackClassicCapDepthMmForInput('#rack_cap_depth_mm', 'rack_cap_depth_mm');
  };
  var getRackClassicRearCapDepthMm = function getRackClassicRearCapDepthMm() {
    return getRackClassicCapDepthMmForInput('#rack_rear_cap_depth_mm', 'rack_rear_cap_depth_mm');
  };
  var getRackPricingType = function getRackPricingType() {
    var selectedType = $('input[name="rack_type"]:checked').val();
    if (selectedType) {
      return selectedType;
    }
    return window.configurator_options && window.configurator_options.rack_type ? window.configurator_options.rack_type : 'rack-19';
  };
  var rackHasRearCap = function rackHasRearCap() {
    var $rearCapInput = $('#rack_left_cap');
    return $rearCapInput.length ? $rearCapInput.is(':checked') : window.configurator_options && window.configurator_options.rack_left_cap === 'yes';
  };
  var getRackFlatCapLengthContributions = function getRackFlatCapLengthContributions(hasRearCap) {
    var options = window.configurator_options || {};
    var flatDepthPerCap = getNumber(options.rack_flat_cap_depth_mm);
    var frontClearance = $('#rack_flat_front_clearance_mm').length ? getNumber($('#rack_flat_front_clearance_mm').val()) : getNumber(options.rack_flat_front_clearance_mm);
    var rearClearance = hasRearCap ? $('#rack_flat_rear_clearance_mm').length ? getNumber($('#rack_flat_rear_clearance_mm').val()) : getNumber(options.rack_flat_rear_clearance_mm) : 0;
    if (flatDepthPerCap <= 0) {
      flatDepthPerCap = rackFlatCapDepthDefaultMm;
    }
    var front = flatDepthPerCap + Math.max(0, frontClearance);
    var rear = hasRearCap ? flatDepthPerCap + Math.max(0, rearClearance) : 0;
    var configuredTotal = getNumber(options.rack_flat_cap_depth_extra_mm);
    var calculatedTotal = front + rear;

    // L'option existante reste l'autorite si la profondeur technique du
    // capot plat evolue. On reporte l'ecart sur le dernier capot present.
    if (configuredTotal > 0 && Math.abs(configuredTotal - calculatedTotal) > rackLengthConsistencyToleranceMm) {
      if (hasRearCap) {
        rear = Math.max(0, rear + configuredTotal - calculatedTotal);
      } else {
        front = Math.max(0, front + configuredTotal - calculatedTotal);
      }
    }
    return {
      front_mm: front,
      rear_mm: rear,
      total_mm: front + rear
    };
  };
  var getRackCustomLengthPricingState = function getRackCustomLengthPricingState() {
    var rackType = getRackPricingType();
    var bodyLength = getNumber($('input#length_needed').val());
    var result = {
      applicable: false,
      valid: true,
      reason: 'rack-19-unchanged',
      rack_type: rackType,
      minimum_body_length_mm: rackCustomBodyMinLengthMm,
      body_length_mm: bodyLength,
      total_length_mm: 0,
      expected_total_length_mm: 0,
      front_cap_contribution_mm: 0,
      rear_cap_contribution_mm: 0,
      total_cap_contribution_mm: 0,
      difference_mm: 0,
      total_field_present: false
    };

    // Le nouveau champ total est propre au Rack configurable. Le Rack 19
    // pouces conserve exactement ses entrees et son calcul historiques.
    if (!isRackConfiguratorPriceContext() || rackType !== 'custom') {
      if (window.configurator_options) {
        window.configurator_options.rack_custom_length_pricing_state = result;
        window.configurator_options.rack_custom_length_pricing_valid = 'yes';
        window.configurator_options.rack_custom_length_pricing_reason = result.reason;
      }
      return result;
    }
    var hasRearCap = rackHasRearCap();
    var isFlatCap = $('#pa_configurateur-type-de-capot').val() === 'capot-plat';
    var frontContribution = 0;
    var rearContribution = 0;
    if (isFlatCap) {
      var flatContributions = getRackFlatCapLengthContributions(hasRearCap);
      frontContribution = flatContributions.front_mm;
      rearContribution = flatContributions.rear_mm;
    } else {
      frontContribution = getRackClassicCapDepthMm();
      rearContribution = hasRearCap ? getRackClassicRearCapDepthMm() : 0;
    }
    var $totalInput = $('#rack_total_length_mm');
    var totalFieldPresent = $totalInput.length > 0;
    var rawTotal = totalFieldPresent ? $totalInput.val() : '';
    var totalLength = totalFieldPresent ? parseFloat(rawTotal) : 0;
    var expectedTotal = bodyLength + frontContribution + rearContribution;
    result.applicable = true;
    result.reason = 'valid';
    result.front_cap_contribution_mm = frontContribution;
    result.rear_cap_contribution_mm = rearContribution;
    result.total_cap_contribution_mm = frontContribution + rearContribution;
    result.expected_total_length_mm = expectedTotal;
    result.total_field_present = totalFieldPresent;
    if (!totalFieldPresent) {
      // Compatibilite avec un formulaire mis en cache avant l'ajout du
      // champ total : on derive uniquement l'etat, sans modifier le DOM.
      totalLength = expectedTotal;
      result.reason = 'legacy-total-derived';
    }
    result.total_length_mm = isNaN(totalLength) ? 0 : totalLength;
    result.difference_mm = result.total_length_mm - expectedTotal;
    if (bodyLength < rackCustomBodyMinLengthMm) {
      result.valid = false;
      result.reason = 'body-length-below-minimum';
    } else if (totalFieldPresent && (rawTotal === '' || isNaN(totalLength) || totalLength <= 0)) {
      result.valid = false;
      result.reason = 'total-length-missing';
    } else if (totalFieldPresent && Math.abs(result.difference_mm) > rackLengthConsistencyToleranceMm) {
      result.valid = false;
      result.reason = 'total-length-mismatch';
    }
    if (window.configurator_options) {
      window.configurator_options.rack_custom_length_pricing_state = result;
      window.configurator_options.rack_custom_length_pricing_valid = result.valid ? 'yes' : 'no';
      window.configurator_options.rack_custom_length_pricing_reason = result.reason;
      window.configurator_options.rack_custom_body_length_mm = result.body_length_mm;
      window.configurator_options.rack_custom_total_length_mm = result.total_length_mm;
      window.configurator_options.rack_custom_expected_total_length_mm = result.expected_total_length_mm;
      window.configurator_options.rack_custom_front_cap_contribution_mm = result.front_cap_contribution_mm;
      window.configurator_options.rack_custom_rear_cap_contribution_mm = result.rear_cap_contribution_mm;
      window.configurator_options.rack_custom_total_cap_contribution_mm = result.total_cap_contribution_mm;
      window.configurator_options.rack_custom_total_length_difference_mm = result.difference_mm;
    }
    return result;
  };
  var getRectangularCaseSurfaceM2 = function getRectangularCaseSurfaceM2(length, width, height) {
    var safeLength = getNumber(length);
    var safeWidth = getNumber(width);
    var safeHeight = getNumber(height);
    if (safeLength <= 0 || safeWidth <= 0 || safeHeight <= 0) {
      return 0;
    }
    return (safeLength * safeWidth * 2 + safeLength * safeHeight * 2 + safeWidth * safeHeight * 2) / 1000000;
  };
  var getRackClassicCapMaterialBreakdown = function getRackClassicCapMaterialBreakdown() {
    var bandInset = getRackClassicCapBandInsetMm();
    var result = {
      applicable: 'no',
      front_depth_mm: 0,
      rear_depth_mm: 0,
      front_band_width_mm: 0,
      rear_band_width_mm: 0,
      front_band_area_m2: 0,
      rear_band_area_m2: 0,
      depth_mm: 0,
      band_inset_mm: bandInset,
      band_width_mm: 0,
      cap_count: 0,
      width_mm: 0,
      height_mm: 0,
      horizontal_band_count: 0,
      vertical_band_count: 0,
      band_area_per_cap_m2: 0,
      total_band_area_m2: 0
    };
    var isFlatCap = $('#pa_configurateur-type-de-capot').val() === 'capot-plat';
    if (!isRackConfiguratorPriceContext() || isFlatCap) {
      if (window.configurator_options) {
        window.configurator_options.rack_classic_cap_material_applicable = 'no';
        window.configurator_options.rack_classic_cap_front_band_width_mm_applied = 0;
        window.configurator_options.rack_classic_cap_rear_band_width_mm_applied = 0;
        window.configurator_options.rack_classic_cap_band_width_mm_applied = 0;
        window.configurator_options.rack_classic_cap_count = 0;
        window.configurator_options.rack_classic_cap_horizontal_band_count = 0;
        window.configurator_options.rack_classic_cap_vertical_band_count = 0;
        window.configurator_options.rack_classic_cap_front_band_area_m2 = 0;
        window.configurator_options.rack_classic_cap_rear_band_area_m2 = 0;
        window.configurator_options.rack_classic_cap_band_area_per_cap_m2 = 0;
        window.configurator_options.rack_classic_cap_total_band_area_m2 = 0;
      }
      return result;
    }
    var $rearCapInput = $('#rack_left_cap');
    var hasRearCap = $rearCapInput.length ? $rearCapInput.is(':checked') : window.configurator_options && window.configurator_options.rack_left_cap === 'yes';
    var frontCapDepth = getRackClassicCapDepthMm();
    var rearCapDepth = hasRearCap ? getRackClassicRearCapDepthMm() : 0;
    var frontBandWidth = Math.max(0, frontCapDepth - bandInset);
    var rearBandWidth = hasRearCap ? Math.max(0, rearCapDepth - bandInset) : 0;
    var capCount = hasRearCap ? 2 : 1;
    var capWidth = getNumber($('input#width_needed').val());
    var capHeight = getNumber($('input#height_needed').val());
    var frontBandArea = capWidth > 0 && capHeight > 0 ? (capWidth * frontBandWidth * 2 + capHeight * frontBandWidth * 2) / 1000000 : 0;
    var rearBandArea = hasRearCap && capWidth > 0 && capHeight > 0 ? (capWidth * rearBandWidth * 2 + capHeight * rearBandWidth * 2) / 1000000 : 0;
    result.applicable = capWidth > 0 && capHeight > 0 ? 'yes' : 'no';
    result.front_depth_mm = frontCapDepth;
    result.rear_depth_mm = rearCapDepth;
    result.front_band_width_mm = frontBandWidth;
    result.rear_band_width_mm = rearBandWidth;
    result.front_band_area_m2 = frontBandArea;
    result.rear_band_area_m2 = rearBandArea;
    // Alias historiques conserves pour les integrations qui lisent encore le capot avant.
    result.depth_mm = frontCapDepth;
    result.band_width_mm = frontBandWidth;
    result.cap_count = capCount;
    result.width_mm = capWidth;
    result.height_mm = capHeight;
    result.horizontal_band_count = capCount * 2;
    result.vertical_band_count = capCount * 2;
    result.band_area_per_cap_m2 = frontBandArea;
    result.total_band_area_m2 = frontBandArea + rearBandArea;
    if (window.configurator_options) {
      window.configurator_options.rack_classic_cap_material_applicable = result.applicable;
      window.configurator_options.rack_classic_cap_depth_mm = frontCapDepth;
      window.configurator_options.rack_classic_rear_cap_depth_mm = rearCapDepth;
      window.configurator_options.rack_classic_cap_band_inset_mm = bandInset;
      window.configurator_options.rack_classic_cap_front_band_width_mm_applied = frontBandWidth;
      window.configurator_options.rack_classic_cap_rear_band_width_mm_applied = rearBandWidth;
      window.configurator_options.rack_classic_cap_band_width_mm_applied = frontBandWidth;
      window.configurator_options.rack_classic_cap_count = capCount;
      window.configurator_options.rack_classic_cap_horizontal_band_count = result.horizontal_band_count;
      window.configurator_options.rack_classic_cap_vertical_band_count = result.vertical_band_count;
      window.configurator_options.rack_classic_cap_front_band_area_m2 = frontBandArea;
      window.configurator_options.rack_classic_cap_rear_band_area_m2 = rearBandArea;
      window.configurator_options.rack_classic_cap_band_area_per_cap_m2 = frontBandArea;
      window.configurator_options.rack_classic_cap_total_band_area_m2 = result.total_band_area_m2;
    }
    return result;
  };
  var isFlightCaseMaterialCatalogPricingEnabled = function isFlightCaseMaterialCatalogPricingEnabled() {
    return (isRackConfiguratorPriceContext() || isMalleConfiguratorPriceContext() || isClocheConfiguratorPriceContext() || isValisePricingV2Enabled()) && getFlightCaseMaterialCatalogCode() !== '';
  };
  var isRackMaterialCatalogPricingEnabled = function isRackMaterialCatalogPricingEnabled() {
    return isFlightCaseMaterialCatalogPricingEnabled();
  };
  var getRackFlatCapMaterialDimensions = function getRackFlatCapMaterialDimensions() {
    var length = getNumber($('input#length_needed').val());
    var width = getNumber($('input#width_needed').val());
    var height = getNumber($('input#height_needed').val());
    var isFlatCap = $('#pa_configurateur-type-de-capot').val() === 'capot-plat';
    var depthExtra = isFlatCap ? getNumber(window.configurator_options.rack_flat_cap_depth_extra_mm) : 0;
    var panelExtra = isFlatCap ? getNumber(window.configurator_options.rack_flat_cap_panel_extra_mm) : 0;
    var lengthState = getRackCustomLengthPricingState();
    var envelopeLength = length + depthExtra;

    // En Rack configurable, length_needed est deja le corps utile derive.
    // Corps + extras doit retomber sur le total visible, sans soustraction
    // ni ajout supplementaire. Le Rack 19 conserve le calcul historique.
    if (isFlatCap && lengthState.applicable && lengthState.valid) {
      envelopeLength = lengthState.expected_total_length_mm;
    }
    return {
      length: envelopeLength,
      width: width + panelExtra,
      height: height + panelExtra,
      depth_extra: depthExtra,
      panel_extra: panelExtra,
      body_length: length,
      total_length: envelopeLength,
      custom_length_valid: !lengthState.applicable || lengthState.valid,
      corrected: isFlatCap && (depthExtra > 0 || panelExtra > 0)
    };
  };
  var getFlightCaseMaterialDimensions = function getFlightCaseMaterialDimensions() {
    if (isRackClocheReferencePricing()) {
      return getRackClocheReferenceDimensions();
    }
    if (isRackConfiguratorPriceContext()) {
      return getRackFlatCapMaterialDimensions();
    }
    return {
      length: getNumber($('input#length_needed').val()),
      width: getNumber($('input#width_needed').val()),
      height: getNumber($('input#height_needed').val()),
      depth_extra: 0,
      panel_extra: 0,
      corrected: false
    };
  };
  var getFlightCaseMaterialCatalogMeasurementAmount = function getFlightCaseMaterialCatalogMeasurementAmount(amount) {
    var measurementBaseSurface = getNumber($('input#_measurement_needed').val());
    var baseSurface = measurementBaseSurface;
    var materialDimensions = getFlightCaseMaterialDimensions();
    var rackLengthState = getRackCustomLengthPricingState();
    if (rackLengthState.applicable && !rackLengthState.valid) {
      window.configurator_options.material_catalog_pricing = 'no';
      window.configurator_options.material_fallback_pricing = 'no';
      window.configurator_options.material_pricing_mode = 'rack-custom-length-invalid';
      window.configurator_options.material_base_area_m2 = 0;
      window.configurator_options.material_area_m2 = 0;
      window.configurator_options.material_price = 0;
      window.configurator_options.rack_material_catalog_pricing = 'no';
      window.configurator_options.rack_material_fallback_pricing = 'no';
      window.configurator_options.rack_material_pricing_mode = 'rack-custom-length-invalid';
      window.configurator_options.rack_material_base_area_m2 = 0;
      window.configurator_options.rack_material_area_m2 = 0;
      window.configurator_options.rack_material_classic_cap_band_price = 0;
      window.configurator_options.rack_material_price = 0;
      return 0;
    }
    if (rackLengthState.applicable) {
      baseSurface = getRectangularCaseSurfaceM2(rackLengthState.body_length_mm, getNumber($('input#width_needed').val()), getNumber($('input#height_needed').val()));
    }
    var surface = materialDimensions.corrected ? getRectangularCaseSurfaceM2(materialDimensions.length, materialDimensions.width, materialDimensions.height) : baseSurface;
    var rackClassicCapMaterial = getRackClassicCapMaterialBreakdown();
    var materialCode = getFlightCaseMaterialCatalogCode();
    var unitPrice = materialCode ? getConfiguratorAccessoryUnitPrice(materialCode, 0) : 0;
    var family = getConfiguratorPriceFamily() || 'standard';
    var rackClassicCapArea = family === 'rack' && rackClassicCapMaterial.applicable === 'yes' ? rackClassicCapMaterial.total_band_area_m2 : 0;
    var amountBeforeMaterialPricing = getNumber(amount);
    var catalogPricingEnabled;
    var fallbackUnitPrice = 0;
    var fallbackPricingEnabled = false;
    var pricingEnabled;
    var effectiveUnitPrice;
    var fallbackBasePrice = amountBeforeMaterialPricing;
    var price;

    // Les six panneaux de l'enveloppe Cloche incluent deja la matiere du
    // capot. Les bandes physiques restent calculees pour la ventilation
    // signee du panier, mais ne s'ajoutent pas a cette assiette commerciale.
    var clocheReference = isRackClocheReferencePricing();
    if (!clocheReference) {
      surface += rackClassicCapArea;
    }
    window.configurator_options.rack_cloche_reference_pricing = clocheReference ? 'yes' : 'no';
    catalogPricingEnabled = (family === 'rack' || family === 'malle' || family === 'cloche' || family === 'valise') && materialCode && surface > 0 && unitPrice > 0;
    if (!catalogPricingEnabled && family === 'rack' && rackClassicCapArea > 0 && measurementBaseSurface > 0 && amountBeforeMaterialPricing > 0) {
      fallbackUnitPrice = amountBeforeMaterialPricing / measurementBaseSurface;
      fallbackPricingEnabled = fallbackUnitPrice > 0;
    }
    pricingEnabled = catalogPricingEnabled || fallbackPricingEnabled;
    effectiveUnitPrice = catalogPricingEnabled ? unitPrice : fallbackUnitPrice;
    if (fallbackPricingEnabled && rackLengthState.applicable) {
      fallbackBasePrice = (clocheReference ? surface : baseSurface) * fallbackUnitPrice;
    }
    price = catalogPricingEnabled ? surface * unitPrice : fallbackPricingEnabled ? fallbackBasePrice + (clocheReference ? 0 : rackClassicCapArea * fallbackUnitPrice) : amount;
    window.configurator_options.material_catalog_pricing = catalogPricingEnabled ? 'yes' : 'no';
    window.configurator_options.material_fallback_pricing = fallbackPricingEnabled ? 'yes' : 'no';
    window.configurator_options.material_pricing_mode = catalogPricingEnabled ? 'catalogue' : fallbackPricingEnabled ? 'fallback-prix-m2' : 'variation';
    window.configurator_options.material_catalog_family = pricingEnabled ? family : '';
    window.configurator_options.material_catalog_code = catalogPricingEnabled ? materialCode : '';
    window.configurator_options.material_base_area_m2 = pricingEnabled ? baseSurface : 0;
    window.configurator_options.material_measurement_base_area_m2 = pricingEnabled ? measurementBaseSurface : 0;
    window.configurator_options.material_area_m2 = pricingEnabled ? surface : 0;
    window.configurator_options.material_unit_price_m2 = pricingEnabled ? effectiveUnitPrice : 0;
    window.configurator_options.material_variation_price_removed = catalogPricingEnabled ? amountBeforeMaterialPricing - price : 0;
    window.configurator_options.material_price = pricingEnabled ? price : 0;
    window.configurator_options.rack_material_catalog_pricing = catalogPricingEnabled && family === 'rack' ? 'yes' : 'no';
    window.configurator_options.rack_material_fallback_pricing = fallbackPricingEnabled && family === 'rack' ? 'yes' : 'no';
    window.configurator_options.rack_material_pricing_mode = family === 'rack' ? window.configurator_options.material_pricing_mode : '';
    window.configurator_options.rack_material_catalog_code = catalogPricingEnabled && family === 'rack' ? materialCode : '';
    window.configurator_options.rack_material_base_area_m2 = pricingEnabled && family === 'rack' ? baseSurface : 0;
    window.configurator_options.rack_material_measurement_base_area_m2 = pricingEnabled && family === 'rack' ? measurementBaseSurface : 0;
    window.configurator_options.rack_material_area_m2 = pricingEnabled && family === 'rack' ? surface : 0;
    window.configurator_options.rack_material_classic_cap_band_area_m2 = family === 'rack' ? rackClassicCapArea : 0;
    window.configurator_options.rack_material_classic_cap_front_band_area_m2 = family === 'rack' ? rackClassicCapMaterial.front_band_area_m2 : 0;
    window.configurator_options.rack_material_classic_cap_rear_band_area_m2 = family === 'rack' ? rackClassicCapMaterial.rear_band_area_m2 : 0;
    window.configurator_options.rack_material_classic_cap_front_band_price = pricingEnabled && family === 'rack' ? rackClassicCapMaterial.front_band_area_m2 * effectiveUnitPrice : 0;
    window.configurator_options.rack_material_classic_cap_rear_band_price = pricingEnabled && family === 'rack' ? rackClassicCapMaterial.rear_band_area_m2 * effectiveUnitPrice : 0;
    window.configurator_options.rack_material_classic_cap_band_price = pricingEnabled && family === 'rack' ? rackClassicCapArea * effectiveUnitPrice : 0;
    window.configurator_options.rack_material_flat_cap_corrected = catalogPricingEnabled && family === 'rack' && materialDimensions.corrected ? 'yes' : 'no';
    window.configurator_options.rack_material_flat_cap_length_mm = catalogPricingEnabled && family === 'rack' ? materialDimensions.length : 0;
    window.configurator_options.rack_material_flat_cap_width_mm = catalogPricingEnabled && family === 'rack' ? materialDimensions.width : 0;
    window.configurator_options.rack_material_flat_cap_height_mm = catalogPricingEnabled && family === 'rack' ? materialDimensions.height : 0;
    window.configurator_options.rack_material_flat_cap_depth_extra_mm = catalogPricingEnabled && family === 'rack' ? materialDimensions.depth_extra : 0;
    window.configurator_options.rack_material_flat_cap_panel_extra_mm = catalogPricingEnabled && family === 'rack' ? materialDimensions.panel_extra : 0;
    window.configurator_options.rack_material_unit_price_m2 = pricingEnabled && family === 'rack' ? effectiveUnitPrice : 0;
    window.configurator_options.rack_material_variation_price_removed = catalogPricingEnabled && family === 'rack' ? amountBeforeMaterialPricing - price : 0;
    window.configurator_options.rack_material_price = pricingEnabled && family === 'rack' ? price : 0;
    window.configurator_options.rack_material_custom_length_valid = family === 'rack' && rackLengthState.applicable ? rackLengthState.valid ? 'yes' : 'no' : '';
    window.configurator_options.rack_material_custom_body_length_mm = family === 'rack' && rackLengthState.applicable ? rackLengthState.body_length_mm : 0;
    window.configurator_options.rack_material_custom_total_length_mm = family === 'rack' && rackLengthState.applicable ? rackLengthState.total_length_mm : 0;
    window.configurator_options.malle_material_catalog_pricing = catalogPricingEnabled && family === 'malle' ? 'yes' : 'no';
    window.configurator_options.malle_material_catalog_code = catalogPricingEnabled && family === 'malle' ? materialCode : '';
    window.configurator_options.malle_material_area_m2 = catalogPricingEnabled && family === 'malle' ? surface : 0;
    window.configurator_options.malle_material_unit_price_m2 = catalogPricingEnabled && family === 'malle' ? unitPrice : 0;
    window.configurator_options.malle_material_variation_price_removed = catalogPricingEnabled && family === 'malle' ? amountBeforeMaterialPricing - price : 0;
    window.configurator_options.malle_material_price = catalogPricingEnabled && family === 'malle' ? price : 0;
    window.configurator_options.cloche_material_catalog_pricing = catalogPricingEnabled && family === 'cloche' ? 'yes' : 'no';
    window.configurator_options.cloche_material_catalog_code = catalogPricingEnabled && family === 'cloche' ? materialCode : '';
    window.configurator_options.cloche_material_area_m2 = catalogPricingEnabled && family === 'cloche' ? surface : 0;
    window.configurator_options.cloche_material_unit_price_m2 = catalogPricingEnabled && family === 'cloche' ? unitPrice : 0;
    window.configurator_options.cloche_material_variation_price_removed = catalogPricingEnabled && family === 'cloche' ? amountBeforeMaterialPricing - price : 0;
    window.configurator_options.cloche_material_price = catalogPricingEnabled && family === 'cloche' ? price : 0;
    window.configurator_options.valise_material_catalog_pricing = catalogPricingEnabled && family === 'valise' ? 'yes' : 'no';
    window.configurator_options.valise_material_catalog_code = catalogPricingEnabled && family === 'valise' ? materialCode : '';
    window.configurator_options.valise_material_area_m2 = catalogPricingEnabled && family === 'valise' ? surface : 0;
    window.configurator_options.valise_material_unit_price_m2 = catalogPricingEnabled && family === 'valise' ? unitPrice : 0;
    window.configurator_options.valise_material_variation_price_removed = catalogPricingEnabled && family === 'valise' ? amountBeforeMaterialPricing - price : 0;
    window.configurator_options.valise_material_price = catalogPricingEnabled && family === 'valise' ? price : 0;
    return price;
  };
  var getRackMaterialCatalogMeasurementAmount = function getRackMaterialCatalogMeasurementAmount(amount) {
    return getFlightCaseMaterialCatalogMeasurementAmount(amount);
  };
  var getRackFlatAdditionalCapRealPriceEstimate = function getRackFlatAdditionalCapRealPriceEstimate(totalPriceCoefficient) {
    var coefficient = getNumber(totalPriceCoefficient);
    if (coefficient <= 0) {
      coefficient = 1;
    }
    var result = {
      applicable: 'no',
      applied: 'no',
      width_mm: 0,
      height_mm: 0,
      area_m2: 0,
      material_code: '',
      material_unit_price_m2: 0,
      material_gross_price: 0,
      material_reused_credit_price: 0,
      material_price: 0,
      profile_linear_m: 0,
      profile_unit_price_m: 0,
      profile_price: 0,
      corner_count: 0,
      corner_unit_price: 0,
      corner_price: 0,
      hardware_unit_price: 0,
      hardware_price: 0,
      be_hours: 0,
      workshop_hours: 0,
      be_rate: 0,
      workshop_rate: 0,
      labor_price: 0,
      price_before_coefficient: 0,
      coefficient: coefficient,
      price_after_coefficient: 0,
      current_forfait_price: 0,
      delta_after_coefficient_vs_forfait: 0
    };
    if (!isRackConfiguratorPriceContext()) {
      window.configurator_options.rack_flat_cap_real_estimate = result;
      return result;
    }
    var isFlatCap = $('#pa_configurateur-type-de-capot').val() === 'capot-plat';
    var $rearCapInput = $('#rack_left_cap');
    var hasLeftCap = $rearCapInput.length ? $rearCapInput.is(':checked') : window.configurator_options.rack_left_cap === 'yes';
    var panelExtra = getNumber(window.configurator_options.rack_flat_cap_panel_extra_mm);
    var capWidth = getNumber($('input#width_needed').val()) + panelExtra;
    var capHeight = getNumber($('input#height_needed').val()) + panelExtra;
    var materialCode = getRackMaterialCatalogCode();
    var materialUnitPrice = materialCode ? getConfiguratorAccessoryUnitPrice(materialCode, 0) : 0;
    var fallbackProfileUnitPrice = getConfiguratorAccessoryUnitPrice('rack_profile_cap_vertical', getNumber(window.configurator_options.prix_mf_alu));
    var profileUnitPrice = getConfiguratorAccessoryUnitPrice('rack_profile_cap_flat', fallbackProfileUnitPrice);
    var cornerUnitPrice = getConfiguratorAccessoryUnitPrice('rack_corner_flat', 0);
    var hardwareUnitPrice = getConfiguratorAccessoryUnitPrice('rack_cap_flat_hardware', 0);
    var beHours = getNumber(window.configurator_options.labor_rack_flat_cap_be_hours);
    var workshopHours = getNumber(window.configurator_options.labor_rack_flat_cap_workshop_hours);
    var beRate = getNumber(window.configurator_options.labor_be_hourly_rate);
    var workshopRate = getNumber(window.configurator_options.labor_workshop_hourly_rate);
    var forfaitPrice = getConfiguratorAccessoryUnitPrice('rack_cap_flat_left', 50);
    result.applicable = isFlatCap && capWidth > 0 && capHeight > 0 ? 'yes' : 'no';
    result.applied = result.applicable === 'yes' && hasLeftCap ? 'yes' : 'no';
    result.width_mm = capWidth;
    result.height_mm = capHeight;
    result.area_m2 = capWidth * capHeight / 1000000;
    result.material_code = materialCode;
    result.material_unit_price_m2 = materialUnitPrice;
    result.material_gross_price = result.area_m2 * materialUnitPrice;
    result.material_reused_credit_price = result.material_gross_price;
    result.material_price = Math.max(0, result.material_gross_price - result.material_reused_credit_price);
    result.profile_linear_m = (capWidth + capHeight) * 2 / 1000;
    result.profile_unit_price_m = profileUnitPrice;
    result.profile_price = result.profile_linear_m * profileUnitPrice;
    result.corner_count = 4;
    result.corner_unit_price = cornerUnitPrice;
    result.corner_price = result.corner_count * cornerUnitPrice;
    result.hardware_unit_price = hardwareUnitPrice;
    result.hardware_price = hardwareUnitPrice;
    result.be_hours = beHours;
    result.workshop_hours = workshopHours;
    result.be_rate = beRate;
    result.workshop_rate = workshopRate;
    result.labor_price = beHours * beRate + workshopHours * workshopRate;
    result.price_before_coefficient = result.material_price + result.profile_price + result.corner_price + result.hardware_price + result.labor_price;
    result.price_after_coefficient = result.price_before_coefficient * coefficient;
    result.current_forfait_price = forfaitPrice;
    result.delta_after_coefficient_vs_forfait = result.price_after_coefficient - forfaitPrice;
    window.configurator_options.rack_flat_cap_real_estimate = result;
    window.configurator_options.rack_flat_cap_real_estimate_applicable = result.applicable;
    window.configurator_options.rack_flat_cap_real_estimate_applied = result.applied;
    window.configurator_options.rack_flat_cap_real_estimate_material_gross_price = result.material_gross_price;
    window.configurator_options.rack_flat_cap_real_estimate_material_reused_credit_price = result.material_reused_credit_price;
    window.configurator_options.rack_flat_cap_real_estimate_material_price = result.material_price;
    window.configurator_options.rack_flat_cap_real_estimate_price_before_coefficient = result.price_before_coefficient;
    window.configurator_options.rack_flat_cap_real_estimate_price_after_coefficient = result.price_after_coefficient;
    window.configurator_options.rack_flat_cap_real_estimate_delta_vs_forfait = result.delta_after_coefficient_vs_forfait;
    return result;
  };
  var getRackClassicAdditionalCapRealPriceEstimate = function getRackClassicAdditionalCapRealPriceEstimate(totalPriceCoefficient) {
    var coefficient = getNumber(totalPriceCoefficient);
    if (coefficient <= 0) {
      coefficient = 1;
    }
    var result = {
      applicable: 'no',
      applied: 'no',
      rack_type: '',
      width_mm: 0,
      height_mm: 0,
      depth_mm: 0,
      band_width_mm: 0,
      band_area_m2: 0,
      material_code: '',
      material_unit_price_m2: 0,
      material_gross_price: 0,
      material_in_measurement_credit_price: 0,
      material_price: 0,
      mf_profile_linear_m: 0,
      mf_profile_unit_price_m: 0,
      mf_profile_price: 0,
      rack_profile_linear_m: 0,
      rack_profile_unit_price_m: 0,
      rack_profile_price: 0,
      hardware_unit_price: 0,
      hardware_price: 0,
      be_hours: 0,
      workshop_hours: 0,
      be_rate: 0,
      workshop_rate: 0,
      labor_price: 0,
      price_before_coefficient: 0,
      coefficient: coefficient,
      price_after_coefficient: 0,
      current_forfait_price: 0
    };
    if (!isRackConfiguratorPriceContext()) {
      window.configurator_options.rack_classic_cap_real_estimate = result;
      return result;
    }
    var rackType = window.configurator_options.rack_type || $('input[name="rack_type"]:checked').val() || 'rack-19';
    var isRack19 = rackType !== 'custom';
    var isClassicCap = $('#pa_configurateur-type-de-capot').val() !== 'capot-plat';
    var hasLeftCap = window.configurator_options.rack_left_cap === 'yes' || $('#rack_left_cap').is(':checked');
    var capWidth = getNumber($('input#width_needed').val());
    var capHeight = getNumber($('input#height_needed').val());
    var capMaterial = getRackClassicCapMaterialBreakdown();
    var capDepth = hasLeftCap ? capMaterial.rear_depth_mm : 0;
    var bandWidth = hasLeftCap ? capMaterial.rear_band_width_mm : 0;
    var materialCode = getRackMaterialCatalogCode();
    var materialUnitPrice = materialCode ? getConfiguratorAccessoryUnitPrice(materialCode, 0) : 0;
    var fallbackProfileUnitPrice = getConfiguratorAccessoryUnitPrice('rack_profile_cap_vertical', getNumber(window.configurator_options.prix_mf_alu));
    var mfProfileUnitPrice = getConfiguratorAccessoryUnitPrice('rack_profile_male_female', fallbackProfileUnitPrice);
    var rackProfileUnitPrice = getConfiguratorAccessoryUnitPrice('rack_rail_19', fallbackProfileUnitPrice);
    var hardwareUnitPrice = getConfiguratorAccessoryUnitPrice('rack_cap_classic_hardware', 0);
    var beHours = getNumber(window.configurator_options.labor_rack_classic_cap_be_hours);
    var workshopHours = getNumber(window.configurator_options.labor_rack_classic_cap_workshop_hours);
    var beRate = getNumber(window.configurator_options.labor_be_hourly_rate);
    var workshopRate = getNumber(window.configurator_options.labor_workshop_hourly_rate);
    var perimeterM = (capWidth + capHeight) * 2 / 1000;
    if (materialUnitPrice <= 0) {
      materialUnitPrice = getNumber(window.configurator_options.rack_material_unit_price_m2);
    }
    result.applicable = isClassicCap && capWidth > 0 && capHeight > 0 ? 'yes' : 'no';
    result.applied = result.applicable === 'yes' && hasLeftCap ? 'yes' : 'no';
    result.rack_type = rackType;
    result.width_mm = capWidth;
    result.height_mm = capHeight;
    result.depth_mm = capDepth;
    result.band_width_mm = bandWidth;
    result.band_area_m2 = hasLeftCap ? capMaterial.rear_band_area_m2 : 0;
    result.material_code = materialCode;
    result.material_unit_price_m2 = materialUnitPrice;
    result.material_gross_price = result.band_area_m2 * materialUnitPrice;
    result.material_in_measurement_credit_price = result.material_gross_price;
    result.material_price = Math.max(0, result.material_gross_price - result.material_in_measurement_credit_price);
    result.mf_profile_linear_m = perimeterM * 2;
    result.mf_profile_unit_price_m = mfProfileUnitPrice;
    result.mf_profile_price = result.mf_profile_linear_m * mfProfileUnitPrice;
    result.rack_profile_linear_m = isRack19 ? capHeight * 2 / 1000 : 0;
    result.rack_profile_unit_price_m = isRack19 ? rackProfileUnitPrice : 0;
    result.rack_profile_price = result.rack_profile_linear_m * result.rack_profile_unit_price_m;
    result.hardware_unit_price = hardwareUnitPrice;
    result.hardware_price = hardwareUnitPrice;
    result.be_hours = beHours;
    result.workshop_hours = workshopHours;
    result.be_rate = beRate;
    result.workshop_rate = workshopRate;
    result.labor_price = beHours * beRate + workshopHours * workshopRate;
    result.price_before_coefficient = result.material_price + result.mf_profile_price + result.rack_profile_price + result.hardware_price + result.labor_price;
    result.price_after_coefficient = result.price_before_coefficient * coefficient;
    result.current_forfait_price = getNumber(window.configurator_options.rack_cap_price_adjustment);
    window.configurator_options.rack_classic_cap_real_estimate = result;
    window.configurator_options.rack_classic_cap_real_estimate_applicable = result.applicable;
    window.configurator_options.rack_classic_cap_real_estimate_applied = result.applied;
    window.configurator_options.rack_classic_cap_real_estimate_band_area_m2 = result.band_area_m2;
    window.configurator_options.rack_classic_cap_real_estimate_material_gross_price = result.material_gross_price;
    window.configurator_options.rack_classic_cap_real_estimate_material_in_measurement_credit_price = result.material_in_measurement_credit_price;
    window.configurator_options.rack_classic_cap_real_estimate_material_price = result.material_price;
    window.configurator_options.rack_classic_cap_real_estimate_mf_profile_price = result.mf_profile_price;
    window.configurator_options.rack_classic_cap_real_estimate_rack_profile_price = result.rack_profile_price;
    window.configurator_options.rack_classic_cap_real_estimate_labor_price = result.labor_price;
    window.configurator_options.rack_classic_cap_real_estimate_price_before_coefficient = result.price_before_coefficient;
    window.configurator_options.rack_classic_cap_real_estimate_price_after_coefficient = result.price_after_coefficient;
    return result;
  };
  var getConfiguratorTotalPriceCoefficient = function getConfiguratorTotalPriceCoefficient() {
    var coefficient = getNumber(window.configurator_options.total_price_coefficient);
    window.configurator_options.total_price_coefficient_scope = isValisePricingV2Enabled() ? 'valise' : 'rack-malle-cloche';
    if (!isRackConfiguratorPriceContext() && !isMalleConfiguratorPriceContext() && !isClocheConfiguratorPriceContext() && !isValisePricingV2Enabled()) {
      return 1;
    }
    return coefficient > 0 ? coefficient : 1;
  };
  var getRackPostCoefficientPriceAdjustment = function getRackPostCoefficientPriceAdjustment(totalPriceCoefficient, rackFlatCapEstimate) {
    if (!isRackConfiguratorPriceContext()) {
      return 0;
    }
    var configuredAdjustment = getNumber(window.configurator_options.rack_cap_price_adjustment);
    var isFlatCap = $('#pa_configurateur-type-de-capot').val() === 'capot-plat';
    var hasLeftCap = window.configurator_options.rack_left_cap === 'yes' || $('#rack_left_cap').is(':checked');
    if (!hasLeftCap) {
      window.configurator_options.rack_left_cap_price_mode = isFlatCap ? 'none' : 'forfait';
      window.configurator_options.rack_cap_price_adjustment_effective = configuredAdjustment;
      return configuredAdjustment;
    }
    var coefficient = getNumber(totalPriceCoefficient);
    if (coefficient <= 0) {
      coefficient = getConfiguratorTotalPriceCoefficient();
    }
    if (!isFlatCap) {
      var classicEstimate = getRackClassicAdditionalCapRealPriceEstimate(coefficient);
      var realClassicLeftCapPrice = getNumber(classicEstimate.price_after_coefficient);
      window.configurator_options.rack_left_cap_price_mode = 'real-classic-cap';
      window.configurator_options.rack_left_cap_forfait_price = configuredAdjustment;
      window.configurator_options.rack_left_cap_price = realClassicLeftCapPrice;
      window.configurator_options.rack_cap_price_adjustment_forfait = configuredAdjustment;
      window.configurator_options.rack_cap_price_adjustment_effective = realClassicLeftCapPrice;
      window.configurator_options.rack_cap_price_adjustment = realClassicLeftCapPrice;
      return realClassicLeftCapPrice;
    }
    var estimate = rackFlatCapEstimate || getRackFlatAdditionalCapRealPriceEstimate(coefficient);
    var flatCapAdjustment = getConfiguratorAccessoryUnitPrice('rack_cap_flat_adjustment', -50);
    var realLeftCapPrice = getNumber(estimate.price_after_coefficient);
    var forfaitLeftCapPrice = getNumber(estimate.current_forfait_price);
    var dynamicAdjustment = flatCapAdjustment + realLeftCapPrice;
    var forfaitAdjustment = flatCapAdjustment + forfaitLeftCapPrice;
    window.configurator_options.rack_left_cap_price_mode = 'real-flat-cap';
    window.configurator_options.rack_left_cap_forfait_price = forfaitLeftCapPrice;
    window.configurator_options.rack_left_cap_price = realLeftCapPrice;
    window.configurator_options.rack_cap_price_adjustment_forfait = forfaitAdjustment;
    window.configurator_options.rack_cap_price_adjustment_effective = dynamicAdjustment;
    window.configurator_options.rack_cap_price_adjustment = dynamicAdjustment;
    return dynamicAdjustment;
  };
  var getConfiguratorLaborVariablePrice = function getConfiguratorLaborVariablePrice(surface, linearmeters) {
    var surfaceM2 = getNumber(surface);
    var edgeLinearMeters = getNumber(linearmeters) * 4;
    if (isValisePricingV2Enabled()) {
      var valiseSideHandleCount = getValiseSideHandleCount();
      var valiseHasTrolley = $('#pa_configurateur-trolley').val() === 'trolley-roul';
      var valiseCapType = getValiseCapType();
      var valiseRemovableCap = valiseCapType === 'capot-amovible';
      var valiseHingedCap = valiseCapType === 'capot-sur-charnieres';
      var valiseFoamSlug = getSelectedFoamSlug();
      var valiseHasFoam = valiseFoamSlug !== '' && valiseFoamSlug !== 'sans-mousse';
      var valiseBeRate = getNumber(window.configurator_options.labor_be_hourly_rate);
      var valiseWorkshopRate = getNumber(window.configurator_options.labor_workshop_hourly_rate);
      var hasValiseBeHoursPerM2 = typeof window.configurator_options.labor_valise_be_hours_per_m2 !== 'undefined' && window.configurator_options.labor_valise_be_hours_per_m2 !== null && window.configurator_options.labor_valise_be_hours_per_m2 !== '';
      var hasValiseWorkshopHoursPerM2 = typeof window.configurator_options.labor_valise_workshop_hours_per_m2 !== 'undefined' && window.configurator_options.labor_valise_workshop_hours_per_m2 !== null && window.configurator_options.labor_valise_workshop_hours_per_m2 !== '';
      var valiseBeHoursPerM2 = hasValiseBeHoursPerM2 ? getNumber(window.configurator_options.labor_valise_be_hours_per_m2) : getNumber(window.configurator_options.labor_be_hours_per_m2);
      var valiseWorkshopHoursPerM2 = hasValiseWorkshopHoursPerM2 ? getNumber(window.configurator_options.labor_valise_workshop_hours_per_m2) : getNumber(window.configurator_options.labor_workshop_hours_per_m2);
      var valiseVariableBeHours = surfaceM2 * valiseBeHoursPerM2;
      var valiseVariableWorkshopHours = surfaceM2 * valiseWorkshopHoursPerM2;
      var valiseTrolleyBeHours = valiseHasTrolley ? getNumber(window.configurator_options.labor_valise_trolley_be_hours) : 0;
      var valiseTrolleyWorkshopHours = valiseHasTrolley ? getNumber(window.configurator_options.labor_valise_trolley_workshop_hours) : 0;
      var valiseCapBeHours = valiseRemovableCap ? getNumber(window.configurator_options.labor_valise_cap_removable_be_hours) : valiseHingedCap ? getNumber(window.configurator_options.labor_valise_cap_hinged_be_hours) : 0;
      var valiseCapWorkshopHours = valiseRemovableCap ? getNumber(window.configurator_options.labor_valise_cap_removable_workshop_hours) : valiseHingedCap ? getNumber(window.configurator_options.labor_valise_cap_hinged_workshop_hours) : 0;
      var valiseSideHandleWorkshopHours = valiseSideHandleCount * getNumber(window.configurator_options.labor_valise_side_handle_workshop_hours_per_piece);
      var valiseFoamBeHours = valiseHasFoam ? getNumber(window.configurator_options.labor_foam_be_hours) : 0;
      var valiseFoamWorkshopHours = valiseHasFoam ? getNumber(window.configurator_options.labor_foam_workshop_hours) : 0;
      var valiseBeHours = getNumber(window.configurator_options.labor_valise_be_hours) + valiseVariableBeHours + valiseTrolleyBeHours + valiseCapBeHours + valiseFoamBeHours;
      var valiseWorkshopHours = getNumber(window.configurator_options.labor_valise_workshop_hours) + valiseVariableWorkshopHours + valiseTrolleyWorkshopHours + valiseCapWorkshopHours + valiseSideHandleWorkshopHours + valiseFoamWorkshopHours;
      var valiseBePrice = valiseBeHours * valiseBeRate;
      var valiseWorkshopPrice = valiseWorkshopHours * valiseWorkshopRate;
      var valisePrice = valiseBePrice + valiseWorkshopPrice;
      window.configurator_options.labor_model = 'valise-hourly-v2';
      window.configurator_options.labor_surface_m2 = surfaceM2;
      window.configurator_options.labor_edge_linear_meters = edgeLinearMeters;
      window.configurator_options.labor_valise_be_hours_per_m2_applied = valiseBeHoursPerM2;
      window.configurator_options.labor_valise_workshop_hours_per_m2_applied = valiseWorkshopHoursPerM2;
      window.configurator_options.labor_valise_trolley_applied = valiseHasTrolley ? 'yes' : 'no';
      window.configurator_options.labor_valise_cap_type = valiseCapType;
      window.configurator_options.labor_valise_side_handle_count = valiseSideHandleCount;
      window.configurator_options.labor_foam_applied = valiseHasFoam ? 'yes' : 'no';
      window.configurator_options.labor_variable_be_hours = valiseVariableBeHours;
      window.configurator_options.labor_variable_workshop_hours = valiseVariableWorkshopHours;
      window.configurator_options.labor_valise_trolley_be_hours_applied = valiseTrolleyBeHours;
      window.configurator_options.labor_valise_trolley_workshop_hours_applied = valiseTrolleyWorkshopHours;
      window.configurator_options.labor_valise_cap_be_hours_applied = valiseCapBeHours;
      window.configurator_options.labor_valise_cap_workshop_hours_applied = valiseCapWorkshopHours;
      window.configurator_options.labor_valise_side_handle_workshop_hours_applied = valiseSideHandleWorkshopHours;
      window.configurator_options.labor_foam_be_hours_applied = valiseFoamBeHours;
      window.configurator_options.labor_foam_workshop_hours_applied = valiseFoamWorkshopHours;
      window.configurator_options.labor_be_hourly_rate_applied = valiseBeRate;
      window.configurator_options.labor_workshop_hourly_rate_applied = valiseWorkshopRate;
      window.configurator_options.labor_be_hours = valiseBeHours;
      window.configurator_options.labor_workshop_hours = valiseWorkshopHours;
      window.configurator_options.labor_be_price = valiseBePrice;
      window.configurator_options.labor_workshop_price = valiseWorkshopPrice;
      window.configurator_options.labor_variable_price = valisePrice;
      return valisePrice;
    }
    if (isMalleConfiguratorPriceContext()) {
      var malleFrontCap = $('input[value="config-capot-avant"]').is(':checked');
      var malleSideCap = $('input[value="config-capot-lat"]').is(':checked');
      var malleExtraCapCount = (malleFrontCap ? 1 : 0) + (malleSideCap ? 1 : 0);
      var malleHasWheels = getNumber(window.configurator_options.nbr_wheels) > 0;
      var mallePalletFootCount = getNumber(window.configurator_options.nbr_pallet_feet);
      var malleHasPalletFeet = mallePalletFootCount > 0;
      var malleFoamSlug = getSelectedFoamSlug();
      var malleHasFoam = malleFoamSlug !== '' && malleFoamSlug !== 'sans-mousse';
      var malleBeRate = getNumber(window.configurator_options.labor_be_hourly_rate);
      var malleWorkshopRate = getNumber(window.configurator_options.labor_workshop_hourly_rate);
      var hasMalleBeHoursPerM2 = typeof window.configurator_options.labor_malle_be_hours_per_m2 !== 'undefined' && window.configurator_options.labor_malle_be_hours_per_m2 !== null && window.configurator_options.labor_malle_be_hours_per_m2 !== '';
      var hasMalleWorkshopHoursPerM2 = typeof window.configurator_options.labor_malle_workshop_hours_per_m2 !== 'undefined' && window.configurator_options.labor_malle_workshop_hours_per_m2 !== null && window.configurator_options.labor_malle_workshop_hours_per_m2 !== '';
      var malleBeHoursPerM2 = hasMalleBeHoursPerM2 ? getNumber(window.configurator_options.labor_malle_be_hours_per_m2) : getNumber(window.configurator_options.labor_be_hours_per_m2);
      var malleWorkshopHoursPerM2 = hasMalleWorkshopHoursPerM2 ? getNumber(window.configurator_options.labor_malle_workshop_hours_per_m2) : getNumber(window.configurator_options.labor_workshop_hours_per_m2);
      var malleVariableBeHours = surfaceM2 * malleBeHoursPerM2;
      var malleVariableWorkshopHours = surfaceM2 * malleWorkshopHoursPerM2;
      var malleExtraCapBeHours = malleExtraCapCount * getNumber(window.configurator_options.labor_malle_extra_cap_be_hours);
      var malleExtraCapWorkshopHours = malleExtraCapCount * getNumber(window.configurator_options.labor_malle_extra_cap_workshop_hours);
      var malleWheelsBeHours = malleHasWheels ? getNumber(window.configurator_options.labor_wheels_be_hours) : 0;
      var malleWheelsWorkshopHours = malleHasWheels ? getNumber(window.configurator_options.labor_wheels_workshop_hours) : 0;
      var mallePalletFeetBeHours = malleHasPalletFeet ? getNumber(window.configurator_options.labor_pallet_feet_be_hours) : 0;
      var mallePalletFeetWorkshopHours = mallePalletFootCount * getNumber(window.configurator_options.labor_pallet_feet_workshop_hours_per_piece);
      var malleFoamBeHours = malleHasFoam ? getNumber(window.configurator_options.labor_foam_be_hours) : 0;
      var malleFoamWorkshopHours = malleHasFoam ? getNumber(window.configurator_options.labor_foam_workshop_hours) : 0;
      var malleBeHours = getNumber(window.configurator_options.labor_malle_be_hours) + malleVariableBeHours + malleExtraCapBeHours + malleWheelsBeHours + mallePalletFeetBeHours + malleFoamBeHours;
      var malleWorkshopHours = getNumber(window.configurator_options.labor_malle_workshop_hours) + malleVariableWorkshopHours + malleExtraCapWorkshopHours + malleWheelsWorkshopHours + mallePalletFeetWorkshopHours + malleFoamWorkshopHours;
      var malleBePrice = malleBeHours * malleBeRate;
      var malleWorkshopPrice = malleWorkshopHours * malleWorkshopRate;
      var mallePrice = malleBePrice + malleWorkshopPrice;
      window.configurator_options.labor_model = 'malle-hourly';
      window.configurator_options.labor_surface_m2 = surfaceM2;
      window.configurator_options.labor_edge_linear_meters = edgeLinearMeters;
      window.configurator_options.labor_malle_extra_cap_count = malleExtraCapCount;
      window.configurator_options.labor_extra_cap_applied = malleExtraCapCount > 0 ? 'yes' : 'no';
      window.configurator_options.labor_wheels_applied = malleHasWheels ? 'yes' : 'no';
      window.configurator_options.labor_pallet_feet_applied = malleHasPalletFeet ? 'yes' : 'no';
      window.configurator_options.labor_foam_applied = malleHasFoam ? 'yes' : 'no';
      window.configurator_options.labor_malle_be_hours_per_m2_applied = malleBeHoursPerM2;
      window.configurator_options.labor_malle_workshop_hours_per_m2_applied = malleWorkshopHoursPerM2;
      window.configurator_options.labor_variable_be_hours = malleVariableBeHours;
      window.configurator_options.labor_variable_workshop_hours = malleVariableWorkshopHours;
      window.configurator_options.labor_extra_cap_be_hours_applied = malleExtraCapBeHours;
      window.configurator_options.labor_extra_cap_workshop_hours_applied = malleExtraCapWorkshopHours;
      window.configurator_options.labor_wheels_be_hours_applied = malleWheelsBeHours;
      window.configurator_options.labor_wheels_workshop_hours_applied = malleWheelsWorkshopHours;
      window.configurator_options.labor_pallet_feet_be_hours_applied = mallePalletFeetBeHours;
      window.configurator_options.labor_pallet_feet_workshop_hours_applied = mallePalletFeetWorkshopHours;
      window.configurator_options.labor_foam_be_hours_applied = malleFoamBeHours;
      window.configurator_options.labor_foam_workshop_hours_applied = malleFoamWorkshopHours;
      window.configurator_options.labor_be_hourly_rate_applied = malleBeRate;
      window.configurator_options.labor_workshop_hourly_rate_applied = malleWorkshopRate;
      window.configurator_options.labor_be_hours = malleBeHours;
      window.configurator_options.labor_workshop_hours = malleWorkshopHours;
      window.configurator_options.labor_be_price = malleBePrice;
      window.configurator_options.labor_workshop_price = malleWorkshopPrice;
      window.configurator_options.labor_variable_price = mallePrice;
      return mallePrice;
    }
    if (isClocheConfiguratorPriceContext() || isRackClocheReferencePricing()) {
      var clocheDouble = $('#capot_double_cloche').is(':checked');
      var clocheHasWheels = getNumber(window.configurator_options.nbr_wheels) > 0;
      var clochePalletFootCount = isRackClocheReferencePricing() ? getRackClocheReferenceAccessories().palletFootCount : getNumber(window.configurator_options.nbr_pallet_feet);
      var clocheHasPalletFeet = clochePalletFootCount > 0;
      var clocheFoamSlug = getSelectedFoamSlug();
      var clocheHasFoam = clocheFoamSlug !== '' && clocheFoamSlug !== 'sans-mousse';
      var clocheBeRate = getNumber(window.configurator_options.labor_be_hourly_rate);
      var clocheWorkshopRate = getNumber(window.configurator_options.labor_workshop_hourly_rate);
      var hasClocheBeHoursPerM2 = typeof window.configurator_options.labor_malle_be_hours_per_m2 !== 'undefined' && window.configurator_options.labor_malle_be_hours_per_m2 !== null && window.configurator_options.labor_malle_be_hours_per_m2 !== '';
      var hasClocheWorkshopHoursPerM2 = typeof window.configurator_options.labor_malle_workshop_hours_per_m2 !== 'undefined' && window.configurator_options.labor_malle_workshop_hours_per_m2 !== null && window.configurator_options.labor_malle_workshop_hours_per_m2 !== '';
      var clocheBeHoursPerM2 = hasClocheBeHoursPerM2 ? getNumber(window.configurator_options.labor_malle_be_hours_per_m2) : getNumber(window.configurator_options.labor_be_hours_per_m2);
      var clocheWorkshopHoursPerM2 = hasClocheWorkshopHoursPerM2 ? getNumber(window.configurator_options.labor_malle_workshop_hours_per_m2) : getNumber(window.configurator_options.labor_workshop_hours_per_m2);
      var clocheVariableBeHours = surfaceM2 * clocheBeHoursPerM2;
      var clocheVariableWorkshopHours = surfaceM2 * clocheWorkshopHoursPerM2;
      var clocheDoubleBeHours = clocheDouble ? getNumber(window.configurator_options.labor_cloche_double_be_hours) : 0;
      var clocheDoubleWorkshopHours = clocheDouble ? getNumber(window.configurator_options.labor_cloche_double_workshop_hours) : 0;
      var clocheWheelsBeHours = clocheHasWheels ? getNumber(window.configurator_options.labor_wheels_be_hours) : 0;
      var clocheWheelsWorkshopHours = clocheHasWheels ? getNumber(window.configurator_options.labor_wheels_workshop_hours) : 0;
      var clochePalletFeetBeHours = clocheHasPalletFeet ? getNumber(window.configurator_options.labor_pallet_feet_be_hours) : 0;
      var clochePalletFeetWorkshopHours = clochePalletFootCount * getNumber(window.configurator_options.labor_pallet_feet_workshop_hours_per_piece);
      var clocheFoamBeHours = clocheHasFoam ? getNumber(window.configurator_options.labor_foam_be_hours) : 0;
      var clocheFoamWorkshopHours = clocheHasFoam ? getNumber(window.configurator_options.labor_foam_workshop_hours) : 0;
      var clocheBeHours = getNumber(window.configurator_options.labor_cloche_be_hours) + clocheVariableBeHours + clocheDoubleBeHours + clocheWheelsBeHours + clochePalletFeetBeHours + clocheFoamBeHours;
      var clocheWorkshopHours = getNumber(window.configurator_options.labor_cloche_workshop_hours) + clocheVariableWorkshopHours + clocheDoubleWorkshopHours + clocheWheelsWorkshopHours + clochePalletFeetWorkshopHours + clocheFoamWorkshopHours;
      var clocheBePrice = clocheBeHours * clocheBeRate;
      var clocheWorkshopPrice = clocheWorkshopHours * clocheWorkshopRate;
      var clochePrice = clocheBePrice + clocheWorkshopPrice;
      window.configurator_options.labor_model = isRackClocheReferencePricing() ? 'rack-custom-cloche-reference' : 'cloche-hourly';
      window.configurator_options.labor_surface_m2 = surfaceM2;
      window.configurator_options.labor_edge_linear_meters = edgeLinearMeters;
      window.configurator_options.labor_cloche_double_applied = clocheDouble ? 'yes' : 'no';
      window.configurator_options.labor_cloche_be_hours_per_m2_applied = clocheBeHoursPerM2;
      window.configurator_options.labor_cloche_workshop_hours_per_m2_applied = clocheWorkshopHoursPerM2;
      window.configurator_options.labor_wheels_applied = clocheHasWheels ? 'yes' : 'no';
      window.configurator_options.labor_pallet_feet_applied = clocheHasPalletFeet ? 'yes' : 'no';
      window.configurator_options.labor_foam_applied = clocheHasFoam ? 'yes' : 'no';
      window.configurator_options.labor_variable_be_hours = clocheVariableBeHours;
      window.configurator_options.labor_variable_workshop_hours = clocheVariableWorkshopHours;
      window.configurator_options.labor_cloche_double_be_hours_applied = clocheDoubleBeHours;
      window.configurator_options.labor_cloche_double_workshop_hours_applied = clocheDoubleWorkshopHours;
      window.configurator_options.labor_wheels_be_hours_applied = clocheWheelsBeHours;
      window.configurator_options.labor_wheels_workshop_hours_applied = clocheWheelsWorkshopHours;
      window.configurator_options.labor_pallet_feet_be_hours_applied = clochePalletFeetBeHours;
      window.configurator_options.labor_pallet_feet_workshop_hours_applied = clochePalletFeetWorkshopHours;
      window.configurator_options.labor_foam_be_hours_applied = clocheFoamBeHours;
      window.configurator_options.labor_foam_workshop_hours_applied = clocheFoamWorkshopHours;
      window.configurator_options.labor_be_hourly_rate_applied = clocheBeRate;
      window.configurator_options.labor_workshop_hourly_rate_applied = clocheWorkshopRate;
      window.configurator_options.labor_be_hours = clocheBeHours;
      window.configurator_options.labor_workshop_hours = clocheWorkshopHours;
      window.configurator_options.labor_be_price = clocheBePrice;
      window.configurator_options.labor_workshop_price = clocheWorkshopPrice;
      window.configurator_options.labor_variable_price = clochePrice;
      return clochePrice;
    }
    if (!isRackConfiguratorPriceContext()) {
      var pricePerM2 = getNumber(window.configurator_options.labor_price_per_m2);
      var pricePerLinearMeter = getNumber(window.configurator_options.labor_price_per_linear_meter);
      var surfacePrice = surfaceM2 * pricePerM2;
      var linearPrice = edgeLinearMeters * pricePerLinearMeter;
      var legacyPrice = surfacePrice + linearPrice;
      window.configurator_options.labor_model = 'legacy-simple';
      window.configurator_options.labor_surface_m2 = surfaceM2;
      window.configurator_options.labor_edge_linear_meters = edgeLinearMeters;
      window.configurator_options.labor_price_per_m2_applied = pricePerM2;
      window.configurator_options.labor_price_per_linear_meter_applied = pricePerLinearMeter;
      window.configurator_options.labor_surface_price = surfacePrice;
      window.configurator_options.labor_linear_price = linearPrice;
      window.configurator_options.labor_variable_price = legacyPrice;
      return legacyPrice;
    }
    var rackType = window.configurator_options.rack_type || $('input[name="rack_type"]:checked').val() || 'rack-19';
    var isRack19 = rackType !== 'custom';
    var rackUnits = isRack19 ? getNumber(window.configurator_options.rack_units || $('#rack_units').val()) : 0;
    var hasExtraCap = window.configurator_options.rack_left_cap === 'yes' || $('#rack_left_cap').is(':checked');
    var isFlatCap = $('#pa_configurateur-type-de-capot').val() === 'capot-plat';
    // Les capots rack ont leur propre calcul reel dedie.
    // On ignore donc l'ancien supplement generique pour eviter un double comptage.
    var hasExtraCapLabor = false;
    var hasWheels = getNumber(window.configurator_options.nbr_wheels) > 0;
    var rackPalletFootCount = getNumber(window.configurator_options.nbr_pallet_feet);
    var hasPalletFeet = rackPalletFootCount > 0;
    var foamSlug = getSelectedFoamSlug();
    var hasFoam = foamSlug !== '' && foamSlug !== 'sans-mousse';
    var beRate = getNumber(window.configurator_options.labor_be_hourly_rate);
    var workshopRate = getNumber(window.configurator_options.labor_workshop_hourly_rate);
    var beHours = isRack19 ? getNumber(window.configurator_options.labor_rack_19_be_hours) : getNumber(window.configurator_options.labor_rack_configurable_be_hours);
    var workshopHours = isRack19 ? getNumber(window.configurator_options.labor_rack_19_workshop_hours) : getNumber(window.configurator_options.labor_rack_configurable_workshop_hours);
    var variableBeHours = surfaceM2 * getNumber(window.configurator_options.labor_be_hours_per_m2);
    var variableWorkshopHours = surfaceM2 * getNumber(window.configurator_options.labor_workshop_hours_per_m2);
    var unitsWorkshopHours = rackUnits * getNumber(window.configurator_options.labor_rack_workshop_hours_per_u);
    var extraCapBeHours = hasExtraCapLabor ? getNumber(window.configurator_options.labor_extra_cap_be_hours) : 0;
    var extraCapWorkshopHours = hasExtraCapLabor ? getNumber(window.configurator_options.labor_extra_cap_workshop_hours) : 0;
    var rackRailsBeHours = isRack19 ? getNumber(window.configurator_options.labor_rack_rails_be_hours) : 0;
    var rackRailsWorkshopHours = isRack19 ? getNumber(window.configurator_options.labor_rack_rails_workshop_hours) : 0;
    var wheelsBeHours = hasWheels ? getNumber(window.configurator_options.labor_wheels_be_hours) : 0;
    var wheelsWorkshopHours = hasWheels ? getNumber(window.configurator_options.labor_wheels_workshop_hours) : 0;
    var palletFeetBeHours = hasPalletFeet ? getNumber(window.configurator_options.labor_pallet_feet_be_hours) : 0;
    var palletFeetWorkshopHours = rackPalletFootCount * getNumber(window.configurator_options.labor_pallet_feet_workshop_hours_per_piece);
    var foamBeHours = hasFoam ? getNumber(window.configurator_options.labor_foam_be_hours) : 0;
    var foamWorkshopHours = hasFoam ? getNumber(window.configurator_options.labor_foam_workshop_hours) : 0;
    beHours += variableBeHours + extraCapBeHours + rackRailsBeHours + wheelsBeHours + palletFeetBeHours + foamBeHours;
    workshopHours += variableWorkshopHours + unitsWorkshopHours + extraCapWorkshopHours + rackRailsWorkshopHours + wheelsWorkshopHours + palletFeetWorkshopHours + foamWorkshopHours;
    var bePrice = beHours * beRate;
    var workshopPrice = workshopHours * workshopRate;
    var price = bePrice + workshopPrice;
    window.configurator_options.labor_model = 'rack-hourly';
    window.configurator_options.labor_rack_type = rackType;
    window.configurator_options.labor_surface_m2 = surfaceM2;
    window.configurator_options.labor_edge_linear_meters = edgeLinearMeters;
    window.configurator_options.labor_rack_units = rackUnits;
    window.configurator_options.labor_extra_cap_applied = hasExtraCapLabor ? 'yes' : 'no';
    window.configurator_options.labor_extra_cap_skipped_flat_cap = hasExtraCap && isFlatCap ? 'yes' : 'no';
    window.configurator_options.labor_rack_rails_applied = isRack19 ? 'yes' : 'no';
    window.configurator_options.labor_wheels_applied = hasWheels ? 'yes' : 'no';
    window.configurator_options.labor_pallet_feet_applied = hasPalletFeet ? 'yes' : 'no';
    window.configurator_options.labor_foam_applied = hasFoam ? 'yes' : 'no';
    window.configurator_options.labor_variable_be_hours = variableBeHours;
    window.configurator_options.labor_variable_workshop_hours = variableWorkshopHours;
    window.configurator_options.labor_units_workshop_hours = unitsWorkshopHours;
    window.configurator_options.labor_extra_cap_be_hours_applied = extraCapBeHours;
    window.configurator_options.labor_extra_cap_workshop_hours_applied = extraCapWorkshopHours;
    window.configurator_options.labor_rack_rails_be_hours_applied = rackRailsBeHours;
    window.configurator_options.labor_rack_rails_workshop_hours_applied = rackRailsWorkshopHours;
    window.configurator_options.labor_wheels_be_hours_applied = wheelsBeHours;
    window.configurator_options.labor_wheels_workshop_hours_applied = wheelsWorkshopHours;
    window.configurator_options.labor_pallet_feet_be_hours_applied = palletFeetBeHours;
    window.configurator_options.labor_pallet_feet_workshop_hours_applied = palletFeetWorkshopHours;
    window.configurator_options.labor_foam_be_hours_applied = foamBeHours;
    window.configurator_options.labor_foam_workshop_hours_applied = foamWorkshopHours;
    window.configurator_options.labor_be_hourly_rate_applied = beRate;
    window.configurator_options.labor_workshop_hourly_rate_applied = workshopRate;
    window.configurator_options.labor_be_hours = beHours;
    window.configurator_options.labor_workshop_hours = workshopHours;
    window.configurator_options.labor_be_price = bePrice;
    window.configurator_options.labor_workshop_price = workshopPrice;
    window.configurator_options.labor_variable_price = price;
    return price;
  };
  var isRackConfiguratorPriceContext = function isRackConfiguratorPriceContext() {
    return $('body').hasClass('flight-case-type-rack') || $('body').hasClass('postid-313');
  };
  var isMalleConfiguratorPriceContext = function isMalleConfiguratorPriceContext() {
    return $('body').hasClass('flight-case-type-malle') || $('body').hasClass('postid-309');
  };
  var isClocheConfiguratorPriceContext = function isClocheConfiguratorPriceContext() {
    return $('body').hasClass('flight-case-type-cloche') || $('body').hasClass('flight-case-cloche') || $('body').hasClass('postid-1711');
  };
  var isValiseConfiguratorPriceContext = function isValiseConfiguratorPriceContext() {
    return $('body').hasClass('flight-case-type-valise') || $('body').hasClass('postid-312');
  };
  var isValiseLightweightPanelSelection = function isValiseLightweightPanelSelection() {
    return isValiseConfiguratorPriceContext() && $('#pa_configurateur-matiere').val() === 'plastique-alveolaire-7mm';
  };
  var isValisePricingV2Enabled = function isValisePricingV2Enabled() {
    var enabled = window.configurator_options && window.configurator_options.valise_pricing_v2_enabled;
    return isValiseConfiguratorPriceContext() && (enabled === true || enabled === 1 || enabled === '1' || enabled === 'yes');
  };
  var getRackWheelBoardPrice = function getRackWheelBoardPrice() {
    if (!isRackConfiguratorPriceContext() || getNumber(window.configurator_options.nbr_wheels) <= 0) {
      return 0;
    }
    var length = getNumber($('input#length_needed').val());
    var width = getNumber($('input#width_needed').val());
    var unitPrice = getConfiguratorAccessoryUnitPrice('rack_wheel_board_cp18', 0);
    var area = length * width / 1000000;
    var price = area > 0 ? area * unitPrice : 0;
    window.configurator_options.rack_wheel_board_area_m2 = area;
    window.configurator_options.rack_wheel_board_price = price;
    return price;
  };
  var getRackRailFastenersPrice = function getRackRailFastenersPrice() {
    if (!isRackConfiguratorPriceContext()) {
      return 0;
    }
    var rackType = window.configurator_options.rack_type || $('input[name="rack_type"]:checked').val() || 'rack-19';
    if (rackType === 'custom') {
      window.configurator_options.rack_rail_fasteners_price = 0;
      window.configurator_options.rack_rail_fasteners_count_per_option = 0;
      return 0;
    }
    var units = getNumber(window.configurator_options.rack_units || $('#rack_units').val());
    var countPerOption = Math.max(0, units) * 4;
    var hasRearCap = window.configurator_options.rack_left_cap === 'yes' || $('#rack_left_cap').is(':checked');
    var options = [{
      id: '#rack_square_nuts',
      code: 'rack_square_nut',
      countKey: 'rack_square_nut_count',
      priceKey: 'rack_square_nut_price'
    }, {
      id: '#rack_black_pozi_screws_12',
      code: 'rack_black_pozi_screw_12',
      countKey: 'rack_black_pozi_screw_12_count',
      priceKey: 'rack_black_pozi_screw_12_price'
    }, {
      id: '#rack_black_pozi_screws_16',
      code: 'rack_black_pozi_screw_16',
      countKey: 'rack_black_pozi_screw_16_count',
      priceKey: 'rack_black_pozi_screw_16_price'
    }, {
      id: '#rack_plastic_washers',
      code: 'rack_plastic_washer',
      countKey: 'rack_plastic_washer_count',
      priceKey: 'rack_plastic_washer_price'
    }, {
      id: '#rack_rear_square_nuts',
      code: 'rack_square_nut',
      countKey: 'rack_rear_square_nut_count',
      priceKey: 'rack_rear_square_nut_price',
      requiresRearCap: true
    }, {
      id: '#rack_rear_black_pozi_screws_12',
      code: 'rack_black_pozi_screw_12',
      countKey: 'rack_rear_black_pozi_screw_12_count',
      priceKey: 'rack_rear_black_pozi_screw_12_price',
      requiresRearCap: true
    }, {
      id: '#rack_rear_black_pozi_screws_16',
      code: 'rack_black_pozi_screw_16',
      countKey: 'rack_rear_black_pozi_screw_16_count',
      priceKey: 'rack_rear_black_pozi_screw_16_price',
      requiresRearCap: true
    }, {
      id: '#rack_rear_plastic_washers',
      code: 'rack_plastic_washer',
      countKey: 'rack_rear_plastic_washer_count',
      priceKey: 'rack_rear_plastic_washer_price',
      requiresRearCap: true
    }];
    var total = 0;
    for (var index = 0; index < options.length; index++) {
      var option = options[index];
      var checked = $(option.id).is(':checked') && (!option.requiresRearCap || hasRearCap);
      var count = checked ? countPerOption : 0;
      var price = count * getConfiguratorAccessoryUnitPrice(option.code, 0);
      window.configurator_options[option.countKey] = count;
      window.configurator_options[option.priceKey] = price;
      total += price;
    }
    window.configurator_options.rack_rail_fasteners_per_unit = 4;
    window.configurator_options.rack_rail_fasteners_count_per_option = countPerOption;
    window.configurator_options.rack_rail_fasteners_price = total;
    return total;
  };
  var getPlatePanelPieces = function getPlatePanelPieces() {
    var length = getNumber($('input#length_needed').val());
    var width = getNumber($('input#width_needed').val());
    var height = getNumber($('input#height_needed').val());
    var rackLengthState = getRackCustomLengthPricingState();
    var rackClassicCapMaterial = getRackClassicCapMaterialBreakdown();
    var pieces = [];
    if (rackLengthState.applicable && !rackLengthState.valid) {
      return pieces;
    }
    var clocheReference = isRackClocheReferencePricing();
    if (clocheReference) {
      var reference = getRackClocheReferenceDimensions();
      length = reference.length;
      width = reference.width;
      height = reference.height;
    }
    if (length <= 0 || width <= 0 || height <= 0) {
      return pieces;
    }
    var addPieces = function addPieces(name, pieceWidth, pieceHeight, count) {
      for (var i = 0; i < count; i++) {
        pieces.push({
          name: name,
          width: pieceWidth,
          height: pieceHeight,
          area: pieceWidth * pieceHeight
        });
      }
    };
    addPieces('fond-capot', length, width, 2);
    addPieces('cotes-longueur', length, height, 2);
    addPieces('cotes-largeur', width, height, 2);
    if (!clocheReference && rackClassicCapMaterial.applicable === 'yes' && rackClassicCapMaterial.front_band_width_mm > 0) {
      addPieces('bandes-capot-rack-avant-horizontales', rackClassicCapMaterial.width_mm, rackClassicCapMaterial.front_band_width_mm, 2);
      addPieces('bandes-capot-rack-avant-verticales', rackClassicCapMaterial.height_mm, rackClassicCapMaterial.front_band_width_mm, 2);
    }
    if (!clocheReference && rackClassicCapMaterial.applicable === 'yes' && rackClassicCapMaterial.rear_band_width_mm > 0) {
      addPieces('bandes-capot-rack-arriere-horizontales', rackClassicCapMaterial.width_mm, rackClassicCapMaterial.rear_band_width_mm, 2);
      addPieces('bandes-capot-rack-arriere-verticales', rackClassicCapMaterial.height_mm, rackClassicCapMaterial.rear_band_width_mm, 2);
    }
    pieces.sort(function (a, b) {
      return b.area - a.area;
    });
    return pieces;
  };
  var rectContains = function rectContains(a, b) {
    return b.x >= a.x && b.y >= a.y && b.x + b.width <= a.x + a.width && b.y + b.height <= a.y + a.height;
  };
  var pruneFreeRects = function pruneFreeRects(freeRects) {
    for (var i = 0; i < freeRects.length; i++) {
      for (var j = i + 1; j < freeRects.length; j++) {
        if (rectContains(freeRects[i], freeRects[j])) {
          freeRects.splice(j, 1);
          j--;
        } else if (rectContains(freeRects[j], freeRects[i])) {
          freeRects.splice(i, 1);
          i--;
          break;
        }
      }
    }
  };
  var splitFreeRects = function splitFreeRects(freeRects, usedRect) {
    for (var i = 0; i < freeRects.length; i++) {
      var rect = freeRects[i];
      var intersects = usedRect.x < rect.x + rect.width && usedRect.x + usedRect.width > rect.x && usedRect.y < rect.y + rect.height && usedRect.y + usedRect.height > rect.y;
      if (!intersects) {
        continue;
      }
      if (usedRect.x > rect.x) {
        freeRects.push({
          x: rect.x,
          y: rect.y,
          width: usedRect.x - rect.x,
          height: rect.height
        });
      }
      if (usedRect.x + usedRect.width < rect.x + rect.width) {
        freeRects.push({
          x: usedRect.x + usedRect.width,
          y: rect.y,
          width: rect.x + rect.width - (usedRect.x + usedRect.width),
          height: rect.height
        });
      }
      if (usedRect.y > rect.y) {
        freeRects.push({
          x: rect.x,
          y: rect.y,
          width: rect.width,
          height: usedRect.y - rect.y
        });
      }
      if (usedRect.y + usedRect.height < rect.y + rect.height) {
        freeRects.push({
          x: rect.x,
          y: usedRect.y + usedRect.height,
          width: rect.width,
          height: rect.y + rect.height - (usedRect.y + usedRect.height)
        });
      }
      freeRects.splice(i, 1);
      i--;
    }
    pruneFreeRects(freeRects);
  };
  var findBestPlatePosition = function findBestPlatePosition(piece, freeRects, gap) {
    var best = null;
    var testPosition = function testPosition(rect, pieceWidth, pieceHeight, rotated) {
      var paddedWidth = pieceWidth + gap;
      var paddedHeight = pieceHeight + gap;
      if (paddedWidth > rect.width || paddedHeight > rect.height) {
        return;
      }
      var leftoverHoriz = rect.width - paddedWidth;
      var leftoverVert = rect.height - paddedHeight;
      var shortSideFit = Math.min(leftoverHoriz, leftoverVert);
      var longSideFit = Math.max(leftoverHoriz, leftoverVert);
      if (best === null || shortSideFit < best.shortSideFit || shortSideFit === best.shortSideFit && longSideFit < best.longSideFit) {
        best = {
          x: rect.x,
          y: rect.y,
          width: paddedWidth,
          height: paddedHeight,
          rotated: rotated,
          shortSideFit: shortSideFit,
          longSideFit: longSideFit
        };
      }
    };
    for (var i = 0; i < freeRects.length; i++) {
      testPosition(freeRects[i], piece.width, piece.height, false);
      testPosition(freeRects[i], piece.height, piece.width, true);
    }
    return best;
  };
  var calculatePlateCount = function calculatePlateCount() {
    var plateWidth = 2500;
    var plateHeight = 1250;
    var margin = 5;
    var cut = 3;
    var gap = margin + cut;
    var offset = margin + gap / 2;
    var usableWidth = plateWidth - 2 * offset;
    var usableHeight = plateHeight - 2 * offset;
    var pieces = getPlatePanelPieces();
    var plateCount = 0;
    if (pieces.length === 0) {
      return {
        possible: true,
        plateCount: 0
      };
    }
    while (pieces.length > 0) {
      var freeRects = [{
        x: 0,
        y: 0,
        width: usableWidth,
        height: usableHeight
      }];
      var placedOnPlate = false;
      for (var i = 0; i < pieces.length;) {
        var placement = findBestPlatePosition(pieces[i], freeRects, gap);
        if (placement === null) {
          i++;
          continue;
        }
        splitFreeRects(freeRects, placement);
        pieces.splice(i, 1);
        placedOnPlate = true;
      }
      if (!placedOnPlate) {
        return {
          possible: false,
          plateCount: plateCount,
          unusablePiece: pieces[0]
        };
      }
      plateCount++;
    }
    return {
      possible: true,
      plateCount: plateCount
    };
  };
  var getBoardCuttingBilledArea = function getBoardCuttingBilledArea(pieceWidth, pieceHeight, plateWidth, plateHeight) {
    var length = parseFloat(pieceWidth) || 0;
    var width = parseFloat(pieceHeight) || 0;
    var twoThirdsLength = 2 / 3 * plateWidth;
    var fiveEighthsLength = 5 / 8 * plateWidth;
    var halfWidth = 0.5 * plateHeight;
    var billedArea = 0;
    if (length <= 0 || width <= 0) {
      return null;
    }
    if (length > fiveEighthsLength && width > halfWidth) {
      billedArea = plateWidth * plateHeight;
    } else if (length <= twoThirdsLength && width <= halfWidth) {
      billedArea = length * width;
    } else if (length > twoThirdsLength && width <= halfWidth) {
      billedArea = width * plateWidth;
    } else if (length <= twoThirdsLength && width > halfWidth) {
      billedArea = length * plateHeight;
    } else {
      billedArea = plateWidth * plateHeight;
    }
    return billedArea / 1000000;
  };
  var getLowestBoardCuttingBilledArea = function getLowestBoardCuttingBilledArea(pieceWidth, pieceHeight, plateWidth, plateHeight) {
    var combos = [];
    var fitsStandard = pieceWidth <= plateWidth && pieceHeight <= plateHeight;
    var fitsRotated = pieceHeight <= plateWidth && pieceWidth <= plateHeight;
    if (fitsStandard) {
      combos.push(getBoardCuttingBilledArea(pieceWidth, pieceHeight, plateWidth, plateHeight));
    }
    if (fitsRotated) {
      combos.push(getBoardCuttingBilledArea(pieceHeight, pieceWidth, plateWidth, plateHeight));
    }
    combos = combos.filter(function (value) {
      return value !== null;
    });
    if (combos.length === 0) {
      return null;
    }
    return Math.min.apply(null, combos);
  };
  var calculateBoardCuttingBilledArea = function calculateBoardCuttingBilledArea() {
    var plateWidth = 2500;
    var plateHeight = 1250;
    var pieces = getPlatePanelPieces();
    var billedArea = 0;
    for (var i = 0; i < pieces.length; i++) {
      var pieceBilledArea = getLowestBoardCuttingBilledArea(pieces[i].width, pieces[i].height, plateWidth, plateHeight);
      if (pieceBilledArea === null) {
        return {
          possible: false,
          billedArea: billedArea,
          unusablePiece: pieces[i]
        };
      }
      billedArea += pieceBilledArea;
    }
    return {
      possible: true,
      billedArea: billedArea
    };
  };
  var getPlatePricingCorrection = function getPlatePricingCorrection(measurementPrice, baseConfiguratorPrice) {
    var surface = parseFloat($('input#_measurement_needed').val());
    var rackLengthState = getRackCustomLengthPricingState();
    var materialDimensions = getFlightCaseMaterialDimensions();
    var rackClassicCapMaterial = getRackClassicCapMaterialBreakdown();
    var plateArea = 2500 * 1250 / 1000000;
    var targetTotalCoefficient = 1.80;
    var plateInfo = calculatePlateCount();
    var cuttingInfo = calculateBoardCuttingBilledArea();
    var pricePerSquareMeter = 0;
    var fullPlateMaterialArea = 0;
    var cuttingMaterialArea = 0;
    var billedMaterialArea = 0;
    var materialPrice = 0;
    var rawCorrection = 0;
    var correction = 0;
    var targetPriceAdjustment = 0;
    var pricingMode = 'none';
    baseConfiguratorPrice = getNumber(baseConfiguratorPrice);
    if (rackLengthState.applicable && !rackLengthState.valid) {
      window.configurator_options.plate_pricing_possible = false;
      window.configurator_options.plate_count = 0;
      window.configurator_options.plate_pricing_mode = 'rack-custom-length-invalid';
      window.configurator_options.plate_price_correction = 0;
      return 0;
    }
    if (rackLengthState.applicable) {
      surface = materialDimensions.corrected ? getRectangularCaseSurfaceM2(materialDimensions.length, materialDimensions.width, materialDimensions.height) : getRectangularCaseSurfaceM2(rackLengthState.body_length_mm, getNumber($('input#width_needed').val()), getNumber($('input#height_needed').val()));
    }
    if (!isRackClocheReferencePricing() && !isNaN(surface) && rackClassicCapMaterial.applicable === 'yes') {
      surface += rackClassicCapMaterial.total_band_area_m2;
    }
    if (!plateInfo.possible || plateInfo.plateCount <= 0 || isNaN(surface) || surface <= 0 || measurementPrice <= 0) {
      window.configurator_options.plate_pricing_possible = plateInfo.possible;
      window.configurator_options.plate_count = plateInfo.plateCount;
      window.configurator_options.plate_price_correction = 0;
      return 0;
    }
    pricePerSquareMeter = measurementPrice / surface;
    fullPlateMaterialArea = plateInfo.plateCount * plateArea;
    cuttingMaterialArea = cuttingInfo.possible ? cuttingInfo.billedArea : fullPlateMaterialArea;
    billedMaterialArea = Math.min(fullPlateMaterialArea, cuttingMaterialArea);
    billedMaterialArea = Math.max(surface, billedMaterialArea);
    pricingMode = cuttingMaterialArea < fullPlateMaterialArea ? 'decoupe' : 'plaques-completes';
    materialPrice = billedMaterialArea * pricePerSquareMeter;
    rawCorrection = Math.max(0, materialPrice - measurementPrice);
    targetPriceAdjustment = materialPrice * targetTotalCoefficient - measurementPrice - baseConfiguratorPrice;
    if (isRackMaterialCatalogPricingEnabled() || window.configurator_options.rack_material_fallback_pricing === 'yes') {
      correction = rawCorrection;
      pricingMode = pricingMode + (window.configurator_options.rack_material_fallback_pricing === 'yes' ? '-cout-matiere-fallback' : '-cout-matiere');
    } else {
      correction = rawCorrection > 0 ? Math.min(rawCorrection, Math.max(0, targetPriceAdjustment)) : 0;
    }
    window.configurator_options.plate_pricing_possible = true;
    window.configurator_options.plate_count = plateInfo.plateCount;
    window.configurator_options.plate_square_meter_price = pricePerSquareMeter;
    window.configurator_options.plate_full_material_area = fullPlateMaterialArea;
    window.configurator_options.plate_cutting_material_area = cuttingMaterialArea;
    window.configurator_options.plate_billed_material_area = billedMaterialArea;
    window.configurator_options.plate_pricing_mode = pricingMode;
    window.configurator_options.plate_material_price = materialPrice;
    window.configurator_options.plate_raw_price_correction = rawCorrection;
    window.configurator_options.plate_target_total_coefficient = targetTotalCoefficient;
    window.configurator_options.plate_target_price_adjustment = targetPriceAdjustment;
    window.configurator_options.plate_price_correction = correction;
    window.configurator_options.plate_effective_total_coefficient = materialPrice > 0 ? (measurementPrice + baseConfiguratorPrice + correction) / materialPrice : 0;
    return correction;
  };
  var isFlightCaseConfigurator = function isFlightCaseConfigurator() {
    return $('body').hasClass('single-configurator');
  };
  var getEffectiveMaxInputValue = function getEffectiveMaxInputValue(type, value) {
    var numericValue = parseInt(value, 10);
    if (isNaN(numericValue)) {
      return value;
    }
    if (isFlightCaseConfigurator() && type === 'width') {
      return Math.min(numericValue, 1224);
    }
    return numericValue;
  };
  var clampMeasurementInputToMax = function clampMeasurementInputToMax($input) {
    var maxValue = parseFloat($input.attr('max'));
    var currentValue = parseFloat($input.val());
    if (!isNaN(maxValue) && !isNaN(currentValue) && currentValue > maxValue) {
      $input.val(maxValue);
      return true;
    }
    return false;
  };
  var getBoardVariationCutFee = function getBoardVariationCutFee() {
    if ($('#decoupe_bois.thwepo-price-field:not(.thwepo-disabled-field)').length > 0) {
      return 0;
    }
    var currentVariationID = parseInt($('.woocommerce-variation-add-to-cart .variation_id').val(), 10);
    var variationMeta = typeof _currentVariationMetas !== 'undefined' ? _currentVariationMetas : null;
    if (!variationMeta || variationMeta.variation_id !== currentVariationID) {
      $.each(_variations || [], function () {
        if ($(this)[0].variation_id === currentVariationID) {
          variationMeta = $(this)[0];
          return false;
        }
      });
    }
    var cutFee = variationMeta && typeof variationMeta.mm_board_cut_fee !== 'undefined' ? getNumber(variationMeta.mm_board_cut_fee) : 0;
    window.configurator_options.mm_board_cut_fee = cutFee;
    return cutFee;
  };
  var getOptionsPrice = function getOptionsPrice(amount) {
    var _totalOptionsPrice = 0;
    // handle all selects fields with paid options
    $('select.thwepo-price-field').each(function () {
      var $currentOption = $(this).find(":selected");
      if (typeof $currentOption.attr('data-price-type') !== 'undefined' && $currentOption.attr('data-price-type') !== null) {
        var _priceType = $currentOption.attr('data-price-type');
        var _price = parseFloat($currentOption.attr('data-price'));
        switch (_priceType) {
          case 'percentage':
            _totalOptionsPrice += amount * (_price / 100);
            break;
          case 'normal':
            _totalOptionsPrice += _price;
            break;
        }
        window.configurator_options[$currentOption.attr('name')] = _price;
      }
    });

    // handle all hidden fields with paid options
    $('input[type="hidden"].thwepo-price-field:not(.thwepo-disabled-field)').each(function () {
      var $currentOption = $(this);
      if (neutralizeValiseLegacyHiddenPriceField($currentOption)) {
        return;
      }
      if (isRackConfiguratorPriceContext() && $currentOption.attr('id') === 'frais_capot_plat') {
        window.configurator_options.rack_legacy_flat_cap_hidden_fee_skipped = getNumber($currentOption.attr('data-price'));
        $currentOption.val(0);
        return;
      }
      if (typeof $currentOption.attr('data-price-type') !== 'undefined' && $currentOption.attr('data-price-type') !== null) {
        var _priceType = $currentOption.attr('data-price-type');
        var _price = parseFloat($currentOption.attr('data-price'));
        switch (_priceType) {
          case 'percentage':
            _totalOptionsPrice += amount * (_price / 100);
            $currentOption.val(_price);
            break;
          case 'normal':
            _totalOptionsPrice += _price;
            $currentOption.val(_price);
            break;
          case 'custom':
            var addVariablePrice = false;
            if ($currentOption.attr('id') === 'frais_configuration') {
              var surface = parseFloat($('input#_measurement_needed').val());
              var linearmeters = (parseFloat($('input#length_needed').val()) + parseFloat($('input#width_needed').val()) + parseFloat($('input#height_needed').val())) / 1000;
              var capLength = (parseFloat($('input#length_needed').val()) + parseFloat($('input#width_needed').val())) / 1000;
              var clocheReference = isRackClocheReferencePricing();
              var referenceAccessories = clocheReference ? getRackClocheReferenceAccessories() : null;
              if (clocheReference) {
                var referenceDimensions = getRackClocheReferenceDimensions();
                surface = getRectangularCaseSurfaceM2(referenceDimensions.length, referenceDimensions.width, referenceDimensions.height);
                linearmeters = (referenceDimensions.length + referenceDimensions.width + referenceDimensions.height) / 1000;
                capLength = (referenceDimensions.length + referenceDimensions.width) / 1000;
              }
              var accessoryFamilyPrefix = clocheReference ? 'cloche' : getConfiguratorPriceFamily();
              var mobilityState = syncMobilityPricingState();
              if (clocheReference) {
                mobilityState = {
                  family: 'cloche',
                  type: mobilityState.type,
                  count: referenceAccessories.wheelCount + referenceAccessories.palletFootCount,
                  wheelCount: referenceAccessories.wheelCount,
                  palletFootCount: referenceAccessories.palletFootCount
                };
              }
              var palletFeetPrice = getPalletFeetPrice(mobilityState);
              var catalogCoreAccessoryPricing = accessoryFamilyPrefix === 'malle' || accessoryFamilyPrefix === 'cloche' || accessoryFamilyPrefix === 'valise';
              var detailedAccessoryPricing = accessoryFamilyPrefix === 'malle' || accessoryFamilyPrefix === 'cloche';
              var valiseAccessoryBreakdown = accessoryFamilyPrefix === 'valise' ? getValiseV2AccessoryBreakdown() : null;
              var cornerCatalogCode = accessoryFamilyPrefix === 'valise' && isValiseLightweightPanelSelection() ? 'valise_corner_20x20' : accessoryFamilyPrefix + '_corner_30x30';
              var cornerUnitPrice = catalogCoreAccessoryPricing ? getConfiguratorAccessoryUnitPrice(cornerCatalogCode, getNumber(window.configurator_options.prix_corniere_30x30)) : getNumber(window.configurator_options.prix_corniere_30x30);
              var profileUnitPrice = catalogCoreAccessoryPricing ? getConfiguratorAccessoryUnitPrice(accessoryFamilyPrefix + '_profile_male_female', getNumber(window.configurator_options.prix_mf_alu)) : getNumber(window.configurator_options.prix_mf_alu);
              var clocheDoubleProfilePrice = getClocheDoubleProfilePrice(profileUnitPrice);
              var lockerUnitPrice = detailedAccessoryPricing ? getConfiguratorAccessoryUnitPrice(accessoryFamilyPrefix + '_locker', getNumber(window.configurator_options.prix_fermoirs)) : getNumber(window.configurator_options.prix_fermoirs);
              var handleUnitPrice = detailedAccessoryPricing ? getConfiguratorAccessoryUnitPrice(accessoryFamilyPrefix + '_handle', getNumber(window.configurator_options.prix_poignees)) : getNumber(window.configurator_options.prix_poignees);
              var wheelUnitPrice = detailedAccessoryPricing ? getConfiguratorAccessoryUnitPrice(accessoryFamilyPrefix + '_wheel', getNumber(window.configurator_options.prix_roulettes)) : getNumber(window.configurator_options.prix_roulettes);
              var lockerPrice = getNumber(window.configurator_options.nbr_lockers) * lockerUnitPrice;
              var handlePrice = getNumber(window.configurator_options.nbr_handles) * handleUnitPrice;
              var wheelPrice = getNumber(window.configurator_options.nbr_wheels) * wheelUnitPrice;
              var cornerHardwarePrice = 0;
              var bracePrice = 0;
              if (clocheReference) {
                lockerPrice = referenceAccessories.lockerCount * getConfiguratorAccessoryUnitPrice(referenceAccessories.lockerCode, lockerUnitPrice);
                handlePrice = referenceAccessories.handleCount * getConfiguratorAccessoryUnitPrice('cloche_handle_standard', handleUnitPrice);
                wheelPrice = referenceAccessories.wheelCount * getConfiguratorAccessoryUnitPrice('cloche_wheel_standard', wheelUnitPrice);
                cornerHardwarePrice = referenceAccessories.cornerCount * getConfiguratorAccessoryUnitPrice(referenceAccessories.cornerCode, getNumber(window.configurator_options.prix_corniere_30x30));
                bracePrice = 0;
              } else if (accessoryFamilyPrefix === 'valise' && valiseAccessoryBreakdown) {
                lockerPrice = 0;
                handlePrice = 0;
                wheelPrice = 0;
                cornerHardwarePrice = 0;
                bracePrice = 0;
              } else if (detailedAccessoryPricing) {
                lockerPrice = getMalleDetailedPiecePrice([{
                  code: accessoryFamilyPrefix + '_locker_large',
                  countKey: accessoryFamilyPrefix + '_locker_large_count'
                }, {
                  code: accessoryFamilyPrefix + '_locker_medium',
                  countKey: accessoryFamilyPrefix + '_locker_medium_count'
                }, {
                  code: accessoryFamilyPrefix + '_cap_locker_medium',
                  countKey: accessoryFamilyPrefix + '_cap_locker_medium_count'
                }], accessoryFamilyPrefix + '_locker', window.configurator_options.nbr_lockers, lockerUnitPrice);
                handlePrice = getMalleDetailedPiecePrice([{
                  code: accessoryFamilyPrefix + '_handle_standard',
                  countKey: accessoryFamilyPrefix + '_handle_standard_count'
                }], accessoryFamilyPrefix + '_handle', window.configurator_options.nbr_handles, handleUnitPrice);
                wheelPrice = getMalleDetailedPiecePrice([{
                  code: accessoryFamilyPrefix + '_wheel_standard',
                  countKey: accessoryFamilyPrefix + '_wheel_standard_count'
                }], accessoryFamilyPrefix + '_wheel', window.configurator_options.nbr_wheels, wheelUnitPrice);
                cornerHardwarePrice = getMalleDetailedPiecePrice([{
                  code: accessoryFamilyPrefix + '_corner_ball_large',
                  countKey: accessoryFamilyPrefix + '_corner_ball_large_count'
                }, {
                  code: accessoryFamilyPrefix + '_corner_ball_medium',
                  countKey: accessoryFamilyPrefix + '_corner_ball_medium_count'
                }, {
                  code: accessoryFamilyPrefix + '_corner_flat',
                  countKey: accessoryFamilyPrefix + '_corner_flat_count'
                }], accessoryFamilyPrefix + '_corner_ball', 0, getNumber(window.configurator_options.prix_corniere_30x30));
                bracePrice = getMalleDetailedPiecePrice([{
                  code: accessoryFamilyPrefix + '_brace',
                  countKey: accessoryFamilyPrefix + '_brace_count'
                }], accessoryFamilyPrefix + '_brace', 0, 0);
              }
              window.configurator_options.accessory_price_family = accessoryFamilyPrefix || 'legacy';
              window.configurator_options.accessory_corner_code = catalogCoreAccessoryPricing ? cornerCatalogCode : 'legacy';
              window.configurator_options.valise_corner_profile_mm = accessoryFamilyPrefix === 'valise' ? isValiseLightweightPanelSelection() ? 20 : 30 : 0;
              window.configurator_options.accessory_corner_unit_price = cornerUnitPrice;
              window.configurator_options.accessory_profile_unit_price = profileUnitPrice;
              window.configurator_options.accessory_profile_base_length_m = capLength * 2;
              window.configurator_options.accessory_profile_base_price = capLength * 2 * profileUnitPrice;
              window.configurator_options.accessory_profile_total_length_m = capLength * 2 + getNumber(window.configurator_options.cloche_double_profile_length_m);
              window.configurator_options.accessory_profile_total_price = capLength * 2 * profileUnitPrice + clocheDoubleProfilePrice;
              window.configurator_options.accessory_locker_unit_price = lockerUnitPrice;
              window.configurator_options.accessory_handle_unit_price = handleUnitPrice;
              window.configurator_options.accessory_wheel_unit_price = wheelUnitPrice;
              window.configurator_options.accessory_locker_price = lockerPrice;
              window.configurator_options.accessory_handle_price = handlePrice;
              window.configurator_options.accessory_wheel_price = wheelPrice;
              window.configurator_options.accessory_pallet_feet_price = palletFeetPrice;
              window.configurator_options.accessory_corner_hardware_price = cornerHardwarePrice;
              window.configurator_options.accessory_brace_price = bracePrice;

              // longueur cornière = linearmeters*4
              addVariablePrice = linearmeters * 4 * cornerUnitPrice;
              // longueur capot = capLength*2
              addVariablePrice += capLength * 2 * profileUnitPrice * 1;
              // jonction supplementaire de la cloche double : face + dos + dessus
              addVariablePrice += clocheDoubleProfilePrice;
              // fermoirs
              addVariablePrice += lockerPrice;
              // poignées
              addVariablePrice += handlePrice;
              // roulettes
              addVariablePrice += wheelPrice;
              // plots palettisables et leur fixation (choix exclusif avec les roulettes)
              addVariablePrice += palletFeetPrice;
              // coins et braces detailles par famille
              addVariablePrice += cornerHardwarePrice;
              addVariablePrice += bracePrice;
              // quincaillerie, poignee principale, fermoirs, trolley et poignees laterales Valise v2
              if (valiseAccessoryBreakdown) {
                addVariablePrice += valiseAccessoryBreakdown.total;
              }
              // plateau roulettes rack en CP 18mm, calcule au m2
              addVariablePrice += getRackWheelBoardPrice();
              // consommables rails rack 19 pouces : 4 pieces par unite U cochee
              addVariablePrice += getRackRailFastenersPrice();
              // moussage calcule au m2, separe des variations matiere
              addVariablePrice += getConfiguratorFoamPrice();
              // forfaits et main d'oeuvre
              if (!isValisePricingV2Enabled()) {
                addVariablePrice += getNumber(window.configurator_options.forfait_accessoires);
              }
              if (isRackConfiguratorPriceContext() || isMalleConfiguratorPriceContext() || isClocheConfiguratorPriceContext() || isValisePricingV2Enabled()) {
                addVariablePrice += getConfiguratorLaborVariablePrice(surface, linearmeters);
              } else {
                addVariablePrice += getNumber(window.configurator_options.forfait_horaire);
                addVariablePrice += getConfiguratorLaborVariablePrice(surface, linearmeters);
              }
              // ajustement capot rack : prix commercial ajoute apres coefficient global
              window.configurator_options.rack_post_coefficient_price_adjustment = getRackPostCoefficientPriceAdjustment(getConfiguratorTotalPriceCoefficient());
              // fermoirs supplementaires des capots rack quand la hauteur impose 2 fermoirs par capot
              var extraRackLockerPrice = getNumber(window.configurator_options.rack_extra_locker_price_adjustment);
              if (clocheReference) {
                // Le premier capot est inclus dans la base Cloche.
                // La moitie du supplement historique double est
                // propre au capot arriere ; ne jamais le cumuler.
                extraRackLockerPrice = rackHasRearCap() ? extraRackLockerPrice / 2 : 0;
              }
              window.configurator_options.rack_extra_locker_price_applied = extraRackLockerPrice;
              addVariablePrice += extraRackLockerPrice;
              // correction prix plaques completes plafonnee par coefficient total
              addVariablePrice += getPlatePricingCorrection(amount, addVariablePrice);
            }
            var amountToAdd = 0;
            if (addVariablePrice !== false) {
              amountToAdd += addVariablePrice;
            }

            // enregistre le total “frais de config”
            if ($currentOption.attr('id') === 'frais_configuration') {
              window.configurator_options.frais_configuration_base_amount = amountToAdd;
            }
            var finalPriceToAdd = (Math.round(amountToAdd * 100) / 100).toFixed(2);
            _totalOptionsPrice += amountToAdd;
            $currentOption.attr('data-base-price', finalPriceToAdd);
            $currentOption.attr('data-price', finalPriceToAdd);
            $currentOption.val(finalPriceToAdd);
            break;
        }
        window.configurator_options[$currentOption.attr('name')] = _price;
      }
    });
    _totalOptionsPrice += getBoardVariationCutFee();

    // handle all checkboxes fields with paid options
    $('input[type="checkbox"].thwepo-price-field').each(function () {
      var $currentOption = $(this);
      if (typeof $currentOption.attr('data-price-type') !== 'undefined' && $currentOption.attr('data-price-type') !== null && $currentOption.is(':checked')) {
        var _priceType = $currentOption.attr('data-price-type');
        var _price = parseFloat($currentOption.attr('data-price'));
        _price = getMalleCatalogCheckboxPrice($currentOption, _price);
        switch (_priceType) {
          case 'percentage':
            _totalOptionsPrice += amount * (_price / 100);
            break;
          case 'normal':
            _totalOptionsPrice += _price;
            break;
        }
        window.configurator_options[$currentOption.attr('name')] = _price;
      }
    });
    $('input[type="radio"].thwepo-price-field').each(function () {
      var $currentOption = $(this);
      if (typeof $currentOption.attr('data-price-type') !== 'undefined' && $currentOption.attr('data-price-type') !== null && $currentOption.is(':checked')) {
        var _priceType = $currentOption.attr('data-price-type');
        var _price = parseFloat($currentOption.attr('data-price'));
        switch (_priceType) {
          case 'percentage':
            _totalOptionsPrice += amount * (_price / 100);
            break;
          case 'normal':
            _totalOptionsPrice += _price;
            break;
        }
        window.configurator_options[$currentOption.attr('name')] = _price;
      }
    });
    return _totalOptionsPrice;
  };
  var getRackCanonicalCapMaterialSurchargeForCart = function getRackCanonicalCapMaterialSurchargeForCart(totalPriceCoefficient) {
    if (!isRackConfiguratorPriceContext() || $('#pa_configurateur-type-de-capot').val() === 'capot-plat') {
      return 0;
    }
    var rackLengthState = getRackCustomLengthPricingState();
    if (rackLengthState.applicable && !rackLengthState.valid) {
      return 0;
    }
    var rawBandMaterialPrice = getNumber(window.configurator_options.rack_material_classic_cap_band_price);
    var coefficient = getNumber(totalPriceCoefficient);
    if (coefficient <= 0) {
      coefficient = 1;
    }
    return Math.round(rawBandMaterialPrice * coefficient * 100) / 100;
  };
  var syncConfigurationFeeForCart = function syncConfigurationFeeForCart(coefficientAmount, postCoefficientPriceAdjustment, measurementPriceAdjustment, totalPriceCoefficient) {
    var $configurationFee = $('#frais_configuration');
    if (!$configurationFee.length) {
      return;
    }
    var storedBaseFee = window.configurator_options.frais_configuration_base_amount;
    var baseFee = typeof storedBaseFee !== 'undefined' ? getNumber(storedBaseFee) : getNumber($configurationFee.attr('data-base-price') || $configurationFee.val() || $configurationFee.attr('data-price'));
    var canonicalRackCapMaterialSurcharge = getRackCanonicalCapMaterialSurchargeForCart(totalPriceCoefficient);
    var cartFee = baseFee + getNumber(coefficientAmount) + getNumber(postCoefficientPriceAdjustment) + getNumber(measurementPriceAdjustment) - canonicalRackCapMaterialSurcharge;
    var cartFeeValue = (Math.round(cartFee * 100) / 100).toFixed(2);
    $configurationFee.attr('data-price', cartFeeValue);
    $configurationFee.val(cartFeeValue);
    window.configurator_options.frais_configuration_base_price = baseFee;
    window.configurator_options.frais_configuration_cart_price = cartFeeValue;
    window.configurator_options.frais_configuration_coefficient_amount = getNumber(coefficientAmount);
    window.configurator_options.frais_configuration_post_coefficient_amount = getNumber(postCoefficientPriceAdjustment);
    window.configurator_options.frais_configuration_measurement_price_adjustment = getNumber(measurementPriceAdjustment);
    window.configurator_options.frais_configuration_rack_cap_material_server_surcharge = canonicalRackCapMaterialSurcharge;
  };
  var getTotalAmount = function getTotalAmount(amountMPC) {
    var _amountFloat = amountMPC.replace(',', '.');
    _amountFloat = _amountFloat.replace('€', '');
    _amountFloat = parseFloat(_amountFloat);
    var cartMeasurementAmount = _amountFloat;
    _amountFloat = getFoamNeutralizedMeasurementAmount(_amountFloat);
    _amountFloat = getFlightCaseMaterialCatalogMeasurementAmount(_amountFloat);
    var measurementPriceAdjustment = _amountFloat - cartMeasurementAmount;
    window.configurator_options.measurement_price = _amountFloat;
    window.configurator_options.cart_measurement_price = cartMeasurementAmount;
    window.configurator_options.measurement_price_adjustment = measurementPriceAdjustment;
    var _optionsPrice = getOptionsPrice(_amountFloat);
    var subtotalBeforeCoefficient = _amountFloat + _optionsPrice;
    var totalPriceCoefficient = getConfiguratorTotalPriceCoefficient();
    var coefficientAmount = subtotalBeforeCoefficient * (totalPriceCoefficient - 1);
    var rackFlatCapEstimate = getRackFlatAdditionalCapRealPriceEstimate(totalPriceCoefficient);
    var postCoefficientPriceAdjustment = getRackPostCoefficientPriceAdjustment(totalPriceCoefficient, rackFlatCapEstimate);
    _amountFloat = subtotalBeforeCoefficient * totalPriceCoefficient + postCoefficientPriceAdjustment;
    window.configurator_options.options_price = _optionsPrice;
    window.configurator_options.post_coefficient_options_price = postCoefficientPriceAdjustment;
    window.configurator_options.total_price_before_coefficient = subtotalBeforeCoefficient;
    window.configurator_options.total_price_coefficient_applied = totalPriceCoefficient;
    window.configurator_options.total_price_coefficient_amount = coefficientAmount;
    syncConfigurationFeeForCart(coefficientAmount, postCoefficientPriceAdjustment, measurementPriceAdjustment, totalPriceCoefficient);
    var _quantity = $('.quantity input[name=quantity]').val();
    _amountFloat = _amountFloat * _quantity;
    window.configurator_options.quantity_selected = _quantity;
    var totalAmount = (Math.round(_amountFloat * 100) / 100).toFixed(2);
    window.configurator_options.total_amount = totalAmount;
    return totalAmount.toString();
  };
  var applyTrolleyDiscount = function applyTrolleyDiscount(amount) {
    var width = parseInt($('.width-input:first input[name="width_needed"]').val());
    var length = parseInt($('.length-input:first input[name="length_needed"]').val());
    var isTrolley = $('#pa_configurateur-trolley').val() === 'trolley-roul';
    var valid = !isNaN(width) && !isNaN(length) && width >= 310 && width <= 1000 && length >= 600 && length <= 2000;
    if (isTrolley && valid && length >= 900) {
      // Removed legacy discount; trolley option already priced correctly.
    }
    return amount;
  };
  var setShipmentDetail = function setShipmentDetail(details) {
    if (details !== '') {
      $('.js--shipment_details').text(details);
    } else {
      var $jsShipmentBlock = $('.js--shipment_details');
      $jsShipmentBlock.text($jsShipmentBlock.attr('data-no-detail'));
    }
  };
  var setMaxInput = function setMaxInput(type, value) {
    var input, info;
    switch (type) {
      case 'length':
        input = $('.js--max-length_needed-input:first');
        if (input.length === 0) {
          input = $('#length_needed');
        }
        info = $('.js--max-length_needed-info:first');
        break;
      case 'width':
        input = $('.js--max-width_needed-input:first');
        if (input.length === 0) {
          input = $('#width_needed');
        }
        info = $('.js--max-width_needed-info:first');
        break;
      case 'height':
        input = $('.js--max-height_needed-input:first');
        if (input.length === 0) {
          input = $('#height_needed');
        }
        info = $('.js--max-height_needed-info:first');
        break;
    }
    var _condition = !isNaN(value) && typeof info !== 'undefined' && typeof input !== 'undefined' && input.length > 0 && info.length > 0;
    if (_condition) {
      var maxValue = value;
      if (value === '') {
        switch (type) {
          case 'length':
            maxValue = defaultMaxLength;
            break;
          case 'width':
            maxValue = defaultMaxWidth;
            break;
          case 'height':
            maxValue = defaultMaxHeight;
            break;
        }
      }
      maxValue = getEffectiveMaxInputValue(type, maxValue);
      input.get(0).setAttribute("max", maxValue);
      info.text('(max ' + maxValue + 'mm)');
      clampMeasurementInputToMax(input);
    }
  };
  var revealDocumentation = function revealDocumentation(doc_url, variation_description) {
    var _docBtn = $('.js--pdf-documentation');
    var _isValidDocUrl = doc_url !== '' && validUrl.isWebUri(doc_url);
    var _issetDocumentation = _docBtn.length !== 0;
    if (_isValidDocUrl && !_issetDocumentation) {
      var _elt = $('<button>');
      $(_elt).addClass('button').addClass('secondary').addClass('js--pdf-documentation');
      $(_elt).attr('data-open', 'modal-fiche-technique');
      $(_elt).text("Consulter la fiche technique");
      var _elt2 = $('<div>');
      $(_elt2).addClass('reveal large').attr('id', 'modal-fiche-technique').attr('data-reveal', 'true');
      $(_elt2).append('<h1>Fiche technique</h1><p class="lead">' + variation_description + '</p>');
      $(_elt2).append('<img src="' + doc_url + '" alt="Fiche Technique" />');
      $(_elt2).append('<button class="close-button" data-close aria-label="Close modal" type="button"><span aria-hidden="true">&times;</span></button>');
      var _container = $('<div>');
      _container.append(_elt);
      _container.append(_elt2);
      $('.product-single__cat .display-cell').append(_container);
      $('#modal-fiche-technique').foundation();
    } else if (_issetDocumentation) {
      _docBtn.remove();
    }
  };
  var setVariationImg = function setVariationImg(imgSrc) {
    if (typeof imgSrc !== 'undefined' && imgSrc !== '') {
      if ($imgElt.length > 0) {
        $imgElt.css('opacity', 0);
        $imgElt.attr('src', imgSrc);
        $imgElt.attr('data-src-selected', imgSrc);
        $imgElt.animate({
          'opacity': 1
        });
      }
    }
  };
  var updateProductMeta = function updateProductMeta() {
    var currentVariationID = $('.woocommerce-variation-add-to-cart .variation_id').val();
    if (currentVariationID !== '') {
      var _metaInfo = null;
      $.each(_variations, function () {
        if ($(this)[0].variation_id === parseInt(currentVariationID)) {
          _metaInfo = $(this)[0];
          _currentVariationMetas = _metaInfo;
        }
      });
      if (_metaInfo !== null) {
        setShipmentDetail(_metaInfo.shipment_details);
        setMaxInput('height', _metaInfo.max_height);
        setMaxInput('width', _metaInfo.max_width);
        setMaxInput('length', _metaInfo.max_length);
        revealDocumentation(_metaInfo.pdf_doc, _metaInfo.variation_description);
        setTimeout(function () {
          setVariationImg(_metaInfo.image.url);
        }, 200);
      }
    } else {
      setMaxInput('height', defaultMaxHeight);
      setMaxInput('width', defaultMaxWidth);
      setMaxInput('length', defaultMaxLength);
      revealDocumentation('', '');
    }
    $('#conex-calculated-price').trigger('wc-measurement-price-calculator-product-price-change');
  };
  var setRackCustomPricingAvailability = function setRackCustomPricingAvailability(lengthState) {
    var blocked = lengthState.applicable && !lengthState.valid;
    var $form = $('form.cart').first();
    var $price = $('#conex-calculated-price');
    var $buttons = $form.find('.single_add_to_cart_button');
    $('body').toggleClass('rack-custom-length-pricing-invalid', blocked);
    $form.attr('data-rack-custom-length-pricing-valid', blocked ? 'no' : 'yes');
    $form.attr('data-rack-custom-length-pricing-reason', lengthState.reason);
    if (!blocked) {
      window.configurator_options.rack_custom_length_pricing_blocked = 'no';
      window.configurator_options.rack_custom_length_pricing_blocked_reason = '';
      $buttons.filter('[data-rack-custom-length-pricing-blocked="yes"]').each(function () {
        var $button = $(this);
        if ($button.attr('data-rack-custom-length-pricing-was-disabled') !== 'yes') {
          $button.prop('disabled', false);
        }
        if ($button.attr('data-rack-custom-length-pricing-had-disabled-class') !== 'yes') {
          $button.removeClass('disabled');
        }
        $button.removeAttr('data-rack-custom-length-pricing-blocked');
        $button.removeAttr('data-rack-custom-length-pricing-was-disabled');
        $button.removeAttr('data-rack-custom-length-pricing-had-disabled-class');
      });
      return;
    }

    // Ne jamais neutraliser les montants THWEPO ou les instantanes de prix
    // ici : le champ total peut etre momentanement incoherent pendant que
    // l'UI derive length_needed. Masquer le prix et bloquer l'ajout suffit;
    // au retour valide, le recalcul synchrone repart des valeurs intactes.
    window.configurator_options.rack_custom_length_pricing_blocked = 'yes';
    window.configurator_options.rack_custom_length_pricing_blocked_reason = lengthState.reason;
    $buttons.each(function () {
      var $button = $(this);
      if ($button.attr('data-rack-custom-length-pricing-blocked') !== 'yes') {
        $button.attr('data-rack-custom-length-pricing-was-disabled', $button.prop('disabled') ? 'yes' : 'no');
        $button.attr('data-rack-custom-length-pricing-had-disabled-class', $button.hasClass('disabled') ? 'yes' : 'no');
      }
      $button.attr('data-rack-custom-length-pricing-blocked', 'yes');
      $button.prop('disabled', true).addClass('disabled');
    });
    $('.js--update-price').html('');
    $price.hide();
  };
  var updateProductPrice = function updateProductPrice() {
    var _amountMPC;
    var valiseCapTypeMissing = isValisePricingV2Enabled() && !getValiseCapType();
    var rackLengthState = getRackCustomLengthPricingState();
    setRackCustomPricingAvailability(rackLengthState);
    if (rackLengthState.applicable && !rackLengthState.valid) {
      return;
    }
    if ($('#price_calculator').length > 0) {
      _amountMPC = $('#price_calculator .amount').html();
    } else if (typeof _currentVariationMetas !== 'undefined') {
      _amountMPC = _currentVariationMetas.display_price + "€";
      _amountMPC.replace('.', ',');
    }
    if (typeof _amountMPC !== 'undefined' && _amountMPC !== '0,00€') {
      var _amountFloat = parseFloat(getTotalAmount(_amountMPC));
      _amountFloat = applyTrolleyDiscount(_amountFloat);
      if (valiseCapTypeMissing) {
        window.configurator_options.valise_cap_type = '';
        window.configurator_options.total_amount = '';
        $('.js--update-price').html('');
        $('#conex-calculated-price').hide();
        return;
      }
      window.configurator_options.total_amount = _amountFloat.toFixed(2);
      var _amountHtml = _amountFloat.toFixed(2).replace('.', '<sup>€');
      _amountHtml = _amountHtml + '</sup>';
      $('.js--update-price').html(_amountHtml);
      $('#conex-calculated-price').show();
    } else {
      $('.js--update-price').html('');
      $('#conex-calculated-price').hide();
    }
  };
  var initCutProfileFamilyChooser = function initCutProfileFamilyChooser() {
    var buttons = $('.js--profile-family-choice');
    var familySelect = $('#pa_aluminium-family');
    if (buttons.length === 0 || familySelect.length === 0) {
      return;
    }
    var syncProfileFamilyButtons = function syncProfileFamilyButtons() {
      var selectedFamily = familySelect.val();
      buttons.each(function () {
        var button = $(this);
        var isSelected = button.attr('data-profile-family') === selectedFamily;
        button.toggleClass('is-active', isSelected);
        button.attr('aria-pressed', isSelected ? 'true' : 'false');
      });
    };
    buttons.on('click', function () {
      var selectedFamily = $(this).attr('data-profile-family');
      if (familySelect.find('option[value="' + selectedFamily + '"]').length === 0) {
        return;
      }
      familySelect.val(selectedFamily).trigger('change');
      syncProfileFamilyButtons();
    });
    familySelect.on('change', function () {
      syncProfileFamilyButtons();
      updateConfiguratorSteps();
    });
    syncProfileFamilyButtons();
  };
  var accessoryFilterDefinitions = {
    '1268': [{
      label: 'Arrêtoirs',
      keywords: ['arrêtoir']
    }, {
      label: 'Compas',
      keywords: ['compas']
    }, {
      label: 'Barres et piano',
      keywords: ['en barre', 'piano']
    }, {
      label: 'Stop et capot',
      keywords: ['stop', 'capot', 'en l']
    }],
    '1266': [{
      label: 'Métal',
      keywords: ['coin métal']
    }, {
      label: 'Coins plats',
      keywords: ['coin plat']
    }, {
      label: 'Capot plat',
      keywords: ['capot']
    }],
    '1273': [{
      label: 'Ventilation',
      keywords: ['aération', 'ventilation']
    }, {
      label: 'Connectique',
      keywords: ['connecteur', 'passage de câble']
    }, {
      label: 'Superposition',
      keywords: ['superposition', 'roulettes']
    }, {
      label: 'Levage',
      keywords: ['levage', 'accroche']
    }],
    '1267': [{
      label: 'Papillon',
      keywords: ['papillon']
    }, {
      label: 'Grenouille',
      keywords: ['grenouille']
    }, {
      label: 'Capot plat',
      keywords: ['capot']
    }],
    '2236': [{
      label: 'Rivets',
      keywords: ['rivet']
    }, {
      label: 'Visserie',
      keywords: ['écrou', 'vis', 'rondelle']
    }, {
      label: 'Outils',
      keywords: ['riveteuse', 'foret', 'colle']
    }, {
      label: 'Kits',
      keywords: ['kit']
    }],
    '1272': [{
      label: 'Supports',
      keywords: ['support']
    }, {
      label: 'Caoutchouc',
      keywords: ['caoutchouc']
    }, {
      label: 'Gerbage et métal',
      keywords: ['gerbage', 'métallique', 'acier']
    }, {
      label: 'Plastique',
      keywords: ['plastique']
    }],
    '1269': [{
      label: 'Télescopiques',
      keywords: ['télescopique']
    }, {
      label: 'Encastrées',
      keywords: ['encastrée', 'encastrable', "d'angle"]
    }, {
      label: 'Surface',
      keywords: ['de surface', 'rétractable']
    }, {
      label: 'Valise',
      keywords: ['valise', 'cuir']
    }, {
      label: 'Plaques',
      keywords: ['contre plaque']
    }],
    '1270': [{
      label: 'Grands modèles',
      keywords: ['grand modèle']
    }, {
      label: 'Petits modèles',
      keywords: ['petit modèle']
    }, {
      label: 'Techniques',
      keywords: ['passage', 'large', 'noir']
    }],
    '1271': [{
      label: 'Pivotantes',
      keywords: ['pivotante', 'lot de roulettes']
    }, {
      label: 'D’angle',
      keywords: ["d'angle", 'renfort coin']
    }, {
      label: 'Encastrées',
      keywords: ['encastrer']
    }]
  };
  var normalizeAccessorySearch = function normalizeAccessorySearch(value) {
    var normalized = (value || '').toString().toLowerCase();
    if (typeof normalized.normalize === 'function') {
      normalized = normalized.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    }
    return normalized;
  };
  var getAccessoryFilter = function getAccessoryFilter(productID, label) {
    var definitions = accessoryFilterDefinitions[productID] || [];
    var normalizedLabel = normalizeAccessorySearch(label);
    var result = 'other';
    $.each(definitions, function (index, definition) {
      var matches = false;
      $.each(definition.keywords, function (keywordIndex, keyword) {
        if (normalizedLabel.indexOf(normalizeAccessorySearch(keyword)) !== -1) {
          matches = true;
          return false;
        }
      });
      if (matches) {
        result = 'group-' + index;
        return false;
      }
    });
    return result;
  };
  var formatAccessoryPrice = function formatAccessoryPrice(value) {
    var price = getNumber(value);
    if (price <= 0) {
      return '';
    }
    return price.toFixed(2).replace('.', ',') + ' € HT';
  };
  var initAccessoryPicker = function initAccessoryPicker() {
    var purchase = $('.accessory-product__purchase:first');
    var target = purchase.find('.js--accessory-picker-target:first');
    var form = purchase.find('.variations_form.cart:first');
    var select = form.find('.variations select:first');
    var rawVariations = form.attr('data-product_variations');
    var productID = (form.attr('data-product_id') || $('.accessory-product:first').attr('data-accessory-product-id') || '').toString();
    var variations = [];
    if (purchase.length === 0 || target.length === 0 || form.length === 0 || select.length === 0 || !rawVariations) {
      return;
    }
    try {
      variations = $.parseJSON(rawVariations);
    } catch (error) {
      return;
    }
    var attributeName = select.attr('name');
    var definitions = accessoryFilterDefinitions[productID] || [];
    var items = [];
    var variationByValue = {};
    $.each(variations, function () {
      var variation = $(this)[0];
      var value = variation && variation.attributes ? variation.attributes[attributeName] : '';
      if (value) {
        variationByValue[value] = variation;
      }
    });
    select.find('option').each(function () {
      var option = $(this);
      var value = option.attr('value');
      var variation;
      var label;
      var reference;
      var referencePosition;
      if (!value) {
        return;
      }
      variation = variationByValue[value] || null;
      label = $.trim(option.text());
      reference = variation && variation.sku ? variation.sku.toString() : '';
      if (reference) {
        referencePosition = label.toLowerCase().lastIndexOf(reference.toLowerCase());
        if (referencePosition > 0 && referencePosition + reference.length >= label.length - 1) {
          label = $.trim(label.substring(0, referencePosition));
        }
      }
      items.push({
        value: value,
        label: label,
        reference: reference,
        price: variation ? variation.display_price : 0,
        inStock: !variation || variation.is_in_stock !== false,
        filter: getAccessoryFilter(productID, option.text())
      });
    });
    if (items.length === 0) {
      return;
    }
    var picker = $('<div class="accessory-picker"></div>');
    var heading = $('<div class="accessory-picker__heading"></div>');
    var headingCopy = $('<div><strong>Choisissez votre modèle</strong><small class="accessory-picker__count" aria-live="polite"></small></div>');
    var reset = $('<button class="accessory-picker__reset" type="button">Réinitialiser</button>').prop('hidden', true);
    var tools = $('<div class="accessory-picker__tools"></div>');
    var filters = $('<div class="accessory-picker__filters" role="group" aria-label="Filtrer les modèles"></div>');
    var list = $('<div class="accessory-picker__list" role="group" aria-label="Références disponibles"></div>');
    var empty = $('<p class="accessory-picker__empty" hidden>Aucune référence ne correspond à cette recherche.</p>');
    var search = null;
    var activeFilter = 'all';
    heading.append(headingCopy, reset);
    picker.append(heading);
    if (items.length >= 9) {
      var searchID = 'accessory-model-search-' + productID;
      var searchLabel = $('<label class="accessory-picker__search" for="' + searchID + '"><span>Rechercher une référence</span></label>');
      search = $('<input type="search" id="' + searchID + '" autocomplete="off" placeholder="Nom, usage ou référence…" />');
      searchLabel.append(search);
      tools.append(searchLabel);
    }
    var filterCounts = {};
    $.each(items, function (index, item) {
      filterCounts[item.filter] = (filterCounts[item.filter] || 0) + 1;
    });
    if (definitions.length > 0) {
      filters.append('<button class="is-active" type="button" data-accessory-filter="all" aria-pressed="true">Tous</button>');
      $.each(definitions, function (index, definition) {
        var filterValue = 'group-' + index;
        if (filterCounts[filterValue]) {
          $('<button type="button"></button>').attr('data-accessory-filter', filterValue).attr('aria-pressed', 'false').text(definition.label).appendTo(filters);
        }
      });
      tools.append(filters);
    }
    if (tools.children().length > 0) {
      picker.append(tools);
    }
    $.each(items, function (index, item) {
      var button = $('<button class="accessory-picker__option" type="button"></button>');
      var name = $('<span class="accessory-picker__option-name"></span>').text(item.label);
      var meta = $('<span class="accessory-picker__option-meta"></span>');
      button.attr('data-accessory-value', item.value);
      button.attr('data-accessory-filter', item.filter);
      button.attr('data-accessory-search', normalizeAccessorySearch(item.label + ' ' + item.reference));
      button.attr('aria-pressed', 'false');
      if (item.reference) {
        $('<span class="accessory-picker__reference"></span>').text('Réf. ' + item.reference).appendTo(meta);
      }
      if (item.inStock) {
        $('<strong class="accessory-picker__price"></strong>').text(formatAccessoryPrice(item.price)).appendTo(meta);
      } else {
        button.prop('disabled', true).addClass('is-unavailable');
        $('<strong class="accessory-picker__stock"></strong>').text('Indisponible').appendTo(meta);
      }
      button.append(name, meta).appendTo(list);
    });
    picker.append(list, empty);
    target.empty().append(picker);
    purchase.addClass('is-accessory-picker-ready');
    var optionButtons = list.find('.accessory-picker__option');
    var countLabel = picker.find('.accessory-picker__count');
    var applyFilters = function applyFilters() {
      var query = search ? normalizeAccessorySearch(search.val()) : '';
      var visibleCount = 0;
      optionButtons.each(function () {
        var button = $(this);
        var matchesFilter = activeFilter === 'all' || button.attr('data-accessory-filter') === activeFilter;
        var matchesSearch = query === '' || button.attr('data-accessory-search').indexOf(query) !== -1;
        var isVisible = matchesFilter && matchesSearch;
        button.prop('hidden', !isVisible);
        if (isVisible) {
          visibleCount++;
        }
      });
      countLabel.text(visibleCount + (visibleCount > 1 ? ' références disponibles' : ' référence disponible'));
      empty.prop('hidden', visibleCount !== 0);
    };
    var syncSelection = function syncSelection() {
      var selectedValue = select.val();
      var selectedVariation = variationByValue[selectedValue] || null;
      var selectedReference = selectedVariation && selectedVariation.sku ? selectedVariation.sku.toString() : '';
      optionButtons.each(function () {
        var button = $(this);
        var isSelected = button.attr('data-accessory-value') === selectedValue;
        button.toggleClass('is-selected', isSelected);
        button.attr('aria-pressed', isSelected ? 'true' : 'false');
      });
      reset.prop('hidden', !selectedValue);
      $('.js--accessory-selected-reference').text(selectedReference ? 'Réf. ' + selectedReference : 'Choisissez une référence');
    };
    filters.on('click', 'button', function () {
      activeFilter = $(this).attr('data-accessory-filter');
      filters.find('button').removeClass('is-active').attr('aria-pressed', 'false');
      $(this).addClass('is-active').attr('aria-pressed', 'true');
      applyFilters();
    });
    if (search) {
      search.on('input', applyFilters);
    }
    optionButtons.on('click', function () {
      var value = $(this).attr('data-accessory-value');
      if ($(this).prop('disabled') || select.find('option[value="' + value + '"]').length === 0) {
        return;
      }
      select.val(value).trigger('change');
      syncSelection();
      updateConfiguratorSteps();
    });
    reset.on('click', function () {
      select.val('').trigger('change');
      syncSelection();
      updateConfiguratorSteps();
    });
    select.on('change', syncSelection);
    form.on('found_variation reset_data hide_variation show_variation', function () {
      setTimeout(function () {
        syncSelection();
        updateConfiguratorSteps();
      }, 0);
    });
    applyFilters();
    syncSelection();
  };
  var hasValidConfiguratorMeasurements = function hasValidConfiguratorMeasurements() {
    var inputs = $('#price_calculator .wc-measurement-inputs input:visible');
    var isValid = inputs.length > 0;
    inputs.each(function () {
      var input = $(this);
      var value = getNumber(input.val());
      var min = getNumber(input.attr('min'));
      var max = getNumber(input.attr('max'));
      if (value <= 0 || min > 0 && value < min || max > 0 && value > max) {
        isValid = false;
      }
    });
    return isValid;
  };
  var hasResolvedConfiguratorVariation = function hasResolvedConfiguratorVariation() {
    var form = $('.variations_form.cart:first');
    var isResolved = form.length > 0;
    form.find('.variations select').each(function () {
      if (!$(this).val()) {
        isResolved = false;
      }
    });
    return isResolved && getNumber(form.find('input.variation_id:first').val()) > 0;
  };
  var hasReadyConfiguratorPrice = function hasReadyConfiguratorPrice() {
    var price = $('#conex-calculated-price');
    var button = $('.single_add_to_cart_button:first');
    var amount = getNumber(window.configurator_options && window.configurator_options.total_amount);
    return price.length > 0 && price.is(':visible') && amount > 0 && button.length > 0 && !button.hasClass('disabled');
  };
  var hasReadyAccessoryPrice = function hasReadyAccessoryPrice() {
    var variationPrice = $('.accessory-product__summary .woocommerce-variation-price:visible .amount:first');
    var calculatedPrice = $('.accessory-product__summary #conex-calculated-price:visible');
    var button = $('.accessory-product__summary .single_add_to_cart_button:first');
    return button.length > 0 && !button.hasClass('disabled') && (variationPrice.length > 0 || calculatedPrice.length > 0);
  };
  var updateConfiguratorSteps = function updateConfiguratorSteps() {
    var steps = $('.cut-product__steps, .foam-product__steps, .accessory-product__steps').first();
    if (steps.length === 0) {
      return;
    }
    var isFoam = steps.hasClass('foam-product__steps');
    var isAccessory = steps.hasClass('accessory-product__steps');
    var isPanel = $('body').hasClass('product-page--cut-panel');
    var selectedFamily = $('#pa_aluminium-family').val();
    var familyReady = isFoam || isPanel || typeof selectedFamily === 'string' && selectedFamily !== '';
    var variationReady = hasResolvedConfiguratorVariation();
    var dimensionsReady = hasValidConfiguratorMeasurements();
    var priceReady = variationReady && (isAccessory ? hasReadyAccessoryPrice() : dimensionsReady && hasReadyConfiguratorPrice());
    var setStepState = function setStepState(name, state) {
      var step = steps.find('[data-configurator-step="' + name + '"]');
      step.removeClass('is-active is-complete').removeAttr('aria-current').attr('data-step-state', state);
      if (state === 'complete') {
        step.addClass('is-complete');
      } else if (state === 'active') {
        step.addClass('is-active').attr('aria-current', 'step');
      }
    };
    if (isFoam) {
      setStepState('family', 'complete');
      setStepState('dimensions', priceReady ? 'complete' : 'active');
      setStepState('price', priceReady ? 'active' : 'pending');
      return;
    }
    if (isAccessory) {
      setStepState('family', 'complete');
      setStepState('variation', variationReady ? 'complete' : 'active');
      setStepState('price', priceReady ? 'active' : 'pending');
      return;
    }
    setStepState('family', familyReady ? 'complete' : 'active');
    setStepState('variation', !familyReady ? 'pending' : variationReady ? 'complete' : 'active');
    setStepState('dimensions', variationReady ? priceReady ? 'complete' : 'active' : 'pending');
    setStepState('price', priceReady ? 'active' : 'pending');
  };

  /*
   * Events
   */

  $(document).ready(function () {
    if ($('body.single-product').length > 0) {
      initCutProfileFamilyChooser();
      _variations = $.parseJSON($('.variations_form.cart').attr('data-product_variations'));
      initAccessoryPicker();
      defaultMaxLength = parseInt($('.js--max-length_needed-info:first').attr('data-max'));
      defaultMaxWidth = parseInt($('.js--max-width_needed-info:first').attr('data-max'));
      defaultMaxHeight = parseInt($('.js--max-height_needed-info:first').attr('data-max'));
      $imgElt = $('.js--change-product-image');
      setMaxInput('width', '');
      document.addEventListener('input', function (event) {
        var target = $(event.target);
        if (target.is('#price_calculator .wc-measurement-inputs input') && clampMeasurementInputToMax(target)) {
          $("#conex-calculated-price").trigger("wc-measurement-price-calculator-product-price-change");
        }
        if (target.is('#price_calculator .wc-measurement-inputs input')) {
          updateConfiguratorSteps();
        }
      }, true);
      document.addEventListener('change', function (event) {
        var target = $(event.target);
        if (target.is('#price_calculator .wc-measurement-inputs input')) {
          clampMeasurementInputToMax(target);
        }
      }, true);
      $(document).on('change', '.quantity input[name=quantity]', function () {
        $('#conex-calculated-price').trigger('wc-measurement-price-calculator-product-price-change');
      });
      $(document).on('change', '#price_calculator .wc-measurement-inputs input', function () {
        clampMeasurementInputToMax($(this));
        $('#conex-calculated-price').trigger('wc-measurement-price-calculator-product-price-change');
      });
      $(document).on('change', 'input.variation_id', function () {
        updateProductMeta();
        updateConfiguratorSteps();
      });
      $(document).on('change', '.variations_form.cart .variations select', function () {
        updateConfiguratorSteps();
      });
      $('.variations_form.cart').on('found_variation reset_data hide_variation show_variation', function () {
        setTimeout(updateConfiguratorSteps, 0);
      });
      $(document).on('wc-measurement-price-calculator-update', 'form.cart', function () {
        $('#conex-calculated-price').trigger('wc-measurement-price-calculator-product-price-change');
      });
      $('.thwepo-price-field').on('change.select2', function () {
        $('#conex-calculated-price').trigger('wc-measurement-price-calculator-product-price-change');
      }).on('change', function () {
        $('#conex-calculated-price').trigger('wc-measurement-price-calculator-product-price-change');
      });
      $(document).on('input', '#rack_cap_depth_mm, #rack_rear_cap_depth_mm', function () {
        $('#conex-calculated-price').trigger('wc-measurement-price-calculator-product-price-change');
      });
      $(document).on('change', '#rack_cap_depth_mm, #rack_rear_cap_depth_mm', function () {
        var depth = $(this).is('#rack_rear_cap_depth_mm') ? getRackClassicRearCapDepthMm() : getRackClassicCapDepthMm();
        $(this).val(depth);
        $('#conex-calculated-price').trigger('wc-measurement-price-calculator-product-price-change');
      });
      $(document).on('input change', 'input[name="rack_type"], #rack_units, #rack_depth_mm, #rack_total_length_mm, #rack_left_cap, #rack_flat_front_clearance_mm, #rack_flat_rear_clearance_mm, .rack-rail-fastener-input', function () {
        $('#conex-calculated-price').trigger('wc-measurement-price-calculator-product-price-change');
      });
      $(document).on('wc-measurement-price-calculator-product-price-change', '#conex-calculated-price', function (e) {
        updateProductPrice();
        updateConfiguratorSteps();
      });
      updateConfiguratorSteps();
    }
  });
})();

},{"valid-url":14}],7:[function(require,module,exports){
"use strict";

function _typeof2(o) { "@babel/helpers - typeof"; return _typeof2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof2(o); }
(function webpackUniversalModuleDefinition(root, factory) {
  if ((typeof exports === "undefined" ? "undefined" : _typeof2(exports)) === 'object' && (typeof module === "undefined" ? "undefined" : _typeof2(module)) === 'object') module.exports = factory(require("jquery"));else if (typeof define === 'function' && define.amd) define(["jquery"], factory);else {
    var a = (typeof exports === "undefined" ? "undefined" : _typeof2(exports)) === 'object' ? factory(require("jquery")) : factory(root["jQuery"]);
    for (var i in a) ((typeof exports === "undefined" ? "undefined" : _typeof2(exports)) === 'object' ? exports : root)[i] = a[i];
  }
})(window, function (__WEBPACK_EXTERNAL_MODULE_jquery__) {
  return /******/function (modules) {
    // webpackBootstrap
    /******/ // The module cache
    /******/
    var installedModules = {};
    /******/
    /******/ // The require function
    /******/
    function __webpack_require__(moduleId) {
      /******/
      /******/ // Check if module is in cache
      /******/if (installedModules[moduleId]) {
        /******/return installedModules[moduleId].exports;
        /******/
      }
      /******/ // Create a new module (and put it into the cache)
      /******/
      var module = installedModules[moduleId] = {
        /******/i: moduleId,
        /******/l: false,
        /******/exports: {}
        /******/
      };
      /******/
      /******/ // Execute the module function
      /******/
      modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
      /******/
      /******/ // Flag the module as loaded
      /******/
      module.l = true;
      /******/
      /******/ // Return the exports of the module
      /******/
      return module.exports;
      /******/
    }
    /******/
    /******/
    /******/ // expose the modules object (__webpack_modules__)
    /******/
    __webpack_require__.m = modules;
    /******/
    /******/ // expose the module cache
    /******/
    __webpack_require__.c = installedModules;
    /******/
    /******/ // define getter function for harmony exports
    /******/
    __webpack_require__.d = function (exports, name, getter) {
      /******/if (!__webpack_require__.o(exports, name)) {
        /******/Object.defineProperty(exports, name, {
          enumerable: true,
          get: getter
        });
        /******/
      }
      /******/
    };
    /******/
    /******/ // define __esModule on exports
    /******/
    __webpack_require__.r = function (exports) {
      /******/if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
        /******/Object.defineProperty(exports, Symbol.toStringTag, {
          value: 'Module'
        });
        /******/
      }
      /******/
      Object.defineProperty(exports, '__esModule', {
        value: true
      });
      /******/
    };
    /******/
    /******/ // create a fake namespace object
    /******/ // mode & 1: value is a module id, require it
    /******/ // mode & 2: merge all properties of value into the ns
    /******/ // mode & 4: return value when already ns object
    /******/ // mode & 8|1: behave like require
    /******/
    __webpack_require__.t = function (value, mode) {
      /******/if (mode & 1) value = __webpack_require__(value);
      /******/
      if (mode & 8) return value;
      /******/
      if (mode & 4 && _typeof2(value) === 'object' && value && value.__esModule) return value;
      /******/
      var ns = Object.create(null);
      /******/
      __webpack_require__.r(ns);
      /******/
      Object.defineProperty(ns, 'default', {
        enumerable: true,
        value: value
      });
      /******/
      if (mode & 2 && typeof value != 'string') for (var key in value) __webpack_require__.d(ns, key, function (key) {
        return value[key];
      }.bind(null, key));
      /******/
      return ns;
      /******/
    };
    /******/
    /******/ // getDefaultExport function for compatibility with non-harmony modules
    /******/
    __webpack_require__.n = function (module) {
      /******/var getter = module && module.__esModule ? /******/function getDefault() {
        return module['default'];
      } : /******/function getModuleExports() {
        return module;
      };
      /******/
      __webpack_require__.d(getter, 'a', getter);
      /******/
      return getter;
      /******/
    };
    /******/
    /******/ // Object.prototype.hasOwnProperty.call
    /******/
    __webpack_require__.o = function (object, property) {
      return Object.prototype.hasOwnProperty.call(object, property);
    };
    /******/
    /******/ // __webpack_public_path__
    /******/
    __webpack_require__.p = "";
    /******/
    /******/
    /******/ // Load entry module and return exports
    /******/
    return __webpack_require__(__webpack_require__.s = 0);
    /******/
  }
  /************************************************************************/
  /******/({
    /***/"./js/entries/foundation.js": (
    /*!**********************************!*\
      !*** ./js/entries/foundation.js ***!
      \**********************************/
    /*! exports provided: Foundation, CoreUtils, Box, onImagesLoaded, Keyboard, MediaQuery, Motion, Nest, Timer, Touch, Triggers, Abide, Accordion, AccordionMenu, Drilldown, Dropdown, DropdownMenu, Equalizer, Interchange, Magellan, OffCanvas, Orbit, ResponsiveMenu, ResponsiveToggle, Reveal, Slider, SmoothScroll, Sticky, Tabs, Toggler, Tooltip, ResponsiveAccordionTabs, default */
    /***/
    function _js_entries_foundationJs(module, __webpack_exports__, __webpack_require__) {
      "use strict";

      __webpack_require__.r(__webpack_exports__);
      /* harmony import */
      var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! jquery */"jquery");
      /* harmony import */
      var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);
      /* harmony import */
      var _foundation_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../foundation.core */"./js/foundation.core.js");
      /* harmony reexport (safe) */
      __webpack_require__.d(__webpack_exports__, "Foundation", function () {
        return _foundation_core__WEBPACK_IMPORTED_MODULE_1__["Foundation"];
      });

      /* harmony import */
      var _foundation_core_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../foundation.core.utils */"./js/foundation.core.utils.js");
      /* harmony reexport (module object) */
      __webpack_require__.d(__webpack_exports__, "CoreUtils", function () {
        return _foundation_core_utils__WEBPACK_IMPORTED_MODULE_2__;
      });
      /* harmony import */
      var _foundation_util_box__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../foundation.util.box */"./js/foundation.util.box.js");
      /* harmony reexport (safe) */
      __webpack_require__.d(__webpack_exports__, "Box", function () {
        return _foundation_util_box__WEBPACK_IMPORTED_MODULE_3__["Box"];
      });

      /* harmony import */
      var _foundation_util_imageLoader__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../foundation.util.imageLoader */"./js/foundation.util.imageLoader.js");
      /* harmony reexport (safe) */
      __webpack_require__.d(__webpack_exports__, "onImagesLoaded", function () {
        return _foundation_util_imageLoader__WEBPACK_IMPORTED_MODULE_4__["onImagesLoaded"];
      });

      /* harmony import */
      var _foundation_util_keyboard__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../foundation.util.keyboard */"./js/foundation.util.keyboard.js");
      /* harmony reexport (safe) */
      __webpack_require__.d(__webpack_exports__, "Keyboard", function () {
        return _foundation_util_keyboard__WEBPACK_IMPORTED_MODULE_5__["Keyboard"];
      });

      /* harmony import */
      var _foundation_util_mediaQuery__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../foundation.util.mediaQuery */"./js/foundation.util.mediaQuery.js");
      /* harmony reexport (safe) */
      __webpack_require__.d(__webpack_exports__, "MediaQuery", function () {
        return _foundation_util_mediaQuery__WEBPACK_IMPORTED_MODULE_6__["MediaQuery"];
      });

      /* harmony import */
      var _foundation_util_motion__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../foundation.util.motion */"./js/foundation.util.motion.js");
      /* harmony reexport (safe) */
      __webpack_require__.d(__webpack_exports__, "Motion", function () {
        return _foundation_util_motion__WEBPACK_IMPORTED_MODULE_7__["Motion"];
      });

      /* harmony import */
      var _foundation_util_nest__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../foundation.util.nest */"./js/foundation.util.nest.js");
      /* harmony reexport (safe) */
      __webpack_require__.d(__webpack_exports__, "Nest", function () {
        return _foundation_util_nest__WEBPACK_IMPORTED_MODULE_8__["Nest"];
      });

      /* harmony import */
      var _foundation_util_timer__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../foundation.util.timer */"./js/foundation.util.timer.js");
      /* harmony reexport (safe) */
      __webpack_require__.d(__webpack_exports__, "Timer", function () {
        return _foundation_util_timer__WEBPACK_IMPORTED_MODULE_9__["Timer"];
      });

      /* harmony import */
      var _foundation_util_touch__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../foundation.util.touch */"./js/foundation.util.touch.js");
      /* harmony reexport (safe) */
      __webpack_require__.d(__webpack_exports__, "Touch", function () {
        return _foundation_util_touch__WEBPACK_IMPORTED_MODULE_10__["Touch"];
      });

      /* harmony import */
      var _foundation_util_triggers__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../foundation.util.triggers */"./js/foundation.util.triggers.js");
      /* harmony reexport (safe) */
      __webpack_require__.d(__webpack_exports__, "Triggers", function () {
        return _foundation_util_triggers__WEBPACK_IMPORTED_MODULE_11__["Triggers"];
      });

      /* harmony import */
      var _foundation_abide__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../foundation.abide */"./js/foundation.abide.js");
      /* harmony reexport (safe) */
      __webpack_require__.d(__webpack_exports__, "Abide", function () {
        return _foundation_abide__WEBPACK_IMPORTED_MODULE_12__["Abide"];
      });

      /* harmony import */
      var _foundation_accordion__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../foundation.accordion */"./js/foundation.accordion.js");
      /* harmony reexport (safe) */
      __webpack_require__.d(__webpack_exports__, "Accordion", function () {
        return _foundation_accordion__WEBPACK_IMPORTED_MODULE_13__["Accordion"];
      });

      /* harmony import */
      var _foundation_accordionMenu__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../foundation.accordionMenu */"./js/foundation.accordionMenu.js");
      /* harmony reexport (safe) */
      __webpack_require__.d(__webpack_exports__, "AccordionMenu", function () {
        return _foundation_accordionMenu__WEBPACK_IMPORTED_MODULE_14__["AccordionMenu"];
      });

      /* harmony import */
      var _foundation_drilldown__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../foundation.drilldown */"./js/foundation.drilldown.js");
      /* harmony reexport (safe) */
      __webpack_require__.d(__webpack_exports__, "Drilldown", function () {
        return _foundation_drilldown__WEBPACK_IMPORTED_MODULE_15__["Drilldown"];
      });

      /* harmony import */
      var _foundation_dropdown__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../foundation.dropdown */"./js/foundation.dropdown.js");
      /* harmony reexport (safe) */
      __webpack_require__.d(__webpack_exports__, "Dropdown", function () {
        return _foundation_dropdown__WEBPACK_IMPORTED_MODULE_16__["Dropdown"];
      });

      /* harmony import */
      var _foundation_dropdownMenu__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ../foundation.dropdownMenu */"./js/foundation.dropdownMenu.js");
      /* harmony reexport (safe) */
      __webpack_require__.d(__webpack_exports__, "DropdownMenu", function () {
        return _foundation_dropdownMenu__WEBPACK_IMPORTED_MODULE_17__["DropdownMenu"];
      });

      /* harmony import */
      var _foundation_equalizer__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ../foundation.equalizer */"./js/foundation.equalizer.js");
      /* harmony reexport (safe) */
      __webpack_require__.d(__webpack_exports__, "Equalizer", function () {
        return _foundation_equalizer__WEBPACK_IMPORTED_MODULE_18__["Equalizer"];
      });

      /* harmony import */
      var _foundation_interchange__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ../foundation.interchange */"./js/foundation.interchange.js");
      /* harmony reexport (safe) */
      __webpack_require__.d(__webpack_exports__, "Interchange", function () {
        return _foundation_interchange__WEBPACK_IMPORTED_MODULE_19__["Interchange"];
      });

      /* harmony import */
      var _foundation_magellan__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ../foundation.magellan */"./js/foundation.magellan.js");
      /* harmony reexport (safe) */
      __webpack_require__.d(__webpack_exports__, "Magellan", function () {
        return _foundation_magellan__WEBPACK_IMPORTED_MODULE_20__["Magellan"];
      });

      /* harmony import */
      var _foundation_offcanvas__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ../foundation.offcanvas */"./js/foundation.offcanvas.js");
      /* harmony reexport (safe) */
      __webpack_require__.d(__webpack_exports__, "OffCanvas", function () {
        return _foundation_offcanvas__WEBPACK_IMPORTED_MODULE_21__["OffCanvas"];
      });

      /* harmony import */
      var _foundation_orbit__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ../foundation.orbit */"./js/foundation.orbit.js");
      /* harmony reexport (safe) */
      __webpack_require__.d(__webpack_exports__, "Orbit", function () {
        return _foundation_orbit__WEBPACK_IMPORTED_MODULE_22__["Orbit"];
      });

      /* harmony import */
      var _foundation_responsiveMenu__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ../foundation.responsiveMenu */"./js/foundation.responsiveMenu.js");
      /* harmony reexport (safe) */
      __webpack_require__.d(__webpack_exports__, "ResponsiveMenu", function () {
        return _foundation_responsiveMenu__WEBPACK_IMPORTED_MODULE_23__["ResponsiveMenu"];
      });

      /* harmony import */
      var _foundation_responsiveToggle__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ../foundation.responsiveToggle */"./js/foundation.responsiveToggle.js");
      /* harmony reexport (safe) */
      __webpack_require__.d(__webpack_exports__, "ResponsiveToggle", function () {
        return _foundation_responsiveToggle__WEBPACK_IMPORTED_MODULE_24__["ResponsiveToggle"];
      });

      /* harmony import */
      var _foundation_reveal__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! ../foundation.reveal */"./js/foundation.reveal.js");
      /* harmony reexport (safe) */
      __webpack_require__.d(__webpack_exports__, "Reveal", function () {
        return _foundation_reveal__WEBPACK_IMPORTED_MODULE_25__["Reveal"];
      });

      /* harmony import */
      var _foundation_slider__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! ../foundation.slider */"./js/foundation.slider.js");
      /* harmony reexport (safe) */
      __webpack_require__.d(__webpack_exports__, "Slider", function () {
        return _foundation_slider__WEBPACK_IMPORTED_MODULE_26__["Slider"];
      });

      /* harmony import */
      var _foundation_smoothScroll__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! ../foundation.smoothScroll */"./js/foundation.smoothScroll.js");
      /* harmony reexport (safe) */
      __webpack_require__.d(__webpack_exports__, "SmoothScroll", function () {
        return _foundation_smoothScroll__WEBPACK_IMPORTED_MODULE_27__["SmoothScroll"];
      });

      /* harmony import */
      var _foundation_sticky__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! ../foundation.sticky */"./js/foundation.sticky.js");
      /* harmony reexport (safe) */
      __webpack_require__.d(__webpack_exports__, "Sticky", function () {
        return _foundation_sticky__WEBPACK_IMPORTED_MODULE_28__["Sticky"];
      });

      /* harmony import */
      var _foundation_tabs__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! ../foundation.tabs */"./js/foundation.tabs.js");
      /* harmony reexport (safe) */
      __webpack_require__.d(__webpack_exports__, "Tabs", function () {
        return _foundation_tabs__WEBPACK_IMPORTED_MODULE_29__["Tabs"];
      });

      /* harmony import */
      var _foundation_toggler__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! ../foundation.toggler */"./js/foundation.toggler.js");
      /* harmony reexport (safe) */
      __webpack_require__.d(__webpack_exports__, "Toggler", function () {
        return _foundation_toggler__WEBPACK_IMPORTED_MODULE_30__["Toggler"];
      });

      /* harmony import */
      var _foundation_tooltip__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! ../foundation.tooltip */"./js/foundation.tooltip.js");
      /* harmony reexport (safe) */
      __webpack_require__.d(__webpack_exports__, "Tooltip", function () {
        return _foundation_tooltip__WEBPACK_IMPORTED_MODULE_31__["Tooltip"];
      });

      /* harmony import */
      var _foundation_responsiveAccordionTabs__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! ../foundation.responsiveAccordionTabs */"./js/foundation.responsiveAccordionTabs.js");
      /* harmony reexport (safe) */
      __webpack_require__.d(__webpack_exports__, "ResponsiveAccordionTabs", function () {
        return _foundation_responsiveAccordionTabs__WEBPACK_IMPORTED_MODULE_32__["ResponsiveAccordionTabs"];
      });
      _foundation_core__WEBPACK_IMPORTED_MODULE_1__["Foundation"].addToJquery(jquery__WEBPACK_IMPORTED_MODULE_0___default.a); // Add Foundation Utils to Foundation global namespace for backwards
      // compatibility.

      _foundation_core__WEBPACK_IMPORTED_MODULE_1__["Foundation"].rtl = _foundation_core_utils__WEBPACK_IMPORTED_MODULE_2__["rtl"];
      _foundation_core__WEBPACK_IMPORTED_MODULE_1__["Foundation"].GetYoDigits = _foundation_core_utils__WEBPACK_IMPORTED_MODULE_2__["GetYoDigits"];
      _foundation_core__WEBPACK_IMPORTED_MODULE_1__["Foundation"].transitionend = _foundation_core_utils__WEBPACK_IMPORTED_MODULE_2__["transitionend"];
      _foundation_core__WEBPACK_IMPORTED_MODULE_1__["Foundation"].RegExpEscape = _foundation_core_utils__WEBPACK_IMPORTED_MODULE_2__["RegExpEscape"];
      _foundation_core__WEBPACK_IMPORTED_MODULE_1__["Foundation"].onLoad = _foundation_core_utils__WEBPACK_IMPORTED_MODULE_2__["onLoad"];
      _foundation_core__WEBPACK_IMPORTED_MODULE_1__["Foundation"].Box = _foundation_util_box__WEBPACK_IMPORTED_MODULE_3__["Box"];
      _foundation_core__WEBPACK_IMPORTED_MODULE_1__["Foundation"].onImagesLoaded = _foundation_util_imageLoader__WEBPACK_IMPORTED_MODULE_4__["onImagesLoaded"];
      _foundation_core__WEBPACK_IMPORTED_MODULE_1__["Foundation"].Keyboard = _foundation_util_keyboard__WEBPACK_IMPORTED_MODULE_5__["Keyboard"];
      _foundation_core__WEBPACK_IMPORTED_MODULE_1__["Foundation"].MediaQuery = _foundation_util_mediaQuery__WEBPACK_IMPORTED_MODULE_6__["MediaQuery"];
      _foundation_core__WEBPACK_IMPORTED_MODULE_1__["Foundation"].Motion = _foundation_util_motion__WEBPACK_IMPORTED_MODULE_7__["Motion"];
      _foundation_core__WEBPACK_IMPORTED_MODULE_1__["Foundation"].Move = _foundation_util_motion__WEBPACK_IMPORTED_MODULE_7__["Move"];
      _foundation_core__WEBPACK_IMPORTED_MODULE_1__["Foundation"].Nest = _foundation_util_nest__WEBPACK_IMPORTED_MODULE_8__["Nest"];
      _foundation_core__WEBPACK_IMPORTED_MODULE_1__["Foundation"].Timer = _foundation_util_timer__WEBPACK_IMPORTED_MODULE_9__["Timer"]; // Touch and Triggers previously were almost purely sede effect driven,
      // so no need to add it to Foundation, just init them.

      _foundation_util_touch__WEBPACK_IMPORTED_MODULE_10__["Touch"].init(jquery__WEBPACK_IMPORTED_MODULE_0___default.a);
      _foundation_util_triggers__WEBPACK_IMPORTED_MODULE_11__["Triggers"].init(jquery__WEBPACK_IMPORTED_MODULE_0___default.a, _foundation_core__WEBPACK_IMPORTED_MODULE_1__["Foundation"]);
      _foundation_util_mediaQuery__WEBPACK_IMPORTED_MODULE_6__["MediaQuery"]._init();
      _foundation_core__WEBPACK_IMPORTED_MODULE_1__["Foundation"].plugin(_foundation_abide__WEBPACK_IMPORTED_MODULE_12__["Abide"], 'Abide');
      _foundation_core__WEBPACK_IMPORTED_MODULE_1__["Foundation"].plugin(_foundation_accordion__WEBPACK_IMPORTED_MODULE_13__["Accordion"], 'Accordion');
      _foundation_core__WEBPACK_IMPORTED_MODULE_1__["Foundation"].plugin(_foundation_accordionMenu__WEBPACK_IMPORTED_MODULE_14__["AccordionMenu"], 'AccordionMenu');
      _foundation_core__WEBPACK_IMPORTED_MODULE_1__["Foundation"].plugin(_foundation_drilldown__WEBPACK_IMPORTED_MODULE_15__["Drilldown"], 'Drilldown');
      _foundation_core__WEBPACK_IMPORTED_MODULE_1__["Foundation"].plugin(_foundation_dropdown__WEBPACK_IMPORTED_MODULE_16__["Dropdown"], 'Dropdown');
      _foundation_core__WEBPACK_IMPORTED_MODULE_1__["Foundation"].plugin(_foundation_dropdownMenu__WEBPACK_IMPORTED_MODULE_17__["DropdownMenu"], 'DropdownMenu');
      _foundation_core__WEBPACK_IMPORTED_MODULE_1__["Foundation"].plugin(_foundation_equalizer__WEBPACK_IMPORTED_MODULE_18__["Equalizer"], 'Equalizer');
      _foundation_core__WEBPACK_IMPORTED_MODULE_1__["Foundation"].plugin(_foundation_interchange__WEBPACK_IMPORTED_MODULE_19__["Interchange"], 'Interchange');
      _foundation_core__WEBPACK_IMPORTED_MODULE_1__["Foundation"].plugin(_foundation_magellan__WEBPACK_IMPORTED_MODULE_20__["Magellan"], 'Magellan');
      _foundation_core__WEBPACK_IMPORTED_MODULE_1__["Foundation"].plugin(_foundation_offcanvas__WEBPACK_IMPORTED_MODULE_21__["OffCanvas"], 'OffCanvas');
      _foundation_core__WEBPACK_IMPORTED_MODULE_1__["Foundation"].plugin(_foundation_orbit__WEBPACK_IMPORTED_MODULE_22__["Orbit"], 'Orbit');
      _foundation_core__WEBPACK_IMPORTED_MODULE_1__["Foundation"].plugin(_foundation_responsiveMenu__WEBPACK_IMPORTED_MODULE_23__["ResponsiveMenu"], 'ResponsiveMenu');
      _foundation_core__WEBPACK_IMPORTED_MODULE_1__["Foundation"].plugin(_foundation_responsiveToggle__WEBPACK_IMPORTED_MODULE_24__["ResponsiveToggle"], 'ResponsiveToggle');
      _foundation_core__WEBPACK_IMPORTED_MODULE_1__["Foundation"].plugin(_foundation_reveal__WEBPACK_IMPORTED_MODULE_25__["Reveal"], 'Reveal');
      _foundation_core__WEBPACK_IMPORTED_MODULE_1__["Foundation"].plugin(_foundation_slider__WEBPACK_IMPORTED_MODULE_26__["Slider"], 'Slider');
      _foundation_core__WEBPACK_IMPORTED_MODULE_1__["Foundation"].plugin(_foundation_smoothScroll__WEBPACK_IMPORTED_MODULE_27__["SmoothScroll"], 'SmoothScroll');
      _foundation_core__WEBPACK_IMPORTED_MODULE_1__["Foundation"].plugin(_foundation_sticky__WEBPACK_IMPORTED_MODULE_28__["Sticky"], 'Sticky');
      _foundation_core__WEBPACK_IMPORTED_MODULE_1__["Foundation"].plugin(_foundation_tabs__WEBPACK_IMPORTED_MODULE_29__["Tabs"], 'Tabs');
      _foundation_core__WEBPACK_IMPORTED_MODULE_1__["Foundation"].plugin(_foundation_toggler__WEBPACK_IMPORTED_MODULE_30__["Toggler"], 'Toggler');
      _foundation_core__WEBPACK_IMPORTED_MODULE_1__["Foundation"].plugin(_foundation_tooltip__WEBPACK_IMPORTED_MODULE_31__["Tooltip"], 'Tooltip');
      _foundation_core__WEBPACK_IMPORTED_MODULE_1__["Foundation"].plugin(_foundation_responsiveAccordionTabs__WEBPACK_IMPORTED_MODULE_32__["ResponsiveAccordionTabs"], 'ResponsiveAccordionTabs');

      /* harmony default export */
      __webpack_exports__["default"] = _foundation_core__WEBPACK_IMPORTED_MODULE_1__["Foundation"];

      /***/
    }),
    /***/"./js/foundation.abide.js": (
    /*!********************************!*\
      !*** ./js/foundation.abide.js ***!
      \********************************/
    /*! exports provided: Abide */
    /***/
    function _js_foundationAbideJs(module, __webpack_exports__, __webpack_require__) {
      "use strict";

      __webpack_require__.r(__webpack_exports__);
      /* harmony export (binding) */
      __webpack_require__.d(__webpack_exports__, "Abide", function () {
        return Abide;
      });
      /* harmony import */
      var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! jquery */"jquery");
      /* harmony import */
      var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);
      /* harmony import */
      var _foundation_core_plugin__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./foundation.core.plugin */"./js/foundation.core.plugin.js");
      /* harmony import */
      var _foundation_core_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./foundation.core.utils */"./js/foundation.core.utils.js");
      function _typeof(obj) {
        if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
          _typeof = function _typeof(obj) {
            return _typeof2(obj);
          };
        } else {
          _typeof = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
          };
        }
        return _typeof(obj);
      }
      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }
      function _defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }
      function _createClass(Constructor, protoProps, staticProps) {
        if (protoProps) _defineProperties(Constructor.prototype, protoProps);
        if (staticProps) _defineProperties(Constructor, staticProps);
        return Constructor;
      }
      function _possibleConstructorReturn(self, call) {
        if (call && (_typeof(call) === "object" || typeof call === "function")) {
          return call;
        }
        return _assertThisInitialized(self);
      }
      function _assertThisInitialized(self) {
        if (self === void 0) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }
        return self;
      }
      function _getPrototypeOf(o) {
        _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
          return o.__proto__ || Object.getPrototypeOf(o);
        };
        return _getPrototypeOf(o);
      }
      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function");
        }
        subClass.prototype = Object.create(superClass && superClass.prototype, {
          constructor: {
            value: subClass,
            writable: true,
            configurable: true
          }
        });
        if (superClass) _setPrototypeOf(subClass, superClass);
      }
      function _setPrototypeOf(o, p) {
        _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
          o.__proto__ = p;
          return o;
        };
        return _setPrototypeOf(o, p);
      }

      /**
       * Abide module.
       * @module foundation.abide
       */

      var Abide = /*#__PURE__*/
      function (_Plugin) {
        _inherits(Abide, _Plugin);
        function Abide() {
          _classCallCheck(this, Abide);
          return _possibleConstructorReturn(this, _getPrototypeOf(Abide).apply(this, arguments));
        }
        _createClass(Abide, [{
          key: "_setup",
          /**
           * Creates a new instance of Abide.
           * @class
           * @name Abide
           * @fires Abide#init
           * @param {Object} element - jQuery object to add the trigger to.
           * @param {Object} options - Overrides to the default plugin settings.
           */
          value: function _setup(element) {
            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            this.$element = element;
            this.options = jquery__WEBPACK_IMPORTED_MODULE_0___default.a.extend(true, {}, Abide.defaults, this.$element.data(), options);
            this.className = 'Abide'; // ie9 back compat

            this._init();
          }
          /**
           * Initializes the Abide plugin and calls functions to get Abide functioning on load.
           * @private
           */
        }, {
          key: "_init",
          value: function _init() {
            var _this2 = this;
            this.$inputs = jquery__WEBPACK_IMPORTED_MODULE_0___default.a.merge(
            // Consider as input to validate:
            this.$element.find('input').not('[type=submit]'),
            // * all input fields expect submit
            this.$element.find('textarea, select') // * all textareas and select fields
            );
            var $globalErrors = this.$element.find('[data-abide-error]'); // Add a11y attributes to all fields

            if (this.options.a11yAttributes) {
              this.$inputs.each(function (i, input) {
                return _this2.addA11yAttributes(jquery__WEBPACK_IMPORTED_MODULE_0___default()(input));
              });
              $globalErrors.each(function (i, error) {
                return _this2.addGlobalErrorA11yAttributes(jquery__WEBPACK_IMPORTED_MODULE_0___default()(error));
              });
            }
            this._events();
          }
          /**
           * Initializes events for Abide.
           * @private
           */
        }, {
          key: "_events",
          value: function _events() {
            var _this3 = this;
            this.$element.off('.abide').on('reset.zf.abide', function () {
              _this3.resetForm();
            }).on('submit.zf.abide', function () {
              return _this3.validateForm();
            });
            if (this.options.validateOn === 'fieldChange') {
              this.$inputs.off('change.zf.abide').on('change.zf.abide', function (e) {
                _this3.validateInput(jquery__WEBPACK_IMPORTED_MODULE_0___default()(e.target));
              });
            }
            if (this.options.liveValidate) {
              this.$inputs.off('input.zf.abide').on('input.zf.abide', function (e) {
                _this3.validateInput(jquery__WEBPACK_IMPORTED_MODULE_0___default()(e.target));
              });
            }
            if (this.options.validateOnBlur) {
              this.$inputs.off('blur.zf.abide').on('blur.zf.abide', function (e) {
                _this3.validateInput(jquery__WEBPACK_IMPORTED_MODULE_0___default()(e.target));
              });
            }
          }
          /**
           * Calls necessary functions to update Abide upon DOM change
           * @private
           */
        }, {
          key: "_reflow",
          value: function _reflow() {
            this._init();
          }
          /**
           * Checks whether or not a form element has the required attribute and if it's checked or not
           * @param {Object} element - jQuery object to check for required attribute
           * @returns {Boolean} Boolean value depends on whether or not attribute is checked or empty
           */
        }, {
          key: "requiredCheck",
          value: function requiredCheck($el) {
            if (!$el.attr('required')) return true;
            var isGood = true;
            switch ($el[0].type) {
              case 'checkbox':
                isGood = $el[0].checked;
                break;
              case 'select':
              case 'select-one':
              case 'select-multiple':
                var opt = $el.find('option:selected');
                if (!opt.length || !opt.val()) isGood = false;
                break;
              default:
                if (!$el.val() || !$el.val().length) isGood = false;
            }
            return isGood;
          }
          /**
           * Get:
           * - Based on $el, the first element(s) corresponding to `formErrorSelector` in this order:
           *   1. The element's direct sibling('s).
           *   2. The element's parent's children.
           * - Element(s) with the attribute `[data-form-error-for]` set with the element's id.
           *
           * This allows for multiple form errors per input, though if none are found, no form errors will be shown.
           *
           * @param {Object} $el - jQuery object to use as reference to find the form error selector.
           * @returns {Object} jQuery object with the selector.
           */
        }, {
          key: "findFormError",
          value: function findFormError($el) {
            var id = $el[0].id;
            var $error = $el.siblings(this.options.formErrorSelector);
            if (!$error.length) {
              $error = $el.parent().find(this.options.formErrorSelector);
            }
            if (id) {
              $error = $error.add(this.$element.find("[data-form-error-for=\"".concat(id, "\"]")));
            }
            return $error;
          }
          /**
           * Get the first element in this order:
           * 2. The <label> with the attribute `[for="someInputId"]`
           * 3. The `.closest()` <label>
           *
           * @param {Object} $el - jQuery object to check for required attribute
           * @returns {Boolean} Boolean value depends on whether or not attribute is checked or empty
           */
        }, {
          key: "findLabel",
          value: function findLabel($el) {
            var id = $el[0].id;
            var $label = this.$element.find("label[for=\"".concat(id, "\"]"));
            if (!$label.length) {
              return $el.closest('label');
            }
            return $label;
          }
          /**
           * Get the set of labels associated with a set of radio els in this order
           * 2. The <label> with the attribute `[for="someInputId"]`
           * 3. The `.closest()` <label>
           *
           * @param {Object} $el - jQuery object to check for required attribute
           * @returns {Boolean} Boolean value depends on whether or not attribute is checked or empty
           */
        }, {
          key: "findRadioLabels",
          value: function findRadioLabels($els) {
            var _this4 = this;
            var labels = $els.map(function (i, el) {
              var id = el.id;
              var $label = _this4.$element.find("label[for=\"".concat(id, "\"]"));
              if (!$label.length) {
                $label = jquery__WEBPACK_IMPORTED_MODULE_0___default()(el).closest('label');
              }
              return $label[0];
            });
            return jquery__WEBPACK_IMPORTED_MODULE_0___default()(labels);
          }
          /**
           * Adds the CSS error class as specified by the Abide settings to the label, input, and the form
           * @param {Object} $el - jQuery object to add the class to
           */
        }, {
          key: "addErrorClasses",
          value: function addErrorClasses($el) {
            var $label = this.findLabel($el);
            var $formError = this.findFormError($el);
            if ($label.length) {
              $label.addClass(this.options.labelErrorClass);
            }
            if ($formError.length) {
              $formError.addClass(this.options.formErrorClass);
            }
            $el.addClass(this.options.inputErrorClass).attr({
              'data-invalid': '',
              'aria-invalid': true
            });
          }
          /**
           * Adds [for] and [role=alert] attributes to all form error targetting $el,
           * and [aria-describedby] attribute to $el toward the first form error.
           * @param {Object} $el - jQuery object
           */
        }, {
          key: "addA11yAttributes",
          value: function addA11yAttributes($el) {
            var $errors = this.findFormError($el);
            var $labels = $errors.filter('label');
            var $error = $errors.first();
            if (!$errors.length) return; // Set [aria-describedby] on the input toward the first form error if it is not set

            if (typeof $el.attr('aria-describedby') === 'undefined') {
              // Get the first error ID or create one
              var errorId = $error.attr('id');
              if (typeof errorId === 'undefined') {
                errorId = Object(_foundation_core_utils__WEBPACK_IMPORTED_MODULE_2__["GetYoDigits"])(6, 'abide-error');
                $error.attr('id', errorId);
              }
              ;
              $el.attr('aria-describedby', errorId);
            }
            if ($labels.filter('[for]').length < $labels.length) {
              // Get the input ID or create one
              var elemId = $el.attr('id');
              if (typeof elemId === 'undefined') {
                elemId = Object(_foundation_core_utils__WEBPACK_IMPORTED_MODULE_2__["GetYoDigits"])(6, 'abide-input');
                $el.attr('id', elemId);
              }
              ; // For each label targeting $el, set [for] if it is not set.

              $labels.each(function (i, label) {
                var $label = jquery__WEBPACK_IMPORTED_MODULE_0___default()(label);
                if (typeof $label.attr('for') === 'undefined') $label.attr('for', elemId);
              });
            } // For each error targeting $el, set [role=alert] if it is not set.

            $errors.each(function (i, label) {
              var $label = jquery__WEBPACK_IMPORTED_MODULE_0___default()(label);
              if (typeof $label.attr('role') === 'undefined') $label.attr('role', 'alert');
            }).end();
          }
          /**
           * Adds [aria-live] attribute to the given global form error $el.
           * @param {Object} $el - jQuery object to add the attribute to
           */
        }, {
          key: "addGlobalErrorA11yAttributes",
          value: function addGlobalErrorA11yAttributes($el) {
            if (typeof $el.attr('aria-live') === 'undefined') $el.attr('aria-live', this.options.a11yErrorLevel);
          }
          /**
           * Remove CSS error classes etc from an entire radio button group
           * @param {String} groupName - A string that specifies the name of a radio button group
           *
           */
        }, {
          key: "removeRadioErrorClasses",
          value: function removeRadioErrorClasses(groupName) {
            var $els = this.$element.find(":radio[name=\"".concat(groupName, "\"]"));
            var $labels = this.findRadioLabels($els);
            var $formErrors = this.findFormError($els);
            if ($labels.length) {
              $labels.removeClass(this.options.labelErrorClass);
            }
            if ($formErrors.length) {
              $formErrors.removeClass(this.options.formErrorClass);
            }
            $els.removeClass(this.options.inputErrorClass).attr({
              'data-invalid': null,
              'aria-invalid': null
            });
          }
          /**
           * Removes CSS error class as specified by the Abide settings from the label, input, and the form
           * @param {Object} $el - jQuery object to remove the class from
           */
        }, {
          key: "removeErrorClasses",
          value: function removeErrorClasses($el) {
            // radios need to clear all of the els
            if ($el[0].type == 'radio') {
              return this.removeRadioErrorClasses($el.attr('name'));
            }
            var $label = this.findLabel($el);
            var $formError = this.findFormError($el);
            if ($label.length) {
              $label.removeClass(this.options.labelErrorClass);
            }
            if ($formError.length) {
              $formError.removeClass(this.options.formErrorClass);
            }
            $el.removeClass(this.options.inputErrorClass).attr({
              'data-invalid': null,
              'aria-invalid': null
            });
          }
          /**
           * Goes through a form to find inputs and proceeds to validate them in ways specific to their type.
           * Ignores inputs with data-abide-ignore, type="hidden" or disabled attributes set
           * @fires Abide#invalid
           * @fires Abide#valid
           * @param {Object} element - jQuery object to validate, should be an HTML input
           * @returns {Boolean} goodToGo - If the input is valid or not.
           */
        }, {
          key: "validateInput",
          value: function validateInput($el) {
            var clearRequire = this.requiredCheck($el),
              validated = false,
              customValidator = true,
              validator = $el.attr('data-validator'),
              equalTo = true; // don't validate ignored inputs or hidden inputs or disabled inputs

            if ($el.is('[data-abide-ignore]') || $el.is('[type="hidden"]') || $el.is('[disabled]')) {
              return true;
            }
            switch ($el[0].type) {
              case 'radio':
                validated = this.validateRadio($el.attr('name'));
                break;
              case 'checkbox':
                validated = clearRequire;
                break;
              case 'select':
              case 'select-one':
              case 'select-multiple':
                validated = clearRequire;
                break;
              default:
                validated = this.validateText($el);
            }
            if (validator) {
              customValidator = this.matchValidation($el, validator, $el.attr('required'));
            }
            if ($el.attr('data-equalto')) {
              equalTo = this.options.validators.equalTo($el);
            }
            var goodToGo = [clearRequire, validated, customValidator, equalTo].indexOf(false) === -1;
            var message = (goodToGo ? 'valid' : 'invalid') + '.zf.abide';
            if (goodToGo) {
              // Re-validate inputs that depend on this one with equalto
              var dependentElements = this.$element.find("[data-equalto=\"".concat($el.attr('id'), "\"]"));
              if (dependentElements.length) {
                var _this = this;
                dependentElements.each(function () {
                  if (jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).val()) {
                    _this.validateInput(jquery__WEBPACK_IMPORTED_MODULE_0___default()(this));
                  }
                });
              }
            }
            this[goodToGo ? 'removeErrorClasses' : 'addErrorClasses']($el);
            /**
             * Fires when the input is done checking for validation. Event trigger is either `valid.zf.abide` or `invalid.zf.abide`
             * Trigger includes the DOM element of the input.
             * @event Abide#valid
             * @event Abide#invalid
             */

            $el.trigger(message, [$el]);
            return goodToGo;
          }
          /**
           * Goes through a form and if there are any invalid inputs, it will display the form error element
           * @returns {Boolean} noError - true if no errors were detected...
           * @fires Abide#formvalid
           * @fires Abide#forminvalid
           */
        }, {
          key: "validateForm",
          value: function validateForm() {
            var _this5 = this;
            var acc = [];
            var _this = this;
            this.$inputs.each(function () {
              acc.push(_this.validateInput(jquery__WEBPACK_IMPORTED_MODULE_0___default()(this)));
            });
            var noError = acc.indexOf(false) === -1;
            this.$element.find('[data-abide-error]').each(function (i, elem) {
              var $elem = jquery__WEBPACK_IMPORTED_MODULE_0___default()(elem); // Ensure a11y attributes are set

              if (_this5.options.a11yAttributes) _this5.addGlobalErrorA11yAttributes($elem); // Show or hide the error

              $elem.css('display', noError ? 'none' : 'block');
            });
            /**
             * Fires when the form is finished validating. Event trigger is either `formvalid.zf.abide` or `forminvalid.zf.abide`.
             * Trigger includes the element of the form.
             * @event Abide#formvalid
             * @event Abide#forminvalid
             */

            this.$element.trigger((noError ? 'formvalid' : 'forminvalid') + '.zf.abide', [this.$element]);
            return noError;
          }
          /**
           * Determines whether or a not a text input is valid based on the pattern specified in the attribute. If no matching pattern is found, returns true.
           * @param {Object} $el - jQuery object to validate, should be a text input HTML element
           * @param {String} pattern - string value of one of the RegEx patterns in Abide.options.patterns
           * @returns {Boolean} Boolean value depends on whether or not the input value matches the pattern specified
           */
        }, {
          key: "validateText",
          value: function validateText($el, pattern) {
            // A pattern can be passed to this function, or it will be infered from the input's "pattern" attribute, or it's "type" attribute
            pattern = pattern || $el.attr('pattern') || $el.attr('type');
            var inputText = $el.val();
            var valid = false;
            if (inputText.length) {
              // If the pattern attribute on the element is in Abide's list of patterns, then test that regexp
              if (this.options.patterns.hasOwnProperty(pattern)) {
                valid = this.options.patterns[pattern].test(inputText);
              } // If the pattern name isn't also the type attribute of the field, then test it as a regexp
              else if (pattern !== $el.attr('type')) {
                valid = new RegExp(pattern).test(inputText);
              } else {
                valid = true;
              }
            } // An empty field is valid if it's not required
            else if (!$el.prop('required')) {
              valid = true;
            }
            return valid;
          }
          /**
           * Determines whether or a not a radio input is valid based on whether or not it is required and selected. Although the function targets a single `<input>`, it validates by checking the `required` and `checked` properties of all radio buttons in its group.
           * @param {String} groupName - A string that specifies the name of a radio button group
           * @returns {Boolean} Boolean value depends on whether or not at least one radio input has been selected (if it's required)
           */
        }, {
          key: "validateRadio",
          value: function validateRadio(groupName) {
            // If at least one radio in the group has the `required` attribute, the group is considered required
            // Per W3C spec, all radio buttons in a group should have `required`, but we're being nice
            var $group = this.$element.find(":radio[name=\"".concat(groupName, "\"]"));
            var valid = false,
              required = false; // For the group to be required, at least one radio needs to be required

            $group.each(function (i, e) {
              if (jquery__WEBPACK_IMPORTED_MODULE_0___default()(e).attr('required')) {
                required = true;
              }
            });
            if (!required) valid = true;
            if (!valid) {
              // For the group to be valid, at least one radio needs to be checked
              $group.each(function (i, e) {
                if (jquery__WEBPACK_IMPORTED_MODULE_0___default()(e).prop('checked')) {
                  valid = true;
                }
              });
            }
            ;
            return valid;
          }
          /**
           * Determines if a selected input passes a custom validation function. Multiple validations can be used, if passed to the element with `data-validator="foo bar baz"` in a space separated listed.
           * @param {Object} $el - jQuery input element.
           * @param {String} validators - a string of function names matching functions in the Abide.options.validators object.
           * @param {Boolean} required - self explanatory?
           * @returns {Boolean} - true if validations passed.
           */
        }, {
          key: "matchValidation",
          value: function matchValidation($el, validators, required) {
            var _this6 = this;
            required = required ? true : false;
            var clear = validators.split(' ').map(function (v) {
              return _this6.options.validators[v]($el, required, $el.parent());
            });
            return clear.indexOf(false) === -1;
          }
          /**
           * Resets form inputs and styles
           * @fires Abide#formreset
           */
        }, {
          key: "resetForm",
          value: function resetForm() {
            var $form = this.$element,
              opts = this.options;
            jquery__WEBPACK_IMPORTED_MODULE_0___default()(".".concat(opts.labelErrorClass), $form).not('small').removeClass(opts.labelErrorClass);
            jquery__WEBPACK_IMPORTED_MODULE_0___default()(".".concat(opts.inputErrorClass), $form).not('small').removeClass(opts.inputErrorClass);
            jquery__WEBPACK_IMPORTED_MODULE_0___default()("".concat(opts.formErrorSelector, ".").concat(opts.formErrorClass)).removeClass(opts.formErrorClass);
            $form.find('[data-abide-error]').css('display', 'none');
            jquery__WEBPACK_IMPORTED_MODULE_0___default()(':input', $form).not(':button, :submit, :reset, :hidden, :radio, :checkbox, [data-abide-ignore]').val('').attr({
              'data-invalid': null,
              'aria-invalid': null
            });
            jquery__WEBPACK_IMPORTED_MODULE_0___default()(':input:radio', $form).not('[data-abide-ignore]').prop('checked', false).attr({
              'data-invalid': null,
              'aria-invalid': null
            });
            jquery__WEBPACK_IMPORTED_MODULE_0___default()(':input:checkbox', $form).not('[data-abide-ignore]').prop('checked', false).attr({
              'data-invalid': null,
              'aria-invalid': null
            });
            /**
             * Fires when the form has been reset.
             * @event Abide#formreset
             */

            $form.trigger('formreset.zf.abide', [$form]);
          }
          /**
           * Destroys an instance of Abide.
           * Removes error styles and classes from elements, without resetting their values.
           */
        }, {
          key: "_destroy",
          value: function _destroy() {
            var _this = this;
            this.$element.off('.abide').find('[data-abide-error]').css('display', 'none');
            this.$inputs.off('.abide').each(function () {
              _this.removeErrorClasses(jquery__WEBPACK_IMPORTED_MODULE_0___default()(this));
            });
          }
        }]);
        return Abide;
      }(_foundation_core_plugin__WEBPACK_IMPORTED_MODULE_1__["Plugin"]);
      /**
       * Default settings for plugin
       */

      Abide.defaults = {
        /**
         * The default event to validate inputs. Checkboxes and radios validate immediately.
         * Remove or change this value for manual validation.
         * @option
         * @type {?string}
         * @default 'fieldChange'
         */
        validateOn: 'fieldChange',
        /**
         * Class to be applied to input labels on failed validation.
         * @option
         * @type {string}
         * @default 'is-invalid-label'
         */
        labelErrorClass: 'is-invalid-label',
        /**
         * Class to be applied to inputs on failed validation.
         * @option
         * @type {string}
         * @default 'is-invalid-input'
         */
        inputErrorClass: 'is-invalid-input',
        /**
         * Class selector to use to target Form Errors for show/hide.
         * @option
         * @type {string}
         * @default '.form-error'
         */
        formErrorSelector: '.form-error',
        /**
         * Class added to Form Errors on failed validation.
         * @option
         * @type {string}
         * @default 'is-visible'
         */
        formErrorClass: 'is-visible',
        /**
         * If true, automatically insert when possible:
         * - `[aria-describedby]` on fields
         * - `[role=alert]` on form errors and `[for]` on form error labels
         * - `[aria-live]` on global errors `[data-abide-error]` (see option `a11yErrorLevel`).
         * @option
         * @type {boolean}
         * @default true
         */
        a11yAttributes: true,
        /**
         * [aria-live] attribute value to be applied on global errors `[data-abide-error]`.
         * Options are: 'assertive', 'polite' and 'off'/null
         * @option
         * @see https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/ARIA_Live_Regions
         * @type {string}
         * @default 'assertive'
         */
        a11yErrorLevel: 'assertive',
        /**
         * Set to true to validate text inputs on any value change.
         * @option
         * @type {boolean}
         * @default false
         */
        liveValidate: false,
        /**
         * Set to true to validate inputs on blur.
         * @option
         * @type {boolean}
         * @default false
         */
        validateOnBlur: false,
        patterns: {
          alpha: /^[a-zA-Z]+$/,
          alpha_numeric: /^[a-zA-Z0-9]+$/,
          integer: /^[-+]?\d+$/,
          number: /^[-+]?\d*(?:[\.\,]\d+)?$/,
          // amex, visa, diners
          card: /^(?:4[0-9]{12}(?:[0-9]{3})?|5[1-5][0-9]{14}|(?:222[1-9]|2[3-6][0-9]{2}|27[0-1][0-9]|2720)[0-9]{12}|6(?:011|5[0-9][0-9])[0-9]{12}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|(?:2131|1800|35\d{3})\d{11})$/,
          cvv: /^([0-9]){3,4}$/,
          // http://www.whatwg.org/specs/web-apps/current-work/multipage/states-of-the-type-attribute.html#valid-e-mail-address
          email: /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/,
          // From CommonRegexJS (@talyssonoc)
          // https://github.com/talyssonoc/CommonRegexJS/blob/e2901b9f57222bc14069dc8f0598d5f412555411/lib/commonregex.js#L76
          // For more restrictive URL Regexs, see https://mathiasbynens.be/demo/url-regex.
          url: /^((?:(https?|ftps?|file|ssh|sftp):\/\/|www\d{0,3}[.]|[a-z0-9.\-]+[.][a-z]{2,4}\/)(?:[^\s()<>]+|\((?:[^\s()<>]+|(?:\([^\s()<>]+\)))*\))+(?:\((?:[^\s()<>]+|(?:\([^\s()<>]+\)))*\)|[^\s`!()\[\]{};:\'".,<>?\xab\xbb\u201c\u201d\u2018\u2019]))$/,
          // abc.de
          domain: /^([a-zA-Z0-9]([a-zA-Z0-9\-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,8}$/,
          datetime: /^([0-2][0-9]{3})\-([0-1][0-9])\-([0-3][0-9])T([0-5][0-9])\:([0-5][0-9])\:([0-5][0-9])(Z|([\-\+]([0-1][0-9])\:00))$/,
          // YYYY-MM-DD
          date: /(?:19|20)[0-9]{2}-(?:(?:0[1-9]|1[0-2])-(?:0[1-9]|1[0-9]|2[0-9])|(?:(?!02)(?:0[1-9]|1[0-2])-(?:30))|(?:(?:0[13578]|1[02])-31))$/,
          // HH:MM:SS
          time: /^(0[0-9]|1[0-9]|2[0-3])(:[0-5][0-9]){2}$/,
          dateISO: /^\d{4}[\/\-]\d{1,2}[\/\-]\d{1,2}$/,
          // MM/DD/YYYY
          month_day_year: /^(0[1-9]|1[012])[- \/.](0[1-9]|[12][0-9]|3[01])[- \/.]\d{4}$/,
          // DD/MM/YYYY
          day_month_year: /^(0[1-9]|[12][0-9]|3[01])[- \/.](0[1-9]|1[012])[- \/.]\d{4}$/,
          // #FFF or #FFFFFF
          color: /^#?([a-fA-F0-9]{6}|[a-fA-F0-9]{3})$/,
          // Domain || URL
          website: {
            test: function test(text) {
              return Abide.defaults.patterns['domain'].test(text) || Abide.defaults.patterns['url'].test(text);
            }
          }
        },
        /**
         * Optional validation functions to be used. `equalTo` being the only default included function.
         * Functions should return only a boolean if the input is valid or not. Functions are given the following arguments:
         * el : The jQuery element to validate.
         * required : Boolean value of the required attribute be present or not.
         * parent : The direct parent of the input.
         * @option
         */
        validators: {
          equalTo: function equalTo(el, required, parent) {
            return jquery__WEBPACK_IMPORTED_MODULE_0___default()("#".concat(el.attr('data-equalto'))).val() === el.val();
          }
        }
      };

      /***/
    }),
    /***/"./js/foundation.accordion.js": (
    /*!************************************!*\
      !*** ./js/foundation.accordion.js ***!
      \************************************/
    /*! exports provided: Accordion */
    /***/
    function _js_foundationAccordionJs(module, __webpack_exports__, __webpack_require__) {
      "use strict";

      __webpack_require__.r(__webpack_exports__);
      /* harmony export (binding) */
      __webpack_require__.d(__webpack_exports__, "Accordion", function () {
        return Accordion;
      });
      /* harmony import */
      var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! jquery */"jquery");
      /* harmony import */
      var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);
      /* harmony import */
      var _foundation_core_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./foundation.core.utils */"./js/foundation.core.utils.js");
      /* harmony import */
      var _foundation_util_keyboard__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./foundation.util.keyboard */"./js/foundation.util.keyboard.js");
      /* harmony import */
      var _foundation_core_plugin__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./foundation.core.plugin */"./js/foundation.core.plugin.js");
      function _typeof(obj) {
        if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
          _typeof = function _typeof(obj) {
            return _typeof2(obj);
          };
        } else {
          _typeof = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
          };
        }
        return _typeof(obj);
      }
      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }
      function _defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }
      function _createClass(Constructor, protoProps, staticProps) {
        if (protoProps) _defineProperties(Constructor.prototype, protoProps);
        if (staticProps) _defineProperties(Constructor, staticProps);
        return Constructor;
      }
      function _possibleConstructorReturn(self, call) {
        if (call && (_typeof(call) === "object" || typeof call === "function")) {
          return call;
        }
        return _assertThisInitialized(self);
      }
      function _assertThisInitialized(self) {
        if (self === void 0) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }
        return self;
      }
      function _getPrototypeOf(o) {
        _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
          return o.__proto__ || Object.getPrototypeOf(o);
        };
        return _getPrototypeOf(o);
      }
      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function");
        }
        subClass.prototype = Object.create(superClass && superClass.prototype, {
          constructor: {
            value: subClass,
            writable: true,
            configurable: true
          }
        });
        if (superClass) _setPrototypeOf(subClass, superClass);
      }
      function _setPrototypeOf(o, p) {
        _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
          o.__proto__ = p;
          return o;
        };
        return _setPrototypeOf(o, p);
      }

      /**
       * Accordion module.
       * @module foundation.accordion
       * @requires foundation.util.keyboard
       */

      var Accordion = /*#__PURE__*/
      function (_Plugin) {
        _inherits(Accordion, _Plugin);
        function Accordion() {
          _classCallCheck(this, Accordion);
          return _possibleConstructorReturn(this, _getPrototypeOf(Accordion).apply(this, arguments));
        }
        _createClass(Accordion, [{
          key: "_setup",
          /**
           * Creates a new instance of an accordion.
           * @class
           * @name Accordion
           * @fires Accordion#init
           * @param {jQuery} element - jQuery object to make into an accordion.
           * @param {Object} options - a plain object with settings to override the default options.
           */
          value: function _setup(element, options) {
            this.$element = element;
            this.options = jquery__WEBPACK_IMPORTED_MODULE_0___default.a.extend({}, Accordion.defaults, this.$element.data(), options);
            this.className = 'Accordion'; // ie9 back compat

            this._init();
            _foundation_util_keyboard__WEBPACK_IMPORTED_MODULE_2__["Keyboard"].register('Accordion', {
              'ENTER': 'toggle',
              'SPACE': 'toggle',
              'ARROW_DOWN': 'next',
              'ARROW_UP': 'previous'
            });
          }
          /**
           * Initializes the accordion by animating the preset active pane(s).
           * @private
           */
        }, {
          key: "_init",
          value: function _init() {
            var _this2 = this;
            this._isInitializing = true;
            this.$element.attr('role', 'tablist');
            this.$tabs = this.$element.children('[data-accordion-item]');
            this.$tabs.each(function (idx, el) {
              var $el = jquery__WEBPACK_IMPORTED_MODULE_0___default()(el),
                $content = $el.children('[data-tab-content]'),
                id = $content[0].id || Object(_foundation_core_utils__WEBPACK_IMPORTED_MODULE_1__["GetYoDigits"])(6, 'accordion'),
                linkId = el.id ? "".concat(el.id, "-label") : "".concat(id, "-label");
              $el.find('a:first').attr({
                'aria-controls': id,
                'role': 'tab',
                'id': linkId,
                'aria-expanded': false,
                'aria-selected': false
              });
              $content.attr({
                'role': 'tabpanel',
                'aria-labelledby': linkId,
                'aria-hidden': true,
                'id': id
              });
            });
            var $initActive = this.$element.find('.is-active').children('[data-tab-content]');
            if ($initActive.length) {
              // Save up the initial hash to return to it later when going back in history
              this._initialAnchor = $initActive.prev('a').attr('href');
              this._openSingleTab($initActive);
            }
            this._checkDeepLink = function () {
              var anchor = window.location.hash;
              if (!anchor.length) {
                // If we are still initializing and there is no anchor, then there is nothing to do
                if (_this2._isInitializing) return; // Otherwise, move to the initial anchor

                if (_this2._initialAnchor) anchor = _this2._initialAnchor;
              }
              var $anchor = anchor && jquery__WEBPACK_IMPORTED_MODULE_0___default()(anchor);
              var $link = anchor && _this2.$element.find("[href$=\"".concat(anchor, "\"]")); // Whether the anchor element that has been found is part of this element

              var isOwnAnchor = !!($anchor.length && $link.length); // If there is an anchor for the hash, open it (if not already active)

              if ($anchor && $link && $link.length) {
                if (!$link.parent('[data-accordion-item]').hasClass('is-active')) {
                  _this2._openSingleTab($anchor);
                }
                ;
              } // Otherwise, close everything
              else {
                _this2._closeAllTabs();
              }
              if (isOwnAnchor) {
                // Roll up a little to show the titles
                if (_this2.options.deepLinkSmudge) {
                  Object(_foundation_core_utils__WEBPACK_IMPORTED_MODULE_1__["onLoad"])(jquery__WEBPACK_IMPORTED_MODULE_0___default()(window), function () {
                    var offset = _this2.$element.offset();
                    jquery__WEBPACK_IMPORTED_MODULE_0___default()('html, body').animate({
                      scrollTop: offset.top
                    }, _this2.options.deepLinkSmudgeDelay);
                  });
                }
                /**
                 * Fires when the plugin has deeplinked at pageload
                 * @event Accordion#deeplink
                 */

                _this2.$element.trigger('deeplink.zf.accordion', [$link, $anchor]);
              }
            }; //use browser to open a tab, if it exists in this tabset

            if (this.options.deepLink) {
              this._checkDeepLink();
            }
            this._events();
            this._isInitializing = false;
          }
          /**
           * Adds event handlers for items within the accordion.
           * @private
           */
        }, {
          key: "_events",
          value: function _events() {
            var _this = this;
            this.$tabs.each(function () {
              var $elem = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this);
              var $tabContent = $elem.children('[data-tab-content]');
              if ($tabContent.length) {
                $elem.children('a').off('click.zf.accordion keydown.zf.accordion').on('click.zf.accordion', function (e) {
                  e.preventDefault();
                  _this.toggle($tabContent);
                }).on('keydown.zf.accordion', function (e) {
                  _foundation_util_keyboard__WEBPACK_IMPORTED_MODULE_2__["Keyboard"].handleKey(e, 'Accordion', {
                    toggle: function toggle() {
                      _this.toggle($tabContent);
                    },
                    next: function next() {
                      var $a = $elem.next().find('a').focus();
                      if (!_this.options.multiExpand) {
                        $a.trigger('click.zf.accordion');
                      }
                    },
                    previous: function previous() {
                      var $a = $elem.prev().find('a').focus();
                      if (!_this.options.multiExpand) {
                        $a.trigger('click.zf.accordion');
                      }
                    },
                    handled: function handled() {
                      e.preventDefault();
                      e.stopPropagation();
                    }
                  });
                });
              }
            });
            if (this.options.deepLink) {
              jquery__WEBPACK_IMPORTED_MODULE_0___default()(window).on('hashchange', this._checkDeepLink);
            }
          }
          /**
           * Toggles the selected content pane's open/close state.
           * @param {jQuery} $target - jQuery object of the pane to toggle (`.accordion-content`).
           * @function
           */
        }, {
          key: "toggle",
          value: function toggle($target) {
            if ($target.closest('[data-accordion]').is('[disabled]')) {
              console.info('Cannot toggle an accordion that is disabled.');
              return;
            }
            if ($target.parent().hasClass('is-active')) {
              this.up($target);
            } else {
              this.down($target);
            } //either replace or update browser history

            if (this.options.deepLink) {
              var anchor = $target.prev('a').attr('href');
              if (this.options.updateHistory) {
                history.pushState({}, '', anchor);
              } else {
                history.replaceState({}, '', anchor);
              }
            }
          }
          /**
           * Opens the accordion tab defined by `$target`.
           * @param {jQuery} $target - Accordion pane to open (`.accordion-content`).
           * @fires Accordion#down
           * @function
           */
        }, {
          key: "down",
          value: function down($target) {
            if ($target.closest('[data-accordion]').is('[disabled]')) {
              console.info('Cannot call down on an accordion that is disabled.');
              return;
            }
            if (this.options.multiExpand) this._openTab($target);else this._openSingleTab($target);
          }
          /**
           * Closes the tab defined by `$target`.
           * It may be ignored if the Accordion options don't allow it.
           *
           * @param {jQuery} $target - Accordion tab to close (`.accordion-content`).
           * @fires Accordion#up
           * @function
           */
        }, {
          key: "up",
          value: function up($target) {
            if (this.$element.is('[disabled]')) {
              console.info('Cannot call up on an accordion that is disabled.');
              return;
            } // Don't close the item if it is already closed

            var $targetItem = $target.parent();
            if (!$targetItem.hasClass('is-active')) return; // Don't close the item if there is no other active item (unless with `allowAllClosed`)

            var $othersItems = $targetItem.siblings();
            if (!this.options.allowAllClosed && !$othersItems.hasClass('is-active')) return;
            this._closeTab($target);
          }
          /**
           * Make the tab defined by `$target` the only opened tab, closing all others tabs.
           * @param {jQuery} $target - Accordion tab to open (`.accordion-content`).
           * @function
           * @private
           */
        }, {
          key: "_openSingleTab",
          value: function _openSingleTab($target) {
            // Close all the others active tabs.
            var $activeContents = this.$element.children('.is-active').children('[data-tab-content]');
            if ($activeContents.length) {
              this._closeTab($activeContents.not($target));
            } // Then open the target.

            this._openTab($target);
          }
          /**
           * Opens the tab defined by `$target`.
           * @param {jQuery} $target - Accordion tab to open (`.accordion-content`).
           * @fires Accordion#down
           * @function
           * @private
           */
        }, {
          key: "_openTab",
          value: function _openTab($target) {
            var _this3 = this;
            var $targetItem = $target.parent();
            var targetContentId = $target.attr('aria-labelledby');
            $target.attr('aria-hidden', false);
            $targetItem.addClass('is-active');
            jquery__WEBPACK_IMPORTED_MODULE_0___default()("#".concat(targetContentId)).attr({
              'aria-expanded': true,
              'aria-selected': true
            });
            $target.slideDown(this.options.slideSpeed, function () {
              /**
               * Fires when the tab is done opening.
               * @event Accordion#down
               */
              _this3.$element.trigger('down.zf.accordion', [$target]);
            });
          }
          /**
           * Closes the tab defined by `$target`.
           * @param {jQuery} $target - Accordion tab to close (`.accordion-content`).
           * @fires Accordion#up
           * @function
           * @private
           */
        }, {
          key: "_closeTab",
          value: function _closeTab($target) {
            var _this4 = this;
            var $targetItem = $target.parent();
            var targetContentId = $target.attr('aria-labelledby');
            $target.attr('aria-hidden', true);
            $targetItem.removeClass('is-active');
            jquery__WEBPACK_IMPORTED_MODULE_0___default()("#".concat(targetContentId)).attr({
              'aria-expanded': false,
              'aria-selected': false
            });
            $target.slideUp(this.options.slideSpeed, function () {
              /**
               * Fires when the tab is done collapsing up.
               * @event Accordion#up
               */
              _this4.$element.trigger('up.zf.accordion', [$target]);
            });
          }
          /**
           * Closes all active tabs
           * @fires Accordion#up
           * @function
           * @private
           */
        }, {
          key: "_closeAllTabs",
          value: function _closeAllTabs() {
            var $activeTabs = this.$element.children('.is-active').children('[data-tab-content]');
            if ($activeTabs.length) {
              this._closeTab($activeTabs);
            }
          }
          /**
           * Destroys an instance of an accordion.
           * @fires Accordion#destroyed
           * @function
           */
        }, {
          key: "_destroy",
          value: function _destroy() {
            this.$element.find('[data-tab-content]').stop(true).slideUp(0).css('display', '');
            this.$element.find('a').off('.zf.accordion');
            if (this.options.deepLink) {
              jquery__WEBPACK_IMPORTED_MODULE_0___default()(window).off('hashchange', this._checkDeepLink);
            }
          }
        }]);
        return Accordion;
      }(_foundation_core_plugin__WEBPACK_IMPORTED_MODULE_3__["Plugin"]);
      Accordion.defaults = {
        /**
         * Amount of time to animate the opening of an accordion pane.
         * @option
         * @type {number}
         * @default 250
         */
        slideSpeed: 250,
        /**
         * Allow the accordion to have multiple open panes.
         * @option
         * @type {boolean}
         * @default false
         */
        multiExpand: false,
        /**
         * Allow the accordion to close all panes.
         * @option
         * @type {boolean}
         * @default false
         */
        allowAllClosed: false,
        /**
         * Link the location hash to the open pane.
         * Set the location hash when the opened pane changes, and open and scroll to the corresponding pane when the location changes.
         * @option
         * @type {boolean}
         * @default false
         */
        deepLink: false,
        /**
         * If `deepLink` is enabled, adjust the deep link scroll to make sure the top of the accordion panel is visible
         * @option
         * @type {boolean}
         * @default false
         */
        deepLinkSmudge: false,
        /**
         * If `deepLinkSmudge` is enabled, animation time (ms) for the deep link adjustment
         * @option
         * @type {number}
         * @default 300
         */
        deepLinkSmudgeDelay: 300,
        /**
         * If `deepLink` is enabled, update the browser history with the open accordion
         * @option
         * @type {boolean}
         * @default false
         */
        updateHistory: false
      };

      /***/
    }),
    /***/"./js/foundation.accordionMenu.js": (
    /*!****************************************!*\
      !*** ./js/foundation.accordionMenu.js ***!
      \****************************************/
    /*! exports provided: AccordionMenu */
    /***/
    function _js_foundationAccordionMenuJs(module, __webpack_exports__, __webpack_require__) {
      "use strict";

      __webpack_require__.r(__webpack_exports__);
      /* harmony export (binding) */
      __webpack_require__.d(__webpack_exports__, "AccordionMenu", function () {
        return AccordionMenu;
      });
      /* harmony import */
      var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! jquery */"jquery");
      /* harmony import */
      var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);
      /* harmony import */
      var _foundation_util_keyboard__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./foundation.util.keyboard */"./js/foundation.util.keyboard.js");
      /* harmony import */
      var _foundation_util_nest__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./foundation.util.nest */"./js/foundation.util.nest.js");
      /* harmony import */
      var _foundation_core_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./foundation.core.utils */"./js/foundation.core.utils.js");
      /* harmony import */
      var _foundation_core_plugin__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./foundation.core.plugin */"./js/foundation.core.plugin.js");
      function _typeof(obj) {
        if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
          _typeof = function _typeof(obj) {
            return _typeof2(obj);
          };
        } else {
          _typeof = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
          };
        }
        return _typeof(obj);
      }
      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }
      function _defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }
      function _createClass(Constructor, protoProps, staticProps) {
        if (protoProps) _defineProperties(Constructor.prototype, protoProps);
        if (staticProps) _defineProperties(Constructor, staticProps);
        return Constructor;
      }
      function _possibleConstructorReturn(self, call) {
        if (call && (_typeof(call) === "object" || typeof call === "function")) {
          return call;
        }
        return _assertThisInitialized(self);
      }
      function _assertThisInitialized(self) {
        if (self === void 0) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }
        return self;
      }
      function _getPrototypeOf(o) {
        _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
          return o.__proto__ || Object.getPrototypeOf(o);
        };
        return _getPrototypeOf(o);
      }
      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function");
        }
        subClass.prototype = Object.create(superClass && superClass.prototype, {
          constructor: {
            value: subClass,
            writable: true,
            configurable: true
          }
        });
        if (superClass) _setPrototypeOf(subClass, superClass);
      }
      function _setPrototypeOf(o, p) {
        _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
          o.__proto__ = p;
          return o;
        };
        return _setPrototypeOf(o, p);
      }

      /**
       * AccordionMenu module.
       * @module foundation.accordionMenu
       * @requires foundation.util.keyboard
       * @requires foundation.util.nest
       */

      var AccordionMenu = /*#__PURE__*/
      function (_Plugin) {
        _inherits(AccordionMenu, _Plugin);
        function AccordionMenu() {
          _classCallCheck(this, AccordionMenu);
          return _possibleConstructorReturn(this, _getPrototypeOf(AccordionMenu).apply(this, arguments));
        }
        _createClass(AccordionMenu, [{
          key: "_setup",
          /**
           * Creates a new instance of an accordion menu.
           * @class
           * @name AccordionMenu
           * @fires AccordionMenu#init
           * @param {jQuery} element - jQuery object to make into an accordion menu.
           * @param {Object} options - Overrides to the default plugin settings.
           */
          value: function _setup(element, options) {
            this.$element = element;
            this.options = jquery__WEBPACK_IMPORTED_MODULE_0___default.a.extend({}, AccordionMenu.defaults, this.$element.data(), options);
            this.className = 'AccordionMenu'; // ie9 back compat

            this._init();
            _foundation_util_keyboard__WEBPACK_IMPORTED_MODULE_1__["Keyboard"].register('AccordionMenu', {
              'ENTER': 'toggle',
              'SPACE': 'toggle',
              'ARROW_RIGHT': 'open',
              'ARROW_UP': 'up',
              'ARROW_DOWN': 'down',
              'ARROW_LEFT': 'close',
              'ESCAPE': 'closeAll'
            });
          }
          /**
           * Initializes the accordion menu by hiding all nested menus.
           * @private
           */
        }, {
          key: "_init",
          value: function _init() {
            _foundation_util_nest__WEBPACK_IMPORTED_MODULE_2__["Nest"].Feather(this.$element, 'accordion');
            var _this = this;
            this.$element.find('[data-submenu]').not('.is-active').slideUp(0); //.find('a').css('padding-left', '1rem');

            this.$element.attr({
              'role': 'tree',
              'aria-multiselectable': this.options.multiOpen
            });
            this.$menuLinks = this.$element.find('.is-accordion-submenu-parent');
            this.$menuLinks.each(function () {
              var linkId = this.id || Object(_foundation_core_utils__WEBPACK_IMPORTED_MODULE_3__["GetYoDigits"])(6, 'acc-menu-link'),
                $elem = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this),
                $sub = $elem.children('[data-submenu]'),
                subId = $sub[0].id || Object(_foundation_core_utils__WEBPACK_IMPORTED_MODULE_3__["GetYoDigits"])(6, 'acc-menu'),
                isActive = $sub.hasClass('is-active');
              if (_this.options.parentLink) {
                var $anchor = $elem.children('a');
                $anchor.clone().prependTo($sub).wrap('<li data-is-parent-link class="is-submenu-parent-item is-submenu-item is-accordion-submenu-item"></li>');
              }
              if (_this.options.submenuToggle) {
                $elem.addClass('has-submenu-toggle');
                $elem.children('a').after('<button id="' + linkId + '" class="submenu-toggle" aria-controls="' + subId + '" aria-expanded="' + isActive + '" title="' + _this.options.submenuToggleText + '"><span class="submenu-toggle-text">' + _this.options.submenuToggleText + '</span></button>');
              } else {
                $elem.attr({
                  'aria-controls': subId,
                  'aria-expanded': isActive,
                  'id': linkId
                });
              }
              $sub.attr({
                'aria-labelledby': linkId,
                'aria-hidden': !isActive,
                'role': 'group',
                'id': subId
              });
            });
            this.$element.find('li').attr({
              'role': 'treeitem'
            });
            var initPanes = this.$element.find('.is-active');
            if (initPanes.length) {
              var _this = this;
              initPanes.each(function () {
                _this.down(jquery__WEBPACK_IMPORTED_MODULE_0___default()(this));
              });
            }
            this._events();
          }
          /**
           * Adds event handlers for items within the menu.
           * @private
           */
        }, {
          key: "_events",
          value: function _events() {
            var _this = this;
            this.$element.find('li').each(function () {
              var $submenu = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).children('[data-submenu]');
              if ($submenu.length) {
                if (_this.options.submenuToggle) {
                  jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).children('.submenu-toggle').off('click.zf.accordionMenu').on('click.zf.accordionMenu', function (e) {
                    _this.toggle($submenu);
                  });
                } else {
                  jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).children('a').off('click.zf.accordionMenu').on('click.zf.accordionMenu', function (e) {
                    e.preventDefault();
                    _this.toggle($submenu);
                  });
                }
              }
            }).on('keydown.zf.accordionmenu', function (e) {
              var $element = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this),
                $elements = $element.parent('ul').children('li'),
                $prevElement,
                $nextElement,
                $target = $element.children('[data-submenu]');
              $elements.each(function (i) {
                if (jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).is($element)) {
                  $prevElement = $elements.eq(Math.max(0, i - 1)).find('a').first();
                  $nextElement = $elements.eq(Math.min(i + 1, $elements.length - 1)).find('a').first();
                  if (jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).children('[data-submenu]:visible').length) {
                    // has open sub menu
                    $nextElement = $element.find('li:first-child').find('a').first();
                  }
                  if (jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).is(':first-child')) {
                    // is first element of sub menu
                    $prevElement = $element.parents('li').first().find('a').first();
                  } else if ($prevElement.parents('li').first().children('[data-submenu]:visible').length) {
                    // if previous element has open sub menu
                    $prevElement = $prevElement.parents('li').find('li:last-child').find('a').first();
                  }
                  if (jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).is(':last-child')) {
                    // is last element of sub menu
                    $nextElement = $element.parents('li').first().next('li').find('a').first();
                  }
                  return;
                }
              });
              _foundation_util_keyboard__WEBPACK_IMPORTED_MODULE_1__["Keyboard"].handleKey(e, 'AccordionMenu', {
                open: function open() {
                  if ($target.is(':hidden')) {
                    _this.down($target);
                    $target.find('li').first().find('a').first().focus();
                  }
                },
                close: function close() {
                  if ($target.length && !$target.is(':hidden')) {
                    // close active sub of this item
                    _this.up($target);
                  } else if ($element.parent('[data-submenu]').length) {
                    // close currently open sub
                    _this.up($element.parent('[data-submenu]'));
                    $element.parents('li').first().find('a').first().focus();
                  }
                },
                up: function up() {
                  $prevElement.focus();
                  return true;
                },
                down: function down() {
                  $nextElement.focus();
                  return true;
                },
                toggle: function toggle() {
                  if (_this.options.submenuToggle) {
                    return false;
                  }
                  if ($element.children('[data-submenu]').length) {
                    _this.toggle($element.children('[data-submenu]'));
                    return true;
                  }
                },
                closeAll: function closeAll() {
                  _this.hideAll();
                },
                handled: function handled(preventDefault) {
                  if (preventDefault) {
                    e.preventDefault();
                  }
                  e.stopImmediatePropagation();
                }
              });
            }); //.attr('tabindex', 0);
          }
          /**
           * Closes all panes of the menu.
           * @function
           */
        }, {
          key: "hideAll",
          value: function hideAll() {
            this.up(this.$element.find('[data-submenu]'));
          }
          /**
           * Opens all panes of the menu.
           * @function
           */
        }, {
          key: "showAll",
          value: function showAll() {
            this.down(this.$element.find('[data-submenu]'));
          }
          /**
           * Toggles the open/close state of a submenu.
           * @function
           * @param {jQuery} $target - the submenu to toggle
           */
        }, {
          key: "toggle",
          value: function toggle($target) {
            if (!$target.is(':animated')) {
              if (!$target.is(':hidden')) {
                this.up($target);
              } else {
                this.down($target);
              }
            }
          }
          /**
           * Opens the sub-menu defined by `$target`.
           * @param {jQuery} $target - Sub-menu to open.
           * @fires AccordionMenu#down
           */
        }, {
          key: "down",
          value: function down($target) {
            var _this2 = this;

            // If having multiple submenus active is disabled, close all the submenus
            // that are not parents or children of the targeted submenu.
            if (!this.options.multiOpen) {
              // The "branch" of the targetted submenu, from the component root to
              // the active submenus nested in it.
              var $targetBranch = $target.parentsUntil(this.$element).add($target).add($target.find('.is-active')); // All the active submenus that are not in the branch.

              var $othersActiveSubmenus = this.$element.find('.is-active').not($targetBranch);
              this.up($othersActiveSubmenus);
            }
            $target.addClass('is-active').attr({
              'aria-hidden': false
            });
            if (this.options.submenuToggle) {
              $target.prev('.submenu-toggle').attr({
                'aria-expanded': true
              });
            } else {
              $target.parent('.is-accordion-submenu-parent').attr({
                'aria-expanded': true
              });
            }
            $target.slideDown(this.options.slideSpeed, function () {
              /**
               * Fires when the menu is done opening.
               * @event AccordionMenu#down
               */
              _this2.$element.trigger('down.zf.accordionMenu', [$target]);
            });
          }
          /**
           * Closes the sub-menu defined by `$target`. All sub-menus inside the target will be closed as well.
           * @param {jQuery} $target - Sub-menu to close.
           * @fires AccordionMenu#up
           */
        }, {
          key: "up",
          value: function up($target) {
            var _this3 = this;
            var $submenus = $target.find('[data-submenu]');
            var $allmenus = $target.add($submenus);
            $submenus.slideUp(0);
            $allmenus.removeClass('is-active').attr('aria-hidden', true);
            if (this.options.submenuToggle) {
              $allmenus.prev('.submenu-toggle').attr('aria-expanded', false);
            } else {
              $allmenus.parent('.is-accordion-submenu-parent').attr('aria-expanded', false);
            }
            $target.slideUp(this.options.slideSpeed, function () {
              /**
               * Fires when the menu is done collapsing up.
               * @event AccordionMenu#up
               */
              _this3.$element.trigger('up.zf.accordionMenu', [$target]);
            });
          }
          /**
           * Destroys an instance of accordion menu.
           * @fires AccordionMenu#destroyed
           */
        }, {
          key: "_destroy",
          value: function _destroy() {
            this.$element.find('[data-submenu]').slideDown(0).css('display', '');
            this.$element.find('a').off('click.zf.accordionMenu');
            this.$element.find('[data-is-parent-link]').detach();
            if (this.options.submenuToggle) {
              this.$element.find('.has-submenu-toggle').removeClass('has-submenu-toggle');
              this.$element.find('.submenu-toggle').remove();
            }
            _foundation_util_nest__WEBPACK_IMPORTED_MODULE_2__["Nest"].Burn(this.$element, 'accordion');
          }
        }]);
        return AccordionMenu;
      }(_foundation_core_plugin__WEBPACK_IMPORTED_MODULE_4__["Plugin"]);
      AccordionMenu.defaults = {
        /**
         * Adds the parent link to the submenu.
         * @option
         * @type {boolean}
         * @default false
         */
        parentLink: false,
        /**
         * Amount of time to animate the opening of a submenu in ms.
         * @option
         * @type {number}
         * @default 250
         */
        slideSpeed: 250,
        /**
         * Adds a separate submenu toggle button. This allows the parent item to have a link.
         * @option
         * @example true
         */
        submenuToggle: false,
        /**
         * The text used for the submenu toggle if enabled. This is used for screen readers only.
         * @option
         * @example true
         */
        submenuToggleText: 'Toggle menu',
        /**
         * Allow the menu to have multiple open panes.
         * @option
         * @type {boolean}
         * @default true
         */
        multiOpen: true
      };

      /***/
    }),
    /***/"./js/foundation.core.js": (
    /*!*******************************!*\
      !*** ./js/foundation.core.js ***!
      \*******************************/
    /*! exports provided: Foundation */
    /***/
    function _js_foundationCoreJs(module, __webpack_exports__, __webpack_require__) {
      "use strict";

      __webpack_require__.r(__webpack_exports__);
      /* harmony export (binding) */
      __webpack_require__.d(__webpack_exports__, "Foundation", function () {
        return Foundation;
      });
      /* harmony import */
      var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! jquery */"jquery");
      /* harmony import */
      var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);
      /* harmony import */
      var _foundation_core_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./foundation.core.utils */"./js/foundation.core.utils.js");
      /* harmony import */
      var _foundation_util_mediaQuery__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./foundation.util.mediaQuery */"./js/foundation.util.mediaQuery.js");
      function _typeof(obj) {
        if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
          _typeof = function _typeof(obj) {
            return _typeof2(obj);
          };
        } else {
          _typeof = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
          };
        }
        return _typeof(obj);
      }
      var FOUNDATION_VERSION = '6.5.3'; // Global Foundation object
      // This is attached to the window, or used as a module for AMD/Browserify

      var Foundation = {
        version: FOUNDATION_VERSION,
        /**
         * Stores initialized plugins.
         */
        _plugins: {},
        /**
         * Stores generated unique ids for plugin instances
         */
        _uuids: [],
        /**
         * Defines a Foundation plugin, adding it to the `Foundation` namespace and the list of plugins to initialize when reflowing.
         * @param {Object} plugin - The constructor of the plugin.
         */
        plugin: function plugin(_plugin, name) {
          // Object key to use when adding to global Foundation object
          // Examples: Foundation.Reveal, Foundation.OffCanvas
          var className = name || functionName(_plugin); // Object key to use when storing the plugin, also used to create the identifying data attribute for the plugin
          // Examples: data-reveal, data-off-canvas

          var attrName = hyphenate(className); // Add to the Foundation object and the plugins list (for reflowing)

          this._plugins[attrName] = this[className] = _plugin;
        },
        /**
         * @function
         * Populates the _uuids array with pointers to each individual plugin instance.
         * Adds the `zfPlugin` data-attribute to programmatically created plugins to allow use of $(selector).foundation(method) calls.
         * Also fires the initialization event for each plugin, consolidating repetitive code.
         * @param {Object} plugin - an instance of a plugin, usually `this` in context.
         * @param {String} name - the name of the plugin, passed as a camelCased string.
         * @fires Plugin#init
         */
        registerPlugin: function registerPlugin(plugin, name) {
          var pluginName = name ? hyphenate(name) : functionName(plugin.constructor).toLowerCase();
          plugin.uuid = Object(_foundation_core_utils__WEBPACK_IMPORTED_MODULE_1__["GetYoDigits"])(6, pluginName);
          if (!plugin.$element.attr("data-".concat(pluginName))) {
            plugin.$element.attr("data-".concat(pluginName), plugin.uuid);
          }
          if (!plugin.$element.data('zfPlugin')) {
            plugin.$element.data('zfPlugin', plugin);
          }
          /**
           * Fires when the plugin has initialized.
           * @event Plugin#init
           */

          plugin.$element.trigger("init.zf.".concat(pluginName));
          this._uuids.push(plugin.uuid);
          return;
        },
        /**
         * @function
         * Removes the plugins uuid from the _uuids array.
         * Removes the zfPlugin data attribute, as well as the data-plugin-name attribute.
         * Also fires the destroyed event for the plugin, consolidating repetitive code.
         * @param {Object} plugin - an instance of a plugin, usually `this` in context.
         * @fires Plugin#destroyed
         */
        unregisterPlugin: function unregisterPlugin(plugin) {
          var pluginName = hyphenate(functionName(plugin.$element.data('zfPlugin').constructor));
          this._uuids.splice(this._uuids.indexOf(plugin.uuid), 1);
          plugin.$element.removeAttr("data-".concat(pluginName)).removeData('zfPlugin')
          /**
           * Fires when the plugin has been destroyed.
           * @event Plugin#destroyed
           */.trigger("destroyed.zf.".concat(pluginName));
          for (var prop in plugin) {
            plugin[prop] = null; //clean up script to prep for garbage collection.
          }
          return;
        },
        /**
         * @function
         * Causes one or more active plugins to re-initialize, resetting event listeners, recalculating positions, etc.
         * @param {String} plugins - optional string of an individual plugin key, attained by calling `$(element).data('pluginName')`, or string of a plugin class i.e. `'dropdown'`
         * @default If no argument is passed, reflow all currently active plugins.
         */
        reInit: function reInit(plugins) {
          var isJQ = plugins instanceof jquery__WEBPACK_IMPORTED_MODULE_0___default.a;
          try {
            if (isJQ) {
              plugins.each(function () {
                jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).data('zfPlugin')._init();
              });
            } else {
              var type = _typeof(plugins),
                _this = this,
                fns = {
                  'object': function object(plgs) {
                    plgs.forEach(function (p) {
                      p = hyphenate(p);
                      jquery__WEBPACK_IMPORTED_MODULE_0___default()('[data-' + p + ']').foundation('_init');
                    });
                  },
                  'string': function string() {
                    plugins = hyphenate(plugins);
                    jquery__WEBPACK_IMPORTED_MODULE_0___default()('[data-' + plugins + ']').foundation('_init');
                  },
                  'undefined': function undefined() {
                    this['object'](Object.keys(_this._plugins));
                  }
                };
              fns[type](plugins);
            }
          } catch (err) {
            console.error(err);
          } finally {
            return plugins;
          }
        },
        /**
         * Initialize plugins on any elements within `elem` (and `elem` itself) that aren't already initialized.
         * @param {Object} elem - jQuery object containing the element to check inside. Also checks the element itself, unless it's the `document` object.
         * @param {String|Array} plugins - A list of plugins to initialize. Leave this out to initialize everything.
         */
        reflow: function reflow(elem, plugins) {
          // If plugins is undefined, just grab everything
          if (typeof plugins === 'undefined') {
            plugins = Object.keys(this._plugins);
          } // If plugins is a string, convert it to an array with one item
          else if (typeof plugins === 'string') {
            plugins = [plugins];
          }
          var _this = this; // Iterate through each plugin

          jquery__WEBPACK_IMPORTED_MODULE_0___default.a.each(plugins, function (i, name) {
            // Get the current plugin
            var plugin = _this._plugins[name]; // Localize the search to all elements inside elem, as well as elem itself, unless elem === document

            var $elem = jquery__WEBPACK_IMPORTED_MODULE_0___default()(elem).find('[data-' + name + ']').addBack('[data-' + name + ']'); // For each plugin found, initialize it

            $elem.each(function () {
              var $el = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this),
                opts = {}; // Don't double-dip on plugins

              if ($el.data('zfPlugin')) {
                console.warn("Tried to initialize " + name + " on an element that already has a Foundation plugin.");
                return;
              }
              if ($el.attr('data-options')) {
                var thing = $el.attr('data-options').split(';').forEach(function (e, i) {
                  var opt = e.split(':').map(function (el) {
                    return el.trim();
                  });
                  if (opt[0]) opts[opt[0]] = parseValue(opt[1]);
                });
              }
              try {
                $el.data('zfPlugin', new plugin(jquery__WEBPACK_IMPORTED_MODULE_0___default()(this), opts));
              } catch (er) {
                console.error(er);
              } finally {
                return;
              }
            });
          });
        },
        getFnName: functionName,
        addToJquery: function addToJquery($) {
          // TODO: consider not making this a jQuery function
          // TODO: need way to reflow vs. re-initialize

          /**
           * The Foundation jQuery method.
           * @param {String|Array} method - An action to perform on the current jQuery object.
           */
          var foundation = function foundation(method) {
            var type = _typeof(method),
              $noJS = $('.no-js');
            if ($noJS.length) {
              $noJS.removeClass('no-js');
            }
            if (type === 'undefined') {
              //needs to initialize the Foundation object, or an individual plugin.
              _foundation_util_mediaQuery__WEBPACK_IMPORTED_MODULE_2__["MediaQuery"]._init();
              Foundation.reflow(this);
            } else if (type === 'string') {
              //an individual method to invoke on a plugin or group of plugins
              var args = Array.prototype.slice.call(arguments, 1); //collect all the arguments, if necessary

              var plugClass = this.data('zfPlugin'); //determine the class of plugin

              if (typeof plugClass !== 'undefined' && typeof plugClass[method] !== 'undefined') {
                //make sure both the class and method exist
                if (this.length === 1) {
                  //if there's only one, call it directly.
                  plugClass[method].apply(plugClass, args);
                } else {
                  this.each(function (i, el) {
                    //otherwise loop through the jQuery collection and invoke the method on each
                    plugClass[method].apply($(el).data('zfPlugin'), args);
                  });
                }
              } else {
                //error for no class or no method
                throw new ReferenceError("We're sorry, '" + method + "' is not an available method for " + (plugClass ? functionName(plugClass) : 'this element') + '.');
              }
            } else {
              //error for invalid argument type
              throw new TypeError("We're sorry, ".concat(type, " is not a valid parameter. You must use a string representing the method you wish to invoke."));
            }
            return this;
          };
          $.fn.foundation = foundation;
          return $;
        }
      };
      Foundation.util = {
        /**
         * Function for applying a debounce effect to a function call.
         * @function
         * @param {Function} func - Function to be called at end of timeout.
         * @param {Number} delay - Time in ms to delay the call of `func`.
         * @returns function
         */
        throttle: function throttle(func, delay) {
          var timer = null;
          return function () {
            var context = this,
              args = arguments;
            if (timer === null) {
              timer = setTimeout(function () {
                func.apply(context, args);
                timer = null;
              }, delay);
            }
          };
        }
      };
      window.Foundation = Foundation; // Polyfill for requestAnimationFrame

      (function () {
        if (!Date.now || !window.Date.now) window.Date.now = Date.now = function () {
          return new Date().getTime();
        };
        var vendors = ['webkit', 'moz'];
        for (var i = 0; i < vendors.length && !window.requestAnimationFrame; ++i) {
          var vp = vendors[i];
          window.requestAnimationFrame = window[vp + 'RequestAnimationFrame'];
          window.cancelAnimationFrame = window[vp + 'CancelAnimationFrame'] || window[vp + 'CancelRequestAnimationFrame'];
        }
        if (/iP(ad|hone|od).*OS 6/.test(window.navigator.userAgent) || !window.requestAnimationFrame || !window.cancelAnimationFrame) {
          var lastTime = 0;
          window.requestAnimationFrame = function (callback) {
            var now = Date.now();
            var nextTime = Math.max(lastTime + 16, now);
            return setTimeout(function () {
              callback(lastTime = nextTime);
            }, nextTime - now);
          };
          window.cancelAnimationFrame = clearTimeout;
        }
        /**
         * Polyfill for performance.now, required by rAF
         */

        if (!window.performance || !window.performance.now) {
          window.performance = {
            start: Date.now(),
            now: function now() {
              return Date.now() - this.start;
            }
          };
        }
      })();
      if (!Function.prototype.bind) {
        Function.prototype.bind = function (oThis) {
          if (typeof this !== 'function') {
            // closest thing possible to the ECMAScript 5
            // internal IsCallable function
            throw new TypeError('Function.prototype.bind - what is trying to be bound is not callable');
          }
          var aArgs = Array.prototype.slice.call(arguments, 1),
            fToBind = this,
            fNOP = function fNOP() {},
            fBound = function fBound() {
              return fToBind.apply(this instanceof fNOP ? this : oThis, aArgs.concat(Array.prototype.slice.call(arguments)));
            };
          if (this.prototype) {
            // native functions don't have a prototype
            fNOP.prototype = this.prototype;
          }
          fBound.prototype = new fNOP();
          return fBound;
        };
      } // Polyfill to get the name of a function in IE9

      function functionName(fn) {
        if (typeof Function.prototype.name === 'undefined') {
          var funcNameRegex = /function\s([^(]{1,})\(/;
          var results = funcNameRegex.exec(fn.toString());
          return results && results.length > 1 ? results[1].trim() : "";
        } else if (typeof fn.prototype === 'undefined') {
          return fn.constructor.name;
        } else {
          return fn.prototype.constructor.name;
        }
      }
      function parseValue(str) {
        if ('true' === str) return true;else if ('false' === str) return false;else if (!isNaN(str * 1)) return parseFloat(str);
        return str;
      } // Convert PascalCase to kebab-case
      // Thank you: http://stackoverflow.com/a/8955580

      function hyphenate(str) {
        return str.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
      }

      /***/
    }),
    /***/"./js/foundation.core.plugin.js": (
    /*!**************************************!*\
      !*** ./js/foundation.core.plugin.js ***!
      \**************************************/
    /*! exports provided: Plugin */
    /***/
    function _js_foundationCorePluginJs(module, __webpack_exports__, __webpack_require__) {
      "use strict";

      __webpack_require__.r(__webpack_exports__);
      /* harmony export (binding) */
      __webpack_require__.d(__webpack_exports__, "Plugin", function () {
        return Plugin;
      });
      /* harmony import */
      var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! jquery */"jquery");
      /* harmony import */
      var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);
      /* harmony import */
      var _foundation_core_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./foundation.core.utils */"./js/foundation.core.utils.js");
      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }
      function _defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }
      function _createClass(Constructor, protoProps, staticProps) {
        if (protoProps) _defineProperties(Constructor.prototype, protoProps);
        if (staticProps) _defineProperties(Constructor, staticProps);
        return Constructor;
      }

      // Abstract class for providing lifecycle hooks. Expect plugins to define AT LEAST
      // {function} _setup (replaces previous constructor),
      // {function} _destroy (replaces previous destroy)

      var Plugin = /*#__PURE__*/
      function () {
        function Plugin(element, options) {
          _classCallCheck(this, Plugin);
          this._setup(element, options);
          var pluginName = getPluginName(this);
          this.uuid = Object(_foundation_core_utils__WEBPACK_IMPORTED_MODULE_1__["GetYoDigits"])(6, pluginName);
          if (!this.$element.attr("data-".concat(pluginName))) {
            this.$element.attr("data-".concat(pluginName), this.uuid);
          }
          if (!this.$element.data('zfPlugin')) {
            this.$element.data('zfPlugin', this);
          }
          /**
           * Fires when the plugin has initialized.
           * @event Plugin#init
           */

          this.$element.trigger("init.zf.".concat(pluginName));
        }
        _createClass(Plugin, [{
          key: "destroy",
          value: function destroy() {
            this._destroy();
            var pluginName = getPluginName(this);
            this.$element.removeAttr("data-".concat(pluginName)).removeData('zfPlugin')
            /**
             * Fires when the plugin has been destroyed.
             * @event Plugin#destroyed
             */.trigger("destroyed.zf.".concat(pluginName));
            for (var prop in this) {
              this[prop] = null; //clean up script to prep for garbage collection.
            }
          }
        }]);
        return Plugin;
      }(); // Convert PascalCase to kebab-case
      // Thank you: http://stackoverflow.com/a/8955580

      function hyphenate(str) {
        return str.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
      }
      function getPluginName(obj) {
        if (typeof obj.constructor.name !== 'undefined') {
          return hyphenate(obj.constructor.name);
        } else {
          return hyphenate(obj.className);
        }
      }

      /***/
    }),
    /***/"./js/foundation.core.utils.js": (
    /*!*************************************!*\
      !*** ./js/foundation.core.utils.js ***!
      \*************************************/
    /*! exports provided: rtl, GetYoDigits, RegExpEscape, transitionend, onLoad, ignoreMousedisappear */
    /***/
    function _js_foundationCoreUtilsJs(module, __webpack_exports__, __webpack_require__) {
      "use strict";

      __webpack_require__.r(__webpack_exports__);
      /* harmony export (binding) */
      __webpack_require__.d(__webpack_exports__, "rtl", function () {
        return rtl;
      });
      /* harmony export (binding) */
      __webpack_require__.d(__webpack_exports__, "GetYoDigits", function () {
        return GetYoDigits;
      });
      /* harmony export (binding) */
      __webpack_require__.d(__webpack_exports__, "RegExpEscape", function () {
        return RegExpEscape;
      });
      /* harmony export (binding) */
      __webpack_require__.d(__webpack_exports__, "transitionend", function () {
        return transitionend;
      });
      /* harmony export (binding) */
      __webpack_require__.d(__webpack_exports__, "onLoad", function () {
        return onLoad;
      });
      /* harmony export (binding) */
      __webpack_require__.d(__webpack_exports__, "ignoreMousedisappear", function () {
        return ignoreMousedisappear;
      });
      /* harmony import */
      var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! jquery */"jquery");
      /* harmony import */
      var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);

      // Core Foundation Utilities, utilized in a number of places.

      /**
       * Returns a boolean for RTL support
       */

      function rtl() {
        return jquery__WEBPACK_IMPORTED_MODULE_0___default()('html').attr('dir') === 'rtl';
      }
      /**
       * returns a random base-36 uid with namespacing
       * @function
       * @param {Number} length - number of random base-36 digits desired. Increase for more random strings.
       * @param {String} namespace - name of plugin to be incorporated in uid, optional.
       * @default {String} '' - if no plugin name is provided, nothing is appended to the uid.
       * @returns {String} - unique id
       */

      function GetYoDigits(length, namespace) {
        length = length || 6;
        return Math.round(Math.pow(36, length + 1) - Math.random() * Math.pow(36, length)).toString(36).slice(1) + (namespace ? "-".concat(namespace) : '');
      }
      /**
       * Escape a string so it can be used as a regexp pattern
       * @function
       * @see https://stackoverflow.com/a/9310752/4317384
       *
       * @param {String} str - string to escape.
       * @returns {String} - escaped string
       */

      function RegExpEscape(str) {
        return str.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
      }
      function transitionend($elem) {
        var transitions = {
          'transition': 'transitionend',
          'WebkitTransition': 'webkitTransitionEnd',
          'MozTransition': 'transitionend',
          'OTransition': 'otransitionend'
        };
        var elem = document.createElement('div'),
          end;
        for (var t in transitions) {
          if (typeof elem.style[t] !== 'undefined') {
            end = transitions[t];
          }
        }
        if (end) {
          return end;
        } else {
          end = setTimeout(function () {
            $elem.triggerHandler('transitionend', [$elem]);
          }, 1);
          return 'transitionend';
        }
      }
      /**
       * Return an event type to listen for window load.
       *
       * If `$elem` is passed, an event will be triggered on `$elem`. If window is already loaded, the event will still be triggered.
       * If `handler` is passed, attach it to the event on `$elem`.
       * Calling `onLoad` without handler allows you to get the event type that will be triggered before attaching the handler by yourself.
       * @function
       *
       * @param {Object} [] $elem - jQuery element on which the event will be triggered if passed.
       * @param {Function} [] handler - function to attach to the event.
       * @returns {String} - event type that should or will be triggered.
       */

      function onLoad($elem, handler) {
        var didLoad = document.readyState === 'complete';
        var eventType = (didLoad ? '_didLoad' : 'load') + '.zf.util.onLoad';
        var cb = function cb() {
          return $elem.triggerHandler(eventType);
        };
        if ($elem) {
          if (handler) $elem.one(eventType, handler);
          if (didLoad) setTimeout(cb);else jquery__WEBPACK_IMPORTED_MODULE_0___default()(window).one('load', cb);
        }
        return eventType;
      }
      /**
       * Retuns an handler for the `mouseleave` that ignore disappeared mouses.
       *
       * If the mouse "disappeared" from the document (like when going on a browser UI element, See https://git.io/zf-11410),
       * the event is ignored.
       * - If the `ignoreLeaveWindow` is `true`, the event is ignored when the user actually left the window
       *   (like by switching to an other window with [Alt]+[Tab]).
       * - If the `ignoreReappear` is `true`, the event will be ignored when the mouse will reappear later on the document
       *   outside of the element it left.
       *
       * @function
       *
       * @param {Function} [] handler - handler for the filtered `mouseleave` event to watch.
       * @param {Object} [] options - object of options:
       * - {Boolean} [false] ignoreLeaveWindow - also ignore when the user switched windows.
       * - {Boolean} [false] ignoreReappear - also ignore when the mouse reappeared outside of the element it left.
       * @returns {Function} - filtered handler to use to listen on the `mouseleave` event.
       */

      function ignoreMousedisappear(handler) {
        var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref$ignoreLeaveWindo = _ref.ignoreLeaveWindow,
          ignoreLeaveWindow = _ref$ignoreLeaveWindo === void 0 ? false : _ref$ignoreLeaveWindo,
          _ref$ignoreReappear = _ref.ignoreReappear,
          ignoreReappear = _ref$ignoreReappear === void 0 ? false : _ref$ignoreReappear;
        return function leaveEventHandler(eLeave) {
          for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            rest[_key - 1] = arguments[_key];
          }
          var callback = handler.bind.apply(handler, [this, eLeave].concat(rest)); // The mouse left: call the given callback if the mouse entered elsewhere

          if (eLeave.relatedTarget !== null) {
            return callback();
          } // Otherwise, check if the mouse actually left the window.
          // In firefox if the user switched between windows, the window sill have the focus by the time
          // the event is triggered. We have to debounce the event to test this case.

          setTimeout(function leaveEventDebouncer() {
            if (!ignoreLeaveWindow && document.hasFocus && !document.hasFocus()) {
              return callback();
            } // Otherwise, wait for the mouse to reeapear outside of the element,

            if (!ignoreReappear) {
              jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).one('mouseenter', function reenterEventHandler(eReenter) {
                if (!jquery__WEBPACK_IMPORTED_MODULE_0___default()(eLeave.currentTarget).has(eReenter.target).length) {
                  // Fill where the mouse finally entered.
                  eLeave.relatedTarget = eReenter.target;
                  callback();
                }
              });
            }
          }, 0);
        };
      }

      /***/
    }),
    /***/"./js/foundation.drilldown.js": (
    /*!************************************!*\
      !*** ./js/foundation.drilldown.js ***!
      \************************************/
    /*! exports provided: Drilldown */
    /***/
    function _js_foundationDrilldownJs(module, __webpack_exports__, __webpack_require__) {
      "use strict";

      __webpack_require__.r(__webpack_exports__);
      /* harmony export (binding) */
      __webpack_require__.d(__webpack_exports__, "Drilldown", function () {
        return Drilldown;
      });
      /* harmony import */
      var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! jquery */"jquery");
      /* harmony import */
      var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);
      /* harmony import */
      var _foundation_util_keyboard__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./foundation.util.keyboard */"./js/foundation.util.keyboard.js");
      /* harmony import */
      var _foundation_util_nest__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./foundation.util.nest */"./js/foundation.util.nest.js");
      /* harmony import */
      var _foundation_core_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./foundation.core.utils */"./js/foundation.core.utils.js");
      /* harmony import */
      var _foundation_util_box__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./foundation.util.box */"./js/foundation.util.box.js");
      /* harmony import */
      var _foundation_core_plugin__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./foundation.core.plugin */"./js/foundation.core.plugin.js");
      function _typeof(obj) {
        if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
          _typeof = function _typeof(obj) {
            return _typeof2(obj);
          };
        } else {
          _typeof = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
          };
        }
        return _typeof(obj);
      }
      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }
      function _defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }
      function _createClass(Constructor, protoProps, staticProps) {
        if (protoProps) _defineProperties(Constructor.prototype, protoProps);
        if (staticProps) _defineProperties(Constructor, staticProps);
        return Constructor;
      }
      function _possibleConstructorReturn(self, call) {
        if (call && (_typeof(call) === "object" || typeof call === "function")) {
          return call;
        }
        return _assertThisInitialized(self);
      }
      function _assertThisInitialized(self) {
        if (self === void 0) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }
        return self;
      }
      function _getPrototypeOf(o) {
        _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
          return o.__proto__ || Object.getPrototypeOf(o);
        };
        return _getPrototypeOf(o);
      }
      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function");
        }
        subClass.prototype = Object.create(superClass && superClass.prototype, {
          constructor: {
            value: subClass,
            writable: true,
            configurable: true
          }
        });
        if (superClass) _setPrototypeOf(subClass, superClass);
      }
      function _setPrototypeOf(o, p) {
        _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
          o.__proto__ = p;
          return o;
        };
        return _setPrototypeOf(o, p);
      }

      /**
       * Drilldown module.
       * @module foundation.drilldown
       * @requires foundation.util.keyboard
       * @requires foundation.util.nest
       * @requires foundation.util.box
       */

      var Drilldown = /*#__PURE__*/
      function (_Plugin) {
        _inherits(Drilldown, _Plugin);
        function Drilldown() {
          _classCallCheck(this, Drilldown);
          return _possibleConstructorReturn(this, _getPrototypeOf(Drilldown).apply(this, arguments));
        }
        _createClass(Drilldown, [{
          key: "_setup",
          /**
           * Creates a new instance of a drilldown menu.
           * @class
           * @name Drilldown
           * @param {jQuery} element - jQuery object to make into an accordion menu.
           * @param {Object} options - Overrides to the default plugin settings.
           */
          value: function _setup(element, options) {
            this.$element = element;
            this.options = jquery__WEBPACK_IMPORTED_MODULE_0___default.a.extend({}, Drilldown.defaults, this.$element.data(), options);
            this.className = 'Drilldown'; // ie9 back compat

            this._init();
            _foundation_util_keyboard__WEBPACK_IMPORTED_MODULE_1__["Keyboard"].register('Drilldown', {
              'ENTER': 'open',
              'SPACE': 'open',
              'ARROW_RIGHT': 'next',
              'ARROW_UP': 'up',
              'ARROW_DOWN': 'down',
              'ARROW_LEFT': 'previous',
              'ESCAPE': 'close',
              'TAB': 'down',
              'SHIFT_TAB': 'up'
            });
          }
          /**
           * Initializes the drilldown by creating jQuery collections of elements
           * @private
           */
        }, {
          key: "_init",
          value: function _init() {
            _foundation_util_nest__WEBPACK_IMPORTED_MODULE_2__["Nest"].Feather(this.$element, 'drilldown');
            if (this.options.autoApplyClass) {
              this.$element.addClass('drilldown');
            }
            this.$element.attr({
              'role': 'tree',
              'aria-multiselectable': false
            });
            this.$submenuAnchors = this.$element.find('li.is-drilldown-submenu-parent').children('a');
            this.$submenus = this.$submenuAnchors.parent('li').children('[data-submenu]').attr('role', 'group');
            this.$menuItems = this.$element.find('li').not('.js-drilldown-back').attr('role', 'treeitem').find('a'); // Set the main menu as current by default (unless a submenu is selected)
            // Used to set the wrapper height when the drilldown is closed/reopened from any (sub)menu

            this.$currentMenu = this.$element;
            this.$element.attr('data-mutate', this.$element.attr('data-drilldown') || Object(_foundation_core_utils__WEBPACK_IMPORTED_MODULE_3__["GetYoDigits"])(6, 'drilldown'));
            this._prepareMenu();
            this._registerEvents();
            this._keyboardEvents();
          }
          /**
           * prepares drilldown menu by setting attributes to links and elements
           * sets a min height to prevent content jumping
           * wraps the element if not already wrapped
           * @private
           * @function
           */
        }, {
          key: "_prepareMenu",
          value: function _prepareMenu() {
            var _this = this; // if(!this.options.holdOpen){
            //   this._menuLinkEvents();
            // }

            this.$submenuAnchors.each(function () {
              var $link = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this);
              var $sub = $link.parent();
              if (_this.options.parentLink) {
                $link.clone().prependTo($sub.children('[data-submenu]')).wrap('<li data-is-parent-link class="is-submenu-parent-item is-submenu-item is-drilldown-submenu-item" role="menuitem"></li>');
              }
              $link.data('savedHref', $link.attr('href')).removeAttr('href').attr('tabindex', 0);
              $link.children('[data-submenu]').attr({
                'aria-hidden': true,
                'tabindex': 0,
                'role': 'group'
              });
              _this._events($link);
            });
            this.$submenus.each(function () {
              var $menu = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this),
                $back = $menu.find('.js-drilldown-back');
              if (!$back.length) {
                switch (_this.options.backButtonPosition) {
                  case "bottom":
                    $menu.append(_this.options.backButton);
                    break;
                  case "top":
                    $menu.prepend(_this.options.backButton);
                    break;
                  default:
                    console.error("Unsupported backButtonPosition value '" + _this.options.backButtonPosition + "'");
                }
              }
              _this._back($menu);
            });
            this.$submenus.addClass('invisible');
            if (!this.options.autoHeight) {
              this.$submenus.addClass('drilldown-submenu-cover-previous');
            } // create a wrapper on element if it doesn't exist.

            if (!this.$element.parent().hasClass('is-drilldown')) {
              this.$wrapper = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this.options.wrapper).addClass('is-drilldown');
              if (this.options.animateHeight) this.$wrapper.addClass('animate-height');
              this.$element.wrap(this.$wrapper);
            } // set wrapper

            this.$wrapper = this.$element.parent();
            this.$wrapper.css(this._getMaxDims());
          }
        }, {
          key: "_resize",
          value: function _resize() {
            this.$wrapper.css({
              'max-width': 'none',
              'min-height': 'none'
            }); // _getMaxDims has side effects (boo) but calling it should update all other necessary heights & widths

            this.$wrapper.css(this._getMaxDims());
          }
          /**
           * Adds event handlers to elements in the menu.
           * @function
           * @private
           * @param {jQuery} $elem - the current menu item to add handlers to.
           */
        }, {
          key: "_events",
          value: function _events($elem) {
            var _this = this;
            $elem.off('click.zf.drilldown').on('click.zf.drilldown', function (e) {
              if (jquery__WEBPACK_IMPORTED_MODULE_0___default()(e.target).parentsUntil('ul', 'li').hasClass('is-drilldown-submenu-parent')) {
                e.stopImmediatePropagation();
                e.preventDefault();
              } // if(e.target !== e.currentTarget.firstElementChild){
              //   return false;
              // }

              _this._show($elem.parent('li'));
              if (_this.options.closeOnClick) {
                var $body = jquery__WEBPACK_IMPORTED_MODULE_0___default()('body');
                $body.off('.zf.drilldown').on('click.zf.drilldown', function (e) {
                  if (e.target === _this.$element[0] || jquery__WEBPACK_IMPORTED_MODULE_0___default.a.contains(_this.$element[0], e.target)) {
                    return;
                  }
                  e.preventDefault();
                  _this._hideAll();
                  $body.off('.zf.drilldown');
                });
              }
            });
          }
          /**
           * Adds event handlers to the menu element.
           * @function
           * @private
           */
        }, {
          key: "_registerEvents",
          value: function _registerEvents() {
            if (this.options.scrollTop) {
              this._bindHandler = this._scrollTop.bind(this);
              this.$element.on('open.zf.drilldown hide.zf.drilldown closed.zf.drilldown', this._bindHandler);
            }
            this.$element.on('mutateme.zf.trigger', this._resize.bind(this));
          }
          /**
           * Scroll to Top of Element or data-scroll-top-element
           * @function
           * @fires Drilldown#scrollme
           */
        }, {
          key: "_scrollTop",
          value: function _scrollTop() {
            var _this = this;
            var $scrollTopElement = _this.options.scrollTopElement != '' ? jquery__WEBPACK_IMPORTED_MODULE_0___default()(_this.options.scrollTopElement) : _this.$element,
              scrollPos = parseInt($scrollTopElement.offset().top + _this.options.scrollTopOffset, 10);
            jquery__WEBPACK_IMPORTED_MODULE_0___default()('html, body').stop(true).animate({
              scrollTop: scrollPos
            }, _this.options.animationDuration, _this.options.animationEasing, function () {
              /**
                * Fires after the menu has scrolled
                * @event Drilldown#scrollme
                */
              if (this === jquery__WEBPACK_IMPORTED_MODULE_0___default()('html')[0]) _this.$element.trigger('scrollme.zf.drilldown');
            });
          }
          /**
           * Adds keydown event listener to `li`'s in the menu.
           * @private
           */
        }, {
          key: "_keyboardEvents",
          value: function _keyboardEvents() {
            var _this = this;
            this.$menuItems.add(this.$element.find('.js-drilldown-back > a, .is-submenu-parent-item > a')).on('keydown.zf.drilldown', function (e) {
              var $element = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this),
                $elements = $element.parent('li').parent('ul').children('li').children('a'),
                $prevElement,
                $nextElement;
              $elements.each(function (i) {
                if (jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).is($element)) {
                  $prevElement = $elements.eq(Math.max(0, i - 1));
                  $nextElement = $elements.eq(Math.min(i + 1, $elements.length - 1));
                  return;
                }
              });
              _foundation_util_keyboard__WEBPACK_IMPORTED_MODULE_1__["Keyboard"].handleKey(e, 'Drilldown', {
                next: function next() {
                  if ($element.is(_this.$submenuAnchors)) {
                    _this._show($element.parent('li'));
                    $element.parent('li').one(Object(_foundation_core_utils__WEBPACK_IMPORTED_MODULE_3__["transitionend"])($element), function () {
                      $element.parent('li').find('ul li a').not('.js-drilldown-back a').first().focus();
                    });
                    return true;
                  }
                },
                previous: function previous() {
                  _this._hide($element.parent('li').parent('ul'));
                  $element.parent('li').parent('ul').one(Object(_foundation_core_utils__WEBPACK_IMPORTED_MODULE_3__["transitionend"])($element), function () {
                    setTimeout(function () {
                      $element.parent('li').parent('ul').parent('li').children('a').first().focus();
                    }, 1);
                  });
                  return true;
                },
                up: function up() {
                  $prevElement.focus(); // Don't tap focus on first element in root ul

                  return !$element.is(_this.$element.find('> li:first-child > a'));
                },
                down: function down() {
                  $nextElement.focus(); // Don't tap focus on last element in root ul

                  return !$element.is(_this.$element.find('> li:last-child > a'));
                },
                close: function close() {
                  // Don't close on element in root ul
                  if (!$element.is(_this.$element.find('> li > a'))) {
                    _this._hide($element.parent().parent());
                    $element.parent().parent().siblings('a').focus();
                  }
                },
                open: function open() {
                  if (_this.options.parentLink && $element.attr('href')) {
                    // Link with href
                    return false;
                  } else if (!$element.is(_this.$menuItems)) {
                    // not menu item means back button
                    _this._hide($element.parent('li').parent('ul'));
                    $element.parent('li').parent('ul').one(Object(_foundation_core_utils__WEBPACK_IMPORTED_MODULE_3__["transitionend"])($element), function () {
                      setTimeout(function () {
                        $element.parent('li').parent('ul').parent('li').children('a').first().focus();
                      }, 1);
                    });
                    return true;
                  } else if ($element.is(_this.$submenuAnchors)) {
                    // Sub menu item
                    _this._show($element.parent('li'));
                    $element.parent('li').one(Object(_foundation_core_utils__WEBPACK_IMPORTED_MODULE_3__["transitionend"])($element), function () {
                      $element.parent('li').find('ul li a').not('.js-drilldown-back a').first().focus();
                    });
                    return true;
                  }
                },
                handled: function handled(preventDefault) {
                  if (preventDefault) {
                    e.preventDefault();
                  }
                  e.stopImmediatePropagation();
                }
              });
            }); // end keyboardAccess
          }
          /**
           * Closes all open elements, and returns to root menu.
           * @function
           * @fires Drilldown#closed
           */
        }, {
          key: "_hideAll",
          value: function _hideAll() {
            var $elem = this.$element.find('.is-drilldown-submenu.is-active').addClass('is-closing');
            if (this.options.autoHeight) this.$wrapper.css({
              height: $elem.parent().closest('ul').data('calcHeight')
            });
            $elem.one(Object(_foundation_core_utils__WEBPACK_IMPORTED_MODULE_3__["transitionend"])($elem), function (e) {
              $elem.removeClass('is-active is-closing');
            });
            /**
             * Fires when the menu is fully closed.
             * @event Drilldown#closed
             */

            this.$element.trigger('closed.zf.drilldown');
          }
          /**
           * Adds event listener for each `back` button, and closes open menus.
           * @function
           * @fires Drilldown#back
           * @param {jQuery} $elem - the current sub-menu to add `back` event.
           */
        }, {
          key: "_back",
          value: function _back($elem) {
            var _this = this;
            $elem.off('click.zf.drilldown');
            $elem.children('.js-drilldown-back').on('click.zf.drilldown', function (e) {
              e.stopImmediatePropagation(); // console.log('mouseup on back');

              _this._hide($elem); // If there is a parent submenu, call show

              var parentSubMenu = $elem.parent('li').parent('ul').parent('li');
              if (parentSubMenu.length) {
                _this._show(parentSubMenu);
              }
            });
          }
          /**
           * Adds event listener to menu items w/o submenus to close open menus on click.
           * @function
           * @private
           */
        }, {
          key: "_menuLinkEvents",
          value: function _menuLinkEvents() {
            var _this = this;
            this.$menuItems.not('.is-drilldown-submenu-parent').off('click.zf.drilldown').on('click.zf.drilldown', function (e) {
              // e.stopImmediatePropagation();
              setTimeout(function () {
                _this._hideAll();
              }, 0);
            });
          }
          /**
           * Sets the CSS classes for submenu to show it.
           * @function
           * @private
           * @param {jQuery} $elem - the target submenu (`ul` tag)
           * @param {boolean} trigger - trigger drilldown event
           */
        }, {
          key: "_setShowSubMenuClasses",
          value: function _setShowSubMenuClasses($elem, trigger) {
            $elem.addClass('is-active').removeClass('invisible').attr('aria-hidden', false);
            $elem.parent('li').attr('aria-expanded', true);
            if (trigger === true) {
              this.$element.trigger('open.zf.drilldown', [$elem]);
            }
          }
          /**
           * Sets the CSS classes for submenu to hide it.
           * @function
           * @private
           * @param {jQuery} $elem - the target submenu (`ul` tag)
           * @param {boolean} trigger - trigger drilldown event
           */
        }, {
          key: "_setHideSubMenuClasses",
          value: function _setHideSubMenuClasses($elem, trigger) {
            $elem.removeClass('is-active').addClass('invisible').attr('aria-hidden', true);
            $elem.parent('li').attr('aria-expanded', false);
            if (trigger === true) {
              $elem.trigger('hide.zf.drilldown', [$elem]);
            }
          }
          /**
           * Opens a specific drilldown (sub)menu no matter which (sub)menu in it is currently visible.
           * Compared to _show() this lets you jump into any submenu without clicking through every submenu on the way to it.
           * @function
           * @fires Drilldown#open
           * @param {jQuery} $elem - the target (sub)menu (`ul` tag)
           * @param {boolean} autoFocus - if true the first link in the target (sub)menu gets auto focused
           */
        }, {
          key: "_showMenu",
          value: function _showMenu($elem, autoFocus) {
            var _this = this; // Reset drilldown

            var $expandedSubmenus = this.$element.find('li[aria-expanded="true"] > ul[data-submenu]');
            $expandedSubmenus.each(function (index) {
              _this._setHideSubMenuClasses(jquery__WEBPACK_IMPORTED_MODULE_0___default()(this));
            }); // Save the menu as the currently displayed one.

            this.$currentMenu = $elem; // If target menu is root, focus first link & exit

            if ($elem.is('[data-drilldown]')) {
              if (autoFocus === true) $elem.find('li[role="treeitem"] > a').first().focus();
              if (this.options.autoHeight) this.$wrapper.css('height', $elem.data('calcHeight'));
              return;
            } // Find all submenus on way to root incl. the element itself

            var $submenus = $elem.children().first().parentsUntil('[data-drilldown]', '[data-submenu]'); // Open target menu and all submenus on its way to root

            $submenus.each(function (index) {
              // Update height of first child (target menu) if autoHeight option true
              if (index === 0 && _this.options.autoHeight) {
                _this.$wrapper.css('height', jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).data('calcHeight'));
              }
              var isLastChild = index == $submenus.length - 1; // Add transitionsend listener to last child (root due to reverse order) to open target menu's first link
              // Last child makes sure the event gets always triggered even if going through several menus

              if (isLastChild === true) {
                jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).one(Object(_foundation_core_utils__WEBPACK_IMPORTED_MODULE_3__["transitionend"])(jquery__WEBPACK_IMPORTED_MODULE_0___default()(this)), function () {
                  if (autoFocus === true) {
                    $elem.find('li[role="treeitem"] > a').first().focus();
                  }
                });
              }
              _this._setShowSubMenuClasses(jquery__WEBPACK_IMPORTED_MODULE_0___default()(this), isLastChild);
            });
          }
          /**
           * Opens a submenu.
           * @function
           * @fires Drilldown#open
           * @param {jQuery} $elem - the current element with a submenu to open, i.e. the `li` tag.
           */
        }, {
          key: "_show",
          value: function _show($elem) {
            var $submenu = $elem.children('[data-submenu]');
            $elem.attr('aria-expanded', true);
            this.$currentMenu = $submenu;
            $submenu.addClass('is-active').removeClass('invisible').attr('aria-hidden', false);
            if (this.options.autoHeight) {
              this.$wrapper.css({
                height: $submenu.data('calcHeight')
              });
            }
            /**
             * Fires when the submenu has opened.
             * @event Drilldown#open
             */

            this.$element.trigger('open.zf.drilldown', [$elem]);
          }
          /**
           * Hides a submenu
           * @function
           * @fires Drilldown#hide
           * @param {jQuery} $elem - the current sub-menu to hide, i.e. the `ul` tag.
           */
        }, {
          key: "_hide",
          value: function _hide($elem) {
            if (this.options.autoHeight) this.$wrapper.css({
              height: $elem.parent().closest('ul').data('calcHeight')
            });
            var _this = this;
            $elem.parent('li').attr('aria-expanded', false);
            $elem.attr('aria-hidden', true);
            $elem.addClass('is-closing').one(Object(_foundation_core_utils__WEBPACK_IMPORTED_MODULE_3__["transitionend"])($elem), function () {
              $elem.removeClass('is-active is-closing');
              $elem.blur().addClass('invisible');
            });
            /**
             * Fires when the submenu has closed.
             * @event Drilldown#hide
             */

            $elem.trigger('hide.zf.drilldown', [$elem]);
          }
          /**
           * Iterates through the nested menus to calculate the min-height, and max-width for the menu.
           * Prevents content jumping.
           * @function
           * @private
           */
        }, {
          key: "_getMaxDims",
          value: function _getMaxDims() {
            var maxHeight = 0,
              result = {},
              _this = this; // Recalculate menu heights and total max height

            this.$submenus.add(this.$element).each(function () {
              var numOfElems = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).children('li').length;
              var height = _foundation_util_box__WEBPACK_IMPORTED_MODULE_4__["Box"].GetDimensions(this).height;
              maxHeight = height > maxHeight ? height : maxHeight;
              if (_this.options.autoHeight) {
                jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).data('calcHeight', height);
              }
            });
            if (this.options.autoHeight) result['height'] = this.$currentMenu.data('calcHeight');else result['min-height'] = "".concat(maxHeight, "px");
            result['max-width'] = "".concat(this.$element[0].getBoundingClientRect().width, "px");
            return result;
          }
          /**
           * Destroys the Drilldown Menu
           * @function
           */
        }, {
          key: "_destroy",
          value: function _destroy() {
            if (this.options.scrollTop) this.$element.off('.zf.drilldown', this._bindHandler);
            this._hideAll();
            this.$element.off('mutateme.zf.trigger');
            _foundation_util_nest__WEBPACK_IMPORTED_MODULE_2__["Nest"].Burn(this.$element, 'drilldown');
            this.$element.unwrap().find('.js-drilldown-back, .is-submenu-parent-item').remove().end().find('.is-active, .is-closing, .is-drilldown-submenu').removeClass('is-active is-closing is-drilldown-submenu').end().find('[data-submenu]').removeAttr('aria-hidden tabindex role');
            this.$submenuAnchors.each(function () {
              jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).off('.zf.drilldown');
            });
            this.$element.find('[data-is-parent-link]').detach();
            this.$submenus.removeClass('drilldown-submenu-cover-previous invisible');
            this.$element.find('a').each(function () {
              var $link = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this);
              $link.removeAttr('tabindex');
              if ($link.data('savedHref')) {
                $link.attr('href', $link.data('savedHref')).removeData('savedHref');
              } else {
                return;
              }
            });
          }
        }]);
        return Drilldown;
      }(_foundation_core_plugin__WEBPACK_IMPORTED_MODULE_5__["Plugin"]);
      Drilldown.defaults = {
        /**
         * Drilldowns depend on styles in order to function properly; in the default build of Foundation these are
         * on the `drilldown` class. This option auto-applies this class to the drilldown upon initialization.
         * @option
         * @type {boolian}
         * @default true
         */
        autoApplyClass: true,
        /**
         * Markup used for JS generated back button. Prepended  or appended (see backButtonPosition) to submenu lists and deleted on `destroy` method, 'js-drilldown-back' class required. Remove the backslash (`\`) if copy and pasting.
         * @option
         * @type {string}
         * @default '<li class="js-drilldown-back"><a tabindex="0">Back</a></li>'
         */
        backButton: '<li class="js-drilldown-back"><a tabindex="0">Back</a></li>',
        /**
         * Position the back button either at the top or bottom of drilldown submenus. Can be `'left'` or `'bottom'`.
         * @option
         * @type {string}
         * @default top
         */
        backButtonPosition: 'top',
        /**
         * Markup used to wrap drilldown menu. Use a class name for independent styling; the JS applied class: `is-drilldown` is required. Remove the backslash (`\`) if copy and pasting.
         * @option
         * @type {string}
         * @default '<div></div>'
         */
        wrapper: '<div></div>',
        /**
         * Adds the parent link to the submenu.
         * @option
         * @type {boolean}
         * @default false
         */
        parentLink: false,
        /**
         * Allow the menu to return to root list on body click.
         * @option
         * @type {boolean}
         * @default false
         */
        closeOnClick: false,
        /**
         * Allow the menu to auto adjust height.
         * @option
         * @type {boolean}
         * @default false
         */
        autoHeight: false,
        /**
         * Animate the auto adjust height.
         * @option
         * @type {boolean}
         * @default false
         */
        animateHeight: false,
        /**
         * Scroll to the top of the menu after opening a submenu or navigating back using the menu back button
         * @option
         * @type {boolean}
         * @default false
         */
        scrollTop: false,
        /**
         * String jquery selector (for example 'body') of element to take offset().top from, if empty string the drilldown menu offset().top is taken
         * @option
         * @type {string}
         * @default ''
         */
        scrollTopElement: '',
        /**
         * ScrollTop offset
         * @option
         * @type {number}
         * @default 0
         */
        scrollTopOffset: 0,
        /**
         * Scroll animation duration
         * @option
         * @type {number}
         * @default 500
         */
        animationDuration: 500,
        /**
         * Scroll animation easing. Can be `'swing'` or `'linear'`.
         * @option
         * @type {string}
         * @see {@link https://api.jquery.com/animate|JQuery animate}
         * @default 'swing'
         */
        animationEasing: 'swing' // holdOpen: false
      };

      /***/
    }),
    /***/"./js/foundation.dropdown.js": (
    /*!***********************************!*\
      !*** ./js/foundation.dropdown.js ***!
      \***********************************/
    /*! exports provided: Dropdown */
    /***/
    function _js_foundationDropdownJs(module, __webpack_exports__, __webpack_require__) {
      "use strict";

      __webpack_require__.r(__webpack_exports__);
      /* harmony export (binding) */
      __webpack_require__.d(__webpack_exports__, "Dropdown", function () {
        return Dropdown;
      });
      /* harmony import */
      var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! jquery */"jquery");
      /* harmony import */
      var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);
      /* harmony import */
      var _foundation_util_keyboard__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./foundation.util.keyboard */"./js/foundation.util.keyboard.js");
      /* harmony import */
      var _foundation_core_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./foundation.core.utils */"./js/foundation.core.utils.js");
      /* harmony import */
      var _foundation_positionable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./foundation.positionable */"./js/foundation.positionable.js");
      /* harmony import */
      var _foundation_util_triggers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./foundation.util.triggers */"./js/foundation.util.triggers.js");
      /* harmony import */
      var _foundation_util_touch__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./foundation.util.touch */"./js/foundation.util.touch.js");
      function _typeof(obj) {
        if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
          _typeof = function _typeof(obj) {
            return _typeof2(obj);
          };
        } else {
          _typeof = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
          };
        }
        return _typeof(obj);
      }
      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }
      function _defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }
      function _createClass(Constructor, protoProps, staticProps) {
        if (protoProps) _defineProperties(Constructor.prototype, protoProps);
        if (staticProps) _defineProperties(Constructor, staticProps);
        return Constructor;
      }
      function _possibleConstructorReturn(self, call) {
        if (call && (_typeof(call) === "object" || typeof call === "function")) {
          return call;
        }
        return _assertThisInitialized(self);
      }
      function _assertThisInitialized(self) {
        if (self === void 0) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }
        return self;
      }
      function _get(target, property, receiver) {
        if (typeof Reflect !== "undefined" && Reflect.get) {
          _get = Reflect.get;
        } else {
          _get = function _get(target, property, receiver) {
            var base = _superPropBase(target, property);
            if (!base) return;
            var desc = Object.getOwnPropertyDescriptor(base, property);
            if (desc.get) {
              return desc.get.call(receiver);
            }
            return desc.value;
          };
        }
        return _get(target, property, receiver || target);
      }
      function _superPropBase(object, property) {
        while (!Object.prototype.hasOwnProperty.call(object, property)) {
          object = _getPrototypeOf(object);
          if (object === null) break;
        }
        return object;
      }
      function _getPrototypeOf(o) {
        _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
          return o.__proto__ || Object.getPrototypeOf(o);
        };
        return _getPrototypeOf(o);
      }
      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function");
        }
        subClass.prototype = Object.create(superClass && superClass.prototype, {
          constructor: {
            value: subClass,
            writable: true,
            configurable: true
          }
        });
        if (superClass) _setPrototypeOf(subClass, superClass);
      }
      function _setPrototypeOf(o, p) {
        _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
          o.__proto__ = p;
          return o;
        };
        return _setPrototypeOf(o, p);
      }

      /**
       * Dropdown module.
       * @module foundation.dropdown
       * @requires foundation.util.keyboard
       * @requires foundation.util.box
       * @requires foundation.util.triggers
       */

      var Dropdown = /*#__PURE__*/
      function (_Positionable) {
        _inherits(Dropdown, _Positionable);
        function Dropdown() {
          _classCallCheck(this, Dropdown);
          return _possibleConstructorReturn(this, _getPrototypeOf(Dropdown).apply(this, arguments));
        }
        _createClass(Dropdown, [{
          key: "_setup",
          /**
           * Creates a new instance of a dropdown.
           * @class
           * @name Dropdown
           * @param {jQuery} element - jQuery object to make into a dropdown.
           *        Object should be of the dropdown panel, rather than its anchor.
           * @param {Object} options - Overrides to the default plugin settings.
           */
          value: function _setup(element, options) {
            this.$element = element;
            this.options = jquery__WEBPACK_IMPORTED_MODULE_0___default.a.extend({}, Dropdown.defaults, this.$element.data(), options);
            this.className = 'Dropdown'; // ie9 back compat
            // Triggers init is idempotent, just need to make sure it is initialized

            _foundation_util_triggers__WEBPACK_IMPORTED_MODULE_4__["Triggers"].init(jquery__WEBPACK_IMPORTED_MODULE_0___default.a);
            this._init();
            _foundation_util_keyboard__WEBPACK_IMPORTED_MODULE_1__["Keyboard"].register('Dropdown', {
              'ENTER': 'toggle',
              'SPACE': 'toggle',
              'ESCAPE': 'close'
            });
          }
          /**
           * Initializes the plugin by setting/checking options and attributes, adding helper variables, and saving the anchor.
           * @function
           * @private
           */
        }, {
          key: "_init",
          value: function _init() {
            var $id = this.$element.attr('id');
            this.$anchors = jquery__WEBPACK_IMPORTED_MODULE_0___default()("[data-toggle=\"".concat($id, "\"]")).length ? jquery__WEBPACK_IMPORTED_MODULE_0___default()("[data-toggle=\"".concat($id, "\"]")) : jquery__WEBPACK_IMPORTED_MODULE_0___default()("[data-open=\"".concat($id, "\"]"));
            this.$anchors.attr({
              'aria-controls': $id,
              'data-is-focus': false,
              'data-yeti-box': $id,
              'aria-haspopup': true,
              'aria-expanded': false
            });
            this._setCurrentAnchor(this.$anchors.first());
            if (this.options.parentClass) {
              this.$parent = this.$element.parents('.' + this.options.parentClass);
            } else {
              this.$parent = null;
            } // Set [aria-labelledby] on the Dropdown if it is not set

            if (typeof this.$element.attr('aria-labelledby') === 'undefined') {
              // Get the anchor ID or create one
              if (typeof this.$currentAnchor.attr('id') === 'undefined') {
                this.$currentAnchor.attr('id', Object(_foundation_core_utils__WEBPACK_IMPORTED_MODULE_2__["GetYoDigits"])(6, 'dd-anchor'));
              }
              ;
              this.$element.attr('aria-labelledby', this.$currentAnchor.attr('id'));
            }
            this.$element.attr({
              'aria-hidden': 'true',
              'data-yeti-box': $id,
              'data-resize': $id
            });
            _get(_getPrototypeOf(Dropdown.prototype), "_init", this).call(this);
            this._events();
          }
        }, {
          key: "_getDefaultPosition",
          value: function _getDefaultPosition() {
            // handle legacy classnames
            var position = this.$element[0].className.match(/(top|left|right|bottom)/g);
            if (position) {
              return position[0];
            } else {
              return 'bottom';
            }
          }
        }, {
          key: "_getDefaultAlignment",
          value: function _getDefaultAlignment() {
            // handle legacy float approach
            var horizontalPosition = /float-(\S+)/.exec(this.$currentAnchor.attr('class'));
            if (horizontalPosition) {
              return horizontalPosition[1];
            }
            return _get(_getPrototypeOf(Dropdown.prototype), "_getDefaultAlignment", this).call(this);
          }
          /**
           * Sets the position and orientation of the dropdown pane, checks for collisions if allow-overlap is not true.
           * Recursively calls itself if a collision is detected, with a new position class.
           * @function
           * @private
           */
        }, {
          key: "_setPosition",
          value: function _setPosition() {
            this.$element.removeClass("has-position-".concat(this.position, " has-alignment-").concat(this.alignment));
            _get(_getPrototypeOf(Dropdown.prototype), "_setPosition", this).call(this, this.$currentAnchor, this.$element, this.$parent);
            this.$element.addClass("has-position-".concat(this.position, " has-alignment-").concat(this.alignment));
          }
          /**
           * Make it a current anchor.
           * Current anchor as the reference for the position of Dropdown panes.
           * @param {HTML} el - DOM element of the anchor.
           * @function
           * @private
           */
        }, {
          key: "_setCurrentAnchor",
          value: function _setCurrentAnchor(el) {
            this.$currentAnchor = jquery__WEBPACK_IMPORTED_MODULE_0___default()(el);
          }
          /**
           * Adds event listeners to the element utilizing the triggers utility library.
           * @function
           * @private
           */
        }, {
          key: "_events",
          value: function _events() {
            var _this = this;
            this.$element.on({
              'open.zf.trigger': this.open.bind(this),
              'close.zf.trigger': this.close.bind(this),
              'toggle.zf.trigger': this.toggle.bind(this),
              'resizeme.zf.trigger': this._setPosition.bind(this)
            });
            this.$anchors.off('click.zf.trigger').on('click.zf.trigger', function () {
              _this._setCurrentAnchor(this);
            });
            if (this.options.hover) {
              this.$anchors.off('mouseenter.zf.dropdown mouseleave.zf.dropdown').on('mouseenter.zf.dropdown', function () {
                _this._setCurrentAnchor(this);
                var bodyData = jquery__WEBPACK_IMPORTED_MODULE_0___default()('body').data();
                if (typeof bodyData.whatinput === 'undefined' || bodyData.whatinput === 'mouse') {
                  clearTimeout(_this.timeout);
                  _this.timeout = setTimeout(function () {
                    _this.open();
                    _this.$anchors.data('hover', true);
                  }, _this.options.hoverDelay);
                }
              }).on('mouseleave.zf.dropdown', Object(_foundation_core_utils__WEBPACK_IMPORTED_MODULE_2__["ignoreMousedisappear"])(function () {
                clearTimeout(_this.timeout);
                _this.timeout = setTimeout(function () {
                  _this.close();
                  _this.$anchors.data('hover', false);
                }, _this.options.hoverDelay);
              }));
              if (this.options.hoverPane) {
                this.$element.off('mouseenter.zf.dropdown mouseleave.zf.dropdown').on('mouseenter.zf.dropdown', function () {
                  clearTimeout(_this.timeout);
                }).on('mouseleave.zf.dropdown', Object(_foundation_core_utils__WEBPACK_IMPORTED_MODULE_2__["ignoreMousedisappear"])(function () {
                  clearTimeout(_this.timeout);
                  _this.timeout = setTimeout(function () {
                    _this.close();
                    _this.$anchors.data('hover', false);
                  }, _this.options.hoverDelay);
                }));
              }
            }
            this.$anchors.add(this.$element).on('keydown.zf.dropdown', function (e) {
              var $target = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this),
                visibleFocusableElements = _foundation_util_keyboard__WEBPACK_IMPORTED_MODULE_1__["Keyboard"].findFocusable(_this.$element);
              _foundation_util_keyboard__WEBPACK_IMPORTED_MODULE_1__["Keyboard"].handleKey(e, 'Dropdown', {
                open: function open() {
                  if ($target.is(_this.$anchors) && !$target.is('input, textarea')) {
                    _this.open();
                    _this.$element.attr('tabindex', -1).focus();
                    e.preventDefault();
                  }
                },
                close: function close() {
                  _this.close();
                  _this.$anchors.focus();
                }
              });
            });
          }
          /**
           * Adds an event handler to the body to close any dropdowns on a click.
           * @function
           * @private
           */
        }, {
          key: "_addBodyHandler",
          value: function _addBodyHandler() {
            var $body = jquery__WEBPACK_IMPORTED_MODULE_0___default()(document.body).not(this.$element),
              _this = this;
            $body.off('click.zf.dropdown').on('click.zf.dropdown', function (e) {
              if (_this.$anchors.is(e.target) || _this.$anchors.find(e.target).length) {
                return;
              }
              if (_this.$element.is(e.target) || _this.$element.find(e.target).length) {
                return;
              }
              _this.close();
              $body.off('click.zf.dropdown');
            });
          }
          /**
           * Opens the dropdown pane, and fires a bubbling event to close other dropdowns.
           * @function
           * @fires Dropdown#closeme
           * @fires Dropdown#show
           */
        }, {
          key: "open",
          value: function open() {
            // var _this = this;

            /**
             * Fires to close other open dropdowns, typically when dropdown is opening
             * @event Dropdown#closeme
             */
            this.$element.trigger('closeme.zf.dropdown', this.$element.attr('id'));
            this.$anchors.addClass('hover').attr({
              'aria-expanded': true
            }); // this.$element/*.show()*/;

            this.$element.addClass('is-opening');
            this._setPosition();
            this.$element.removeClass('is-opening').addClass('is-open').attr({
              'aria-hidden': false
            });
            if (this.options.autoFocus) {
              var $focusable = _foundation_util_keyboard__WEBPACK_IMPORTED_MODULE_1__["Keyboard"].findFocusable(this.$element);
              if ($focusable.length) {
                $focusable.eq(0).focus();
              }
            }
            if (this.options.closeOnClick) {
              this._addBodyHandler();
            }
            if (this.options.trapFocus) {
              _foundation_util_keyboard__WEBPACK_IMPORTED_MODULE_1__["Keyboard"].trapFocus(this.$element);
            }
            /**
             * Fires once the dropdown is visible.
             * @event Dropdown#show
             */

            this.$element.trigger('show.zf.dropdown', [this.$element]);
          }
          /**
           * Closes the open dropdown pane.
           * @function
           * @fires Dropdown#hide
           */
        }, {
          key: "close",
          value: function close() {
            if (!this.$element.hasClass('is-open')) {
              return false;
            }
            this.$element.removeClass('is-open').attr({
              'aria-hidden': true
            });
            this.$anchors.removeClass('hover').attr('aria-expanded', false);
            /**
             * Fires once the dropdown is no longer visible.
             * @event Dropdown#hide
             */

            this.$element.trigger('hide.zf.dropdown', [this.$element]);
            if (this.options.trapFocus) {
              _foundation_util_keyboard__WEBPACK_IMPORTED_MODULE_1__["Keyboard"].releaseFocus(this.$element);
            }
          }
          /**
           * Toggles the dropdown pane's visibility.
           * @function
           */
        }, {
          key: "toggle",
          value: function toggle() {
            if (this.$element.hasClass('is-open')) {
              if (this.$anchors.data('hover')) return;
              this.close();
            } else {
              this.open();
            }
          }
          /**
           * Destroys the dropdown.
           * @function
           */
        }, {
          key: "_destroy",
          value: function _destroy() {
            this.$element.off('.zf.trigger').hide();
            this.$anchors.off('.zf.dropdown');
            jquery__WEBPACK_IMPORTED_MODULE_0___default()(document.body).off('click.zf.dropdown');
          }
        }]);
        return Dropdown;
      }(_foundation_positionable__WEBPACK_IMPORTED_MODULE_3__["Positionable"]);
      Dropdown.defaults = {
        /**
         * Class that designates bounding container of Dropdown (default: window)
         * @option
         * @type {?string}
         * @default null
         */
        parentClass: null,
        /**
         * Amount of time to delay opening a submenu on hover event.
         * @option
         * @type {number}
         * @default 250
         */
        hoverDelay: 250,
        /**
         * Allow submenus to open on hover events
         * @option
         * @type {boolean}
         * @default false
         */
        hover: false,
        /**
         * Don't close dropdown when hovering over dropdown pane
         * @option
         * @type {boolean}
         * @default false
         */
        hoverPane: false,
        /**
         * Number of pixels between the dropdown pane and the triggering element on open.
         * @option
         * @type {number}
         * @default 0
         */
        vOffset: 0,
        /**
         * Number of pixels between the dropdown pane and the triggering element on open.
         * @option
         * @type {number}
         * @default 0
         */
        hOffset: 0,
        /**
         * Position of dropdown. Can be left, right, bottom, top, or auto.
         * @option
         * @type {string}
         * @default 'auto'
         */
        position: 'auto',
        /**
         * Alignment of dropdown relative to anchor. Can be left, right, bottom, top, center, or auto.
         * @option
         * @type {string}
         * @default 'auto'
         */
        alignment: 'auto',
        /**
         * Allow overlap of container/window. If false, dropdown will first try to position as defined by data-position and data-alignment, but reposition if it would cause an overflow.
         * @option
         * @type {boolean}
         * @default false
         */
        allowOverlap: false,
        /**
         * Allow overlap of only the bottom of the container. This is the most common
         * behavior for dropdowns, allowing the dropdown to extend the bottom of the
         * screen but not otherwise influence or break out of the container.
         * @option
         * @type {boolean}
         * @default true
         */
        allowBottomOverlap: true,
        /**
         * Allow the plugin to trap focus to the dropdown pane if opened with keyboard commands.
         * @option
         * @type {boolean}
         * @default false
         */
        trapFocus: false,
        /**
         * Allow the plugin to set focus to the first focusable element within the pane, regardless of method of opening.
         * @option
         * @type {boolean}
         * @default false
         */
        autoFocus: false,
        /**
         * Allows a click on the body to close the dropdown.
         * @option
         * @type {boolean}
         * @default false
         */
        closeOnClick: false
      };

      /***/
    }),
    /***/"./js/foundation.dropdownMenu.js": (
    /*!***************************************!*\
      !*** ./js/foundation.dropdownMenu.js ***!
      \***************************************/
    /*! exports provided: DropdownMenu */
    /***/
    function _js_foundationDropdownMenuJs(module, __webpack_exports__, __webpack_require__) {
      "use strict";

      __webpack_require__.r(__webpack_exports__);
      /* harmony export (binding) */
      __webpack_require__.d(__webpack_exports__, "DropdownMenu", function () {
        return DropdownMenu;
      });
      /* harmony import */
      var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! jquery */"jquery");
      /* harmony import */
      var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);
      /* harmony import */
      var _foundation_core_plugin__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./foundation.core.plugin */"./js/foundation.core.plugin.js");
      /* harmony import */
      var _foundation_core_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./foundation.core.utils */"./js/foundation.core.utils.js");
      /* harmony import */
      var _foundation_util_keyboard__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./foundation.util.keyboard */"./js/foundation.util.keyboard.js");
      /* harmony import */
      var _foundation_util_nest__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./foundation.util.nest */"./js/foundation.util.nest.js");
      /* harmony import */
      var _foundation_util_box__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./foundation.util.box */"./js/foundation.util.box.js");
      function _typeof(obj) {
        if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
          _typeof = function _typeof(obj) {
            return _typeof2(obj);
          };
        } else {
          _typeof = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
          };
        }
        return _typeof(obj);
      }
      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }
      function _defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }
      function _createClass(Constructor, protoProps, staticProps) {
        if (protoProps) _defineProperties(Constructor.prototype, protoProps);
        if (staticProps) _defineProperties(Constructor, staticProps);
        return Constructor;
      }
      function _possibleConstructorReturn(self, call) {
        if (call && (_typeof(call) === "object" || typeof call === "function")) {
          return call;
        }
        return _assertThisInitialized(self);
      }
      function _assertThisInitialized(self) {
        if (self === void 0) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }
        return self;
      }
      function _getPrototypeOf(o) {
        _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
          return o.__proto__ || Object.getPrototypeOf(o);
        };
        return _getPrototypeOf(o);
      }
      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function");
        }
        subClass.prototype = Object.create(superClass && superClass.prototype, {
          constructor: {
            value: subClass,
            writable: true,
            configurable: true
          }
        });
        if (superClass) _setPrototypeOf(subClass, superClass);
      }
      function _setPrototypeOf(o, p) {
        _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
          o.__proto__ = p;
          return o;
        };
        return _setPrototypeOf(o, p);
      }

      /**
       * DropdownMenu module.
       * @module foundation.dropdown-menu
       * @requires foundation.util.keyboard
       * @requires foundation.util.box
       * @requires foundation.util.nest
       */

      var DropdownMenu = /*#__PURE__*/
      function (_Plugin) {
        _inherits(DropdownMenu, _Plugin);
        function DropdownMenu() {
          _classCallCheck(this, DropdownMenu);
          return _possibleConstructorReturn(this, _getPrototypeOf(DropdownMenu).apply(this, arguments));
        }
        _createClass(DropdownMenu, [{
          key: "_setup",
          /**
           * Creates a new instance of DropdownMenu.
           * @class
           * @name DropdownMenu
           * @fires DropdownMenu#init
           * @param {jQuery} element - jQuery object to make into a dropdown menu.
           * @param {Object} options - Overrides to the default plugin settings.
           */
          value: function _setup(element, options) {
            this.$element = element;
            this.options = jquery__WEBPACK_IMPORTED_MODULE_0___default.a.extend({}, DropdownMenu.defaults, this.$element.data(), options);
            this.className = 'DropdownMenu'; // ie9 back compat

            this._init();
            _foundation_util_keyboard__WEBPACK_IMPORTED_MODULE_3__["Keyboard"].register('DropdownMenu', {
              'ENTER': 'open',
              'SPACE': 'open',
              'ARROW_RIGHT': 'next',
              'ARROW_UP': 'up',
              'ARROW_DOWN': 'down',
              'ARROW_LEFT': 'previous',
              'ESCAPE': 'close'
            });
          }
          /**
           * Initializes the plugin, and calls _prepareMenu
           * @private
           * @function
           */
        }, {
          key: "_init",
          value: function _init() {
            _foundation_util_nest__WEBPACK_IMPORTED_MODULE_4__["Nest"].Feather(this.$element, 'dropdown');
            var subs = this.$element.find('li.is-dropdown-submenu-parent');
            this.$element.children('.is-dropdown-submenu-parent').children('.is-dropdown-submenu').addClass('first-sub');
            this.$menuItems = this.$element.find('[role="menuitem"]');
            this.$tabs = this.$element.children('[role="menuitem"]');
            this.$tabs.find('ul.is-dropdown-submenu').addClass(this.options.verticalClass);
            if (this.options.alignment === 'auto') {
              if (this.$element.hasClass(this.options.rightClass) || Object(_foundation_core_utils__WEBPACK_IMPORTED_MODULE_2__["rtl"])() || this.$element.parents('.top-bar-right').is('*')) {
                this.options.alignment = 'right';
                subs.addClass('opens-left');
              } else {
                this.options.alignment = 'left';
                subs.addClass('opens-right');
              }
            } else {
              if (this.options.alignment === 'right') {
                subs.addClass('opens-left');
              } else {
                subs.addClass('opens-right');
              }
            }
            this.changed = false;
            this._events();
          }
        }, {
          key: "_isVertical",
          value: function _isVertical() {
            return this.$tabs.css('display') === 'block' || this.$element.css('flex-direction') === 'column';
          }
        }, {
          key: "_isRtl",
          value: function _isRtl() {
            return this.$element.hasClass('align-right') || Object(_foundation_core_utils__WEBPACK_IMPORTED_MODULE_2__["rtl"])() && !this.$element.hasClass('align-left');
          }
          /**
           * Adds event listeners to elements within the menu
           * @private
           * @function
           */
        }, {
          key: "_events",
          value: function _events() {
            var _this = this,
              hasTouch = 'ontouchstart' in window || typeof window.ontouchstart !== 'undefined',
              parClass = 'is-dropdown-submenu-parent'; // used for onClick and in the keyboard handlers

            var handleClickFn = function handleClickFn(e) {
              var $elem = jquery__WEBPACK_IMPORTED_MODULE_0___default()(e.target).parentsUntil('ul', ".".concat(parClass)),
                hasSub = $elem.hasClass(parClass),
                hasClicked = $elem.attr('data-is-click') === 'true',
                $sub = $elem.children('.is-dropdown-submenu');
              if (hasSub) {
                if (hasClicked) {
                  if (!_this.options.closeOnClick || !_this.options.clickOpen && !hasTouch || _this.options.forceFollow && hasTouch) {
                    return;
                  } else {
                    e.stopImmediatePropagation();
                    e.preventDefault();
                    _this._hide($elem);
                  }
                } else {
                  e.preventDefault();
                  e.stopImmediatePropagation();
                  _this._show($sub);
                  $elem.add($elem.parentsUntil(_this.$element, ".".concat(parClass))).attr('data-is-click', true);
                }
              }
            };
            if (this.options.clickOpen || hasTouch) {
              this.$menuItems.on('click.zf.dropdownmenu touchstart.zf.dropdownmenu', handleClickFn);
            } // Handle Leaf element Clicks

            if (_this.options.closeOnClickInside) {
              this.$menuItems.on('click.zf.dropdownmenu', function (e) {
                var $elem = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this),
                  hasSub = $elem.hasClass(parClass);
                if (!hasSub) {
                  _this._hide();
                }
              });
            }
            if (!this.options.disableHover) {
              this.$menuItems.on('mouseenter.zf.dropdownmenu', function (e) {
                var $elem = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this),
                  hasSub = $elem.hasClass(parClass);
                if (hasSub) {
                  clearTimeout($elem.data('_delay'));
                  $elem.data('_delay', setTimeout(function () {
                    _this._show($elem.children('.is-dropdown-submenu'));
                  }, _this.options.hoverDelay));
                }
              }).on('mouseleave.zf.dropdownMenu', Object(_foundation_core_utils__WEBPACK_IMPORTED_MODULE_2__["ignoreMousedisappear"])(function (e) {
                var $elem = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this),
                  hasSub = $elem.hasClass(parClass);
                if (hasSub && _this.options.autoclose) {
                  if ($elem.attr('data-is-click') === 'true' && _this.options.clickOpen) {
                    return false;
                  }
                  clearTimeout($elem.data('_delay'));
                  $elem.data('_delay', setTimeout(function () {
                    _this._hide($elem);
                  }, _this.options.closingTime));
                }
              }));
            }
            this.$menuItems.on('keydown.zf.dropdownmenu', function (e) {
              var $element = jquery__WEBPACK_IMPORTED_MODULE_0___default()(e.target).parentsUntil('ul', '[role="menuitem"]'),
                isTab = _this.$tabs.index($element) > -1,
                $elements = isTab ? _this.$tabs : $element.siblings('li').add($element),
                $prevElement,
                $nextElement;
              $elements.each(function (i) {
                if (jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).is($element)) {
                  $prevElement = $elements.eq(i - 1);
                  $nextElement = $elements.eq(i + 1);
                  return;
                }
              });
              var nextSibling = function nextSibling() {
                  $nextElement.children('a:first').focus();
                  e.preventDefault();
                },
                prevSibling = function prevSibling() {
                  $prevElement.children('a:first').focus();
                  e.preventDefault();
                },
                openSub = function openSub() {
                  var $sub = $element.children('ul.is-dropdown-submenu');
                  if ($sub.length) {
                    _this._show($sub);
                    $element.find('li > a:first').focus();
                    e.preventDefault();
                  } else {
                    return;
                  }
                },
                closeSub = function closeSub() {
                  //if ($element.is(':first-child')) {
                  var close = $element.parent('ul').parent('li');
                  close.children('a:first').focus();
                  _this._hide(close);
                  e.preventDefault(); //}
                };
              var functions = {
                open: openSub,
                close: function close() {
                  _this._hide(_this.$element);
                  _this.$menuItems.eq(0).children('a').focus(); // focus to first element

                  e.preventDefault();
                },
                handled: function handled() {
                  e.stopImmediatePropagation();
                }
              };
              if (isTab) {
                if (_this._isVertical()) {
                  // vertical menu
                  if (_this._isRtl()) {
                    // right aligned
                    jquery__WEBPACK_IMPORTED_MODULE_0___default.a.extend(functions, {
                      down: nextSibling,
                      up: prevSibling,
                      next: closeSub,
                      previous: openSub
                    });
                  } else {
                    // left aligned
                    jquery__WEBPACK_IMPORTED_MODULE_0___default.a.extend(functions, {
                      down: nextSibling,
                      up: prevSibling,
                      next: openSub,
                      previous: closeSub
                    });
                  }
                } else {
                  // horizontal menu
                  if (_this._isRtl()) {
                    // right aligned
                    jquery__WEBPACK_IMPORTED_MODULE_0___default.a.extend(functions, {
                      next: prevSibling,
                      previous: nextSibling,
                      down: openSub,
                      up: closeSub
                    });
                  } else {
                    // left aligned
                    jquery__WEBPACK_IMPORTED_MODULE_0___default.a.extend(functions, {
                      next: nextSibling,
                      previous: prevSibling,
                      down: openSub,
                      up: closeSub
                    });
                  }
                }
              } else {
                // not tabs -> one sub
                if (_this._isRtl()) {
                  // right aligned
                  jquery__WEBPACK_IMPORTED_MODULE_0___default.a.extend(functions, {
                    next: closeSub,
                    previous: openSub,
                    down: nextSibling,
                    up: prevSibling
                  });
                } else {
                  // left aligned
                  jquery__WEBPACK_IMPORTED_MODULE_0___default.a.extend(functions, {
                    next: openSub,
                    previous: closeSub,
                    down: nextSibling,
                    up: prevSibling
                  });
                }
              }
              _foundation_util_keyboard__WEBPACK_IMPORTED_MODULE_3__["Keyboard"].handleKey(e, 'DropdownMenu', functions);
            });
          }
          /**
           * Adds an event handler to the body to close any dropdowns on a click.
           * @function
           * @private
           */
        }, {
          key: "_addBodyHandler",
          value: function _addBodyHandler() {
            var $body = jquery__WEBPACK_IMPORTED_MODULE_0___default()(document.body),
              _this = this;
            $body.off('mouseup.zf.dropdownmenu touchend.zf.dropdownmenu').on('mouseup.zf.dropdownmenu touchend.zf.dropdownmenu', function (e) {
              var $link = _this.$element.find(e.target);
              if ($link.length) {
                return;
              }
              _this._hide();
              $body.off('mouseup.zf.dropdownmenu touchend.zf.dropdownmenu');
            });
          }
          /**
           * Opens a dropdown pane, and checks for collisions first.
           * @param {jQuery} $sub - ul element that is a submenu to show
           * @function
           * @private
           * @fires Dropdownmenu#show
           */
        }, {
          key: "_show",
          value: function _show($sub) {
            var idx = this.$tabs.index(this.$tabs.filter(function (i, el) {
              return jquery__WEBPACK_IMPORTED_MODULE_0___default()(el).find($sub).length > 0;
            }));
            var $sibs = $sub.parent('li.is-dropdown-submenu-parent').siblings('li.is-dropdown-submenu-parent');
            this._hide($sibs, idx);
            $sub.css('visibility', 'hidden').addClass('js-dropdown-active').parent('li.is-dropdown-submenu-parent').addClass('is-active');
            var clear = _foundation_util_box__WEBPACK_IMPORTED_MODULE_5__["Box"].ImNotTouchingYou($sub, null, true);
            if (!clear) {
              var oldClass = this.options.alignment === 'left' ? '-right' : '-left',
                $parentLi = $sub.parent('.is-dropdown-submenu-parent');
              $parentLi.removeClass("opens".concat(oldClass)).addClass("opens-".concat(this.options.alignment));
              clear = _foundation_util_box__WEBPACK_IMPORTED_MODULE_5__["Box"].ImNotTouchingYou($sub, null, true);
              if (!clear) {
                $parentLi.removeClass("opens-".concat(this.options.alignment)).addClass('opens-inner');
              }
              this.changed = true;
            }
            $sub.css('visibility', '');
            if (this.options.closeOnClick) {
              this._addBodyHandler();
            }
            /**
             * Fires when the new dropdown pane is visible.
             * @event Dropdownmenu#show
             */

            this.$element.trigger('show.zf.dropdownmenu', [$sub]);
          }
          /**
           * Hides a single, currently open dropdown pane, if passed a parameter, otherwise, hides everything.
           * @function
           * @param {jQuery} $elem - element with a submenu to hide
           * @param {Number} idx - index of the $tabs collection to hide
           * @private
           */
        }, {
          key: "_hide",
          value: function _hide($elem, idx) {
            var $toClose;
            if ($elem && $elem.length) {
              $toClose = $elem;
            } else if (typeof idx !== 'undefined') {
              $toClose = this.$tabs.not(function (i, el) {
                return i === idx;
              });
            } else {
              $toClose = this.$element;
            }
            var somethingToClose = $toClose.hasClass('is-active') || $toClose.find('.is-active').length > 0;
            if (somethingToClose) {
              $toClose.find('li.is-active').add($toClose).attr({
                'data-is-click': false
              }).removeClass('is-active');
              $toClose.find('ul.js-dropdown-active').removeClass('js-dropdown-active');
              if (this.changed || $toClose.find('opens-inner').length) {
                var oldClass = this.options.alignment === 'left' ? 'right' : 'left';
                $toClose.find('li.is-dropdown-submenu-parent').add($toClose).removeClass("opens-inner opens-".concat(this.options.alignment)).addClass("opens-".concat(oldClass));
                this.changed = false;
              }
              /**
               * Fires when the open menus are closed.
               * @event Dropdownmenu#hide
               */

              this.$element.trigger('hide.zf.dropdownmenu', [$toClose]);
            }
          }
          /**
           * Destroys the plugin.
           * @function
           */
        }, {
          key: "_destroy",
          value: function _destroy() {
            this.$menuItems.off('.zf.dropdownmenu').removeAttr('data-is-click').removeClass('is-right-arrow is-left-arrow is-down-arrow opens-right opens-left opens-inner');
            jquery__WEBPACK_IMPORTED_MODULE_0___default()(document.body).off('.zf.dropdownmenu');
            _foundation_util_nest__WEBPACK_IMPORTED_MODULE_4__["Nest"].Burn(this.$element, 'dropdown');
          }
        }]);
        return DropdownMenu;
      }(_foundation_core_plugin__WEBPACK_IMPORTED_MODULE_1__["Plugin"]);
      /**
       * Default settings for plugin
       */

      DropdownMenu.defaults = {
        /**
         * Disallows hover events from opening submenus
         * @option
         * @type {boolean}
         * @default false
         */
        disableHover: false,
        /**
         * Allow a submenu to automatically close on a mouseleave event, if not clicked open.
         * @option
         * @type {boolean}
         * @default true
         */
        autoclose: true,
        /**
         * Amount of time to delay opening a submenu on hover event.
         * @option
         * @type {number}
         * @default 50
         */
        hoverDelay: 50,
        /**
         * Allow a submenu to open/remain open on parent click event. Allows cursor to move away from menu.
         * @option
         * @type {boolean}
         * @default false
         */
        clickOpen: false,
        /**
         * Amount of time to delay closing a submenu on a mouseleave event.
         * @option
         * @type {number}
         * @default 500
         */
        closingTime: 500,
        /**
         * Position of the menu relative to what direction the submenus should open. Handled by JS. Can be `'auto'`, `'left'` or `'right'`.
         * @option
         * @type {string}
         * @default 'auto'
         */
        alignment: 'auto',
        /**
         * Allow clicks on the body to close any open submenus.
         * @option
         * @type {boolean}
         * @default true
         */
        closeOnClick: true,
        /**
         * Allow clicks on leaf anchor links to close any open submenus.
         * @option
         * @type {boolean}
         * @default true
         */
        closeOnClickInside: true,
        /**
         * Class applied to vertical oriented menus, Foundation default is `vertical`. Update this if using your own class.
         * @option
         * @type {string}
         * @default 'vertical'
         */
        verticalClass: 'vertical',
        /**
         * Class applied to right-side oriented menus, Foundation default is `align-right`. Update this if using your own class.
         * @option
         * @type {string}
         * @default 'align-right'
         */
        rightClass: 'align-right',
        /**
         * Boolean to force overide the clicking of links to perform default action, on second touch event for mobile.
         * @option
         * @type {boolean}
         * @default true
         */
        forceFollow: true
      };

      /***/
    }),
    /***/"./js/foundation.equalizer.js": (
    /*!************************************!*\
      !*** ./js/foundation.equalizer.js ***!
      \************************************/
    /*! exports provided: Equalizer */
    /***/
    function _js_foundationEqualizerJs(module, __webpack_exports__, __webpack_require__) {
      "use strict";

      __webpack_require__.r(__webpack_exports__);
      /* harmony export (binding) */
      __webpack_require__.d(__webpack_exports__, "Equalizer", function () {
        return Equalizer;
      });
      /* harmony import */
      var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! jquery */"jquery");
      /* harmony import */
      var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);
      /* harmony import */
      var _foundation_util_mediaQuery__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./foundation.util.mediaQuery */"./js/foundation.util.mediaQuery.js");
      /* harmony import */
      var _foundation_util_imageLoader__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./foundation.util.imageLoader */"./js/foundation.util.imageLoader.js");
      /* harmony import */
      var _foundation_core_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./foundation.core.utils */"./js/foundation.core.utils.js");
      /* harmony import */
      var _foundation_core_plugin__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./foundation.core.plugin */"./js/foundation.core.plugin.js");
      function _typeof(obj) {
        if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
          _typeof = function _typeof(obj) {
            return _typeof2(obj);
          };
        } else {
          _typeof = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
          };
        }
        return _typeof(obj);
      }
      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }
      function _defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }
      function _createClass(Constructor, protoProps, staticProps) {
        if (protoProps) _defineProperties(Constructor.prototype, protoProps);
        if (staticProps) _defineProperties(Constructor, staticProps);
        return Constructor;
      }
      function _possibleConstructorReturn(self, call) {
        if (call && (_typeof(call) === "object" || typeof call === "function")) {
          return call;
        }
        return _assertThisInitialized(self);
      }
      function _assertThisInitialized(self) {
        if (self === void 0) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }
        return self;
      }
      function _getPrototypeOf(o) {
        _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
          return o.__proto__ || Object.getPrototypeOf(o);
        };
        return _getPrototypeOf(o);
      }
      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function");
        }
        subClass.prototype = Object.create(superClass && superClass.prototype, {
          constructor: {
            value: subClass,
            writable: true,
            configurable: true
          }
        });
        if (superClass) _setPrototypeOf(subClass, superClass);
      }
      function _setPrototypeOf(o, p) {
        _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
          o.__proto__ = p;
          return o;
        };
        return _setPrototypeOf(o, p);
      }

      /**
       * Equalizer module.
       * @module foundation.equalizer
       * @requires foundation.util.mediaQuery
       * @requires foundation.util.imageLoader if equalizer contains images
       */

      var Equalizer = /*#__PURE__*/
      function (_Plugin) {
        _inherits(Equalizer, _Plugin);
        function Equalizer() {
          _classCallCheck(this, Equalizer);
          return _possibleConstructorReturn(this, _getPrototypeOf(Equalizer).apply(this, arguments));
        }
        _createClass(Equalizer, [{
          key: "_setup",
          /**
           * Creates a new instance of Equalizer.
           * @class
           * @name Equalizer
           * @fires Equalizer#init
           * @param {Object} element - jQuery object to add the trigger to.
           * @param {Object} options - Overrides to the default plugin settings.
           */
          value: function _setup(element, options) {
            this.$element = element;
            this.options = jquery__WEBPACK_IMPORTED_MODULE_0___default.a.extend({}, Equalizer.defaults, this.$element.data(), options);
            this.className = 'Equalizer'; // ie9 back compat

            this._init();
          }
          /**
           * Initializes the Equalizer plugin and calls functions to get equalizer functioning on load.
           * @private
           */
        }, {
          key: "_init",
          value: function _init() {
            var eqId = this.$element.attr('data-equalizer') || '';
            var $watched = this.$element.find("[data-equalizer-watch=\"".concat(eqId, "\"]"));
            _foundation_util_mediaQuery__WEBPACK_IMPORTED_MODULE_1__["MediaQuery"]._init();
            this.$watched = $watched.length ? $watched : this.$element.find('[data-equalizer-watch]');
            this.$element.attr('data-resize', eqId || Object(_foundation_core_utils__WEBPACK_IMPORTED_MODULE_3__["GetYoDigits"])(6, 'eq'));
            this.$element.attr('data-mutate', eqId || Object(_foundation_core_utils__WEBPACK_IMPORTED_MODULE_3__["GetYoDigits"])(6, 'eq'));
            this.hasNested = this.$element.find('[data-equalizer]').length > 0;
            this.isNested = this.$element.parentsUntil(document.body, '[data-equalizer]').length > 0;
            this.isOn = false;
            this._bindHandler = {
              onResizeMeBound: this._onResizeMe.bind(this),
              onPostEqualizedBound: this._onPostEqualized.bind(this)
            };
            var imgs = this.$element.find('img');
            var tooSmall;
            if (this.options.equalizeOn) {
              tooSmall = this._checkMQ();
              jquery__WEBPACK_IMPORTED_MODULE_0___default()(window).on('changed.zf.mediaquery', this._checkMQ.bind(this));
            } else {
              this._events();
            }
            if (typeof tooSmall !== 'undefined' && tooSmall === false || typeof tooSmall === 'undefined') {
              if (imgs.length) {
                Object(_foundation_util_imageLoader__WEBPACK_IMPORTED_MODULE_2__["onImagesLoaded"])(imgs, this._reflow.bind(this));
              } else {
                this._reflow();
              }
            }
          }
          /**
           * Removes event listeners if the breakpoint is too small.
           * @private
           */
        }, {
          key: "_pauseEvents",
          value: function _pauseEvents() {
            this.isOn = false;
            this.$element.off({
              '.zf.equalizer': this._bindHandler.onPostEqualizedBound,
              'resizeme.zf.trigger': this._bindHandler.onResizeMeBound,
              'mutateme.zf.trigger': this._bindHandler.onResizeMeBound
            });
          }
          /**
           * function to handle $elements resizeme.zf.trigger, with bound this on _bindHandler.onResizeMeBound
           * @private
           */
        }, {
          key: "_onResizeMe",
          value: function _onResizeMe(e) {
            this._reflow();
          }
          /**
           * function to handle $elements postequalized.zf.equalizer, with bound this on _bindHandler.onPostEqualizedBound
           * @private
           */
        }, {
          key: "_onPostEqualized",
          value: function _onPostEqualized(e) {
            if (e.target !== this.$element[0]) {
              this._reflow();
            }
          }
          /**
           * Initializes events for Equalizer.
           * @private
           */
        }, {
          key: "_events",
          value: function _events() {
            var _this = this;
            this._pauseEvents();
            if (this.hasNested) {
              this.$element.on('postequalized.zf.equalizer', this._bindHandler.onPostEqualizedBound);
            } else {
              this.$element.on('resizeme.zf.trigger', this._bindHandler.onResizeMeBound);
              this.$element.on('mutateme.zf.trigger', this._bindHandler.onResizeMeBound);
            }
            this.isOn = true;
          }
          /**
           * Checks the current breakpoint to the minimum required size.
           * @private
           */
        }, {
          key: "_checkMQ",
          value: function _checkMQ() {
            var tooSmall = !_foundation_util_mediaQuery__WEBPACK_IMPORTED_MODULE_1__["MediaQuery"].is(this.options.equalizeOn);
            if (tooSmall) {
              if (this.isOn) {
                this._pauseEvents();
                this.$watched.css('height', 'auto');
              }
            } else {
              if (!this.isOn) {
                this._events();
              }
            }
            return tooSmall;
          }
          /**
           * A noop version for the plugin
           * @private
           */
        }, {
          key: "_killswitch",
          value: function _killswitch() {
            return;
          }
          /**
           * Calls necessary functions to update Equalizer upon DOM change
           * @private
           */
        }, {
          key: "_reflow",
          value: function _reflow() {
            if (!this.options.equalizeOnStack) {
              if (this._isStacked()) {
                this.$watched.css('height', 'auto');
                return false;
              }
            }
            if (this.options.equalizeByRow) {
              this.getHeightsByRow(this.applyHeightByRow.bind(this));
            } else {
              this.getHeights(this.applyHeight.bind(this));
            }
          }
          /**
           * Manually determines if the first 2 elements are *NOT* stacked.
           * @private
           */
        }, {
          key: "_isStacked",
          value: function _isStacked() {
            if (!this.$watched[0] || !this.$watched[1]) {
              return true;
            }
            return this.$watched[0].getBoundingClientRect().top !== this.$watched[1].getBoundingClientRect().top;
          }
          /**
           * Finds the outer heights of children contained within an Equalizer parent and returns them in an array
           * @param {Function} cb - A non-optional callback to return the heights array to.
           * @returns {Array} heights - An array of heights of children within Equalizer container
           */
        }, {
          key: "getHeights",
          value: function getHeights(cb) {
            var heights = [];
            for (var i = 0, len = this.$watched.length; i < len; i++) {
              this.$watched[i].style.height = 'auto';
              heights.push(this.$watched[i].offsetHeight);
            }
            cb(heights);
          }
          /**
           * Finds the outer heights of children contained within an Equalizer parent and returns them in an array
           * @param {Function} cb - A non-optional callback to return the heights array to.
           * @returns {Array} groups - An array of heights of children within Equalizer container grouped by row with element,height and max as last child
           */
        }, {
          key: "getHeightsByRow",
          value: function getHeightsByRow(cb) {
            var lastElTopOffset = this.$watched.length ? this.$watched.first().offset().top : 0,
              groups = [],
              group = 0; //group by Row

            groups[group] = [];
            for (var i = 0, len = this.$watched.length; i < len; i++) {
              this.$watched[i].style.height = 'auto'; //maybe could use this.$watched[i].offsetTop

              var elOffsetTop = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this.$watched[i]).offset().top;
              if (elOffsetTop != lastElTopOffset) {
                group++;
                groups[group] = [];
                lastElTopOffset = elOffsetTop;
              }
              groups[group].push([this.$watched[i], this.$watched[i].offsetHeight]);
            }
            for (var j = 0, ln = groups.length; j < ln; j++) {
              var heights = jquery__WEBPACK_IMPORTED_MODULE_0___default()(groups[j]).map(function () {
                return this[1];
              }).get();
              var max = Math.max.apply(null, heights);
              groups[j].push(max);
            }
            cb(groups);
          }
          /**
           * Changes the CSS height property of each child in an Equalizer parent to match the tallest
           * @param {array} heights - An array of heights of children within Equalizer container
           * @fires Equalizer#preequalized
           * @fires Equalizer#postequalized
           */
        }, {
          key: "applyHeight",
          value: function applyHeight(heights) {
            var max = Math.max.apply(null, heights);
            /**
             * Fires before the heights are applied
             * @event Equalizer#preequalized
             */

            this.$element.trigger('preequalized.zf.equalizer');
            this.$watched.css('height', max);
            /**
             * Fires when the heights have been applied
             * @event Equalizer#postequalized
             */

            this.$element.trigger('postequalized.zf.equalizer');
          }
          /**
           * Changes the CSS height property of each child in an Equalizer parent to match the tallest by row
           * @param {array} groups - An array of heights of children within Equalizer container grouped by row with element,height and max as last child
           * @fires Equalizer#preequalized
           * @fires Equalizer#preequalizedrow
           * @fires Equalizer#postequalizedrow
           * @fires Equalizer#postequalized
           */
        }, {
          key: "applyHeightByRow",
          value: function applyHeightByRow(groups) {
            /**
             * Fires before the heights are applied
             */
            this.$element.trigger('preequalized.zf.equalizer');
            for (var i = 0, len = groups.length; i < len; i++) {
              var groupsILength = groups[i].length,
                max = groups[i][groupsILength - 1];
              if (groupsILength <= 2) {
                jquery__WEBPACK_IMPORTED_MODULE_0___default()(groups[i][0][0]).css({
                  'height': 'auto'
                });
                continue;
              }
              /**
                * Fires before the heights per row are applied
                * @event Equalizer#preequalizedrow
                */

              this.$element.trigger('preequalizedrow.zf.equalizer');
              for (var j = 0, lenJ = groupsILength - 1; j < lenJ; j++) {
                jquery__WEBPACK_IMPORTED_MODULE_0___default()(groups[i][j][0]).css({
                  'height': max
                });
              }
              /**
                * Fires when the heights per row have been applied
                * @event Equalizer#postequalizedrow
                */

              this.$element.trigger('postequalizedrow.zf.equalizer');
            }
            /**
             * Fires when the heights have been applied
             */

            this.$element.trigger('postequalized.zf.equalizer');
          }
          /**
           * Destroys an instance of Equalizer.
           * @function
           */
        }, {
          key: "_destroy",
          value: function _destroy() {
            this._pauseEvents();
            this.$watched.css('height', 'auto');
          }
        }]);
        return Equalizer;
      }(_foundation_core_plugin__WEBPACK_IMPORTED_MODULE_4__["Plugin"]);
      /**
       * Default settings for plugin
       */

      Equalizer.defaults = {
        /**
         * Enable height equalization when stacked on smaller screens.
         * @option
         * @type {boolean}
         * @default false
         */
        equalizeOnStack: false,
        /**
         * Enable height equalization row by row.
         * @option
         * @type {boolean}
         * @default false
         */
        equalizeByRow: false,
        /**
         * String representing the minimum breakpoint size the plugin should equalize heights on.
         * @option
         * @type {string}
         * @default ''
         */
        equalizeOn: ''
      };

      /***/
    }),
    /***/"./js/foundation.interchange.js": (
    /*!**************************************!*\
      !*** ./js/foundation.interchange.js ***!
      \**************************************/
    /*! exports provided: Interchange */
    /***/
    function _js_foundationInterchangeJs(module, __webpack_exports__, __webpack_require__) {
      "use strict";

      __webpack_require__.r(__webpack_exports__);
      /* harmony export (binding) */
      __webpack_require__.d(__webpack_exports__, "Interchange", function () {
        return Interchange;
      });
      /* harmony import */
      var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! jquery */"jquery");
      /* harmony import */
      var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);
      /* harmony import */
      var _foundation_util_mediaQuery__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./foundation.util.mediaQuery */"./js/foundation.util.mediaQuery.js");
      /* harmony import */
      var _foundation_core_plugin__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./foundation.core.plugin */"./js/foundation.core.plugin.js");
      /* harmony import */
      var _foundation_core_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./foundation.core.utils */"./js/foundation.core.utils.js");
      function _typeof(obj) {
        if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
          _typeof = function _typeof(obj) {
            return _typeof2(obj);
          };
        } else {
          _typeof = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
          };
        }
        return _typeof(obj);
      }
      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }
      function _defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }
      function _createClass(Constructor, protoProps, staticProps) {
        if (protoProps) _defineProperties(Constructor.prototype, protoProps);
        if (staticProps) _defineProperties(Constructor, staticProps);
        return Constructor;
      }
      function _possibleConstructorReturn(self, call) {
        if (call && (_typeof(call) === "object" || typeof call === "function")) {
          return call;
        }
        return _assertThisInitialized(self);
      }
      function _assertThisInitialized(self) {
        if (self === void 0) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }
        return self;
      }
      function _getPrototypeOf(o) {
        _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
          return o.__proto__ || Object.getPrototypeOf(o);
        };
        return _getPrototypeOf(o);
      }
      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function");
        }
        subClass.prototype = Object.create(superClass && superClass.prototype, {
          constructor: {
            value: subClass,
            writable: true,
            configurable: true
          }
        });
        if (superClass) _setPrototypeOf(subClass, superClass);
      }
      function _setPrototypeOf(o, p) {
        _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
          o.__proto__ = p;
          return o;
        };
        return _setPrototypeOf(o, p);
      }

      /**
       * Interchange module.
       * @module foundation.interchange
       * @requires foundation.util.mediaQuery
       */

      var Interchange = /*#__PURE__*/
      function (_Plugin) {
        _inherits(Interchange, _Plugin);
        function Interchange() {
          _classCallCheck(this, Interchange);
          return _possibleConstructorReturn(this, _getPrototypeOf(Interchange).apply(this, arguments));
        }
        _createClass(Interchange, [{
          key: "_setup",
          /**
           * Creates a new instance of Interchange.
           * @class
           * @name Interchange
           * @fires Interchange#init
           * @param {Object} element - jQuery object to add the trigger to.
           * @param {Object} options - Overrides to the default plugin settings.
           */
          value: function _setup(element, options) {
            this.$element = element;
            this.options = jquery__WEBPACK_IMPORTED_MODULE_0___default.a.extend({}, Interchange.defaults, options);
            this.rules = [];
            this.currentPath = '';
            this.className = 'Interchange'; // ie9 back compat

            this._init();
            this._events();
          }
          /**
           * Initializes the Interchange plugin and calls functions to get interchange functioning on load.
           * @function
           * @private
           */
        }, {
          key: "_init",
          value: function _init() {
            _foundation_util_mediaQuery__WEBPACK_IMPORTED_MODULE_1__["MediaQuery"]._init();
            var id = this.$element[0].id || Object(_foundation_core_utils__WEBPACK_IMPORTED_MODULE_3__["GetYoDigits"])(6, 'interchange');
            this.$element.attr({
              'data-resize': id,
              'id': id
            });
            this._addBreakpoints();
            this._generateRules();
            this._reflow();
          }
          /**
           * Initializes events for Interchange.
           * @function
           * @private
           */
        }, {
          key: "_events",
          value: function _events() {
            var _this2 = this;
            this.$element.off('resizeme.zf.trigger').on('resizeme.zf.trigger', function () {
              return _this2._reflow();
            });
          }
          /**
           * Calls necessary functions to update Interchange upon DOM change
           * @function
           * @private
           */
        }, {
          key: "_reflow",
          value: function _reflow() {
            var match; // Iterate through each rule, but only save the last match

            for (var i in this.rules) {
              if (this.rules.hasOwnProperty(i)) {
                var rule = this.rules[i];
                if (window.matchMedia(rule.query).matches) {
                  match = rule;
                }
              }
            }
            if (match) {
              this.replace(match.path);
            }
          }
          /**
           * Gets the Foundation breakpoints and adds them to the Interchange.SPECIAL_QUERIES object.
           * @function
           * @private
           */
        }, {
          key: "_addBreakpoints",
          value: function _addBreakpoints() {
            for (var i in _foundation_util_mediaQuery__WEBPACK_IMPORTED_MODULE_1__["MediaQuery"].queries) {
              if (_foundation_util_mediaQuery__WEBPACK_IMPORTED_MODULE_1__["MediaQuery"].queries.hasOwnProperty(i)) {
                var query = _foundation_util_mediaQuery__WEBPACK_IMPORTED_MODULE_1__["MediaQuery"].queries[i];
                Interchange.SPECIAL_QUERIES[query.name] = query.value;
              }
            }
          }
          /**
           * Checks the Interchange element for the provided media query + content pairings
           * @function
           * @private
           * @param {Object} element - jQuery object that is an Interchange instance
           * @returns {Array} scenarios - Array of objects that have 'mq' and 'path' keys with corresponding keys
           */
        }, {
          key: "_generateRules",
          value: function _generateRules(element) {
            var rulesList = [];
            var rules;
            if (this.options.rules) {
              rules = this.options.rules;
            } else {
              rules = this.$element.data('interchange');
            }
            rules = typeof rules === 'string' ? rules.match(/\[.*?, .*?\]/g) : rules;
            for (var i in rules) {
              if (rules.hasOwnProperty(i)) {
                var rule = rules[i].slice(1, -1).split(', ');
                var path = rule.slice(0, -1).join('');
                var query = rule[rule.length - 1];
                if (Interchange.SPECIAL_QUERIES[query]) {
                  query = Interchange.SPECIAL_QUERIES[query];
                }
                rulesList.push({
                  path: path,
                  query: query
                });
              }
            }
            this.rules = rulesList;
          }
          /**
           * Update the `src` property of an image, or change the HTML of a container, to the specified path.
           * @function
           * @param {String} path - Path to the image or HTML partial.
           * @fires Interchange#replaced
           */
        }, {
          key: "replace",
          value: function replace(path) {
            if (this.currentPath === path) return;
            var _this = this,
              trigger = 'replaced.zf.interchange'; // Replacing images

            if (this.$element[0].nodeName === 'IMG') {
              this.$element.attr('src', path).on('load', function () {
                _this.currentPath = path;
              }).trigger(trigger);
            } // Replacing background images
            else if (path.match(/\.(gif|jpg|jpeg|png|svg|tiff)([?#].*)?/i)) {
              path = path.replace(/\(/g, '%28').replace(/\)/g, '%29');
              this.$element.css({
                'background-image': 'url(' + path + ')'
              }).trigger(trigger);
            } // Replacing HTML
            else {
              jquery__WEBPACK_IMPORTED_MODULE_0___default.a.get(path, function (response) {
                _this.$element.html(response).trigger(trigger);
                jquery__WEBPACK_IMPORTED_MODULE_0___default()(response).foundation();
                _this.currentPath = path;
              });
            }
            /**
             * Fires when content in an Interchange element is done being loaded.
             * @event Interchange#replaced
             */
            // this.$element.trigger('replaced.zf.interchange');
          }
          /**
           * Destroys an instance of interchange.
           * @function
           */
        }, {
          key: "_destroy",
          value: function _destroy() {
            this.$element.off('resizeme.zf.trigger');
          }
        }]);
        return Interchange;
      }(_foundation_core_plugin__WEBPACK_IMPORTED_MODULE_2__["Plugin"]);
      /**
       * Default settings for plugin
       */

      Interchange.defaults = {
        /**
         * Rules to be applied to Interchange elements. Set with the `data-interchange` array notation.
         * @option
         * @type {?array}
         * @default null
         */
        rules: null
      };
      Interchange.SPECIAL_QUERIES = {
        'landscape': 'screen and (orientation: landscape)',
        'portrait': 'screen and (orientation: portrait)',
        'retina': 'only screen and (-webkit-min-device-pixel-ratio: 2), only screen and (min--moz-device-pixel-ratio: 2), only screen and (-o-min-device-pixel-ratio: 2/1), only screen and (min-device-pixel-ratio: 2), only screen and (min-resolution: 192dpi), only screen and (min-resolution: 2dppx)'
      };

      /***/
    }),
    /***/"./js/foundation.magellan.js": (
    /*!***********************************!*\
      !*** ./js/foundation.magellan.js ***!
      \***********************************/
    /*! exports provided: Magellan */
    /***/
    function _js_foundationMagellanJs(module, __webpack_exports__, __webpack_require__) {
      "use strict";

      __webpack_require__.r(__webpack_exports__);
      /* harmony export (binding) */
      __webpack_require__.d(__webpack_exports__, "Magellan", function () {
        return Magellan;
      });
      /* harmony import */
      var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! jquery */"jquery");
      /* harmony import */
      var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);
      /* harmony import */
      var _foundation_core_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./foundation.core.utils */"./js/foundation.core.utils.js");
      /* harmony import */
      var _foundation_core_plugin__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./foundation.core.plugin */"./js/foundation.core.plugin.js");
      /* harmony import */
      var _foundation_smoothScroll__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./foundation.smoothScroll */"./js/foundation.smoothScroll.js");
      function _typeof(obj) {
        if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
          _typeof = function _typeof(obj) {
            return _typeof2(obj);
          };
        } else {
          _typeof = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
          };
        }
        return _typeof(obj);
      }
      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }
      function _defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }
      function _createClass(Constructor, protoProps, staticProps) {
        if (protoProps) _defineProperties(Constructor.prototype, protoProps);
        if (staticProps) _defineProperties(Constructor, staticProps);
        return Constructor;
      }
      function _possibleConstructorReturn(self, call) {
        if (call && (_typeof(call) === "object" || typeof call === "function")) {
          return call;
        }
        return _assertThisInitialized(self);
      }
      function _assertThisInitialized(self) {
        if (self === void 0) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }
        return self;
      }
      function _getPrototypeOf(o) {
        _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
          return o.__proto__ || Object.getPrototypeOf(o);
        };
        return _getPrototypeOf(o);
      }
      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function");
        }
        subClass.prototype = Object.create(superClass && superClass.prototype, {
          constructor: {
            value: subClass,
            writable: true,
            configurable: true
          }
        });
        if (superClass) _setPrototypeOf(subClass, superClass);
      }
      function _setPrototypeOf(o, p) {
        _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
          o.__proto__ = p;
          return o;
        };
        return _setPrototypeOf(o, p);
      }

      /**
       * Magellan module.
       * @module foundation.magellan
       * @requires foundation.smoothScroll
       */

      var Magellan = /*#__PURE__*/
      function (_Plugin) {
        _inherits(Magellan, _Plugin);
        function Magellan() {
          _classCallCheck(this, Magellan);
          return _possibleConstructorReturn(this, _getPrototypeOf(Magellan).apply(this, arguments));
        }
        _createClass(Magellan, [{
          key: "_setup",
          /**
           * Creates a new instance of Magellan.
           * @class
           * @name Magellan
           * @fires Magellan#init
           * @param {Object} element - jQuery object to add the trigger to.
           * @param {Object} options - Overrides to the default plugin settings.
           */
          value: function _setup(element, options) {
            this.$element = element;
            this.options = jquery__WEBPACK_IMPORTED_MODULE_0___default.a.extend({}, Magellan.defaults, this.$element.data(), options);
            this.className = 'Magellan'; // ie9 back compat

            this._init();
            this.calcPoints();
          }
          /**
           * Initializes the Magellan plugin and calls functions to get equalizer functioning on load.
           * @private
           */
        }, {
          key: "_init",
          value: function _init() {
            var id = this.$element[0].id || Object(_foundation_core_utils__WEBPACK_IMPORTED_MODULE_1__["GetYoDigits"])(6, 'magellan');
            var _this = this;
            this.$targets = jquery__WEBPACK_IMPORTED_MODULE_0___default()('[data-magellan-target]');
            this.$links = this.$element.find('a');
            this.$element.attr({
              'data-resize': id,
              'data-scroll': id,
              'id': id
            });
            this.$active = jquery__WEBPACK_IMPORTED_MODULE_0___default()();
            this.scrollPos = parseInt(window.pageYOffset, 10);
            this._events();
          }
          /**
           * Calculates an array of pixel values that are the demarcation lines between locations on the page.
           * Can be invoked if new elements are added or the size of a location changes.
           * @function
           */
        }, {
          key: "calcPoints",
          value: function calcPoints() {
            var _this = this,
              body = document.body,
              html = document.documentElement;
            this.points = [];
            this.winHeight = Math.round(Math.max(window.innerHeight, html.clientHeight));
            this.docHeight = Math.round(Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight));
            this.$targets.each(function () {
              var $tar = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this),
                pt = Math.round($tar.offset().top - _this.options.threshold);
              $tar.targetPoint = pt;
              _this.points.push(pt);
            });
          }
          /**
           * Initializes events for Magellan.
           * @private
           */
        }, {
          key: "_events",
          value: function _events() {
            var _this = this,
              $body = jquery__WEBPACK_IMPORTED_MODULE_0___default()('html, body'),
              opts = {
                duration: _this.options.animationDuration,
                easing: _this.options.animationEasing
              };
            jquery__WEBPACK_IMPORTED_MODULE_0___default()(window).one('load', function () {
              if (_this.options.deepLinking) {
                if (location.hash) {
                  _this.scrollToLoc(location.hash);
                }
              }
              _this.calcPoints();
              _this._updateActive();
            });
            _this.onLoadListener = Object(_foundation_core_utils__WEBPACK_IMPORTED_MODULE_1__["onLoad"])(jquery__WEBPACK_IMPORTED_MODULE_0___default()(window), function () {
              _this.$element.on({
                'resizeme.zf.trigger': _this.reflow.bind(_this),
                'scrollme.zf.trigger': _this._updateActive.bind(_this)
              }).on('click.zf.magellan', 'a[href^="#"]', function (e) {
                e.preventDefault();
                var arrival = this.getAttribute('href');
                _this.scrollToLoc(arrival);
              });
            });
            this._deepLinkScroll = function (e) {
              if (_this.options.deepLinking) {
                _this.scrollToLoc(window.location.hash);
              }
            };
            jquery__WEBPACK_IMPORTED_MODULE_0___default()(window).on('hashchange', this._deepLinkScroll);
          }
          /**
           * Function to scroll to a given location on the page.
           * @param {String} loc - a properly formatted jQuery id selector. Example: '#foo'
           * @function
           */
        }, {
          key: "scrollToLoc",
          value: function scrollToLoc(loc) {
            this._inTransition = true;
            var _this = this;
            var options = {
              animationEasing: this.options.animationEasing,
              animationDuration: this.options.animationDuration,
              threshold: this.options.threshold,
              offset: this.options.offset
            };
            _foundation_smoothScroll__WEBPACK_IMPORTED_MODULE_3__["SmoothScroll"].scrollToLoc(loc, options, function () {
              _this._inTransition = false;
            });
          }
          /**
           * Calls necessary functions to update Magellan upon DOM change
           * @function
           */
        }, {
          key: "reflow",
          value: function reflow() {
            this.calcPoints();
            this._updateActive();
          }
          /**
           * Updates the visibility of an active location link, and updates the url hash for the page, if deepLinking enabled.
           * @private
           * @function
           * @fires Magellan#update
           */
        }, {
          key: "_updateActive",
          value: function _updateActive() /*evt, elem, scrollPos*/
          {
            var _this2 = this;
            if (this._inTransition) return;
            var newScrollPos = parseInt(window.pageYOffset, 10);
            var isScrollingUp = this.scrollPos > newScrollPos;
            this.scrollPos = newScrollPos;
            var activeIdx; // Before the first point: no link

            if (newScrollPos < this.points[0]) {}
            /* do nothing */
            // At the bottom of the page: last link
            else if (newScrollPos + this.winHeight === this.docHeight) {
              activeIdx = this.points.length - 1;
            } // Otherwhise, use the last visible link
            else {
              var visibleLinks = this.points.filter(function (p, i) {
                return p - _this2.options.offset - (isScrollingUp ? _this2.options.threshold : 0) <= newScrollPos;
              });
              activeIdx = visibleLinks.length ? visibleLinks.length - 1 : 0;
            } // Get the new active link

            var $oldActive = this.$active;
            var activeHash = '';
            if (typeof activeIdx !== 'undefined') {
              this.$active = this.$links.filter('[href="#' + this.$targets.eq(activeIdx).data('magellan-target') + '"]');
              if (this.$active.length) activeHash = this.$active[0].getAttribute('href');
            } else {
              this.$active = jquery__WEBPACK_IMPORTED_MODULE_0___default()();
            }
            var isNewActive = !(!this.$active.length && !$oldActive.length) && !this.$active.is($oldActive);
            var isNewHash = activeHash !== window.location.hash; // Update the active link element

            if (isNewActive) {
              $oldActive.removeClass(this.options.activeClass);
              this.$active.addClass(this.options.activeClass);
            } // Update the hash (it may have changed with the same active link)

            if (this.options.deepLinking && isNewHash) {
              if (window.history.pushState) {
                // Set or remove the hash (see: https://stackoverflow.com/a/5298684/4317384
                var url = activeHash ? activeHash : window.location.pathname + window.location.search;
                window.history.pushState(null, null, url);
              } else {
                window.location.hash = activeHash;
              }
            }
            if (isNewActive) {
              /**
               * Fires when magellan is finished updating to the new active element.
               * @event Magellan#update
               */
              this.$element.trigger('update.zf.magellan', [this.$active]);
            }
          }
          /**
           * Destroys an instance of Magellan and resets the url of the window.
           * @function
           */
        }, {
          key: "_destroy",
          value: function _destroy() {
            this.$element.off('.zf.trigger .zf.magellan').find(".".concat(this.options.activeClass)).removeClass(this.options.activeClass);
            if (this.options.deepLinking) {
              var hash = this.$active[0].getAttribute('href');
              window.location.hash.replace(hash, '');
            }
            jquery__WEBPACK_IMPORTED_MODULE_0___default()(window).off('hashchange', this._deepLinkScroll);
            if (this.onLoadListener) jquery__WEBPACK_IMPORTED_MODULE_0___default()(window).off(this.onLoadListener);
          }
        }]);
        return Magellan;
      }(_foundation_core_plugin__WEBPACK_IMPORTED_MODULE_2__["Plugin"]);
      /**
       * Default settings for plugin
       */

      Magellan.defaults = {
        /**
         * Amount of time, in ms, the animated scrolling should take between locations.
         * @option
         * @type {number}
         * @default 500
         */
        animationDuration: 500,
        /**
         * Animation style to use when scrolling between locations. Can be `'swing'` or `'linear'`.
         * @option
         * @type {string}
         * @default 'linear'
         * @see {@link https://api.jquery.com/animate|Jquery animate}
         */
        animationEasing: 'linear',
        /**
         * Number of pixels to use as a marker for location changes.
         * @option
         * @type {number}
         * @default 50
         */
        threshold: 50,
        /**
         * Class applied to the active locations link on the magellan container.
         * @option
         * @type {string}
         * @default 'is-active'
         */
        activeClass: 'is-active',
        /**
         * Allows the script to manipulate the url of the current page, and if supported, alter the history.
         * @option
         * @type {boolean}
         * @default false
         */
        deepLinking: false,
        /**
         * Number of pixels to offset the scroll of the page on item click if using a sticky nav bar.
         * @option
         * @type {number}
         * @default 0
         */
        offset: 0
      };

      /***/
    }),
    /***/"./js/foundation.offcanvas.js": (
    /*!************************************!*\
      !*** ./js/foundation.offcanvas.js ***!
      \************************************/
    /*! exports provided: OffCanvas */
    /***/
    function _js_foundationOffcanvasJs(module, __webpack_exports__, __webpack_require__) {
      "use strict";

      __webpack_require__.r(__webpack_exports__);
      /* harmony export (binding) */
      __webpack_require__.d(__webpack_exports__, "OffCanvas", function () {
        return OffCanvas;
      });
      /* harmony import */
      var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! jquery */"jquery");
      /* harmony import */
      var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);
      /* harmony import */
      var _foundation_core_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./foundation.core.utils */"./js/foundation.core.utils.js");
      /* harmony import */
      var _foundation_util_keyboard__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./foundation.util.keyboard */"./js/foundation.util.keyboard.js");
      /* harmony import */
      var _foundation_util_mediaQuery__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./foundation.util.mediaQuery */"./js/foundation.util.mediaQuery.js");
      /* harmony import */
      var _foundation_core_plugin__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./foundation.core.plugin */"./js/foundation.core.plugin.js");
      /* harmony import */
      var _foundation_util_triggers__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./foundation.util.triggers */"./js/foundation.util.triggers.js");
      function _typeof(obj) {
        if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
          _typeof = function _typeof(obj) {
            return _typeof2(obj);
          };
        } else {
          _typeof = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
          };
        }
        return _typeof(obj);
      }
      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }
      function _defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }
      function _createClass(Constructor, protoProps, staticProps) {
        if (protoProps) _defineProperties(Constructor.prototype, protoProps);
        if (staticProps) _defineProperties(Constructor, staticProps);
        return Constructor;
      }
      function _possibleConstructorReturn(self, call) {
        if (call && (_typeof(call) === "object" || typeof call === "function")) {
          return call;
        }
        return _assertThisInitialized(self);
      }
      function _assertThisInitialized(self) {
        if (self === void 0) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }
        return self;
      }
      function _getPrototypeOf(o) {
        _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
          return o.__proto__ || Object.getPrototypeOf(o);
        };
        return _getPrototypeOf(o);
      }
      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function");
        }
        subClass.prototype = Object.create(superClass && superClass.prototype, {
          constructor: {
            value: subClass,
            writable: true,
            configurable: true
          }
        });
        if (superClass) _setPrototypeOf(subClass, superClass);
      }
      function _setPrototypeOf(o, p) {
        _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
          o.__proto__ = p;
          return o;
        };
        return _setPrototypeOf(o, p);
      }

      /**
       * OffCanvas module.
       * @module foundation.offcanvas
       * @requires foundation.util.keyboard
       * @requires foundation.util.mediaQuery
       * @requires foundation.util.triggers
       */

      var OffCanvas = /*#__PURE__*/
      function (_Plugin) {
        _inherits(OffCanvas, _Plugin);
        function OffCanvas() {
          _classCallCheck(this, OffCanvas);
          return _possibleConstructorReturn(this, _getPrototypeOf(OffCanvas).apply(this, arguments));
        }
        _createClass(OffCanvas, [{
          key: "_setup",
          /**
           * Creates a new instance of an off-canvas wrapper.
           * @class
           * @name OffCanvas
           * @fires OffCanvas#init
           * @param {Object} element - jQuery object to initialize.
           * @param {Object} options - Overrides to the default plugin settings.
           */
          value: function _setup(element, options) {
            var _this2 = this;
            this.className = 'OffCanvas'; // ie9 back compat

            this.$element = element;
            this.options = jquery__WEBPACK_IMPORTED_MODULE_0___default.a.extend({}, OffCanvas.defaults, this.$element.data(), options);
            this.contentClasses = {
              base: [],
              reveal: []
            };
            this.$lastTrigger = jquery__WEBPACK_IMPORTED_MODULE_0___default()();
            this.$triggers = jquery__WEBPACK_IMPORTED_MODULE_0___default()();
            this.position = 'left';
            this.$content = jquery__WEBPACK_IMPORTED_MODULE_0___default()();
            this.nested = !!this.options.nested; // Defines the CSS transition/position classes of the off-canvas content container.

            jquery__WEBPACK_IMPORTED_MODULE_0___default()(['push', 'overlap']).each(function (index, val) {
              _this2.contentClasses.base.push('has-transition-' + val);
            });
            jquery__WEBPACK_IMPORTED_MODULE_0___default()(['left', 'right', 'top', 'bottom']).each(function (index, val) {
              _this2.contentClasses.base.push('has-position-' + val);
              _this2.contentClasses.reveal.push('has-reveal-' + val);
            }); // Triggers init is idempotent, just need to make sure it is initialized

            _foundation_util_triggers__WEBPACK_IMPORTED_MODULE_5__["Triggers"].init(jquery__WEBPACK_IMPORTED_MODULE_0___default.a);
            _foundation_util_mediaQuery__WEBPACK_IMPORTED_MODULE_3__["MediaQuery"]._init();
            this._init();
            this._events();
            _foundation_util_keyboard__WEBPACK_IMPORTED_MODULE_2__["Keyboard"].register('OffCanvas', {
              'ESCAPE': 'close'
            });
          }
          /**
           * Initializes the off-canvas wrapper by adding the exit overlay (if needed).
           * @function
           * @private
           */
        }, {
          key: "_init",
          value: function _init() {
            var id = this.$element.attr('id');
            this.$element.attr('aria-hidden', 'true'); // Find off-canvas content, either by ID (if specified), by siblings or by closest selector (fallback)

            if (this.options.contentId) {
              this.$content = jquery__WEBPACK_IMPORTED_MODULE_0___default()('#' + this.options.contentId);
            } else if (this.$element.siblings('[data-off-canvas-content]').length) {
              this.$content = this.$element.siblings('[data-off-canvas-content]').first();
            } else {
              this.$content = this.$element.closest('[data-off-canvas-content]').first();
            }
            if (!this.options.contentId) {
              // Assume that the off-canvas element is nested if it isn't a sibling of the content
              this.nested = this.$element.siblings('[data-off-canvas-content]').length === 0;
            } else if (this.options.contentId && this.options.nested === null) {
              // Warning if using content ID without setting the nested option
              // Once the element is nested it is required to work properly in this case
              console.warn('Remember to use the nested option if using the content ID option!');
            }
            if (this.nested === true) {
              // Force transition overlap if nested
              this.options.transition = 'overlap'; // Remove appropriate classes if already assigned in markup

              this.$element.removeClass('is-transition-push');
            }
            this.$element.addClass("is-transition-".concat(this.options.transition, " is-closed")); // Find triggers that affect this element and add aria-expanded to them

            this.$triggers = jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).find('[data-open="' + id + '"], [data-close="' + id + '"], [data-toggle="' + id + '"]').attr('aria-expanded', 'false').attr('aria-controls', id); // Get position by checking for related CSS class

            this.position = this.$element.is('.position-left, .position-top, .position-right, .position-bottom') ? this.$element.attr('class').match(/position\-(left|top|right|bottom)/)[1] : this.position; // Add an overlay over the content if necessary

            if (this.options.contentOverlay === true) {
              var overlay = document.createElement('div');
              var overlayPosition = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this.$element).css("position") === 'fixed' ? 'is-overlay-fixed' : 'is-overlay-absolute';
              overlay.setAttribute('class', 'js-off-canvas-overlay ' + overlayPosition);
              this.$overlay = jquery__WEBPACK_IMPORTED_MODULE_0___default()(overlay);
              if (overlayPosition === 'is-overlay-fixed') {
                jquery__WEBPACK_IMPORTED_MODULE_0___default()(this.$overlay).insertAfter(this.$element);
              } else {
                this.$content.append(this.$overlay);
              }
            } // Get the revealOn option from the class.

            var revealOnRegExp = new RegExp(Object(_foundation_core_utils__WEBPACK_IMPORTED_MODULE_1__["RegExpEscape"])(this.options.revealClass) + '([^\\s]+)', 'g');
            var revealOnClass = revealOnRegExp.exec(this.$element[0].className);
            if (revealOnClass) {
              this.options.isRevealed = true;
              this.options.revealOn = this.options.revealOn || revealOnClass[1];
            } // Ensure the `reveal-on-*` class is set.

            if (this.options.isRevealed === true && this.options.revealOn) {
              this.$element.first().addClass("".concat(this.options.revealClass).concat(this.options.revealOn));
              this._setMQChecker();
            }
            if (this.options.transitionTime) {
              this.$element.css('transition-duration', this.options.transitionTime);
            } // Initally remove all transition/position CSS classes from off-canvas content container.

            this._removeContentClasses();
          }
          /**
           * Adds event handlers to the off-canvas wrapper and the exit overlay.
           * @function
           * @private
           */
        }, {
          key: "_events",
          value: function _events() {
            this.$element.off('.zf.trigger .zf.offcanvas').on({
              'open.zf.trigger': this.open.bind(this),
              'close.zf.trigger': this.close.bind(this),
              'toggle.zf.trigger': this.toggle.bind(this),
              'keydown.zf.offcanvas': this._handleKeyboard.bind(this)
            });
            if (this.options.closeOnClick === true) {
              var $target = this.options.contentOverlay ? this.$overlay : this.$content;
              $target.on({
                'click.zf.offcanvas': this.close.bind(this)
              });
            }
          }
          /**
           * Applies event listener for elements that will reveal at certain breakpoints.
           * @private
           */
        }, {
          key: "_setMQChecker",
          value: function _setMQChecker() {
            var _this = this;
            this.onLoadListener = Object(_foundation_core_utils__WEBPACK_IMPORTED_MODULE_1__["onLoad"])(jquery__WEBPACK_IMPORTED_MODULE_0___default()(window), function () {
              if (_foundation_util_mediaQuery__WEBPACK_IMPORTED_MODULE_3__["MediaQuery"].atLeast(_this.options.revealOn)) {
                _this.reveal(true);
              }
            });
            jquery__WEBPACK_IMPORTED_MODULE_0___default()(window).on('changed.zf.mediaquery', function () {
              if (_foundation_util_mediaQuery__WEBPACK_IMPORTED_MODULE_3__["MediaQuery"].atLeast(_this.options.revealOn)) {
                _this.reveal(true);
              } else {
                _this.reveal(false);
              }
            });
          }
          /**
           * Removes the CSS transition/position classes of the off-canvas content container.
           * Removing the classes is important when another off-canvas gets opened that uses the same content container.
           * @param {Boolean} hasReveal - true if related off-canvas element is revealed.
           * @private
           */
        }, {
          key: "_removeContentClasses",
          value: function _removeContentClasses(hasReveal) {
            if (typeof hasReveal !== 'boolean') {
              this.$content.removeClass(this.contentClasses.base.join(' '));
            } else if (hasReveal === false) {
              this.$content.removeClass("has-reveal-".concat(this.position));
            }
          }
          /**
           * Adds the CSS transition/position classes of the off-canvas content container, based on the opening off-canvas element.
           * Beforehand any transition/position class gets removed.
           * @param {Boolean} hasReveal - true if related off-canvas element is revealed.
           * @private
           */
        }, {
          key: "_addContentClasses",
          value: function _addContentClasses(hasReveal) {
            this._removeContentClasses(hasReveal);
            if (typeof hasReveal !== 'boolean') {
              this.$content.addClass("has-transition-".concat(this.options.transition, " has-position-").concat(this.position));
            } else if (hasReveal === true) {
              this.$content.addClass("has-reveal-".concat(this.position));
            }
          }
          /**
           * Handles the revealing/hiding the off-canvas at breakpoints, not the same as open.
           * @param {Boolean} isRevealed - true if element should be revealed.
           * @function
           */
        }, {
          key: "reveal",
          value: function reveal(isRevealed) {
            if (isRevealed) {
              this.close();
              this.isRevealed = true;
              this.$element.attr('aria-hidden', 'false');
              this.$element.off('open.zf.trigger toggle.zf.trigger');
              this.$element.removeClass('is-closed');
            } else {
              this.isRevealed = false;
              this.$element.attr('aria-hidden', 'true');
              this.$element.off('open.zf.trigger toggle.zf.trigger').on({
                'open.zf.trigger': this.open.bind(this),
                'toggle.zf.trigger': this.toggle.bind(this)
              });
              this.$element.addClass('is-closed');
            }
            this._addContentClasses(isRevealed);
          }
          /**
           * Stops scrolling of the body when offcanvas is open on mobile Safari and other troublesome browsers.
           * @private
           */
        }, {
          key: "_stopScrolling",
          value: function _stopScrolling(event) {
            return false;
          } // Taken and adapted from http://stackoverflow.com/questions/16889447/prevent-full-page-scrolling-ios
          // Only really works for y, not sure how to extend to x or if we need to.
        }, {
          key: "_recordScrollable",
          value: function _recordScrollable(event) {
            var elem = this; // called from event handler context with this as elem
            // If the element is scrollable (content overflows), then...

            if (elem.scrollHeight !== elem.clientHeight) {
              // If we're at the top, scroll down one pixel to allow scrolling up
              if (elem.scrollTop === 0) {
                elem.scrollTop = 1;
              } // If we're at the bottom, scroll up one pixel to allow scrolling down

              if (elem.scrollTop === elem.scrollHeight - elem.clientHeight) {
                elem.scrollTop = elem.scrollHeight - elem.clientHeight - 1;
              }
            }
            elem.allowUp = elem.scrollTop > 0;
            elem.allowDown = elem.scrollTop < elem.scrollHeight - elem.clientHeight;
            elem.lastY = event.originalEvent.pageY;
          }
        }, {
          key: "_stopScrollPropagation",
          value: function _stopScrollPropagation(event) {
            var elem = this; // called from event handler context with this as elem

            var up = event.pageY < elem.lastY;
            var down = !up;
            elem.lastY = event.pageY;
            if (up && elem.allowUp || down && elem.allowDown) {
              event.stopPropagation();
            } else {
              event.preventDefault();
            }
          }
          /**
           * Opens the off-canvas menu.
           * @function
           * @param {Object} event - Event object passed from listener.
           * @param {jQuery} trigger - element that triggered the off-canvas to open.
           * @fires Offcanvas#opened
           * @todo also trigger 'open' event?
           */
        }, {
          key: "open",
          value: function open(event, trigger) {
            if (this.$element.hasClass('is-open') || this.isRevealed) {
              return;
            }
            var _this = this;
            if (trigger) {
              this.$lastTrigger = trigger;
            }
            if (this.options.forceTo === 'top') {
              window.scrollTo(0, 0);
            } else if (this.options.forceTo === 'bottom') {
              window.scrollTo(0, document.body.scrollHeight);
            }
            if (this.options.transitionTime && this.options.transition !== 'overlap') {
              this.$element.siblings('[data-off-canvas-content]').css('transition-duration', this.options.transitionTime);
            } else {
              this.$element.siblings('[data-off-canvas-content]').css('transition-duration', '');
            }
            this.$element.addClass('is-open').removeClass('is-closed');
            this.$triggers.attr('aria-expanded', 'true');
            this.$element.attr('aria-hidden', 'false');
            this.$content.addClass('is-open-' + this.position); // If `contentScroll` is set to false, add class and disable scrolling on touch devices.

            if (this.options.contentScroll === false) {
              jquery__WEBPACK_IMPORTED_MODULE_0___default()('body').addClass('is-off-canvas-open').on('touchmove', this._stopScrolling);
              this.$element.on('touchstart', this._recordScrollable);
              this.$element.on('touchmove', this._stopScrollPropagation);
            }
            if (this.options.contentOverlay === true) {
              this.$overlay.addClass('is-visible');
            }
            if (this.options.closeOnClick === true && this.options.contentOverlay === true) {
              this.$overlay.addClass('is-closable');
            }
            if (this.options.autoFocus === true) {
              this.$element.one(Object(_foundation_core_utils__WEBPACK_IMPORTED_MODULE_1__["transitionend"])(this.$element), function () {
                if (!_this.$element.hasClass('is-open')) {
                  return; // exit if prematurely closed
                }
                var canvasFocus = _this.$element.find('[data-autofocus]');
                if (canvasFocus.length) {
                  canvasFocus.eq(0).focus();
                } else {
                  _this.$element.find('a, button').eq(0).focus();
                }
              });
            }
            if (this.options.trapFocus === true) {
              this.$content.attr('tabindex', '-1');
              _foundation_util_keyboard__WEBPACK_IMPORTED_MODULE_2__["Keyboard"].trapFocus(this.$element);
            }
            this._addContentClasses();
            /**
             * Fires when the off-canvas menu opens.
             * @event Offcanvas#opened
             */

            this.$element.trigger('opened.zf.offcanvas');
          }
          /**
           * Closes the off-canvas menu.
           * @function
           * @param {Function} cb - optional cb to fire after closure.
           * @fires Offcanvas#closed
           */
        }, {
          key: "close",
          value: function close(cb) {
            if (!this.$element.hasClass('is-open') || this.isRevealed) {
              return;
            }
            var _this = this;
            this.$element.removeClass('is-open');
            this.$element.attr('aria-hidden', 'true')
            /**
             * Fires when the off-canvas menu opens.
             * @event Offcanvas#closed
             */.trigger('closed.zf.offcanvas');
            this.$content.removeClass('is-open-left is-open-top is-open-right is-open-bottom'); // If `contentScroll` is set to false, remove class and re-enable scrolling on touch devices.

            if (this.options.contentScroll === false) {
              jquery__WEBPACK_IMPORTED_MODULE_0___default()('body').removeClass('is-off-canvas-open').off('touchmove', this._stopScrolling);
              this.$element.off('touchstart', this._recordScrollable);
              this.$element.off('touchmove', this._stopScrollPropagation);
            }
            if (this.options.contentOverlay === true) {
              this.$overlay.removeClass('is-visible');
            }
            if (this.options.closeOnClick === true && this.options.contentOverlay === true) {
              this.$overlay.removeClass('is-closable');
            }
            this.$triggers.attr('aria-expanded', 'false');
            if (this.options.trapFocus === true) {
              this.$content.removeAttr('tabindex');
              _foundation_util_keyboard__WEBPACK_IMPORTED_MODULE_2__["Keyboard"].releaseFocus(this.$element);
            } // Listen to transitionEnd and add class when done.

            this.$element.one(Object(_foundation_core_utils__WEBPACK_IMPORTED_MODULE_1__["transitionend"])(this.$element), function (e) {
              _this.$element.addClass('is-closed');
              _this._removeContentClasses();
            });
          }
          /**
           * Toggles the off-canvas menu open or closed.
           * @function
           * @param {Object} event - Event object passed from listener.
           * @param {jQuery} trigger - element that triggered the off-canvas to open.
           */
        }, {
          key: "toggle",
          value: function toggle(event, trigger) {
            if (this.$element.hasClass('is-open')) {
              this.close(event, trigger);
            } else {
              this.open(event, trigger);
            }
          }
          /**
           * Handles keyboard input when detected. When the escape key is pressed, the off-canvas menu closes, and focus is restored to the element that opened the menu.
           * @function
           * @private
           */
        }, {
          key: "_handleKeyboard",
          value: function _handleKeyboard(e) {
            var _this3 = this;
            _foundation_util_keyboard__WEBPACK_IMPORTED_MODULE_2__["Keyboard"].handleKey(e, 'OffCanvas', {
              close: function close() {
                _this3.close();
                _this3.$lastTrigger.focus();
                return true;
              },
              handled: function handled() {
                e.stopPropagation();
                e.preventDefault();
              }
            });
          }
          /**
           * Destroys the offcanvas plugin.
           * @function
           */
        }, {
          key: "_destroy",
          value: function _destroy() {
            this.close();
            this.$element.off('.zf.trigger .zf.offcanvas');
            this.$overlay.off('.zf.offcanvas');
            if (this.onLoadListener) jquery__WEBPACK_IMPORTED_MODULE_0___default()(window).off(this.onLoadListener);
          }
        }]);
        return OffCanvas;
      }(_foundation_core_plugin__WEBPACK_IMPORTED_MODULE_4__["Plugin"]);
      OffCanvas.defaults = {
        /**
         * Allow the user to click outside of the menu to close it.
         * @option
         * @type {boolean}
         * @default true
         */
        closeOnClick: true,
        /**
         * Adds an overlay on top of `[data-off-canvas-content]`.
         * @option
         * @type {boolean}
         * @default true
         */
        contentOverlay: true,
        /**
         * Target an off-canvas content container by ID that may be placed anywhere. If null the closest content container will be taken.
         * @option
         * @type {?string}
         * @default null
         */
        contentId: null,
        /**
         * Define the off-canvas element is nested in an off-canvas content. This is required when using the contentId option for a nested element.
         * @option
         * @type {boolean}
         * @default null
         */
        nested: null,
        /**
         * Enable/disable scrolling of the main content when an off canvas panel is open.
         * @option
         * @type {boolean}
         * @default true
         */
        contentScroll: true,
        /**
         * Amount of time in ms the open and close transition requires. If none selected, pulls from body style.
         * @option
         * @type {number}
         * @default null
         */
        transitionTime: null,
        /**
         * Type of transition for the offcanvas menu. Options are 'push', 'detached' or 'slide'.
         * @option
         * @type {string}
         * @default push
         */
        transition: 'push',
        /**
         * Force the page to scroll to top or bottom on open.
         * @option
         * @type {?string}
         * @default null
         */
        forceTo: null,
        /**
         * Allow the offcanvas to remain open for certain breakpoints.
         * @option
         * @type {boolean}
         * @default false
         */
        isRevealed: false,
        /**
         * Breakpoint at which to reveal. JS will use a RegExp to target standard classes, if changing classnames, pass your class with the `revealClass` option.
         * @option
         * @type {?string}
         * @default null
         */
        revealOn: null,
        /**
         * Force focus to the offcanvas on open. If true, will focus the opening trigger on close.
         * @option
         * @type {boolean}
         * @default true
         */
        autoFocus: true,
        /**
         * Class used to force an offcanvas to remain open. Foundation defaults for this are `reveal-for-large` & `reveal-for-medium`.
         * @option
         * @type {string}
         * @default reveal-for-
         * @todo improve the regex testing for this.
         */
        revealClass: 'reveal-for-',
        /**
         * Triggers optional focus trapping when opening an offcanvas. Sets tabindex of [data-off-canvas-content] to -1 for accessibility purposes.
         * @option
         * @type {boolean}
         * @default false
         */
        trapFocus: false
      };

      /***/
    }),
    /***/"./js/foundation.orbit.js": (
    /*!********************************!*\
      !*** ./js/foundation.orbit.js ***!
      \********************************/
    /*! exports provided: Orbit */
    /***/
    function _js_foundationOrbitJs(module, __webpack_exports__, __webpack_require__) {
      "use strict";

      __webpack_require__.r(__webpack_exports__);
      /* harmony export (binding) */
      __webpack_require__.d(__webpack_exports__, "Orbit", function () {
        return Orbit;
      });
      /* harmony import */
      var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! jquery */"jquery");
      /* harmony import */
      var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);
      /* harmony import */
      var _foundation_util_keyboard__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./foundation.util.keyboard */"./js/foundation.util.keyboard.js");
      /* harmony import */
      var _foundation_util_motion__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./foundation.util.motion */"./js/foundation.util.motion.js");
      /* harmony import */
      var _foundation_util_timer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./foundation.util.timer */"./js/foundation.util.timer.js");
      /* harmony import */
      var _foundation_util_imageLoader__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./foundation.util.imageLoader */"./js/foundation.util.imageLoader.js");
      /* harmony import */
      var _foundation_core_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./foundation.core.utils */"./js/foundation.core.utils.js");
      /* harmony import */
      var _foundation_core_plugin__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./foundation.core.plugin */"./js/foundation.core.plugin.js");
      /* harmony import */
      var _foundation_util_touch__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./foundation.util.touch */"./js/foundation.util.touch.js");
      function _typeof(obj) {
        if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
          _typeof = function _typeof(obj) {
            return _typeof2(obj);
          };
        } else {
          _typeof = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
          };
        }
        return _typeof(obj);
      }
      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }
      function _defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }
      function _createClass(Constructor, protoProps, staticProps) {
        if (protoProps) _defineProperties(Constructor.prototype, protoProps);
        if (staticProps) _defineProperties(Constructor, staticProps);
        return Constructor;
      }
      function _possibleConstructorReturn(self, call) {
        if (call && (_typeof(call) === "object" || typeof call === "function")) {
          return call;
        }
        return _assertThisInitialized(self);
      }
      function _assertThisInitialized(self) {
        if (self === void 0) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }
        return self;
      }
      function _getPrototypeOf(o) {
        _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
          return o.__proto__ || Object.getPrototypeOf(o);
        };
        return _getPrototypeOf(o);
      }
      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function");
        }
        subClass.prototype = Object.create(superClass && superClass.prototype, {
          constructor: {
            value: subClass,
            writable: true,
            configurable: true
          }
        });
        if (superClass) _setPrototypeOf(subClass, superClass);
      }
      function _setPrototypeOf(o, p) {
        _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
          o.__proto__ = p;
          return o;
        };
        return _setPrototypeOf(o, p);
      }

      /**
       * Orbit module.
       * @module foundation.orbit
       * @requires foundation.util.keyboard
       * @requires foundation.util.motion
       * @requires foundation.util.timer
       * @requires foundation.util.imageLoader
       * @requires foundation.util.touch
       */

      var Orbit = /*#__PURE__*/
      function (_Plugin) {
        _inherits(Orbit, _Plugin);
        function Orbit() {
          _classCallCheck(this, Orbit);
          return _possibleConstructorReturn(this, _getPrototypeOf(Orbit).apply(this, arguments));
        }
        _createClass(Orbit, [{
          key: "_setup",
          /**
          * Creates a new instance of an orbit carousel.
          * @class
          * @name Orbit
          * @param {jQuery} element - jQuery object to make into an Orbit Carousel.
          * @param {Object} options - Overrides to the default plugin settings.
          */
          value: function _setup(element, options) {
            this.$element = element;
            this.options = jquery__WEBPACK_IMPORTED_MODULE_0___default.a.extend({}, Orbit.defaults, this.$element.data(), options);
            this.className = 'Orbit'; // ie9 back compat

            _foundation_util_touch__WEBPACK_IMPORTED_MODULE_7__["Touch"].init(jquery__WEBPACK_IMPORTED_MODULE_0___default.a); // Touch init is idempotent, we just need to make sure it's initialied.

            this._init();
            _foundation_util_keyboard__WEBPACK_IMPORTED_MODULE_1__["Keyboard"].register('Orbit', {
              'ltr': {
                'ARROW_RIGHT': 'next',
                'ARROW_LEFT': 'previous'
              },
              'rtl': {
                'ARROW_LEFT': 'next',
                'ARROW_RIGHT': 'previous'
              }
            });
          }
          /**
          * Initializes the plugin by creating jQuery collections, setting attributes, and starting the animation.
          * @function
          * @private
          */
        }, {
          key: "_init",
          value: function _init() {
            // @TODO: consider discussion on PR #9278 about DOM pollution by changeSlide
            this._reset();
            this.$wrapper = this.$element.find(".".concat(this.options.containerClass));
            this.$slides = this.$element.find(".".concat(this.options.slideClass));
            var $images = this.$element.find('img'),
              initActive = this.$slides.filter('.is-active'),
              id = this.$element[0].id || Object(_foundation_core_utils__WEBPACK_IMPORTED_MODULE_5__["GetYoDigits"])(6, 'orbit');
            this.$element.attr({
              'data-resize': id,
              'id': id
            });
            if (!initActive.length) {
              this.$slides.eq(0).addClass('is-active');
            }
            if (!this.options.useMUI) {
              this.$slides.addClass('no-motionui');
            }
            if ($images.length) {
              Object(_foundation_util_imageLoader__WEBPACK_IMPORTED_MODULE_4__["onImagesLoaded"])($images, this._prepareForOrbit.bind(this));
            } else {
              this._prepareForOrbit(); //hehe
            }
            if (this.options.bullets) {
              this._loadBullets();
            }
            this._events();
            if (this.options.autoPlay && this.$slides.length > 1) {
              this.geoSync();
            }
            if (this.options.accessible) {
              // allow wrapper to be focusable to enable arrow navigation
              this.$wrapper.attr('tabindex', 0);
            }
          }
          /**
          * Creates a jQuery collection of bullets, if they are being used.
          * @function
          * @private
          */
        }, {
          key: "_loadBullets",
          value: function _loadBullets() {
            this.$bullets = this.$element.find(".".concat(this.options.boxOfBullets)).find('button');
          }
          /**
          * Sets a `timer` object on the orbit, and starts the counter for the next slide.
          * @function
          */
        }, {
          key: "geoSync",
          value: function geoSync() {
            var _this = this;
            this.timer = new _foundation_util_timer__WEBPACK_IMPORTED_MODULE_3__["Timer"](this.$element, {
              duration: this.options.timerDelay,
              infinite: false
            }, function () {
              _this.changeSlide(true);
            });
            this.timer.start();
          }
          /**
          * Sets wrapper and slide heights for the orbit.
          * @function
          * @private
          */
        }, {
          key: "_prepareForOrbit",
          value: function _prepareForOrbit() {
            var _this = this;
            this._setWrapperHeight();
          }
          /**
          * Calulates the height of each slide in the collection, and uses the tallest one for the wrapper height.
          * @function
          * @private
          * @param {Function} cb - a callback function to fire when complete.
          */
        }, {
          key: "_setWrapperHeight",
          value: function _setWrapperHeight(cb) {
            //rewrite this to `for` loop
            var max = 0,
              temp,
              counter = 0,
              _this = this;
            this.$slides.each(function () {
              temp = this.getBoundingClientRect().height;
              jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).attr('data-slide', counter); // hide all slides but the active one

              if (!/mui/g.test(jquery__WEBPACK_IMPORTED_MODULE_0___default()(this)[0].className) && _this.$slides.filter('.is-active')[0] !== _this.$slides.eq(counter)[0]) {
                jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).css({
                  'display': 'none'
                });
              }
              max = temp > max ? temp : max;
              counter++;
            });
            if (counter === this.$slides.length) {
              this.$wrapper.css({
                'height': max
              }); //only change the wrapper height property once.

              if (cb) {
                cb(max);
              } //fire callback with max height dimension.
            }
          }
          /**
          * Sets the max-height of each slide.
          * @function
          * @private
          */
        }, {
          key: "_setSlideHeight",
          value: function _setSlideHeight(height) {
            this.$slides.each(function () {
              jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).css('max-height', height);
            });
          }
          /**
          * Adds event listeners to basically everything within the element.
          * @function
          * @private
          */
        }, {
          key: "_events",
          value: function _events() {
            var _this = this; //***************************************
            //**Now using custom event - thanks to:**
            //**      Yohai Ararat of Toronto      **
            //***************************************
            //

            this.$element.off('.resizeme.zf.trigger').on({
              'resizeme.zf.trigger': this._prepareForOrbit.bind(this)
            });
            if (this.$slides.length > 1) {
              if (this.options.swipe) {
                this.$slides.off('swipeleft.zf.orbit swiperight.zf.orbit').on('swipeleft.zf.orbit', function (e) {
                  e.preventDefault();
                  _this.changeSlide(true);
                }).on('swiperight.zf.orbit', function (e) {
                  e.preventDefault();
                  _this.changeSlide(false);
                });
              } //***************************************

              if (this.options.autoPlay) {
                this.$slides.on('click.zf.orbit', function () {
                  _this.$element.data('clickedOn', _this.$element.data('clickedOn') ? false : true);
                  _this.timer[_this.$element.data('clickedOn') ? 'pause' : 'start']();
                });
                if (this.options.pauseOnHover) {
                  this.$element.on('mouseenter.zf.orbit', function () {
                    _this.timer.pause();
                  }).on('mouseleave.zf.orbit', function () {
                    if (!_this.$element.data('clickedOn')) {
                      _this.timer.start();
                    }
                  });
                }
              }
              if (this.options.navButtons) {
                var $controls = this.$element.find(".".concat(this.options.nextClass, ", .").concat(this.options.prevClass));
                $controls.attr('tabindex', 0) //also need to handle enter/return and spacebar key presses
                .on('click.zf.orbit touchend.zf.orbit', function (e) {
                  e.preventDefault();
                  _this.changeSlide(jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).hasClass(_this.options.nextClass));
                });
              }
              if (this.options.bullets) {
                this.$bullets.on('click.zf.orbit touchend.zf.orbit', function () {
                  if (/is-active/g.test(this.className)) {
                    return false;
                  } //if this is active, kick out of function.

                  var idx = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).data('slide'),
                    ltr = idx > _this.$slides.filter('.is-active').data('slide'),
                    $slide = _this.$slides.eq(idx);
                  _this.changeSlide(ltr, $slide, idx);
                });
              }
              if (this.options.accessible) {
                this.$wrapper.add(this.$bullets).on('keydown.zf.orbit', function (e) {
                  // handle keyboard event with keyboard util
                  _foundation_util_keyboard__WEBPACK_IMPORTED_MODULE_1__["Keyboard"].handleKey(e, 'Orbit', {
                    next: function next() {
                      _this.changeSlide(true);
                    },
                    previous: function previous() {
                      _this.changeSlide(false);
                    },
                    handled: function handled() {
                      // if bullet is focused, make sure focus moves
                      if (jquery__WEBPACK_IMPORTED_MODULE_0___default()(e.target).is(_this.$bullets)) {
                        _this.$bullets.filter('.is-active').focus();
                      }
                    }
                  });
                });
              }
            }
          }
          /**
           * Resets Orbit so it can be reinitialized
           */
        }, {
          key: "_reset",
          value: function _reset() {
            // Don't do anything if there are no slides (first run)
            if (typeof this.$slides == 'undefined') {
              return;
            }
            if (this.$slides.length > 1) {
              // Remove old events
              this.$element.off('.zf.orbit').find('*').off('.zf.orbit'); // Restart timer if autoPlay is enabled

              if (this.options.autoPlay) {
                this.timer.restart();
              } // Reset all sliddes

              this.$slides.each(function (el) {
                jquery__WEBPACK_IMPORTED_MODULE_0___default()(el).removeClass('is-active is-active is-in').removeAttr('aria-live').hide();
              }); // Show the first slide

              this.$slides.first().addClass('is-active').show(); // Triggers when the slide has finished animating

              this.$element.trigger('slidechange.zf.orbit', [this.$slides.first()]); // Select first bullet if bullets are present

              if (this.options.bullets) {
                this._updateBullets(0);
              }
            }
          }
          /**
          * Changes the current slide to a new one.
          * @function
          * @param {Boolean} isLTR - if true the slide moves from right to left, if false the slide moves from left to right.
          * @param {jQuery} chosenSlide - the jQuery element of the slide to show next, if one is selected.
          * @param {Number} idx - the index of the new slide in its collection, if one chosen.
          * @fires Orbit#slidechange
          */
        }, {
          key: "changeSlide",
          value: function changeSlide(isLTR, chosenSlide, idx) {
            if (!this.$slides) {
              return;
            } // Don't freak out if we're in the middle of cleanup

            var $curSlide = this.$slides.filter('.is-active').eq(0);
            if (/mui/g.test($curSlide[0].className)) {
              return false;
            } //if the slide is currently animating, kick out of the function

            var $firstSlide = this.$slides.first(),
              $lastSlide = this.$slides.last(),
              dirIn = isLTR ? 'Right' : 'Left',
              dirOut = isLTR ? 'Left' : 'Right',
              _this = this,
              $newSlide;
            if (!chosenSlide) {
              //most of the time, this will be auto played or clicked from the navButtons.
              $newSlide = isLTR ?
              //if wrapping enabled, check to see if there is a `next` or `prev` sibling, if not, select the first or last slide to fill in. if wrapping not enabled, attempt to select `next` or `prev`, if there's nothing there, the function will kick out on next step. CRAZY NESTED TERNARIES!!!!!
              this.options.infiniteWrap ? $curSlide.next(".".concat(this.options.slideClass)).length ? $curSlide.next(".".concat(this.options.slideClass)) : $firstSlide : $curSlide.next(".".concat(this.options.slideClass)) :
              //pick next slide if moving left to right
              this.options.infiniteWrap ? $curSlide.prev(".".concat(this.options.slideClass)).length ? $curSlide.prev(".".concat(this.options.slideClass)) : $lastSlide : $curSlide.prev(".".concat(this.options.slideClass)); //pick prev slide if moving right to left
            } else {
              $newSlide = chosenSlide;
            }
            if ($newSlide.length) {
              /**
              * Triggers before the next slide starts animating in and only if a next slide has been found.
              * @event Orbit#beforeslidechange
              */
              this.$element.trigger('beforeslidechange.zf.orbit', [$curSlide, $newSlide]);
              if (this.options.bullets) {
                idx = idx || this.$slides.index($newSlide); //grab index to update bullets

                this._updateBullets(idx);
              }
              if (this.options.useMUI && !this.$element.is(':hidden')) {
                _foundation_util_motion__WEBPACK_IMPORTED_MODULE_2__["Motion"].animateIn($newSlide.addClass('is-active'), this.options["animInFrom".concat(dirIn)], function () {
                  $newSlide.css({
                    'display': 'block'
                  }).attr('aria-live', 'polite');
                });
                _foundation_util_motion__WEBPACK_IMPORTED_MODULE_2__["Motion"].animateOut($curSlide.removeClass('is-active'), this.options["animOutTo".concat(dirOut)], function () {
                  $curSlide.removeAttr('aria-live');
                  if (_this.options.autoPlay && !_this.timer.isPaused) {
                    _this.timer.restart();
                  } //do stuff?
                });
              } else {
                $curSlide.removeClass('is-active is-in').removeAttr('aria-live').hide();
                $newSlide.addClass('is-active is-in').attr('aria-live', 'polite').show();
                if (this.options.autoPlay && !this.timer.isPaused) {
                  this.timer.restart();
                }
              }
              /**
              * Triggers when the slide has finished animating in.
              * @event Orbit#slidechange
              */

              this.$element.trigger('slidechange.zf.orbit', [$newSlide]);
            }
          }
          /**
          * Updates the active state of the bullets, if displayed.
          * @function
          * @private
          * @param {Number} idx - the index of the current slide.
          */
        }, {
          key: "_updateBullets",
          value: function _updateBullets(idx) {
            var $oldBullet = this.$element.find(".".concat(this.options.boxOfBullets)).find('.is-active').removeClass('is-active').blur(),
              span = $oldBullet.find('span:last').detach(),
              $newBullet = this.$bullets.eq(idx).addClass('is-active').append(span);
          }
          /**
          * Destroys the carousel and hides the element.
          * @function
          */
        }, {
          key: "_destroy",
          value: function _destroy() {
            this.$element.off('.zf.orbit').find('*').off('.zf.orbit').end().hide();
          }
        }]);
        return Orbit;
      }(_foundation_core_plugin__WEBPACK_IMPORTED_MODULE_6__["Plugin"]);
      Orbit.defaults = {
        /**
        * Tells the JS to look for and loadBullets.
        * @option
         * @type {boolean}
        * @default true
        */
        bullets: true,
        /**
        * Tells the JS to apply event listeners to nav buttons
        * @option
         * @type {boolean}
        * @default true
        */
        navButtons: true,
        /**
        * motion-ui animation class to apply
        * @option
         * @type {string}
        * @default 'slide-in-right'
        */
        animInFromRight: 'slide-in-right',
        /**
        * motion-ui animation class to apply
        * @option
         * @type {string}
        * @default 'slide-out-right'
        */
        animOutToRight: 'slide-out-right',
        /**
        * motion-ui animation class to apply
        * @option
         * @type {string}
        * @default 'slide-in-left'
        *
        */
        animInFromLeft: 'slide-in-left',
        /**
        * motion-ui animation class to apply
        * @option
         * @type {string}
        * @default 'slide-out-left'
        */
        animOutToLeft: 'slide-out-left',
        /**
        * Allows Orbit to automatically animate on page load.
        * @option
         * @type {boolean}
        * @default true
        */
        autoPlay: true,
        /**
        * Amount of time, in ms, between slide transitions
        * @option
         * @type {number}
        * @default 5000
        */
        timerDelay: 5000,
        /**
        * Allows Orbit to infinitely loop through the slides
        * @option
         * @type {boolean}
        * @default true
        */
        infiniteWrap: true,
        /**
        * Allows the Orbit slides to bind to swipe events for mobile, requires an additional util library
        * @option
         * @type {boolean}
        * @default true
        */
        swipe: true,
        /**
        * Allows the timing function to pause animation on hover.
        * @option
         * @type {boolean}
        * @default true
        */
        pauseOnHover: true,
        /**
        * Allows Orbit to bind keyboard events to the slider, to animate frames with arrow keys
        * @option
         * @type {boolean}
        * @default true
        */
        accessible: true,
        /**
        * Class applied to the container of Orbit
        * @option
         * @type {string}
        * @default 'orbit-container'
        */
        containerClass: 'orbit-container',
        /**
        * Class applied to individual slides.
        * @option
         * @type {string}
        * @default 'orbit-slide'
        */
        slideClass: 'orbit-slide',
        /**
        * Class applied to the bullet container. You're welcome.
        * @option
         * @type {string}
        * @default 'orbit-bullets'
        */
        boxOfBullets: 'orbit-bullets',
        /**
        * Class applied to the `next` navigation button.
        * @option
         * @type {string}
        * @default 'orbit-next'
        */
        nextClass: 'orbit-next',
        /**
        * Class applied to the `previous` navigation button.
        * @option
         * @type {string}
        * @default 'orbit-previous'
        */
        prevClass: 'orbit-previous',
        /**
        * Boolean to flag the js to use motion ui classes or not. Default to true for backwards compatibility.
        * @option
         * @type {boolean}
        * @default true
        */
        useMUI: true
      };

      /***/
    }),
    /***/"./js/foundation.positionable.js": (
    /*!***************************************!*\
      !*** ./js/foundation.positionable.js ***!
      \***************************************/
    /*! exports provided: Positionable */
    /***/
    function _js_foundationPositionableJs(module, __webpack_exports__, __webpack_require__) {
      "use strict";

      __webpack_require__.r(__webpack_exports__);
      /* harmony export (binding) */
      __webpack_require__.d(__webpack_exports__, "Positionable", function () {
        return Positionable;
      });
      /* harmony import */
      var _foundation_util_box__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./foundation.util.box */"./js/foundation.util.box.js");
      /* harmony import */
      var _foundation_core_plugin__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./foundation.core.plugin */"./js/foundation.core.plugin.js");
      /* harmony import */
      var _foundation_core_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./foundation.core.utils */"./js/foundation.core.utils.js");
      function _typeof(obj) {
        if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
          _typeof = function _typeof(obj) {
            return _typeof2(obj);
          };
        } else {
          _typeof = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
          };
        }
        return _typeof(obj);
      }
      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }
      function _defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }
      function _createClass(Constructor, protoProps, staticProps) {
        if (protoProps) _defineProperties(Constructor.prototype, protoProps);
        if (staticProps) _defineProperties(Constructor, staticProps);
        return Constructor;
      }
      function _possibleConstructorReturn(self, call) {
        if (call && (_typeof(call) === "object" || typeof call === "function")) {
          return call;
        }
        return _assertThisInitialized(self);
      }
      function _assertThisInitialized(self) {
        if (self === void 0) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }
        return self;
      }
      function _getPrototypeOf(o) {
        _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
          return o.__proto__ || Object.getPrototypeOf(o);
        };
        return _getPrototypeOf(o);
      }
      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function");
        }
        subClass.prototype = Object.create(superClass && superClass.prototype, {
          constructor: {
            value: subClass,
            writable: true,
            configurable: true
          }
        });
        if (superClass) _setPrototypeOf(subClass, superClass);
      }
      function _setPrototypeOf(o, p) {
        _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
          o.__proto__ = p;
          return o;
        };
        return _setPrototypeOf(o, p);
      }
      var POSITIONS = ['left', 'right', 'top', 'bottom'];
      var VERTICAL_ALIGNMENTS = ['top', 'bottom', 'center'];
      var HORIZONTAL_ALIGNMENTS = ['left', 'right', 'center'];
      var ALIGNMENTS = {
        'left': VERTICAL_ALIGNMENTS,
        'right': VERTICAL_ALIGNMENTS,
        'top': HORIZONTAL_ALIGNMENTS,
        'bottom': HORIZONTAL_ALIGNMENTS
      };
      function nextItem(item, array) {
        var currentIdx = array.indexOf(item);
        if (currentIdx === array.length - 1) {
          return array[0];
        } else {
          return array[currentIdx + 1];
        }
      }
      var Positionable = /*#__PURE__*/
      function (_Plugin) {
        _inherits(Positionable, _Plugin);
        function Positionable() {
          _classCallCheck(this, Positionable);
          return _possibleConstructorReturn(this, _getPrototypeOf(Positionable).apply(this, arguments));
        }
        _createClass(Positionable, [{
          key: "_init",
          /**
           * Abstract class encapsulating the tether-like explicit positioning logic
           * including repositioning based on overlap.
           * Expects classes to define defaults for vOffset, hOffset, position,
           * alignment, allowOverlap, and allowBottomOverlap. They can do this by
           * extending the defaults, or (for now recommended due to the way docs are
           * generated) by explicitly declaring them.
           *
           **/
          value: function _init() {
            this.triedPositions = {};
            this.position = this.options.position === 'auto' ? this._getDefaultPosition() : this.options.position;
            this.alignment = this.options.alignment === 'auto' ? this._getDefaultAlignment() : this.options.alignment;
            this.originalPosition = this.position;
            this.originalAlignment = this.alignment;
          }
        }, {
          key: "_getDefaultPosition",
          value: function _getDefaultPosition() {
            return 'bottom';
          }
        }, {
          key: "_getDefaultAlignment",
          value: function _getDefaultAlignment() {
            switch (this.position) {
              case 'bottom':
              case 'top':
                return Object(_foundation_core_utils__WEBPACK_IMPORTED_MODULE_2__["rtl"])() ? 'right' : 'left';
              case 'left':
              case 'right':
                return 'bottom';
            }
          }
          /**
           * Adjusts the positionable possible positions by iterating through alignments
           * and positions.
           * @function
           * @private
           */
        }, {
          key: "_reposition",
          value: function _reposition() {
            if (this._alignmentsExhausted(this.position)) {
              this.position = nextItem(this.position, POSITIONS);
              this.alignment = ALIGNMENTS[this.position][0];
            } else {
              this._realign();
            }
          }
          /**
           * Adjusts the dropdown pane possible positions by iterating through alignments
           * on the current position.
           * @function
           * @private
           */
        }, {
          key: "_realign",
          value: function _realign() {
            this._addTriedPosition(this.position, this.alignment);
            this.alignment = nextItem(this.alignment, ALIGNMENTS[this.position]);
          }
        }, {
          key: "_addTriedPosition",
          value: function _addTriedPosition(position, alignment) {
            this.triedPositions[position] = this.triedPositions[position] || [];
            this.triedPositions[position].push(alignment);
          }
        }, {
          key: "_positionsExhausted",
          value: function _positionsExhausted() {
            var isExhausted = true;
            for (var i = 0; i < POSITIONS.length; i++) {
              isExhausted = isExhausted && this._alignmentsExhausted(POSITIONS[i]);
            }
            return isExhausted;
          }
        }, {
          key: "_alignmentsExhausted",
          value: function _alignmentsExhausted(position) {
            return this.triedPositions[position] && this.triedPositions[position].length == ALIGNMENTS[position].length;
          } // When we're trying to center, we don't want to apply offset that's going to
          // take us just off center, so wrap around to return 0 for the appropriate
          // offset in those alignments.  TODO: Figure out if we want to make this
          // configurable behavior... it feels more intuitive, especially for tooltips, but
          // it's possible someone might actually want to start from center and then nudge
          // slightly off.
        }, {
          key: "_getVOffset",
          value: function _getVOffset() {
            return this.options.vOffset;
          }
        }, {
          key: "_getHOffset",
          value: function _getHOffset() {
            return this.options.hOffset;
          }
        }, {
          key: "_setPosition",
          value: function _setPosition($anchor, $element, $parent) {
            if ($anchor.attr('aria-expanded') === 'false') {
              return false;
            }
            var $eleDims = _foundation_util_box__WEBPACK_IMPORTED_MODULE_0__["Box"].GetDimensions($element),
              $anchorDims = _foundation_util_box__WEBPACK_IMPORTED_MODULE_0__["Box"].GetDimensions($anchor);
            if (!this.options.allowOverlap) {
              // restore original position & alignment before checking overlap
              this.position = this.originalPosition;
              this.alignment = this.originalAlignment;
            }
            $element.offset(_foundation_util_box__WEBPACK_IMPORTED_MODULE_0__["Box"].GetExplicitOffsets($element, $anchor, this.position, this.alignment, this._getVOffset(), this._getHOffset()));
            if (!this.options.allowOverlap) {
              var overlaps = {};
              var minOverlap = 100000000; // default coordinates to how we start, in case we can't figure out better

              var minCoordinates = {
                position: this.position,
                alignment: this.alignment
              };
              while (!this._positionsExhausted()) {
                var overlap = _foundation_util_box__WEBPACK_IMPORTED_MODULE_0__["Box"].OverlapArea($element, $parent, false, false, this.options.allowBottomOverlap);
                if (overlap === 0) {
                  return;
                }
                if (overlap < minOverlap) {
                  minOverlap = overlap;
                  minCoordinates = {
                    position: this.position,
                    alignment: this.alignment
                  };
                }
                this._reposition();
                $element.offset(_foundation_util_box__WEBPACK_IMPORTED_MODULE_0__["Box"].GetExplicitOffsets($element, $anchor, this.position, this.alignment, this._getVOffset(), this._getHOffset()));
              } // If we get through the entire loop, there was no non-overlapping
              // position available. Pick the version with least overlap.

              this.position = minCoordinates.position;
              this.alignment = minCoordinates.alignment;
              $element.offset(_foundation_util_box__WEBPACK_IMPORTED_MODULE_0__["Box"].GetExplicitOffsets($element, $anchor, this.position, this.alignment, this._getVOffset(), this._getHOffset()));
            }
          }
        }]);
        return Positionable;
      }(_foundation_core_plugin__WEBPACK_IMPORTED_MODULE_1__["Plugin"]);
      Positionable.defaults = {
        /**
         * Position of positionable relative to anchor. Can be left, right, bottom, top, or auto.
         * @option
         * @type {string}
         * @default 'auto'
         */
        position: 'auto',
        /**
         * Alignment of positionable relative to anchor. Can be left, right, bottom, top, center, or auto.
         * @option
         * @type {string}
         * @default 'auto'
         */
        alignment: 'auto',
        /**
         * Allow overlap of container/window. If false, dropdown positionable first
         * try to position as defined by data-position and data-alignment, but
         * reposition if it would cause an overflow.
         * @option
         * @type {boolean}
         * @default false
         */
        allowOverlap: false,
        /**
         * Allow overlap of only the bottom of the container. This is the most common
         * behavior for dropdowns, allowing the dropdown to extend the bottom of the
         * screen but not otherwise influence or break out of the container.
         * @option
         * @type {boolean}
         * @default true
         */
        allowBottomOverlap: true,
        /**
         * Number of pixels the positionable should be separated vertically from anchor
         * @option
         * @type {number}
         * @default 0
         */
        vOffset: 0,
        /**
         * Number of pixels the positionable should be separated horizontally from anchor
         * @option
         * @type {number}
         * @default 0
         */
        hOffset: 0
      };

      /***/
    }),
    /***/"./js/foundation.responsiveAccordionTabs.js": (
    /*!**************************************************!*\
      !*** ./js/foundation.responsiveAccordionTabs.js ***!
      \**************************************************/
    /*! exports provided: ResponsiveAccordionTabs */
    /***/
    function _js_foundationResponsiveAccordionTabsJs(module, __webpack_exports__, __webpack_require__) {
      "use strict";

      __webpack_require__.r(__webpack_exports__);
      /* harmony export (binding) */
      __webpack_require__.d(__webpack_exports__, "ResponsiveAccordionTabs", function () {
        return ResponsiveAccordionTabs;
      });
      /* harmony import */
      var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! jquery */"jquery");
      /* harmony import */
      var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);
      /* harmony import */
      var _foundation_util_mediaQuery__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./foundation.util.mediaQuery */"./js/foundation.util.mediaQuery.js");
      /* harmony import */
      var _foundation_core_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./foundation.core.utils */"./js/foundation.core.utils.js");
      /* harmony import */
      var _foundation_core_plugin__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./foundation.core.plugin */"./js/foundation.core.plugin.js");
      /* harmony import */
      var _foundation_accordion__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./foundation.accordion */"./js/foundation.accordion.js");
      /* harmony import */
      var _foundation_tabs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./foundation.tabs */"./js/foundation.tabs.js");
      function _typeof(obj) {
        if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
          _typeof = function _typeof(obj) {
            return _typeof2(obj);
          };
        } else {
          _typeof = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
          };
        }
        return _typeof(obj);
      }
      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }
      function _defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }
      function _createClass(Constructor, protoProps, staticProps) {
        if (protoProps) _defineProperties(Constructor.prototype, protoProps);
        if (staticProps) _defineProperties(Constructor, staticProps);
        return Constructor;
      }
      function _possibleConstructorReturn(self, call) {
        if (call && (_typeof(call) === "object" || typeof call === "function")) {
          return call;
        }
        return _assertThisInitialized(self);
      }
      function _assertThisInitialized(self) {
        if (self === void 0) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }
        return self;
      }
      function _getPrototypeOf(o) {
        _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
          return o.__proto__ || Object.getPrototypeOf(o);
        };
        return _getPrototypeOf(o);
      }
      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function");
        }
        subClass.prototype = Object.create(superClass && superClass.prototype, {
          constructor: {
            value: subClass,
            writable: true,
            configurable: true
          }
        });
        if (superClass) _setPrototypeOf(subClass, superClass);
      }
      function _setPrototypeOf(o, p) {
        _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
          o.__proto__ = p;
          return o;
        };
        return _setPrototypeOf(o, p);
      }

      // The plugin matches the plugin classes with these plugin instances.

      var MenuPlugins = {
        tabs: {
          cssClass: 'tabs',
          plugin: _foundation_tabs__WEBPACK_IMPORTED_MODULE_5__["Tabs"]
        },
        accordion: {
          cssClass: 'accordion',
          plugin: _foundation_accordion__WEBPACK_IMPORTED_MODULE_4__["Accordion"]
        }
      };
      /**
       * ResponsiveAccordionTabs module.
       * @module foundation.responsiveAccordionTabs
       * @requires foundation.util.motion
       * @requires foundation.accordion
       * @requires foundation.tabs
       */

      var ResponsiveAccordionTabs = /*#__PURE__*/
      function (_Plugin) {
        _inherits(ResponsiveAccordionTabs, _Plugin);
        function ResponsiveAccordionTabs() {
          _classCallCheck(this, ResponsiveAccordionTabs);
          return _possibleConstructorReturn(this, _getPrototypeOf(ResponsiveAccordionTabs).apply(this, arguments));
        }
        _createClass(ResponsiveAccordionTabs, [{
          key: "_setup",
          /**
           * Creates a new instance of a responsive accordion tabs.
           * @class
           * @name ResponsiveAccordionTabs
           * @fires ResponsiveAccordionTabs#init
           * @param {jQuery} element - jQuery object to make into Responsive Accordion Tabs.
           * @param {Object} options - Overrides to the default plugin settings.
           */
          value: function _setup(element, options) {
            this.$element = jquery__WEBPACK_IMPORTED_MODULE_0___default()(element);
            this.options = jquery__WEBPACK_IMPORTED_MODULE_0___default.a.extend({}, this.$element.data(), options);
            this.rules = this.$element.data('responsive-accordion-tabs');
            this.currentMq = null;
            this.currentPlugin = null;
            this.className = 'ResponsiveAccordionTabs'; // ie9 back compat

            if (!this.$element.attr('id')) {
              this.$element.attr('id', Object(_foundation_core_utils__WEBPACK_IMPORTED_MODULE_2__["GetYoDigits"])(6, 'responsiveaccordiontabs'));
            }
            ;
            this._init();
            this._events();
          }
          /**
           * Initializes the Menu by parsing the classes from the 'data-responsive-accordion-tabs' attribute on the element.
           * @function
           * @private
           */
        }, {
          key: "_init",
          value: function _init() {
            _foundation_util_mediaQuery__WEBPACK_IMPORTED_MODULE_1__["MediaQuery"]._init(); // The first time an Interchange plugin is initialized, this.rules is converted from a string of "classes" to an object of rules

            if (typeof this.rules === 'string') {
              var rulesTree = {}; // Parse rules from "classes" pulled from data attribute

              var rules = this.rules.split(' '); // Iterate through every rule found

              for (var i = 0; i < rules.length; i++) {
                var rule = rules[i].split('-');
                var ruleSize = rule.length > 1 ? rule[0] : 'small';
                var rulePlugin = rule.length > 1 ? rule[1] : rule[0];
                if (MenuPlugins[rulePlugin] !== null) {
                  rulesTree[ruleSize] = MenuPlugins[rulePlugin];
                }
              }
              this.rules = rulesTree;
            }
            this._getAllOptions();
            if (!jquery__WEBPACK_IMPORTED_MODULE_0___default.a.isEmptyObject(this.rules)) {
              this._checkMediaQueries();
            }
          }
        }, {
          key: "_getAllOptions",
          value: function _getAllOptions() {
            //get all defaults and options
            var _this = this;
            _this.allOptions = {};
            for (var key in MenuPlugins) {
              if (MenuPlugins.hasOwnProperty(key)) {
                var obj = MenuPlugins[key];
                try {
                  var dummyPlugin = jquery__WEBPACK_IMPORTED_MODULE_0___default()('<ul></ul>');
                  var tmpPlugin = new obj.plugin(dummyPlugin, _this.options);
                  for (var keyKey in tmpPlugin.options) {
                    if (tmpPlugin.options.hasOwnProperty(keyKey) && keyKey !== 'zfPlugin') {
                      var objObj = tmpPlugin.options[keyKey];
                      _this.allOptions[keyKey] = objObj;
                    }
                  }
                  tmpPlugin.destroy();
                } catch (e) {}
              }
            }
          }
          /**
           * Initializes events for the Menu.
           * @function
           * @private
           */
        }, {
          key: "_events",
          value: function _events() {
            this._changedZfMediaQueryHandler = this._checkMediaQueries.bind(this);
            jquery__WEBPACK_IMPORTED_MODULE_0___default()(window).on('changed.zf.mediaquery', this._changedZfMediaQueryHandler);
          }
          /**
           * Checks the current screen width against available media queries. If the media query has changed, and the plugin needed has changed, the plugins will swap out.
           * @function
           * @private
           */
        }, {
          key: "_checkMediaQueries",
          value: function _checkMediaQueries() {
            var matchedMq,
              _this = this; // Iterate through each rule and find the last matching rule

            jquery__WEBPACK_IMPORTED_MODULE_0___default.a.each(this.rules, function (key) {
              if (_foundation_util_mediaQuery__WEBPACK_IMPORTED_MODULE_1__["MediaQuery"].atLeast(key)) {
                matchedMq = key;
              }
            }); // No match? No dice

            if (!matchedMq) return; // Plugin already initialized? We good

            if (this.currentPlugin instanceof this.rules[matchedMq].plugin) return; // Remove existing plugin-specific CSS classes

            jquery__WEBPACK_IMPORTED_MODULE_0___default.a.each(MenuPlugins, function (key, value) {
              _this.$element.removeClass(value.cssClass);
            }); // Add the CSS class for the new plugin

            this.$element.addClass(this.rules[matchedMq].cssClass); // Create an instance of the new plugin

            if (this.currentPlugin) {
              //don't know why but on nested elements data zfPlugin get's lost
              if (!this.currentPlugin.$element.data('zfPlugin') && this.storezfData) this.currentPlugin.$element.data('zfPlugin', this.storezfData);
              this.currentPlugin.destroy();
            }
            this._handleMarkup(this.rules[matchedMq].cssClass);
            this.currentPlugin = new this.rules[matchedMq].plugin(this.$element, {});
            this.storezfData = this.currentPlugin.$element.data('zfPlugin');
          }
        }, {
          key: "_handleMarkup",
          value: function _handleMarkup(toSet) {
            var _this = this,
              fromString = 'accordion';
            var $panels = jquery__WEBPACK_IMPORTED_MODULE_0___default()('[data-tabs-content=' + this.$element.attr('id') + ']');
            if ($panels.length) fromString = 'tabs';
            if (fromString === toSet) {
              return;
            }
            ;
            var tabsTitle = _this.allOptions.linkClass ? _this.allOptions.linkClass : 'tabs-title';
            var tabsPanel = _this.allOptions.panelClass ? _this.allOptions.panelClass : 'tabs-panel';
            this.$element.removeAttr('role');
            var $liHeads = this.$element.children('.' + tabsTitle + ',[data-accordion-item]').removeClass(tabsTitle).removeClass('accordion-item').removeAttr('data-accordion-item');
            var $liHeadsA = $liHeads.children('a').removeClass('accordion-title');
            if (fromString === 'tabs') {
              $panels = $panels.children('.' + tabsPanel).removeClass(tabsPanel).removeAttr('role').removeAttr('aria-hidden').removeAttr('aria-labelledby');
              $panels.children('a').removeAttr('role').removeAttr('aria-controls').removeAttr('aria-selected');
            } else {
              $panels = $liHeads.children('[data-tab-content]').removeClass('accordion-content');
            }
            ;
            $panels.css({
              display: '',
              visibility: ''
            });
            $liHeads.css({
              display: '',
              visibility: ''
            });
            if (toSet === 'accordion') {
              $panels.each(function (key, value) {
                jquery__WEBPACK_IMPORTED_MODULE_0___default()(value).appendTo($liHeads.get(key)).addClass('accordion-content').attr('data-tab-content', '').removeClass('is-active').css({
                  height: ''
                });
                jquery__WEBPACK_IMPORTED_MODULE_0___default()('[data-tabs-content=' + _this.$element.attr('id') + ']').after('<div id="tabs-placeholder-' + _this.$element.attr('id') + '"></div>').detach();
                $liHeads.addClass('accordion-item').attr('data-accordion-item', '');
                $liHeadsA.addClass('accordion-title');
              });
            } else if (toSet === 'tabs') {
              var $tabsContent = jquery__WEBPACK_IMPORTED_MODULE_0___default()('[data-tabs-content=' + _this.$element.attr('id') + ']');
              var $placeholder = jquery__WEBPACK_IMPORTED_MODULE_0___default()('#tabs-placeholder-' + _this.$element.attr('id'));
              if ($placeholder.length) {
                $tabsContent = jquery__WEBPACK_IMPORTED_MODULE_0___default()('<div class="tabs-content"></div>').insertAfter($placeholder).attr('data-tabs-content', _this.$element.attr('id'));
                $placeholder.remove();
              } else {
                $tabsContent = jquery__WEBPACK_IMPORTED_MODULE_0___default()('<div class="tabs-content"></div>').insertAfter(_this.$element).attr('data-tabs-content', _this.$element.attr('id'));
              }
              ;
              $panels.each(function (key, value) {
                var tempValue = jquery__WEBPACK_IMPORTED_MODULE_0___default()(value).appendTo($tabsContent).addClass(tabsPanel);
                var hash = $liHeadsA.get(key).hash.slice(1);
                var id = jquery__WEBPACK_IMPORTED_MODULE_0___default()(value).attr('id') || Object(_foundation_core_utils__WEBPACK_IMPORTED_MODULE_2__["GetYoDigits"])(6, 'accordion');
                if (hash !== id) {
                  if (hash !== '') {
                    jquery__WEBPACK_IMPORTED_MODULE_0___default()(value).attr('id', hash);
                  } else {
                    hash = id;
                    jquery__WEBPACK_IMPORTED_MODULE_0___default()(value).attr('id', hash);
                    jquery__WEBPACK_IMPORTED_MODULE_0___default()($liHeadsA.get(key)).attr('href', jquery__WEBPACK_IMPORTED_MODULE_0___default()($liHeadsA.get(key)).attr('href').replace('#', '') + '#' + hash);
                  }
                  ;
                }
                ;
                var isActive = jquery__WEBPACK_IMPORTED_MODULE_0___default()($liHeads.get(key)).hasClass('is-active');
                if (isActive) {
                  tempValue.addClass('is-active');
                }
                ;
              });
              $liHeads.addClass(tabsTitle);
            }
            ;
          }
          /**
           * Destroys the instance of the current plugin on this element, as well as the window resize handler that switches the plugins out.
           * @function
           */
        }, {
          key: "_destroy",
          value: function _destroy() {
            if (this.currentPlugin) this.currentPlugin.destroy();
            jquery__WEBPACK_IMPORTED_MODULE_0___default()(window).off('changed.zf.mediaquery', this._changedZfMediaQueryHandler);
          }
        }]);
        return ResponsiveAccordionTabs;
      }(_foundation_core_plugin__WEBPACK_IMPORTED_MODULE_3__["Plugin"]);
      ResponsiveAccordionTabs.defaults = {};

      /***/
    }),
    /***/"./js/foundation.responsiveMenu.js": (
    /*!*****************************************!*\
      !*** ./js/foundation.responsiveMenu.js ***!
      \*****************************************/
    /*! exports provided: ResponsiveMenu */
    /***/
    function _js_foundationResponsiveMenuJs(module, __webpack_exports__, __webpack_require__) {
      "use strict";

      __webpack_require__.r(__webpack_exports__);
      /* harmony export (binding) */
      __webpack_require__.d(__webpack_exports__, "ResponsiveMenu", function () {
        return ResponsiveMenu;
      });
      /* harmony import */
      var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! jquery */"jquery");
      /* harmony import */
      var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);
      /* harmony import */
      var _foundation_util_mediaQuery__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./foundation.util.mediaQuery */"./js/foundation.util.mediaQuery.js");
      /* harmony import */
      var _foundation_core_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./foundation.core.utils */"./js/foundation.core.utils.js");
      /* harmony import */
      var _foundation_core_plugin__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./foundation.core.plugin */"./js/foundation.core.plugin.js");
      /* harmony import */
      var _foundation_dropdownMenu__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./foundation.dropdownMenu */"./js/foundation.dropdownMenu.js");
      /* harmony import */
      var _foundation_drilldown__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./foundation.drilldown */"./js/foundation.drilldown.js");
      /* harmony import */
      var _foundation_accordionMenu__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./foundation.accordionMenu */"./js/foundation.accordionMenu.js");
      function _typeof(obj) {
        if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
          _typeof = function _typeof(obj) {
            return _typeof2(obj);
          };
        } else {
          _typeof = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
          };
        }
        return _typeof(obj);
      }
      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }
      function _defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }
      function _createClass(Constructor, protoProps, staticProps) {
        if (protoProps) _defineProperties(Constructor.prototype, protoProps);
        if (staticProps) _defineProperties(Constructor, staticProps);
        return Constructor;
      }
      function _possibleConstructorReturn(self, call) {
        if (call && (_typeof(call) === "object" || typeof call === "function")) {
          return call;
        }
        return _assertThisInitialized(self);
      }
      function _assertThisInitialized(self) {
        if (self === void 0) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }
        return self;
      }
      function _getPrototypeOf(o) {
        _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
          return o.__proto__ || Object.getPrototypeOf(o);
        };
        return _getPrototypeOf(o);
      }
      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function");
        }
        subClass.prototype = Object.create(superClass && superClass.prototype, {
          constructor: {
            value: subClass,
            writable: true,
            configurable: true
          }
        });
        if (superClass) _setPrototypeOf(subClass, superClass);
      }
      function _setPrototypeOf(o, p) {
        _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
          o.__proto__ = p;
          return o;
        };
        return _setPrototypeOf(o, p);
      }
      var MenuPlugins = {
        dropdown: {
          cssClass: 'dropdown',
          plugin: _foundation_dropdownMenu__WEBPACK_IMPORTED_MODULE_4__["DropdownMenu"]
        },
        drilldown: {
          cssClass: 'drilldown',
          plugin: _foundation_drilldown__WEBPACK_IMPORTED_MODULE_5__["Drilldown"]
        },
        accordion: {
          cssClass: 'accordion-menu',
          plugin: _foundation_accordionMenu__WEBPACK_IMPORTED_MODULE_6__["AccordionMenu"]
        }
      }; // import "foundation.util.triggers.js";

      /**
       * ResponsiveMenu module.
       * @module foundation.responsiveMenu
       * @requires foundation.util.triggers
       * @requires foundation.util.mediaQuery
       */

      var ResponsiveMenu = /*#__PURE__*/
      function (_Plugin) {
        _inherits(ResponsiveMenu, _Plugin);
        function ResponsiveMenu() {
          _classCallCheck(this, ResponsiveMenu);
          return _possibleConstructorReturn(this, _getPrototypeOf(ResponsiveMenu).apply(this, arguments));
        }
        _createClass(ResponsiveMenu, [{
          key: "_setup",
          /**
           * Creates a new instance of a responsive menu.
           * @class
           * @name ResponsiveMenu
           * @fires ResponsiveMenu#init
           * @param {jQuery} element - jQuery object to make into a dropdown menu.
           * @param {Object} options - Overrides to the default plugin settings.
           */
          value: function _setup(element, options) {
            this.$element = jquery__WEBPACK_IMPORTED_MODULE_0___default()(element);
            this.rules = this.$element.data('responsive-menu');
            this.currentMq = null;
            this.currentPlugin = null;
            this.className = 'ResponsiveMenu'; // ie9 back compat

            this._init();
            this._events();
          }
          /**
           * Initializes the Menu by parsing the classes from the 'data-ResponsiveMenu' attribute on the element.
           * @function
           * @private
           */
        }, {
          key: "_init",
          value: function _init() {
            _foundation_util_mediaQuery__WEBPACK_IMPORTED_MODULE_1__["MediaQuery"]._init(); // The first time an Interchange plugin is initialized, this.rules is converted from a string of "classes" to an object of rules

            if (typeof this.rules === 'string') {
              var rulesTree = {}; // Parse rules from "classes" pulled from data attribute

              var rules = this.rules.split(' '); // Iterate through every rule found

              for (var i = 0; i < rules.length; i++) {
                var rule = rules[i].split('-');
                var ruleSize = rule.length > 1 ? rule[0] : 'small';
                var rulePlugin = rule.length > 1 ? rule[1] : rule[0];
                if (MenuPlugins[rulePlugin] !== null) {
                  rulesTree[ruleSize] = MenuPlugins[rulePlugin];
                }
              }
              this.rules = rulesTree;
            }
            if (!jquery__WEBPACK_IMPORTED_MODULE_0___default.a.isEmptyObject(this.rules)) {
              this._checkMediaQueries();
            } // Add data-mutate since children may need it.

            this.$element.attr('data-mutate', this.$element.attr('data-mutate') || Object(_foundation_core_utils__WEBPACK_IMPORTED_MODULE_2__["GetYoDigits"])(6, 'responsive-menu'));
          }
          /**
           * Initializes events for the Menu.
           * @function
           * @private
           */
        }, {
          key: "_events",
          value: function _events() {
            var _this = this;
            jquery__WEBPACK_IMPORTED_MODULE_0___default()(window).on('changed.zf.mediaquery', function () {
              _this._checkMediaQueries();
            }); // $(window).on('resize.zf.ResponsiveMenu', function() {
            //   _this._checkMediaQueries();
            // });
          }
          /**
           * Checks the current screen width against available media queries. If the media query has changed, and the plugin needed has changed, the plugins will swap out.
           * @function
           * @private
           */
        }, {
          key: "_checkMediaQueries",
          value: function _checkMediaQueries() {
            var matchedMq,
              _this = this; // Iterate through each rule and find the last matching rule

            jquery__WEBPACK_IMPORTED_MODULE_0___default.a.each(this.rules, function (key) {
              if (_foundation_util_mediaQuery__WEBPACK_IMPORTED_MODULE_1__["MediaQuery"].atLeast(key)) {
                matchedMq = key;
              }
            }); // No match? No dice

            if (!matchedMq) return; // Plugin already initialized? We good

            if (this.currentPlugin instanceof this.rules[matchedMq].plugin) return; // Remove existing plugin-specific CSS classes

            jquery__WEBPACK_IMPORTED_MODULE_0___default.a.each(MenuPlugins, function (key, value) {
              _this.$element.removeClass(value.cssClass);
            }); // Add the CSS class for the new plugin

            this.$element.addClass(this.rules[matchedMq].cssClass); // Create an instance of the new plugin

            if (this.currentPlugin) this.currentPlugin.destroy();
            this.currentPlugin = new this.rules[matchedMq].plugin(this.$element, {});
          }
          /**
           * Destroys the instance of the current plugin on this element, as well as the window resize handler that switches the plugins out.
           * @function
           */
        }, {
          key: "_destroy",
          value: function _destroy() {
            this.currentPlugin.destroy();
            jquery__WEBPACK_IMPORTED_MODULE_0___default()(window).off('.zf.ResponsiveMenu');
          }
        }]);
        return ResponsiveMenu;
      }(_foundation_core_plugin__WEBPACK_IMPORTED_MODULE_3__["Plugin"]);
      ResponsiveMenu.defaults = {};

      /***/
    }),
    /***/"./js/foundation.responsiveToggle.js": (
    /*!*******************************************!*\
      !*** ./js/foundation.responsiveToggle.js ***!
      \*******************************************/
    /*! exports provided: ResponsiveToggle */
    /***/
    function _js_foundationResponsiveToggleJs(module, __webpack_exports__, __webpack_require__) {
      "use strict";

      __webpack_require__.r(__webpack_exports__);
      /* harmony export (binding) */
      __webpack_require__.d(__webpack_exports__, "ResponsiveToggle", function () {
        return ResponsiveToggle;
      });
      /* harmony import */
      var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! jquery */"jquery");
      /* harmony import */
      var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);
      /* harmony import */
      var _foundation_util_mediaQuery__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./foundation.util.mediaQuery */"./js/foundation.util.mediaQuery.js");
      /* harmony import */
      var _foundation_util_motion__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./foundation.util.motion */"./js/foundation.util.motion.js");
      /* harmony import */
      var _foundation_core_plugin__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./foundation.core.plugin */"./js/foundation.core.plugin.js");
      function _typeof(obj) {
        if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
          _typeof = function _typeof(obj) {
            return _typeof2(obj);
          };
        } else {
          _typeof = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
          };
        }
        return _typeof(obj);
      }
      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }
      function _defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }
      function _createClass(Constructor, protoProps, staticProps) {
        if (protoProps) _defineProperties(Constructor.prototype, protoProps);
        if (staticProps) _defineProperties(Constructor, staticProps);
        return Constructor;
      }
      function _possibleConstructorReturn(self, call) {
        if (call && (_typeof(call) === "object" || typeof call === "function")) {
          return call;
        }
        return _assertThisInitialized(self);
      }
      function _assertThisInitialized(self) {
        if (self === void 0) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }
        return self;
      }
      function _getPrototypeOf(o) {
        _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
          return o.__proto__ || Object.getPrototypeOf(o);
        };
        return _getPrototypeOf(o);
      }
      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function");
        }
        subClass.prototype = Object.create(superClass && superClass.prototype, {
          constructor: {
            value: subClass,
            writable: true,
            configurable: true
          }
        });
        if (superClass) _setPrototypeOf(subClass, superClass);
      }
      function _setPrototypeOf(o, p) {
        _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
          o.__proto__ = p;
          return o;
        };
        return _setPrototypeOf(o, p);
      }

      /**
       * ResponsiveToggle module.
       * @module foundation.responsiveToggle
       * @requires foundation.util.mediaQuery
       * @requires foundation.util.motion
       */

      var ResponsiveToggle = /*#__PURE__*/
      function (_Plugin) {
        _inherits(ResponsiveToggle, _Plugin);
        function ResponsiveToggle() {
          _classCallCheck(this, ResponsiveToggle);
          return _possibleConstructorReturn(this, _getPrototypeOf(ResponsiveToggle).apply(this, arguments));
        }
        _createClass(ResponsiveToggle, [{
          key: "_setup",
          /**
           * Creates a new instance of Tab Bar.
           * @class
           * @name ResponsiveToggle
           * @fires ResponsiveToggle#init
           * @param {jQuery} element - jQuery object to attach tab bar functionality to.
           * @param {Object} options - Overrides to the default plugin settings.
           */
          value: function _setup(element, options) {
            this.$element = jquery__WEBPACK_IMPORTED_MODULE_0___default()(element);
            this.options = jquery__WEBPACK_IMPORTED_MODULE_0___default.a.extend({}, ResponsiveToggle.defaults, this.$element.data(), options);
            this.className = 'ResponsiveToggle'; // ie9 back compat

            this._init();
            this._events();
          }
          /**
           * Initializes the tab bar by finding the target element, toggling element, and running update().
           * @function
           * @private
           */
        }, {
          key: "_init",
          value: function _init() {
            _foundation_util_mediaQuery__WEBPACK_IMPORTED_MODULE_1__["MediaQuery"]._init();
            var targetID = this.$element.data('responsive-toggle');
            if (!targetID) {
              console.error('Your tab bar needs an ID of a Menu as the value of data-tab-bar.');
            }
            this.$targetMenu = jquery__WEBPACK_IMPORTED_MODULE_0___default()("#".concat(targetID));
            this.$toggler = this.$element.find('[data-toggle]').filter(function () {
              var target = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).data('toggle');
              return target === targetID || target === "";
            });
            this.options = jquery__WEBPACK_IMPORTED_MODULE_0___default.a.extend({}, this.options, this.$targetMenu.data()); // If they were set, parse the animation classes

            if (this.options.animate) {
              var input = this.options.animate.split(' ');
              this.animationIn = input[0];
              this.animationOut = input[1] || null;
            }
            this._update();
          }
          /**
           * Adds necessary event handlers for the tab bar to work.
           * @function
           * @private
           */
        }, {
          key: "_events",
          value: function _events() {
            var _this = this;
            this._updateMqHandler = this._update.bind(this);
            jquery__WEBPACK_IMPORTED_MODULE_0___default()(window).on('changed.zf.mediaquery', this._updateMqHandler);
            this.$toggler.on('click.zf.responsiveToggle', this.toggleMenu.bind(this));
          }
          /**
           * Checks the current media query to determine if the tab bar should be visible or hidden.
           * @function
           * @private
           */
        }, {
          key: "_update",
          value: function _update() {
            // Mobile
            if (!_foundation_util_mediaQuery__WEBPACK_IMPORTED_MODULE_1__["MediaQuery"].atLeast(this.options.hideFor)) {
              this.$element.show();
              this.$targetMenu.hide();
            } // Desktop
            else {
              this.$element.hide();
              this.$targetMenu.show();
            }
          }
          /**
           * Toggles the element attached to the tab bar. The toggle only happens if the screen is small enough to allow it.
           * @function
           * @fires ResponsiveToggle#toggled
           */
        }, {
          key: "toggleMenu",
          value: function toggleMenu() {
            var _this2 = this;
            if (!_foundation_util_mediaQuery__WEBPACK_IMPORTED_MODULE_1__["MediaQuery"].atLeast(this.options.hideFor)) {
              /**
               * Fires when the element attached to the tab bar toggles.
               * @event ResponsiveToggle#toggled
               */
              if (this.options.animate) {
                if (this.$targetMenu.is(':hidden')) {
                  _foundation_util_motion__WEBPACK_IMPORTED_MODULE_2__["Motion"].animateIn(this.$targetMenu, this.animationIn, function () {
                    _this2.$element.trigger('toggled.zf.responsiveToggle');
                    _this2.$targetMenu.find('[data-mutate]').triggerHandler('mutateme.zf.trigger');
                  });
                } else {
                  _foundation_util_motion__WEBPACK_IMPORTED_MODULE_2__["Motion"].animateOut(this.$targetMenu, this.animationOut, function () {
                    _this2.$element.trigger('toggled.zf.responsiveToggle');
                  });
                }
              } else {
                this.$targetMenu.toggle(0);
                this.$targetMenu.find('[data-mutate]').trigger('mutateme.zf.trigger');
                this.$element.trigger('toggled.zf.responsiveToggle');
              }
            }
          }
        }, {
          key: "_destroy",
          value: function _destroy() {
            this.$element.off('.zf.responsiveToggle');
            this.$toggler.off('.zf.responsiveToggle');
            jquery__WEBPACK_IMPORTED_MODULE_0___default()(window).off('changed.zf.mediaquery', this._updateMqHandler);
          }
        }]);
        return ResponsiveToggle;
      }(_foundation_core_plugin__WEBPACK_IMPORTED_MODULE_3__["Plugin"]);
      ResponsiveToggle.defaults = {
        /**
         * The breakpoint after which the menu is always shown, and the tab bar is hidden.
         * @option
         * @type {string}
         * @default 'medium'
         */
        hideFor: 'medium',
        /**
         * To decide if the toggle should be animated or not.
         * @option
         * @type {boolean}
         * @default false
         */
        animate: false
      };

      /***/
    }),
    /***/"./js/foundation.reveal.js": (
    /*!*********************************!*\
      !*** ./js/foundation.reveal.js ***!
      \*********************************/
    /*! exports provided: Reveal */
    /***/
    function _js_foundationRevealJs(module, __webpack_exports__, __webpack_require__) {
      "use strict";

      __webpack_require__.r(__webpack_exports__);
      /* harmony export (binding) */
      __webpack_require__.d(__webpack_exports__, "Reveal", function () {
        return Reveal;
      });
      /* harmony import */
      var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! jquery */"jquery");
      /* harmony import */
      var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);
      /* harmony import */
      var _foundation_core_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./foundation.core.utils */"./js/foundation.core.utils.js");
      /* harmony import */
      var _foundation_util_keyboard__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./foundation.util.keyboard */"./js/foundation.util.keyboard.js");
      /* harmony import */
      var _foundation_util_mediaQuery__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./foundation.util.mediaQuery */"./js/foundation.util.mediaQuery.js");
      /* harmony import */
      var _foundation_util_motion__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./foundation.util.motion */"./js/foundation.util.motion.js");
      /* harmony import */
      var _foundation_core_plugin__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./foundation.core.plugin */"./js/foundation.core.plugin.js");
      /* harmony import */
      var _foundation_util_triggers__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./foundation.util.triggers */"./js/foundation.util.triggers.js");
      /* harmony import */
      var _foundation_util_touch__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./foundation.util.touch */"./js/foundation.util.touch.js");
      function _typeof(obj) {
        if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
          _typeof = function _typeof(obj) {
            return _typeof2(obj);
          };
        } else {
          _typeof = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
          };
        }
        return _typeof(obj);
      }
      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }
      function _defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }
      function _createClass(Constructor, protoProps, staticProps) {
        if (protoProps) _defineProperties(Constructor.prototype, protoProps);
        if (staticProps) _defineProperties(Constructor, staticProps);
        return Constructor;
      }
      function _possibleConstructorReturn(self, call) {
        if (call && (_typeof(call) === "object" || typeof call === "function")) {
          return call;
        }
        return _assertThisInitialized(self);
      }
      function _assertThisInitialized(self) {
        if (self === void 0) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }
        return self;
      }
      function _getPrototypeOf(o) {
        _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
          return o.__proto__ || Object.getPrototypeOf(o);
        };
        return _getPrototypeOf(o);
      }
      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function");
        }
        subClass.prototype = Object.create(superClass && superClass.prototype, {
          constructor: {
            value: subClass,
            writable: true,
            configurable: true
          }
        });
        if (superClass) _setPrototypeOf(subClass, superClass);
      }
      function _setPrototypeOf(o, p) {
        _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
          o.__proto__ = p;
          return o;
        };
        return _setPrototypeOf(o, p);
      }

      /**
       * Reveal module.
       * @module foundation.reveal
       * @requires foundation.util.keyboard
       * @requires foundation.util.triggers
       * @requires foundation.util.mediaQuery
       * @requires foundation.util.motion if using animations
       */

      var Reveal = /*#__PURE__*/
      function (_Plugin) {
        _inherits(Reveal, _Plugin);
        function Reveal() {
          _classCallCheck(this, Reveal);
          return _possibleConstructorReturn(this, _getPrototypeOf(Reveal).apply(this, arguments));
        }
        _createClass(Reveal, [{
          key: "_setup",
          /**
           * Creates a new instance of Reveal.
           * @class
           * @name Reveal
           * @param {jQuery} element - jQuery object to use for the modal.
           * @param {Object} options - optional parameters.
           */
          value: function _setup(element, options) {
            this.$element = element;
            this.options = jquery__WEBPACK_IMPORTED_MODULE_0___default.a.extend({}, Reveal.defaults, this.$element.data(), options);
            this.className = 'Reveal'; // ie9 back compat

            this._init(); // Triggers init is idempotent, just need to make sure it is initialized

            _foundation_util_triggers__WEBPACK_IMPORTED_MODULE_6__["Triggers"].init(jquery__WEBPACK_IMPORTED_MODULE_0___default.a);
            _foundation_util_keyboard__WEBPACK_IMPORTED_MODULE_2__["Keyboard"].register('Reveal', {
              'ESCAPE': 'close'
            });
          }
          /**
           * Initializes the modal by adding the overlay and close buttons, (if selected).
           * @private
           */
        }, {
          key: "_init",
          value: function _init() {
            var _this2 = this;
            _foundation_util_mediaQuery__WEBPACK_IMPORTED_MODULE_3__["MediaQuery"]._init();
            this.id = this.$element.attr('id');
            this.isActive = false;
            this.cached = {
              mq: _foundation_util_mediaQuery__WEBPACK_IMPORTED_MODULE_3__["MediaQuery"].current
            };
            this.$anchor = jquery__WEBPACK_IMPORTED_MODULE_0___default()("[data-open=\"".concat(this.id, "\"]")).length ? jquery__WEBPACK_IMPORTED_MODULE_0___default()("[data-open=\"".concat(this.id, "\"]")) : jquery__WEBPACK_IMPORTED_MODULE_0___default()("[data-toggle=\"".concat(this.id, "\"]"));
            this.$anchor.attr({
              'aria-controls': this.id,
              'aria-haspopup': true,
              'tabindex': 0
            });
            if (this.options.fullScreen || this.$element.hasClass('full')) {
              this.options.fullScreen = true;
              this.options.overlay = false;
            }
            if (this.options.overlay && !this.$overlay) {
              this.$overlay = this._makeOverlay(this.id);
            }
            this.$element.attr({
              'role': 'dialog',
              'aria-hidden': true,
              'data-yeti-box': this.id,
              'data-resize': this.id
            });
            if (this.$overlay) {
              this.$element.detach().appendTo(this.$overlay);
            } else {
              this.$element.detach().appendTo(jquery__WEBPACK_IMPORTED_MODULE_0___default()(this.options.appendTo));
              this.$element.addClass('without-overlay');
            }
            this._events();
            if (this.options.deepLink && window.location.hash === "#".concat(this.id)) {
              this.onLoadListener = Object(_foundation_core_utils__WEBPACK_IMPORTED_MODULE_1__["onLoad"])(jquery__WEBPACK_IMPORTED_MODULE_0___default()(window), function () {
                return _this2.open();
              });
            }
          }
          /**
           * Creates an overlay div to display behind the modal.
           * @private
           */
        }, {
          key: "_makeOverlay",
          value: function _makeOverlay() {
            var additionalOverlayClasses = '';
            if (this.options.additionalOverlayClasses) {
              additionalOverlayClasses = ' ' + this.options.additionalOverlayClasses;
            }
            return jquery__WEBPACK_IMPORTED_MODULE_0___default()('<div></div>').addClass('reveal-overlay' + additionalOverlayClasses).appendTo(this.options.appendTo);
          }
          /**
           * Updates position of modal
           * TODO:  Figure out if we actually need to cache these values or if it doesn't matter
           * @private
           */
        }, {
          key: "_updatePosition",
          value: function _updatePosition() {
            var width = this.$element.outerWidth();
            var outerWidth = jquery__WEBPACK_IMPORTED_MODULE_0___default()(window).width();
            var height = this.$element.outerHeight();
            var outerHeight = jquery__WEBPACK_IMPORTED_MODULE_0___default()(window).height();
            var left,
              top = null;
            if (this.options.hOffset === 'auto') {
              left = parseInt((outerWidth - width) / 2, 10);
            } else {
              left = parseInt(this.options.hOffset, 10);
            }
            if (this.options.vOffset === 'auto') {
              if (height > outerHeight) {
                top = parseInt(Math.min(100, outerHeight / 10), 10);
              } else {
                top = parseInt((outerHeight - height) / 4, 10);
              }
            } else if (this.options.vOffset !== null) {
              top = parseInt(this.options.vOffset, 10);
            }
            if (top !== null) {
              this.$element.css({
                top: top + 'px'
              });
            } // only worry about left if we don't have an overlay or we have a horizontal offset,
            // otherwise we're perfectly in the middle

            if (!this.$overlay || this.options.hOffset !== 'auto') {
              this.$element.css({
                left: left + 'px'
              });
              this.$element.css({
                margin: '0px'
              });
            }
          }
          /**
           * Adds event handlers for the modal.
           * @private
           */
        }, {
          key: "_events",
          value: function _events() {
            var _this3 = this;
            var _this = this;
            this.$element.on({
              'open.zf.trigger': this.open.bind(this),
              'close.zf.trigger': function closeZfTrigger(event, $element) {
                if (event.target === _this.$element[0] || jquery__WEBPACK_IMPORTED_MODULE_0___default()(event.target).parents('[data-closable]')[0] === $element) {
                  // only close reveal when it's explicitly called
                  return _this3.close.apply(_this3);
                }
              },
              'toggle.zf.trigger': this.toggle.bind(this),
              'resizeme.zf.trigger': function resizemeZfTrigger() {
                _this._updatePosition();
              }
            });
            if (this.options.closeOnClick && this.options.overlay) {
              this.$overlay.off('.zf.reveal').on('click.zf.reveal', function (e) {
                if (e.target === _this.$element[0] || jquery__WEBPACK_IMPORTED_MODULE_0___default.a.contains(_this.$element[0], e.target) || !jquery__WEBPACK_IMPORTED_MODULE_0___default.a.contains(document, e.target)) {
                  return;
                }
                _this.close();
              });
            }
            if (this.options.deepLink) {
              jquery__WEBPACK_IMPORTED_MODULE_0___default()(window).on("hashchange.zf.reveal:".concat(this.id), this._handleState.bind(this));
            }
          }
          /**
           * Handles modal methods on back/forward button clicks or any other event that triggers hashchange.
           * @private
           */
        }, {
          key: "_handleState",
          value: function _handleState(e) {
            if (window.location.hash === '#' + this.id && !this.isActive) {
              this.open();
            } else {
              this.close();
            }
          }
          /**
          * Disables the scroll when Reveal is shown to prevent the background from shifting
          * @param {number} scrollTop - Scroll to visually apply, window current scroll by default
          */
        }, {
          key: "_disableScroll",
          value: function _disableScroll(scrollTop) {
            scrollTop = scrollTop || jquery__WEBPACK_IMPORTED_MODULE_0___default()(window).scrollTop();
            if (jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).height() > jquery__WEBPACK_IMPORTED_MODULE_0___default()(window).height()) {
              jquery__WEBPACK_IMPORTED_MODULE_0___default()("html").css("top", -scrollTop);
            }
          }
          /**
          * Reenables the scroll when Reveal closes
          * @param {number} scrollTop - Scroll to restore, html "top" property by default (as set by `_disableScroll`)
          */
        }, {
          key: "_enableScroll",
          value: function _enableScroll(scrollTop) {
            scrollTop = scrollTop || parseInt(jquery__WEBPACK_IMPORTED_MODULE_0___default()("html").css("top"));
            if (jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).height() > jquery__WEBPACK_IMPORTED_MODULE_0___default()(window).height()) {
              jquery__WEBPACK_IMPORTED_MODULE_0___default()("html").css("top", "");
              jquery__WEBPACK_IMPORTED_MODULE_0___default()(window).scrollTop(-scrollTop);
            }
          }
          /**
           * Opens the modal controlled by `this.$anchor`, and closes all others by default.
           * @function
           * @fires Reveal#closeme
           * @fires Reveal#open
           */
        }, {
          key: "open",
          value: function open() {
            var _this4 = this;

            // either update or replace browser history
            var hash = "#".concat(this.id);
            if (this.options.deepLink && window.location.hash !== hash) {
              if (window.history.pushState) {
                if (this.options.updateHistory) {
                  window.history.pushState({}, '', hash);
                } else {
                  window.history.replaceState({}, '', hash);
                }
              } else {
                window.location.hash = hash;
              }
            } // Remember anchor that opened it to set focus back later, have general anchors as fallback

            this.$activeAnchor = jquery__WEBPACK_IMPORTED_MODULE_0___default()(document.activeElement).is(this.$anchor) ? jquery__WEBPACK_IMPORTED_MODULE_0___default()(document.activeElement) : this.$anchor;
            this.isActive = true; // Make elements invisible, but remove display: none so we can get size and positioning

            this.$element.css({
              'visibility': 'hidden'
            }).show().scrollTop(0);
            if (this.options.overlay) {
              this.$overlay.css({
                'visibility': 'hidden'
              }).show();
            }
            this._updatePosition();
            this.$element.hide().css({
              'visibility': ''
            });
            if (this.$overlay) {
              this.$overlay.css({
                'visibility': ''
              }).hide();
              if (this.$element.hasClass('fast')) {
                this.$overlay.addClass('fast');
              } else if (this.$element.hasClass('slow')) {
                this.$overlay.addClass('slow');
              }
            }
            if (!this.options.multipleOpened) {
              /**
               * Fires immediately before the modal opens.
               * Closes any other modals that are currently open
               * @event Reveal#closeme
               */
              this.$element.trigger('closeme.zf.reveal', this.id);
            }
            this._disableScroll();
            var _this = this; // Motion UI method of reveal

            if (this.options.animationIn) {
              var afterAnimation = function afterAnimation() {
                _this.$element.attr({
                  'aria-hidden': false,
                  'tabindex': -1
                }).focus();
                _this._addGlobalClasses();
                _foundation_util_keyboard__WEBPACK_IMPORTED_MODULE_2__["Keyboard"].trapFocus(_this.$element);
              };
              if (this.options.overlay) {
                _foundation_util_motion__WEBPACK_IMPORTED_MODULE_4__["Motion"].animateIn(this.$overlay, 'fade-in');
              }
              _foundation_util_motion__WEBPACK_IMPORTED_MODULE_4__["Motion"].animateIn(this.$element, this.options.animationIn, function () {
                if (_this4.$element) {
                  // protect against object having been removed
                  _this4.focusableElements = _foundation_util_keyboard__WEBPACK_IMPORTED_MODULE_2__["Keyboard"].findFocusable(_this4.$element);
                  afterAnimation();
                }
              });
            } // jQuery method of reveal
            else {
              if (this.options.overlay) {
                this.$overlay.show(0);
              }
              this.$element.show(this.options.showDelay);
            } // handle accessibility

            this.$element.attr({
              'aria-hidden': false,
              'tabindex': -1
            }).focus();
            _foundation_util_keyboard__WEBPACK_IMPORTED_MODULE_2__["Keyboard"].trapFocus(this.$element);
            this._addGlobalClasses();
            this._addGlobalListeners();
            /**
             * Fires when the modal has successfully opened.
             * @event Reveal#open
             */

            this.$element.trigger('open.zf.reveal');
          }
          /**
           * Adds classes and listeners on document required by open modals.
           *
           * The following classes are added and updated:
           * - `.is-reveal-open` - Prevents the scroll on document
           * - `.zf-has-scroll`  - Displays a disabled scrollbar on document if required like if the
           *                       scroll was not disabled. This prevent a "shift" of the page content due
           *                       the scrollbar disappearing when the modal opens.
           *
           * @private
           */
        }, {
          key: "_addGlobalClasses",
          value: function _addGlobalClasses() {
            var updateScrollbarClass = function updateScrollbarClass() {
              jquery__WEBPACK_IMPORTED_MODULE_0___default()('html').toggleClass('zf-has-scroll', !!(jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).height() > jquery__WEBPACK_IMPORTED_MODULE_0___default()(window).height()));
            };
            this.$element.on('resizeme.zf.trigger.revealScrollbarListener', function () {
              return updateScrollbarClass();
            });
            updateScrollbarClass();
            jquery__WEBPACK_IMPORTED_MODULE_0___default()('html').addClass('is-reveal-open');
          }
          /**
           * Removes classes and listeners on document that were required by open modals.
           * @private
           */
        }, {
          key: "_removeGlobalClasses",
          value: function _removeGlobalClasses() {
            this.$element.off('resizeme.zf.trigger.revealScrollbarListener');
            jquery__WEBPACK_IMPORTED_MODULE_0___default()('html').removeClass('is-reveal-open');
            jquery__WEBPACK_IMPORTED_MODULE_0___default()('html').removeClass('zf-has-scroll');
          }
          /**
           * Adds extra event handlers for the body and window if necessary.
           * @private
           */
        }, {
          key: "_addGlobalListeners",
          value: function _addGlobalListeners() {
            var _this = this;
            if (!this.$element) {
              return;
            } // If we're in the middle of cleanup, don't freak out

            this.focusableElements = _foundation_util_keyboard__WEBPACK_IMPORTED_MODULE_2__["Keyboard"].findFocusable(this.$element);
            if (!this.options.overlay && this.options.closeOnClick && !this.options.fullScreen) {
              jquery__WEBPACK_IMPORTED_MODULE_0___default()('body').on('click.zf.reveal', function (e) {
                if (e.target === _this.$element[0] || jquery__WEBPACK_IMPORTED_MODULE_0___default.a.contains(_this.$element[0], e.target) || !jquery__WEBPACK_IMPORTED_MODULE_0___default.a.contains(document, e.target)) {
                  return;
                }
                _this.close();
              });
            }
            if (this.options.closeOnEsc) {
              jquery__WEBPACK_IMPORTED_MODULE_0___default()(window).on('keydown.zf.reveal', function (e) {
                _foundation_util_keyboard__WEBPACK_IMPORTED_MODULE_2__["Keyboard"].handleKey(e, 'Reveal', {
                  close: function close() {
                    if (_this.options.closeOnEsc) {
                      _this.close();
                    }
                  }
                });
              });
            }
          }
          /**
           * Closes the modal.
           * @function
           * @fires Reveal#closed
           */
        }, {
          key: "close",
          value: function close() {
            if (!this.isActive || !this.$element.is(':visible')) {
              return false;
            }
            var _this = this; // Motion UI method of hiding

            if (this.options.animationOut) {
              if (this.options.overlay) {
                _foundation_util_motion__WEBPACK_IMPORTED_MODULE_4__["Motion"].animateOut(this.$overlay, 'fade-out');
              }
              _foundation_util_motion__WEBPACK_IMPORTED_MODULE_4__["Motion"].animateOut(this.$element, this.options.animationOut, finishUp);
            } // jQuery method of hiding
            else {
              this.$element.hide(this.options.hideDelay);
              if (this.options.overlay) {
                this.$overlay.hide(0, finishUp);
              } else {
                finishUp();
              }
            } // Conditionals to remove extra event listeners added on open

            if (this.options.closeOnEsc) {
              jquery__WEBPACK_IMPORTED_MODULE_0___default()(window).off('keydown.zf.reveal');
            }
            if (!this.options.overlay && this.options.closeOnClick) {
              jquery__WEBPACK_IMPORTED_MODULE_0___default()('body').off('click.zf.reveal');
            }
            this.$element.off('keydown.zf.reveal');
            function finishUp() {
              // Get the current top before the modal is closed and restore the scroll after.
              // TODO: use component properties instead of HTML properties
              // See https://github.com/zurb/foundation-sites/pull/10786
              var scrollTop = parseInt(jquery__WEBPACK_IMPORTED_MODULE_0___default()("html").css("top"));
              if (jquery__WEBPACK_IMPORTED_MODULE_0___default()('.reveal:visible').length === 0) {
                _this._removeGlobalClasses(); // also remove .is-reveal-open from the html element when there is no opened reveal
              }
              _foundation_util_keyboard__WEBPACK_IMPORTED_MODULE_2__["Keyboard"].releaseFocus(_this.$element);
              _this.$element.attr('aria-hidden', true);
              _this._enableScroll(scrollTop);
              /**
              * Fires when the modal is done closing.
              * @event Reveal#closed
              */

              _this.$element.trigger('closed.zf.reveal');
            }
            /**
            * Resets the modal content
            * This prevents a running video to keep going in the background
            */

            if (this.options.resetOnClose) {
              this.$element.html(this.$element.html());
            }
            this.isActive = false; // If deepLink and we did not switched to an other modal...

            if (_this.options.deepLink && window.location.hash === "#".concat(this.id)) {
              // Remove the history hash
              if (window.history.replaceState) {
                var urlWithoutHash = window.location.pathname + window.location.search;
                if (this.options.updateHistory) {
                  window.history.pushState({}, '', urlWithoutHash); // remove the hash
                } else {
                  window.history.replaceState('', document.title, urlWithoutHash);
                }
              } else {
                window.location.hash = '';
              }
            }
            this.$activeAnchor.focus();
          }
          /**
           * Toggles the open/closed state of a modal.
           * @function
           */
        }, {
          key: "toggle",
          value: function toggle() {
            if (this.isActive) {
              this.close();
            } else {
              this.open();
            }
          }
        }, {
          key: "_destroy",
          /**
           * Destroys an instance of a modal.
           * @function
           */
          value: function _destroy() {
            if (this.options.overlay) {
              this.$element.appendTo(jquery__WEBPACK_IMPORTED_MODULE_0___default()(this.options.appendTo)); // move $element outside of $overlay to prevent error unregisterPlugin()

              this.$overlay.hide().off().remove();
            }
            this.$element.hide().off();
            this.$anchor.off('.zf');
            jquery__WEBPACK_IMPORTED_MODULE_0___default()(window).off(".zf.reveal:".concat(this.id));
            if (this.onLoadListener) jquery__WEBPACK_IMPORTED_MODULE_0___default()(window).off(this.onLoadListener);
            if (jquery__WEBPACK_IMPORTED_MODULE_0___default()('.reveal:visible').length === 0) {
              this._removeGlobalClasses(); // also remove .is-reveal-open from the html element when there is no opened reveal
            }
          }
        }]);
        return Reveal;
      }(_foundation_core_plugin__WEBPACK_IMPORTED_MODULE_5__["Plugin"]);
      Reveal.defaults = {
        /**
         * Motion-UI class to use for animated elements. If none used, defaults to simple show/hide.
         * @option
         * @type {string}
         * @default ''
         */
        animationIn: '',
        /**
         * Motion-UI class to use for animated elements. If none used, defaults to simple show/hide.
         * @option
         * @type {string}
         * @default ''
         */
        animationOut: '',
        /**
         * Time, in ms, to delay the opening of a modal after a click if no animation used.
         * @option
         * @type {number}
         * @default 0
         */
        showDelay: 0,
        /**
         * Time, in ms, to delay the closing of a modal after a click if no animation used.
         * @option
         * @type {number}
         * @default 0
         */
        hideDelay: 0,
        /**
         * Allows a click on the body/overlay to close the modal.
         * @option
         * @type {boolean}
         * @default true
         */
        closeOnClick: true,
        /**
         * Allows the modal to close if the user presses the `ESCAPE` key.
         * @option
         * @type {boolean}
         * @default true
         */
        closeOnEsc: true,
        /**
         * If true, allows multiple modals to be displayed at once.
         * @option
         * @type {boolean}
         * @default false
         */
        multipleOpened: false,
        /**
         * Distance, in pixels, the modal should push down from the top of the screen.
         * @option
         * @type {number|string}
         * @default auto
         */
        vOffset: 'auto',
        /**
         * Distance, in pixels, the modal should push in from the side of the screen.
         * @option
         * @type {number|string}
         * @default auto
         */
        hOffset: 'auto',
        /**
         * Allows the modal to be fullscreen, completely blocking out the rest of the view. JS checks for this as well.
         * @option
         * @type {boolean}
         * @default false
         */
        fullScreen: false,
        /**
         * Allows the modal to generate an overlay div, which will cover the view when modal opens.
         * @option
         * @type {boolean}
         * @default true
         */
        overlay: true,
        /**
         * Allows the modal to remove and reinject markup on close. Should be true if using video elements w/o using provider's api, otherwise, videos will continue to play in the background.
         * @option
         * @type {boolean}
         * @default false
         */
        resetOnClose: false,
        /**
         * Link the location hash to the modal.
         * Set the location hash when the modal is opened/closed, and open/close the modal when the location changes.
         * @option
         * @type {boolean}
         * @default false
         */
        deepLink: false,
        /**
         * If `deepLink` is enabled, update the browser history with the open modal
         * @option
         * @default false
         */
        updateHistory: false,
        /**
        * Allows the modal to append to custom div.
        * @option
        * @type {string}
        * @default "body"
        */
        appendTo: "body",
        /**
         * Allows adding additional class names to the reveal overlay.
         * @option
         * @type {string}
         * @default ''
         */
        additionalOverlayClasses: ''
      };

      /***/
    }),
    /***/"./js/foundation.slider.js": (
    /*!*********************************!*\
      !*** ./js/foundation.slider.js ***!
      \*********************************/
    /*! exports provided: Slider */
    /***/
    function _js_foundationSliderJs(module, __webpack_exports__, __webpack_require__) {
      "use strict";

      __webpack_require__.r(__webpack_exports__);
      /* harmony export (binding) */
      __webpack_require__.d(__webpack_exports__, "Slider", function () {
        return Slider;
      });
      /* harmony import */
      var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! jquery */"jquery");
      /* harmony import */
      var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);
      /* harmony import */
      var _foundation_util_keyboard__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./foundation.util.keyboard */"./js/foundation.util.keyboard.js");
      /* harmony import */
      var _foundation_util_motion__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./foundation.util.motion */"./js/foundation.util.motion.js");
      /* harmony import */
      var _foundation_core_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./foundation.core.utils */"./js/foundation.core.utils.js");
      /* harmony import */
      var _foundation_core_plugin__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./foundation.core.plugin */"./js/foundation.core.plugin.js");
      /* harmony import */
      var _foundation_util_touch__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./foundation.util.touch */"./js/foundation.util.touch.js");
      /* harmony import */
      var _foundation_util_triggers__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./foundation.util.triggers */"./js/foundation.util.triggers.js");
      function _typeof(obj) {
        if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
          _typeof = function _typeof(obj) {
            return _typeof2(obj);
          };
        } else {
          _typeof = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
          };
        }
        return _typeof(obj);
      }
      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }
      function _defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }
      function _createClass(Constructor, protoProps, staticProps) {
        if (protoProps) _defineProperties(Constructor.prototype, protoProps);
        if (staticProps) _defineProperties(Constructor, staticProps);
        return Constructor;
      }
      function _possibleConstructorReturn(self, call) {
        if (call && (_typeof(call) === "object" || typeof call === "function")) {
          return call;
        }
        return _assertThisInitialized(self);
      }
      function _assertThisInitialized(self) {
        if (self === void 0) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }
        return self;
      }
      function _getPrototypeOf(o) {
        _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
          return o.__proto__ || Object.getPrototypeOf(o);
        };
        return _getPrototypeOf(o);
      }
      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function");
        }
        subClass.prototype = Object.create(superClass && superClass.prototype, {
          constructor: {
            value: subClass,
            writable: true,
            configurable: true
          }
        });
        if (superClass) _setPrototypeOf(subClass, superClass);
      }
      function _setPrototypeOf(o, p) {
        _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
          o.__proto__ = p;
          return o;
        };
        return _setPrototypeOf(o, p);
      }

      /**
       * Slider module.
       * @module foundation.slider
       * @requires foundation.util.motion
       * @requires foundation.util.triggers
       * @requires foundation.util.keyboard
       * @requires foundation.util.touch
       */

      var Slider = /*#__PURE__*/
      function (_Plugin) {
        _inherits(Slider, _Plugin);
        function Slider() {
          _classCallCheck(this, Slider);
          return _possibleConstructorReturn(this, _getPrototypeOf(Slider).apply(this, arguments));
        }
        _createClass(Slider, [{
          key: "_setup",
          /**
           * Creates a new instance of a slider control.
           * @class
           * @name Slider
           * @param {jQuery} element - jQuery object to make into a slider control.
           * @param {Object} options - Overrides to the default plugin settings.
           */
          value: function _setup(element, options) {
            this.$element = element;
            this.options = jquery__WEBPACK_IMPORTED_MODULE_0___default.a.extend({}, Slider.defaults, this.$element.data(), options);
            this.className = 'Slider'; // ie9 back compat
            // Touch and Triggers inits are idempotent, we just need to make sure it's initialied.

            _foundation_util_touch__WEBPACK_IMPORTED_MODULE_5__["Touch"].init(jquery__WEBPACK_IMPORTED_MODULE_0___default.a);
            _foundation_util_triggers__WEBPACK_IMPORTED_MODULE_6__["Triggers"].init(jquery__WEBPACK_IMPORTED_MODULE_0___default.a);
            this._init();
            _foundation_util_keyboard__WEBPACK_IMPORTED_MODULE_1__["Keyboard"].register('Slider', {
              'ltr': {
                'ARROW_RIGHT': 'increase',
                'ARROW_UP': 'increase',
                'ARROW_DOWN': 'decrease',
                'ARROW_LEFT': 'decrease',
                'SHIFT_ARROW_RIGHT': 'increase_fast',
                'SHIFT_ARROW_UP': 'increase_fast',
                'SHIFT_ARROW_DOWN': 'decrease_fast',
                'SHIFT_ARROW_LEFT': 'decrease_fast',
                'HOME': 'min',
                'END': 'max'
              },
              'rtl': {
                'ARROW_LEFT': 'increase',
                'ARROW_RIGHT': 'decrease',
                'SHIFT_ARROW_LEFT': 'increase_fast',
                'SHIFT_ARROW_RIGHT': 'decrease_fast'
              }
            });
          }
          /**
           * Initilizes the plugin by reading/setting attributes, creating collections and setting the initial position of the handle(s).
           * @function
           * @private
           */
        }, {
          key: "_init",
          value: function _init() {
            this.inputs = this.$element.find('input');
            this.handles = this.$element.find('[data-slider-handle]');
            this.$handle = this.handles.eq(0);
            this.$input = this.inputs.length ? this.inputs.eq(0) : jquery__WEBPACK_IMPORTED_MODULE_0___default()("#".concat(this.$handle.attr('aria-controls')));
            this.$fill = this.$element.find('[data-slider-fill]').css(this.options.vertical ? 'height' : 'width', 0);
            var isDbl = false,
              _this = this;
            if (this.options.disabled || this.$element.hasClass(this.options.disabledClass)) {
              this.options.disabled = true;
              this.$element.addClass(this.options.disabledClass);
            }
            if (!this.inputs.length) {
              this.inputs = jquery__WEBPACK_IMPORTED_MODULE_0___default()().add(this.$input);
              this.options.binding = true;
            }
            this._setInitAttr(0);
            if (this.handles[1]) {
              this.options.doubleSided = true;
              this.$handle2 = this.handles.eq(1);
              this.$input2 = this.inputs.length > 1 ? this.inputs.eq(1) : jquery__WEBPACK_IMPORTED_MODULE_0___default()("#".concat(this.$handle2.attr('aria-controls')));
              if (!this.inputs[1]) {
                this.inputs = this.inputs.add(this.$input2);
              }
              isDbl = true; // this.$handle.triggerHandler('click.zf.slider');

              this._setInitAttr(1);
            } // Set handle positions

            this.setHandles();
            this._events();
          }
        }, {
          key: "setHandles",
          value: function setHandles() {
            var _this2 = this;
            if (this.handles[1]) {
              this._setHandlePos(this.$handle, this.inputs.eq(0).val(), true, function () {
                _this2._setHandlePos(_this2.$handle2, _this2.inputs.eq(1).val(), true);
              });
            } else {
              this._setHandlePos(this.$handle, this.inputs.eq(0).val(), true);
            }
          }
        }, {
          key: "_reflow",
          value: function _reflow() {
            this.setHandles();
          }
          /**
          * @function
          * @private
          * @param {Number} value - floating point (the value) to be transformed using to a relative position on the slider (the inverse of _value)
          */
        }, {
          key: "_pctOfBar",
          value: function _pctOfBar(value) {
            var pctOfBar = percent(value - this.options.start, this.options.end - this.options.start);
            switch (this.options.positionValueFunction) {
              case "pow":
                pctOfBar = this._logTransform(pctOfBar);
                break;
              case "log":
                pctOfBar = this._powTransform(pctOfBar);
                break;
            }
            return pctOfBar.toFixed(2);
          }
          /**
          * @function
          * @private
          * @param {Number} pctOfBar - floating point, the relative position of the slider (typically between 0-1) to be transformed to a value
          */
        }, {
          key: "_value",
          value: function _value(pctOfBar) {
            switch (this.options.positionValueFunction) {
              case "pow":
                pctOfBar = this._powTransform(pctOfBar);
                break;
              case "log":
                pctOfBar = this._logTransform(pctOfBar);
                break;
            }
            var value = (this.options.end - this.options.start) * pctOfBar + parseFloat(this.options.start);
            return value;
          }
          /**
          * @function
          * @private
          * @param {Number} value - floating point (typically between 0-1) to be transformed using the log function
          */
        }, {
          key: "_logTransform",
          value: function _logTransform(value) {
            return baseLog(this.options.nonLinearBase, value * (this.options.nonLinearBase - 1) + 1);
          }
          /**
          * @function
          * @private
          * @param {Number} value - floating point (typically between 0-1) to be transformed using the power function
          */
        }, {
          key: "_powTransform",
          value: function _powTransform(value) {
            return (Math.pow(this.options.nonLinearBase, value) - 1) / (this.options.nonLinearBase - 1);
          }
          /**
           * Sets the position of the selected handle and fill bar.
           * @function
           * @private
           * @param {jQuery} $hndl - the selected handle to move.
           * @param {Number} location - floating point between the start and end values of the slider bar.
           * @param {Function} cb - callback function to fire on completion.
           * @fires Slider#moved
           * @fires Slider#changed
           */
        }, {
          key: "_setHandlePos",
          value: function _setHandlePos($hndl, location, noInvert, cb) {
            // don't move if the slider has been disabled since its initialization
            if (this.$element.hasClass(this.options.disabledClass)) {
              return;
            } //might need to alter that slightly for bars that will have odd number selections.

            location = parseFloat(location); //on input change events, convert string to number...grumble.
            // prevent slider from running out of bounds, if value exceeds the limits set through options, override the value to min/max

            if (location < this.options.start) {
              location = this.options.start;
            } else if (location > this.options.end) {
              location = this.options.end;
            }
            var isDbl = this.options.doubleSided; //this is for single-handled vertical sliders, it adjusts the value to account for the slider being "upside-down"
            //for click and drag events, it's weird due to the scale(-1, 1) css property

            if (this.options.vertical && !noInvert) {
              location = this.options.end - location;
            }
            if (isDbl) {
              //this block is to prevent 2 handles from crossing eachother. Could/should be improved.
              if (this.handles.index($hndl) === 0) {
                var h2Val = parseFloat(this.$handle2.attr('aria-valuenow'));
                location = location >= h2Val ? h2Val - this.options.step : location;
              } else {
                var h1Val = parseFloat(this.$handle.attr('aria-valuenow'));
                location = location <= h1Val ? h1Val + this.options.step : location;
              }
            }
            var _this = this,
              vert = this.options.vertical,
              hOrW = vert ? 'height' : 'width',
              lOrT = vert ? 'top' : 'left',
              handleDim = $hndl[0].getBoundingClientRect()[hOrW],
              elemDim = this.$element[0].getBoundingClientRect()[hOrW],
              //percentage of bar min/max value based on click or drag point
              pctOfBar = this._pctOfBar(location),
              //number of actual pixels to shift the handle, based on the percentage obtained above
              pxToMove = (elemDim - handleDim) * pctOfBar,
              //percentage of bar to shift the handle
              movement = (percent(pxToMove, elemDim) * 100).toFixed(this.options.decimal); //fixing the decimal value for the location number, is passed to other methods as a fixed floating-point value

            location = parseFloat(location.toFixed(this.options.decimal)); // declare empty object for css adjustments, only used with 2 handled-sliders

            var css = {};
            this._setValues($hndl, location); // TODO update to calculate based on values set to respective inputs??

            if (isDbl) {
              var isLeftHndl = this.handles.index($hndl) === 0,
                //empty variable, will be used for min-height/width for fill bar
                dim,
                //percentage w/h of the handle compared to the slider bar
                handlePct = ~~(percent(handleDim, elemDim) * 100); //if left handle, the math is slightly different than if it's the right handle, and the left/top property needs to be changed for the fill bar

              if (isLeftHndl) {
                //left or top percentage value to apply to the fill bar.
                css[lOrT] = "".concat(movement, "%"); //calculate the new min-height/width for the fill bar.

                dim = parseFloat(this.$handle2[0].style[lOrT]) - movement + handlePct; //this callback is necessary to prevent errors and allow the proper placement and initialization of a 2-handled slider
                //plus, it means we don't care if 'dim' isNaN on init, it won't be in the future.

                if (cb && typeof cb === 'function') {
                  cb();
                } //this is only needed for the initialization of 2 handled sliders
              } else {
                //just caching the value of the left/bottom handle's left/top property
                var handlePos = parseFloat(this.$handle[0].style[lOrT]); //calculate the new min-height/width for the fill bar. Use isNaN to prevent false positives for numbers <= 0
                //based on the percentage of movement of the handle being manipulated, less the opposing handle's left/top position, plus the percentage w/h of the handle itself

                dim = movement - (isNaN(handlePos) ? (this.options.initialStart - this.options.start) / ((this.options.end - this.options.start) / 100) : handlePos) + handlePct;
              } // assign the min-height/width to our css object

              css["min-".concat(hOrW)] = "".concat(dim, "%");
            }
            this.$element.one('finished.zf.animate', function () {
              /**
               * Fires when the handle is done moving.
               * @event Slider#moved
               */
              _this.$element.trigger('moved.zf.slider', [$hndl]);
            }); //because we don't know exactly how the handle will be moved, check the amount of time it should take to move.

            var moveTime = this.$element.data('dragging') ? 1000 / 60 : this.options.moveTime;
            Object(_foundation_util_motion__WEBPACK_IMPORTED_MODULE_2__["Move"])(moveTime, $hndl, function () {
              // adjusting the left/top property of the handle, based on the percentage calculated above
              // if movement isNaN, that is because the slider is hidden and we cannot determine handle width,
              // fall back to next best guess.
              if (isNaN(movement)) {
                $hndl.css(lOrT, "".concat(pctOfBar * 100, "%"));
              } else {
                $hndl.css(lOrT, "".concat(movement, "%"));
              }
              if (!_this.options.doubleSided) {
                //if single-handled, a simple method to expand the fill bar
                _this.$fill.css(hOrW, "".concat(pctOfBar * 100, "%"));
              } else {
                //otherwise, use the css object we created above
                _this.$fill.css(css);
              }
            });
            /**
             * Fires when the value has not been change for a given time.
             * @event Slider#changed
             */

            clearTimeout(_this.timeout);
            _this.timeout = setTimeout(function () {
              _this.$element.trigger('changed.zf.slider', [$hndl]);
            }, _this.options.changedDelay);
          }
          /**
           * Sets the initial attribute for the slider element.
           * @function
           * @private
           * @param {Number} idx - index of the current handle/input to use.
           */
        }, {
          key: "_setInitAttr",
          value: function _setInitAttr(idx) {
            var initVal = idx === 0 ? this.options.initialStart : this.options.initialEnd;
            var id = this.inputs.eq(idx).attr('id') || Object(_foundation_core_utils__WEBPACK_IMPORTED_MODULE_3__["GetYoDigits"])(6, 'slider');
            this.inputs.eq(idx).attr({
              'id': id,
              'max': this.options.end,
              'min': this.options.start,
              'step': this.options.step
            });
            this.inputs.eq(idx).val(initVal);
            this.handles.eq(idx).attr({
              'role': 'slider',
              'aria-controls': id,
              'aria-valuemax': this.options.end,
              'aria-valuemin': this.options.start,
              'aria-valuenow': initVal,
              'aria-orientation': this.options.vertical ? 'vertical' : 'horizontal',
              'tabindex': 0
            });
          }
          /**
           * Sets the input and `aria-valuenow` values for the slider element.
           * @function
           * @private
           * @param {jQuery} $handle - the currently selected handle.
           * @param {Number} val - floating point of the new value.
           */
        }, {
          key: "_setValues",
          value: function _setValues($handle, val) {
            var idx = this.options.doubleSided ? this.handles.index($handle) : 0;
            this.inputs.eq(idx).val(val);
            $handle.attr('aria-valuenow', val);
          }
          /**
           * Handles events on the slider element.
           * Calculates the new location of the current handle.
           * If there are two handles and the bar was clicked, it determines which handle to move.
           * @function
           * @private
           * @param {Object} e - the `event` object passed from the listener.
           * @param {jQuery} $handle - the current handle to calculate for, if selected.
           * @param {Number} val - floating point number for the new value of the slider.
           * TODO clean this up, there's a lot of repeated code between this and the _setHandlePos fn.
           */
        }, {
          key: "_handleEvent",
          value: function _handleEvent(e, $handle, val) {
            var value, hasVal;
            if (!val) {
              //click or drag events
              e.preventDefault();
              var _this = this,
                vertical = this.options.vertical,
                param = vertical ? 'height' : 'width',
                direction = vertical ? 'top' : 'left',
                eventOffset = vertical ? e.pageY : e.pageX,
                halfOfHandle = this.$handle[0].getBoundingClientRect()[param] / 2,
                barDim = this.$element[0].getBoundingClientRect()[param],
                windowScroll = vertical ? jquery__WEBPACK_IMPORTED_MODULE_0___default()(window).scrollTop() : jquery__WEBPACK_IMPORTED_MODULE_0___default()(window).scrollLeft();
              var elemOffset = this.$element.offset()[direction]; // touch events emulated by the touch util give position relative to screen, add window.scroll to event coordinates...
              // best way to guess this is simulated is if clientY == pageY

              if (e.clientY === e.pageY) {
                eventOffset = eventOffset + windowScroll;
              }
              var eventFromBar = eventOffset - elemOffset;
              var barXY;
              if (eventFromBar < 0) {
                barXY = 0;
              } else if (eventFromBar > barDim) {
                barXY = barDim;
              } else {
                barXY = eventFromBar;
              }
              var offsetPct = percent(barXY, barDim);
              value = this._value(offsetPct); // turn everything around for RTL, yay math!

              if (Object(_foundation_core_utils__WEBPACK_IMPORTED_MODULE_3__["rtl"])() && !this.options.vertical) {
                value = this.options.end - value;
              }
              value = _this._adjustValue(null, value); //boolean flag for the setHandlePos fn, specifically for vertical sliders

              hasVal = false;
              if (!$handle) {
                //figure out which handle it is, pass it to the next function.
                var firstHndlPos = absPosition(this.$handle, direction, barXY, param),
                  secndHndlPos = absPosition(this.$handle2, direction, barXY, param);
                $handle = firstHndlPos <= secndHndlPos ? this.$handle : this.$handle2;
              }
            } else {
              //change event on input
              value = this._adjustValue(null, val);
              hasVal = true;
            }
            this._setHandlePos($handle, value, hasVal);
          }
          /**
           * Adjustes value for handle in regard to step value. returns adjusted value
           * @function
           * @private
           * @param {jQuery} $handle - the selected handle.
           * @param {Number} value - value to adjust. used if $handle is falsy
           */
        }, {
          key: "_adjustValue",
          value: function _adjustValue($handle, value) {
            var val,
              step = this.options.step,
              div = parseFloat(step / 2),
              left,
              prev_val,
              next_val;
            if (!!$handle) {
              val = parseFloat($handle.attr('aria-valuenow'));
            } else {
              val = value;
            }
            if (val >= 0) {
              left = val % step;
            } else {
              left = step + val % step;
            }
            prev_val = val - left;
            next_val = prev_val + step;
            if (left === 0) {
              return val;
            }
            val = val >= prev_val + div ? next_val : prev_val;
            return val;
          }
          /**
           * Adds event listeners to the slider elements.
           * @function
           * @private
           */
        }, {
          key: "_events",
          value: function _events() {
            this._eventsForHandle(this.$handle);
            if (this.handles[1]) {
              this._eventsForHandle(this.$handle2);
            }
          }
          /**
           * Adds event listeners a particular handle
           * @function
           * @private
           * @param {jQuery} $handle - the current handle to apply listeners to.
           */
        }, {
          key: "_eventsForHandle",
          value: function _eventsForHandle($handle) {
            var _this = this,
              curHandle,
              timer;
            var handleChangeEvent = function handleChangeEvent(e) {
              var idx = _this.inputs.index(jquery__WEBPACK_IMPORTED_MODULE_0___default()(this));
              _this._handleEvent(e, _this.handles.eq(idx), jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).val());
            }; // IE only triggers the change event when the input loses focus which strictly follows the HTML specification
            // listen for the enter key and trigger a change
            // @see https://html.spec.whatwg.org/multipage/input.html#common-input-element-events

            this.inputs.off('keyup.zf.slider').on('keyup.zf.slider', function (e) {
              if (e.keyCode == 13) handleChangeEvent.call(this, e);
            });
            this.inputs.off('change.zf.slider').on('change.zf.slider', handleChangeEvent);
            if (this.options.clickSelect) {
              this.$element.off('click.zf.slider').on('click.zf.slider', function (e) {
                if (_this.$element.data('dragging')) {
                  return false;
                }
                if (!jquery__WEBPACK_IMPORTED_MODULE_0___default()(e.target).is('[data-slider-handle]')) {
                  if (_this.options.doubleSided) {
                    _this._handleEvent(e);
                  } else {
                    _this._handleEvent(e, _this.$handle);
                  }
                }
              });
            }
            if (this.options.draggable) {
              this.handles.addTouch();
              var $body = jquery__WEBPACK_IMPORTED_MODULE_0___default()('body');
              $handle.off('mousedown.zf.slider').on('mousedown.zf.slider', function (e) {
                $handle.addClass('is-dragging');
                _this.$fill.addClass('is-dragging'); //

                _this.$element.data('dragging', true);
                curHandle = jquery__WEBPACK_IMPORTED_MODULE_0___default()(e.currentTarget);
                $body.on('mousemove.zf.slider', function (e) {
                  e.preventDefault();
                  _this._handleEvent(e, curHandle);
                }).on('mouseup.zf.slider', function (e) {
                  _this._handleEvent(e, curHandle);
                  $handle.removeClass('is-dragging');
                  _this.$fill.removeClass('is-dragging');
                  _this.$element.data('dragging', false);
                  $body.off('mousemove.zf.slider mouseup.zf.slider');
                });
              }) // prevent events triggered by touch
              .on('selectstart.zf.slider touchmove.zf.slider', function (e) {
                e.preventDefault();
              });
            }
            $handle.off('keydown.zf.slider').on('keydown.zf.slider', function (e) {
              var _$handle = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this),
                idx = _this.options.doubleSided ? _this.handles.index(_$handle) : 0,
                oldValue = parseFloat(_this.inputs.eq(idx).val()),
                newValue; // handle keyboard event with keyboard util

              _foundation_util_keyboard__WEBPACK_IMPORTED_MODULE_1__["Keyboard"].handleKey(e, 'Slider', {
                decrease: function decrease() {
                  newValue = oldValue - _this.options.step;
                },
                increase: function increase() {
                  newValue = oldValue + _this.options.step;
                },
                decrease_fast: function decrease_fast() {
                  newValue = oldValue - _this.options.step * 10;
                },
                increase_fast: function increase_fast() {
                  newValue = oldValue + _this.options.step * 10;
                },
                min: function min() {
                  newValue = _this.options.start;
                },
                max: function max() {
                  newValue = _this.options.end;
                },
                handled: function handled() {
                  // only set handle pos when event was handled specially
                  e.preventDefault();
                  _this._setHandlePos(_$handle, newValue, true);
                }
              });
              /*if (newValue) { // if pressed key has special function, update value
                e.preventDefault();
                _this._setHandlePos(_$handle, newValue);
              }*/
            });
          }
          /**
           * Destroys the slider plugin.
           */
        }, {
          key: "_destroy",
          value: function _destroy() {
            this.handles.off('.zf.slider');
            this.inputs.off('.zf.slider');
            this.$element.off('.zf.slider');
            clearTimeout(this.timeout);
          }
        }]);
        return Slider;
      }(_foundation_core_plugin__WEBPACK_IMPORTED_MODULE_4__["Plugin"]);
      Slider.defaults = {
        /**
         * Minimum value for the slider scale.
         * @option
         * @type {number}
         * @default 0
         */
        start: 0,
        /**
         * Maximum value for the slider scale.
         * @option
         * @type {number}
         * @default 100
         */
        end: 100,
        /**
         * Minimum value change per change event.
         * @option
         * @type {number}
         * @default 1
         */
        step: 1,
        /**
         * Value at which the handle/input *(left handle/first input)* should be set to on initialization.
         * @option
         * @type {number}
         * @default 0
         */
        initialStart: 0,
        /**
         * Value at which the right handle/second input should be set to on initialization.
         * @option
         * @type {number}
         * @default 100
         */
        initialEnd: 100,
        /**
         * Allows the input to be located outside the container and visible. Set to by the JS
         * @option
         * @type {boolean}
         * @default false
         */
        binding: false,
        /**
         * Allows the user to click/tap on the slider bar to select a value.
         * @option
         * @type {boolean}
         * @default true
         */
        clickSelect: true,
        /**
         * Set to true and use the `vertical` class to change alignment to vertical.
         * @option
         * @type {boolean}
         * @default false
         */
        vertical: false,
        /**
         * Allows the user to drag the slider handle(s) to select a value.
         * @option
         * @type {boolean}
         * @default true
         */
        draggable: true,
        /**
         * Disables the slider and prevents event listeners from being applied. Double checked by JS with `disabledClass`.
         * @option
         * @type {boolean}
         * @default false
         */
        disabled: false,
        /**
         * Allows the use of two handles. Double checked by the JS. Changes some logic handling.
         * @option
         * @type {boolean}
         * @default false
         */
        doubleSided: false,
        /**
         * Potential future feature.
         */
        // steps: 100,

        /**
         * Number of decimal places the plugin should go to for floating point precision.
         * @option
         * @type {number}
         * @default 2
         */
        decimal: 2,
        /**
         * Time delay for dragged elements.
         */
        // dragDelay: 0,

        /**
         * Time, in ms, to animate the movement of a slider handle if user clicks/taps on the bar. Needs to be manually set if updating the transition time in the Sass settings.
         * @option
         * @type {number}
         * @default 200
         */
        moveTime: 200,
        //update this if changing the transition time in the sass

        /**
         * Class applied to disabled sliders.
         * @option
         * @type {string}
         * @default 'disabled'
         */
        disabledClass: 'disabled',
        /**
         * Will invert the default layout for a vertical<span data-tooltip title="who would do this???"> </span>slider.
         * @option
         * @type {boolean}
         * @default false
         */
        invertVertical: false,
        /**
         * Milliseconds before the `changed.zf-slider` event is triggered after value change.
         * @option
         * @type {number}
         * @default 500
         */
        changedDelay: 500,
        /**
        * Basevalue for non-linear sliders
        * @option
        * @type {number}
        * @default 5
        */
        nonLinearBase: 5,
        /**
        * Basevalue for non-linear sliders, possible values are: `'linear'`, `'pow'` & `'log'`. Pow and Log use the nonLinearBase setting.
        * @option
        * @type {string}
        * @default 'linear'
        */
        positionValueFunction: 'linear'
      };
      function percent(frac, num) {
        return frac / num;
      }
      function absPosition($handle, dir, clickPos, param) {
        return Math.abs($handle.position()[dir] + $handle[param]() / 2 - clickPos);
      }
      function baseLog(base, value) {
        return Math.log(value) / Math.log(base);
      }

      /***/
    }),
    /***/"./js/foundation.smoothScroll.js": (
    /*!***************************************!*\
      !*** ./js/foundation.smoothScroll.js ***!
      \***************************************/
    /*! exports provided: SmoothScroll */
    /***/
    function _js_foundationSmoothScrollJs(module, __webpack_exports__, __webpack_require__) {
      "use strict";

      __webpack_require__.r(__webpack_exports__);
      /* harmony export (binding) */
      __webpack_require__.d(__webpack_exports__, "SmoothScroll", function () {
        return SmoothScroll;
      });
      /* harmony import */
      var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! jquery */"jquery");
      /* harmony import */
      var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);
      /* harmony import */
      var _foundation_core_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./foundation.core.utils */"./js/foundation.core.utils.js");
      /* harmony import */
      var _foundation_core_plugin__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./foundation.core.plugin */"./js/foundation.core.plugin.js");
      function _typeof(obj) {
        if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
          _typeof = function _typeof(obj) {
            return _typeof2(obj);
          };
        } else {
          _typeof = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
          };
        }
        return _typeof(obj);
      }
      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }
      function _defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }
      function _createClass(Constructor, protoProps, staticProps) {
        if (protoProps) _defineProperties(Constructor.prototype, protoProps);
        if (staticProps) _defineProperties(Constructor, staticProps);
        return Constructor;
      }
      function _possibleConstructorReturn(self, call) {
        if (call && (_typeof(call) === "object" || typeof call === "function")) {
          return call;
        }
        return _assertThisInitialized(self);
      }
      function _assertThisInitialized(self) {
        if (self === void 0) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }
        return self;
      }
      function _getPrototypeOf(o) {
        _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
          return o.__proto__ || Object.getPrototypeOf(o);
        };
        return _getPrototypeOf(o);
      }
      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function");
        }
        subClass.prototype = Object.create(superClass && superClass.prototype, {
          constructor: {
            value: subClass,
            writable: true,
            configurable: true
          }
        });
        if (superClass) _setPrototypeOf(subClass, superClass);
      }
      function _setPrototypeOf(o, p) {
        _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
          o.__proto__ = p;
          return o;
        };
        return _setPrototypeOf(o, p);
      }

      /**
       * SmoothScroll module.
       * @module foundation.smooth-scroll
       */

      var SmoothScroll = /*#__PURE__*/
      function (_Plugin) {
        _inherits(SmoothScroll, _Plugin);
        function SmoothScroll() {
          _classCallCheck(this, SmoothScroll);
          return _possibleConstructorReturn(this, _getPrototypeOf(SmoothScroll).apply(this, arguments));
        }
        _createClass(SmoothScroll, [{
          key: "_setup",
          /**
           * Creates a new instance of SmoothScroll.
           * @class
           * @name SmoothScroll
           * @fires SmoothScroll#init
           * @param {Object} element - jQuery object to add the trigger to.
           * @param {Object} options - Overrides to the default plugin settings.
           */
          value: function _setup(element, options) {
            this.$element = element;
            this.options = jquery__WEBPACK_IMPORTED_MODULE_0___default.a.extend({}, SmoothScroll.defaults, this.$element.data(), options);
            this.className = 'SmoothScroll'; // ie9 back compat

            this._init();
          }
          /**
           * Initialize the SmoothScroll plugin
           * @private
           */
        }, {
          key: "_init",
          value: function _init() {
            var id = this.$element[0].id || Object(_foundation_core_utils__WEBPACK_IMPORTED_MODULE_1__["GetYoDigits"])(6, 'smooth-scroll');
            this.$element.attr({
              id: id
            });
            this._events();
          }
          /**
           * Initializes events for SmoothScroll.
           * @private
           */
        }, {
          key: "_events",
          value: function _events() {
            this._linkClickListener = this._handleLinkClick.bind(this);
            this.$element.on('click.zf.smoothScroll', this._linkClickListener);
            this.$element.on('click.zf.smoothScroll', 'a[href^="#"]', this._linkClickListener);
          }
          /**
           * Handle the given event to smoothly scroll to the anchor pointed by the event target.
           * @param {*} e - event
           * @function
           * @private
           */
        }, {
          key: "_handleLinkClick",
          value: function _handleLinkClick(e) {
            var _this = this;

            // Follow the link if it does not point to an anchor.
            if (!jquery__WEBPACK_IMPORTED_MODULE_0___default()(e.currentTarget).is('a[href^="#"]')) return;
            var arrival = e.currentTarget.getAttribute('href');
            this._inTransition = true;
            SmoothScroll.scrollToLoc(arrival, this.options, function () {
              _this._inTransition = false;
            });
            e.preventDefault();
          }
        }, {
          key: "_destroy",
          /**
           * Destroys the SmoothScroll instance.
           * @function
           */
          value: function _destroy() {
            this.$element.off('click.zf.smoothScroll', this._linkClickListener);
            this.$element.off('click.zf.smoothScroll', 'a[href^="#"]', this._linkClickListener);
          }
        }], [{
          key: "scrollToLoc",
          /**
           * Function to scroll to a given location on the page.
           * @param {String} loc - A properly formatted jQuery id selector. Example: '#foo'
           * @param {Object} options - The options to use.
           * @param {Function} callback - The callback function.
           * @static
           * @function
           */
          value: function scrollToLoc(loc) {
            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : SmoothScroll.defaults;
            var callback = arguments.length > 2 ? arguments[2] : undefined;
            var $loc = jquery__WEBPACK_IMPORTED_MODULE_0___default()(loc); // Do nothing if target does not exist to prevent errors

            if (!$loc.length) return false;
            var scrollPos = Math.round($loc.offset().top - options.threshold / 2 - options.offset);
            jquery__WEBPACK_IMPORTED_MODULE_0___default()('html, body').stop(true).animate({
              scrollTop: scrollPos
            }, options.animationDuration, options.animationEasing, function () {
              if (typeof callback === 'function') {
                callback();
              }
            });
          }
        }]);
        return SmoothScroll;
      }(_foundation_core_plugin__WEBPACK_IMPORTED_MODULE_2__["Plugin"]);
      /**
       * Default settings for plugin.
       */

      SmoothScroll.defaults = {
        /**
         * Amount of time, in ms, the animated scrolling should take between locations.
         * @option
         * @type {number}
         * @default 500
         */
        animationDuration: 500,
        /**
         * Animation style to use when scrolling between locations. Can be `'swing'` or `'linear'`.
         * @option
         * @type {string}
         * @default 'linear'
         * @see {@link https://api.jquery.com/animate|Jquery animate}
         */
        animationEasing: 'linear',
        /**
         * Number of pixels to use as a marker for location changes.
         * @option
         * @type {number}
         * @default 50
         */
        threshold: 50,
        /**
         * Number of pixels to offset the scroll of the page on item click if using a sticky nav bar.
         * @option
         * @type {number}
         * @default 0
         */
        offset: 0
      };

      /***/
    }),
    /***/"./js/foundation.sticky.js": (
    /*!*********************************!*\
      !*** ./js/foundation.sticky.js ***!
      \*********************************/
    /*! exports provided: Sticky */
    /***/
    function _js_foundationStickyJs(module, __webpack_exports__, __webpack_require__) {
      "use strict";

      __webpack_require__.r(__webpack_exports__);
      /* harmony export (binding) */
      __webpack_require__.d(__webpack_exports__, "Sticky", function () {
        return Sticky;
      });
      /* harmony import */
      var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! jquery */"jquery");
      /* harmony import */
      var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);
      /* harmony import */
      var _foundation_core_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./foundation.core.utils */"./js/foundation.core.utils.js");
      /* harmony import */
      var _foundation_util_mediaQuery__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./foundation.util.mediaQuery */"./js/foundation.util.mediaQuery.js");
      /* harmony import */
      var _foundation_core_plugin__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./foundation.core.plugin */"./js/foundation.core.plugin.js");
      /* harmony import */
      var _foundation_util_triggers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./foundation.util.triggers */"./js/foundation.util.triggers.js");
      function _typeof(obj) {
        if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
          _typeof = function _typeof(obj) {
            return _typeof2(obj);
          };
        } else {
          _typeof = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
          };
        }
        return _typeof(obj);
      }
      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }
      function _defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }
      function _createClass(Constructor, protoProps, staticProps) {
        if (protoProps) _defineProperties(Constructor.prototype, protoProps);
        if (staticProps) _defineProperties(Constructor, staticProps);
        return Constructor;
      }
      function _possibleConstructorReturn(self, call) {
        if (call && (_typeof(call) === "object" || typeof call === "function")) {
          return call;
        }
        return _assertThisInitialized(self);
      }
      function _assertThisInitialized(self) {
        if (self === void 0) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }
        return self;
      }
      function _getPrototypeOf(o) {
        _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
          return o.__proto__ || Object.getPrototypeOf(o);
        };
        return _getPrototypeOf(o);
      }
      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function");
        }
        subClass.prototype = Object.create(superClass && superClass.prototype, {
          constructor: {
            value: subClass,
            writable: true,
            configurable: true
          }
        });
        if (superClass) _setPrototypeOf(subClass, superClass);
      }
      function _setPrototypeOf(o, p) {
        _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
          o.__proto__ = p;
          return o;
        };
        return _setPrototypeOf(o, p);
      }

      /**
       * Sticky module.
       * @module foundation.sticky
       * @requires foundation.util.triggers
       * @requires foundation.util.mediaQuery
       */

      var Sticky = /*#__PURE__*/
      function (_Plugin) {
        _inherits(Sticky, _Plugin);
        function Sticky() {
          _classCallCheck(this, Sticky);
          return _possibleConstructorReturn(this, _getPrototypeOf(Sticky).apply(this, arguments));
        }
        _createClass(Sticky, [{
          key: "_setup",
          /**
           * Creates a new instance of a sticky thing.
           * @class
           * @name Sticky
           * @param {jQuery} element - jQuery object to make sticky.
           * @param {Object} options - options object passed when creating the element programmatically.
           */
          value: function _setup(element, options) {
            this.$element = element;
            this.options = jquery__WEBPACK_IMPORTED_MODULE_0___default.a.extend({}, Sticky.defaults, this.$element.data(), options);
            this.className = 'Sticky'; // ie9 back compat
            // Triggers init is idempotent, just need to make sure it is initialized

            _foundation_util_triggers__WEBPACK_IMPORTED_MODULE_4__["Triggers"].init(jquery__WEBPACK_IMPORTED_MODULE_0___default.a);
            this._init();
          }
          /**
           * Initializes the sticky element by adding classes, getting/setting dimensions, breakpoints and attributes
           * @function
           * @private
           */
        }, {
          key: "_init",
          value: function _init() {
            _foundation_util_mediaQuery__WEBPACK_IMPORTED_MODULE_2__["MediaQuery"]._init();
            var $parent = this.$element.parent('[data-sticky-container]'),
              id = this.$element[0].id || Object(_foundation_core_utils__WEBPACK_IMPORTED_MODULE_1__["GetYoDigits"])(6, 'sticky'),
              _this = this;
            if ($parent.length) {
              this.$container = $parent;
            } else {
              this.wasWrapped = true;
              this.$element.wrap(this.options.container);
              this.$container = this.$element.parent();
            }
            this.$container.addClass(this.options.containerClass);
            this.$element.addClass(this.options.stickyClass).attr({
              'data-resize': id,
              'data-mutate': id
            });
            if (this.options.anchor !== '') {
              jquery__WEBPACK_IMPORTED_MODULE_0___default()('#' + _this.options.anchor).attr({
                'data-mutate': id
              });
            }
            this.scrollCount = this.options.checkEvery;
            this.isStuck = false;
            this.onLoadListener = Object(_foundation_core_utils__WEBPACK_IMPORTED_MODULE_1__["onLoad"])(jquery__WEBPACK_IMPORTED_MODULE_0___default()(window), function () {
              //We calculate the container height to have correct values for anchor points offset calculation.
              _this.containerHeight = _this.$element.css("display") == "none" ? 0 : _this.$element[0].getBoundingClientRect().height;
              _this.$container.css('height', _this.containerHeight);
              _this.elemHeight = _this.containerHeight;
              if (_this.options.anchor !== '') {
                _this.$anchor = jquery__WEBPACK_IMPORTED_MODULE_0___default()('#' + _this.options.anchor);
              } else {
                _this._parsePoints();
              }
              _this._setSizes(function () {
                var scroll = window.pageYOffset;
                _this._calc(false, scroll); //Unstick the element will ensure that proper classes are set.

                if (!_this.isStuck) {
                  _this._removeSticky(scroll >= _this.topPoint ? false : true);
                }
              });
              _this._events(id.split('-').reverse().join('-'));
            });
          }
          /**
           * If using multiple elements as anchors, calculates the top and bottom pixel values the sticky thing should stick and unstick on.
           * @function
           * @private
           */
        }, {
          key: "_parsePoints",
          value: function _parsePoints() {
            var top = this.options.topAnchor == "" ? 1 : this.options.topAnchor,
              btm = this.options.btmAnchor == "" ? document.documentElement.scrollHeight : this.options.btmAnchor,
              pts = [top, btm],
              breaks = {};
            for (var i = 0, len = pts.length; i < len && pts[i]; i++) {
              var pt;
              if (typeof pts[i] === 'number') {
                pt = pts[i];
              } else {
                var place = pts[i].split(':'),
                  anchor = jquery__WEBPACK_IMPORTED_MODULE_0___default()("#".concat(place[0]));
                pt = anchor.offset().top;
                if (place[1] && place[1].toLowerCase() === 'bottom') {
                  pt += anchor[0].getBoundingClientRect().height;
                }
              }
              breaks[i] = pt;
            }
            this.points = breaks;
            return;
          }
          /**
           * Adds event handlers for the scrolling element.
           * @private
           * @param {String} id - pseudo-random id for unique scroll event listener.
           */
        }, {
          key: "_events",
          value: function _events(id) {
            var _this = this,
              scrollListener = this.scrollListener = "scroll.zf.".concat(id);
            if (this.isOn) {
              return;
            }
            if (this.canStick) {
              this.isOn = true;
              jquery__WEBPACK_IMPORTED_MODULE_0___default()(window).off(scrollListener).on(scrollListener, function (e) {
                if (_this.scrollCount === 0) {
                  _this.scrollCount = _this.options.checkEvery;
                  _this._setSizes(function () {
                    _this._calc(false, window.pageYOffset);
                  });
                } else {
                  _this.scrollCount--;
                  _this._calc(false, window.pageYOffset);
                }
              });
            }
            this.$element.off('resizeme.zf.trigger').on('resizeme.zf.trigger', function (e, el) {
              _this._eventsHandler(id);
            });
            this.$element.on('mutateme.zf.trigger', function (e, el) {
              _this._eventsHandler(id);
            });
            if (this.$anchor) {
              this.$anchor.on('mutateme.zf.trigger', function (e, el) {
                _this._eventsHandler(id);
              });
            }
          }
          /**
           * Handler for events.
           * @private
           * @param {String} id - pseudo-random id for unique scroll event listener.
           */
        }, {
          key: "_eventsHandler",
          value: function _eventsHandler(id) {
            var _this = this,
              scrollListener = this.scrollListener = "scroll.zf.".concat(id);
            _this._setSizes(function () {
              _this._calc(false);
              if (_this.canStick) {
                if (!_this.isOn) {
                  _this._events(id);
                }
              } else if (_this.isOn) {
                _this._pauseListeners(scrollListener);
              }
            });
          }
          /**
           * Removes event handlers for scroll and change events on anchor.
           * @fires Sticky#pause
           * @param {String} scrollListener - unique, namespaced scroll listener attached to `window`
           */
        }, {
          key: "_pauseListeners",
          value: function _pauseListeners(scrollListener) {
            this.isOn = false;
            jquery__WEBPACK_IMPORTED_MODULE_0___default()(window).off(scrollListener);
            /**
             * Fires when the plugin is paused due to resize event shrinking the view.
             * @event Sticky#pause
             * @private
             */

            this.$element.trigger('pause.zf.sticky');
          }
          /**
           * Called on every `scroll` event and on `_init`
           * fires functions based on booleans and cached values
           * @param {Boolean} checkSizes - true if plugin should recalculate sizes and breakpoints.
           * @param {Number} scroll - current scroll position passed from scroll event cb function. If not passed, defaults to `window.pageYOffset`.
           */
        }, {
          key: "_calc",
          value: function _calc(checkSizes, scroll) {
            if (checkSizes) {
              this._setSizes();
            }
            if (!this.canStick) {
              if (this.isStuck) {
                this._removeSticky(true);
              }
              return false;
            }
            if (!scroll) {
              scroll = window.pageYOffset;
            }
            if (scroll >= this.topPoint) {
              if (scroll <= this.bottomPoint) {
                if (!this.isStuck) {
                  this._setSticky();
                }
              } else {
                if (this.isStuck) {
                  this._removeSticky(false);
                }
              }
            } else {
              if (this.isStuck) {
                this._removeSticky(true);
              }
            }
          }
          /**
           * Causes the $element to become stuck.
           * Adds `position: fixed;`, and helper classes.
           * @fires Sticky#stuckto
           * @function
           * @private
           */
        }, {
          key: "_setSticky",
          value: function _setSticky() {
            var _this = this,
              stickTo = this.options.stickTo,
              mrgn = stickTo === 'top' ? 'marginTop' : 'marginBottom',
              notStuckTo = stickTo === 'top' ? 'bottom' : 'top',
              css = {};
            css[mrgn] = "".concat(this.options[mrgn], "em");
            css[stickTo] = 0;
            css[notStuckTo] = 'auto';
            this.isStuck = true;
            this.$element.removeClass("is-anchored is-at-".concat(notStuckTo)).addClass("is-stuck is-at-".concat(stickTo)).css(css)
            /**
             * Fires when the $element has become `position: fixed;`
             * Namespaced to `top` or `bottom`, e.g. `sticky.zf.stuckto:top`
             * @event Sticky#stuckto
             */.trigger("sticky.zf.stuckto:".concat(stickTo));
            this.$element.on("transitionend webkitTransitionEnd oTransitionEnd otransitionend MSTransitionEnd", function () {
              _this._setSizes();
            });
          }
          /**
           * Causes the $element to become unstuck.
           * Removes `position: fixed;`, and helper classes.
           * Adds other helper classes.
           * @param {Boolean} isTop - tells the function if the $element should anchor to the top or bottom of its $anchor element.
           * @fires Sticky#unstuckfrom
           * @private
           */
        }, {
          key: "_removeSticky",
          value: function _removeSticky(isTop) {
            var stickTo = this.options.stickTo,
              stickToTop = stickTo === 'top',
              css = {},
              anchorPt = (this.points ? this.points[1] - this.points[0] : this.anchorHeight) - this.elemHeight,
              mrgn = stickToTop ? 'marginTop' : 'marginBottom',
              notStuckTo = stickToTop ? 'bottom' : 'top',
              topOrBottom = isTop ? 'top' : 'bottom';
            css[mrgn] = 0;
            css['bottom'] = 'auto';
            if (isTop) {
              css['top'] = 0;
            } else {
              css['top'] = anchorPt;
            }
            this.isStuck = false;
            this.$element.removeClass("is-stuck is-at-".concat(stickTo)).addClass("is-anchored is-at-".concat(topOrBottom)).css(css)
            /**
             * Fires when the $element has become anchored.
             * Namespaced to `top` or `bottom`, e.g. `sticky.zf.unstuckfrom:bottom`
             * @event Sticky#unstuckfrom
             */.trigger("sticky.zf.unstuckfrom:".concat(topOrBottom));
          }
          /**
           * Sets the $element and $container sizes for plugin.
           * Calls `_setBreakPoints`.
           * @param {Function} cb - optional callback function to fire on completion of `_setBreakPoints`.
           * @private
           */
        }, {
          key: "_setSizes",
          value: function _setSizes(cb) {
            this.canStick = _foundation_util_mediaQuery__WEBPACK_IMPORTED_MODULE_2__["MediaQuery"].is(this.options.stickyOn);
            if (!this.canStick) {
              if (cb && typeof cb === 'function') {
                cb();
              }
            }
            var _this = this,
              newElemWidth = this.$container[0].getBoundingClientRect().width,
              comp = window.getComputedStyle(this.$container[0]),
              pdngl = parseInt(comp['padding-left'], 10),
              pdngr = parseInt(comp['padding-right'], 10);
            if (this.$anchor && this.$anchor.length) {
              this.anchorHeight = this.$anchor[0].getBoundingClientRect().height;
            } else {
              this._parsePoints();
            }
            this.$element.css({
              'max-width': "".concat(newElemWidth - pdngl - pdngr, "px")
            });
            var newContainerHeight = this.$element[0].getBoundingClientRect().height || this.containerHeight;
            if (this.$element.css("display") == "none") {
              newContainerHeight = 0;
            }
            this.containerHeight = newContainerHeight;
            this.$container.css({
              height: newContainerHeight
            });
            this.elemHeight = newContainerHeight;
            if (!this.isStuck) {
              if (this.$element.hasClass('is-at-bottom')) {
                var anchorPt = (this.points ? this.points[1] - this.$container.offset().top : this.anchorHeight) - this.elemHeight;
                this.$element.css('top', anchorPt);
              }
            }
            this._setBreakPoints(newContainerHeight, function () {
              if (cb && typeof cb === 'function') {
                cb();
              }
            });
          }
          /**
           * Sets the upper and lower breakpoints for the element to become sticky/unsticky.
           * @param {Number} elemHeight - px value for sticky.$element height, calculated by `_setSizes`.
           * @param {Function} cb - optional callback function to be called on completion.
           * @private
           */
        }, {
          key: "_setBreakPoints",
          value: function _setBreakPoints(elemHeight, cb) {
            if (!this.canStick) {
              if (cb && typeof cb === 'function') {
                cb();
              } else {
                return false;
              }
            }
            var mTop = emCalc(this.options.marginTop),
              mBtm = emCalc(this.options.marginBottom),
              topPoint = this.points ? this.points[0] : this.$anchor.offset().top,
              bottomPoint = this.points ? this.points[1] : topPoint + this.anchorHeight,
              // topPoint = this.$anchor.offset().top || this.points[0],
              // bottomPoint = topPoint + this.anchorHeight || this.points[1],
              winHeight = window.innerHeight;
            if (this.options.stickTo === 'top') {
              topPoint -= mTop;
              bottomPoint -= elemHeight + mTop;
            } else if (this.options.stickTo === 'bottom') {
              topPoint -= winHeight - (elemHeight + mBtm);
              bottomPoint -= winHeight - mBtm;
            } else {//this would be the stickTo: both option... tricky
            }
            this.topPoint = topPoint;
            this.bottomPoint = bottomPoint;
            if (cb && typeof cb === 'function') {
              cb();
            }
          }
          /**
           * Destroys the current sticky element.
           * Resets the element to the top position first.
           * Removes event listeners, JS-added css properties and classes, and unwraps the $element if the JS added the $container.
           * @function
           */
        }, {
          key: "_destroy",
          value: function _destroy() {
            this._removeSticky(true);
            this.$element.removeClass("".concat(this.options.stickyClass, " is-anchored is-at-top")).css({
              height: '',
              top: '',
              bottom: '',
              'max-width': ''
            }).off('resizeme.zf.trigger').off('mutateme.zf.trigger');
            if (this.$anchor && this.$anchor.length) {
              this.$anchor.off('change.zf.sticky');
            }
            if (this.scrollListener) jquery__WEBPACK_IMPORTED_MODULE_0___default()(window).off(this.scrollListener);
            if (this.onLoadListener) jquery__WEBPACK_IMPORTED_MODULE_0___default()(window).off(this.onLoadListener);
            if (this.wasWrapped) {
              this.$element.unwrap();
            } else {
              this.$container.removeClass(this.options.containerClass).css({
                height: ''
              });
            }
          }
        }]);
        return Sticky;
      }(_foundation_core_plugin__WEBPACK_IMPORTED_MODULE_3__["Plugin"]);
      Sticky.defaults = {
        /**
         * Customizable container template. Add your own classes for styling and sizing.
         * @option
         * @type {string}
         * @default '&lt;div data-sticky-container&gt;&lt;/div&gt;'
         */
        container: '<div data-sticky-container></div>',
        /**
         * Location in the view the element sticks to. Can be `'top'` or `'bottom'`.
         * @option
         * @type {string}
         * @default 'top'
         */
        stickTo: 'top',
        /**
         * If anchored to a single element, the id of that element.
         * @option
         * @type {string}
         * @default ''
         */
        anchor: '',
        /**
         * If using more than one element as anchor points, the id of the top anchor.
         * @option
         * @type {string}
         * @default ''
         */
        topAnchor: '',
        /**
         * If using more than one element as anchor points, the id of the bottom anchor.
         * @option
         * @type {string}
         * @default ''
         */
        btmAnchor: '',
        /**
         * Margin, in `em`'s to apply to the top of the element when it becomes sticky.
         * @option
         * @type {number}
         * @default 1
         */
        marginTop: 1,
        /**
         * Margin, in `em`'s to apply to the bottom of the element when it becomes sticky.
         * @option
         * @type {number}
         * @default 1
         */
        marginBottom: 1,
        /**
         * Breakpoint string that is the minimum screen size an element should become sticky.
         * @option
         * @type {string}
         * @default 'medium'
         */
        stickyOn: 'medium',
        /**
         * Class applied to sticky element, and removed on destruction. Foundation defaults to `sticky`.
         * @option
         * @type {string}
         * @default 'sticky'
         */
        stickyClass: 'sticky',
        /**
         * Class applied to sticky container. Foundation defaults to `sticky-container`.
         * @option
         * @type {string}
         * @default 'sticky-container'
         */
        containerClass: 'sticky-container',
        /**
         * Number of scroll events between the plugin's recalculating sticky points. Setting it to `0` will cause it to recalc every scroll event, setting it to `-1` will prevent recalc on scroll.
         * @option
         * @type {number}
         * @default -1
         */
        checkEvery: -1
      };
      /**
       * Helper function to calculate em values
       * @param Number {em} - number of em's to calculate into pixels
       */

      function emCalc(em) {
        return parseInt(window.getComputedStyle(document.body, null).fontSize, 10) * em;
      }

      /***/
    }),
    /***/"./js/foundation.tabs.js": (
    /*!*******************************!*\
      !*** ./js/foundation.tabs.js ***!
      \*******************************/
    /*! exports provided: Tabs */
    /***/
    function _js_foundationTabsJs(module, __webpack_exports__, __webpack_require__) {
      "use strict";

      __webpack_require__.r(__webpack_exports__);
      /* harmony export (binding) */
      __webpack_require__.d(__webpack_exports__, "Tabs", function () {
        return Tabs;
      });
      /* harmony import */
      var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! jquery */"jquery");
      /* harmony import */
      var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);
      /* harmony import */
      var _foundation_core_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./foundation.core.utils */"./js/foundation.core.utils.js");
      /* harmony import */
      var _foundation_util_keyboard__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./foundation.util.keyboard */"./js/foundation.util.keyboard.js");
      /* harmony import */
      var _foundation_util_imageLoader__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./foundation.util.imageLoader */"./js/foundation.util.imageLoader.js");
      /* harmony import */
      var _foundation_core_plugin__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./foundation.core.plugin */"./js/foundation.core.plugin.js");
      function _typeof(obj) {
        if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
          _typeof = function _typeof(obj) {
            return _typeof2(obj);
          };
        } else {
          _typeof = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
          };
        }
        return _typeof(obj);
      }
      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }
      function _defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }
      function _createClass(Constructor, protoProps, staticProps) {
        if (protoProps) _defineProperties(Constructor.prototype, protoProps);
        if (staticProps) _defineProperties(Constructor, staticProps);
        return Constructor;
      }
      function _possibleConstructorReturn(self, call) {
        if (call && (_typeof(call) === "object" || typeof call === "function")) {
          return call;
        }
        return _assertThisInitialized(self);
      }
      function _assertThisInitialized(self) {
        if (self === void 0) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }
        return self;
      }
      function _getPrototypeOf(o) {
        _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
          return o.__proto__ || Object.getPrototypeOf(o);
        };
        return _getPrototypeOf(o);
      }
      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function");
        }
        subClass.prototype = Object.create(superClass && superClass.prototype, {
          constructor: {
            value: subClass,
            writable: true,
            configurable: true
          }
        });
        if (superClass) _setPrototypeOf(subClass, superClass);
      }
      function _setPrototypeOf(o, p) {
        _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
          o.__proto__ = p;
          return o;
        };
        return _setPrototypeOf(o, p);
      }

      /**
       * Tabs module.
       * @module foundation.tabs
       * @requires foundation.util.keyboard
       * @requires foundation.util.imageLoader if tabs contain images
       */

      var Tabs = /*#__PURE__*/
      function (_Plugin) {
        _inherits(Tabs, _Plugin);
        function Tabs() {
          _classCallCheck(this, Tabs);
          return _possibleConstructorReturn(this, _getPrototypeOf(Tabs).apply(this, arguments));
        }
        _createClass(Tabs, [{
          key: "_setup",
          /**
           * Creates a new instance of tabs.
           * @class
           * @name Tabs
           * @fires Tabs#init
           * @param {jQuery} element - jQuery object to make into tabs.
           * @param {Object} options - Overrides to the default plugin settings.
           */
          value: function _setup(element, options) {
            this.$element = element;
            this.options = jquery__WEBPACK_IMPORTED_MODULE_0___default.a.extend({}, Tabs.defaults, this.$element.data(), options);
            this.className = 'Tabs'; // ie9 back compat

            this._init();
            _foundation_util_keyboard__WEBPACK_IMPORTED_MODULE_2__["Keyboard"].register('Tabs', {
              'ENTER': 'open',
              'SPACE': 'open',
              'ARROW_RIGHT': 'next',
              'ARROW_UP': 'previous',
              'ARROW_DOWN': 'next',
              'ARROW_LEFT': 'previous' // 'TAB': 'next',
              // 'SHIFT_TAB': 'previous'
            });
          }
          /**
           * Initializes the tabs by showing and focusing (if autoFocus=true) the preset active tab.
           * @private
           */
        }, {
          key: "_init",
          value: function _init() {
            var _this2 = this;
            var _this = this;
            this._isInitializing = true;
            this.$element.attr({
              'role': 'tablist'
            });
            this.$tabTitles = this.$element.find(".".concat(this.options.linkClass));
            this.$tabContent = jquery__WEBPACK_IMPORTED_MODULE_0___default()("[data-tabs-content=\"".concat(this.$element[0].id, "\"]"));
            this.$tabTitles.each(function () {
              var $elem = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this),
                $link = $elem.find('a'),
                isActive = $elem.hasClass("".concat(_this.options.linkActiveClass)),
                hash = $link.attr('data-tabs-target') || $link[0].hash.slice(1),
                linkId = $link[0].id ? $link[0].id : "".concat(hash, "-label"),
                $tabContent = jquery__WEBPACK_IMPORTED_MODULE_0___default()("#".concat(hash));
              $elem.attr({
                'role': 'presentation'
              });
              $link.attr({
                'role': 'tab',
                'aria-controls': hash,
                'aria-selected': isActive,
                'id': linkId,
                'tabindex': isActive ? '0' : '-1'
              });
              $tabContent.attr({
                'role': 'tabpanel',
                'aria-labelledby': linkId
              }); // Save up the initial hash to return to it later when going back in history

              if (isActive) {
                _this._initialAnchor = "#".concat(hash);
              }
              if (!isActive) {
                $tabContent.attr('aria-hidden', 'true');
              }
              if (isActive && _this.options.autoFocus) {
                _this.onLoadListener = Object(_foundation_core_utils__WEBPACK_IMPORTED_MODULE_1__["onLoad"])(jquery__WEBPACK_IMPORTED_MODULE_0___default()(window), function () {
                  jquery__WEBPACK_IMPORTED_MODULE_0___default()('html, body').animate({
                    scrollTop: $elem.offset().top
                  }, _this.options.deepLinkSmudgeDelay, function () {
                    $link.focus();
                  });
                });
              }
            });
            if (this.options.matchHeight) {
              var $images = this.$tabContent.find('img');
              if ($images.length) {
                Object(_foundation_util_imageLoader__WEBPACK_IMPORTED_MODULE_3__["onImagesLoaded"])($images, this._setHeight.bind(this));
              } else {
                this._setHeight();
              }
            } // Current context-bound function to open tabs on page load or history hashchange

            this._checkDeepLink = function () {
              var anchor = window.location.hash;
              if (!anchor.length) {
                // If we are still initializing and there is no anchor, then there is nothing to do
                if (_this2._isInitializing) return; // Otherwise, move to the initial anchor

                if (_this2._initialAnchor) anchor = _this2._initialAnchor;
              }
              var $anchor = anchor && jquery__WEBPACK_IMPORTED_MODULE_0___default()(anchor);
              var $link = anchor && _this2.$element.find('[href$="' + anchor + '"]'); // Whether the anchor element that has been found is part of this element

              var isOwnAnchor = !!($anchor.length && $link.length); // If there is an anchor for the hash, select it

              if ($anchor && $anchor.length && $link && $link.length) {
                _this2.selectTab($anchor, true);
              } // Otherwise, collapse everything
              else {
                _this2._collapse();
              }
              if (isOwnAnchor) {
                // Roll up a little to show the titles
                if (_this2.options.deepLinkSmudge) {
                  var offset = _this2.$element.offset();
                  jquery__WEBPACK_IMPORTED_MODULE_0___default()('html, body').animate({
                    scrollTop: offset.top
                  }, _this2.options.deepLinkSmudgeDelay);
                }
                /**
                 * Fires when the plugin has deeplinked at pageload
                 * @event Tabs#deeplink
                 */

                _this2.$element.trigger('deeplink.zf.tabs', [$link, $anchor]);
              }
            }; //use browser to open a tab, if it exists in this tabset

            if (this.options.deepLink) {
              this._checkDeepLink();
            }
            this._events();
            this._isInitializing = false;
          }
          /**
           * Adds event handlers for items within the tabs.
           * @private
           */
        }, {
          key: "_events",
          value: function _events() {
            this._addKeyHandler();
            this._addClickHandler();
            this._setHeightMqHandler = null;
            if (this.options.matchHeight) {
              this._setHeightMqHandler = this._setHeight.bind(this);
              jquery__WEBPACK_IMPORTED_MODULE_0___default()(window).on('changed.zf.mediaquery', this._setHeightMqHandler);
            }
            if (this.options.deepLink) {
              jquery__WEBPACK_IMPORTED_MODULE_0___default()(window).on('hashchange', this._checkDeepLink);
            }
          }
          /**
           * Adds click handlers for items within the tabs.
           * @private
           */
        }, {
          key: "_addClickHandler",
          value: function _addClickHandler() {
            var _this = this;
            this.$element.off('click.zf.tabs').on('click.zf.tabs', ".".concat(this.options.linkClass), function (e) {
              e.preventDefault();
              e.stopPropagation();
              _this._handleTabChange(jquery__WEBPACK_IMPORTED_MODULE_0___default()(this));
            });
          }
          /**
           * Adds keyboard event handlers for items within the tabs.
           * @private
           */
        }, {
          key: "_addKeyHandler",
          value: function _addKeyHandler() {
            var _this = this;
            this.$tabTitles.off('keydown.zf.tabs').on('keydown.zf.tabs', function (e) {
              if (e.which === 9) return;
              var $element = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this),
                $elements = $element.parent('ul').children('li'),
                $prevElement,
                $nextElement;
              $elements.each(function (i) {
                if (jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).is($element)) {
                  if (_this.options.wrapOnKeys) {
                    $prevElement = i === 0 ? $elements.last() : $elements.eq(i - 1);
                    $nextElement = i === $elements.length - 1 ? $elements.first() : $elements.eq(i + 1);
                  } else {
                    $prevElement = $elements.eq(Math.max(0, i - 1));
                    $nextElement = $elements.eq(Math.min(i + 1, $elements.length - 1));
                  }
                  return;
                }
              }); // handle keyboard event with keyboard util

              _foundation_util_keyboard__WEBPACK_IMPORTED_MODULE_2__["Keyboard"].handleKey(e, 'Tabs', {
                open: function open() {
                  $element.find('[role="tab"]').focus();
                  _this._handleTabChange($element);
                },
                previous: function previous() {
                  $prevElement.find('[role="tab"]').focus();
                  _this._handleTabChange($prevElement);
                },
                next: function next() {
                  $nextElement.find('[role="tab"]').focus();
                  _this._handleTabChange($nextElement);
                },
                handled: function handled() {
                  e.stopPropagation();
                  e.preventDefault();
                }
              });
            });
          }
          /**
           * Opens the tab `$targetContent` defined by `$target`. Collapses active tab.
           * @param {jQuery} $target - Tab to open.
           * @param {boolean} historyHandled - browser has already handled a history update
           * @fires Tabs#change
           * @function
           */
        }, {
          key: "_handleTabChange",
          value: function _handleTabChange($target, historyHandled) {
            // With `activeCollapse`, if the target is the active Tab, collapse it.
            if ($target.hasClass("".concat(this.options.linkActiveClass))) {
              if (this.options.activeCollapse) {
                this._collapse();
              }
              return;
            }
            var $oldTab = this.$element.find(".".concat(this.options.linkClass, ".").concat(this.options.linkActiveClass)),
              $tabLink = $target.find('[role="tab"]'),
              target = $tabLink.attr('data-tabs-target'),
              anchor = target && target.length ? "#".concat(target) : $tabLink[0].hash,
              $targetContent = this.$tabContent.find(anchor); //close old tab

            this._collapseTab($oldTab); //open new tab

            this._openTab($target); //either replace or update browser history

            if (this.options.deepLink && !historyHandled) {
              if (this.options.updateHistory) {
                history.pushState({}, '', anchor);
              } else {
                history.replaceState({}, '', anchor);
              }
            }
            /**
             * Fires when the plugin has successfully changed tabs.
             * @event Tabs#change
             */

            this.$element.trigger('change.zf.tabs', [$target, $targetContent]); //fire to children a mutation event

            $targetContent.find("[data-mutate]").trigger("mutateme.zf.trigger");
          }
          /**
           * Opens the tab `$targetContent` defined by `$target`.
           * @param {jQuery} $target - Tab to open.
           * @function
           */
        }, {
          key: "_openTab",
          value: function _openTab($target) {
            var $tabLink = $target.find('[role="tab"]'),
              hash = $tabLink.attr('data-tabs-target') || $tabLink[0].hash.slice(1),
              $targetContent = this.$tabContent.find("#".concat(hash));
            $target.addClass("".concat(this.options.linkActiveClass));
            $tabLink.attr({
              'aria-selected': 'true',
              'tabindex': '0'
            });
            $targetContent.addClass("".concat(this.options.panelActiveClass)).removeAttr('aria-hidden');
          }
          /**
           * Collapses `$targetContent` defined by `$target`.
           * @param {jQuery} $target - Tab to collapse.
           * @function
           */
        }, {
          key: "_collapseTab",
          value: function _collapseTab($target) {
            var $target_anchor = $target.removeClass("".concat(this.options.linkActiveClass)).find('[role="tab"]').attr({
              'aria-selected': 'false',
              'tabindex': -1
            });
            jquery__WEBPACK_IMPORTED_MODULE_0___default()("#".concat($target_anchor.attr('aria-controls'))).removeClass("".concat(this.options.panelActiveClass)).attr({
              'aria-hidden': 'true'
            });
          }
          /**
           * Collapses the active Tab.
           * @fires Tabs#collapse
           * @function
           */
        }, {
          key: "_collapse",
          value: function _collapse() {
            var $activeTab = this.$element.find(".".concat(this.options.linkClass, ".").concat(this.options.linkActiveClass));
            if ($activeTab.length) {
              this._collapseTab($activeTab);
              /**
              * Fires when the plugin has successfully collapsed tabs.
              * @event Tabs#collapse
              */

              this.$element.trigger('collapse.zf.tabs', [$activeTab]);
            }
          }
          /**
           * Public method for selecting a content pane to display.
           * @param {jQuery | String} elem - jQuery object or string of the id of the pane to display.
           * @param {boolean} historyHandled - browser has already handled a history update
           * @function
           */
        }, {
          key: "selectTab",
          value: function selectTab(elem, historyHandled) {
            var idStr;
            if (_typeof(elem) === 'object') {
              idStr = elem[0].id;
            } else {
              idStr = elem;
            }
            if (idStr.indexOf('#') < 0) {
              idStr = "#".concat(idStr);
            }
            var $target = this.$tabTitles.has("[href$=\"".concat(idStr, "\"]"));
            this._handleTabChange($target, historyHandled);
          }
        }, {
          key: "_setHeight",
          /**
           * Sets the height of each panel to the height of the tallest panel.
           * If enabled in options, gets called on media query change.
           * If loading content via external source, can be called directly or with _reflow.
           * If enabled with `data-match-height="true"`, tabs sets to equal height
           * @function
           * @private
           */
          value: function _setHeight() {
            var max = 0,
              _this = this; // Lock down the `this` value for the root tabs object

            this.$tabContent.find(".".concat(this.options.panelClass)).css('height', '').each(function () {
              var panel = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this),
                isActive = panel.hasClass("".concat(_this.options.panelActiveClass)); // get the options from the parent instead of trying to get them from the child

              if (!isActive) {
                panel.css({
                  'visibility': 'hidden',
                  'display': 'block'
                });
              }
              var temp = this.getBoundingClientRect().height;
              if (!isActive) {
                panel.css({
                  'visibility': '',
                  'display': ''
                });
              }
              max = temp > max ? temp : max;
            }).css('height', "".concat(max, "px"));
          }
          /**
           * Destroys an instance of tabs.
           * @fires Tabs#destroyed
           */
        }, {
          key: "_destroy",
          value: function _destroy() {
            this.$element.find(".".concat(this.options.linkClass)).off('.zf.tabs').hide().end().find(".".concat(this.options.panelClass)).hide();
            if (this.options.matchHeight) {
              if (this._setHeightMqHandler != null) {
                jquery__WEBPACK_IMPORTED_MODULE_0___default()(window).off('changed.zf.mediaquery', this._setHeightMqHandler);
              }
            }
            if (this.options.deepLink) {
              jquery__WEBPACK_IMPORTED_MODULE_0___default()(window).off('hashchange', this._checkDeepLink);
            }
            if (this.onLoadListener) {
              jquery__WEBPACK_IMPORTED_MODULE_0___default()(window).off(this.onLoadListener);
            }
          }
        }]);
        return Tabs;
      }(_foundation_core_plugin__WEBPACK_IMPORTED_MODULE_4__["Plugin"]);
      Tabs.defaults = {
        /**
         * Link the location hash to the active pane.
         * Set the location hash when the active pane changes, and open the corresponding pane when the location changes.
         * @option
         * @type {boolean}
         * @default false
         */
        deepLink: false,
        /**
         * If `deepLink` is enabled, adjust the deep link scroll to make sure the top of the tab panel is visible
         * @option
         * @type {boolean}
         * @default false
         */
        deepLinkSmudge: false,
        /**
         * If `deepLinkSmudge` is enabled, animation time (ms) for the deep link adjustment
         * @option
         * @type {number}
         * @default 300
         */
        deepLinkSmudgeDelay: 300,
        /**
         * If `deepLink` is enabled, update the browser history with the open tab
         * @option
         * @type {boolean}
         * @default false
         */
        updateHistory: false,
        /**
         * Allows the window to scroll to content of active pane on load.
         * Not recommended if more than one tab panel per page.
         * @option
         * @type {boolean}
         * @default false
         */
        autoFocus: false,
        /**
         * Allows keyboard input to 'wrap' around the tab links.
         * @option
         * @type {boolean}
         * @default true
         */
        wrapOnKeys: true,
        /**
         * Allows the tab content panes to match heights if set to true.
         * @option
         * @type {boolean}
         * @default false
         */
        matchHeight: false,
        /**
         * Allows active tabs to collapse when clicked.
         * @option
         * @type {boolean}
         * @default false
         */
        activeCollapse: false,
        /**
         * Class applied to `li`'s in tab link list.
         * @option
         * @type {string}
         * @default 'tabs-title'
         */
        linkClass: 'tabs-title',
        /**
         * Class applied to the active `li` in tab link list.
         * @option
         * @type {string}
         * @default 'is-active'
         */
        linkActiveClass: 'is-active',
        /**
         * Class applied to the content containers.
         * @option
         * @type {string}
         * @default 'tabs-panel'
         */
        panelClass: 'tabs-panel',
        /**
         * Class applied to the active content container.
         * @option
         * @type {string}
         * @default 'is-active'
         */
        panelActiveClass: 'is-active'
      };

      /***/
    }),
    /***/"./js/foundation.toggler.js": (
    /*!**********************************!*\
      !*** ./js/foundation.toggler.js ***!
      \**********************************/
    /*! exports provided: Toggler */
    /***/
    function _js_foundationTogglerJs(module, __webpack_exports__, __webpack_require__) {
      "use strict";

      __webpack_require__.r(__webpack_exports__);
      /* harmony export (binding) */
      __webpack_require__.d(__webpack_exports__, "Toggler", function () {
        return Toggler;
      });
      /* harmony import */
      var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! jquery */"jquery");
      /* harmony import */
      var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);
      /* harmony import */
      var _foundation_util_motion__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./foundation.util.motion */"./js/foundation.util.motion.js");
      /* harmony import */
      var _foundation_core_plugin__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./foundation.core.plugin */"./js/foundation.core.plugin.js");
      /* harmony import */
      var _foundation_core_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./foundation.core.utils */"./js/foundation.core.utils.js");
      /* harmony import */
      var _foundation_util_triggers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./foundation.util.triggers */"./js/foundation.util.triggers.js");
      function _typeof(obj) {
        if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
          _typeof = function _typeof(obj) {
            return _typeof2(obj);
          };
        } else {
          _typeof = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
          };
        }
        return _typeof(obj);
      }
      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }
      function _defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }
      function _createClass(Constructor, protoProps, staticProps) {
        if (protoProps) _defineProperties(Constructor.prototype, protoProps);
        if (staticProps) _defineProperties(Constructor, staticProps);
        return Constructor;
      }
      function _possibleConstructorReturn(self, call) {
        if (call && (_typeof(call) === "object" || typeof call === "function")) {
          return call;
        }
        return _assertThisInitialized(self);
      }
      function _assertThisInitialized(self) {
        if (self === void 0) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }
        return self;
      }
      function _getPrototypeOf(o) {
        _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
          return o.__proto__ || Object.getPrototypeOf(o);
        };
        return _getPrototypeOf(o);
      }
      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function");
        }
        subClass.prototype = Object.create(superClass && superClass.prototype, {
          constructor: {
            value: subClass,
            writable: true,
            configurable: true
          }
        });
        if (superClass) _setPrototypeOf(subClass, superClass);
      }
      function _setPrototypeOf(o, p) {
        _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
          o.__proto__ = p;
          return o;
        };
        return _setPrototypeOf(o, p);
      }

      /**
       * Toggler module.
       * @module foundation.toggler
       * @requires foundation.util.motion
       * @requires foundation.util.triggers
       */

      var Toggler = /*#__PURE__*/
      function (_Plugin) {
        _inherits(Toggler, _Plugin);
        function Toggler() {
          _classCallCheck(this, Toggler);
          return _possibleConstructorReturn(this, _getPrototypeOf(Toggler).apply(this, arguments));
        }
        _createClass(Toggler, [{
          key: "_setup",
          /**
           * Creates a new instance of Toggler.
           * @class
           * @name Toggler
           * @fires Toggler#init
           * @param {Object} element - jQuery object to add the trigger to.
           * @param {Object} options - Overrides to the default plugin settings.
           */
          value: function _setup(element, options) {
            this.$element = element;
            this.options = jquery__WEBPACK_IMPORTED_MODULE_0___default.a.extend({}, Toggler.defaults, element.data(), options);
            this.className = '';
            this.className = 'Toggler'; // ie9 back compat
            // Triggers init is idempotent, just need to make sure it is initialized

            _foundation_util_triggers__WEBPACK_IMPORTED_MODULE_4__["Triggers"].init(jquery__WEBPACK_IMPORTED_MODULE_0___default.a);
            this._init();
            this._events();
          }
          /**
           * Initializes the Toggler plugin by parsing the toggle class from data-toggler, or animation classes from data-animate.
           * @function
           * @private
           */
        }, {
          key: "_init",
          value: function _init() {
            var input; // Parse animation classes if they were set

            if (this.options.animate) {
              input = this.options.animate.split(' ');
              this.animationIn = input[0];
              this.animationOut = input[1] || null;
            } // Otherwise, parse toggle class
            else {
              input = this.$element.data('toggler'); // Allow for a . at the beginning of the string

              this.className = input[0] === '.' ? input.slice(1) : input;
            } // Add ARIA attributes to triggers:

            var id = this.$element[0].id,
              $triggers = jquery__WEBPACK_IMPORTED_MODULE_0___default()("[data-open~=\"".concat(id, "\"], [data-close~=\"").concat(id, "\"], [data-toggle~=\"").concat(id, "\"]")); // - aria-expanded: according to the element visibility.

            $triggers.attr('aria-expanded', !this.$element.is(':hidden')); // - aria-controls: adding the element id to it if not already in it.

            $triggers.each(function (index, trigger) {
              var $trigger = jquery__WEBPACK_IMPORTED_MODULE_0___default()(trigger);
              var controls = $trigger.attr('aria-controls') || '';
              var containsId = new RegExp("\\b".concat(Object(_foundation_core_utils__WEBPACK_IMPORTED_MODULE_3__["RegExpEscape"])(id), "\\b")).test(controls);
              if (!containsId) $trigger.attr('aria-controls', controls ? "".concat(controls, " ").concat(id) : id);
            });
          }
          /**
           * Initializes events for the toggle trigger.
           * @function
           * @private
           */
        }, {
          key: "_events",
          value: function _events() {
            this.$element.off('toggle.zf.trigger').on('toggle.zf.trigger', this.toggle.bind(this));
          }
          /**
           * Toggles the target class on the target element. An event is fired from the original trigger depending on if the resultant state was "on" or "off".
           * @function
           * @fires Toggler#on
           * @fires Toggler#off
           */
        }, {
          key: "toggle",
          value: function toggle() {
            this[this.options.animate ? '_toggleAnimate' : '_toggleClass']();
          }
        }, {
          key: "_toggleClass",
          value: function _toggleClass() {
            this.$element.toggleClass(this.className);
            var isOn = this.$element.hasClass(this.className);
            if (isOn) {
              /**
               * Fires if the target element has the class after a toggle.
               * @event Toggler#on
               */
              this.$element.trigger('on.zf.toggler');
            } else {
              /**
               * Fires if the target element does not have the class after a toggle.
               * @event Toggler#off
               */
              this.$element.trigger('off.zf.toggler');
            }
            this._updateARIA(isOn);
            this.$element.find('[data-mutate]').trigger('mutateme.zf.trigger');
          }
        }, {
          key: "_toggleAnimate",
          value: function _toggleAnimate() {
            var _this = this;
            if (this.$element.is(':hidden')) {
              _foundation_util_motion__WEBPACK_IMPORTED_MODULE_1__["Motion"].animateIn(this.$element, this.animationIn, function () {
                _this._updateARIA(true);
                this.trigger('on.zf.toggler');
                this.find('[data-mutate]').trigger('mutateme.zf.trigger');
              });
            } else {
              _foundation_util_motion__WEBPACK_IMPORTED_MODULE_1__["Motion"].animateOut(this.$element, this.animationOut, function () {
                _this._updateARIA(false);
                this.trigger('off.zf.toggler');
                this.find('[data-mutate]').trigger('mutateme.zf.trigger');
              });
            }
          }
        }, {
          key: "_updateARIA",
          value: function _updateARIA(isOn) {
            var id = this.$element[0].id;
            jquery__WEBPACK_IMPORTED_MODULE_0___default()("[data-open=\"".concat(id, "\"], [data-close=\"").concat(id, "\"], [data-toggle=\"").concat(id, "\"]")).attr({
              'aria-expanded': isOn ? true : false
            });
          }
          /**
           * Destroys the instance of Toggler on the element.
           * @function
           */
        }, {
          key: "_destroy",
          value: function _destroy() {
            this.$element.off('.zf.toggler');
          }
        }]);
        return Toggler;
      }(_foundation_core_plugin__WEBPACK_IMPORTED_MODULE_2__["Plugin"]);
      Toggler.defaults = {
        /**
         * Tells the plugin if the element should animated when toggled.
         * @option
         * @type {boolean}
         * @default false
         */
        animate: false
      };

      /***/
    }),
    /***/"./js/foundation.tooltip.js": (
    /*!**********************************!*\
      !*** ./js/foundation.tooltip.js ***!
      \**********************************/
    /*! exports provided: Tooltip */
    /***/
    function _js_foundationTooltipJs(module, __webpack_exports__, __webpack_require__) {
      "use strict";

      __webpack_require__.r(__webpack_exports__);
      /* harmony export (binding) */
      __webpack_require__.d(__webpack_exports__, "Tooltip", function () {
        return Tooltip;
      });
      /* harmony import */
      var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! jquery */"jquery");
      /* harmony import */
      var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);
      /* harmony import */
      var _foundation_core_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./foundation.core.utils */"./js/foundation.core.utils.js");
      /* harmony import */
      var _foundation_util_mediaQuery__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./foundation.util.mediaQuery */"./js/foundation.util.mediaQuery.js");
      /* harmony import */
      var _foundation_util_triggers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./foundation.util.triggers */"./js/foundation.util.triggers.js");
      /* harmony import */
      var _foundation_positionable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./foundation.positionable */"./js/foundation.positionable.js");
      function _typeof(obj) {
        if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
          _typeof = function _typeof(obj) {
            return _typeof2(obj);
          };
        } else {
          _typeof = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
          };
        }
        return _typeof(obj);
      }
      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }
      function _defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }
      function _createClass(Constructor, protoProps, staticProps) {
        if (protoProps) _defineProperties(Constructor.prototype, protoProps);
        if (staticProps) _defineProperties(Constructor, staticProps);
        return Constructor;
      }
      function _possibleConstructorReturn(self, call) {
        if (call && (_typeof(call) === "object" || typeof call === "function")) {
          return call;
        }
        return _assertThisInitialized(self);
      }
      function _assertThisInitialized(self) {
        if (self === void 0) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }
        return self;
      }
      function _get(target, property, receiver) {
        if (typeof Reflect !== "undefined" && Reflect.get) {
          _get = Reflect.get;
        } else {
          _get = function _get(target, property, receiver) {
            var base = _superPropBase(target, property);
            if (!base) return;
            var desc = Object.getOwnPropertyDescriptor(base, property);
            if (desc.get) {
              return desc.get.call(receiver);
            }
            return desc.value;
          };
        }
        return _get(target, property, receiver || target);
      }
      function _superPropBase(object, property) {
        while (!Object.prototype.hasOwnProperty.call(object, property)) {
          object = _getPrototypeOf(object);
          if (object === null) break;
        }
        return object;
      }
      function _getPrototypeOf(o) {
        _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
          return o.__proto__ || Object.getPrototypeOf(o);
        };
        return _getPrototypeOf(o);
      }
      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function");
        }
        subClass.prototype = Object.create(superClass && superClass.prototype, {
          constructor: {
            value: subClass,
            writable: true,
            configurable: true
          }
        });
        if (superClass) _setPrototypeOf(subClass, superClass);
      }
      function _setPrototypeOf(o, p) {
        _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
          o.__proto__ = p;
          return o;
        };
        return _setPrototypeOf(o, p);
      }

      /**
       * Tooltip module.
       * @module foundation.tooltip
       * @requires foundation.util.box
       * @requires foundation.util.mediaQuery
       * @requires foundation.util.triggers
       */

      var Tooltip = /*#__PURE__*/
      function (_Positionable) {
        _inherits(Tooltip, _Positionable);
        function Tooltip() {
          _classCallCheck(this, Tooltip);
          return _possibleConstructorReturn(this, _getPrototypeOf(Tooltip).apply(this, arguments));
        }
        _createClass(Tooltip, [{
          key: "_setup",
          /**
           * Creates a new instance of a Tooltip.
           * @class
           * @name Tooltip
           * @fires Tooltip#init
           * @param {jQuery} element - jQuery object to attach a tooltip to.
           * @param {Object} options - object to extend the default configuration.
           */
          value: function _setup(element, options) {
            this.$element = element;
            this.options = jquery__WEBPACK_IMPORTED_MODULE_0___default.a.extend({}, Tooltip.defaults, this.$element.data(), options);
            this.className = 'Tooltip'; // ie9 back compat

            this.isActive = false;
            this.isClick = false; // Triggers init is idempotent, just need to make sure it is initialized

            _foundation_util_triggers__WEBPACK_IMPORTED_MODULE_3__["Triggers"].init(jquery__WEBPACK_IMPORTED_MODULE_0___default.a);
            this._init();
          }
          /**
           * Initializes the tooltip by setting the creating the tip element, adding it's text, setting private variables and setting attributes on the anchor.
           * @private
           */
        }, {
          key: "_init",
          value: function _init() {
            _foundation_util_mediaQuery__WEBPACK_IMPORTED_MODULE_2__["MediaQuery"]._init();
            var elemId = this.$element.attr('aria-describedby') || Object(_foundation_core_utils__WEBPACK_IMPORTED_MODULE_1__["GetYoDigits"])(6, 'tooltip');
            this.options.tipText = this.options.tipText || this.$element.attr('title');
            this.template = this.options.template ? jquery__WEBPACK_IMPORTED_MODULE_0___default()(this.options.template) : this._buildTemplate(elemId);
            if (this.options.allowHtml) {
              this.template.appendTo(document.body).html(this.options.tipText).hide();
            } else {
              this.template.appendTo(document.body).text(this.options.tipText).hide();
            }
            this.$element.attr({
              'title': '',
              'aria-describedby': elemId,
              'data-yeti-box': elemId,
              'data-toggle': elemId,
              'data-resize': elemId
            }).addClass(this.options.triggerClass);
            _get(_getPrototypeOf(Tooltip.prototype), "_init", this).call(this);
            this._events();
          }
        }, {
          key: "_getDefaultPosition",
          value: function _getDefaultPosition() {
            // handle legacy classnames
            var position = this.$element[0].className.match(/\b(top|left|right|bottom)\b/g);
            return position ? position[0] : 'top';
          }
        }, {
          key: "_getDefaultAlignment",
          value: function _getDefaultAlignment() {
            return 'center';
          }
        }, {
          key: "_getHOffset",
          value: function _getHOffset() {
            if (this.position === 'left' || this.position === 'right') {
              return this.options.hOffset + this.options.tooltipWidth;
            } else {
              return this.options.hOffset;
            }
          }
        }, {
          key: "_getVOffset",
          value: function _getVOffset() {
            if (this.position === 'top' || this.position === 'bottom') {
              return this.options.vOffset + this.options.tooltipHeight;
            } else {
              return this.options.vOffset;
            }
          }
          /**
           * builds the tooltip element, adds attributes, and returns the template.
           * @private
           */
        }, {
          key: "_buildTemplate",
          value: function _buildTemplate(id) {
            var templateClasses = "".concat(this.options.tooltipClass, " ").concat(this.options.templateClasses).trim();
            var $template = jquery__WEBPACK_IMPORTED_MODULE_0___default()('<div></div>').addClass(templateClasses).attr({
              'role': 'tooltip',
              'aria-hidden': true,
              'data-is-active': false,
              'data-is-focus': false,
              'id': id
            });
            return $template;
          }
          /**
           * sets the position class of an element and recursively calls itself until there are no more possible positions to attempt, or the tooltip element is no longer colliding.
           * if the tooltip is larger than the screen width, default to full width - any user selected margin
           * @private
           */
        }, {
          key: "_setPosition",
          value: function _setPosition() {
            _get(_getPrototypeOf(Tooltip.prototype), "_setPosition", this).call(this, this.$element, this.template);
          }
          /**
           * reveals the tooltip, and fires an event to close any other open tooltips on the page
           * @fires Tooltip#closeme
           * @fires Tooltip#show
           * @function
           */
        }, {
          key: "show",
          value: function show() {
            if (this.options.showOn !== 'all' && !_foundation_util_mediaQuery__WEBPACK_IMPORTED_MODULE_2__["MediaQuery"].is(this.options.showOn)) {
              // console.error('The screen is too small to display this tooltip');
              return false;
            }
            var _this = this;
            this.template.css('visibility', 'hidden').show();
            this._setPosition();
            this.template.removeClass('top bottom left right').addClass(this.position);
            this.template.removeClass('align-top align-bottom align-left align-right align-center').addClass('align-' + this.alignment);
            /**
             * Fires to close all other open tooltips on the page
             * @event Closeme#tooltip
             */

            this.$element.trigger('closeme.zf.tooltip', this.template.attr('id'));
            this.template.attr({
              'data-is-active': true,
              'aria-hidden': false
            });
            _this.isActive = true; // console.log(this.template);

            this.template.stop().hide().css('visibility', '').fadeIn(this.options.fadeInDuration, function () {//maybe do stuff?
            });
            /**
             * Fires when the tooltip is shown
             * @event Tooltip#show
             */

            this.$element.trigger('show.zf.tooltip');
          }
          /**
           * Hides the current tooltip, and resets the positioning class if it was changed due to collision
           * @fires Tooltip#hide
           * @function
           */
        }, {
          key: "hide",
          value: function hide() {
            // console.log('hiding', this.$element.data('yeti-box'));
            var _this = this;
            this.template.stop().attr({
              'aria-hidden': true,
              'data-is-active': false
            }).fadeOut(this.options.fadeOutDuration, function () {
              _this.isActive = false;
              _this.isClick = false;
            });
            /**
             * fires when the tooltip is hidden
             * @event Tooltip#hide
             */

            this.$element.trigger('hide.zf.tooltip');
          }
          /**
           * adds event listeners for the tooltip and its anchor
           * TODO combine some of the listeners like focus and mouseenter, etc.
           * @private
           */
        }, {
          key: "_events",
          value: function _events() {
            var _this = this;
            var $template = this.template;
            var isFocus = false;
            if (!this.options.disableHover) {
              this.$element.on('mouseenter.zf.tooltip', function (e) {
                if (!_this.isActive) {
                  _this.timeout = setTimeout(function () {
                    _this.show();
                  }, _this.options.hoverDelay);
                }
              }).on('mouseleave.zf.tooltip', Object(_foundation_core_utils__WEBPACK_IMPORTED_MODULE_1__["ignoreMousedisappear"])(function (e) {
                clearTimeout(_this.timeout);
                if (!isFocus || _this.isClick && !_this.options.clickOpen) {
                  _this.hide();
                }
              }));
            }
            if (this.options.clickOpen) {
              this.$element.on('mousedown.zf.tooltip', function (e) {
                e.stopImmediatePropagation();
                if (_this.isClick) {//_this.hide();
                  // _this.isClick = false;
                } else {
                  _this.isClick = true;
                  if ((_this.options.disableHover || !_this.$element.attr('tabindex')) && !_this.isActive) {
                    _this.show();
                  }
                }
              });
            } else {
              this.$element.on('mousedown.zf.tooltip', function (e) {
                e.stopImmediatePropagation();
                _this.isClick = true;
              });
            }
            if (!this.options.disableForTouch) {
              this.$element.on('tap.zf.tooltip touchend.zf.tooltip', function (e) {
                _this.isActive ? _this.hide() : _this.show();
              });
            }
            this.$element.on({
              // 'toggle.zf.trigger': this.toggle.bind(this),
              // 'close.zf.trigger': this.hide.bind(this)
              'close.zf.trigger': this.hide.bind(this)
            });
            this.$element.on('focus.zf.tooltip', function (e) {
              isFocus = true;
              if (_this.isClick) {
                // If we're not showing open on clicks, we need to pretend a click-launched focus isn't
                // a real focus, otherwise on hover and come back we get bad behavior
                if (!_this.options.clickOpen) {
                  isFocus = false;
                }
                return false;
              } else {
                _this.show();
              }
            }).on('focusout.zf.tooltip', function (e) {
              isFocus = false;
              _this.isClick = false;
              _this.hide();
            }).on('resizeme.zf.trigger', function () {
              if (_this.isActive) {
                _this._setPosition();
              }
            });
          }
          /**
           * adds a toggle method, in addition to the static show() & hide() functions
           * @function
           */
        }, {
          key: "toggle",
          value: function toggle() {
            if (this.isActive) {
              this.hide();
            } else {
              this.show();
            }
          }
          /**
           * Destroys an instance of tooltip, removes template element from the view.
           * @function
           */
        }, {
          key: "_destroy",
          value: function _destroy() {
            this.$element.attr('title', this.template.text()).off('.zf.trigger .zf.tooltip').removeClass(this.options.triggerClass).removeClass('top right left bottom').removeAttr('aria-describedby data-disable-hover data-resize data-toggle data-tooltip data-yeti-box');
            this.template.remove();
          }
        }]);
        return Tooltip;
      }(_foundation_positionable__WEBPACK_IMPORTED_MODULE_4__["Positionable"]);
      Tooltip.defaults = {
        disableForTouch: false,
        /**
         * Time, in ms, before a tooltip should open on hover.
         * @option
         * @type {number}
         * @default 200
         */
        hoverDelay: 200,
        /**
         * Time, in ms, a tooltip should take to fade into view.
         * @option
         * @type {number}
         * @default 150
         */
        fadeInDuration: 150,
        /**
         * Time, in ms, a tooltip should take to fade out of view.
         * @option
         * @type {number}
         * @default 150
         */
        fadeOutDuration: 150,
        /**
         * Disables hover events from opening the tooltip if set to true
         * @option
         * @type {boolean}
         * @default false
         */
        disableHover: false,
        /**
         * Optional addtional classes to apply to the tooltip template on init.
         * @option
         * @type {string}
         * @default ''
         */
        templateClasses: '',
        /**
         * Non-optional class added to tooltip templates. Foundation default is 'tooltip'.
         * @option
         * @type {string}
         * @default 'tooltip'
         */
        tooltipClass: 'tooltip',
        /**
         * Class applied to the tooltip anchor element.
         * @option
         * @type {string}
         * @default 'has-tip'
         */
        triggerClass: 'has-tip',
        /**
         * Minimum breakpoint size at which to open the tooltip.
         * @option
         * @type {string}
         * @default 'small'
         */
        showOn: 'small',
        /**
         * Custom template to be used to generate markup for tooltip.
         * @option
         * @type {string}
         * @default ''
         */
        template: '',
        /**
         * Text displayed in the tooltip template on open.
         * @option
         * @type {string}
         * @default ''
         */
        tipText: '',
        touchCloseText: 'Tap to close.',
        /**
         * Allows the tooltip to remain open if triggered with a click or touch event.
         * @option
         * @type {boolean}
         * @default true
         */
        clickOpen: true,
        /**
         * Position of tooltip. Can be left, right, bottom, top, or auto.
         * @option
         * @type {string}
         * @default 'auto'
         */
        position: 'auto',
        /**
         * Alignment of tooltip relative to anchor. Can be left, right, bottom, top, center, or auto.
         * @option
         * @type {string}
         * @default 'auto'
         */
        alignment: 'auto',
        /**
         * Allow overlap of container/window. If false, tooltip will first try to
         * position as defined by data-position and data-alignment, but reposition if
         * it would cause an overflow.  @option
         * @type {boolean}
         * @default false
         */
        allowOverlap: false,
        /**
         * Allow overlap of only the bottom of the container. This is the most common
         * behavior for dropdowns, allowing the dropdown to extend the bottom of the
         * screen but not otherwise influence or break out of the container.
         * Less common for tooltips.
         * @option
         * @type {boolean}
         * @default false
         */
        allowBottomOverlap: false,
        /**
         * Distance, in pixels, the template should push away from the anchor on the Y axis.
         * @option
         * @type {number}
         * @default 0
         */
        vOffset: 0,
        /**
         * Distance, in pixels, the template should push away from the anchor on the X axis
         * @option
         * @type {number}
         * @default 0
         */
        hOffset: 0,
        /**
         * Distance, in pixels, the template spacing auto-adjust for a vertical tooltip
         * @option
         * @type {number}
         * @default 14
         */
        tooltipHeight: 14,
        /**
         * Distance, in pixels, the template spacing auto-adjust for a horizontal tooltip
         * @option
         * @type {number}
         * @default 12
         */
        tooltipWidth: 12,
        /**
        * Allow HTML in tooltip. Warning: If you are loading user-generated content into tooltips,
        * allowing HTML may open yourself up to XSS attacks.
        * @option
        * @type {boolean}
        * @default false
        */
        allowHtml: false
      };
      /**
       * TODO utilize resize event trigger
       */

      /***/
    }),
    /***/"./js/foundation.util.box.js": (
    /*!***********************************!*\
      !*** ./js/foundation.util.box.js ***!
      \***********************************/
    /*! exports provided: Box */
    /***/
    function _js_foundationUtilBoxJs(module, __webpack_exports__, __webpack_require__) {
      "use strict";

      __webpack_require__.r(__webpack_exports__);
      /* harmony export (binding) */
      __webpack_require__.d(__webpack_exports__, "Box", function () {
        return Box;
      });
      /* harmony import */
      var _foundation_core_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./foundation.core.utils */"./js/foundation.core.utils.js");
      var Box = {
        ImNotTouchingYou: ImNotTouchingYou,
        OverlapArea: OverlapArea,
        GetDimensions: GetDimensions,
        GetOffsets: GetOffsets,
        GetExplicitOffsets: GetExplicitOffsets
        /**
         * Compares the dimensions of an element to a container and determines collision events with container.
         * @function
         * @param {jQuery} element - jQuery object to test for collisions.
         * @param {jQuery} parent - jQuery object to use as bounding container.
         * @param {Boolean} lrOnly - set to true to check left and right values only.
         * @param {Boolean} tbOnly - set to true to check top and bottom values only.
         * @default if no parent object passed, detects collisions with `window`.
         * @returns {Boolean} - true if collision free, false if a collision in any direction.
         */
      };
      function ImNotTouchingYou(element, parent, lrOnly, tbOnly, ignoreBottom) {
        return OverlapArea(element, parent, lrOnly, tbOnly, ignoreBottom) === 0;
      }
      ;
      function OverlapArea(element, parent, lrOnly, tbOnly, ignoreBottom) {
        var eleDims = GetDimensions(element),
          topOver,
          bottomOver,
          leftOver,
          rightOver;
        if (parent) {
          var parDims = GetDimensions(parent);
          bottomOver = parDims.height + parDims.offset.top - (eleDims.offset.top + eleDims.height);
          topOver = eleDims.offset.top - parDims.offset.top;
          leftOver = eleDims.offset.left - parDims.offset.left;
          rightOver = parDims.width + parDims.offset.left - (eleDims.offset.left + eleDims.width);
        } else {
          bottomOver = eleDims.windowDims.height + eleDims.windowDims.offset.top - (eleDims.offset.top + eleDims.height);
          topOver = eleDims.offset.top - eleDims.windowDims.offset.top;
          leftOver = eleDims.offset.left - eleDims.windowDims.offset.left;
          rightOver = eleDims.windowDims.width - (eleDims.offset.left + eleDims.width);
        }
        bottomOver = ignoreBottom ? 0 : Math.min(bottomOver, 0);
        topOver = Math.min(topOver, 0);
        leftOver = Math.min(leftOver, 0);
        rightOver = Math.min(rightOver, 0);
        if (lrOnly) {
          return leftOver + rightOver;
        }
        if (tbOnly) {
          return topOver + bottomOver;
        } // use sum of squares b/c we care about overlap area.

        return Math.sqrt(topOver * topOver + bottomOver * bottomOver + leftOver * leftOver + rightOver * rightOver);
      }
      /**
       * Uses native methods to return an object of dimension values.
       * @function
       * @param {jQuery || HTML} element - jQuery object or DOM element for which to get the dimensions. Can be any element other that document or window.
       * @returns {Object} - nested object of integer pixel values
       * TODO - if element is window, return only those values.
       */

      function GetDimensions(elem) {
        elem = elem.length ? elem[0] : elem;
        if (elem === window || elem === document) {
          throw new Error("I'm sorry, Dave. I'm afraid I can't do that.");
        }
        var rect = elem.getBoundingClientRect(),
          parRect = elem.parentNode.getBoundingClientRect(),
          winRect = document.body.getBoundingClientRect(),
          winY = window.pageYOffset,
          winX = window.pageXOffset;
        return {
          width: rect.width,
          height: rect.height,
          offset: {
            top: rect.top + winY,
            left: rect.left + winX
          },
          parentDims: {
            width: parRect.width,
            height: parRect.height,
            offset: {
              top: parRect.top + winY,
              left: parRect.left + winX
            }
          },
          windowDims: {
            width: winRect.width,
            height: winRect.height,
            offset: {
              top: winY,
              left: winX
            }
          }
        };
      }
      /**
       * Returns an object of top and left integer pixel values for dynamically rendered elements,
       * such as: Tooltip, Reveal, and Dropdown. Maintained for backwards compatibility, and where
       * you don't know alignment, but generally from
       * 6.4 forward you should use GetExplicitOffsets, as GetOffsets conflates position and alignment.
       * @function
       * @param {jQuery} element - jQuery object for the element being positioned.
       * @param {jQuery} anchor - jQuery object for the element's anchor point.
       * @param {String} position - a string relating to the desired position of the element, relative to it's anchor
       * @param {Number} vOffset - integer pixel value of desired vertical separation between anchor and element.
       * @param {Number} hOffset - integer pixel value of desired horizontal separation between anchor and element.
       * @param {Boolean} isOverflow - if a collision event is detected, sets to true to default the element to full width - any desired offset.
       * TODO alter/rewrite to work with `em` values as well/instead of pixels
       */

      function GetOffsets(element, anchor, position, vOffset, hOffset, isOverflow) {
        console.log("NOTE: GetOffsets is deprecated in favor of GetExplicitOffsets and will be removed in 6.5");
        switch (position) {
          case 'top':
            return Object(_foundation_core_utils__WEBPACK_IMPORTED_MODULE_0__["rtl"])() ? GetExplicitOffsets(element, anchor, 'top', 'left', vOffset, hOffset, isOverflow) : GetExplicitOffsets(element, anchor, 'top', 'right', vOffset, hOffset, isOverflow);
          case 'bottom':
            return Object(_foundation_core_utils__WEBPACK_IMPORTED_MODULE_0__["rtl"])() ? GetExplicitOffsets(element, anchor, 'bottom', 'left', vOffset, hOffset, isOverflow) : GetExplicitOffsets(element, anchor, 'bottom', 'right', vOffset, hOffset, isOverflow);
          case 'center top':
            return GetExplicitOffsets(element, anchor, 'top', 'center', vOffset, hOffset, isOverflow);
          case 'center bottom':
            return GetExplicitOffsets(element, anchor, 'bottom', 'center', vOffset, hOffset, isOverflow);
          case 'center left':
            return GetExplicitOffsets(element, anchor, 'left', 'center', vOffset, hOffset, isOverflow);
          case 'center right':
            return GetExplicitOffsets(element, anchor, 'right', 'center', vOffset, hOffset, isOverflow);
          case 'left bottom':
            return GetExplicitOffsets(element, anchor, 'bottom', 'left', vOffset, hOffset, isOverflow);
          case 'right bottom':
            return GetExplicitOffsets(element, anchor, 'bottom', 'right', vOffset, hOffset, isOverflow);
          // Backwards compatibility... this along with the reveal and reveal full
          // classes are the only ones that didn't reference anchor

          case 'center':
            return {
              left: $eleDims.windowDims.offset.left + $eleDims.windowDims.width / 2 - $eleDims.width / 2 + hOffset,
              top: $eleDims.windowDims.offset.top + $eleDims.windowDims.height / 2 - ($eleDims.height / 2 + vOffset)
            };
          case 'reveal':
            return {
              left: ($eleDims.windowDims.width - $eleDims.width) / 2 + hOffset,
              top: $eleDims.windowDims.offset.top + vOffset
            };
          case 'reveal full':
            return {
              left: $eleDims.windowDims.offset.left,
              top: $eleDims.windowDims.offset.top
            };
            break;
          default:
            return {
              left: Object(_foundation_core_utils__WEBPACK_IMPORTED_MODULE_0__["rtl"])() ? $anchorDims.offset.left - $eleDims.width + $anchorDims.width - hOffset : $anchorDims.offset.left + hOffset,
              top: $anchorDims.offset.top + $anchorDims.height + vOffset
            };
        }
      }
      function GetExplicitOffsets(element, anchor, position, alignment, vOffset, hOffset, isOverflow) {
        var $eleDims = GetDimensions(element),
          $anchorDims = anchor ? GetDimensions(anchor) : null;
        var topVal, leftVal; // set position related attribute

        switch (position) {
          case 'top':
            topVal = $anchorDims.offset.top - ($eleDims.height + vOffset);
            break;
          case 'bottom':
            topVal = $anchorDims.offset.top + $anchorDims.height + vOffset;
            break;
          case 'left':
            leftVal = $anchorDims.offset.left - ($eleDims.width + hOffset);
            break;
          case 'right':
            leftVal = $anchorDims.offset.left + $anchorDims.width + hOffset;
            break;
        } // set alignment related attribute

        switch (position) {
          case 'top':
          case 'bottom':
            switch (alignment) {
              case 'left':
                leftVal = $anchorDims.offset.left + hOffset;
                break;
              case 'right':
                leftVal = $anchorDims.offset.left - $eleDims.width + $anchorDims.width - hOffset;
                break;
              case 'center':
                leftVal = isOverflow ? hOffset : $anchorDims.offset.left + $anchorDims.width / 2 - $eleDims.width / 2 + hOffset;
                break;
            }
            break;
          case 'right':
          case 'left':
            switch (alignment) {
              case 'bottom':
                topVal = $anchorDims.offset.top - vOffset + $anchorDims.height - $eleDims.height;
                break;
              case 'top':
                topVal = $anchorDims.offset.top + vOffset;
                break;
              case 'center':
                topVal = $anchorDims.offset.top + vOffset + $anchorDims.height / 2 - $eleDims.height / 2;
                break;
            }
            break;
        }
        return {
          top: topVal,
          left: leftVal
        };
      }

      /***/
    }),
    /***/"./js/foundation.util.imageLoader.js": (
    /*!*******************************************!*\
      !*** ./js/foundation.util.imageLoader.js ***!
      \*******************************************/
    /*! exports provided: onImagesLoaded */
    /***/
    function _js_foundationUtilImageLoaderJs(module, __webpack_exports__, __webpack_require__) {
      "use strict";

      __webpack_require__.r(__webpack_exports__);
      /* harmony export (binding) */
      __webpack_require__.d(__webpack_exports__, "onImagesLoaded", function () {
        return onImagesLoaded;
      });
      /* harmony import */
      var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! jquery */"jquery");
      /* harmony import */
      var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);

      /**
       * Runs a callback function when images are fully loaded.
       * @param {Object} images - Image(s) to check if loaded.
       * @param {Func} callback - Function to execute when image is fully loaded.
       */

      function onImagesLoaded(images, callback) {
        var self = this,
          unloaded = images.length;
        if (unloaded === 0) {
          callback();
        }
        images.each(function () {
          // Check if image is loaded
          if (this.complete && typeof this.naturalWidth !== 'undefined') {
            singleImageLoaded();
          } else {
            // If the above check failed, simulate loading on detached element.
            var image = new Image(); // Still count image as loaded if it finalizes with an error.

            var events = "load.zf.images error.zf.images";
            jquery__WEBPACK_IMPORTED_MODULE_0___default()(image).one(events, function me(event) {
              // Unbind the event listeners. We're using 'one' but only one of the two events will have fired.
              jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).off(events, me);
              singleImageLoaded();
            });
            image.src = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).attr('src');
          }
        });
        function singleImageLoaded() {
          unloaded--;
          if (unloaded === 0) {
            callback();
          }
        }
      }

      /***/
    }),
    /***/"./js/foundation.util.keyboard.js": (
    /*!****************************************!*\
      !*** ./js/foundation.util.keyboard.js ***!
      \****************************************/
    /*! exports provided: Keyboard */
    /***/
    function _js_foundationUtilKeyboardJs(module, __webpack_exports__, __webpack_require__) {
      "use strict";

      __webpack_require__.r(__webpack_exports__);
      /* harmony export (binding) */
      __webpack_require__.d(__webpack_exports__, "Keyboard", function () {
        return Keyboard;
      });
      /* harmony import */
      var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! jquery */"jquery");
      /* harmony import */
      var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);
      /* harmony import */
      var _foundation_core_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./foundation.core.utils */"./js/foundation.core.utils.js");
      /*******************************************
       *                                         *
       * This util was created by Marius Olbertz *
       * Please thank Marius on GitHub /owlbertz *
       * or the web http://www.mariusolbertz.de/ *
       *                                         *
       ******************************************/

      var keyCodes = {
        9: 'TAB',
        13: 'ENTER',
        27: 'ESCAPE',
        32: 'SPACE',
        35: 'END',
        36: 'HOME',
        37: 'ARROW_LEFT',
        38: 'ARROW_UP',
        39: 'ARROW_RIGHT',
        40: 'ARROW_DOWN'
      };
      var commands = {}; // Functions pulled out to be referenceable from internals

      function findFocusable($element) {
        if (!$element) {
          return false;
        }
        return $element.find('a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable]').filter(function () {
          if (!jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).is(':visible') || jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).attr('tabindex') < 0) {
            return false;
          } //only have visible elements and those that have a tabindex greater or equal 0

          return true;
        });
      }
      function parseKey(event) {
        var key = keyCodes[event.which || event.keyCode] || String.fromCharCode(event.which).toUpperCase(); // Remove un-printable characters, e.g. for `fromCharCode` calls for CTRL only events

        key = key.replace(/\W+/, '');
        if (event.shiftKey) key = "SHIFT_".concat(key);
        if (event.ctrlKey) key = "CTRL_".concat(key);
        if (event.altKey) key = "ALT_".concat(key); // Remove trailing underscore, in case only modifiers were used (e.g. only `CTRL_ALT`)

        key = key.replace(/_$/, '');
        return key;
      }
      var Keyboard = {
        keys: getKeyCodes(keyCodes),
        /**
         * Parses the (keyboard) event and returns a String that represents its key
         * Can be used like Foundation.parseKey(event) === Foundation.keys.SPACE
         * @param {Event} event - the event generated by the event handler
         * @return String key - String that represents the key pressed
         */
        parseKey: parseKey,
        /**
         * Handles the given (keyboard) event
         * @param {Event} event - the event generated by the event handler
         * @param {String} component - Foundation component's name, e.g. Slider or Reveal
         * @param {Objects} functions - collection of functions that are to be executed
         */
        handleKey: function handleKey(event, component, functions) {
          var commandList = commands[component],
            keyCode = this.parseKey(event),
            cmds,
            command,
            fn;
          if (!commandList) return console.warn('Component not defined!');
          if (typeof commandList.ltr === 'undefined') {
            // this component does not differentiate between ltr and rtl
            cmds = commandList; // use plain list
          } else {
            // merge ltr and rtl: if document is rtl, rtl overwrites ltr and vice versa
            if (Object(_foundation_core_utils__WEBPACK_IMPORTED_MODULE_1__["rtl"])()) cmds = jquery__WEBPACK_IMPORTED_MODULE_0___default.a.extend({}, commandList.ltr, commandList.rtl);else cmds = jquery__WEBPACK_IMPORTED_MODULE_0___default.a.extend({}, commandList.rtl, commandList.ltr);
          }
          command = cmds[keyCode];
          fn = functions[command];
          if (fn && typeof fn === 'function') {
            // execute function  if exists
            var returnValue = fn.apply();
            if (functions.handled || typeof functions.handled === 'function') {
              // execute function when event was handled
              functions.handled(returnValue);
            }
          } else {
            if (functions.unhandled || typeof functions.unhandled === 'function') {
              // execute function when event was not handled
              functions.unhandled();
            }
          }
        },
        /**
         * Finds all focusable elements within the given `$element`
         * @param {jQuery} $element - jQuery object to search within
         * @return {jQuery} $focusable - all focusable elements within `$element`
         */
        findFocusable: findFocusable,
        /**
         * Returns the component name name
         * @param {Object} component - Foundation component, e.g. Slider or Reveal
         * @return String componentName
         */
        register: function register(componentName, cmds) {
          commands[componentName] = cmds;
        },
        // TODO9438: These references to Keyboard need to not require global. Will 'this' work in this context?
        //

        /**
         * Traps the focus in the given element.
         * @param  {jQuery} $element  jQuery object to trap the foucs into.
         */
        trapFocus: function trapFocus($element) {
          var $focusable = findFocusable($element),
            $firstFocusable = $focusable.eq(0),
            $lastFocusable = $focusable.eq(-1);
          $element.on('keydown.zf.trapfocus', function (event) {
            if (event.target === $lastFocusable[0] && parseKey(event) === 'TAB') {
              event.preventDefault();
              $firstFocusable.focus();
            } else if (event.target === $firstFocusable[0] && parseKey(event) === 'SHIFT_TAB') {
              event.preventDefault();
              $lastFocusable.focus();
            }
          });
        },
        /**
         * Releases the trapped focus from the given element.
         * @param  {jQuery} $element  jQuery object to release the focus for.
         */
        releaseFocus: function releaseFocus($element) {
          $element.off('keydown.zf.trapfocus');
        }
      };
      /*
       * Constants for easier comparing.
       * Can be used like Foundation.parseKey(event) === Foundation.keys.SPACE
       */

      function getKeyCodes(kcs) {
        var k = {};
        for (var kc in kcs) {
          k[kcs[kc]] = kcs[kc];
        }
        return k;
      }

      /***/
    }),
    /***/"./js/foundation.util.mediaQuery.js": (
    /*!******************************************!*\
      !*** ./js/foundation.util.mediaQuery.js ***!
      \******************************************/
    /*! exports provided: MediaQuery */
    /***/
    function _js_foundationUtilMediaQueryJs(module, __webpack_exports__, __webpack_require__) {
      "use strict";

      __webpack_require__.r(__webpack_exports__);
      /* harmony export (binding) */
      __webpack_require__.d(__webpack_exports__, "MediaQuery", function () {
        return MediaQuery;
      });
      /* harmony import */
      var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! jquery */"jquery");
      /* harmony import */
      var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);
      function _typeof(obj) {
        if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
          _typeof = function _typeof(obj) {
            return _typeof2(obj);
          };
        } else {
          _typeof = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
          };
        }
        return _typeof(obj);
      }

      // Default set of media queries

      var defaultQueries = {
        'default': 'only screen',
        landscape: 'only screen and (orientation: landscape)',
        portrait: 'only screen and (orientation: portrait)',
        retina: 'only screen and (-webkit-min-device-pixel-ratio: 2),' + 'only screen and (min--moz-device-pixel-ratio: 2),' + 'only screen and (-o-min-device-pixel-ratio: 2/1),' + 'only screen and (min-device-pixel-ratio: 2),' + 'only screen and (min-resolution: 192dpi),' + 'only screen and (min-resolution: 2dppx)'
      }; // matchMedia() polyfill - Test a CSS media type/query in JS.
      // Authors & copyright(c) 2012: Scott Jehl, Paul Irish, Nicholas Zakas, David Knight. MIT license

      /* eslint-disable */

      window.matchMedia || (window.matchMedia = function () {
        "use strict";

        // For browsers that support matchMedium api such as IE 9 and webkit
        var styleMedia = window.styleMedia || window.media; // For those that don't support matchMedium

        if (!styleMedia) {
          var style = document.createElement('style'),
            script = document.getElementsByTagName('script')[0],
            info = null;
          style.type = 'text/css';
          style.id = 'matchmediajs-test';
          if (!script) {
            document.head.appendChild(style);
          } else {
            script.parentNode.insertBefore(style, script);
          } // 'style.currentStyle' is used by IE <= 8 and 'window.getComputedStyle' for all other browsers

          info = 'getComputedStyle' in window && window.getComputedStyle(style, null) || style.currentStyle;
          styleMedia = {
            matchMedium: function matchMedium(media) {
              var text = '@media ' + media + '{ #matchmediajs-test { width: 1px; } }'; // 'style.styleSheet' is used by IE <= 8 and 'style.textContent' for all other browsers

              if (style.styleSheet) {
                style.styleSheet.cssText = text;
              } else {
                style.textContent = text;
              } // Test if media query is true or false

              return info.width === '1px';
            }
          };
        }
        return function (media) {
          return {
            matches: styleMedia.matchMedium(media || 'all'),
            media: media || 'all'
          };
        };
      }());
      /* eslint-enable */

      var MediaQuery = {
        queries: [],
        current: '',
        /**
         * Initializes the media query helper, by extracting the breakpoint list from the CSS and activating the breakpoint watcher.
         * @function
         * @private
         */
        _init: function _init() {
          var self = this;
          var $meta = jquery__WEBPACK_IMPORTED_MODULE_0___default()('meta.foundation-mq');
          if (!$meta.length) {
            jquery__WEBPACK_IMPORTED_MODULE_0___default()('<meta class="foundation-mq">').appendTo(document.head);
          }
          var extractedStyles = jquery__WEBPACK_IMPORTED_MODULE_0___default()('.foundation-mq').css('font-family');
          var namedQueries;
          namedQueries = parseStyleToObject(extractedStyles);
          for (var key in namedQueries) {
            if (namedQueries.hasOwnProperty(key)) {
              self.queries.push({
                name: key,
                value: "only screen and (min-width: ".concat(namedQueries[key], ")")
              });
            }
          }
          this.current = this._getCurrentSize();
          this._watcher();
        },
        /**
         * Checks if the screen is at least as wide as a breakpoint.
         * @function
         * @param {String} size - Name of the breakpoint to check.
         * @returns {Boolean} `true` if the breakpoint matches, `false` if it's smaller.
         */
        atLeast: function atLeast(size) {
          var query = this.get(size);
          if (query) {
            return window.matchMedia(query).matches;
          }
          return false;
        },
        /**
         * Checks if the screen matches to a breakpoint.
         * @function
         * @param {String} size - Name of the breakpoint to check, either 'small only' or 'small'. Omitting 'only' falls back to using atLeast() method.
         * @returns {Boolean} `true` if the breakpoint matches, `false` if it does not.
         */
        is: function is(size) {
          size = size.trim().split(' ');
          if (size.length > 1 && size[1] === 'only') {
            if (size[0] === this._getCurrentSize()) return true;
          } else {
            return this.atLeast(size[0]);
          }
          return false;
        },
        /**
         * Gets the media query of a breakpoint.
         * @function
         * @param {String} size - Name of the breakpoint to get.
         * @returns {String|null} - The media query of the breakpoint, or `null` if the breakpoint doesn't exist.
         */
        get: function get(size) {
          for (var i in this.queries) {
            if (this.queries.hasOwnProperty(i)) {
              var query = this.queries[i];
              if (size === query.name) return query.value;
            }
          }
          return null;
        },
        /**
         * Gets the current breakpoint name by testing every breakpoint and returning the last one to match (the biggest one).
         * @function
         * @private
         * @returns {String} Name of the current breakpoint.
         */
        _getCurrentSize: function _getCurrentSize() {
          var matched;
          for (var i = 0; i < this.queries.length; i++) {
            var query = this.queries[i];
            if (window.matchMedia(query.value).matches) {
              matched = query;
            }
          }
          if (_typeof(matched) === 'object') {
            return matched.name;
          } else {
            return matched;
          }
        },
        /**
         * Activates the breakpoint watcher, which fires an event on the window whenever the breakpoint changes.
         * @function
         * @private
         */
        _watcher: function _watcher() {
          var _this = this;
          jquery__WEBPACK_IMPORTED_MODULE_0___default()(window).off('resize.zf.mediaquery').on('resize.zf.mediaquery', function () {
            var newSize = _this._getCurrentSize(),
              currentSize = _this.current;
            if (newSize !== currentSize) {
              // Change the current media query
              _this.current = newSize; // Broadcast the media query change on the window

              jquery__WEBPACK_IMPORTED_MODULE_0___default()(window).trigger('changed.zf.mediaquery', [newSize, currentSize]);
            }
          });
        }
      }; // Thank you: https://github.com/sindresorhus/query-string

      function parseStyleToObject(str) {
        var styleObject = {};
        if (typeof str !== 'string') {
          return styleObject;
        }
        str = str.trim().slice(1, -1); // browsers re-quote string style values

        if (!str) {
          return styleObject;
        }
        styleObject = str.split('&').reduce(function (ret, param) {
          var parts = param.replace(/\+/g, ' ').split('=');
          var key = parts[0];
          var val = parts[1];
          key = decodeURIComponent(key); // missing `=` should be `null`:
          // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters

          val = typeof val === 'undefined' ? null : decodeURIComponent(val);
          if (!ret.hasOwnProperty(key)) {
            ret[key] = val;
          } else if (Array.isArray(ret[key])) {
            ret[key].push(val);
          } else {
            ret[key] = [ret[key], val];
          }
          return ret;
        }, {});
        return styleObject;
      }

      /***/
    }),
    /***/"./js/foundation.util.motion.js": (
    /*!**************************************!*\
      !*** ./js/foundation.util.motion.js ***!
      \**************************************/
    /*! exports provided: Move, Motion */
    /***/
    function _js_foundationUtilMotionJs(module, __webpack_exports__, __webpack_require__) {
      "use strict";

      __webpack_require__.r(__webpack_exports__);
      /* harmony export (binding) */
      __webpack_require__.d(__webpack_exports__, "Move", function () {
        return Move;
      });
      /* harmony export (binding) */
      __webpack_require__.d(__webpack_exports__, "Motion", function () {
        return Motion;
      });
      /* harmony import */
      var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! jquery */"jquery");
      /* harmony import */
      var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);
      /* harmony import */
      var _foundation_core_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./foundation.core.utils */"./js/foundation.core.utils.js");

      /**
       * Motion module.
       * @module foundation.motion
       */

      var initClasses = ['mui-enter', 'mui-leave'];
      var activeClasses = ['mui-enter-active', 'mui-leave-active'];
      var Motion = {
        animateIn: function animateIn(element, animation, cb) {
          animate(true, element, animation, cb);
        },
        animateOut: function animateOut(element, animation, cb) {
          animate(false, element, animation, cb);
        }
      };
      function Move(duration, elem, fn) {
        var anim,
          prog,
          start = null; // console.log('called');

        if (duration === 0) {
          fn.apply(elem);
          elem.trigger('finished.zf.animate', [elem]).triggerHandler('finished.zf.animate', [elem]);
          return;
        }
        function move(ts) {
          if (!start) start = ts; // console.log(start, ts);

          prog = ts - start;
          fn.apply(elem);
          if (prog < duration) {
            anim = window.requestAnimationFrame(move, elem);
          } else {
            window.cancelAnimationFrame(anim);
            elem.trigger('finished.zf.animate', [elem]).triggerHandler('finished.zf.animate', [elem]);
          }
        }
        anim = window.requestAnimationFrame(move);
      }
      /**
       * Animates an element in or out using a CSS transition class.
       * @function
       * @private
       * @param {Boolean} isIn - Defines if the animation is in or out.
       * @param {Object} element - jQuery or HTML object to animate.
       * @param {String} animation - CSS class to use.
       * @param {Function} cb - Callback to run when animation is finished.
       */

      function animate(isIn, element, animation, cb) {
        element = jquery__WEBPACK_IMPORTED_MODULE_0___default()(element).eq(0);
        if (!element.length) return;
        var initClass = isIn ? initClasses[0] : initClasses[1];
        var activeClass = isIn ? activeClasses[0] : activeClasses[1]; // Set up the animation

        reset();
        element.addClass(animation).css('transition', 'none');
        requestAnimationFrame(function () {
          element.addClass(initClass);
          if (isIn) element.show();
        }); // Start the animation

        requestAnimationFrame(function () {
          element[0].offsetWidth;
          element.css('transition', '').addClass(activeClass);
        }); // Clean up the animation when it finishes

        element.one(Object(_foundation_core_utils__WEBPACK_IMPORTED_MODULE_1__["transitionend"])(element), finish); // Hides the element (for out animations), resets the element, and runs a callback

        function finish() {
          if (!isIn) element.hide();
          reset();
          if (cb) cb.apply(element);
        } // Resets transitions and removes motion-specific classes

        function reset() {
          element[0].style.transitionDuration = 0;
          element.removeClass("".concat(initClass, " ").concat(activeClass, " ").concat(animation));
        }
      }

      /***/
    }),
    /***/"./js/foundation.util.nest.js": (
    /*!************************************!*\
      !*** ./js/foundation.util.nest.js ***!
      \************************************/
    /*! exports provided: Nest */
    /***/
    function _js_foundationUtilNestJs(module, __webpack_exports__, __webpack_require__) {
      "use strict";

      __webpack_require__.r(__webpack_exports__);
      /* harmony export (binding) */
      __webpack_require__.d(__webpack_exports__, "Nest", function () {
        return Nest;
      });
      /* harmony import */
      var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! jquery */"jquery");
      /* harmony import */
      var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);
      var Nest = {
        Feather: function Feather(menu) {
          var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'zf';
          menu.attr('role', 'menubar');
          var items = menu.find('li').attr({
              'role': 'menuitem'
            }),
            subMenuClass = "is-".concat(type, "-submenu"),
            subItemClass = "".concat(subMenuClass, "-item"),
            hasSubClass = "is-".concat(type, "-submenu-parent"),
            applyAria = type !== 'accordion'; // Accordions handle their own ARIA attriutes.

          items.each(function () {
            var $item = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this),
              $sub = $item.children('ul');
            if ($sub.length) {
              $item.addClass(hasSubClass);
              if (applyAria) {
                $item.attr({
                  'aria-haspopup': true,
                  'aria-label': $item.children('a:first').text()
                }); // Note:  Drilldowns behave differently in how they hide, and so need
                // additional attributes.  We should look if this possibly over-generalized
                // utility (Nest) is appropriate when we rework menus in 6.4

                if (type === 'drilldown') {
                  $item.attr({
                    'aria-expanded': false
                  });
                }
              }
              $sub.addClass("submenu ".concat(subMenuClass)).attr({
                'data-submenu': '',
                'role': 'menubar'
              });
              if (type === 'drilldown') {
                $sub.attr({
                  'aria-hidden': true
                });
              }
            }
            if ($item.parent('[data-submenu]').length) {
              $item.addClass("is-submenu-item ".concat(subItemClass));
            }
          });
          return;
        },
        Burn: function Burn(menu, type) {
          var
            //items = menu.find('li'),
            subMenuClass = "is-".concat(type, "-submenu"),
            subItemClass = "".concat(subMenuClass, "-item"),
            hasSubClass = "is-".concat(type, "-submenu-parent");
          menu.find('>li, > li > ul, .menu, .menu > li, [data-submenu] > li').removeClass("".concat(subMenuClass, " ").concat(subItemClass, " ").concat(hasSubClass, " is-submenu-item submenu is-active")).removeAttr('data-submenu').css('display', '');
        }
      };

      /***/
    }),
    /***/"./js/foundation.util.timer.js": (
    /*!*************************************!*\
      !*** ./js/foundation.util.timer.js ***!
      \*************************************/
    /*! exports provided: Timer */
    /***/
    function _js_foundationUtilTimerJs(module, __webpack_exports__, __webpack_require__) {
      "use strict";

      __webpack_require__.r(__webpack_exports__);
      /* harmony export (binding) */
      __webpack_require__.d(__webpack_exports__, "Timer", function () {
        return Timer;
      });
      /* harmony import */
      var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! jquery */"jquery");
      /* harmony import */
      var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);
      function Timer(elem, options, cb) {
        var _this = this,
          duration = options.duration,
          //options is an object for easily adding features later.
          nameSpace = Object.keys(elem.data())[0] || 'timer',
          remain = -1,
          start,
          timer;
        this.isPaused = false;
        this.restart = function () {
          remain = -1;
          clearTimeout(timer);
          this.start();
        };
        this.start = function () {
          this.isPaused = false; // if(!elem.data('paused')){ return false; }//maybe implement this sanity check if used for other things.

          clearTimeout(timer);
          remain = remain <= 0 ? duration : remain;
          elem.data('paused', false);
          start = Date.now();
          timer = setTimeout(function () {
            if (options.infinite) {
              _this.restart(); //rerun the timer.
            }
            if (cb && typeof cb === 'function') {
              cb();
            }
          }, remain);
          elem.trigger("timerstart.zf.".concat(nameSpace));
        };
        this.pause = function () {
          this.isPaused = true; //if(elem.data('paused')){ return false; }//maybe implement this sanity check if used for other things.

          clearTimeout(timer);
          elem.data('paused', true);
          var end = Date.now();
          remain = remain - (end - start);
          elem.trigger("timerpaused.zf.".concat(nameSpace));
        };
      }

      /***/
    }),
    /***/"./js/foundation.util.touch.js": (
    /*!*************************************!*\
      !*** ./js/foundation.util.touch.js ***!
      \*************************************/
    /*! exports provided: Touch */
    /***/
    function _js_foundationUtilTouchJs(module, __webpack_exports__, __webpack_require__) {
      "use strict";

      __webpack_require__.r(__webpack_exports__);
      /* harmony export (binding) */
      __webpack_require__.d(__webpack_exports__, "Touch", function () {
        return Touch;
      });
      /* harmony import */
      var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! jquery */"jquery");
      /* harmony import */
      var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);
      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }
      function _defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }
      function _createClass(Constructor, protoProps, staticProps) {
        if (protoProps) _defineProperties(Constructor.prototype, protoProps);
        if (staticProps) _defineProperties(Constructor, staticProps);
        return Constructor;
      }

      //**************************************************
      //**Work inspired by multiple jquery swipe plugins**
      //**Done by Yohai Ararat ***************************
      //**************************************************

      var Touch = {};
      var startPosX,
        startPosY,
        startTime,
        elapsedTime,
        startEvent,
        isMoving = false,
        didMoved = false;
      function onTouchEnd(e) {
        this.removeEventListener('touchmove', onTouchMove);
        this.removeEventListener('touchend', onTouchEnd); // If the touch did not move, consider it as a "tap"

        if (!didMoved) {
          var tapEvent = jquery__WEBPACK_IMPORTED_MODULE_0___default.a.Event('tap', startEvent || e);
          jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).trigger(tapEvent);
        }
        startEvent = null;
        isMoving = false;
        didMoved = false;
      }
      function onTouchMove(e) {
        if (jquery__WEBPACK_IMPORTED_MODULE_0___default.a.spotSwipe.preventDefault) {
          e.preventDefault();
        }
        if (isMoving) {
          var x = e.touches[0].pageX;
          var y = e.touches[0].pageY;
          var dx = startPosX - x;
          var dy = startPosY - y;
          var dir;
          didMoved = true;
          elapsedTime = new Date().getTime() - startTime;
          if (Math.abs(dx) >= jquery__WEBPACK_IMPORTED_MODULE_0___default.a.spotSwipe.moveThreshold && elapsedTime <= jquery__WEBPACK_IMPORTED_MODULE_0___default.a.spotSwipe.timeThreshold) {
            dir = dx > 0 ? 'left' : 'right';
          } // else if(Math.abs(dy) >= $.spotSwipe.moveThreshold && elapsedTime <= $.spotSwipe.timeThreshold) {
          //   dir = dy > 0 ? 'down' : 'up';
          // }

          if (dir) {
            e.preventDefault();
            onTouchEnd.apply(this, arguments);
            jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).trigger(jquery__WEBPACK_IMPORTED_MODULE_0___default.a.Event('swipe', e), dir).trigger(jquery__WEBPACK_IMPORTED_MODULE_0___default.a.Event("swipe".concat(dir), e));
          }
        }
      }
      function onTouchStart(e) {
        if (e.touches.length == 1) {
          startPosX = e.touches[0].pageX;
          startPosY = e.touches[0].pageY;
          startEvent = e;
          isMoving = true;
          didMoved = false;
          startTime = new Date().getTime();
          this.addEventListener('touchmove', onTouchMove, false);
          this.addEventListener('touchend', onTouchEnd, false);
        }
      }
      function init() {
        this.addEventListener && this.addEventListener('touchstart', onTouchStart, false);
      }
      function teardown() {
        this.removeEventListener('touchstart', onTouchStart);
      }
      var SpotSwipe = /*#__PURE__*/
      function () {
        function SpotSwipe($) {
          _classCallCheck(this, SpotSwipe);
          this.version = '1.0.0';
          this.enabled = 'ontouchstart' in document.documentElement;
          this.preventDefault = false;
          this.moveThreshold = 75;
          this.timeThreshold = 200;
          this.$ = $;
          this._init();
        }
        _createClass(SpotSwipe, [{
          key: "_init",
          value: function _init() {
            var $ = this.$;
            $.event.special.swipe = {
              setup: init
            };
            $.event.special.tap = {
              setup: init
            };
            $.each(['left', 'up', 'down', 'right'], function () {
              $.event.special["swipe".concat(this)] = {
                setup: function setup() {
                  $(this).on('swipe', $.noop);
                }
              };
            });
          }
        }]);
        return SpotSwipe;
      }();
      /****************************************************
       * As far as I can tell, both setupSpotSwipe and    *
       * setupTouchHandler should be idempotent,          *
       * because they directly replace functions &        *
       * values, and do not add event handlers directly.  *
       ****************************************************/

      Touch.setupSpotSwipe = function ($) {
        $.spotSwipe = new SpotSwipe($);
      };
      /****************************************************
       * Method for adding pseudo drag events to elements *
       ***************************************************/

      Touch.setupTouchHandler = function ($) {
        $.fn.addTouch = function () {
          this.each(function (i, el) {
            $(el).bind('touchstart touchmove touchend touchcancel', function (event) {
              //we pass the original event object because the jQuery event
              //object is normalized to w3c specs and does not provide the TouchList
              handleTouch(event);
            });
          });
          var handleTouch = function handleTouch(event) {
            var touches = event.changedTouches,
              first = touches[0],
              eventTypes = {
                touchstart: 'mousedown',
                touchmove: 'mousemove',
                touchend: 'mouseup'
              },
              type = eventTypes[event.type],
              simulatedEvent;
            if ('MouseEvent' in window && typeof window.MouseEvent === 'function') {
              simulatedEvent = new window.MouseEvent(type, {
                'bubbles': true,
                'cancelable': true,
                'screenX': first.screenX,
                'screenY': first.screenY,
                'clientX': first.clientX,
                'clientY': first.clientY
              });
            } else {
              simulatedEvent = document.createEvent('MouseEvent');
              simulatedEvent.initMouseEvent(type, true, true, window, 1, first.screenX, first.screenY, first.clientX, first.clientY, false, false, false, false, 0
              /*left*/, null);
            }
            first.target.dispatchEvent(simulatedEvent);
          };
        };
      };
      Touch.init = function ($) {
        if (typeof $.spotSwipe === 'undefined') {
          Touch.setupSpotSwipe($);
          Touch.setupTouchHandler($);
        }
      };

      /***/
    }),
    /***/"./js/foundation.util.triggers.js": (
    /*!****************************************!*\
      !*** ./js/foundation.util.triggers.js ***!
      \****************************************/
    /*! exports provided: Triggers */
    /***/
    function _js_foundationUtilTriggersJs(module, __webpack_exports__, __webpack_require__) {
      "use strict";

      __webpack_require__.r(__webpack_exports__);
      /* harmony export (binding) */
      __webpack_require__.d(__webpack_exports__, "Triggers", function () {
        return Triggers;
      });
      /* harmony import */
      var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! jquery */"jquery");
      /* harmony import */
      var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);
      /* harmony import */
      var _foundation_core_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./foundation.core.utils */"./js/foundation.core.utils.js");
      /* harmony import */
      var _foundation_util_motion__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./foundation.util.motion */"./js/foundation.util.motion.js");
      function _typeof(obj) {
        if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
          _typeof = function _typeof(obj) {
            return _typeof2(obj);
          };
        } else {
          _typeof = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
          };
        }
        return _typeof(obj);
      }
      var MutationObserver = function () {
        var prefixes = ['WebKit', 'Moz', 'O', 'Ms', ''];
        for (var i = 0; i < prefixes.length; i++) {
          if ("".concat(prefixes[i], "MutationObserver") in window) {
            return window["".concat(prefixes[i], "MutationObserver")];
          }
        }
        return false;
      }();
      var triggers = function triggers(el, type) {
        el.data(type).split(' ').forEach(function (id) {
          jquery__WEBPACK_IMPORTED_MODULE_0___default()("#".concat(id))[type === 'close' ? 'trigger' : 'triggerHandler']("".concat(type, ".zf.trigger"), [el]);
        });
      };
      var Triggers = {
        Listeners: {
          Basic: {},
          Global: {}
        },
        Initializers: {}
      };
      Triggers.Listeners.Basic = {
        openListener: function openListener() {
          triggers(jquery__WEBPACK_IMPORTED_MODULE_0___default()(this), 'open');
        },
        closeListener: function closeListener() {
          var id = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).data('close');
          if (id) {
            triggers(jquery__WEBPACK_IMPORTED_MODULE_0___default()(this), 'close');
          } else {
            jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).trigger('close.zf.trigger');
          }
        },
        toggleListener: function toggleListener() {
          var id = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).data('toggle');
          if (id) {
            triggers(jquery__WEBPACK_IMPORTED_MODULE_0___default()(this), 'toggle');
          } else {
            jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).trigger('toggle.zf.trigger');
          }
        },
        closeableListener: function closeableListener(e) {
          e.stopPropagation();
          var animation = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).data('closable');
          if (animation !== '') {
            _foundation_util_motion__WEBPACK_IMPORTED_MODULE_2__["Motion"].animateOut(jquery__WEBPACK_IMPORTED_MODULE_0___default()(this), animation, function () {
              jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).trigger('closed.zf');
            });
          } else {
            jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).fadeOut().trigger('closed.zf');
          }
        },
        toggleFocusListener: function toggleFocusListener() {
          var id = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).data('toggle-focus');
          jquery__WEBPACK_IMPORTED_MODULE_0___default()("#".concat(id)).triggerHandler('toggle.zf.trigger', [jquery__WEBPACK_IMPORTED_MODULE_0___default()(this)]);
        }
      }; // Elements with [data-open] will reveal a plugin that supports it when clicked.

      Triggers.Initializers.addOpenListener = function ($elem) {
        $elem.off('click.zf.trigger', Triggers.Listeners.Basic.openListener);
        $elem.on('click.zf.trigger', '[data-open]', Triggers.Listeners.Basic.openListener);
      }; // Elements with [data-close] will close a plugin that supports it when clicked.
      // If used without a value on [data-close], the event will bubble, allowing it to close a parent component.

      Triggers.Initializers.addCloseListener = function ($elem) {
        $elem.off('click.zf.trigger', Triggers.Listeners.Basic.closeListener);
        $elem.on('click.zf.trigger', '[data-close]', Triggers.Listeners.Basic.closeListener);
      }; // Elements with [data-toggle] will toggle a plugin that supports it when clicked.

      Triggers.Initializers.addToggleListener = function ($elem) {
        $elem.off('click.zf.trigger', Triggers.Listeners.Basic.toggleListener);
        $elem.on('click.zf.trigger', '[data-toggle]', Triggers.Listeners.Basic.toggleListener);
      }; // Elements with [data-closable] will respond to close.zf.trigger events.

      Triggers.Initializers.addCloseableListener = function ($elem) {
        $elem.off('close.zf.trigger', Triggers.Listeners.Basic.closeableListener);
        $elem.on('close.zf.trigger', '[data-closeable], [data-closable]', Triggers.Listeners.Basic.closeableListener);
      }; // Elements with [data-toggle-focus] will respond to coming in and out of focus

      Triggers.Initializers.addToggleFocusListener = function ($elem) {
        $elem.off('focus.zf.trigger blur.zf.trigger', Triggers.Listeners.Basic.toggleFocusListener);
        $elem.on('focus.zf.trigger blur.zf.trigger', '[data-toggle-focus]', Triggers.Listeners.Basic.toggleFocusListener);
      }; // More Global/complex listeners and triggers

      Triggers.Listeners.Global = {
        resizeListener: function resizeListener($nodes) {
          if (!MutationObserver) {
            //fallback for IE 9
            $nodes.each(function () {
              jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).triggerHandler('resizeme.zf.trigger');
            });
          } //trigger all listening elements and signal a resize event

          $nodes.attr('data-events', "resize");
        },
        scrollListener: function scrollListener($nodes) {
          if (!MutationObserver) {
            //fallback for IE 9
            $nodes.each(function () {
              jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).triggerHandler('scrollme.zf.trigger');
            });
          } //trigger all listening elements and signal a scroll event

          $nodes.attr('data-events', "scroll");
        },
        closeMeListener: function closeMeListener(e, pluginId) {
          var plugin = e.namespace.split('.')[0];
          var plugins = jquery__WEBPACK_IMPORTED_MODULE_0___default()("[data-".concat(plugin, "]")).not("[data-yeti-box=\"".concat(pluginId, "\"]"));
          plugins.each(function () {
            var _this = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this);
            _this.triggerHandler('close.zf.trigger', [_this]);
          });
        } // Global, parses whole document.
      };
      Triggers.Initializers.addClosemeListener = function (pluginName) {
        var yetiBoxes = jquery__WEBPACK_IMPORTED_MODULE_0___default()('[data-yeti-box]'),
          plugNames = ['dropdown', 'tooltip', 'reveal'];
        if (pluginName) {
          if (typeof pluginName === 'string') {
            plugNames.push(pluginName);
          } else if (_typeof(pluginName) === 'object' && typeof pluginName[0] === 'string') {
            plugNames = plugNames.concat(pluginName);
          } else {
            console.error('Plugin names must be strings');
          }
        }
        if (yetiBoxes.length) {
          var listeners = plugNames.map(function (name) {
            return "closeme.zf.".concat(name);
          }).join(' ');
          jquery__WEBPACK_IMPORTED_MODULE_0___default()(window).off(listeners).on(listeners, Triggers.Listeners.Global.closeMeListener);
        }
      };
      function debounceGlobalListener(debounce, trigger, listener) {
        var timer,
          args = Array.prototype.slice.call(arguments, 3);
        jquery__WEBPACK_IMPORTED_MODULE_0___default()(window).off(trigger).on(trigger, function (e) {
          if (timer) {
            clearTimeout(timer);
          }
          timer = setTimeout(function () {
            listener.apply(null, args);
          }, debounce || 10); //default time to emit scroll event
        });
      }
      Triggers.Initializers.addResizeListener = function (debounce) {
        var $nodes = jquery__WEBPACK_IMPORTED_MODULE_0___default()('[data-resize]');
        if ($nodes.length) {
          debounceGlobalListener(debounce, 'resize.zf.trigger', Triggers.Listeners.Global.resizeListener, $nodes);
        }
      };
      Triggers.Initializers.addScrollListener = function (debounce) {
        var $nodes = jquery__WEBPACK_IMPORTED_MODULE_0___default()('[data-scroll]');
        if ($nodes.length) {
          debounceGlobalListener(debounce, 'scroll.zf.trigger', Triggers.Listeners.Global.scrollListener, $nodes);
        }
      };
      Triggers.Initializers.addMutationEventsListener = function ($elem) {
        if (!MutationObserver) {
          return false;
        }
        var $nodes = $elem.find('[data-resize], [data-scroll], [data-mutate]'); //element callback

        var listeningElementsMutation = function listeningElementsMutation(mutationRecordsList) {
          var $target = jquery__WEBPACK_IMPORTED_MODULE_0___default()(mutationRecordsList[0].target); //trigger the event handler for the element depending on type

          switch (mutationRecordsList[0].type) {
            case "attributes":
              if ($target.attr("data-events") === "scroll" && mutationRecordsList[0].attributeName === "data-events") {
                $target.triggerHandler('scrollme.zf.trigger', [$target, window.pageYOffset]);
              }
              if ($target.attr("data-events") === "resize" && mutationRecordsList[0].attributeName === "data-events") {
                $target.triggerHandler('resizeme.zf.trigger', [$target]);
              }
              if (mutationRecordsList[0].attributeName === "style") {
                $target.closest("[data-mutate]").attr("data-events", "mutate");
                $target.closest("[data-mutate]").triggerHandler('mutateme.zf.trigger', [$target.closest("[data-mutate]")]);
              }
              break;
            case "childList":
              $target.closest("[data-mutate]").attr("data-events", "mutate");
              $target.closest("[data-mutate]").triggerHandler('mutateme.zf.trigger', [$target.closest("[data-mutate]")]);
              break;
            default:
              return false;
            //nothing
          }
        };
        if ($nodes.length) {
          //for each element that needs to listen for resizing, scrolling, or mutation add a single observer
          for (var i = 0; i <= $nodes.length - 1; i++) {
            var elementObserver = new MutationObserver(listeningElementsMutation);
            elementObserver.observe($nodes[i], {
              attributes: true,
              childList: true,
              characterData: false,
              subtree: true,
              attributeFilter: ["data-events", "style"]
            });
          }
        }
      };
      Triggers.Initializers.addSimpleListeners = function () {
        var $document = jquery__WEBPACK_IMPORTED_MODULE_0___default()(document);
        Triggers.Initializers.addOpenListener($document);
        Triggers.Initializers.addCloseListener($document);
        Triggers.Initializers.addToggleListener($document);
        Triggers.Initializers.addCloseableListener($document);
        Triggers.Initializers.addToggleFocusListener($document);
      };
      Triggers.Initializers.addGlobalListeners = function () {
        var $document = jquery__WEBPACK_IMPORTED_MODULE_0___default()(document);
        Triggers.Initializers.addMutationEventsListener($document);
        Triggers.Initializers.addResizeListener();
        Triggers.Initializers.addScrollListener();
        Triggers.Initializers.addClosemeListener();
      };
      Triggers.init = function ($, Foundation) {
        Object(_foundation_core_utils__WEBPACK_IMPORTED_MODULE_1__["onLoad"])($(window), function () {
          if ($.triggersInitialized !== true) {
            Triggers.Initializers.addSimpleListeners();
            Triggers.Initializers.addGlobalListeners();
            $.triggersInitialized = true;
          }
        });
        if (Foundation) {
          Foundation.Triggers = Triggers; // Legacy included to be backwards compatible for now.

          Foundation.IHearYou = Triggers.Initializers.addGlobalListeners;
        }
      };

      /***/
    }),
    /***/0: (
    /*!****************************************!*\
      !*** multi ./js/entries/foundation.js ***!
      \****************************************/
    /*! no static exports found */
    /***/
    function _(module, exports, __webpack_require__) {
      module.exports = __webpack_require__(/*! /Users/ncoden/Documents/Documents/Projects/Programmation/Web/2016/Foundation/foundation-sites/js/entries/foundation.js */"./js/entries/foundation.js");

      /***/
    }),
    /***/"jquery": (
    /*!********************************************************************************************!*\
      !*** external {"root":["jQuery"],"amd":"jquery","commonjs":"jquery","commonjs2":"jquery"} ***!
      \********************************************************************************************/
    /*! no static exports found */
    /***/
    function jquery(module, exports) {
      module.exports = __WEBPACK_EXTERNAL_MODULE_jquery__;

      /***/
    })

    /******/
  });
});

},{"jquery":9}],8:[function(require,module,exports){
function hidePlaceholderOnFocus(a){target=a.currentTarget?a.currentTarget:a.srcElement,target.value==target.getAttribute("placeholder")&&(target.value="")}function unfocusOnAnElement(a){target=a.currentTarget?a.currentTarget:a.srcElement,""==target.value&&(target.value=target.getAttribute("placeholder"))}if(!("placeholder"in document.createElement("input")))for(var inputs=document.getElementsByTagName("input"),i=0;i<inputs.length;i++)inputs[i].value||(inputs[i].value=inputs[i].getAttribute("placeholder")),inputs[i].addEventListener?(inputs[i].addEventListener("click",hidePlaceholderOnFocus,!1),inputs[i].addEventListener("blur",unfocusOnAnElement,!1)):inputs[i].attachEvent&&(inputs[i].attachEvent("onclick",hidePlaceholderOnFocus),inputs[i].attachEvent("onblur",unfocusOnAnElement));
},{}],9:[function(require,module,exports){
/*!
 * jQuery JavaScript Library v3.3.1
 * https://jquery.com/
 *
 * Includes Sizzle.js
 * https://sizzlejs.com/
 *
 * Copyright JS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2018-01-20T17:24Z
 */
( function( global, factory ) {

	"use strict";

	if ( typeof module === "object" && typeof module.exports === "object" ) {

		// For CommonJS and CommonJS-like environments where a proper `window`
		// is present, execute the factory and get jQuery.
		// For environments that do not have a `window` with a `document`
		// (such as Node.js), expose a factory as module.exports.
		// This accentuates the need for the creation of a real `window`.
		// e.g. var jQuery = require("jquery")(window);
		// See ticket #14549 for more info.
		module.exports = global.document ?
			factory( global, true ) :
			function( w ) {
				if ( !w.document ) {
					throw new Error( "jQuery requires a window with a document" );
				}
				return factory( w );
			};
	} else {
		factory( global );
	}

// Pass this if window is not defined yet
} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {

// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
// enough that all such attempts are guarded in a try block.
"use strict";

var arr = [];

var document = window.document;

var getProto = Object.getPrototypeOf;

var slice = arr.slice;

var concat = arr.concat;

var push = arr.push;

var indexOf = arr.indexOf;

var class2type = {};

var toString = class2type.toString;

var hasOwn = class2type.hasOwnProperty;

var fnToString = hasOwn.toString;

var ObjectFunctionString = fnToString.call( Object );

var support = {};

var isFunction = function isFunction( obj ) {

      // Support: Chrome <=57, Firefox <=52
      // In some browsers, typeof returns "function" for HTML <object> elements
      // (i.e., `typeof document.createElement( "object" ) === "function"`).
      // We don't want to classify *any* DOM node as a function.
      return typeof obj === "function" && typeof obj.nodeType !== "number";
  };


var isWindow = function isWindow( obj ) {
		return obj != null && obj === obj.window;
	};




	var preservedScriptAttributes = {
		type: true,
		src: true,
		noModule: true
	};

	function DOMEval( code, doc, node ) {
		doc = doc || document;

		var i,
			script = doc.createElement( "script" );

		script.text = code;
		if ( node ) {
			for ( i in preservedScriptAttributes ) {
				if ( node[ i ] ) {
					script[ i ] = node[ i ];
				}
			}
		}
		doc.head.appendChild( script ).parentNode.removeChild( script );
	}


function toType( obj ) {
	if ( obj == null ) {
		return obj + "";
	}

	// Support: Android <=2.3 only (functionish RegExp)
	return typeof obj === "object" || typeof obj === "function" ?
		class2type[ toString.call( obj ) ] || "object" :
		typeof obj;
}
/* global Symbol */
// Defining this global in .eslintrc.json would create a danger of using the global
// unguarded in another place, it seems safer to define global only for this module



var
	version = "3.3.1",

	// Define a local copy of jQuery
	jQuery = function( selector, context ) {

		// The jQuery object is actually just the init constructor 'enhanced'
		// Need init if jQuery is called (just allow error to be thrown if not included)
		return new jQuery.fn.init( selector, context );
	},

	// Support: Android <=4.0 only
	// Make sure we trim BOM and NBSP
	rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;

jQuery.fn = jQuery.prototype = {

	// The current version of jQuery being used
	jquery: version,

	constructor: jQuery,

	// The default length of a jQuery object is 0
	length: 0,

	toArray: function() {
		return slice.call( this );
	},

	// Get the Nth element in the matched element set OR
	// Get the whole matched element set as a clean array
	get: function( num ) {

		// Return all the elements in a clean array
		if ( num == null ) {
			return slice.call( this );
		}

		// Return just the one element from the set
		return num < 0 ? this[ num + this.length ] : this[ num ];
	},

	// Take an array of elements and push it onto the stack
	// (returning the new matched element set)
	pushStack: function( elems ) {

		// Build a new jQuery matched element set
		var ret = jQuery.merge( this.constructor(), elems );

		// Add the old object onto the stack (as a reference)
		ret.prevObject = this;

		// Return the newly-formed element set
		return ret;
	},

	// Execute a callback for every element in the matched set.
	each: function( callback ) {
		return jQuery.each( this, callback );
	},

	map: function( callback ) {
		return this.pushStack( jQuery.map( this, function( elem, i ) {
			return callback.call( elem, i, elem );
		} ) );
	},

	slice: function() {
		return this.pushStack( slice.apply( this, arguments ) );
	},

	first: function() {
		return this.eq( 0 );
	},

	last: function() {
		return this.eq( -1 );
	},

	eq: function( i ) {
		var len = this.length,
			j = +i + ( i < 0 ? len : 0 );
		return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
	},

	end: function() {
		return this.prevObject || this.constructor();
	},

	// For internal use only.
	// Behaves like an Array's method, not like a jQuery method.
	push: push,
	sort: arr.sort,
	splice: arr.splice
};

jQuery.extend = jQuery.fn.extend = function() {
	var options, name, src, copy, copyIsArray, clone,
		target = arguments[ 0 ] || {},
		i = 1,
		length = arguments.length,
		deep = false;

	// Handle a deep copy situation
	if ( typeof target === "boolean" ) {
		deep = target;

		// Skip the boolean and the target
		target = arguments[ i ] || {};
		i++;
	}

	// Handle case when target is a string or something (possible in deep copy)
	if ( typeof target !== "object" && !isFunction( target ) ) {
		target = {};
	}

	// Extend jQuery itself if only one argument is passed
	if ( i === length ) {
		target = this;
		i--;
	}

	for ( ; i < length; i++ ) {

		// Only deal with non-null/undefined values
		if ( ( options = arguments[ i ] ) != null ) {

			// Extend the base object
			for ( name in options ) {
				src = target[ name ];
				copy = options[ name ];

				// Prevent never-ending loop
				if ( target === copy ) {
					continue;
				}

				// Recurse if we're merging plain objects or arrays
				if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
					( copyIsArray = Array.isArray( copy ) ) ) ) {

					if ( copyIsArray ) {
						copyIsArray = false;
						clone = src && Array.isArray( src ) ? src : [];

					} else {
						clone = src && jQuery.isPlainObject( src ) ? src : {};
					}

					// Never move original objects, clone them
					target[ name ] = jQuery.extend( deep, clone, copy );

				// Don't bring in undefined values
				} else if ( copy !== undefined ) {
					target[ name ] = copy;
				}
			}
		}
	}

	// Return the modified object
	return target;
};

jQuery.extend( {

	// Unique for each copy of jQuery on the page
	expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),

	// Assume jQuery is ready without the ready module
	isReady: true,

	error: function( msg ) {
		throw new Error( msg );
	},

	noop: function() {},

	isPlainObject: function( obj ) {
		var proto, Ctor;

		// Detect obvious negatives
		// Use toString instead of jQuery.type to catch host objects
		if ( !obj || toString.call( obj ) !== "[object Object]" ) {
			return false;
		}

		proto = getProto( obj );

		// Objects with no prototype (e.g., `Object.create( null )`) are plain
		if ( !proto ) {
			return true;
		}

		// Objects with prototype are plain iff they were constructed by a global Object function
		Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
		return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
	},

	isEmptyObject: function( obj ) {

		/* eslint-disable no-unused-vars */
		// See https://github.com/eslint/eslint/issues/6125
		var name;

		for ( name in obj ) {
			return false;
		}
		return true;
	},

	// Evaluates a script in a global context
	globalEval: function( code ) {
		DOMEval( code );
	},

	each: function( obj, callback ) {
		var length, i = 0;

		if ( isArrayLike( obj ) ) {
			length = obj.length;
			for ( ; i < length; i++ ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		} else {
			for ( i in obj ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		}

		return obj;
	},

	// Support: Android <=4.0 only
	trim: function( text ) {
		return text == null ?
			"" :
			( text + "" ).replace( rtrim, "" );
	},

	// results is for internal usage only
	makeArray: function( arr, results ) {
		var ret = results || [];

		if ( arr != null ) {
			if ( isArrayLike( Object( arr ) ) ) {
				jQuery.merge( ret,
					typeof arr === "string" ?
					[ arr ] : arr
				);
			} else {
				push.call( ret, arr );
			}
		}

		return ret;
	},

	inArray: function( elem, arr, i ) {
		return arr == null ? -1 : indexOf.call( arr, elem, i );
	},

	// Support: Android <=4.0 only, PhantomJS 1 only
	// push.apply(_, arraylike) throws on ancient WebKit
	merge: function( first, second ) {
		var len = +second.length,
			j = 0,
			i = first.length;

		for ( ; j < len; j++ ) {
			first[ i++ ] = second[ j ];
		}

		first.length = i;

		return first;
	},

	grep: function( elems, callback, invert ) {
		var callbackInverse,
			matches = [],
			i = 0,
			length = elems.length,
			callbackExpect = !invert;

		// Go through the array, only saving the items
		// that pass the validator function
		for ( ; i < length; i++ ) {
			callbackInverse = !callback( elems[ i ], i );
			if ( callbackInverse !== callbackExpect ) {
				matches.push( elems[ i ] );
			}
		}

		return matches;
	},

	// arg is for internal usage only
	map: function( elems, callback, arg ) {
		var length, value,
			i = 0,
			ret = [];

		// Go through the array, translating each of the items to their new values
		if ( isArrayLike( elems ) ) {
			length = elems.length;
			for ( ; i < length; i++ ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}

		// Go through every key on the object,
		} else {
			for ( i in elems ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}
		}

		// Flatten any nested arrays
		return concat.apply( [], ret );
	},

	// A global GUID counter for objects
	guid: 1,

	// jQuery.support is not used in Core but other projects attach their
	// properties to it so it needs to exist.
	support: support
} );

if ( typeof Symbol === "function" ) {
	jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
}

// Populate the class2type map
jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
function( i, name ) {
	class2type[ "[object " + name + "]" ] = name.toLowerCase();
} );

function isArrayLike( obj ) {

	// Support: real iOS 8.2 only (not reproducible in simulator)
	// `in` check used to prevent JIT error (gh-2145)
	// hasOwn isn't used here due to false negatives
	// regarding Nodelist length in IE
	var length = !!obj && "length" in obj && obj.length,
		type = toType( obj );

	if ( isFunction( obj ) || isWindow( obj ) ) {
		return false;
	}

	return type === "array" || length === 0 ||
		typeof length === "number" && length > 0 && ( length - 1 ) in obj;
}
var Sizzle =
/*!
 * Sizzle CSS Selector Engine v2.3.3
 * https://sizzlejs.com/
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license
 * http://jquery.org/license
 *
 * Date: 2016-08-08
 */
(function( window ) {

var i,
	support,
	Expr,
	getText,
	isXML,
	tokenize,
	compile,
	select,
	outermostContext,
	sortInput,
	hasDuplicate,

	// Local document vars
	setDocument,
	document,
	docElem,
	documentIsHTML,
	rbuggyQSA,
	rbuggyMatches,
	matches,
	contains,

	// Instance-specific data
	expando = "sizzle" + 1 * new Date(),
	preferredDoc = window.document,
	dirruns = 0,
	done = 0,
	classCache = createCache(),
	tokenCache = createCache(),
	compilerCache = createCache(),
	sortOrder = function( a, b ) {
		if ( a === b ) {
			hasDuplicate = true;
		}
		return 0;
	},

	// Instance methods
	hasOwn = ({}).hasOwnProperty,
	arr = [],
	pop = arr.pop,
	push_native = arr.push,
	push = arr.push,
	slice = arr.slice,
	// Use a stripped-down indexOf as it's faster than native
	// https://jsperf.com/thor-indexof-vs-for/5
	indexOf = function( list, elem ) {
		var i = 0,
			len = list.length;
		for ( ; i < len; i++ ) {
			if ( list[i] === elem ) {
				return i;
			}
		}
		return -1;
	},

	booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",

	// Regular expressions

	// http://www.w3.org/TR/css3-selectors/#whitespace
	whitespace = "[\\x20\\t\\r\\n\\f]",

	// http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
	identifier = "(?:\\\\.|[\\w-]|[^\0-\\xa0])+",

	// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
	attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
		// Operator (capture 2)
		"*([*^$|!~]?=)" + whitespace +
		// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
		"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
		"*\\]",

	pseudos = ":(" + identifier + ")(?:\\((" +
		// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
		// 1. quoted (capture 3; capture 4 or capture 5)
		"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
		// 2. simple (capture 6)
		"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
		// 3. anything else (capture 2)
		".*" +
		")\\)|)",

	// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
	rwhitespace = new RegExp( whitespace + "+", "g" ),
	rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),

	rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
	rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),

	rattributeQuotes = new RegExp( "=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g" ),

	rpseudo = new RegExp( pseudos ),
	ridentifier = new RegExp( "^" + identifier + "$" ),

	matchExpr = {
		"ID": new RegExp( "^#(" + identifier + ")" ),
		"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
		"TAG": new RegExp( "^(" + identifier + "|[*])" ),
		"ATTR": new RegExp( "^" + attributes ),
		"PSEUDO": new RegExp( "^" + pseudos ),
		"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
			"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
			"*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
		"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
		// For use in libraries implementing .is()
		// We use this for POS matching in `select`
		"needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
			whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
	},

	rinputs = /^(?:input|select|textarea|button)$/i,
	rheader = /^h\d$/i,

	rnative = /^[^{]+\{\s*\[native \w/,

	// Easily-parseable/retrievable ID or TAG or CLASS selectors
	rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

	rsibling = /[+~]/,

	// CSS escapes
	// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
	runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
	funescape = function( _, escaped, escapedWhitespace ) {
		var high = "0x" + escaped - 0x10000;
		// NaN means non-codepoint
		// Support: Firefox<24
		// Workaround erroneous numeric interpretation of +"0x"
		return high !== high || escapedWhitespace ?
			escaped :
			high < 0 ?
				// BMP codepoint
				String.fromCharCode( high + 0x10000 ) :
				// Supplemental Plane codepoint (surrogate pair)
				String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
	},

	// CSS string/identifier serialization
	// https://drafts.csswg.org/cssom/#common-serializing-idioms
	rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
	fcssescape = function( ch, asCodePoint ) {
		if ( asCodePoint ) {

			// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
			if ( ch === "\0" ) {
				return "\uFFFD";
			}

			// Control characters and (dependent upon position) numbers get escaped as code points
			return ch.slice( 0, -1 ) + "\\" + ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
		}

		// Other potentially-special ASCII characters get backslash-escaped
		return "\\" + ch;
	},

	// Used for iframes
	// See setDocument()
	// Removing the function wrapper causes a "Permission Denied"
	// error in IE
	unloadHandler = function() {
		setDocument();
	},

	disabledAncestor = addCombinator(
		function( elem ) {
			return elem.disabled === true && ("form" in elem || "label" in elem);
		},
		{ dir: "parentNode", next: "legend" }
	);

// Optimize for push.apply( _, NodeList )
try {
	push.apply(
		(arr = slice.call( preferredDoc.childNodes )),
		preferredDoc.childNodes
	);
	// Support: Android<4.0
	// Detect silently failing push.apply
	arr[ preferredDoc.childNodes.length ].nodeType;
} catch ( e ) {
	push = { apply: arr.length ?

		// Leverage slice if possible
		function( target, els ) {
			push_native.apply( target, slice.call(els) );
		} :

		// Support: IE<9
		// Otherwise append directly
		function( target, els ) {
			var j = target.length,
				i = 0;
			// Can't trust NodeList.length
			while ( (target[j++] = els[i++]) ) {}
			target.length = j - 1;
		}
	};
}

function Sizzle( selector, context, results, seed ) {
	var m, i, elem, nid, match, groups, newSelector,
		newContext = context && context.ownerDocument,

		// nodeType defaults to 9, since context defaults to document
		nodeType = context ? context.nodeType : 9;

	results = results || [];

	// Return early from calls with invalid selector or context
	if ( typeof selector !== "string" || !selector ||
		nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {

		return results;
	}

	// Try to shortcut find operations (as opposed to filters) in HTML documents
	if ( !seed ) {

		if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
			setDocument( context );
		}
		context = context || document;

		if ( documentIsHTML ) {

			// If the selector is sufficiently simple, try using a "get*By*" DOM method
			// (excepting DocumentFragment context, where the methods don't exist)
			if ( nodeType !== 11 && (match = rquickExpr.exec( selector )) ) {

				// ID selector
				if ( (m = match[1]) ) {

					// Document context
					if ( nodeType === 9 ) {
						if ( (elem = context.getElementById( m )) ) {

							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( elem.id === m ) {
								results.push( elem );
								return results;
							}
						} else {
							return results;
						}

					// Element context
					} else {

						// Support: IE, Opera, Webkit
						// TODO: identify versions
						// getElementById can match elements by name instead of ID
						if ( newContext && (elem = newContext.getElementById( m )) &&
							contains( context, elem ) &&
							elem.id === m ) {

							results.push( elem );
							return results;
						}
					}

				// Type selector
				} else if ( match[2] ) {
					push.apply( results, context.getElementsByTagName( selector ) );
					return results;

				// Class selector
				} else if ( (m = match[3]) && support.getElementsByClassName &&
					context.getElementsByClassName ) {

					push.apply( results, context.getElementsByClassName( m ) );
					return results;
				}
			}

			// Take advantage of querySelectorAll
			if ( support.qsa &&
				!compilerCache[ selector + " " ] &&
				(!rbuggyQSA || !rbuggyQSA.test( selector )) ) {

				if ( nodeType !== 1 ) {
					newContext = context;
					newSelector = selector;

				// qSA looks outside Element context, which is not what we want
				// Thanks to Andrew Dupont for this workaround technique
				// Support: IE <=8
				// Exclude object elements
				} else if ( context.nodeName.toLowerCase() !== "object" ) {

					// Capture the context ID, setting it first if necessary
					if ( (nid = context.getAttribute( "id" )) ) {
						nid = nid.replace( rcssescape, fcssescape );
					} else {
						context.setAttribute( "id", (nid = expando) );
					}

					// Prefix every selector in the list
					groups = tokenize( selector );
					i = groups.length;
					while ( i-- ) {
						groups[i] = "#" + nid + " " + toSelector( groups[i] );
					}
					newSelector = groups.join( "," );

					// Expand context for sibling selectors
					newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
						context;
				}

				if ( newSelector ) {
					try {
						push.apply( results,
							newContext.querySelectorAll( newSelector )
						);
						return results;
					} catch ( qsaError ) {
					} finally {
						if ( nid === expando ) {
							context.removeAttribute( "id" );
						}
					}
				}
			}
		}
	}

	// All others
	return select( selector.replace( rtrim, "$1" ), context, results, seed );
}

/**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */
function createCache() {
	var keys = [];

	function cache( key, value ) {
		// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
		if ( keys.push( key + " " ) > Expr.cacheLength ) {
			// Only keep the most recent entries
			delete cache[ keys.shift() ];
		}
		return (cache[ key + " " ] = value);
	}
	return cache;
}

/**
 * Mark a function for special use by Sizzle
 * @param {Function} fn The function to mark
 */
function markFunction( fn ) {
	fn[ expando ] = true;
	return fn;
}

/**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */
function assert( fn ) {
	var el = document.createElement("fieldset");

	try {
		return !!fn( el );
	} catch (e) {
		return false;
	} finally {
		// Remove from its parent by default
		if ( el.parentNode ) {
			el.parentNode.removeChild( el );
		}
		// release memory in IE
		el = null;
	}
}

/**
 * Adds the same handler for all of the specified attrs
 * @param {String} attrs Pipe-separated list of attributes
 * @param {Function} handler The method that will be applied
 */
function addHandle( attrs, handler ) {
	var arr = attrs.split("|"),
		i = arr.length;

	while ( i-- ) {
		Expr.attrHandle[ arr[i] ] = handler;
	}
}

/**
 * Checks document order of two siblings
 * @param {Element} a
 * @param {Element} b
 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
 */
function siblingCheck( a, b ) {
	var cur = b && a,
		diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
			a.sourceIndex - b.sourceIndex;

	// Use IE sourceIndex if available on both nodes
	if ( diff ) {
		return diff;
	}

	// Check if b follows a
	if ( cur ) {
		while ( (cur = cur.nextSibling) ) {
			if ( cur === b ) {
				return -1;
			}
		}
	}

	return a ? 1 : -1;
}

/**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */
function createInputPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return name === "input" && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */
function createButtonPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return (name === "input" || name === "button") && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */
function createDisabledPseudo( disabled ) {

	// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
	return function( elem ) {

		// Only certain elements can match :enabled or :disabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
		if ( "form" in elem ) {

			// Check for inherited disabledness on relevant non-disabled elements:
			// * listed form-associated elements in a disabled fieldset
			//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
			// * option elements in a disabled optgroup
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
			// All such elements have a "form" property.
			if ( elem.parentNode && elem.disabled === false ) {

				// Option elements defer to a parent optgroup if present
				if ( "label" in elem ) {
					if ( "label" in elem.parentNode ) {
						return elem.parentNode.disabled === disabled;
					} else {
						return elem.disabled === disabled;
					}
				}

				// Support: IE 6 - 11
				// Use the isDisabled shortcut property to check for disabled fieldset ancestors
				return elem.isDisabled === disabled ||

					// Where there is no isDisabled, check manually
					/* jshint -W018 */
					elem.isDisabled !== !disabled &&
						disabledAncestor( elem ) === disabled;
			}

			return elem.disabled === disabled;

		// Try to winnow out elements that can't be disabled before trusting the disabled property.
		// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
		// even exist on them, let alone have a boolean value.
		} else if ( "label" in elem ) {
			return elem.disabled === disabled;
		}

		// Remaining elements are neither :enabled nor :disabled
		return false;
	};
}

/**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */
function createPositionalPseudo( fn ) {
	return markFunction(function( argument ) {
		argument = +argument;
		return markFunction(function( seed, matches ) {
			var j,
				matchIndexes = fn( [], seed.length, argument ),
				i = matchIndexes.length;

			// Match elements found at the specified indexes
			while ( i-- ) {
				if ( seed[ (j = matchIndexes[i]) ] ) {
					seed[j] = !(matches[j] = seed[j]);
				}
			}
		});
	});
}

/**
 * Checks a node for validity as a Sizzle context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */
function testContext( context ) {
	return context && typeof context.getElementsByTagName !== "undefined" && context;
}

// Expose support vars for convenience
support = Sizzle.support = {};

/**
 * Detects XML nodes
 * @param {Element|Object} elem An element or a document
 * @returns {Boolean} True iff elem is a non-HTML XML node
 */
isXML = Sizzle.isXML = function( elem ) {
	// documentElement is verified for cases where it doesn't yet exist
	// (such as loading iframes in IE - #4833)
	var documentElement = elem && (elem.ownerDocument || elem).documentElement;
	return documentElement ? documentElement.nodeName !== "HTML" : false;
};

/**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [doc] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */
setDocument = Sizzle.setDocument = function( node ) {
	var hasCompare, subWindow,
		doc = node ? node.ownerDocument || node : preferredDoc;

	// Return early if doc is invalid or already selected
	if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
		return document;
	}

	// Update global variables
	document = doc;
	docElem = document.documentElement;
	documentIsHTML = !isXML( document );

	// Support: IE 9-11, Edge
	// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
	if ( preferredDoc !== document &&
		(subWindow = document.defaultView) && subWindow.top !== subWindow ) {

		// Support: IE 11, Edge
		if ( subWindow.addEventListener ) {
			subWindow.addEventListener( "unload", unloadHandler, false );

		// Support: IE 9 - 10 only
		} else if ( subWindow.attachEvent ) {
			subWindow.attachEvent( "onunload", unloadHandler );
		}
	}

	/* Attributes
	---------------------------------------------------------------------- */

	// Support: IE<8
	// Verify that getAttribute really returns attributes and not properties
	// (excepting IE8 booleans)
	support.attributes = assert(function( el ) {
		el.className = "i";
		return !el.getAttribute("className");
	});

	/* getElement(s)By*
	---------------------------------------------------------------------- */

	// Check if getElementsByTagName("*") returns only elements
	support.getElementsByTagName = assert(function( el ) {
		el.appendChild( document.createComment("") );
		return !el.getElementsByTagName("*").length;
	});

	// Support: IE<9
	support.getElementsByClassName = rnative.test( document.getElementsByClassName );

	// Support: IE<10
	// Check if getElementById returns elements by name
	// The broken getElementById methods don't pick up programmatically-set names,
	// so use a roundabout getElementsByName test
	support.getById = assert(function( el ) {
		docElem.appendChild( el ).id = expando;
		return !document.getElementsByName || !document.getElementsByName( expando ).length;
	});

	// ID filter and find
	if ( support.getById ) {
		Expr.filter["ID"] = function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				return elem.getAttribute("id") === attrId;
			};
		};
		Expr.find["ID"] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var elem = context.getElementById( id );
				return elem ? [ elem ] : [];
			}
		};
	} else {
		Expr.filter["ID"] =  function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				var node = typeof elem.getAttributeNode !== "undefined" &&
					elem.getAttributeNode("id");
				return node && node.value === attrId;
			};
		};

		// Support: IE 6 - 7 only
		// getElementById is not reliable as a find shortcut
		Expr.find["ID"] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var node, i, elems,
					elem = context.getElementById( id );

				if ( elem ) {

					// Verify the id attribute
					node = elem.getAttributeNode("id");
					if ( node && node.value === id ) {
						return [ elem ];
					}

					// Fall back on getElementsByName
					elems = context.getElementsByName( id );
					i = 0;
					while ( (elem = elems[i++]) ) {
						node = elem.getAttributeNode("id");
						if ( node && node.value === id ) {
							return [ elem ];
						}
					}
				}

				return [];
			}
		};
	}

	// Tag
	Expr.find["TAG"] = support.getElementsByTagName ?
		function( tag, context ) {
			if ( typeof context.getElementsByTagName !== "undefined" ) {
				return context.getElementsByTagName( tag );

			// DocumentFragment nodes don't have gEBTN
			} else if ( support.qsa ) {
				return context.querySelectorAll( tag );
			}
		} :

		function( tag, context ) {
			var elem,
				tmp = [],
				i = 0,
				// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
				results = context.getElementsByTagName( tag );

			// Filter out possible comments
			if ( tag === "*" ) {
				while ( (elem = results[i++]) ) {
					if ( elem.nodeType === 1 ) {
						tmp.push( elem );
					}
				}

				return tmp;
			}
			return results;
		};

	// Class
	Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
		if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
			return context.getElementsByClassName( className );
		}
	};

	/* QSA/matchesSelector
	---------------------------------------------------------------------- */

	// QSA and matchesSelector support

	// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
	rbuggyMatches = [];

	// qSa(:focus) reports false when true (Chrome 21)
	// We allow this because of a bug in IE8/9 that throws an error
	// whenever `document.activeElement` is accessed on an iframe
	// So, we allow :focus to pass through QSA all the time to avoid the IE error
	// See https://bugs.jquery.com/ticket/13378
	rbuggyQSA = [];

	if ( (support.qsa = rnative.test( document.querySelectorAll )) ) {
		// Build QSA regex
		// Regex strategy adopted from Diego Perini
		assert(function( el ) {
			// Select is set to empty string on purpose
			// This is to test IE's treatment of not explicitly
			// setting a boolean content attribute,
			// since its presence should be enough
			// https://bugs.jquery.com/ticket/12359
			docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
				"<select id='" + expando + "-\r\\' msallowcapture=''>" +
				"<option selected=''></option></select>";

			// Support: IE8, Opera 11-12.16
			// Nothing should be selected when empty strings follow ^= or $= or *=
			// The test attribute must be unknown in Opera but "safe" for WinRT
			// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
			if ( el.querySelectorAll("[msallowcapture^='']").length ) {
				rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
			}

			// Support: IE8
			// Boolean attributes and "value" are not treated correctly
			if ( !el.querySelectorAll("[selected]").length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
			}

			// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
			if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
				rbuggyQSA.push("~=");
			}

			// Webkit/Opera - :checked should return selected option elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			// IE8 throws error here and will not see later tests
			if ( !el.querySelectorAll(":checked").length ) {
				rbuggyQSA.push(":checked");
			}

			// Support: Safari 8+, iOS 8+
			// https://bugs.webkit.org/show_bug.cgi?id=136851
			// In-page `selector#id sibling-combinator selector` fails
			if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
				rbuggyQSA.push(".#.+[+~]");
			}
		});

		assert(function( el ) {
			el.innerHTML = "<a href='' disabled='disabled'></a>" +
				"<select disabled='disabled'><option/></select>";

			// Support: Windows 8 Native Apps
			// The type and name attributes are restricted during .innerHTML assignment
			var input = document.createElement("input");
			input.setAttribute( "type", "hidden" );
			el.appendChild( input ).setAttribute( "name", "D" );

			// Support: IE8
			// Enforce case-sensitivity of name attribute
			if ( el.querySelectorAll("[name=d]").length ) {
				rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
			}

			// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
			// IE8 throws error here and will not see later tests
			if ( el.querySelectorAll(":enabled").length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Support: IE9-11+
			// IE's :disabled selector does not pick up the children of disabled fieldsets
			docElem.appendChild( el ).disabled = true;
			if ( el.querySelectorAll(":disabled").length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Opera 10-11 does not throw on post-comma invalid pseudos
			el.querySelectorAll("*,:x");
			rbuggyQSA.push(",.*:");
		});
	}

	if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
		docElem.webkitMatchesSelector ||
		docElem.mozMatchesSelector ||
		docElem.oMatchesSelector ||
		docElem.msMatchesSelector) )) ) {

		assert(function( el ) {
			// Check to see if it's possible to do matchesSelector
			// on a disconnected node (IE 9)
			support.disconnectedMatch = matches.call( el, "*" );

			// This should fail with an exception
			// Gecko does not error, returns false instead
			matches.call( el, "[s!='']:x" );
			rbuggyMatches.push( "!=", pseudos );
		});
	}

	rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
	rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );

	/* Contains
	---------------------------------------------------------------------- */
	hasCompare = rnative.test( docElem.compareDocumentPosition );

	// Element contains another
	// Purposefully self-exclusive
	// As in, an element does not contain itself
	contains = hasCompare || rnative.test( docElem.contains ) ?
		function( a, b ) {
			var adown = a.nodeType === 9 ? a.documentElement : a,
				bup = b && b.parentNode;
			return a === bup || !!( bup && bup.nodeType === 1 && (
				adown.contains ?
					adown.contains( bup ) :
					a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
			));
		} :
		function( a, b ) {
			if ( b ) {
				while ( (b = b.parentNode) ) {
					if ( b === a ) {
						return true;
					}
				}
			}
			return false;
		};

	/* Sorting
	---------------------------------------------------------------------- */

	// Document order sorting
	sortOrder = hasCompare ?
	function( a, b ) {

		// Flag for duplicate removal
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		// Sort on method existence if only one input has compareDocumentPosition
		var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
		if ( compare ) {
			return compare;
		}

		// Calculate position if both inputs belong to the same document
		compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
			a.compareDocumentPosition( b ) :

			// Otherwise we know they are disconnected
			1;

		// Disconnected nodes
		if ( compare & 1 ||
			(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {

			// Choose the first element that is related to our preferred document
			if ( a === document || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
				return -1;
			}
			if ( b === document || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
				return 1;
			}

			// Maintain original order
			return sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;
		}

		return compare & 4 ? -1 : 1;
	} :
	function( a, b ) {
		// Exit early if the nodes are identical
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		var cur,
			i = 0,
			aup = a.parentNode,
			bup = b.parentNode,
			ap = [ a ],
			bp = [ b ];

		// Parentless nodes are either documents or disconnected
		if ( !aup || !bup ) {
			return a === document ? -1 :
				b === document ? 1 :
				aup ? -1 :
				bup ? 1 :
				sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;

		// If the nodes are siblings, we can do a quick check
		} else if ( aup === bup ) {
			return siblingCheck( a, b );
		}

		// Otherwise we need full lists of their ancestors for comparison
		cur = a;
		while ( (cur = cur.parentNode) ) {
			ap.unshift( cur );
		}
		cur = b;
		while ( (cur = cur.parentNode) ) {
			bp.unshift( cur );
		}

		// Walk down the tree looking for a discrepancy
		while ( ap[i] === bp[i] ) {
			i++;
		}

		return i ?
			// Do a sibling check if the nodes have a common ancestor
			siblingCheck( ap[i], bp[i] ) :

			// Otherwise nodes in our document sort first
			ap[i] === preferredDoc ? -1 :
			bp[i] === preferredDoc ? 1 :
			0;
	};

	return document;
};

Sizzle.matches = function( expr, elements ) {
	return Sizzle( expr, null, null, elements );
};

Sizzle.matchesSelector = function( elem, expr ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	// Make sure that attribute selectors are quoted
	expr = expr.replace( rattributeQuotes, "='$1']" );

	if ( support.matchesSelector && documentIsHTML &&
		!compilerCache[ expr + " " ] &&
		( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
		( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {

		try {
			var ret = matches.call( elem, expr );

			// IE 9's matchesSelector returns false on disconnected nodes
			if ( ret || support.disconnectedMatch ||
					// As well, disconnected nodes are said to be in a document
					// fragment in IE 9
					elem.document && elem.document.nodeType !== 11 ) {
				return ret;
			}
		} catch (e) {}
	}

	return Sizzle( expr, document, null, [ elem ] ).length > 0;
};

Sizzle.contains = function( context, elem ) {
	// Set document vars if needed
	if ( ( context.ownerDocument || context ) !== document ) {
		setDocument( context );
	}
	return contains( context, elem );
};

Sizzle.attr = function( elem, name ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	var fn = Expr.attrHandle[ name.toLowerCase() ],
		// Don't get fooled by Object.prototype properties (jQuery #13807)
		val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
			fn( elem, name, !documentIsHTML ) :
			undefined;

	return val !== undefined ?
		val :
		support.attributes || !documentIsHTML ?
			elem.getAttribute( name ) :
			(val = elem.getAttributeNode(name)) && val.specified ?
				val.value :
				null;
};

Sizzle.escape = function( sel ) {
	return (sel + "").replace( rcssescape, fcssescape );
};

Sizzle.error = function( msg ) {
	throw new Error( "Syntax error, unrecognized expression: " + msg );
};

/**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */
Sizzle.uniqueSort = function( results ) {
	var elem,
		duplicates = [],
		j = 0,
		i = 0;

	// Unless we *know* we can detect duplicates, assume their presence
	hasDuplicate = !support.detectDuplicates;
	sortInput = !support.sortStable && results.slice( 0 );
	results.sort( sortOrder );

	if ( hasDuplicate ) {
		while ( (elem = results[i++]) ) {
			if ( elem === results[ i ] ) {
				j = duplicates.push( i );
			}
		}
		while ( j-- ) {
			results.splice( duplicates[ j ], 1 );
		}
	}

	// Clear input after sorting to release objects
	// See https://github.com/jquery/sizzle/pull/225
	sortInput = null;

	return results;
};

/**
 * Utility function for retrieving the text value of an array of DOM nodes
 * @param {Array|Element} elem
 */
getText = Sizzle.getText = function( elem ) {
	var node,
		ret = "",
		i = 0,
		nodeType = elem.nodeType;

	if ( !nodeType ) {
		// If no nodeType, this is expected to be an array
		while ( (node = elem[i++]) ) {
			// Do not traverse comment nodes
			ret += getText( node );
		}
	} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
		// Use textContent for elements
		// innerText usage removed for consistency of new lines (jQuery #11153)
		if ( typeof elem.textContent === "string" ) {
			return elem.textContent;
		} else {
			// Traverse its children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				ret += getText( elem );
			}
		}
	} else if ( nodeType === 3 || nodeType === 4 ) {
		return elem.nodeValue;
	}
	// Do not include comment or processing instruction nodes

	return ret;
};

Expr = Sizzle.selectors = {

	// Can be adjusted by the user
	cacheLength: 50,

	createPseudo: markFunction,

	match: matchExpr,

	attrHandle: {},

	find: {},

	relative: {
		">": { dir: "parentNode", first: true },
		" ": { dir: "parentNode" },
		"+": { dir: "previousSibling", first: true },
		"~": { dir: "previousSibling" }
	},

	preFilter: {
		"ATTR": function( match ) {
			match[1] = match[1].replace( runescape, funescape );

			// Move the given value to match[3] whether quoted or unquoted
			match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );

			if ( match[2] === "~=" ) {
				match[3] = " " + match[3] + " ";
			}

			return match.slice( 0, 4 );
		},

		"CHILD": function( match ) {
			/* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/
			match[1] = match[1].toLowerCase();

			if ( match[1].slice( 0, 3 ) === "nth" ) {
				// nth-* requires argument
				if ( !match[3] ) {
					Sizzle.error( match[0] );
				}

				// numeric x and y parameters for Expr.filter.CHILD
				// remember that false/true cast respectively to 0/1
				match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
				match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );

			// other types prohibit arguments
			} else if ( match[3] ) {
				Sizzle.error( match[0] );
			}

			return match;
		},

		"PSEUDO": function( match ) {
			var excess,
				unquoted = !match[6] && match[2];

			if ( matchExpr["CHILD"].test( match[0] ) ) {
				return null;
			}

			// Accept quoted arguments as-is
			if ( match[3] ) {
				match[2] = match[4] || match[5] || "";

			// Strip excess characters from unquoted arguments
			} else if ( unquoted && rpseudo.test( unquoted ) &&
				// Get excess from tokenize (recursively)
				(excess = tokenize( unquoted, true )) &&
				// advance to the next closing parenthesis
				(excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {

				// excess is a negative index
				match[0] = match[0].slice( 0, excess );
				match[2] = unquoted.slice( 0, excess );
			}

			// Return only captures needed by the pseudo filter method (type and argument)
			return match.slice( 0, 3 );
		}
	},

	filter: {

		"TAG": function( nodeNameSelector ) {
			var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
			return nodeNameSelector === "*" ?
				function() { return true; } :
				function( elem ) {
					return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
				};
		},

		"CLASS": function( className ) {
			var pattern = classCache[ className + " " ];

			return pattern ||
				(pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
				classCache( className, function( elem ) {
					return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "" );
				});
		},

		"ATTR": function( name, operator, check ) {
			return function( elem ) {
				var result = Sizzle.attr( elem, name );

				if ( result == null ) {
					return operator === "!=";
				}
				if ( !operator ) {
					return true;
				}

				result += "";

				return operator === "=" ? result === check :
					operator === "!=" ? result !== check :
					operator === "^=" ? check && result.indexOf( check ) === 0 :
					operator === "*=" ? check && result.indexOf( check ) > -1 :
					operator === "$=" ? check && result.slice( -check.length ) === check :
					operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
					operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
					false;
			};
		},

		"CHILD": function( type, what, argument, first, last ) {
			var simple = type.slice( 0, 3 ) !== "nth",
				forward = type.slice( -4 ) !== "last",
				ofType = what === "of-type";

			return first === 1 && last === 0 ?

				// Shortcut for :nth-*(n)
				function( elem ) {
					return !!elem.parentNode;
				} :

				function( elem, context, xml ) {
					var cache, uniqueCache, outerCache, node, nodeIndex, start,
						dir = simple !== forward ? "nextSibling" : "previousSibling",
						parent = elem.parentNode,
						name = ofType && elem.nodeName.toLowerCase(),
						useCache = !xml && !ofType,
						diff = false;

					if ( parent ) {

						// :(first|last|only)-(child|of-type)
						if ( simple ) {
							while ( dir ) {
								node = elem;
								while ( (node = node[ dir ]) ) {
									if ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) {

										return false;
									}
								}
								// Reverse direction for :only-* (if we haven't yet done so)
								start = dir = type === "only" && !start && "nextSibling";
							}
							return true;
						}

						start = [ forward ? parent.firstChild : parent.lastChild ];

						// non-xml :nth-child(...) stores cache data on `parent`
						if ( forward && useCache ) {

							// Seek `elem` from a previously-cached index

							// ...in a gzip-friendly way
							node = parent;
							outerCache = node[ expando ] || (node[ expando ] = {});

							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ node.uniqueID ] ||
								(outerCache[ node.uniqueID ] = {});

							cache = uniqueCache[ type ] || [];
							nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
							diff = nodeIndex && cache[ 2 ];
							node = nodeIndex && parent.childNodes[ nodeIndex ];

							while ( (node = ++nodeIndex && node && node[ dir ] ||

								// Fallback to seeking `elem` from the start
								(diff = nodeIndex = 0) || start.pop()) ) {

								// When found, cache indexes on `parent` and break
								if ( node.nodeType === 1 && ++diff && node === elem ) {
									uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
									break;
								}
							}

						} else {
							// Use previously-cached element index if available
							if ( useCache ) {
								// ...in a gzip-friendly way
								node = elem;
								outerCache = node[ expando ] || (node[ expando ] = {});

								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									(outerCache[ node.uniqueID ] = {});

								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex;
							}

							// xml :nth-child(...)
							// or :nth-last-child(...) or :nth(-last)?-of-type(...)
							if ( diff === false ) {
								// Use the same loop as above to seek `elem` from the start
								while ( (node = ++nodeIndex && node && node[ dir ] ||
									(diff = nodeIndex = 0) || start.pop()) ) {

									if ( ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) &&
										++diff ) {

										// Cache the index of each encountered element
										if ( useCache ) {
											outerCache = node[ expando ] || (node[ expando ] = {});

											// Support: IE <9 only
											// Defend against cloned attroperties (jQuery gh-1709)
											uniqueCache = outerCache[ node.uniqueID ] ||
												(outerCache[ node.uniqueID ] = {});

											uniqueCache[ type ] = [ dirruns, diff ];
										}

										if ( node === elem ) {
											break;
										}
									}
								}
							}
						}

						// Incorporate the offset, then check against cycle size
						diff -= last;
						return diff === first || ( diff % first === 0 && diff / first >= 0 );
					}
				};
		},

		"PSEUDO": function( pseudo, argument ) {
			// pseudo-class names are case-insensitive
			// http://www.w3.org/TR/selectors/#pseudo-classes
			// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
			// Remember that setFilters inherits from pseudos
			var args,
				fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
					Sizzle.error( "unsupported pseudo: " + pseudo );

			// The user may use createPseudo to indicate that
			// arguments are needed to create the filter function
			// just as Sizzle does
			if ( fn[ expando ] ) {
				return fn( argument );
			}

			// But maintain support for old signatures
			if ( fn.length > 1 ) {
				args = [ pseudo, pseudo, "", argument ];
				return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
					markFunction(function( seed, matches ) {
						var idx,
							matched = fn( seed, argument ),
							i = matched.length;
						while ( i-- ) {
							idx = indexOf( seed, matched[i] );
							seed[ idx ] = !( matches[ idx ] = matched[i] );
						}
					}) :
					function( elem ) {
						return fn( elem, 0, args );
					};
			}

			return fn;
		}
	},

	pseudos: {
		// Potentially complex pseudos
		"not": markFunction(function( selector ) {
			// Trim the selector passed to compile
			// to avoid treating leading and trailing
			// spaces as combinators
			var input = [],
				results = [],
				matcher = compile( selector.replace( rtrim, "$1" ) );

			return matcher[ expando ] ?
				markFunction(function( seed, matches, context, xml ) {
					var elem,
						unmatched = matcher( seed, null, xml, [] ),
						i = seed.length;

					// Match elements unmatched by `matcher`
					while ( i-- ) {
						if ( (elem = unmatched[i]) ) {
							seed[i] = !(matches[i] = elem);
						}
					}
				}) :
				function( elem, context, xml ) {
					input[0] = elem;
					matcher( input, null, xml, results );
					// Don't keep the element (issue #299)
					input[0] = null;
					return !results.pop();
				};
		}),

		"has": markFunction(function( selector ) {
			return function( elem ) {
				return Sizzle( selector, elem ).length > 0;
			};
		}),

		"contains": markFunction(function( text ) {
			text = text.replace( runescape, funescape );
			return function( elem ) {
				return ( elem.textContent || elem.innerText || getText( elem ) ).indexOf( text ) > -1;
			};
		}),

		// "Whether an element is represented by a :lang() selector
		// is based solely on the element's language value
		// being equal to the identifier C,
		// or beginning with the identifier C immediately followed by "-".
		// The matching of C against the element's language value is performed case-insensitively.
		// The identifier C does not have to be a valid language name."
		// http://www.w3.org/TR/selectors/#lang-pseudo
		"lang": markFunction( function( lang ) {
			// lang value must be a valid identifier
			if ( !ridentifier.test(lang || "") ) {
				Sizzle.error( "unsupported lang: " + lang );
			}
			lang = lang.replace( runescape, funescape ).toLowerCase();
			return function( elem ) {
				var elemLang;
				do {
					if ( (elemLang = documentIsHTML ?
						elem.lang :
						elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {

						elemLang = elemLang.toLowerCase();
						return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
					}
				} while ( (elem = elem.parentNode) && elem.nodeType === 1 );
				return false;
			};
		}),

		// Miscellaneous
		"target": function( elem ) {
			var hash = window.location && window.location.hash;
			return hash && hash.slice( 1 ) === elem.id;
		},

		"root": function( elem ) {
			return elem === docElem;
		},

		"focus": function( elem ) {
			return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
		},

		// Boolean properties
		"enabled": createDisabledPseudo( false ),
		"disabled": createDisabledPseudo( true ),

		"checked": function( elem ) {
			// In CSS3, :checked should return both checked and selected elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			var nodeName = elem.nodeName.toLowerCase();
			return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
		},

		"selected": function( elem ) {
			// Accessing this property makes selected-by-default
			// options in Safari work properly
			if ( elem.parentNode ) {
				elem.parentNode.selectedIndex;
			}

			return elem.selected === true;
		},

		// Contents
		"empty": function( elem ) {
			// http://www.w3.org/TR/selectors/#empty-pseudo
			// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
			//   but not by others (comment: 8; processing instruction: 7; etc.)
			// nodeType < 6 works because attributes (2) do not appear as children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				if ( elem.nodeType < 6 ) {
					return false;
				}
			}
			return true;
		},

		"parent": function( elem ) {
			return !Expr.pseudos["empty"]( elem );
		},

		// Element/input types
		"header": function( elem ) {
			return rheader.test( elem.nodeName );
		},

		"input": function( elem ) {
			return rinputs.test( elem.nodeName );
		},

		"button": function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === "button" || name === "button";
		},

		"text": function( elem ) {
			var attr;
			return elem.nodeName.toLowerCase() === "input" &&
				elem.type === "text" &&

				// Support: IE<8
				// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
				( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
		},

		// Position-in-collection
		"first": createPositionalPseudo(function() {
			return [ 0 ];
		}),

		"last": createPositionalPseudo(function( matchIndexes, length ) {
			return [ length - 1 ];
		}),

		"eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
			return [ argument < 0 ? argument + length : argument ];
		}),

		"even": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 0;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"odd": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 1;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; --i >= 0; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; ++i < length; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		})
	}
};

Expr.pseudos["nth"] = Expr.pseudos["eq"];

// Add button/input type pseudos
for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
	Expr.pseudos[ i ] = createInputPseudo( i );
}
for ( i in { submit: true, reset: true } ) {
	Expr.pseudos[ i ] = createButtonPseudo( i );
}

// Easy API for creating new setFilters
function setFilters() {}
setFilters.prototype = Expr.filters = Expr.pseudos;
Expr.setFilters = new setFilters();

tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
	var matched, match, tokens, type,
		soFar, groups, preFilters,
		cached = tokenCache[ selector + " " ];

	if ( cached ) {
		return parseOnly ? 0 : cached.slice( 0 );
	}

	soFar = selector;
	groups = [];
	preFilters = Expr.preFilter;

	while ( soFar ) {

		// Comma and first run
		if ( !matched || (match = rcomma.exec( soFar )) ) {
			if ( match ) {
				// Don't consume trailing commas as valid
				soFar = soFar.slice( match[0].length ) || soFar;
			}
			groups.push( (tokens = []) );
		}

		matched = false;

		// Combinators
		if ( (match = rcombinators.exec( soFar )) ) {
			matched = match.shift();
			tokens.push({
				value: matched,
				// Cast descendant combinators to space
				type: match[0].replace( rtrim, " " )
			});
			soFar = soFar.slice( matched.length );
		}

		// Filters
		for ( type in Expr.filter ) {
			if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
				(match = preFilters[ type ]( match ))) ) {
				matched = match.shift();
				tokens.push({
					value: matched,
					type: type,
					matches: match
				});
				soFar = soFar.slice( matched.length );
			}
		}

		if ( !matched ) {
			break;
		}
	}

	// Return the length of the invalid excess
	// if we're just parsing
	// Otherwise, throw an error or return tokens
	return parseOnly ?
		soFar.length :
		soFar ?
			Sizzle.error( selector ) :
			// Cache the tokens
			tokenCache( selector, groups ).slice( 0 );
};

function toSelector( tokens ) {
	var i = 0,
		len = tokens.length,
		selector = "";
	for ( ; i < len; i++ ) {
		selector += tokens[i].value;
	}
	return selector;
}

function addCombinator( matcher, combinator, base ) {
	var dir = combinator.dir,
		skip = combinator.next,
		key = skip || dir,
		checkNonElements = base && key === "parentNode",
		doneName = done++;

	return combinator.first ?
		// Check against closest ancestor/preceding element
		function( elem, context, xml ) {
			while ( (elem = elem[ dir ]) ) {
				if ( elem.nodeType === 1 || checkNonElements ) {
					return matcher( elem, context, xml );
				}
			}
			return false;
		} :

		// Check against all ancestor/preceding elements
		function( elem, context, xml ) {
			var oldCache, uniqueCache, outerCache,
				newCache = [ dirruns, doneName ];

			// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
			if ( xml ) {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						if ( matcher( elem, context, xml ) ) {
							return true;
						}
					}
				}
			} else {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						outerCache = elem[ expando ] || (elem[ expando ] = {});

						// Support: IE <9 only
						// Defend against cloned attroperties (jQuery gh-1709)
						uniqueCache = outerCache[ elem.uniqueID ] || (outerCache[ elem.uniqueID ] = {});

						if ( skip && skip === elem.nodeName.toLowerCase() ) {
							elem = elem[ dir ] || elem;
						} else if ( (oldCache = uniqueCache[ key ]) &&
							oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {

							// Assign to newCache so results back-propagate to previous elements
							return (newCache[ 2 ] = oldCache[ 2 ]);
						} else {
							// Reuse newcache so results back-propagate to previous elements
							uniqueCache[ key ] = newCache;

							// A match means we're done; a fail means we have to keep checking
							if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
								return true;
							}
						}
					}
				}
			}
			return false;
		};
}

function elementMatcher( matchers ) {
	return matchers.length > 1 ?
		function( elem, context, xml ) {
			var i = matchers.length;
			while ( i-- ) {
				if ( !matchers[i]( elem, context, xml ) ) {
					return false;
				}
			}
			return true;
		} :
		matchers[0];
}

function multipleContexts( selector, contexts, results ) {
	var i = 0,
		len = contexts.length;
	for ( ; i < len; i++ ) {
		Sizzle( selector, contexts[i], results );
	}
	return results;
}

function condense( unmatched, map, filter, context, xml ) {
	var elem,
		newUnmatched = [],
		i = 0,
		len = unmatched.length,
		mapped = map != null;

	for ( ; i < len; i++ ) {
		if ( (elem = unmatched[i]) ) {
			if ( !filter || filter( elem, context, xml ) ) {
				newUnmatched.push( elem );
				if ( mapped ) {
					map.push( i );
				}
			}
		}
	}

	return newUnmatched;
}

function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
	if ( postFilter && !postFilter[ expando ] ) {
		postFilter = setMatcher( postFilter );
	}
	if ( postFinder && !postFinder[ expando ] ) {
		postFinder = setMatcher( postFinder, postSelector );
	}
	return markFunction(function( seed, results, context, xml ) {
		var temp, i, elem,
			preMap = [],
			postMap = [],
			preexisting = results.length,

			// Get initial elements from seed or context
			elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),

			// Prefilter to get matcher input, preserving a map for seed-results synchronization
			matcherIn = preFilter && ( seed || !selector ) ?
				condense( elems, preMap, preFilter, context, xml ) :
				elems,

			matcherOut = matcher ?
				// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
				postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

					// ...intermediate processing is necessary
					[] :

					// ...otherwise use results directly
					results :
				matcherIn;

		// Find primary matches
		if ( matcher ) {
			matcher( matcherIn, matcherOut, context, xml );
		}

		// Apply postFilter
		if ( postFilter ) {
			temp = condense( matcherOut, postMap );
			postFilter( temp, [], context, xml );

			// Un-match failing elements by moving them back to matcherIn
			i = temp.length;
			while ( i-- ) {
				if ( (elem = temp[i]) ) {
					matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
				}
			}
		}

		if ( seed ) {
			if ( postFinder || preFilter ) {
				if ( postFinder ) {
					// Get the final matcherOut by condensing this intermediate into postFinder contexts
					temp = [];
					i = matcherOut.length;
					while ( i-- ) {
						if ( (elem = matcherOut[i]) ) {
							// Restore matcherIn since elem is not yet a final match
							temp.push( (matcherIn[i] = elem) );
						}
					}
					postFinder( null, (matcherOut = []), temp, xml );
				}

				// Move matched elements from seed to results to keep them synchronized
				i = matcherOut.length;
				while ( i-- ) {
					if ( (elem = matcherOut[i]) &&
						(temp = postFinder ? indexOf( seed, elem ) : preMap[i]) > -1 ) {

						seed[temp] = !(results[temp] = elem);
					}
				}
			}

		// Add elements to results, through postFinder if defined
		} else {
			matcherOut = condense(
				matcherOut === results ?
					matcherOut.splice( preexisting, matcherOut.length ) :
					matcherOut
			);
			if ( postFinder ) {
				postFinder( null, results, matcherOut, xml );
			} else {
				push.apply( results, matcherOut );
			}
		}
	});
}

function matcherFromTokens( tokens ) {
	var checkContext, matcher, j,
		len = tokens.length,
		leadingRelative = Expr.relative[ tokens[0].type ],
		implicitRelative = leadingRelative || Expr.relative[" "],
		i = leadingRelative ? 1 : 0,

		// The foundational matcher ensures that elements are reachable from top-level context(s)
		matchContext = addCombinator( function( elem ) {
			return elem === checkContext;
		}, implicitRelative, true ),
		matchAnyContext = addCombinator( function( elem ) {
			return indexOf( checkContext, elem ) > -1;
		}, implicitRelative, true ),
		matchers = [ function( elem, context, xml ) {
			var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
				(checkContext = context).nodeType ?
					matchContext( elem, context, xml ) :
					matchAnyContext( elem, context, xml ) );
			// Avoid hanging onto element (issue #299)
			checkContext = null;
			return ret;
		} ];

	for ( ; i < len; i++ ) {
		if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
			matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
		} else {
			matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );

			// Return special upon seeing a positional matcher
			if ( matcher[ expando ] ) {
				// Find the next relative operator (if any) for proper handling
				j = ++i;
				for ( ; j < len; j++ ) {
					if ( Expr.relative[ tokens[j].type ] ) {
						break;
					}
				}
				return setMatcher(
					i > 1 && elementMatcher( matchers ),
					i > 1 && toSelector(
						// If the preceding token was a descendant combinator, insert an implicit any-element `*`
						tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
					).replace( rtrim, "$1" ),
					matcher,
					i < j && matcherFromTokens( tokens.slice( i, j ) ),
					j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
					j < len && toSelector( tokens )
				);
			}
			matchers.push( matcher );
		}
	}

	return elementMatcher( matchers );
}

function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
	var bySet = setMatchers.length > 0,
		byElement = elementMatchers.length > 0,
		superMatcher = function( seed, context, xml, results, outermost ) {
			var elem, j, matcher,
				matchedCount = 0,
				i = "0",
				unmatched = seed && [],
				setMatched = [],
				contextBackup = outermostContext,
				// We must always have either seed elements or outermost context
				elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
				// Use integer dirruns iff this is the outermost matcher
				dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
				len = elems.length;

			if ( outermost ) {
				outermostContext = context === document || context || outermost;
			}

			// Add elements passing elementMatchers directly to results
			// Support: IE<9, Safari
			// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
			for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
				if ( byElement && elem ) {
					j = 0;
					if ( !context && elem.ownerDocument !== document ) {
						setDocument( elem );
						xml = !documentIsHTML;
					}
					while ( (matcher = elementMatchers[j++]) ) {
						if ( matcher( elem, context || document, xml) ) {
							results.push( elem );
							break;
						}
					}
					if ( outermost ) {
						dirruns = dirrunsUnique;
					}
				}

				// Track unmatched elements for set filters
				if ( bySet ) {
					// They will have gone through all possible matchers
					if ( (elem = !matcher && elem) ) {
						matchedCount--;
					}

					// Lengthen the array for every element, matched or not
					if ( seed ) {
						unmatched.push( elem );
					}
				}
			}

			// `i` is now the count of elements visited above, and adding it to `matchedCount`
			// makes the latter nonnegative.
			matchedCount += i;

			// Apply set filters to unmatched elements
			// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
			// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
			// no element matchers and no seed.
			// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
			// case, which will result in a "00" `matchedCount` that differs from `i` but is also
			// numerically zero.
			if ( bySet && i !== matchedCount ) {
				j = 0;
				while ( (matcher = setMatchers[j++]) ) {
					matcher( unmatched, setMatched, context, xml );
				}

				if ( seed ) {
					// Reintegrate element matches to eliminate the need for sorting
					if ( matchedCount > 0 ) {
						while ( i-- ) {
							if ( !(unmatched[i] || setMatched[i]) ) {
								setMatched[i] = pop.call( results );
							}
						}
					}

					// Discard index placeholder values to get only actual matches
					setMatched = condense( setMatched );
				}

				// Add matches to results
				push.apply( results, setMatched );

				// Seedless set matches succeeding multiple successful matchers stipulate sorting
				if ( outermost && !seed && setMatched.length > 0 &&
					( matchedCount + setMatchers.length ) > 1 ) {

					Sizzle.uniqueSort( results );
				}
			}

			// Override manipulation of globals by nested matchers
			if ( outermost ) {
				dirruns = dirrunsUnique;
				outermostContext = contextBackup;
			}

			return unmatched;
		};

	return bySet ?
		markFunction( superMatcher ) :
		superMatcher;
}

compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
	var i,
		setMatchers = [],
		elementMatchers = [],
		cached = compilerCache[ selector + " " ];

	if ( !cached ) {
		// Generate a function of recursive functions that can be used to check each element
		if ( !match ) {
			match = tokenize( selector );
		}
		i = match.length;
		while ( i-- ) {
			cached = matcherFromTokens( match[i] );
			if ( cached[ expando ] ) {
				setMatchers.push( cached );
			} else {
				elementMatchers.push( cached );
			}
		}

		// Cache the compiled function
		cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );

		// Save selector and tokenization
		cached.selector = selector;
	}
	return cached;
};

/**
 * A low-level selection function that works with Sizzle's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with Sizzle.compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */
select = Sizzle.select = function( selector, context, results, seed ) {
	var i, tokens, token, type, find,
		compiled = typeof selector === "function" && selector,
		match = !seed && tokenize( (selector = compiled.selector || selector) );

	results = results || [];

	// Try to minimize operations if there is only one selector in the list and no seed
	// (the latter of which guarantees us context)
	if ( match.length === 1 ) {

		// Reduce context if the leading compound selector is an ID
		tokens = match[0] = match[0].slice( 0 );
		if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
				context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[1].type ] ) {

			context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
			if ( !context ) {
				return results;

			// Precompiled matchers will still verify ancestry, so step up a level
			} else if ( compiled ) {
				context = context.parentNode;
			}

			selector = selector.slice( tokens.shift().value.length );
		}

		// Fetch a seed set for right-to-left matching
		i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
		while ( i-- ) {
			token = tokens[i];

			// Abort if we hit a combinator
			if ( Expr.relative[ (type = token.type) ] ) {
				break;
			}
			if ( (find = Expr.find[ type ]) ) {
				// Search, expanding context for leading sibling combinators
				if ( (seed = find(
					token.matches[0].replace( runescape, funescape ),
					rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
				)) ) {

					// If seed is empty or no tokens remain, we can return early
					tokens.splice( i, 1 );
					selector = seed.length && toSelector( tokens );
					if ( !selector ) {
						push.apply( results, seed );
						return results;
					}

					break;
				}
			}
		}
	}

	// Compile and execute a filtering function if one is not provided
	// Provide `match` to avoid retokenization if we modified the selector above
	( compiled || compile( selector, match ) )(
		seed,
		context,
		!documentIsHTML,
		results,
		!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
	);
	return results;
};

// One-time assignments

// Sort stability
support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;

// Support: Chrome 14-35+
// Always assume duplicates if they aren't passed to the comparison function
support.detectDuplicates = !!hasDuplicate;

// Initialize against the default document
setDocument();

// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
// Detached nodes confoundingly follow *each other*
support.sortDetached = assert(function( el ) {
	// Should return 1, but returns 4 (following)
	return el.compareDocumentPosition( document.createElement("fieldset") ) & 1;
});

// Support: IE<8
// Prevent attribute/property "interpolation"
// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
if ( !assert(function( el ) {
	el.innerHTML = "<a href='#'></a>";
	return el.firstChild.getAttribute("href") === "#" ;
}) ) {
	addHandle( "type|href|height|width", function( elem, name, isXML ) {
		if ( !isXML ) {
			return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
		}
	});
}

// Support: IE<9
// Use defaultValue in place of getAttribute("value")
if ( !support.attributes || !assert(function( el ) {
	el.innerHTML = "<input/>";
	el.firstChild.setAttribute( "value", "" );
	return el.firstChild.getAttribute( "value" ) === "";
}) ) {
	addHandle( "value", function( elem, name, isXML ) {
		if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
			return elem.defaultValue;
		}
	});
}

// Support: IE<9
// Use getAttributeNode to fetch booleans when getAttribute lies
if ( !assert(function( el ) {
	return el.getAttribute("disabled") == null;
}) ) {
	addHandle( booleans, function( elem, name, isXML ) {
		var val;
		if ( !isXML ) {
			return elem[ name ] === true ? name.toLowerCase() :
					(val = elem.getAttributeNode( name )) && val.specified ?
					val.value :
				null;
		}
	});
}

return Sizzle;

})( window );



jQuery.find = Sizzle;
jQuery.expr = Sizzle.selectors;

// Deprecated
jQuery.expr[ ":" ] = jQuery.expr.pseudos;
jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
jQuery.text = Sizzle.getText;
jQuery.isXMLDoc = Sizzle.isXML;
jQuery.contains = Sizzle.contains;
jQuery.escapeSelector = Sizzle.escape;




var dir = function( elem, dir, until ) {
	var matched = [],
		truncate = until !== undefined;

	while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
		if ( elem.nodeType === 1 ) {
			if ( truncate && jQuery( elem ).is( until ) ) {
				break;
			}
			matched.push( elem );
		}
	}
	return matched;
};


var siblings = function( n, elem ) {
	var matched = [];

	for ( ; n; n = n.nextSibling ) {
		if ( n.nodeType === 1 && n !== elem ) {
			matched.push( n );
		}
	}

	return matched;
};


var rneedsContext = jQuery.expr.match.needsContext;



function nodeName( elem, name ) {

  return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();

};
var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );



// Implement the identical functionality for filter and not
function winnow( elements, qualifier, not ) {
	if ( isFunction( qualifier ) ) {
		return jQuery.grep( elements, function( elem, i ) {
			return !!qualifier.call( elem, i, elem ) !== not;
		} );
	}

	// Single element
	if ( qualifier.nodeType ) {
		return jQuery.grep( elements, function( elem ) {
			return ( elem === qualifier ) !== not;
		} );
	}

	// Arraylike of elements (jQuery, arguments, Array)
	if ( typeof qualifier !== "string" ) {
		return jQuery.grep( elements, function( elem ) {
			return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
		} );
	}

	// Filtered directly for both simple and complex selectors
	return jQuery.filter( qualifier, elements, not );
}

jQuery.filter = function( expr, elems, not ) {
	var elem = elems[ 0 ];

	if ( not ) {
		expr = ":not(" + expr + ")";
	}

	if ( elems.length === 1 && elem.nodeType === 1 ) {
		return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
	}

	return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
		return elem.nodeType === 1;
	} ) );
};

jQuery.fn.extend( {
	find: function( selector ) {
		var i, ret,
			len = this.length,
			self = this;

		if ( typeof selector !== "string" ) {
			return this.pushStack( jQuery( selector ).filter( function() {
				for ( i = 0; i < len; i++ ) {
					if ( jQuery.contains( self[ i ], this ) ) {
						return true;
					}
				}
			} ) );
		}

		ret = this.pushStack( [] );

		for ( i = 0; i < len; i++ ) {
			jQuery.find( selector, self[ i ], ret );
		}

		return len > 1 ? jQuery.uniqueSort( ret ) : ret;
	},
	filter: function( selector ) {
		return this.pushStack( winnow( this, selector || [], false ) );
	},
	not: function( selector ) {
		return this.pushStack( winnow( this, selector || [], true ) );
	},
	is: function( selector ) {
		return !!winnow(
			this,

			// If this is a positional/relative selector, check membership in the returned set
			// so $("p:first").is("p:last") won't return true for a doc with two "p".
			typeof selector === "string" && rneedsContext.test( selector ) ?
				jQuery( selector ) :
				selector || [],
			false
		).length;
	}
} );


// Initialize a jQuery object


// A central reference to the root jQuery(document)
var rootjQuery,

	// A simple way to check for HTML strings
	// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
	// Strict HTML recognition (#11290: must start with <)
	// Shortcut simple #id case for speed
	rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,

	init = jQuery.fn.init = function( selector, context, root ) {
		var match, elem;

		// HANDLE: $(""), $(null), $(undefined), $(false)
		if ( !selector ) {
			return this;
		}

		// Method init() accepts an alternate rootjQuery
		// so migrate can support jQuery.sub (gh-2101)
		root = root || rootjQuery;

		// Handle HTML strings
		if ( typeof selector === "string" ) {
			if ( selector[ 0 ] === "<" &&
				selector[ selector.length - 1 ] === ">" &&
				selector.length >= 3 ) {

				// Assume that strings that start and end with <> are HTML and skip the regex check
				match = [ null, selector, null ];

			} else {
				match = rquickExpr.exec( selector );
			}

			// Match html or make sure no context is specified for #id
			if ( match && ( match[ 1 ] || !context ) ) {

				// HANDLE: $(html) -> $(array)
				if ( match[ 1 ] ) {
					context = context instanceof jQuery ? context[ 0 ] : context;

					// Option to run scripts is true for back-compat
					// Intentionally let the error be thrown if parseHTML is not present
					jQuery.merge( this, jQuery.parseHTML(
						match[ 1 ],
						context && context.nodeType ? context.ownerDocument || context : document,
						true
					) );

					// HANDLE: $(html, props)
					if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
						for ( match in context ) {

							// Properties of context are called as methods if possible
							if ( isFunction( this[ match ] ) ) {
								this[ match ]( context[ match ] );

							// ...and otherwise set as attributes
							} else {
								this.attr( match, context[ match ] );
							}
						}
					}

					return this;

				// HANDLE: $(#id)
				} else {
					elem = document.getElementById( match[ 2 ] );

					if ( elem ) {

						// Inject the element directly into the jQuery object
						this[ 0 ] = elem;
						this.length = 1;
					}
					return this;
				}

			// HANDLE: $(expr, $(...))
			} else if ( !context || context.jquery ) {
				return ( context || root ).find( selector );

			// HANDLE: $(expr, context)
			// (which is just equivalent to: $(context).find(expr)
			} else {
				return this.constructor( context ).find( selector );
			}

		// HANDLE: $(DOMElement)
		} else if ( selector.nodeType ) {
			this[ 0 ] = selector;
			this.length = 1;
			return this;

		// HANDLE: $(function)
		// Shortcut for document ready
		} else if ( isFunction( selector ) ) {
			return root.ready !== undefined ?
				root.ready( selector ) :

				// Execute immediately if ready is not present
				selector( jQuery );
		}

		return jQuery.makeArray( selector, this );
	};

// Give the init function the jQuery prototype for later instantiation
init.prototype = jQuery.fn;

// Initialize central reference
rootjQuery = jQuery( document );


var rparentsprev = /^(?:parents|prev(?:Until|All))/,

	// Methods guaranteed to produce a unique set when starting from a unique set
	guaranteedUnique = {
		children: true,
		contents: true,
		next: true,
		prev: true
	};

jQuery.fn.extend( {
	has: function( target ) {
		var targets = jQuery( target, this ),
			l = targets.length;

		return this.filter( function() {
			var i = 0;
			for ( ; i < l; i++ ) {
				if ( jQuery.contains( this, targets[ i ] ) ) {
					return true;
				}
			}
		} );
	},

	closest: function( selectors, context ) {
		var cur,
			i = 0,
			l = this.length,
			matched = [],
			targets = typeof selectors !== "string" && jQuery( selectors );

		// Positional selectors never match, since there's no _selection_ context
		if ( !rneedsContext.test( selectors ) ) {
			for ( ; i < l; i++ ) {
				for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {

					// Always skip document fragments
					if ( cur.nodeType < 11 && ( targets ?
						targets.index( cur ) > -1 :

						// Don't pass non-elements to Sizzle
						cur.nodeType === 1 &&
							jQuery.find.matchesSelector( cur, selectors ) ) ) {

						matched.push( cur );
						break;
					}
				}
			}
		}

		return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
	},

	// Determine the position of an element within the set
	index: function( elem ) {

		// No argument, return index in parent
		if ( !elem ) {
			return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
		}

		// Index in selector
		if ( typeof elem === "string" ) {
			return indexOf.call( jQuery( elem ), this[ 0 ] );
		}

		// Locate the position of the desired element
		return indexOf.call( this,

			// If it receives a jQuery object, the first element is used
			elem.jquery ? elem[ 0 ] : elem
		);
	},

	add: function( selector, context ) {
		return this.pushStack(
			jQuery.uniqueSort(
				jQuery.merge( this.get(), jQuery( selector, context ) )
			)
		);
	},

	addBack: function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter( selector )
		);
	}
} );

function sibling( cur, dir ) {
	while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
	return cur;
}

jQuery.each( {
	parent: function( elem ) {
		var parent = elem.parentNode;
		return parent && parent.nodeType !== 11 ? parent : null;
	},
	parents: function( elem ) {
		return dir( elem, "parentNode" );
	},
	parentsUntil: function( elem, i, until ) {
		return dir( elem, "parentNode", until );
	},
	next: function( elem ) {
		return sibling( elem, "nextSibling" );
	},
	prev: function( elem ) {
		return sibling( elem, "previousSibling" );
	},
	nextAll: function( elem ) {
		return dir( elem, "nextSibling" );
	},
	prevAll: function( elem ) {
		return dir( elem, "previousSibling" );
	},
	nextUntil: function( elem, i, until ) {
		return dir( elem, "nextSibling", until );
	},
	prevUntil: function( elem, i, until ) {
		return dir( elem, "previousSibling", until );
	},
	siblings: function( elem ) {
		return siblings( ( elem.parentNode || {} ).firstChild, elem );
	},
	children: function( elem ) {
		return siblings( elem.firstChild );
	},
	contents: function( elem ) {
        if ( nodeName( elem, "iframe" ) ) {
            return elem.contentDocument;
        }

        // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
        // Treat the template element as a regular one in browsers that
        // don't support it.
        if ( nodeName( elem, "template" ) ) {
            elem = elem.content || elem;
        }

        return jQuery.merge( [], elem.childNodes );
	}
}, function( name, fn ) {
	jQuery.fn[ name ] = function( until, selector ) {
		var matched = jQuery.map( this, fn, until );

		if ( name.slice( -5 ) !== "Until" ) {
			selector = until;
		}

		if ( selector && typeof selector === "string" ) {
			matched = jQuery.filter( selector, matched );
		}

		if ( this.length > 1 ) {

			// Remove duplicates
			if ( !guaranteedUnique[ name ] ) {
				jQuery.uniqueSort( matched );
			}

			// Reverse order for parents* and prev-derivatives
			if ( rparentsprev.test( name ) ) {
				matched.reverse();
			}
		}

		return this.pushStack( matched );
	};
} );
var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );



// Convert String-formatted options into Object-formatted ones
function createOptions( options ) {
	var object = {};
	jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
		object[ flag ] = true;
	} );
	return object;
}

/*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */
jQuery.Callbacks = function( options ) {

	// Convert options from String-formatted to Object-formatted if needed
	// (we check in cache first)
	options = typeof options === "string" ?
		createOptions( options ) :
		jQuery.extend( {}, options );

	var // Flag to know if list is currently firing
		firing,

		// Last fire value for non-forgettable lists
		memory,

		// Flag to know if list was already fired
		fired,

		// Flag to prevent firing
		locked,

		// Actual callback list
		list = [],

		// Queue of execution data for repeatable lists
		queue = [],

		// Index of currently firing callback (modified by add/remove as needed)
		firingIndex = -1,

		// Fire callbacks
		fire = function() {

			// Enforce single-firing
			locked = locked || options.once;

			// Execute callbacks for all pending executions,
			// respecting firingIndex overrides and runtime changes
			fired = firing = true;
			for ( ; queue.length; firingIndex = -1 ) {
				memory = queue.shift();
				while ( ++firingIndex < list.length ) {

					// Run callback and check for early termination
					if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
						options.stopOnFalse ) {

						// Jump to end and forget the data so .add doesn't re-fire
						firingIndex = list.length;
						memory = false;
					}
				}
			}

			// Forget the data if we're done with it
			if ( !options.memory ) {
				memory = false;
			}

			firing = false;

			// Clean up if we're done firing for good
			if ( locked ) {

				// Keep an empty list if we have data for future add calls
				if ( memory ) {
					list = [];

				// Otherwise, this object is spent
				} else {
					list = "";
				}
			}
		},

		// Actual Callbacks object
		self = {

			// Add a callback or a collection of callbacks to the list
			add: function() {
				if ( list ) {

					// If we have memory from a past run, we should fire after adding
					if ( memory && !firing ) {
						firingIndex = list.length - 1;
						queue.push( memory );
					}

					( function add( args ) {
						jQuery.each( args, function( _, arg ) {
							if ( isFunction( arg ) ) {
								if ( !options.unique || !self.has( arg ) ) {
									list.push( arg );
								}
							} else if ( arg && arg.length && toType( arg ) !== "string" ) {

								// Inspect recursively
								add( arg );
							}
						} );
					} )( arguments );

					if ( memory && !firing ) {
						fire();
					}
				}
				return this;
			},

			// Remove a callback from the list
			remove: function() {
				jQuery.each( arguments, function( _, arg ) {
					var index;
					while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
						list.splice( index, 1 );

						// Handle firing indexes
						if ( index <= firingIndex ) {
							firingIndex--;
						}
					}
				} );
				return this;
			},

			// Check if a given callback is in the list.
			// If no argument is given, return whether or not list has callbacks attached.
			has: function( fn ) {
				return fn ?
					jQuery.inArray( fn, list ) > -1 :
					list.length > 0;
			},

			// Remove all callbacks from the list
			empty: function() {
				if ( list ) {
					list = [];
				}
				return this;
			},

			// Disable .fire and .add
			// Abort any current/pending executions
			// Clear all callbacks and values
			disable: function() {
				locked = queue = [];
				list = memory = "";
				return this;
			},
			disabled: function() {
				return !list;
			},

			// Disable .fire
			// Also disable .add unless we have memory (since it would have no effect)
			// Abort any pending executions
			lock: function() {
				locked = queue = [];
				if ( !memory && !firing ) {
					list = memory = "";
				}
				return this;
			},
			locked: function() {
				return !!locked;
			},

			// Call all callbacks with the given context and arguments
			fireWith: function( context, args ) {
				if ( !locked ) {
					args = args || [];
					args = [ context, args.slice ? args.slice() : args ];
					queue.push( args );
					if ( !firing ) {
						fire();
					}
				}
				return this;
			},

			// Call all the callbacks with the given arguments
			fire: function() {
				self.fireWith( this, arguments );
				return this;
			},

			// To know if the callbacks have already been called at least once
			fired: function() {
				return !!fired;
			}
		};

	return self;
};


function Identity( v ) {
	return v;
}
function Thrower( ex ) {
	throw ex;
}

function adoptValue( value, resolve, reject, noValue ) {
	var method;

	try {

		// Check for promise aspect first to privilege synchronous behavior
		if ( value && isFunction( ( method = value.promise ) ) ) {
			method.call( value ).done( resolve ).fail( reject );

		// Other thenables
		} else if ( value && isFunction( ( method = value.then ) ) ) {
			method.call( value, resolve, reject );

		// Other non-thenables
		} else {

			// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
			// * false: [ value ].slice( 0 ) => resolve( value )
			// * true: [ value ].slice( 1 ) => resolve()
			resolve.apply( undefined, [ value ].slice( noValue ) );
		}

	// For Promises/A+, convert exceptions into rejections
	// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
	// Deferred#then to conditionally suppress rejection.
	} catch ( value ) {

		// Support: Android 4.0 only
		// Strict mode functions invoked without .call/.apply get global-object context
		reject.apply( undefined, [ value ] );
	}
}

jQuery.extend( {

	Deferred: function( func ) {
		var tuples = [

				// action, add listener, callbacks,
				// ... .then handlers, argument index, [final state]
				[ "notify", "progress", jQuery.Callbacks( "memory" ),
					jQuery.Callbacks( "memory" ), 2 ],
				[ "resolve", "done", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 0, "resolved" ],
				[ "reject", "fail", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 1, "rejected" ]
			],
			state = "pending",
			promise = {
				state: function() {
					return state;
				},
				always: function() {
					deferred.done( arguments ).fail( arguments );
					return this;
				},
				"catch": function( fn ) {
					return promise.then( null, fn );
				},

				// Keep pipe for back-compat
				pipe: function( /* fnDone, fnFail, fnProgress */ ) {
					var fns = arguments;

					return jQuery.Deferred( function( newDefer ) {
						jQuery.each( tuples, function( i, tuple ) {

							// Map tuples (progress, done, fail) to arguments (done, fail, progress)
							var fn = isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];

							// deferred.progress(function() { bind to newDefer or newDefer.notify })
							// deferred.done(function() { bind to newDefer or newDefer.resolve })
							// deferred.fail(function() { bind to newDefer or newDefer.reject })
							deferred[ tuple[ 1 ] ]( function() {
								var returned = fn && fn.apply( this, arguments );
								if ( returned && isFunction( returned.promise ) ) {
									returned.promise()
										.progress( newDefer.notify )
										.done( newDefer.resolve )
										.fail( newDefer.reject );
								} else {
									newDefer[ tuple[ 0 ] + "With" ](
										this,
										fn ? [ returned ] : arguments
									);
								}
							} );
						} );
						fns = null;
					} ).promise();
				},
				then: function( onFulfilled, onRejected, onProgress ) {
					var maxDepth = 0;
					function resolve( depth, deferred, handler, special ) {
						return function() {
							var that = this,
								args = arguments,
								mightThrow = function() {
									var returned, then;

									// Support: Promises/A+ section 2.3.3.3.3
									// https://promisesaplus.com/#point-59
									// Ignore double-resolution attempts
									if ( depth < maxDepth ) {
										return;
									}

									returned = handler.apply( that, args );

									// Support: Promises/A+ section 2.3.1
									// https://promisesaplus.com/#point-48
									if ( returned === deferred.promise() ) {
										throw new TypeError( "Thenable self-resolution" );
									}

									// Support: Promises/A+ sections 2.3.3.1, 3.5
									// https://promisesaplus.com/#point-54
									// https://promisesaplus.com/#point-75
									// Retrieve `then` only once
									then = returned &&

										// Support: Promises/A+ section 2.3.4
										// https://promisesaplus.com/#point-64
										// Only check objects and functions for thenability
										( typeof returned === "object" ||
											typeof returned === "function" ) &&
										returned.then;

									// Handle a returned thenable
									if ( isFunction( then ) ) {

										// Special processors (notify) just wait for resolution
										if ( special ) {
											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special )
											);

										// Normal processors (resolve) also hook into progress
										} else {

											// ...and disregard older resolution values
											maxDepth++;

											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special ),
												resolve( maxDepth, deferred, Identity,
													deferred.notifyWith )
											);
										}

									// Handle all other returned values
									} else {

										// Only substitute handlers pass on context
										// and multiple values (non-spec behavior)
										if ( handler !== Identity ) {
											that = undefined;
											args = [ returned ];
										}

										// Process the value(s)
										// Default process is resolve
										( special || deferred.resolveWith )( that, args );
									}
								},

								// Only normal processors (resolve) catch and reject exceptions
								process = special ?
									mightThrow :
									function() {
										try {
											mightThrow();
										} catch ( e ) {

											if ( jQuery.Deferred.exceptionHook ) {
												jQuery.Deferred.exceptionHook( e,
													process.stackTrace );
											}

											// Support: Promises/A+ section 2.3.3.3.4.1
											// https://promisesaplus.com/#point-61
											// Ignore post-resolution exceptions
											if ( depth + 1 >= maxDepth ) {

												// Only substitute handlers pass on context
												// and multiple values (non-spec behavior)
												if ( handler !== Thrower ) {
													that = undefined;
													args = [ e ];
												}

												deferred.rejectWith( that, args );
											}
										}
									};

							// Support: Promises/A+ section 2.3.3.3.1
							// https://promisesaplus.com/#point-57
							// Re-resolve promises immediately to dodge false rejection from
							// subsequent errors
							if ( depth ) {
								process();
							} else {

								// Call an optional hook to record the stack, in case of exception
								// since it's otherwise lost when execution goes async
								if ( jQuery.Deferred.getStackHook ) {
									process.stackTrace = jQuery.Deferred.getStackHook();
								}
								window.setTimeout( process );
							}
						};
					}

					return jQuery.Deferred( function( newDefer ) {

						// progress_handlers.add( ... )
						tuples[ 0 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onProgress ) ?
									onProgress :
									Identity,
								newDefer.notifyWith
							)
						);

						// fulfilled_handlers.add( ... )
						tuples[ 1 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onFulfilled ) ?
									onFulfilled :
									Identity
							)
						);

						// rejected_handlers.add( ... )
						tuples[ 2 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onRejected ) ?
									onRejected :
									Thrower
							)
						);
					} ).promise();
				},

				// Get a promise for this deferred
				// If obj is provided, the promise aspect is added to the object
				promise: function( obj ) {
					return obj != null ? jQuery.extend( obj, promise ) : promise;
				}
			},
			deferred = {};

		// Add list-specific methods
		jQuery.each( tuples, function( i, tuple ) {
			var list = tuple[ 2 ],
				stateString = tuple[ 5 ];

			// promise.progress = list.add
			// promise.done = list.add
			// promise.fail = list.add
			promise[ tuple[ 1 ] ] = list.add;

			// Handle state
			if ( stateString ) {
				list.add(
					function() {

						// state = "resolved" (i.e., fulfilled)
						// state = "rejected"
						state = stateString;
					},

					// rejected_callbacks.disable
					// fulfilled_callbacks.disable
					tuples[ 3 - i ][ 2 ].disable,

					// rejected_handlers.disable
					// fulfilled_handlers.disable
					tuples[ 3 - i ][ 3 ].disable,

					// progress_callbacks.lock
					tuples[ 0 ][ 2 ].lock,

					// progress_handlers.lock
					tuples[ 0 ][ 3 ].lock
				);
			}

			// progress_handlers.fire
			// fulfilled_handlers.fire
			// rejected_handlers.fire
			list.add( tuple[ 3 ].fire );

			// deferred.notify = function() { deferred.notifyWith(...) }
			// deferred.resolve = function() { deferred.resolveWith(...) }
			// deferred.reject = function() { deferred.rejectWith(...) }
			deferred[ tuple[ 0 ] ] = function() {
				deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
				return this;
			};

			// deferred.notifyWith = list.fireWith
			// deferred.resolveWith = list.fireWith
			// deferred.rejectWith = list.fireWith
			deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
		} );

		// Make the deferred a promise
		promise.promise( deferred );

		// Call given func if any
		if ( func ) {
			func.call( deferred, deferred );
		}

		// All done!
		return deferred;
	},

	// Deferred helper
	when: function( singleValue ) {
		var

			// count of uncompleted subordinates
			remaining = arguments.length,

			// count of unprocessed arguments
			i = remaining,

			// subordinate fulfillment data
			resolveContexts = Array( i ),
			resolveValues = slice.call( arguments ),

			// the master Deferred
			master = jQuery.Deferred(),

			// subordinate callback factory
			updateFunc = function( i ) {
				return function( value ) {
					resolveContexts[ i ] = this;
					resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
					if ( !( --remaining ) ) {
						master.resolveWith( resolveContexts, resolveValues );
					}
				};
			};

		// Single- and empty arguments are adopted like Promise.resolve
		if ( remaining <= 1 ) {
			adoptValue( singleValue, master.done( updateFunc( i ) ).resolve, master.reject,
				!remaining );

			// Use .then() to unwrap secondary thenables (cf. gh-3000)
			if ( master.state() === "pending" ||
				isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {

				return master.then();
			}
		}

		// Multiple arguments are aggregated like Promise.all array elements
		while ( i-- ) {
			adoptValue( resolveValues[ i ], updateFunc( i ), master.reject );
		}

		return master.promise();
	}
} );


// These usually indicate a programmer mistake during development,
// warn about them ASAP rather than swallowing them by default.
var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;

jQuery.Deferred.exceptionHook = function( error, stack ) {

	// Support: IE 8 - 9 only
	// Console exists when dev tools are open, which can happen at any time
	if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
		window.console.warn( "jQuery.Deferred exception: " + error.message, error.stack, stack );
	}
};




jQuery.readyException = function( error ) {
	window.setTimeout( function() {
		throw error;
	} );
};




// The deferred used on DOM ready
var readyList = jQuery.Deferred();

jQuery.fn.ready = function( fn ) {

	readyList
		.then( fn )

		// Wrap jQuery.readyException in a function so that the lookup
		// happens at the time of error handling instead of callback
		// registration.
		.catch( function( error ) {
			jQuery.readyException( error );
		} );

	return this;
};

jQuery.extend( {

	// Is the DOM ready to be used? Set to true once it occurs.
	isReady: false,

	// A counter to track how many items to wait for before
	// the ready event fires. See #6781
	readyWait: 1,

	// Handle when the DOM is ready
	ready: function( wait ) {

		// Abort if there are pending holds or we're already ready
		if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
			return;
		}

		// Remember that the DOM is ready
		jQuery.isReady = true;

		// If a normal DOM Ready event fired, decrement, and wait if need be
		if ( wait !== true && --jQuery.readyWait > 0 ) {
			return;
		}

		// If there are functions bound, to execute
		readyList.resolveWith( document, [ jQuery ] );
	}
} );

jQuery.ready.then = readyList.then;

// The ready event handler and self cleanup method
function completed() {
	document.removeEventListener( "DOMContentLoaded", completed );
	window.removeEventListener( "load", completed );
	jQuery.ready();
}

// Catch cases where $(document).ready() is called
// after the browser event has already occurred.
// Support: IE <=9 - 10 only
// Older IE sometimes signals "interactive" too soon
if ( document.readyState === "complete" ||
	( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {

	// Handle it asynchronously to allow scripts the opportunity to delay ready
	window.setTimeout( jQuery.ready );

} else {

	// Use the handy event callback
	document.addEventListener( "DOMContentLoaded", completed );

	// A fallback to window.onload, that will always work
	window.addEventListener( "load", completed );
}




// Multifunctional method to get and set values of a collection
// The value/s can optionally be executed if it's a function
var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
	var i = 0,
		len = elems.length,
		bulk = key == null;

	// Sets many values
	if ( toType( key ) === "object" ) {
		chainable = true;
		for ( i in key ) {
			access( elems, fn, i, key[ i ], true, emptyGet, raw );
		}

	// Sets one value
	} else if ( value !== undefined ) {
		chainable = true;

		if ( !isFunction( value ) ) {
			raw = true;
		}

		if ( bulk ) {

			// Bulk operations run against the entire set
			if ( raw ) {
				fn.call( elems, value );
				fn = null;

			// ...except when executing function values
			} else {
				bulk = fn;
				fn = function( elem, key, value ) {
					return bulk.call( jQuery( elem ), value );
				};
			}
		}

		if ( fn ) {
			for ( ; i < len; i++ ) {
				fn(
					elems[ i ], key, raw ?
					value :
					value.call( elems[ i ], i, fn( elems[ i ], key ) )
				);
			}
		}
	}

	if ( chainable ) {
		return elems;
	}

	// Gets
	if ( bulk ) {
		return fn.call( elems );
	}

	return len ? fn( elems[ 0 ], key ) : emptyGet;
};


// Matches dashed string for camelizing
var rmsPrefix = /^-ms-/,
	rdashAlpha = /-([a-z])/g;

// Used by camelCase as callback to replace()
function fcamelCase( all, letter ) {
	return letter.toUpperCase();
}

// Convert dashed to camelCase; used by the css and data modules
// Support: IE <=9 - 11, Edge 12 - 15
// Microsoft forgot to hump their vendor prefix (#9572)
function camelCase( string ) {
	return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
}
var acceptData = function( owner ) {

	// Accepts only:
	//  - Node
	//    - Node.ELEMENT_NODE
	//    - Node.DOCUMENT_NODE
	//  - Object
	//    - Any
	return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
};




function Data() {
	this.expando = jQuery.expando + Data.uid++;
}

Data.uid = 1;

Data.prototype = {

	cache: function( owner ) {

		// Check if the owner object already has a cache
		var value = owner[ this.expando ];

		// If not, create one
		if ( !value ) {
			value = {};

			// We can accept data for non-element nodes in modern browsers,
			// but we should not, see #8335.
			// Always return an empty object.
			if ( acceptData( owner ) ) {

				// If it is a node unlikely to be stringify-ed or looped over
				// use plain assignment
				if ( owner.nodeType ) {
					owner[ this.expando ] = value;

				// Otherwise secure it in a non-enumerable property
				// configurable must be true to allow the property to be
				// deleted when data is removed
				} else {
					Object.defineProperty( owner, this.expando, {
						value: value,
						configurable: true
					} );
				}
			}
		}

		return value;
	},
	set: function( owner, data, value ) {
		var prop,
			cache = this.cache( owner );

		// Handle: [ owner, key, value ] args
		// Always use camelCase key (gh-2257)
		if ( typeof data === "string" ) {
			cache[ camelCase( data ) ] = value;

		// Handle: [ owner, { properties } ] args
		} else {

			// Copy the properties one-by-one to the cache object
			for ( prop in data ) {
				cache[ camelCase( prop ) ] = data[ prop ];
			}
		}
		return cache;
	},
	get: function( owner, key ) {
		return key === undefined ?
			this.cache( owner ) :

			// Always use camelCase key (gh-2257)
			owner[ this.expando ] && owner[ this.expando ][ camelCase( key ) ];
	},
	access: function( owner, key, value ) {

		// In cases where either:
		//
		//   1. No key was specified
		//   2. A string key was specified, but no value provided
		//
		// Take the "read" path and allow the get method to determine
		// which value to return, respectively either:
		//
		//   1. The entire cache object
		//   2. The data stored at the key
		//
		if ( key === undefined ||
				( ( key && typeof key === "string" ) && value === undefined ) ) {

			return this.get( owner, key );
		}

		// When the key is not a string, or both a key and value
		// are specified, set or extend (existing objects) with either:
		//
		//   1. An object of properties
		//   2. A key and value
		//
		this.set( owner, key, value );

		// Since the "set" path can have two possible entry points
		// return the expected data based on which path was taken[*]
		return value !== undefined ? value : key;
	},
	remove: function( owner, key ) {
		var i,
			cache = owner[ this.expando ];

		if ( cache === undefined ) {
			return;
		}

		if ( key !== undefined ) {

			// Support array or space separated string of keys
			if ( Array.isArray( key ) ) {

				// If key is an array of keys...
				// We always set camelCase keys, so remove that.
				key = key.map( camelCase );
			} else {
				key = camelCase( key );

				// If a key with the spaces exists, use it.
				// Otherwise, create an array by matching non-whitespace
				key = key in cache ?
					[ key ] :
					( key.match( rnothtmlwhite ) || [] );
			}

			i = key.length;

			while ( i-- ) {
				delete cache[ key[ i ] ];
			}
		}

		// Remove the expando if there's no more data
		if ( key === undefined || jQuery.isEmptyObject( cache ) ) {

			// Support: Chrome <=35 - 45
			// Webkit & Blink performance suffers when deleting properties
			// from DOM nodes, so set to undefined instead
			// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
			if ( owner.nodeType ) {
				owner[ this.expando ] = undefined;
			} else {
				delete owner[ this.expando ];
			}
		}
	},
	hasData: function( owner ) {
		var cache = owner[ this.expando ];
		return cache !== undefined && !jQuery.isEmptyObject( cache );
	}
};
var dataPriv = new Data();

var dataUser = new Data();



//	Implementation Summary
//
//	1. Enforce API surface and semantic compatibility with 1.9.x branch
//	2. Improve the module's maintainability by reducing the storage
//		paths to a single mechanism.
//	3. Use the same single mechanism to support "private" and "user" data.
//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
//	5. Avoid exposing implementation details on user objects (eg. expando properties)
//	6. Provide a clear path for implementation upgrade to WeakMap in 2014

var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
	rmultiDash = /[A-Z]/g;

function getData( data ) {
	if ( data === "true" ) {
		return true;
	}

	if ( data === "false" ) {
		return false;
	}

	if ( data === "null" ) {
		return null;
	}

	// Only convert to a number if it doesn't change the string
	if ( data === +data + "" ) {
		return +data;
	}

	if ( rbrace.test( data ) ) {
		return JSON.parse( data );
	}

	return data;
}

function dataAttr( elem, key, data ) {
	var name;

	// If nothing was found internally, try to fetch any
	// data from the HTML5 data-* attribute
	if ( data === undefined && elem.nodeType === 1 ) {
		name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
		data = elem.getAttribute( name );

		if ( typeof data === "string" ) {
			try {
				data = getData( data );
			} catch ( e ) {}

			// Make sure we set the data so it isn't changed later
			dataUser.set( elem, key, data );
		} else {
			data = undefined;
		}
	}
	return data;
}

jQuery.extend( {
	hasData: function( elem ) {
		return dataUser.hasData( elem ) || dataPriv.hasData( elem );
	},

	data: function( elem, name, data ) {
		return dataUser.access( elem, name, data );
	},

	removeData: function( elem, name ) {
		dataUser.remove( elem, name );
	},

	// TODO: Now that all calls to _data and _removeData have been replaced
	// with direct calls to dataPriv methods, these can be deprecated.
	_data: function( elem, name, data ) {
		return dataPriv.access( elem, name, data );
	},

	_removeData: function( elem, name ) {
		dataPriv.remove( elem, name );
	}
} );

jQuery.fn.extend( {
	data: function( key, value ) {
		var i, name, data,
			elem = this[ 0 ],
			attrs = elem && elem.attributes;

		// Gets all values
		if ( key === undefined ) {
			if ( this.length ) {
				data = dataUser.get( elem );

				if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
					i = attrs.length;
					while ( i-- ) {

						// Support: IE 11 only
						// The attrs elements can be null (#14894)
						if ( attrs[ i ] ) {
							name = attrs[ i ].name;
							if ( name.indexOf( "data-" ) === 0 ) {
								name = camelCase( name.slice( 5 ) );
								dataAttr( elem, name, data[ name ] );
							}
						}
					}
					dataPriv.set( elem, "hasDataAttrs", true );
				}
			}

			return data;
		}

		// Sets multiple values
		if ( typeof key === "object" ) {
			return this.each( function() {
				dataUser.set( this, key );
			} );
		}

		return access( this, function( value ) {
			var data;

			// The calling jQuery object (element matches) is not empty
			// (and therefore has an element appears at this[ 0 ]) and the
			// `value` parameter was not undefined. An empty jQuery object
			// will result in `undefined` for elem = this[ 0 ] which will
			// throw an exception if an attempt to read a data cache is made.
			if ( elem && value === undefined ) {

				// Attempt to get data from the cache
				// The key will always be camelCased in Data
				data = dataUser.get( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// Attempt to "discover" the data in
				// HTML5 custom data-* attrs
				data = dataAttr( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// We tried really hard, but the data doesn't exist.
				return;
			}

			// Set the data...
			this.each( function() {

				// We always store the camelCased key
				dataUser.set( this, key, value );
			} );
		}, null, value, arguments.length > 1, null, true );
	},

	removeData: function( key ) {
		return this.each( function() {
			dataUser.remove( this, key );
		} );
	}
} );


jQuery.extend( {
	queue: function( elem, type, data ) {
		var queue;

		if ( elem ) {
			type = ( type || "fx" ) + "queue";
			queue = dataPriv.get( elem, type );

			// Speed up dequeue by getting out quickly if this is just a lookup
			if ( data ) {
				if ( !queue || Array.isArray( data ) ) {
					queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
				} else {
					queue.push( data );
				}
			}
			return queue || [];
		}
	},

	dequeue: function( elem, type ) {
		type = type || "fx";

		var queue = jQuery.queue( elem, type ),
			startLength = queue.length,
			fn = queue.shift(),
			hooks = jQuery._queueHooks( elem, type ),
			next = function() {
				jQuery.dequeue( elem, type );
			};

		// If the fx queue is dequeued, always remove the progress sentinel
		if ( fn === "inprogress" ) {
			fn = queue.shift();
			startLength--;
		}

		if ( fn ) {

			// Add a progress sentinel to prevent the fx queue from being
			// automatically dequeued
			if ( type === "fx" ) {
				queue.unshift( "inprogress" );
			}

			// Clear up the last queue stop function
			delete hooks.stop;
			fn.call( elem, next, hooks );
		}

		if ( !startLength && hooks ) {
			hooks.empty.fire();
		}
	},

	// Not public - generate a queueHooks object, or return the current one
	_queueHooks: function( elem, type ) {
		var key = type + "queueHooks";
		return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
			empty: jQuery.Callbacks( "once memory" ).add( function() {
				dataPriv.remove( elem, [ type + "queue", key ] );
			} )
		} );
	}
} );

jQuery.fn.extend( {
	queue: function( type, data ) {
		var setter = 2;

		if ( typeof type !== "string" ) {
			data = type;
			type = "fx";
			setter--;
		}

		if ( arguments.length < setter ) {
			return jQuery.queue( this[ 0 ], type );
		}

		return data === undefined ?
			this :
			this.each( function() {
				var queue = jQuery.queue( this, type, data );

				// Ensure a hooks for this queue
				jQuery._queueHooks( this, type );

				if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
					jQuery.dequeue( this, type );
				}
			} );
	},
	dequeue: function( type ) {
		return this.each( function() {
			jQuery.dequeue( this, type );
		} );
	},
	clearQueue: function( type ) {
		return this.queue( type || "fx", [] );
	},

	// Get a promise resolved when queues of a certain type
	// are emptied (fx is the type by default)
	promise: function( type, obj ) {
		var tmp,
			count = 1,
			defer = jQuery.Deferred(),
			elements = this,
			i = this.length,
			resolve = function() {
				if ( !( --count ) ) {
					defer.resolveWith( elements, [ elements ] );
				}
			};

		if ( typeof type !== "string" ) {
			obj = type;
			type = undefined;
		}
		type = type || "fx";

		while ( i-- ) {
			tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
			if ( tmp && tmp.empty ) {
				count++;
				tmp.empty.add( resolve );
			}
		}
		resolve();
		return defer.promise( obj );
	}
} );
var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;

var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );


var cssExpand = [ "Top", "Right", "Bottom", "Left" ];

var isHiddenWithinTree = function( elem, el ) {

		// isHiddenWithinTree might be called from jQuery#filter function;
		// in that case, element will be second argument
		elem = el || elem;

		// Inline style trumps all
		return elem.style.display === "none" ||
			elem.style.display === "" &&

			// Otherwise, check computed style
			// Support: Firefox <=43 - 45
			// Disconnected elements can have computed display: none, so first confirm that elem is
			// in the document.
			jQuery.contains( elem.ownerDocument, elem ) &&

			jQuery.css( elem, "display" ) === "none";
	};

var swap = function( elem, options, callback, args ) {
	var ret, name,
		old = {};

	// Remember the old values, and insert the new ones
	for ( name in options ) {
		old[ name ] = elem.style[ name ];
		elem.style[ name ] = options[ name ];
	}

	ret = callback.apply( elem, args || [] );

	// Revert the old values
	for ( name in options ) {
		elem.style[ name ] = old[ name ];
	}

	return ret;
};




function adjustCSS( elem, prop, valueParts, tween ) {
	var adjusted, scale,
		maxIterations = 20,
		currentValue = tween ?
			function() {
				return tween.cur();
			} :
			function() {
				return jQuery.css( elem, prop, "" );
			},
		initial = currentValue(),
		unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),

		// Starting value computation is required for potential unit mismatches
		initialInUnit = ( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
			rcssNum.exec( jQuery.css( elem, prop ) );

	if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {

		// Support: Firefox <=54
		// Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
		initial = initial / 2;

		// Trust units reported by jQuery.css
		unit = unit || initialInUnit[ 3 ];

		// Iteratively approximate from a nonzero starting point
		initialInUnit = +initial || 1;

		while ( maxIterations-- ) {

			// Evaluate and update our best guess (doubling guesses that zero out).
			// Finish if the scale equals or crosses 1 (making the old*new product non-positive).
			jQuery.style( elem, prop, initialInUnit + unit );
			if ( ( 1 - scale ) * ( 1 - ( scale = currentValue() / initial || 0.5 ) ) <= 0 ) {
				maxIterations = 0;
			}
			initialInUnit = initialInUnit / scale;

		}

		initialInUnit = initialInUnit * 2;
		jQuery.style( elem, prop, initialInUnit + unit );

		// Make sure we update the tween properties later on
		valueParts = valueParts || [];
	}

	if ( valueParts ) {
		initialInUnit = +initialInUnit || +initial || 0;

		// Apply relative offset (+=/-=) if specified
		adjusted = valueParts[ 1 ] ?
			initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
			+valueParts[ 2 ];
		if ( tween ) {
			tween.unit = unit;
			tween.start = initialInUnit;
			tween.end = adjusted;
		}
	}
	return adjusted;
}


var defaultDisplayMap = {};

function getDefaultDisplay( elem ) {
	var temp,
		doc = elem.ownerDocument,
		nodeName = elem.nodeName,
		display = defaultDisplayMap[ nodeName ];

	if ( display ) {
		return display;
	}

	temp = doc.body.appendChild( doc.createElement( nodeName ) );
	display = jQuery.css( temp, "display" );

	temp.parentNode.removeChild( temp );

	if ( display === "none" ) {
		display = "block";
	}
	defaultDisplayMap[ nodeName ] = display;

	return display;
}

function showHide( elements, show ) {
	var display, elem,
		values = [],
		index = 0,
		length = elements.length;

	// Determine new display value for elements that need to change
	for ( ; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}

		display = elem.style.display;
		if ( show ) {

			// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
			// check is required in this first loop unless we have a nonempty display value (either
			// inline or about-to-be-restored)
			if ( display === "none" ) {
				values[ index ] = dataPriv.get( elem, "display" ) || null;
				if ( !values[ index ] ) {
					elem.style.display = "";
				}
			}
			if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
				values[ index ] = getDefaultDisplay( elem );
			}
		} else {
			if ( display !== "none" ) {
				values[ index ] = "none";

				// Remember what we're overwriting
				dataPriv.set( elem, "display", display );
			}
		}
	}

	// Set the display of the elements in a second loop to avoid constant reflow
	for ( index = 0; index < length; index++ ) {
		if ( values[ index ] != null ) {
			elements[ index ].style.display = values[ index ];
		}
	}

	return elements;
}

jQuery.fn.extend( {
	show: function() {
		return showHide( this, true );
	},
	hide: function() {
		return showHide( this );
	},
	toggle: function( state ) {
		if ( typeof state === "boolean" ) {
			return state ? this.show() : this.hide();
		}

		return this.each( function() {
			if ( isHiddenWithinTree( this ) ) {
				jQuery( this ).show();
			} else {
				jQuery( this ).hide();
			}
		} );
	}
} );
var rcheckableType = ( /^(?:checkbox|radio)$/i );

var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]+)/i );

var rscriptType = ( /^$|^module$|\/(?:java|ecma)script/i );



// We have to close these tags to support XHTML (#13200)
var wrapMap = {

	// Support: IE <=9 only
	option: [ 1, "<select multiple='multiple'>", "</select>" ],

	// XHTML parsers do not magically insert elements in the
	// same way that tag soup parsers do. So we cannot shorten
	// this by omitting <tbody> or other required elements.
	thead: [ 1, "<table>", "</table>" ],
	col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
	tr: [ 2, "<table><tbody>", "</tbody></table>" ],
	td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],

	_default: [ 0, "", "" ]
};

// Support: IE <=9 only
wrapMap.optgroup = wrapMap.option;

wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
wrapMap.th = wrapMap.td;


function getAll( context, tag ) {

	// Support: IE <=9 - 11 only
	// Use typeof to avoid zero-argument method invocation on host objects (#15151)
	var ret;

	if ( typeof context.getElementsByTagName !== "undefined" ) {
		ret = context.getElementsByTagName( tag || "*" );

	} else if ( typeof context.querySelectorAll !== "undefined" ) {
		ret = context.querySelectorAll( tag || "*" );

	} else {
		ret = [];
	}

	if ( tag === undefined || tag && nodeName( context, tag ) ) {
		return jQuery.merge( [ context ], ret );
	}

	return ret;
}


// Mark scripts as having already been evaluated
function setGlobalEval( elems, refElements ) {
	var i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		dataPriv.set(
			elems[ i ],
			"globalEval",
			!refElements || dataPriv.get( refElements[ i ], "globalEval" )
		);
	}
}


var rhtml = /<|&#?\w+;/;

function buildFragment( elems, context, scripts, selection, ignored ) {
	var elem, tmp, tag, wrap, contains, j,
		fragment = context.createDocumentFragment(),
		nodes = [],
		i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		elem = elems[ i ];

		if ( elem || elem === 0 ) {

			// Add nodes directly
			if ( toType( elem ) === "object" ) {

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );

			// Convert non-html into a text node
			} else if ( !rhtml.test( elem ) ) {
				nodes.push( context.createTextNode( elem ) );

			// Convert html into DOM nodes
			} else {
				tmp = tmp || fragment.appendChild( context.createElement( "div" ) );

				// Deserialize a standard representation
				tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
				wrap = wrapMap[ tag ] || wrapMap._default;
				tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];

				// Descend through wrappers to the right content
				j = wrap[ 0 ];
				while ( j-- ) {
					tmp = tmp.lastChild;
				}

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, tmp.childNodes );

				// Remember the top-level container
				tmp = fragment.firstChild;

				// Ensure the created nodes are orphaned (#12392)
				tmp.textContent = "";
			}
		}
	}

	// Remove wrapper from fragment
	fragment.textContent = "";

	i = 0;
	while ( ( elem = nodes[ i++ ] ) ) {

		// Skip elements already in the context collection (trac-4087)
		if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
			if ( ignored ) {
				ignored.push( elem );
			}
			continue;
		}

		contains = jQuery.contains( elem.ownerDocument, elem );

		// Append to fragment
		tmp = getAll( fragment.appendChild( elem ), "script" );

		// Preserve script evaluation history
		if ( contains ) {
			setGlobalEval( tmp );
		}

		// Capture executables
		if ( scripts ) {
			j = 0;
			while ( ( elem = tmp[ j++ ] ) ) {
				if ( rscriptType.test( elem.type || "" ) ) {
					scripts.push( elem );
				}
			}
		}
	}

	return fragment;
}


( function() {
	var fragment = document.createDocumentFragment(),
		div = fragment.appendChild( document.createElement( "div" ) ),
		input = document.createElement( "input" );

	// Support: Android 4.0 - 4.3 only
	// Check state lost if the name is set (#11217)
	// Support: Windows Web Apps (WWA)
	// `name` and `type` must use .setAttribute for WWA (#14901)
	input.setAttribute( "type", "radio" );
	input.setAttribute( "checked", "checked" );
	input.setAttribute( "name", "t" );

	div.appendChild( input );

	// Support: Android <=4.1 only
	// Older WebKit doesn't clone checked state correctly in fragments
	support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;

	// Support: IE <=11 only
	// Make sure textarea (and checkbox) defaultValue is properly cloned
	div.innerHTML = "<textarea>x</textarea>";
	support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
} )();
var documentElement = document.documentElement;



var
	rkeyEvent = /^key/,
	rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
	rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

function returnTrue() {
	return true;
}

function returnFalse() {
	return false;
}

// Support: IE <=9 only
// See #13393 for more info
function safeActiveElement() {
	try {
		return document.activeElement;
	} catch ( err ) { }
}

function on( elem, types, selector, data, fn, one ) {
	var origFn, type;

	// Types can be a map of types/handlers
	if ( typeof types === "object" ) {

		// ( types-Object, selector, data )
		if ( typeof selector !== "string" ) {

			// ( types-Object, data )
			data = data || selector;
			selector = undefined;
		}
		for ( type in types ) {
			on( elem, type, selector, data, types[ type ], one );
		}
		return elem;
	}

	if ( data == null && fn == null ) {

		// ( types, fn )
		fn = selector;
		data = selector = undefined;
	} else if ( fn == null ) {
		if ( typeof selector === "string" ) {

			// ( types, selector, fn )
			fn = data;
			data = undefined;
		} else {

			// ( types, data, fn )
			fn = data;
			data = selector;
			selector = undefined;
		}
	}
	if ( fn === false ) {
		fn = returnFalse;
	} else if ( !fn ) {
		return elem;
	}

	if ( one === 1 ) {
		origFn = fn;
		fn = function( event ) {

			// Can use an empty set, since event contains the info
			jQuery().off( event );
			return origFn.apply( this, arguments );
		};

		// Use same guid so caller can remove using origFn
		fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
	}
	return elem.each( function() {
		jQuery.event.add( this, types, fn, data, selector );
	} );
}

/*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */
jQuery.event = {

	global: {},

	add: function( elem, types, handler, data, selector ) {

		var handleObjIn, eventHandle, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.get( elem );

		// Don't attach events to noData or text/comment nodes (but allow plain objects)
		if ( !elemData ) {
			return;
		}

		// Caller can pass in an object of custom data in lieu of the handler
		if ( handler.handler ) {
			handleObjIn = handler;
			handler = handleObjIn.handler;
			selector = handleObjIn.selector;
		}

		// Ensure that invalid selectors throw exceptions at attach time
		// Evaluate against documentElement in case elem is a non-element node (e.g., document)
		if ( selector ) {
			jQuery.find.matchesSelector( documentElement, selector );
		}

		// Make sure that the handler has a unique ID, used to find/remove it later
		if ( !handler.guid ) {
			handler.guid = jQuery.guid++;
		}

		// Init the element's event structure and main handler, if this is the first
		if ( !( events = elemData.events ) ) {
			events = elemData.events = {};
		}
		if ( !( eventHandle = elemData.handle ) ) {
			eventHandle = elemData.handle = function( e ) {

				// Discard the second event of a jQuery.event.trigger() and
				// when an event is called after a page has unloaded
				return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
					jQuery.event.dispatch.apply( elem, arguments ) : undefined;
			};
		}

		// Handle multiple events separated by a space
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// There *must* be a type, no attaching namespace-only handlers
			if ( !type ) {
				continue;
			}

			// If event changes its type, use the special event handlers for the changed type
			special = jQuery.event.special[ type ] || {};

			// If selector defined, determine special event api type, otherwise given type
			type = ( selector ? special.delegateType : special.bindType ) || type;

			// Update special based on newly reset type
			special = jQuery.event.special[ type ] || {};

			// handleObj is passed to all event handlers
			handleObj = jQuery.extend( {
				type: type,
				origType: origType,
				data: data,
				handler: handler,
				guid: handler.guid,
				selector: selector,
				needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
				namespace: namespaces.join( "." )
			}, handleObjIn );

			// Init the event handler queue if we're the first
			if ( !( handlers = events[ type ] ) ) {
				handlers = events[ type ] = [];
				handlers.delegateCount = 0;

				// Only use addEventListener if the special events handler returns false
				if ( !special.setup ||
					special.setup.call( elem, data, namespaces, eventHandle ) === false ) {

					if ( elem.addEventListener ) {
						elem.addEventListener( type, eventHandle );
					}
				}
			}

			if ( special.add ) {
				special.add.call( elem, handleObj );

				if ( !handleObj.handler.guid ) {
					handleObj.handler.guid = handler.guid;
				}
			}

			// Add to the element's handler list, delegates in front
			if ( selector ) {
				handlers.splice( handlers.delegateCount++, 0, handleObj );
			} else {
				handlers.push( handleObj );
			}

			// Keep track of which events have ever been used, for event optimization
			jQuery.event.global[ type ] = true;
		}

	},

	// Detach an event or set of events from an element
	remove: function( elem, types, handler, selector, mappedTypes ) {

		var j, origCount, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );

		if ( !elemData || !( events = elemData.events ) ) {
			return;
		}

		// Once for each type.namespace in types; type may be omitted
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// Unbind all events (on this namespace, if provided) for the element
			if ( !type ) {
				for ( type in events ) {
					jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
				}
				continue;
			}

			special = jQuery.event.special[ type ] || {};
			type = ( selector ? special.delegateType : special.bindType ) || type;
			handlers = events[ type ] || [];
			tmp = tmp[ 2 ] &&
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );

			// Remove matching events
			origCount = j = handlers.length;
			while ( j-- ) {
				handleObj = handlers[ j ];

				if ( ( mappedTypes || origType === handleObj.origType ) &&
					( !handler || handler.guid === handleObj.guid ) &&
					( !tmp || tmp.test( handleObj.namespace ) ) &&
					( !selector || selector === handleObj.selector ||
						selector === "**" && handleObj.selector ) ) {
					handlers.splice( j, 1 );

					if ( handleObj.selector ) {
						handlers.delegateCount--;
					}
					if ( special.remove ) {
						special.remove.call( elem, handleObj );
					}
				}
			}

			// Remove generic event handler if we removed something and no more handlers exist
			// (avoids potential for endless recursion during removal of special event handlers)
			if ( origCount && !handlers.length ) {
				if ( !special.teardown ||
					special.teardown.call( elem, namespaces, elemData.handle ) === false ) {

					jQuery.removeEvent( elem, type, elemData.handle );
				}

				delete events[ type ];
			}
		}

		// Remove data and the expando if it's no longer used
		if ( jQuery.isEmptyObject( events ) ) {
			dataPriv.remove( elem, "handle events" );
		}
	},

	dispatch: function( nativeEvent ) {

		// Make a writable jQuery.Event from the native event object
		var event = jQuery.event.fix( nativeEvent );

		var i, j, ret, matched, handleObj, handlerQueue,
			args = new Array( arguments.length ),
			handlers = ( dataPriv.get( this, "events" ) || {} )[ event.type ] || [],
			special = jQuery.event.special[ event.type ] || {};

		// Use the fix-ed jQuery.Event rather than the (read-only) native event
		args[ 0 ] = event;

		for ( i = 1; i < arguments.length; i++ ) {
			args[ i ] = arguments[ i ];
		}

		event.delegateTarget = this;

		// Call the preDispatch hook for the mapped type, and let it bail if desired
		if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
			return;
		}

		// Determine handlers
		handlerQueue = jQuery.event.handlers.call( this, event, handlers );

		// Run delegates first; they may want to stop propagation beneath us
		i = 0;
		while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
			event.currentTarget = matched.elem;

			j = 0;
			while ( ( handleObj = matched.handlers[ j++ ] ) &&
				!event.isImmediatePropagationStopped() ) {

				// Triggered event must either 1) have no namespace, or 2) have namespace(s)
				// a subset or equal to those in the bound event (both can have no namespace).
				if ( !event.rnamespace || event.rnamespace.test( handleObj.namespace ) ) {

					event.handleObj = handleObj;
					event.data = handleObj.data;

					ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
						handleObj.handler ).apply( matched.elem, args );

					if ( ret !== undefined ) {
						if ( ( event.result = ret ) === false ) {
							event.preventDefault();
							event.stopPropagation();
						}
					}
				}
			}
		}

		// Call the postDispatch hook for the mapped type
		if ( special.postDispatch ) {
			special.postDispatch.call( this, event );
		}

		return event.result;
	},

	handlers: function( event, handlers ) {
		var i, handleObj, sel, matchedHandlers, matchedSelectors,
			handlerQueue = [],
			delegateCount = handlers.delegateCount,
			cur = event.target;

		// Find delegate handlers
		if ( delegateCount &&

			// Support: IE <=9
			// Black-hole SVG <use> instance trees (trac-13180)
			cur.nodeType &&

			// Support: Firefox <=42
			// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
			// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
			// Support: IE 11 only
			// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
			!( event.type === "click" && event.button >= 1 ) ) {

			for ( ; cur !== this; cur = cur.parentNode || this ) {

				// Don't check non-elements (#13208)
				// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
				if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
					matchedHandlers = [];
					matchedSelectors = {};
					for ( i = 0; i < delegateCount; i++ ) {
						handleObj = handlers[ i ];

						// Don't conflict with Object.prototype properties (#13203)
						sel = handleObj.selector + " ";

						if ( matchedSelectors[ sel ] === undefined ) {
							matchedSelectors[ sel ] = handleObj.needsContext ?
								jQuery( sel, this ).index( cur ) > -1 :
								jQuery.find( sel, this, null, [ cur ] ).length;
						}
						if ( matchedSelectors[ sel ] ) {
							matchedHandlers.push( handleObj );
						}
					}
					if ( matchedHandlers.length ) {
						handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
					}
				}
			}
		}

		// Add the remaining (directly-bound) handlers
		cur = this;
		if ( delegateCount < handlers.length ) {
			handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
		}

		return handlerQueue;
	},

	addProp: function( name, hook ) {
		Object.defineProperty( jQuery.Event.prototype, name, {
			enumerable: true,
			configurable: true,

			get: isFunction( hook ) ?
				function() {
					if ( this.originalEvent ) {
							return hook( this.originalEvent );
					}
				} :
				function() {
					if ( this.originalEvent ) {
							return this.originalEvent[ name ];
					}
				},

			set: function( value ) {
				Object.defineProperty( this, name, {
					enumerable: true,
					configurable: true,
					writable: true,
					value: value
				} );
			}
		} );
	},

	fix: function( originalEvent ) {
		return originalEvent[ jQuery.expando ] ?
			originalEvent :
			new jQuery.Event( originalEvent );
	},

	special: {
		load: {

			// Prevent triggered image.load events from bubbling to window.load
			noBubble: true
		},
		focus: {

			// Fire native event if possible so blur/focus sequence is correct
			trigger: function() {
				if ( this !== safeActiveElement() && this.focus ) {
					this.focus();
					return false;
				}
			},
			delegateType: "focusin"
		},
		blur: {
			trigger: function() {
				if ( this === safeActiveElement() && this.blur ) {
					this.blur();
					return false;
				}
			},
			delegateType: "focusout"
		},
		click: {

			// For checkbox, fire native event so checked state will be right
			trigger: function() {
				if ( this.type === "checkbox" && this.click && nodeName( this, "input" ) ) {
					this.click();
					return false;
				}
			},

			// For cross-browser consistency, don't fire native .click() on links
			_default: function( event ) {
				return nodeName( event.target, "a" );
			}
		},

		beforeunload: {
			postDispatch: function( event ) {

				// Support: Firefox 20+
				// Firefox doesn't alert if the returnValue field is not set.
				if ( event.result !== undefined && event.originalEvent ) {
					event.originalEvent.returnValue = event.result;
				}
			}
		}
	}
};

jQuery.removeEvent = function( elem, type, handle ) {

	// This "if" is needed for plain objects
	if ( elem.removeEventListener ) {
		elem.removeEventListener( type, handle );
	}
};

jQuery.Event = function( src, props ) {

	// Allow instantiation without the 'new' keyword
	if ( !( this instanceof jQuery.Event ) ) {
		return new jQuery.Event( src, props );
	}

	// Event object
	if ( src && src.type ) {
		this.originalEvent = src;
		this.type = src.type;

		// Events bubbling up the document may have been marked as prevented
		// by a handler lower down the tree; reflect the correct value.
		this.isDefaultPrevented = src.defaultPrevented ||
				src.defaultPrevented === undefined &&

				// Support: Android <=2.3 only
				src.returnValue === false ?
			returnTrue :
			returnFalse;

		// Create target properties
		// Support: Safari <=6 - 7 only
		// Target should not be a text node (#504, #13143)
		this.target = ( src.target && src.target.nodeType === 3 ) ?
			src.target.parentNode :
			src.target;

		this.currentTarget = src.currentTarget;
		this.relatedTarget = src.relatedTarget;

	// Event type
	} else {
		this.type = src;
	}

	// Put explicitly provided properties onto the event object
	if ( props ) {
		jQuery.extend( this, props );
	}

	// Create a timestamp if incoming event doesn't have one
	this.timeStamp = src && src.timeStamp || Date.now();

	// Mark it as fixed
	this[ jQuery.expando ] = true;
};

// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
jQuery.Event.prototype = {
	constructor: jQuery.Event,
	isDefaultPrevented: returnFalse,
	isPropagationStopped: returnFalse,
	isImmediatePropagationStopped: returnFalse,
	isSimulated: false,

	preventDefault: function() {
		var e = this.originalEvent;

		this.isDefaultPrevented = returnTrue;

		if ( e && !this.isSimulated ) {
			e.preventDefault();
		}
	},
	stopPropagation: function() {
		var e = this.originalEvent;

		this.isPropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopPropagation();
		}
	},
	stopImmediatePropagation: function() {
		var e = this.originalEvent;

		this.isImmediatePropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopImmediatePropagation();
		}

		this.stopPropagation();
	}
};

// Includes all common event props including KeyEvent and MouseEvent specific props
jQuery.each( {
	altKey: true,
	bubbles: true,
	cancelable: true,
	changedTouches: true,
	ctrlKey: true,
	detail: true,
	eventPhase: true,
	metaKey: true,
	pageX: true,
	pageY: true,
	shiftKey: true,
	view: true,
	"char": true,
	charCode: true,
	key: true,
	keyCode: true,
	button: true,
	buttons: true,
	clientX: true,
	clientY: true,
	offsetX: true,
	offsetY: true,
	pointerId: true,
	pointerType: true,
	screenX: true,
	screenY: true,
	targetTouches: true,
	toElement: true,
	touches: true,

	which: function( event ) {
		var button = event.button;

		// Add which for key events
		if ( event.which == null && rkeyEvent.test( event.type ) ) {
			return event.charCode != null ? event.charCode : event.keyCode;
		}

		// Add which for click: 1 === left; 2 === middle; 3 === right
		if ( !event.which && button !== undefined && rmouseEvent.test( event.type ) ) {
			if ( button & 1 ) {
				return 1;
			}

			if ( button & 2 ) {
				return 3;
			}

			if ( button & 4 ) {
				return 2;
			}

			return 0;
		}

		return event.which;
	}
}, jQuery.event.addProp );

// Create mouseenter/leave events using mouseover/out and event-time checks
// so that event delegation works in jQuery.
// Do the same for pointerenter/pointerleave and pointerover/pointerout
//
// Support: Safari 7 only
// Safari sends mouseenter too often; see:
// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
// for the description of the bug (it existed in older Chrome versions as well).
jQuery.each( {
	mouseenter: "mouseover",
	mouseleave: "mouseout",
	pointerenter: "pointerover",
	pointerleave: "pointerout"
}, function( orig, fix ) {
	jQuery.event.special[ orig ] = {
		delegateType: fix,
		bindType: fix,

		handle: function( event ) {
			var ret,
				target = this,
				related = event.relatedTarget,
				handleObj = event.handleObj;

			// For mouseenter/leave call the handler if related is outside the target.
			// NB: No relatedTarget if the mouse left/entered the browser window
			if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
				event.type = handleObj.origType;
				ret = handleObj.handler.apply( this, arguments );
				event.type = fix;
			}
			return ret;
		}
	};
} );

jQuery.fn.extend( {

	on: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn );
	},
	one: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn, 1 );
	},
	off: function( types, selector, fn ) {
		var handleObj, type;
		if ( types && types.preventDefault && types.handleObj ) {

			// ( event )  dispatched jQuery.Event
			handleObj = types.handleObj;
			jQuery( types.delegateTarget ).off(
				handleObj.namespace ?
					handleObj.origType + "." + handleObj.namespace :
					handleObj.origType,
				handleObj.selector,
				handleObj.handler
			);
			return this;
		}
		if ( typeof types === "object" ) {

			// ( types-object [, selector] )
			for ( type in types ) {
				this.off( type, selector, types[ type ] );
			}
			return this;
		}
		if ( selector === false || typeof selector === "function" ) {

			// ( types [, fn] )
			fn = selector;
			selector = undefined;
		}
		if ( fn === false ) {
			fn = returnFalse;
		}
		return this.each( function() {
			jQuery.event.remove( this, types, fn, selector );
		} );
	}
} );


var

	/* eslint-disable max-len */

	// See https://github.com/eslint/eslint/issues/3229
	rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,

	/* eslint-enable */

	// Support: IE <=10 - 11, Edge 12 - 13 only
	// In IE/Edge using regex groups here causes severe slowdowns.
	// See https://connect.microsoft.com/IE/feedback/details/1736512/
	rnoInnerhtml = /<script|<style|<link/i,

	// checked="checked" or checked
	rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
	rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;

// Prefer a tbody over its parent table for containing new rows
function manipulationTarget( elem, content ) {
	if ( nodeName( elem, "table" ) &&
		nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {

		return jQuery( elem ).children( "tbody" )[ 0 ] || elem;
	}

	return elem;
}

// Replace/restore the type attribute of script elements for safe DOM manipulation
function disableScript( elem ) {
	elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
	return elem;
}
function restoreScript( elem ) {
	if ( ( elem.type || "" ).slice( 0, 5 ) === "true/" ) {
		elem.type = elem.type.slice( 5 );
	} else {
		elem.removeAttribute( "type" );
	}

	return elem;
}

function cloneCopyEvent( src, dest ) {
	var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;

	if ( dest.nodeType !== 1 ) {
		return;
	}

	// 1. Copy private data: events, handlers, etc.
	if ( dataPriv.hasData( src ) ) {
		pdataOld = dataPriv.access( src );
		pdataCur = dataPriv.set( dest, pdataOld );
		events = pdataOld.events;

		if ( events ) {
			delete pdataCur.handle;
			pdataCur.events = {};

			for ( type in events ) {
				for ( i = 0, l = events[ type ].length; i < l; i++ ) {
					jQuery.event.add( dest, type, events[ type ][ i ] );
				}
			}
		}
	}

	// 2. Copy user data
	if ( dataUser.hasData( src ) ) {
		udataOld = dataUser.access( src );
		udataCur = jQuery.extend( {}, udataOld );

		dataUser.set( dest, udataCur );
	}
}

// Fix IE bugs, see support tests
function fixInput( src, dest ) {
	var nodeName = dest.nodeName.toLowerCase();

	// Fails to persist the checked state of a cloned checkbox or radio button.
	if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
		dest.checked = src.checked;

	// Fails to return the selected option to the default selected state when cloning options
	} else if ( nodeName === "input" || nodeName === "textarea" ) {
		dest.defaultValue = src.defaultValue;
	}
}

function domManip( collection, args, callback, ignored ) {

	// Flatten any nested arrays
	args = concat.apply( [], args );

	var fragment, first, scripts, hasScripts, node, doc,
		i = 0,
		l = collection.length,
		iNoClone = l - 1,
		value = args[ 0 ],
		valueIsFunction = isFunction( value );

	// We can't cloneNode fragments that contain checked, in WebKit
	if ( valueIsFunction ||
			( l > 1 && typeof value === "string" &&
				!support.checkClone && rchecked.test( value ) ) ) {
		return collection.each( function( index ) {
			var self = collection.eq( index );
			if ( valueIsFunction ) {
				args[ 0 ] = value.call( this, index, self.html() );
			}
			domManip( self, args, callback, ignored );
		} );
	}

	if ( l ) {
		fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
		first = fragment.firstChild;

		if ( fragment.childNodes.length === 1 ) {
			fragment = first;
		}

		// Require either new content or an interest in ignored elements to invoke the callback
		if ( first || ignored ) {
			scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
			hasScripts = scripts.length;

			// Use the original fragment for the last item
			// instead of the first because it can end up
			// being emptied incorrectly in certain situations (#8070).
			for ( ; i < l; i++ ) {
				node = fragment;

				if ( i !== iNoClone ) {
					node = jQuery.clone( node, true, true );

					// Keep references to cloned scripts for later restoration
					if ( hasScripts ) {

						// Support: Android <=4.0 only, PhantomJS 1 only
						// push.apply(_, arraylike) throws on ancient WebKit
						jQuery.merge( scripts, getAll( node, "script" ) );
					}
				}

				callback.call( collection[ i ], node, i );
			}

			if ( hasScripts ) {
				doc = scripts[ scripts.length - 1 ].ownerDocument;

				// Reenable scripts
				jQuery.map( scripts, restoreScript );

				// Evaluate executable scripts on first document insertion
				for ( i = 0; i < hasScripts; i++ ) {
					node = scripts[ i ];
					if ( rscriptType.test( node.type || "" ) &&
						!dataPriv.access( node, "globalEval" ) &&
						jQuery.contains( doc, node ) ) {

						if ( node.src && ( node.type || "" ).toLowerCase()  !== "module" ) {

							// Optional AJAX dependency, but won't run scripts if not present
							if ( jQuery._evalUrl ) {
								jQuery._evalUrl( node.src );
							}
						} else {
							DOMEval( node.textContent.replace( rcleanScript, "" ), doc, node );
						}
					}
				}
			}
		}
	}

	return collection;
}

function remove( elem, selector, keepData ) {
	var node,
		nodes = selector ? jQuery.filter( selector, elem ) : elem,
		i = 0;

	for ( ; ( node = nodes[ i ] ) != null; i++ ) {
		if ( !keepData && node.nodeType === 1 ) {
			jQuery.cleanData( getAll( node ) );
		}

		if ( node.parentNode ) {
			if ( keepData && jQuery.contains( node.ownerDocument, node ) ) {
				setGlobalEval( getAll( node, "script" ) );
			}
			node.parentNode.removeChild( node );
		}
	}

	return elem;
}

jQuery.extend( {
	htmlPrefilter: function( html ) {
		return html.replace( rxhtmlTag, "<$1></$2>" );
	},

	clone: function( elem, dataAndEvents, deepDataAndEvents ) {
		var i, l, srcElements, destElements,
			clone = elem.cloneNode( true ),
			inPage = jQuery.contains( elem.ownerDocument, elem );

		// Fix IE cloning issues
		if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
				!jQuery.isXMLDoc( elem ) ) {

			// We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
			destElements = getAll( clone );
			srcElements = getAll( elem );

			for ( i = 0, l = srcElements.length; i < l; i++ ) {
				fixInput( srcElements[ i ], destElements[ i ] );
			}
		}

		// Copy the events from the original to the clone
		if ( dataAndEvents ) {
			if ( deepDataAndEvents ) {
				srcElements = srcElements || getAll( elem );
				destElements = destElements || getAll( clone );

				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					cloneCopyEvent( srcElements[ i ], destElements[ i ] );
				}
			} else {
				cloneCopyEvent( elem, clone );
			}
		}

		// Preserve script evaluation history
		destElements = getAll( clone, "script" );
		if ( destElements.length > 0 ) {
			setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
		}

		// Return the cloned set
		return clone;
	},

	cleanData: function( elems ) {
		var data, elem, type,
			special = jQuery.event.special,
			i = 0;

		for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
			if ( acceptData( elem ) ) {
				if ( ( data = elem[ dataPriv.expando ] ) ) {
					if ( data.events ) {
						for ( type in data.events ) {
							if ( special[ type ] ) {
								jQuery.event.remove( elem, type );

							// This is a shortcut to avoid jQuery.event.remove's overhead
							} else {
								jQuery.removeEvent( elem, type, data.handle );
							}
						}
					}

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataPriv.expando ] = undefined;
				}
				if ( elem[ dataUser.expando ] ) {

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataUser.expando ] = undefined;
				}
			}
		}
	}
} );

jQuery.fn.extend( {
	detach: function( selector ) {
		return remove( this, selector, true );
	},

	remove: function( selector ) {
		return remove( this, selector );
	},

	text: function( value ) {
		return access( this, function( value ) {
			return value === undefined ?
				jQuery.text( this ) :
				this.empty().each( function() {
					if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
						this.textContent = value;
					}
				} );
		}, null, value, arguments.length );
	},

	append: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.appendChild( elem );
			}
		} );
	},

	prepend: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.insertBefore( elem, target.firstChild );
			}
		} );
	},

	before: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this );
			}
		} );
	},

	after: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this.nextSibling );
			}
		} );
	},

	empty: function() {
		var elem,
			i = 0;

		for ( ; ( elem = this[ i ] ) != null; i++ ) {
			if ( elem.nodeType === 1 ) {

				// Prevent memory leaks
				jQuery.cleanData( getAll( elem, false ) );

				// Remove any remaining nodes
				elem.textContent = "";
			}
		}

		return this;
	},

	clone: function( dataAndEvents, deepDataAndEvents ) {
		dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
		deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

		return this.map( function() {
			return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
		} );
	},

	html: function( value ) {
		return access( this, function( value ) {
			var elem = this[ 0 ] || {},
				i = 0,
				l = this.length;

			if ( value === undefined && elem.nodeType === 1 ) {
				return elem.innerHTML;
			}

			// See if we can take a shortcut and just use innerHTML
			if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
				!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {

				value = jQuery.htmlPrefilter( value );

				try {
					for ( ; i < l; i++ ) {
						elem = this[ i ] || {};

						// Remove element nodes and prevent memory leaks
						if ( elem.nodeType === 1 ) {
							jQuery.cleanData( getAll( elem, false ) );
							elem.innerHTML = value;
						}
					}

					elem = 0;

				// If using innerHTML throws an exception, use the fallback method
				} catch ( e ) {}
			}

			if ( elem ) {
				this.empty().append( value );
			}
		}, null, value, arguments.length );
	},

	replaceWith: function() {
		var ignored = [];

		// Make the changes, replacing each non-ignored context element with the new content
		return domManip( this, arguments, function( elem ) {
			var parent = this.parentNode;

			if ( jQuery.inArray( this, ignored ) < 0 ) {
				jQuery.cleanData( getAll( this ) );
				if ( parent ) {
					parent.replaceChild( elem, this );
				}
			}

		// Force callback invocation
		}, ignored );
	}
} );

jQuery.each( {
	appendTo: "append",
	prependTo: "prepend",
	insertBefore: "before",
	insertAfter: "after",
	replaceAll: "replaceWith"
}, function( name, original ) {
	jQuery.fn[ name ] = function( selector ) {
		var elems,
			ret = [],
			insert = jQuery( selector ),
			last = insert.length - 1,
			i = 0;

		for ( ; i <= last; i++ ) {
			elems = i === last ? this : this.clone( true );
			jQuery( insert[ i ] )[ original ]( elems );

			// Support: Android <=4.0 only, PhantomJS 1 only
			// .get() because push.apply(_, arraylike) throws on ancient WebKit
			push.apply( ret, elems.get() );
		}

		return this.pushStack( ret );
	};
} );
var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );

var getStyles = function( elem ) {

		// Support: IE <=11 only, Firefox <=30 (#15098, #14150)
		// IE throws on elements created in popups
		// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
		var view = elem.ownerDocument.defaultView;

		if ( !view || !view.opener ) {
			view = window;
		}

		return view.getComputedStyle( elem );
	};

var rboxStyle = new RegExp( cssExpand.join( "|" ), "i" );



( function() {

	// Executing both pixelPosition & boxSizingReliable tests require only one layout
	// so they're executed at the same time to save the second computation.
	function computeStyleTests() {

		// This is a singleton, we need to execute it only once
		if ( !div ) {
			return;
		}

		container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
			"margin-top:1px;padding:0;border:0";
		div.style.cssText =
			"position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
			"margin:auto;border:1px;padding:1px;" +
			"width:60%;top:1%";
		documentElement.appendChild( container ).appendChild( div );

		var divStyle = window.getComputedStyle( div );
		pixelPositionVal = divStyle.top !== "1%";

		// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
		reliableMarginLeftVal = roundPixelMeasures( divStyle.marginLeft ) === 12;

		// Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
		// Some styles come back with percentage values, even though they shouldn't
		div.style.right = "60%";
		pixelBoxStylesVal = roundPixelMeasures( divStyle.right ) === 36;

		// Support: IE 9 - 11 only
		// Detect misreporting of content dimensions for box-sizing:border-box elements
		boxSizingReliableVal = roundPixelMeasures( divStyle.width ) === 36;

		// Support: IE 9 only
		// Detect overflow:scroll screwiness (gh-3699)
		div.style.position = "absolute";
		scrollboxSizeVal = div.offsetWidth === 36 || "absolute";

		documentElement.removeChild( container );

		// Nullify the div so it wouldn't be stored in the memory and
		// it will also be a sign that checks already performed
		div = null;
	}

	function roundPixelMeasures( measure ) {
		return Math.round( parseFloat( measure ) );
	}

	var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal,
		reliableMarginLeftVal,
		container = document.createElement( "div" ),
		div = document.createElement( "div" );

	// Finish early in limited (non-browser) environments
	if ( !div.style ) {
		return;
	}

	// Support: IE <=9 - 11 only
	// Style of cloned element affects source element cloned (#8908)
	div.style.backgroundClip = "content-box";
	div.cloneNode( true ).style.backgroundClip = "";
	support.clearCloneStyle = div.style.backgroundClip === "content-box";

	jQuery.extend( support, {
		boxSizingReliable: function() {
			computeStyleTests();
			return boxSizingReliableVal;
		},
		pixelBoxStyles: function() {
			computeStyleTests();
			return pixelBoxStylesVal;
		},
		pixelPosition: function() {
			computeStyleTests();
			return pixelPositionVal;
		},
		reliableMarginLeft: function() {
			computeStyleTests();
			return reliableMarginLeftVal;
		},
		scrollboxSize: function() {
			computeStyleTests();
			return scrollboxSizeVal;
		}
	} );
} )();


function curCSS( elem, name, computed ) {
	var width, minWidth, maxWidth, ret,

		// Support: Firefox 51+
		// Retrieving style before computed somehow
		// fixes an issue with getting wrong values
		// on detached elements
		style = elem.style;

	computed = computed || getStyles( elem );

	// getPropertyValue is needed for:
	//   .css('filter') (IE 9 only, #12537)
	//   .css('--customProperty) (#3144)
	if ( computed ) {
		ret = computed.getPropertyValue( name ) || computed[ name ];

		if ( ret === "" && !jQuery.contains( elem.ownerDocument, elem ) ) {
			ret = jQuery.style( elem, name );
		}

		// A tribute to the "awesome hack by Dean Edwards"
		// Android Browser returns percentage for some values,
		// but width seems to be reliably pixels.
		// This is against the CSSOM draft spec:
		// https://drafts.csswg.org/cssom/#resolved-values
		if ( !support.pixelBoxStyles() && rnumnonpx.test( ret ) && rboxStyle.test( name ) ) {

			// Remember the original values
			width = style.width;
			minWidth = style.minWidth;
			maxWidth = style.maxWidth;

			// Put in the new values to get a computed value out
			style.minWidth = style.maxWidth = style.width = ret;
			ret = computed.width;

			// Revert the changed values
			style.width = width;
			style.minWidth = minWidth;
			style.maxWidth = maxWidth;
		}
	}

	return ret !== undefined ?

		// Support: IE <=9 - 11 only
		// IE returns zIndex value as an integer.
		ret + "" :
		ret;
}


function addGetHookIf( conditionFn, hookFn ) {

	// Define the hook, we'll check on the first run if it's really needed.
	return {
		get: function() {
			if ( conditionFn() ) {

				// Hook not needed (or it's not possible to use it due
				// to missing dependency), remove it.
				delete this.get;
				return;
			}

			// Hook needed; redefine it so that the support test is not executed again.
			return ( this.get = hookFn ).apply( this, arguments );
		}
	};
}


var

	// Swappable if display is none or starts with table
	// except "table", "table-cell", or "table-caption"
	// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
	rdisplayswap = /^(none|table(?!-c[ea]).+)/,
	rcustomProp = /^--/,
	cssShow = { position: "absolute", visibility: "hidden", display: "block" },
	cssNormalTransform = {
		letterSpacing: "0",
		fontWeight: "400"
	},

	cssPrefixes = [ "Webkit", "Moz", "ms" ],
	emptyStyle = document.createElement( "div" ).style;

// Return a css property mapped to a potentially vendor prefixed property
function vendorPropName( name ) {

	// Shortcut for names that are not vendor prefixed
	if ( name in emptyStyle ) {
		return name;
	}

	// Check for vendor prefixed names
	var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
		i = cssPrefixes.length;

	while ( i-- ) {
		name = cssPrefixes[ i ] + capName;
		if ( name in emptyStyle ) {
			return name;
		}
	}
}

// Return a property mapped along what jQuery.cssProps suggests or to
// a vendor prefixed property.
function finalPropName( name ) {
	var ret = jQuery.cssProps[ name ];
	if ( !ret ) {
		ret = jQuery.cssProps[ name ] = vendorPropName( name ) || name;
	}
	return ret;
}

function setPositiveNumber( elem, value, subtract ) {

	// Any relative (+/-) values have already been
	// normalized at this point
	var matches = rcssNum.exec( value );
	return matches ?

		// Guard against undefined "subtract", e.g., when used as in cssHooks
		Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
		value;
}

function boxModelAdjustment( elem, dimension, box, isBorderBox, styles, computedVal ) {
	var i = dimension === "width" ? 1 : 0,
		extra = 0,
		delta = 0;

	// Adjustment may not be necessary
	if ( box === ( isBorderBox ? "border" : "content" ) ) {
		return 0;
	}

	for ( ; i < 4; i += 2 ) {

		// Both box models exclude margin
		if ( box === "margin" ) {
			delta += jQuery.css( elem, box + cssExpand[ i ], true, styles );
		}

		// If we get here with a content-box, we're seeking "padding" or "border" or "margin"
		if ( !isBorderBox ) {

			// Add padding
			delta += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );

			// For "border" or "margin", add border
			if ( box !== "padding" ) {
				delta += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );

			// But still keep track of it otherwise
			} else {
				extra += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}

		// If we get here with a border-box (content + padding + border), we're seeking "content" or
		// "padding" or "margin"
		} else {

			// For "content", subtract padding
			if ( box === "content" ) {
				delta -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
			}

			// For "content" or "padding", subtract border
			if ( box !== "margin" ) {
				delta -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		}
	}

	// Account for positive content-box scroll gutter when requested by providing computedVal
	if ( !isBorderBox && computedVal >= 0 ) {

		// offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
		// Assuming integer scroll gutter, subtract the rest and round down
		delta += Math.max( 0, Math.ceil(
			elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
			computedVal -
			delta -
			extra -
			0.5
		) );
	}

	return delta;
}

function getWidthOrHeight( elem, dimension, extra ) {

	// Start with computed style
	var styles = getStyles( elem ),
		val = curCSS( elem, dimension, styles ),
		isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
		valueIsBorderBox = isBorderBox;

	// Support: Firefox <=54
	// Return a confounding non-pixel value or feign ignorance, as appropriate.
	if ( rnumnonpx.test( val ) ) {
		if ( !extra ) {
			return val;
		}
		val = "auto";
	}

	// Check for style in case a browser which returns unreliable values
	// for getComputedStyle silently falls back to the reliable elem.style
	valueIsBorderBox = valueIsBorderBox &&
		( support.boxSizingReliable() || val === elem.style[ dimension ] );

	// Fall back to offsetWidth/offsetHeight when value is "auto"
	// This happens for inline elements with no explicit setting (gh-3571)
	// Support: Android <=4.1 - 4.3 only
	// Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
	if ( val === "auto" ||
		!parseFloat( val ) && jQuery.css( elem, "display", false, styles ) === "inline" ) {

		val = elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ];

		// offsetWidth/offsetHeight provide border-box values
		valueIsBorderBox = true;
	}

	// Normalize "" and auto
	val = parseFloat( val ) || 0;

	// Adjust for the element's box model
	return ( val +
		boxModelAdjustment(
			elem,
			dimension,
			extra || ( isBorderBox ? "border" : "content" ),
			valueIsBorderBox,
			styles,

			// Provide the current computed size to request scroll gutter calculation (gh-3589)
			val
		)
	) + "px";
}

jQuery.extend( {

	// Add in style property hooks for overriding the default
	// behavior of getting and setting a style property
	cssHooks: {
		opacity: {
			get: function( elem, computed ) {
				if ( computed ) {

					// We should always get a number back from opacity
					var ret = curCSS( elem, "opacity" );
					return ret === "" ? "1" : ret;
				}
			}
		}
	},

	// Don't automatically add "px" to these possibly-unitless properties
	cssNumber: {
		"animationIterationCount": true,
		"columnCount": true,
		"fillOpacity": true,
		"flexGrow": true,
		"flexShrink": true,
		"fontWeight": true,
		"lineHeight": true,
		"opacity": true,
		"order": true,
		"orphans": true,
		"widows": true,
		"zIndex": true,
		"zoom": true
	},

	// Add in properties whose names you wish to fix before
	// setting or getting the value
	cssProps: {},

	// Get and set the style property on a DOM Node
	style: function( elem, name, value, extra ) {

		// Don't set styles on text and comment nodes
		if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
			return;
		}

		// Make sure that we're working with the right name
		var ret, type, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name ),
			style = elem.style;

		// Make sure that we're working with the right name. We don't
		// want to query the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Gets hook for the prefixed version, then unprefixed version
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// Check if we're setting a value
		if ( value !== undefined ) {
			type = typeof value;

			// Convert "+=" or "-=" to relative numbers (#7345)
			if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
				value = adjustCSS( elem, name, ret );

				// Fixes bug #9237
				type = "number";
			}

			// Make sure that null and NaN values aren't set (#7116)
			if ( value == null || value !== value ) {
				return;
			}

			// If a number was passed in, add the unit (except for certain CSS properties)
			if ( type === "number" ) {
				value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
			}

			// background-* props affect original clone's values
			if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
				style[ name ] = "inherit";
			}

			// If a hook was provided, use that value, otherwise just set the specified value
			if ( !hooks || !( "set" in hooks ) ||
				( value = hooks.set( elem, value, extra ) ) !== undefined ) {

				if ( isCustomProp ) {
					style.setProperty( name, value );
				} else {
					style[ name ] = value;
				}
			}

		} else {

			// If a hook was provided get the non-computed value from there
			if ( hooks && "get" in hooks &&
				( ret = hooks.get( elem, false, extra ) ) !== undefined ) {

				return ret;
			}

			// Otherwise just get the value from the style object
			return style[ name ];
		}
	},

	css: function( elem, name, extra, styles ) {
		var val, num, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name );

		// Make sure that we're working with the right name. We don't
		// want to modify the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Try prefixed name followed by the unprefixed name
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// If a hook was provided get the computed value from there
		if ( hooks && "get" in hooks ) {
			val = hooks.get( elem, true, extra );
		}

		// Otherwise, if a way to get the computed value exists, use that
		if ( val === undefined ) {
			val = curCSS( elem, name, styles );
		}

		// Convert "normal" to computed value
		if ( val === "normal" && name in cssNormalTransform ) {
			val = cssNormalTransform[ name ];
		}

		// Make numeric if forced or a qualifier was provided and val looks numeric
		if ( extra === "" || extra ) {
			num = parseFloat( val );
			return extra === true || isFinite( num ) ? num || 0 : val;
		}

		return val;
	}
} );

jQuery.each( [ "height", "width" ], function( i, dimension ) {
	jQuery.cssHooks[ dimension ] = {
		get: function( elem, computed, extra ) {
			if ( computed ) {

				// Certain elements can have dimension info if we invisibly show them
				// but it must have a current display style that would benefit
				return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&

					// Support: Safari 8+
					// Table columns in Safari have non-zero offsetWidth & zero
					// getBoundingClientRect().width unless display is changed.
					// Support: IE <=11 only
					// Running getBoundingClientRect on a disconnected node
					// in IE throws an error.
					( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
						swap( elem, cssShow, function() {
							return getWidthOrHeight( elem, dimension, extra );
						} ) :
						getWidthOrHeight( elem, dimension, extra );
			}
		},

		set: function( elem, value, extra ) {
			var matches,
				styles = getStyles( elem ),
				isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
				subtract = extra && boxModelAdjustment(
					elem,
					dimension,
					extra,
					isBorderBox,
					styles
				);

			// Account for unreliable border-box dimensions by comparing offset* to computed and
			// faking a content-box to get border and padding (gh-3699)
			if ( isBorderBox && support.scrollboxSize() === styles.position ) {
				subtract -= Math.ceil(
					elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
					parseFloat( styles[ dimension ] ) -
					boxModelAdjustment( elem, dimension, "border", false, styles ) -
					0.5
				);
			}

			// Convert to pixels if value adjustment is needed
			if ( subtract && ( matches = rcssNum.exec( value ) ) &&
				( matches[ 3 ] || "px" ) !== "px" ) {

				elem.style[ dimension ] = value;
				value = jQuery.css( elem, dimension );
			}

			return setPositiveNumber( elem, value, subtract );
		}
	};
} );

jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
	function( elem, computed ) {
		if ( computed ) {
			return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
				elem.getBoundingClientRect().left -
					swap( elem, { marginLeft: 0 }, function() {
						return elem.getBoundingClientRect().left;
					} )
				) + "px";
		}
	}
);

// These hooks are used by animate to expand properties
jQuery.each( {
	margin: "",
	padding: "",
	border: "Width"
}, function( prefix, suffix ) {
	jQuery.cssHooks[ prefix + suffix ] = {
		expand: function( value ) {
			var i = 0,
				expanded = {},

				// Assumes a single number if not a string
				parts = typeof value === "string" ? value.split( " " ) : [ value ];

			for ( ; i < 4; i++ ) {
				expanded[ prefix + cssExpand[ i ] + suffix ] =
					parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
			}

			return expanded;
		}
	};

	if ( prefix !== "margin" ) {
		jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
	}
} );

jQuery.fn.extend( {
	css: function( name, value ) {
		return access( this, function( elem, name, value ) {
			var styles, len,
				map = {},
				i = 0;

			if ( Array.isArray( name ) ) {
				styles = getStyles( elem );
				len = name.length;

				for ( ; i < len; i++ ) {
					map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
				}

				return map;
			}

			return value !== undefined ?
				jQuery.style( elem, name, value ) :
				jQuery.css( elem, name );
		}, name, value, arguments.length > 1 );
	}
} );


function Tween( elem, options, prop, end, easing ) {
	return new Tween.prototype.init( elem, options, prop, end, easing );
}
jQuery.Tween = Tween;

Tween.prototype = {
	constructor: Tween,
	init: function( elem, options, prop, end, easing, unit ) {
		this.elem = elem;
		this.prop = prop;
		this.easing = easing || jQuery.easing._default;
		this.options = options;
		this.start = this.now = this.cur();
		this.end = end;
		this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
	},
	cur: function() {
		var hooks = Tween.propHooks[ this.prop ];

		return hooks && hooks.get ?
			hooks.get( this ) :
			Tween.propHooks._default.get( this );
	},
	run: function( percent ) {
		var eased,
			hooks = Tween.propHooks[ this.prop ];

		if ( this.options.duration ) {
			this.pos = eased = jQuery.easing[ this.easing ](
				percent, this.options.duration * percent, 0, 1, this.options.duration
			);
		} else {
			this.pos = eased = percent;
		}
		this.now = ( this.end - this.start ) * eased + this.start;

		if ( this.options.step ) {
			this.options.step.call( this.elem, this.now, this );
		}

		if ( hooks && hooks.set ) {
			hooks.set( this );
		} else {
			Tween.propHooks._default.set( this );
		}
		return this;
	}
};

Tween.prototype.init.prototype = Tween.prototype;

Tween.propHooks = {
	_default: {
		get: function( tween ) {
			var result;

			// Use a property on the element directly when it is not a DOM element,
			// or when there is no matching style property that exists.
			if ( tween.elem.nodeType !== 1 ||
				tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
				return tween.elem[ tween.prop ];
			}

			// Passing an empty string as a 3rd parameter to .css will automatically
			// attempt a parseFloat and fallback to a string if the parse fails.
			// Simple values such as "10px" are parsed to Float;
			// complex values such as "rotate(1rad)" are returned as-is.
			result = jQuery.css( tween.elem, tween.prop, "" );

			// Empty strings, null, undefined and "auto" are converted to 0.
			return !result || result === "auto" ? 0 : result;
		},
		set: function( tween ) {

			// Use step hook for back compat.
			// Use cssHook if its there.
			// Use .style if available and use plain properties where available.
			if ( jQuery.fx.step[ tween.prop ] ) {
				jQuery.fx.step[ tween.prop ]( tween );
			} else if ( tween.elem.nodeType === 1 &&
				( tween.elem.style[ jQuery.cssProps[ tween.prop ] ] != null ||
					jQuery.cssHooks[ tween.prop ] ) ) {
				jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
			} else {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	}
};

// Support: IE <=9 only
// Panic based approach to setting things on disconnected nodes
Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
	set: function( tween ) {
		if ( tween.elem.nodeType && tween.elem.parentNode ) {
			tween.elem[ tween.prop ] = tween.now;
		}
	}
};

jQuery.easing = {
	linear: function( p ) {
		return p;
	},
	swing: function( p ) {
		return 0.5 - Math.cos( p * Math.PI ) / 2;
	},
	_default: "swing"
};

jQuery.fx = Tween.prototype.init;

// Back compat <1.8 extension point
jQuery.fx.step = {};




var
	fxNow, inProgress,
	rfxtypes = /^(?:toggle|show|hide)$/,
	rrun = /queueHooks$/;

function schedule() {
	if ( inProgress ) {
		if ( document.hidden === false && window.requestAnimationFrame ) {
			window.requestAnimationFrame( schedule );
		} else {
			window.setTimeout( schedule, jQuery.fx.interval );
		}

		jQuery.fx.tick();
	}
}

// Animations created synchronously will run synchronously
function createFxNow() {
	window.setTimeout( function() {
		fxNow = undefined;
	} );
	return ( fxNow = Date.now() );
}

// Generate parameters to create a standard animation
function genFx( type, includeWidth ) {
	var which,
		i = 0,
		attrs = { height: type };

	// If we include width, step value is 1 to do all cssExpand values,
	// otherwise step value is 2 to skip over Left and Right
	includeWidth = includeWidth ? 1 : 0;
	for ( ; i < 4; i += 2 - includeWidth ) {
		which = cssExpand[ i ];
		attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
	}

	if ( includeWidth ) {
		attrs.opacity = attrs.width = type;
	}

	return attrs;
}

function createTween( value, prop, animation ) {
	var tween,
		collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
		index = 0,
		length = collection.length;
	for ( ; index < length; index++ ) {
		if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {

			// We're done with this property
			return tween;
		}
	}
}

function defaultPrefilter( elem, props, opts ) {
	var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
		isBox = "width" in props || "height" in props,
		anim = this,
		orig = {},
		style = elem.style,
		hidden = elem.nodeType && isHiddenWithinTree( elem ),
		dataShow = dataPriv.get( elem, "fxshow" );

	// Queue-skipping animations hijack the fx hooks
	if ( !opts.queue ) {
		hooks = jQuery._queueHooks( elem, "fx" );
		if ( hooks.unqueued == null ) {
			hooks.unqueued = 0;
			oldfire = hooks.empty.fire;
			hooks.empty.fire = function() {
				if ( !hooks.unqueued ) {
					oldfire();
				}
			};
		}
		hooks.unqueued++;

		anim.always( function() {

			// Ensure the complete handler is called before this completes
			anim.always( function() {
				hooks.unqueued--;
				if ( !jQuery.queue( elem, "fx" ).length ) {
					hooks.empty.fire();
				}
			} );
		} );
	}

	// Detect show/hide animations
	for ( prop in props ) {
		value = props[ prop ];
		if ( rfxtypes.test( value ) ) {
			delete props[ prop ];
			toggle = toggle || value === "toggle";
			if ( value === ( hidden ? "hide" : "show" ) ) {

				// Pretend to be hidden if this is a "show" and
				// there is still data from a stopped show/hide
				if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
					hidden = true;

				// Ignore all other no-op show/hide data
				} else {
					continue;
				}
			}
			orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
		}
	}

	// Bail out if this is a no-op like .hide().hide()
	propTween = !jQuery.isEmptyObject( props );
	if ( !propTween && jQuery.isEmptyObject( orig ) ) {
		return;
	}

	// Restrict "overflow" and "display" styles during box animations
	if ( isBox && elem.nodeType === 1 ) {

		// Support: IE <=9 - 11, Edge 12 - 15
		// Record all 3 overflow attributes because IE does not infer the shorthand
		// from identically-valued overflowX and overflowY and Edge just mirrors
		// the overflowX value there.
		opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];

		// Identify a display type, preferring old show/hide data over the CSS cascade
		restoreDisplay = dataShow && dataShow.display;
		if ( restoreDisplay == null ) {
			restoreDisplay = dataPriv.get( elem, "display" );
		}
		display = jQuery.css( elem, "display" );
		if ( display === "none" ) {
			if ( restoreDisplay ) {
				display = restoreDisplay;
			} else {

				// Get nonempty value(s) by temporarily forcing visibility
				showHide( [ elem ], true );
				restoreDisplay = elem.style.display || restoreDisplay;
				display = jQuery.css( elem, "display" );
				showHide( [ elem ] );
			}
		}

		// Animate inline elements as inline-block
		if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
			if ( jQuery.css( elem, "float" ) === "none" ) {

				// Restore the original display value at the end of pure show/hide animations
				if ( !propTween ) {
					anim.done( function() {
						style.display = restoreDisplay;
					} );
					if ( restoreDisplay == null ) {
						display = style.display;
						restoreDisplay = display === "none" ? "" : display;
					}
				}
				style.display = "inline-block";
			}
		}
	}

	if ( opts.overflow ) {
		style.overflow = "hidden";
		anim.always( function() {
			style.overflow = opts.overflow[ 0 ];
			style.overflowX = opts.overflow[ 1 ];
			style.overflowY = opts.overflow[ 2 ];
		} );
	}

	// Implement show/hide animations
	propTween = false;
	for ( prop in orig ) {

		// General show/hide setup for this element animation
		if ( !propTween ) {
			if ( dataShow ) {
				if ( "hidden" in dataShow ) {
					hidden = dataShow.hidden;
				}
			} else {
				dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
			}

			// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
			if ( toggle ) {
				dataShow.hidden = !hidden;
			}

			// Show elements before animating them
			if ( hidden ) {
				showHide( [ elem ], true );
			}

			/* eslint-disable no-loop-func */

			anim.done( function() {

			/* eslint-enable no-loop-func */

				// The final step of a "hide" animation is actually hiding the element
				if ( !hidden ) {
					showHide( [ elem ] );
				}
				dataPriv.remove( elem, "fxshow" );
				for ( prop in orig ) {
					jQuery.style( elem, prop, orig[ prop ] );
				}
			} );
		}

		// Per-property setup
		propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
		if ( !( prop in dataShow ) ) {
			dataShow[ prop ] = propTween.start;
			if ( hidden ) {
				propTween.end = propTween.start;
				propTween.start = 0;
			}
		}
	}
}

function propFilter( props, specialEasing ) {
	var index, name, easing, value, hooks;

	// camelCase, specialEasing and expand cssHook pass
	for ( index in props ) {
		name = camelCase( index );
		easing = specialEasing[ name ];
		value = props[ index ];
		if ( Array.isArray( value ) ) {
			easing = value[ 1 ];
			value = props[ index ] = value[ 0 ];
		}

		if ( index !== name ) {
			props[ name ] = value;
			delete props[ index ];
		}

		hooks = jQuery.cssHooks[ name ];
		if ( hooks && "expand" in hooks ) {
			value = hooks.expand( value );
			delete props[ name ];

			// Not quite $.extend, this won't overwrite existing keys.
			// Reusing 'index' because we have the correct "name"
			for ( index in value ) {
				if ( !( index in props ) ) {
					props[ index ] = value[ index ];
					specialEasing[ index ] = easing;
				}
			}
		} else {
			specialEasing[ name ] = easing;
		}
	}
}

function Animation( elem, properties, options ) {
	var result,
		stopped,
		index = 0,
		length = Animation.prefilters.length,
		deferred = jQuery.Deferred().always( function() {

			// Don't match elem in the :animated selector
			delete tick.elem;
		} ),
		tick = function() {
			if ( stopped ) {
				return false;
			}
			var currentTime = fxNow || createFxNow(),
				remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),

				// Support: Android 2.3 only
				// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
				temp = remaining / animation.duration || 0,
				percent = 1 - temp,
				index = 0,
				length = animation.tweens.length;

			for ( ; index < length; index++ ) {
				animation.tweens[ index ].run( percent );
			}

			deferred.notifyWith( elem, [ animation, percent, remaining ] );

			// If there's more to do, yield
			if ( percent < 1 && length ) {
				return remaining;
			}

			// If this was an empty animation, synthesize a final progress notification
			if ( !length ) {
				deferred.notifyWith( elem, [ animation, 1, 0 ] );
			}

			// Resolve the animation and report its conclusion
			deferred.resolveWith( elem, [ animation ] );
			return false;
		},
		animation = deferred.promise( {
			elem: elem,
			props: jQuery.extend( {}, properties ),
			opts: jQuery.extend( true, {
				specialEasing: {},
				easing: jQuery.easing._default
			}, options ),
			originalProperties: properties,
			originalOptions: options,
			startTime: fxNow || createFxNow(),
			duration: options.duration,
			tweens: [],
			createTween: function( prop, end ) {
				var tween = jQuery.Tween( elem, animation.opts, prop, end,
						animation.opts.specialEasing[ prop ] || animation.opts.easing );
				animation.tweens.push( tween );
				return tween;
			},
			stop: function( gotoEnd ) {
				var index = 0,

					// If we are going to the end, we want to run all the tweens
					// otherwise we skip this part
					length = gotoEnd ? animation.tweens.length : 0;
				if ( stopped ) {
					return this;
				}
				stopped = true;
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( 1 );
				}

				// Resolve when we played the last frame; otherwise, reject
				if ( gotoEnd ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
					deferred.resolveWith( elem, [ animation, gotoEnd ] );
				} else {
					deferred.rejectWith( elem, [ animation, gotoEnd ] );
				}
				return this;
			}
		} ),
		props = animation.props;

	propFilter( props, animation.opts.specialEasing );

	for ( ; index < length; index++ ) {
		result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
		if ( result ) {
			if ( isFunction( result.stop ) ) {
				jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
					result.stop.bind( result );
			}
			return result;
		}
	}

	jQuery.map( props, createTween, animation );

	if ( isFunction( animation.opts.start ) ) {
		animation.opts.start.call( elem, animation );
	}

	// Attach callbacks from options
	animation
		.progress( animation.opts.progress )
		.done( animation.opts.done, animation.opts.complete )
		.fail( animation.opts.fail )
		.always( animation.opts.always );

	jQuery.fx.timer(
		jQuery.extend( tick, {
			elem: elem,
			anim: animation,
			queue: animation.opts.queue
		} )
	);

	return animation;
}

jQuery.Animation = jQuery.extend( Animation, {

	tweeners: {
		"*": [ function( prop, value ) {
			var tween = this.createTween( prop, value );
			adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
			return tween;
		} ]
	},

	tweener: function( props, callback ) {
		if ( isFunction( props ) ) {
			callback = props;
			props = [ "*" ];
		} else {
			props = props.match( rnothtmlwhite );
		}

		var prop,
			index = 0,
			length = props.length;

		for ( ; index < length; index++ ) {
			prop = props[ index ];
			Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
			Animation.tweeners[ prop ].unshift( callback );
		}
	},

	prefilters: [ defaultPrefilter ],

	prefilter: function( callback, prepend ) {
		if ( prepend ) {
			Animation.prefilters.unshift( callback );
		} else {
			Animation.prefilters.push( callback );
		}
	}
} );

jQuery.speed = function( speed, easing, fn ) {
	var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
		complete: fn || !fn && easing ||
			isFunction( speed ) && speed,
		duration: speed,
		easing: fn && easing || easing && !isFunction( easing ) && easing
	};

	// Go to the end state if fx are off
	if ( jQuery.fx.off ) {
		opt.duration = 0;

	} else {
		if ( typeof opt.duration !== "number" ) {
			if ( opt.duration in jQuery.fx.speeds ) {
				opt.duration = jQuery.fx.speeds[ opt.duration ];

			} else {
				opt.duration = jQuery.fx.speeds._default;
			}
		}
	}

	// Normalize opt.queue - true/undefined/null -> "fx"
	if ( opt.queue == null || opt.queue === true ) {
		opt.queue = "fx";
	}

	// Queueing
	opt.old = opt.complete;

	opt.complete = function() {
		if ( isFunction( opt.old ) ) {
			opt.old.call( this );
		}

		if ( opt.queue ) {
			jQuery.dequeue( this, opt.queue );
		}
	};

	return opt;
};

jQuery.fn.extend( {
	fadeTo: function( speed, to, easing, callback ) {

		// Show any hidden elements after setting opacity to 0
		return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()

			// Animate to the value specified
			.end().animate( { opacity: to }, speed, easing, callback );
	},
	animate: function( prop, speed, easing, callback ) {
		var empty = jQuery.isEmptyObject( prop ),
			optall = jQuery.speed( speed, easing, callback ),
			doAnimation = function() {

				// Operate on a copy of prop so per-property easing won't be lost
				var anim = Animation( this, jQuery.extend( {}, prop ), optall );

				// Empty animations, or finishing resolves immediately
				if ( empty || dataPriv.get( this, "finish" ) ) {
					anim.stop( true );
				}
			};
			doAnimation.finish = doAnimation;

		return empty || optall.queue === false ?
			this.each( doAnimation ) :
			this.queue( optall.queue, doAnimation );
	},
	stop: function( type, clearQueue, gotoEnd ) {
		var stopQueue = function( hooks ) {
			var stop = hooks.stop;
			delete hooks.stop;
			stop( gotoEnd );
		};

		if ( typeof type !== "string" ) {
			gotoEnd = clearQueue;
			clearQueue = type;
			type = undefined;
		}
		if ( clearQueue && type !== false ) {
			this.queue( type || "fx", [] );
		}

		return this.each( function() {
			var dequeue = true,
				index = type != null && type + "queueHooks",
				timers = jQuery.timers,
				data = dataPriv.get( this );

			if ( index ) {
				if ( data[ index ] && data[ index ].stop ) {
					stopQueue( data[ index ] );
				}
			} else {
				for ( index in data ) {
					if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
						stopQueue( data[ index ] );
					}
				}
			}

			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this &&
					( type == null || timers[ index ].queue === type ) ) {

					timers[ index ].anim.stop( gotoEnd );
					dequeue = false;
					timers.splice( index, 1 );
				}
			}

			// Start the next in the queue if the last step wasn't forced.
			// Timers currently will call their complete callbacks, which
			// will dequeue but only if they were gotoEnd.
			if ( dequeue || !gotoEnd ) {
				jQuery.dequeue( this, type );
			}
		} );
	},
	finish: function( type ) {
		if ( type !== false ) {
			type = type || "fx";
		}
		return this.each( function() {
			var index,
				data = dataPriv.get( this ),
				queue = data[ type + "queue" ],
				hooks = data[ type + "queueHooks" ],
				timers = jQuery.timers,
				length = queue ? queue.length : 0;

			// Enable finishing flag on private data
			data.finish = true;

			// Empty the queue first
			jQuery.queue( this, type, [] );

			if ( hooks && hooks.stop ) {
				hooks.stop.call( this, true );
			}

			// Look for any active animations, and finish them
			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
					timers[ index ].anim.stop( true );
					timers.splice( index, 1 );
				}
			}

			// Look for any animations in the old queue and finish them
			for ( index = 0; index < length; index++ ) {
				if ( queue[ index ] && queue[ index ].finish ) {
					queue[ index ].finish.call( this );
				}
			}

			// Turn off finishing flag
			delete data.finish;
		} );
	}
} );

jQuery.each( [ "toggle", "show", "hide" ], function( i, name ) {
	var cssFn = jQuery.fn[ name ];
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return speed == null || typeof speed === "boolean" ?
			cssFn.apply( this, arguments ) :
			this.animate( genFx( name, true ), speed, easing, callback );
	};
} );

// Generate shortcuts for custom animations
jQuery.each( {
	slideDown: genFx( "show" ),
	slideUp: genFx( "hide" ),
	slideToggle: genFx( "toggle" ),
	fadeIn: { opacity: "show" },
	fadeOut: { opacity: "hide" },
	fadeToggle: { opacity: "toggle" }
}, function( name, props ) {
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return this.animate( props, speed, easing, callback );
	};
} );

jQuery.timers = [];
jQuery.fx.tick = function() {
	var timer,
		i = 0,
		timers = jQuery.timers;

	fxNow = Date.now();

	for ( ; i < timers.length; i++ ) {
		timer = timers[ i ];

		// Run the timer and safely remove it when done (allowing for external removal)
		if ( !timer() && timers[ i ] === timer ) {
			timers.splice( i--, 1 );
		}
	}

	if ( !timers.length ) {
		jQuery.fx.stop();
	}
	fxNow = undefined;
};

jQuery.fx.timer = function( timer ) {
	jQuery.timers.push( timer );
	jQuery.fx.start();
};

jQuery.fx.interval = 13;
jQuery.fx.start = function() {
	if ( inProgress ) {
		return;
	}

	inProgress = true;
	schedule();
};

jQuery.fx.stop = function() {
	inProgress = null;
};

jQuery.fx.speeds = {
	slow: 600,
	fast: 200,

	// Default speed
	_default: 400
};


// Based off of the plugin by Clint Helfers, with permission.
// https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
jQuery.fn.delay = function( time, type ) {
	time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
	type = type || "fx";

	return this.queue( type, function( next, hooks ) {
		var timeout = window.setTimeout( next, time );
		hooks.stop = function() {
			window.clearTimeout( timeout );
		};
	} );
};


( function() {
	var input = document.createElement( "input" ),
		select = document.createElement( "select" ),
		opt = select.appendChild( document.createElement( "option" ) );

	input.type = "checkbox";

	// Support: Android <=4.3 only
	// Default value for a checkbox should be "on"
	support.checkOn = input.value !== "";

	// Support: IE <=11 only
	// Must access selectedIndex to make default options select
	support.optSelected = opt.selected;

	// Support: IE <=11 only
	// An input loses its value after becoming a radio
	input = document.createElement( "input" );
	input.value = "t";
	input.type = "radio";
	support.radioValue = input.value === "t";
} )();


var boolHook,
	attrHandle = jQuery.expr.attrHandle;

jQuery.fn.extend( {
	attr: function( name, value ) {
		return access( this, jQuery.attr, name, value, arguments.length > 1 );
	},

	removeAttr: function( name ) {
		return this.each( function() {
			jQuery.removeAttr( this, name );
		} );
	}
} );

jQuery.extend( {
	attr: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set attributes on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		// Fallback to prop when attributes are not supported
		if ( typeof elem.getAttribute === "undefined" ) {
			return jQuery.prop( elem, name, value );
		}

		// Attribute hooks are determined by the lowercase version
		// Grab necessary hook if one is defined
		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
			hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
				( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
		}

		if ( value !== undefined ) {
			if ( value === null ) {
				jQuery.removeAttr( elem, name );
				return;
			}

			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			elem.setAttribute( name, value + "" );
			return value;
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		ret = jQuery.find.attr( elem, name );

		// Non-existent attributes return null, we normalize to undefined
		return ret == null ? undefined : ret;
	},

	attrHooks: {
		type: {
			set: function( elem, value ) {
				if ( !support.radioValue && value === "radio" &&
					nodeName( elem, "input" ) ) {
					var val = elem.value;
					elem.setAttribute( "type", value );
					if ( val ) {
						elem.value = val;
					}
					return value;
				}
			}
		}
	},

	removeAttr: function( elem, value ) {
		var name,
			i = 0,

			// Attribute names can contain non-HTML whitespace characters
			// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
			attrNames = value && value.match( rnothtmlwhite );

		if ( attrNames && elem.nodeType === 1 ) {
			while ( ( name = attrNames[ i++ ] ) ) {
				elem.removeAttribute( name );
			}
		}
	}
} );

// Hooks for boolean attributes
boolHook = {
	set: function( elem, value, name ) {
		if ( value === false ) {

			// Remove boolean attributes when set to false
			jQuery.removeAttr( elem, name );
		} else {
			elem.setAttribute( name, name );
		}
		return name;
	}
};

jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {
	var getter = attrHandle[ name ] || jQuery.find.attr;

	attrHandle[ name ] = function( elem, name, isXML ) {
		var ret, handle,
			lowercaseName = name.toLowerCase();

		if ( !isXML ) {

			// Avoid an infinite loop by temporarily removing this function from the getter
			handle = attrHandle[ lowercaseName ];
			attrHandle[ lowercaseName ] = ret;
			ret = getter( elem, name, isXML ) != null ?
				lowercaseName :
				null;
			attrHandle[ lowercaseName ] = handle;
		}
		return ret;
	};
} );




var rfocusable = /^(?:input|select|textarea|button)$/i,
	rclickable = /^(?:a|area)$/i;

jQuery.fn.extend( {
	prop: function( name, value ) {
		return access( this, jQuery.prop, name, value, arguments.length > 1 );
	},

	removeProp: function( name ) {
		return this.each( function() {
			delete this[ jQuery.propFix[ name ] || name ];
		} );
	}
} );

jQuery.extend( {
	prop: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set properties on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {

			// Fix name and attach hooks
			name = jQuery.propFix[ name ] || name;
			hooks = jQuery.propHooks[ name ];
		}

		if ( value !== undefined ) {
			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			return ( elem[ name ] = value );
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		return elem[ name ];
	},

	propHooks: {
		tabIndex: {
			get: function( elem ) {

				// Support: IE <=9 - 11 only
				// elem.tabIndex doesn't always return the
				// correct value when it hasn't been explicitly set
				// https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
				// Use proper attribute retrieval(#12072)
				var tabindex = jQuery.find.attr( elem, "tabindex" );

				if ( tabindex ) {
					return parseInt( tabindex, 10 );
				}

				if (
					rfocusable.test( elem.nodeName ) ||
					rclickable.test( elem.nodeName ) &&
					elem.href
				) {
					return 0;
				}

				return -1;
			}
		}
	},

	propFix: {
		"for": "htmlFor",
		"class": "className"
	}
} );

// Support: IE <=11 only
// Accessing the selectedIndex property
// forces the browser to respect setting selected
// on the option
// The getter ensures a default option is selected
// when in an optgroup
// eslint rule "no-unused-expressions" is disabled for this code
// since it considers such accessions noop
if ( !support.optSelected ) {
	jQuery.propHooks.selected = {
		get: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent && parent.parentNode ) {
				parent.parentNode.selectedIndex;
			}
			return null;
		},
		set: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent ) {
				parent.selectedIndex;

				if ( parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
			}
		}
	};
}

jQuery.each( [
	"tabIndex",
	"readOnly",
	"maxLength",
	"cellSpacing",
	"cellPadding",
	"rowSpan",
	"colSpan",
	"useMap",
	"frameBorder",
	"contentEditable"
], function() {
	jQuery.propFix[ this.toLowerCase() ] = this;
} );




	// Strip and collapse whitespace according to HTML spec
	// https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
	function stripAndCollapse( value ) {
		var tokens = value.match( rnothtmlwhite ) || [];
		return tokens.join( " " );
	}


function getClass( elem ) {
	return elem.getAttribute && elem.getAttribute( "class" ) || "";
}

function classesToArray( value ) {
	if ( Array.isArray( value ) ) {
		return value;
	}
	if ( typeof value === "string" ) {
		return value.match( rnothtmlwhite ) || [];
	}
	return [];
}

jQuery.fn.extend( {
	addClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		classes = classesToArray( value );

		if ( classes.length ) {
			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {
						if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
							cur += clazz + " ";
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	removeClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( !arguments.length ) {
			return this.attr( "class", "" );
		}

		classes = classesToArray( value );

		if ( classes.length ) {
			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );

				// This expression is here for better compressibility (see addClass)
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {

						// Remove *all* instances
						while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
							cur = cur.replace( " " + clazz + " ", " " );
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	toggleClass: function( value, stateVal ) {
		var type = typeof value,
			isValidValue = type === "string" || Array.isArray( value );

		if ( typeof stateVal === "boolean" && isValidValue ) {
			return stateVal ? this.addClass( value ) : this.removeClass( value );
		}

		if ( isFunction( value ) ) {
			return this.each( function( i ) {
				jQuery( this ).toggleClass(
					value.call( this, i, getClass( this ), stateVal ),
					stateVal
				);
			} );
		}

		return this.each( function() {
			var className, i, self, classNames;

			if ( isValidValue ) {

				// Toggle individual class names
				i = 0;
				self = jQuery( this );
				classNames = classesToArray( value );

				while ( ( className = classNames[ i++ ] ) ) {

					// Check each className given, space separated list
					if ( self.hasClass( className ) ) {
						self.removeClass( className );
					} else {
						self.addClass( className );
					}
				}

			// Toggle whole class name
			} else if ( value === undefined || type === "boolean" ) {
				className = getClass( this );
				if ( className ) {

					// Store className if set
					dataPriv.set( this, "__className__", className );
				}

				// If the element has a class name or if we're passed `false`,
				// then remove the whole classname (if there was one, the above saved it).
				// Otherwise bring back whatever was previously saved (if anything),
				// falling back to the empty string if nothing was stored.
				if ( this.setAttribute ) {
					this.setAttribute( "class",
						className || value === false ?
						"" :
						dataPriv.get( this, "__className__" ) || ""
					);
				}
			}
		} );
	},

	hasClass: function( selector ) {
		var className, elem,
			i = 0;

		className = " " + selector + " ";
		while ( ( elem = this[ i++ ] ) ) {
			if ( elem.nodeType === 1 &&
				( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
					return true;
			}
		}

		return false;
	}
} );




var rreturn = /\r/g;

jQuery.fn.extend( {
	val: function( value ) {
		var hooks, ret, valueIsFunction,
			elem = this[ 0 ];

		if ( !arguments.length ) {
			if ( elem ) {
				hooks = jQuery.valHooks[ elem.type ] ||
					jQuery.valHooks[ elem.nodeName.toLowerCase() ];

				if ( hooks &&
					"get" in hooks &&
					( ret = hooks.get( elem, "value" ) ) !== undefined
				) {
					return ret;
				}

				ret = elem.value;

				// Handle most common string cases
				if ( typeof ret === "string" ) {
					return ret.replace( rreturn, "" );
				}

				// Handle cases where value is null/undef or number
				return ret == null ? "" : ret;
			}

			return;
		}

		valueIsFunction = isFunction( value );

		return this.each( function( i ) {
			var val;

			if ( this.nodeType !== 1 ) {
				return;
			}

			if ( valueIsFunction ) {
				val = value.call( this, i, jQuery( this ).val() );
			} else {
				val = value;
			}

			// Treat null/undefined as ""; convert numbers to string
			if ( val == null ) {
				val = "";

			} else if ( typeof val === "number" ) {
				val += "";

			} else if ( Array.isArray( val ) ) {
				val = jQuery.map( val, function( value ) {
					return value == null ? "" : value + "";
				} );
			}

			hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];

			// If set returns undefined, fall back to normal setting
			if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
				this.value = val;
			}
		} );
	}
} );

jQuery.extend( {
	valHooks: {
		option: {
			get: function( elem ) {

				var val = jQuery.find.attr( elem, "value" );
				return val != null ?
					val :

					// Support: IE <=10 - 11 only
					// option.text throws exceptions (#14686, #14858)
					// Strip and collapse whitespace
					// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
					stripAndCollapse( jQuery.text( elem ) );
			}
		},
		select: {
			get: function( elem ) {
				var value, option, i,
					options = elem.options,
					index = elem.selectedIndex,
					one = elem.type === "select-one",
					values = one ? null : [],
					max = one ? index + 1 : options.length;

				if ( index < 0 ) {
					i = max;

				} else {
					i = one ? index : 0;
				}

				// Loop through all the selected options
				for ( ; i < max; i++ ) {
					option = options[ i ];

					// Support: IE <=9 only
					// IE8-9 doesn't update selected after form reset (#2551)
					if ( ( option.selected || i === index ) &&

							// Don't return options that are disabled or in a disabled optgroup
							!option.disabled &&
							( !option.parentNode.disabled ||
								!nodeName( option.parentNode, "optgroup" ) ) ) {

						// Get the specific value for the option
						value = jQuery( option ).val();

						// We don't need an array for one selects
						if ( one ) {
							return value;
						}

						// Multi-Selects return an array
						values.push( value );
					}
				}

				return values;
			},

			set: function( elem, value ) {
				var optionSet, option,
					options = elem.options,
					values = jQuery.makeArray( value ),
					i = options.length;

				while ( i-- ) {
					option = options[ i ];

					/* eslint-disable no-cond-assign */

					if ( option.selected =
						jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
					) {
						optionSet = true;
					}

					/* eslint-enable no-cond-assign */
				}

				// Force browsers to behave consistently when non-matching value is set
				if ( !optionSet ) {
					elem.selectedIndex = -1;
				}
				return values;
			}
		}
	}
} );

// Radios and checkboxes getter/setter
jQuery.each( [ "radio", "checkbox" ], function() {
	jQuery.valHooks[ this ] = {
		set: function( elem, value ) {
			if ( Array.isArray( value ) ) {
				return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
			}
		}
	};
	if ( !support.checkOn ) {
		jQuery.valHooks[ this ].get = function( elem ) {
			return elem.getAttribute( "value" ) === null ? "on" : elem.value;
		};
	}
} );




// Return jQuery for attributes-only inclusion


support.focusin = "onfocusin" in window;


var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
	stopPropagationCallback = function( e ) {
		e.stopPropagation();
	};

jQuery.extend( jQuery.event, {

	trigger: function( event, data, elem, onlyHandlers ) {

		var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
			eventPath = [ elem || document ],
			type = hasOwn.call( event, "type" ) ? event.type : event,
			namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];

		cur = lastElement = tmp = elem = elem || document;

		// Don't do events on text and comment nodes
		if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
			return;
		}

		// focus/blur morphs to focusin/out; ensure we're not firing them right now
		if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
			return;
		}

		if ( type.indexOf( "." ) > -1 ) {

			// Namespaced trigger; create a regexp to match event type in handle()
			namespaces = type.split( "." );
			type = namespaces.shift();
			namespaces.sort();
		}
		ontype = type.indexOf( ":" ) < 0 && "on" + type;

		// Caller can pass in a jQuery.Event object, Object, or just an event type string
		event = event[ jQuery.expando ] ?
			event :
			new jQuery.Event( type, typeof event === "object" && event );

		// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
		event.isTrigger = onlyHandlers ? 2 : 3;
		event.namespace = namespaces.join( "." );
		event.rnamespace = event.namespace ?
			new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
			null;

		// Clean up the event in case it is being reused
		event.result = undefined;
		if ( !event.target ) {
			event.target = elem;
		}

		// Clone any incoming data and prepend the event, creating the handler arg list
		data = data == null ?
			[ event ] :
			jQuery.makeArray( data, [ event ] );

		// Allow special events to draw outside the lines
		special = jQuery.event.special[ type ] || {};
		if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
			return;
		}

		// Determine event propagation path in advance, per W3C events spec (#9951)
		// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
		if ( !onlyHandlers && !special.noBubble && !isWindow( elem ) ) {

			bubbleType = special.delegateType || type;
			if ( !rfocusMorph.test( bubbleType + type ) ) {
				cur = cur.parentNode;
			}
			for ( ; cur; cur = cur.parentNode ) {
				eventPath.push( cur );
				tmp = cur;
			}

			// Only add window if we got to document (e.g., not plain obj or detached DOM)
			if ( tmp === ( elem.ownerDocument || document ) ) {
				eventPath.push( tmp.defaultView || tmp.parentWindow || window );
			}
		}

		// Fire handlers on the event path
		i = 0;
		while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
			lastElement = cur;
			event.type = i > 1 ?
				bubbleType :
				special.bindType || type;

			// jQuery handler
			handle = ( dataPriv.get( cur, "events" ) || {} )[ event.type ] &&
				dataPriv.get( cur, "handle" );
			if ( handle ) {
				handle.apply( cur, data );
			}

			// Native handler
			handle = ontype && cur[ ontype ];
			if ( handle && handle.apply && acceptData( cur ) ) {
				event.result = handle.apply( cur, data );
				if ( event.result === false ) {
					event.preventDefault();
				}
			}
		}
		event.type = type;

		// If nobody prevented the default action, do it now
		if ( !onlyHandlers && !event.isDefaultPrevented() ) {

			if ( ( !special._default ||
				special._default.apply( eventPath.pop(), data ) === false ) &&
				acceptData( elem ) ) {

				// Call a native DOM method on the target with the same name as the event.
				// Don't do default actions on window, that's where global variables be (#6170)
				if ( ontype && isFunction( elem[ type ] ) && !isWindow( elem ) ) {

					// Don't re-trigger an onFOO event when we call its FOO() method
					tmp = elem[ ontype ];

					if ( tmp ) {
						elem[ ontype ] = null;
					}

					// Prevent re-triggering of the same event, since we already bubbled it above
					jQuery.event.triggered = type;

					if ( event.isPropagationStopped() ) {
						lastElement.addEventListener( type, stopPropagationCallback );
					}

					elem[ type ]();

					if ( event.isPropagationStopped() ) {
						lastElement.removeEventListener( type, stopPropagationCallback );
					}

					jQuery.event.triggered = undefined;

					if ( tmp ) {
						elem[ ontype ] = tmp;
					}
				}
			}
		}

		return event.result;
	},

	// Piggyback on a donor event to simulate a different one
	// Used only for `focus(in | out)` events
	simulate: function( type, elem, event ) {
		var e = jQuery.extend(
			new jQuery.Event(),
			event,
			{
				type: type,
				isSimulated: true
			}
		);

		jQuery.event.trigger( e, null, elem );
	}

} );

jQuery.fn.extend( {

	trigger: function( type, data ) {
		return this.each( function() {
			jQuery.event.trigger( type, data, this );
		} );
	},
	triggerHandler: function( type, data ) {
		var elem = this[ 0 ];
		if ( elem ) {
			return jQuery.event.trigger( type, data, elem, true );
		}
	}
} );


// Support: Firefox <=44
// Firefox doesn't have focus(in | out) events
// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
//
// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
// focus(in | out) events fire after focus & blur events,
// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
if ( !support.focusin ) {
	jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {

		// Attach a single capturing handler on the document while someone wants focusin/focusout
		var handler = function( event ) {
			jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
		};

		jQuery.event.special[ fix ] = {
			setup: function() {
				var doc = this.ownerDocument || this,
					attaches = dataPriv.access( doc, fix );

				if ( !attaches ) {
					doc.addEventListener( orig, handler, true );
				}
				dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
			},
			teardown: function() {
				var doc = this.ownerDocument || this,
					attaches = dataPriv.access( doc, fix ) - 1;

				if ( !attaches ) {
					doc.removeEventListener( orig, handler, true );
					dataPriv.remove( doc, fix );

				} else {
					dataPriv.access( doc, fix, attaches );
				}
			}
		};
	} );
}
var location = window.location;

var nonce = Date.now();

var rquery = ( /\?/ );



// Cross-browser xml parsing
jQuery.parseXML = function( data ) {
	var xml;
	if ( !data || typeof data !== "string" ) {
		return null;
	}

	// Support: IE 9 - 11 only
	// IE throws on parseFromString with invalid input.
	try {
		xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
	} catch ( e ) {
		xml = undefined;
	}

	if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
		jQuery.error( "Invalid XML: " + data );
	}
	return xml;
};


var
	rbracket = /\[\]$/,
	rCRLF = /\r?\n/g,
	rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
	rsubmittable = /^(?:input|select|textarea|keygen)/i;

function buildParams( prefix, obj, traditional, add ) {
	var name;

	if ( Array.isArray( obj ) ) {

		// Serialize array item.
		jQuery.each( obj, function( i, v ) {
			if ( traditional || rbracket.test( prefix ) ) {

				// Treat each array item as a scalar.
				add( prefix, v );

			} else {

				// Item is non-scalar (array or object), encode its numeric index.
				buildParams(
					prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
					v,
					traditional,
					add
				);
			}
		} );

	} else if ( !traditional && toType( obj ) === "object" ) {

		// Serialize object item.
		for ( name in obj ) {
			buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
		}

	} else {

		// Serialize scalar item.
		add( prefix, obj );
	}
}

// Serialize an array of form elements or a set of
// key/values into a query string
jQuery.param = function( a, traditional ) {
	var prefix,
		s = [],
		add = function( key, valueOrFunction ) {

			// If value is a function, invoke it and use its return value
			var value = isFunction( valueOrFunction ) ?
				valueOrFunction() :
				valueOrFunction;

			s[ s.length ] = encodeURIComponent( key ) + "=" +
				encodeURIComponent( value == null ? "" : value );
		};

	// If an array was passed in, assume that it is an array of form elements.
	if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {

		// Serialize the form elements
		jQuery.each( a, function() {
			add( this.name, this.value );
		} );

	} else {

		// If traditional, encode the "old" way (the way 1.3.2 or older
		// did it), otherwise encode params recursively.
		for ( prefix in a ) {
			buildParams( prefix, a[ prefix ], traditional, add );
		}
	}

	// Return the resulting serialization
	return s.join( "&" );
};

jQuery.fn.extend( {
	serialize: function() {
		return jQuery.param( this.serializeArray() );
	},
	serializeArray: function() {
		return this.map( function() {

			// Can add propHook for "elements" to filter or add form elements
			var elements = jQuery.prop( this, "elements" );
			return elements ? jQuery.makeArray( elements ) : this;
		} )
		.filter( function() {
			var type = this.type;

			// Use .is( ":disabled" ) so that fieldset[disabled] works
			return this.name && !jQuery( this ).is( ":disabled" ) &&
				rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
				( this.checked || !rcheckableType.test( type ) );
		} )
		.map( function( i, elem ) {
			var val = jQuery( this ).val();

			if ( val == null ) {
				return null;
			}

			if ( Array.isArray( val ) ) {
				return jQuery.map( val, function( val ) {
					return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
				} );
			}

			return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
		} ).get();
	}
} );


var
	r20 = /%20/g,
	rhash = /#.*$/,
	rantiCache = /([?&])_=[^&]*/,
	rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,

	// #7653, #8125, #8152: local protocol detection
	rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
	rnoContent = /^(?:GET|HEAD)$/,
	rprotocol = /^\/\//,

	/* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */
	prefilters = {},

	/* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */
	transports = {},

	// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
	allTypes = "*/".concat( "*" ),

	// Anchor tag for parsing the document origin
	originAnchor = document.createElement( "a" );
	originAnchor.href = location.href;

// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
function addToPrefiltersOrTransports( structure ) {

	// dataTypeExpression is optional and defaults to "*"
	return function( dataTypeExpression, func ) {

		if ( typeof dataTypeExpression !== "string" ) {
			func = dataTypeExpression;
			dataTypeExpression = "*";
		}

		var dataType,
			i = 0,
			dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];

		if ( isFunction( func ) ) {

			// For each dataType in the dataTypeExpression
			while ( ( dataType = dataTypes[ i++ ] ) ) {

				// Prepend if requested
				if ( dataType[ 0 ] === "+" ) {
					dataType = dataType.slice( 1 ) || "*";
					( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );

				// Otherwise append
				} else {
					( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
				}
			}
		}
	};
}

// Base inspection function for prefilters and transports
function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {

	var inspected = {},
		seekingTransport = ( structure === transports );

	function inspect( dataType ) {
		var selected;
		inspected[ dataType ] = true;
		jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
			var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
			if ( typeof dataTypeOrTransport === "string" &&
				!seekingTransport && !inspected[ dataTypeOrTransport ] ) {

				options.dataTypes.unshift( dataTypeOrTransport );
				inspect( dataTypeOrTransport );
				return false;
			} else if ( seekingTransport ) {
				return !( selected = dataTypeOrTransport );
			}
		} );
		return selected;
	}

	return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
}

// A special extend for ajax options
// that takes "flat" options (not to be deep extended)
// Fixes #9887
function ajaxExtend( target, src ) {
	var key, deep,
		flatOptions = jQuery.ajaxSettings.flatOptions || {};

	for ( key in src ) {
		if ( src[ key ] !== undefined ) {
			( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
		}
	}
	if ( deep ) {
		jQuery.extend( true, target, deep );
	}

	return target;
}

/* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */
function ajaxHandleResponses( s, jqXHR, responses ) {

	var ct, type, finalDataType, firstDataType,
		contents = s.contents,
		dataTypes = s.dataTypes;

	// Remove auto dataType and get content-type in the process
	while ( dataTypes[ 0 ] === "*" ) {
		dataTypes.shift();
		if ( ct === undefined ) {
			ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
		}
	}

	// Check if we're dealing with a known content-type
	if ( ct ) {
		for ( type in contents ) {
			if ( contents[ type ] && contents[ type ].test( ct ) ) {
				dataTypes.unshift( type );
				break;
			}
		}
	}

	// Check to see if we have a response for the expected dataType
	if ( dataTypes[ 0 ] in responses ) {
		finalDataType = dataTypes[ 0 ];
	} else {

		// Try convertible dataTypes
		for ( type in responses ) {
			if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
				finalDataType = type;
				break;
			}
			if ( !firstDataType ) {
				firstDataType = type;
			}
		}

		// Or just use first one
		finalDataType = finalDataType || firstDataType;
	}

	// If we found a dataType
	// We add the dataType to the list if needed
	// and return the corresponding response
	if ( finalDataType ) {
		if ( finalDataType !== dataTypes[ 0 ] ) {
			dataTypes.unshift( finalDataType );
		}
		return responses[ finalDataType ];
	}
}

/* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */
function ajaxConvert( s, response, jqXHR, isSuccess ) {
	var conv2, current, conv, tmp, prev,
		converters = {},

		// Work with a copy of dataTypes in case we need to modify it for conversion
		dataTypes = s.dataTypes.slice();

	// Create converters map with lowercased keys
	if ( dataTypes[ 1 ] ) {
		for ( conv in s.converters ) {
			converters[ conv.toLowerCase() ] = s.converters[ conv ];
		}
	}

	current = dataTypes.shift();

	// Convert to each sequential dataType
	while ( current ) {

		if ( s.responseFields[ current ] ) {
			jqXHR[ s.responseFields[ current ] ] = response;
		}

		// Apply the dataFilter if provided
		if ( !prev && isSuccess && s.dataFilter ) {
			response = s.dataFilter( response, s.dataType );
		}

		prev = current;
		current = dataTypes.shift();

		if ( current ) {

			// There's only work to do if current dataType is non-auto
			if ( current === "*" ) {

				current = prev;

			// Convert response if prev dataType is non-auto and differs from current
			} else if ( prev !== "*" && prev !== current ) {

				// Seek a direct converter
				conv = converters[ prev + " " + current ] || converters[ "* " + current ];

				// If none found, seek a pair
				if ( !conv ) {
					for ( conv2 in converters ) {

						// If conv2 outputs current
						tmp = conv2.split( " " );
						if ( tmp[ 1 ] === current ) {

							// If prev can be converted to accepted input
							conv = converters[ prev + " " + tmp[ 0 ] ] ||
								converters[ "* " + tmp[ 0 ] ];
							if ( conv ) {

								// Condense equivalence converters
								if ( conv === true ) {
									conv = converters[ conv2 ];

								// Otherwise, insert the intermediate dataType
								} else if ( converters[ conv2 ] !== true ) {
									current = tmp[ 0 ];
									dataTypes.unshift( tmp[ 1 ] );
								}
								break;
							}
						}
					}
				}

				// Apply converter (if not an equivalence)
				if ( conv !== true ) {

					// Unless errors are allowed to bubble, catch and return them
					if ( conv && s.throws ) {
						response = conv( response );
					} else {
						try {
							response = conv( response );
						} catch ( e ) {
							return {
								state: "parsererror",
								error: conv ? e : "No conversion from " + prev + " to " + current
							};
						}
					}
				}
			}
		}
	}

	return { state: "success", data: response };
}

jQuery.extend( {

	// Counter for holding the number of active queries
	active: 0,

	// Last-Modified header cache for next request
	lastModified: {},
	etag: {},

	ajaxSettings: {
		url: location.href,
		type: "GET",
		isLocal: rlocalProtocol.test( location.protocol ),
		global: true,
		processData: true,
		async: true,
		contentType: "application/x-www-form-urlencoded; charset=UTF-8",

		/*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/

		accepts: {
			"*": allTypes,
			text: "text/plain",
			html: "text/html",
			xml: "application/xml, text/xml",
			json: "application/json, text/javascript"
		},

		contents: {
			xml: /\bxml\b/,
			html: /\bhtml/,
			json: /\bjson\b/
		},

		responseFields: {
			xml: "responseXML",
			text: "responseText",
			json: "responseJSON"
		},

		// Data converters
		// Keys separate source (or catchall "*") and destination types with a single space
		converters: {

			// Convert anything to text
			"* text": String,

			// Text to html (true = no transformation)
			"text html": true,

			// Evaluate text as a json expression
			"text json": JSON.parse,

			// Parse text as xml
			"text xml": jQuery.parseXML
		},

		// For options that shouldn't be deep extended:
		// you can add your own custom options here if
		// and when you create one that shouldn't be
		// deep extended (see ajaxExtend)
		flatOptions: {
			url: true,
			context: true
		}
	},

	// Creates a full fledged settings object into target
	// with both ajaxSettings and settings fields.
	// If target is omitted, writes into ajaxSettings.
	ajaxSetup: function( target, settings ) {
		return settings ?

			// Building a settings object
			ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :

			// Extending ajaxSettings
			ajaxExtend( jQuery.ajaxSettings, target );
	},

	ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
	ajaxTransport: addToPrefiltersOrTransports( transports ),

	// Main method
	ajax: function( url, options ) {

		// If url is an object, simulate pre-1.5 signature
		if ( typeof url === "object" ) {
			options = url;
			url = undefined;
		}

		// Force options to be an object
		options = options || {};

		var transport,

			// URL without anti-cache param
			cacheURL,

			// Response headers
			responseHeadersString,
			responseHeaders,

			// timeout handle
			timeoutTimer,

			// Url cleanup var
			urlAnchor,

			// Request state (becomes false upon send and true upon completion)
			completed,

			// To know if global events are to be dispatched
			fireGlobals,

			// Loop variable
			i,

			// uncached part of the url
			uncached,

			// Create the final options object
			s = jQuery.ajaxSetup( {}, options ),

			// Callbacks context
			callbackContext = s.context || s,

			// Context for global events is callbackContext if it is a DOM node or jQuery collection
			globalEventContext = s.context &&
				( callbackContext.nodeType || callbackContext.jquery ) ?
					jQuery( callbackContext ) :
					jQuery.event,

			// Deferreds
			deferred = jQuery.Deferred(),
			completeDeferred = jQuery.Callbacks( "once memory" ),

			// Status-dependent callbacks
			statusCode = s.statusCode || {},

			// Headers (they are sent all at once)
			requestHeaders = {},
			requestHeadersNames = {},

			// Default abort message
			strAbort = "canceled",

			// Fake xhr
			jqXHR = {
				readyState: 0,

				// Builds headers hashtable if needed
				getResponseHeader: function( key ) {
					var match;
					if ( completed ) {
						if ( !responseHeaders ) {
							responseHeaders = {};
							while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
								responseHeaders[ match[ 1 ].toLowerCase() ] = match[ 2 ];
							}
						}
						match = responseHeaders[ key.toLowerCase() ];
					}
					return match == null ? null : match;
				},

				// Raw string
				getAllResponseHeaders: function() {
					return completed ? responseHeadersString : null;
				},

				// Caches the header
				setRequestHeader: function( name, value ) {
					if ( completed == null ) {
						name = requestHeadersNames[ name.toLowerCase() ] =
							requestHeadersNames[ name.toLowerCase() ] || name;
						requestHeaders[ name ] = value;
					}
					return this;
				},

				// Overrides response content-type header
				overrideMimeType: function( type ) {
					if ( completed == null ) {
						s.mimeType = type;
					}
					return this;
				},

				// Status-dependent callbacks
				statusCode: function( map ) {
					var code;
					if ( map ) {
						if ( completed ) {

							// Execute the appropriate callbacks
							jqXHR.always( map[ jqXHR.status ] );
						} else {

							// Lazy-add the new callbacks in a way that preserves old ones
							for ( code in map ) {
								statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
							}
						}
					}
					return this;
				},

				// Cancel the request
				abort: function( statusText ) {
					var finalText = statusText || strAbort;
					if ( transport ) {
						transport.abort( finalText );
					}
					done( 0, finalText );
					return this;
				}
			};

		// Attach deferreds
		deferred.promise( jqXHR );

		// Add protocol if not provided (prefilters might expect it)
		// Handle falsy url in the settings object (#10093: consistency with old signature)
		// We also use the url parameter if available
		s.url = ( ( url || s.url || location.href ) + "" )
			.replace( rprotocol, location.protocol + "//" );

		// Alias method option to type as per ticket #12004
		s.type = options.method || options.type || s.method || s.type;

		// Extract dataTypes list
		s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];

		// A cross-domain request is in order when the origin doesn't match the current origin.
		if ( s.crossDomain == null ) {
			urlAnchor = document.createElement( "a" );

			// Support: IE <=8 - 11, Edge 12 - 15
			// IE throws exception on accessing the href property if url is malformed,
			// e.g. http://example.com:80x/
			try {
				urlAnchor.href = s.url;

				// Support: IE <=8 - 11 only
				// Anchor's host property isn't correctly set when s.url is relative
				urlAnchor.href = urlAnchor.href;
				s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
					urlAnchor.protocol + "//" + urlAnchor.host;
			} catch ( e ) {

				// If there is an error parsing the URL, assume it is crossDomain,
				// it can be rejected by the transport if it is invalid
				s.crossDomain = true;
			}
		}

		// Convert data if not already a string
		if ( s.data && s.processData && typeof s.data !== "string" ) {
			s.data = jQuery.param( s.data, s.traditional );
		}

		// Apply prefilters
		inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );

		// If request was aborted inside a prefilter, stop there
		if ( completed ) {
			return jqXHR;
		}

		// We can fire global events as of now if asked to
		// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
		fireGlobals = jQuery.event && s.global;

		// Watch for a new set of requests
		if ( fireGlobals && jQuery.active++ === 0 ) {
			jQuery.event.trigger( "ajaxStart" );
		}

		// Uppercase the type
		s.type = s.type.toUpperCase();

		// Determine if request has content
		s.hasContent = !rnoContent.test( s.type );

		// Save the URL in case we're toying with the If-Modified-Since
		// and/or If-None-Match header later on
		// Remove hash to simplify url manipulation
		cacheURL = s.url.replace( rhash, "" );

		// More options handling for requests with no content
		if ( !s.hasContent ) {

			// Remember the hash so we can put it back
			uncached = s.url.slice( cacheURL.length );

			// If data is available and should be processed, append data to url
			if ( s.data && ( s.processData || typeof s.data === "string" ) ) {
				cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;

				// #9682: remove data so that it's not used in an eventual retry
				delete s.data;
			}

			// Add or update anti-cache param if needed
			if ( s.cache === false ) {
				cacheURL = cacheURL.replace( rantiCache, "$1" );
				uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce++ ) + uncached;
			}

			// Put hash and anti-cache on the URL that will be requested (gh-1732)
			s.url = cacheURL + uncached;

		// Change '%20' to '+' if this is encoded form body content (gh-2658)
		} else if ( s.data && s.processData &&
			( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
			s.data = s.data.replace( r20, "+" );
		}

		// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
		if ( s.ifModified ) {
			if ( jQuery.lastModified[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
			}
			if ( jQuery.etag[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
			}
		}

		// Set the correct header, if data is being sent
		if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
			jqXHR.setRequestHeader( "Content-Type", s.contentType );
		}

		// Set the Accepts header for the server, depending on the dataType
		jqXHR.setRequestHeader(
			"Accept",
			s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
				s.accepts[ s.dataTypes[ 0 ] ] +
					( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
				s.accepts[ "*" ]
		);

		// Check for headers option
		for ( i in s.headers ) {
			jqXHR.setRequestHeader( i, s.headers[ i ] );
		}

		// Allow custom headers/mimetypes and early abort
		if ( s.beforeSend &&
			( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {

			// Abort if not done already and return
			return jqXHR.abort();
		}

		// Aborting is no longer a cancellation
		strAbort = "abort";

		// Install callbacks on deferreds
		completeDeferred.add( s.complete );
		jqXHR.done( s.success );
		jqXHR.fail( s.error );

		// Get transport
		transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );

		// If no transport, we auto-abort
		if ( !transport ) {
			done( -1, "No Transport" );
		} else {
			jqXHR.readyState = 1;

			// Send global event
			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
			}

			// If request was aborted inside ajaxSend, stop there
			if ( completed ) {
				return jqXHR;
			}

			// Timeout
			if ( s.async && s.timeout > 0 ) {
				timeoutTimer = window.setTimeout( function() {
					jqXHR.abort( "timeout" );
				}, s.timeout );
			}

			try {
				completed = false;
				transport.send( requestHeaders, done );
			} catch ( e ) {

				// Rethrow post-completion exceptions
				if ( completed ) {
					throw e;
				}

				// Propagate others as results
				done( -1, e );
			}
		}

		// Callback for when everything is done
		function done( status, nativeStatusText, responses, headers ) {
			var isSuccess, success, error, response, modified,
				statusText = nativeStatusText;

			// Ignore repeat invocations
			if ( completed ) {
				return;
			}

			completed = true;

			// Clear timeout if it exists
			if ( timeoutTimer ) {
				window.clearTimeout( timeoutTimer );
			}

			// Dereference transport for early garbage collection
			// (no matter how long the jqXHR object will be used)
			transport = undefined;

			// Cache response headers
			responseHeadersString = headers || "";

			// Set readyState
			jqXHR.readyState = status > 0 ? 4 : 0;

			// Determine if successful
			isSuccess = status >= 200 && status < 300 || status === 304;

			// Get response data
			if ( responses ) {
				response = ajaxHandleResponses( s, jqXHR, responses );
			}

			// Convert no matter what (that way responseXXX fields are always set)
			response = ajaxConvert( s, response, jqXHR, isSuccess );

			// If successful, handle type chaining
			if ( isSuccess ) {

				// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
				if ( s.ifModified ) {
					modified = jqXHR.getResponseHeader( "Last-Modified" );
					if ( modified ) {
						jQuery.lastModified[ cacheURL ] = modified;
					}
					modified = jqXHR.getResponseHeader( "etag" );
					if ( modified ) {
						jQuery.etag[ cacheURL ] = modified;
					}
				}

				// if no content
				if ( status === 204 || s.type === "HEAD" ) {
					statusText = "nocontent";

				// if not modified
				} else if ( status === 304 ) {
					statusText = "notmodified";

				// If we have data, let's convert it
				} else {
					statusText = response.state;
					success = response.data;
					error = response.error;
					isSuccess = !error;
				}
			} else {

				// Extract error from statusText and normalize for non-aborts
				error = statusText;
				if ( status || !statusText ) {
					statusText = "error";
					if ( status < 0 ) {
						status = 0;
					}
				}
			}

			// Set data for the fake xhr object
			jqXHR.status = status;
			jqXHR.statusText = ( nativeStatusText || statusText ) + "";

			// Success/Error
			if ( isSuccess ) {
				deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
			} else {
				deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
			}

			// Status-dependent callbacks
			jqXHR.statusCode( statusCode );
			statusCode = undefined;

			if ( fireGlobals ) {
				globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
					[ jqXHR, s, isSuccess ? success : error ] );
			}

			// Complete
			completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );

			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );

				// Handle the global AJAX counter
				if ( !( --jQuery.active ) ) {
					jQuery.event.trigger( "ajaxStop" );
				}
			}
		}

		return jqXHR;
	},

	getJSON: function( url, data, callback ) {
		return jQuery.get( url, data, callback, "json" );
	},

	getScript: function( url, callback ) {
		return jQuery.get( url, undefined, callback, "script" );
	}
} );

jQuery.each( [ "get", "post" ], function( i, method ) {
	jQuery[ method ] = function( url, data, callback, type ) {

		// Shift arguments if data argument was omitted
		if ( isFunction( data ) ) {
			type = type || callback;
			callback = data;
			data = undefined;
		}

		// The url can be an options object (which then must have .url)
		return jQuery.ajax( jQuery.extend( {
			url: url,
			type: method,
			dataType: type,
			data: data,
			success: callback
		}, jQuery.isPlainObject( url ) && url ) );
	};
} );


jQuery._evalUrl = function( url ) {
	return jQuery.ajax( {
		url: url,

		// Make this explicit, since user can override this through ajaxSetup (#11264)
		type: "GET",
		dataType: "script",
		cache: true,
		async: false,
		global: false,
		"throws": true
	} );
};


jQuery.fn.extend( {
	wrapAll: function( html ) {
		var wrap;

		if ( this[ 0 ] ) {
			if ( isFunction( html ) ) {
				html = html.call( this[ 0 ] );
			}

			// The elements to wrap the target around
			wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );

			if ( this[ 0 ].parentNode ) {
				wrap.insertBefore( this[ 0 ] );
			}

			wrap.map( function() {
				var elem = this;

				while ( elem.firstElementChild ) {
					elem = elem.firstElementChild;
				}

				return elem;
			} ).append( this );
		}

		return this;
	},

	wrapInner: function( html ) {
		if ( isFunction( html ) ) {
			return this.each( function( i ) {
				jQuery( this ).wrapInner( html.call( this, i ) );
			} );
		}

		return this.each( function() {
			var self = jQuery( this ),
				contents = self.contents();

			if ( contents.length ) {
				contents.wrapAll( html );

			} else {
				self.append( html );
			}
		} );
	},

	wrap: function( html ) {
		var htmlIsFunction = isFunction( html );

		return this.each( function( i ) {
			jQuery( this ).wrapAll( htmlIsFunction ? html.call( this, i ) : html );
		} );
	},

	unwrap: function( selector ) {
		this.parent( selector ).not( "body" ).each( function() {
			jQuery( this ).replaceWith( this.childNodes );
		} );
		return this;
	}
} );


jQuery.expr.pseudos.hidden = function( elem ) {
	return !jQuery.expr.pseudos.visible( elem );
};
jQuery.expr.pseudos.visible = function( elem ) {
	return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
};




jQuery.ajaxSettings.xhr = function() {
	try {
		return new window.XMLHttpRequest();
	} catch ( e ) {}
};

var xhrSuccessStatus = {

		// File protocol always yields status code 0, assume 200
		0: 200,

		// Support: IE <=9 only
		// #1450: sometimes IE returns 1223 when it should be 204
		1223: 204
	},
	xhrSupported = jQuery.ajaxSettings.xhr();

support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
support.ajax = xhrSupported = !!xhrSupported;

jQuery.ajaxTransport( function( options ) {
	var callback, errorCallback;

	// Cross domain only allowed if supported through XMLHttpRequest
	if ( support.cors || xhrSupported && !options.crossDomain ) {
		return {
			send: function( headers, complete ) {
				var i,
					xhr = options.xhr();

				xhr.open(
					options.type,
					options.url,
					options.async,
					options.username,
					options.password
				);

				// Apply custom fields if provided
				if ( options.xhrFields ) {
					for ( i in options.xhrFields ) {
						xhr[ i ] = options.xhrFields[ i ];
					}
				}

				// Override mime type if needed
				if ( options.mimeType && xhr.overrideMimeType ) {
					xhr.overrideMimeType( options.mimeType );
				}

				// X-Requested-With header
				// For cross-domain requests, seeing as conditions for a preflight are
				// akin to a jigsaw puzzle, we simply never set it to be sure.
				// (it can always be set on a per-request basis or even using ajaxSetup)
				// For same-domain requests, won't change header if already provided.
				if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
					headers[ "X-Requested-With" ] = "XMLHttpRequest";
				}

				// Set headers
				for ( i in headers ) {
					xhr.setRequestHeader( i, headers[ i ] );
				}

				// Callback
				callback = function( type ) {
					return function() {
						if ( callback ) {
							callback = errorCallback = xhr.onload =
								xhr.onerror = xhr.onabort = xhr.ontimeout =
									xhr.onreadystatechange = null;

							if ( type === "abort" ) {
								xhr.abort();
							} else if ( type === "error" ) {

								// Support: IE <=9 only
								// On a manual native abort, IE9 throws
								// errors on any property access that is not readyState
								if ( typeof xhr.status !== "number" ) {
									complete( 0, "error" );
								} else {
									complete(

										// File: protocol always yields status 0; see #8605, #14207
										xhr.status,
										xhr.statusText
									);
								}
							} else {
								complete(
									xhrSuccessStatus[ xhr.status ] || xhr.status,
									xhr.statusText,

									// Support: IE <=9 only
									// IE9 has no XHR2 but throws on binary (trac-11426)
									// For XHR2 non-text, let the caller handle it (gh-2498)
									( xhr.responseType || "text" ) !== "text"  ||
									typeof xhr.responseText !== "string" ?
										{ binary: xhr.response } :
										{ text: xhr.responseText },
									xhr.getAllResponseHeaders()
								);
							}
						}
					};
				};

				// Listen to events
				xhr.onload = callback();
				errorCallback = xhr.onerror = xhr.ontimeout = callback( "error" );

				// Support: IE 9 only
				// Use onreadystatechange to replace onabort
				// to handle uncaught aborts
				if ( xhr.onabort !== undefined ) {
					xhr.onabort = errorCallback;
				} else {
					xhr.onreadystatechange = function() {

						// Check readyState before timeout as it changes
						if ( xhr.readyState === 4 ) {

							// Allow onerror to be called first,
							// but that will not handle a native abort
							// Also, save errorCallback to a variable
							// as xhr.onerror cannot be accessed
							window.setTimeout( function() {
								if ( callback ) {
									errorCallback();
								}
							} );
						}
					};
				}

				// Create the abort callback
				callback = callback( "abort" );

				try {

					// Do send the request (this may raise an exception)
					xhr.send( options.hasContent && options.data || null );
				} catch ( e ) {

					// #14683: Only rethrow if this hasn't been notified as an error yet
					if ( callback ) {
						throw e;
					}
				}
			},

			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
jQuery.ajaxPrefilter( function( s ) {
	if ( s.crossDomain ) {
		s.contents.script = false;
	}
} );

// Install script dataType
jQuery.ajaxSetup( {
	accepts: {
		script: "text/javascript, application/javascript, " +
			"application/ecmascript, application/x-ecmascript"
	},
	contents: {
		script: /\b(?:java|ecma)script\b/
	},
	converters: {
		"text script": function( text ) {
			jQuery.globalEval( text );
			return text;
		}
	}
} );

// Handle cache's special case and crossDomain
jQuery.ajaxPrefilter( "script", function( s ) {
	if ( s.cache === undefined ) {
		s.cache = false;
	}
	if ( s.crossDomain ) {
		s.type = "GET";
	}
} );

// Bind script tag hack transport
jQuery.ajaxTransport( "script", function( s ) {

	// This transport only deals with cross domain requests
	if ( s.crossDomain ) {
		var script, callback;
		return {
			send: function( _, complete ) {
				script = jQuery( "<script>" ).prop( {
					charset: s.scriptCharset,
					src: s.url
				} ).on(
					"load error",
					callback = function( evt ) {
						script.remove();
						callback = null;
						if ( evt ) {
							complete( evt.type === "error" ? 404 : 200, evt.type );
						}
					}
				);

				// Use native DOM manipulation to avoid our domManip AJAX trickery
				document.head.appendChild( script[ 0 ] );
			},
			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




var oldCallbacks = [],
	rjsonp = /(=)\?(?=&|$)|\?\?/;

// Default jsonp settings
jQuery.ajaxSetup( {
	jsonp: "callback",
	jsonpCallback: function() {
		var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
		this[ callback ] = true;
		return callback;
	}
} );

// Detect, normalize options and install callbacks for jsonp requests
jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {

	var callbackName, overwritten, responseContainer,
		jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
			"url" :
			typeof s.data === "string" &&
				( s.contentType || "" )
					.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
				rjsonp.test( s.data ) && "data"
		);

	// Handle iff the expected data type is "jsonp" or we have a parameter to set
	if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {

		// Get callback name, remembering preexisting value associated with it
		callbackName = s.jsonpCallback = isFunction( s.jsonpCallback ) ?
			s.jsonpCallback() :
			s.jsonpCallback;

		// Insert callback into url or form data
		if ( jsonProp ) {
			s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
		} else if ( s.jsonp !== false ) {
			s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
		}

		// Use data converter to retrieve json after script execution
		s.converters[ "script json" ] = function() {
			if ( !responseContainer ) {
				jQuery.error( callbackName + " was not called" );
			}
			return responseContainer[ 0 ];
		};

		// Force json dataType
		s.dataTypes[ 0 ] = "json";

		// Install callback
		overwritten = window[ callbackName ];
		window[ callbackName ] = function() {
			responseContainer = arguments;
		};

		// Clean-up function (fires after converters)
		jqXHR.always( function() {

			// If previous value didn't exist - remove it
			if ( overwritten === undefined ) {
				jQuery( window ).removeProp( callbackName );

			// Otherwise restore preexisting value
			} else {
				window[ callbackName ] = overwritten;
			}

			// Save back as free
			if ( s[ callbackName ] ) {

				// Make sure that re-using the options doesn't screw things around
				s.jsonpCallback = originalSettings.jsonpCallback;

				// Save the callback name for future use
				oldCallbacks.push( callbackName );
			}

			// Call if it was a function and we have a response
			if ( responseContainer && isFunction( overwritten ) ) {
				overwritten( responseContainer[ 0 ] );
			}

			responseContainer = overwritten = undefined;
		} );

		// Delegate to script
		return "script";
	}
} );




// Support: Safari 8 only
// In Safari 8 documents created via document.implementation.createHTMLDocument
// collapse sibling forms: the second one becomes a child of the first one.
// Because of that, this security measure has to be disabled in Safari 8.
// https://bugs.webkit.org/show_bug.cgi?id=137337
support.createHTMLDocument = ( function() {
	var body = document.implementation.createHTMLDocument( "" ).body;
	body.innerHTML = "<form></form><form></form>";
	return body.childNodes.length === 2;
} )();


// Argument "data" should be string of html
// context (optional): If specified, the fragment will be created in this context,
// defaults to document
// keepScripts (optional): If true, will include scripts passed in the html string
jQuery.parseHTML = function( data, context, keepScripts ) {
	if ( typeof data !== "string" ) {
		return [];
	}
	if ( typeof context === "boolean" ) {
		keepScripts = context;
		context = false;
	}

	var base, parsed, scripts;

	if ( !context ) {

		// Stop scripts or inline event handlers from being executed immediately
		// by using document.implementation
		if ( support.createHTMLDocument ) {
			context = document.implementation.createHTMLDocument( "" );

			// Set the base href for the created document
			// so any parsed elements with URLs
			// are based on the document's URL (gh-2965)
			base = context.createElement( "base" );
			base.href = document.location.href;
			context.head.appendChild( base );
		} else {
			context = document;
		}
	}

	parsed = rsingleTag.exec( data );
	scripts = !keepScripts && [];

	// Single tag
	if ( parsed ) {
		return [ context.createElement( parsed[ 1 ] ) ];
	}

	parsed = buildFragment( [ data ], context, scripts );

	if ( scripts && scripts.length ) {
		jQuery( scripts ).remove();
	}

	return jQuery.merge( [], parsed.childNodes );
};


/**
 * Load a url into a page
 */
jQuery.fn.load = function( url, params, callback ) {
	var selector, type, response,
		self = this,
		off = url.indexOf( " " );

	if ( off > -1 ) {
		selector = stripAndCollapse( url.slice( off ) );
		url = url.slice( 0, off );
	}

	// If it's a function
	if ( isFunction( params ) ) {

		// We assume that it's the callback
		callback = params;
		params = undefined;

	// Otherwise, build a param string
	} else if ( params && typeof params === "object" ) {
		type = "POST";
	}

	// If we have elements to modify, make the request
	if ( self.length > 0 ) {
		jQuery.ajax( {
			url: url,

			// If "type" variable is undefined, then "GET" method will be used.
			// Make value of this field explicit since
			// user can override it through ajaxSetup method
			type: type || "GET",
			dataType: "html",
			data: params
		} ).done( function( responseText ) {

			// Save response for use in complete callback
			response = arguments;

			self.html( selector ?

				// If a selector was specified, locate the right elements in a dummy div
				// Exclude scripts to avoid IE 'Permission Denied' errors
				jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :

				// Otherwise use the full result
				responseText );

		// If the request succeeds, this function gets "data", "status", "jqXHR"
		// but they are ignored because response was set above.
		// If it fails, this function gets "jqXHR", "status", "error"
		} ).always( callback && function( jqXHR, status ) {
			self.each( function() {
				callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
			} );
		} );
	}

	return this;
};




// Attach a bunch of functions for handling common AJAX events
jQuery.each( [
	"ajaxStart",
	"ajaxStop",
	"ajaxComplete",
	"ajaxError",
	"ajaxSuccess",
	"ajaxSend"
], function( i, type ) {
	jQuery.fn[ type ] = function( fn ) {
		return this.on( type, fn );
	};
} );




jQuery.expr.pseudos.animated = function( elem ) {
	return jQuery.grep( jQuery.timers, function( fn ) {
		return elem === fn.elem;
	} ).length;
};




jQuery.offset = {
	setOffset: function( elem, options, i ) {
		var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
			position = jQuery.css( elem, "position" ),
			curElem = jQuery( elem ),
			props = {};

		// Set position first, in-case top/left are set even on static elem
		if ( position === "static" ) {
			elem.style.position = "relative";
		}

		curOffset = curElem.offset();
		curCSSTop = jQuery.css( elem, "top" );
		curCSSLeft = jQuery.css( elem, "left" );
		calculatePosition = ( position === "absolute" || position === "fixed" ) &&
			( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;

		// Need to be able to calculate position if either
		// top or left is auto and position is either absolute or fixed
		if ( calculatePosition ) {
			curPosition = curElem.position();
			curTop = curPosition.top;
			curLeft = curPosition.left;

		} else {
			curTop = parseFloat( curCSSTop ) || 0;
			curLeft = parseFloat( curCSSLeft ) || 0;
		}

		if ( isFunction( options ) ) {

			// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
			options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
		}

		if ( options.top != null ) {
			props.top = ( options.top - curOffset.top ) + curTop;
		}
		if ( options.left != null ) {
			props.left = ( options.left - curOffset.left ) + curLeft;
		}

		if ( "using" in options ) {
			options.using.call( elem, props );

		} else {
			curElem.css( props );
		}
	}
};

jQuery.fn.extend( {

	// offset() relates an element's border box to the document origin
	offset: function( options ) {

		// Preserve chaining for setter
		if ( arguments.length ) {
			return options === undefined ?
				this :
				this.each( function( i ) {
					jQuery.offset.setOffset( this, options, i );
				} );
		}

		var rect, win,
			elem = this[ 0 ];

		if ( !elem ) {
			return;
		}

		// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
		// Support: IE <=11 only
		// Running getBoundingClientRect on a
		// disconnected node in IE throws an error
		if ( !elem.getClientRects().length ) {
			return { top: 0, left: 0 };
		}

		// Get document-relative position by adding viewport scroll to viewport-relative gBCR
		rect = elem.getBoundingClientRect();
		win = elem.ownerDocument.defaultView;
		return {
			top: rect.top + win.pageYOffset,
			left: rect.left + win.pageXOffset
		};
	},

	// position() relates an element's margin box to its offset parent's padding box
	// This corresponds to the behavior of CSS absolute positioning
	position: function() {
		if ( !this[ 0 ] ) {
			return;
		}

		var offsetParent, offset, doc,
			elem = this[ 0 ],
			parentOffset = { top: 0, left: 0 };

		// position:fixed elements are offset from the viewport, which itself always has zero offset
		if ( jQuery.css( elem, "position" ) === "fixed" ) {

			// Assume position:fixed implies availability of getBoundingClientRect
			offset = elem.getBoundingClientRect();

		} else {
			offset = this.offset();

			// Account for the *real* offset parent, which can be the document or its root element
			// when a statically positioned element is identified
			doc = elem.ownerDocument;
			offsetParent = elem.offsetParent || doc.documentElement;
			while ( offsetParent &&
				( offsetParent === doc.body || offsetParent === doc.documentElement ) &&
				jQuery.css( offsetParent, "position" ) === "static" ) {

				offsetParent = offsetParent.parentNode;
			}
			if ( offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 ) {

				// Incorporate borders into its offset, since they are outside its content origin
				parentOffset = jQuery( offsetParent ).offset();
				parentOffset.top += jQuery.css( offsetParent, "borderTopWidth", true );
				parentOffset.left += jQuery.css( offsetParent, "borderLeftWidth", true );
			}
		}

		// Subtract parent offsets and element margins
		return {
			top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
			left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
		};
	},

	// This method will return documentElement in the following cases:
	// 1) For the element inside the iframe without offsetParent, this method will return
	//    documentElement of the parent window
	// 2) For the hidden or detached element
	// 3) For body or html element, i.e. in case of the html node - it will return itself
	//
	// but those exceptions were never presented as a real life use-cases
	// and might be considered as more preferable results.
	//
	// This logic, however, is not guaranteed and can change at any point in the future
	offsetParent: function() {
		return this.map( function() {
			var offsetParent = this.offsetParent;

			while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
				offsetParent = offsetParent.offsetParent;
			}

			return offsetParent || documentElement;
		} );
	}
} );

// Create scrollLeft and scrollTop methods
jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
	var top = "pageYOffset" === prop;

	jQuery.fn[ method ] = function( val ) {
		return access( this, function( elem, method, val ) {

			// Coalesce documents and windows
			var win;
			if ( isWindow( elem ) ) {
				win = elem;
			} else if ( elem.nodeType === 9 ) {
				win = elem.defaultView;
			}

			if ( val === undefined ) {
				return win ? win[ prop ] : elem[ method ];
			}

			if ( win ) {
				win.scrollTo(
					!top ? val : win.pageXOffset,
					top ? val : win.pageYOffset
				);

			} else {
				elem[ method ] = val;
			}
		}, method, val, arguments.length );
	};
} );

// Support: Safari <=7 - 9.1, Chrome <=37 - 49
// Add the top/left cssHooks using jQuery.fn.position
// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
// getComputedStyle returns percent when specified for top/left/bottom/right;
// rather than make the css module depend on the offset module, just check for it here
jQuery.each( [ "top", "left" ], function( i, prop ) {
	jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
		function( elem, computed ) {
			if ( computed ) {
				computed = curCSS( elem, prop );

				// If curCSS returns percentage, fallback to offset
				return rnumnonpx.test( computed ) ?
					jQuery( elem ).position()[ prop ] + "px" :
					computed;
			}
		}
	);
} );


// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
	jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name },
		function( defaultExtra, funcName ) {

		// Margin is only for outerHeight, outerWidth
		jQuery.fn[ funcName ] = function( margin, value ) {
			var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
				extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );

			return access( this, function( elem, type, value ) {
				var doc;

				if ( isWindow( elem ) ) {

					// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
					return funcName.indexOf( "outer" ) === 0 ?
						elem[ "inner" + name ] :
						elem.document.documentElement[ "client" + name ];
				}

				// Get document width or height
				if ( elem.nodeType === 9 ) {
					doc = elem.documentElement;

					// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
					// whichever is greatest
					return Math.max(
						elem.body[ "scroll" + name ], doc[ "scroll" + name ],
						elem.body[ "offset" + name ], doc[ "offset" + name ],
						doc[ "client" + name ]
					);
				}

				return value === undefined ?

					// Get width or height on the element, requesting but not forcing parseFloat
					jQuery.css( elem, type, extra ) :

					// Set width or height on the element
					jQuery.style( elem, type, value, extra );
			}, type, chainable ? margin : undefined, chainable );
		};
	} );
} );


jQuery.each( ( "blur focus focusin focusout resize scroll click dblclick " +
	"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
	"change select submit keydown keypress keyup contextmenu" ).split( " " ),
	function( i, name ) {

	// Handle event binding
	jQuery.fn[ name ] = function( data, fn ) {
		return arguments.length > 0 ?
			this.on( name, null, data, fn ) :
			this.trigger( name );
	};
} );

jQuery.fn.extend( {
	hover: function( fnOver, fnOut ) {
		return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
	}
} );




jQuery.fn.extend( {

	bind: function( types, data, fn ) {
		return this.on( types, null, data, fn );
	},
	unbind: function( types, fn ) {
		return this.off( types, null, fn );
	},

	delegate: function( selector, types, data, fn ) {
		return this.on( types, selector, data, fn );
	},
	undelegate: function( selector, types, fn ) {

		// ( namespace ) or ( selector, types [, fn] )
		return arguments.length === 1 ?
			this.off( selector, "**" ) :
			this.off( types, selector || "**", fn );
	}
} );

// Bind a function to a context, optionally partially applying any
// arguments.
// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
// However, it is not slated for removal any time soon
jQuery.proxy = function( fn, context ) {
	var tmp, args, proxy;

	if ( typeof context === "string" ) {
		tmp = fn[ context ];
		context = fn;
		fn = tmp;
	}

	// Quick check to determine if target is callable, in the spec
	// this throws a TypeError, but we will just return undefined.
	if ( !isFunction( fn ) ) {
		return undefined;
	}

	// Simulated bind
	args = slice.call( arguments, 2 );
	proxy = function() {
		return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
	};

	// Set the guid of unique handler to the same of original handler, so it can be removed
	proxy.guid = fn.guid = fn.guid || jQuery.guid++;

	return proxy;
};

jQuery.holdReady = function( hold ) {
	if ( hold ) {
		jQuery.readyWait++;
	} else {
		jQuery.ready( true );
	}
};
jQuery.isArray = Array.isArray;
jQuery.parseJSON = JSON.parse;
jQuery.nodeName = nodeName;
jQuery.isFunction = isFunction;
jQuery.isWindow = isWindow;
jQuery.camelCase = camelCase;
jQuery.type = toType;

jQuery.now = Date.now;

jQuery.isNumeric = function( obj ) {

	// As of jQuery 3.0, isNumeric is limited to
	// strings and numbers (primitives or objects)
	// that can be coerced to finite numbers (gh-2662)
	var type = jQuery.type( obj );
	return ( type === "number" || type === "string" ) &&

		// parseFloat NaNs numeric-cast false positives ("")
		// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
		// subtraction forces infinities to NaN
		!isNaN( obj - parseFloat( obj ) );
};




// Register as a named AMD module, since jQuery can be concatenated with other
// files that may use define, but not via a proper concatenation script that
// understands anonymous AMD modules. A named AMD is safest and most robust
// way to register. Lowercase jquery is used because AMD module names are
// derived from file names, and jQuery is normally delivered in a lowercase
// file name. Do this after creating the global so that if an AMD module wants
// to call noConflict to hide this version of jQuery, it will work.

// Note that for maximum portability, libraries that are not jQuery should
// declare themselves as anonymous modules, and avoid setting a global if an
// AMD loader is present. jQuery is a special case. For more information, see
// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

if ( typeof define === "function" && define.amd ) {
	define( "jquery", [], function() {
		return jQuery;
	} );
}




var

	// Map over jQuery in case of overwrite
	_jQuery = window.jQuery,

	// Map over the $ in case of overwrite
	_$ = window.$;

jQuery.noConflict = function( deep ) {
	if ( window.$ === jQuery ) {
		window.$ = _$;
	}

	if ( deep && window.jQuery === jQuery ) {
		window.jQuery = _jQuery;
	}

	return jQuery;
};

// Expose jQuery and $ identifiers, even in AMD
// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
// and CommonJS for browser emulators (#13566)
if ( !noGlobal ) {
	window.jQuery = window.$ = jQuery;
}




return jQuery;
} );

},{}],10:[function(require,module,exports){
/*! object-fit-polyfill - 2015-11-04 */!function(window,document){"use strict";var supports=function(){var div=document.createElement("div"),vendors="Khtml Ms O Moz Webkit".split(" "),len=vendors.length;return function(prop){if(prop in div.style)return!0;for(prop=prop.replace(/^[a-z]/,function(val){return val.toUpperCase()});len--;)if(vendors[len]+prop in div.style)return!0;return!1}}(),copyComputedStyle=function(from,to){var computed_style_object=!1;if(computed_style_object=from.currentStyle||document.defaultView.getComputedStyle(from,null),!computed_style_object)return null;var stylePropertyValid=function(name,value){return"undefined"!=typeof value&&"object"!=typeof value&&"function"!=typeof value&&value.length>0&&value!=parseInt(value)};for(var property in computed_style_object)stylePropertyValid(property,computed_style_object[property])&&(to.style[property]=computed_style_object[property])};if(supports("object-fit")===!1)for(var oDiv,sSource,oImages=document.querySelectorAll("[data-object-fit]"),nKey=0;nKey<oImages.length;nKey++){switch(oDiv=document.createElement("div"),sSource=oImages[nKey].getAttribute("data-src-retina")?oImages[nKey].getAttribute("data-src-retina"):oImages[nKey].getAttribute("data-src")?oImages[nKey].getAttribute("data-src"):oImages[nKey].src,copyComputedStyle(oImages[nKey],oDiv),oDiv.style.display="block",oDiv.style.backgroundImage="url("+sSource+")",oDiv.style.backgroundPosition="center center",oDiv.style.className=oImages[nKey].className,oDiv.style.backgroundRepeat="no-repeat",oImages[nKey].getAttribute("data-object-fit")){case"cover":oDiv.style.backgroundSize="cover";break;case"contain":oDiv.style.backgroundSize="contain";break;case"fill":oDiv.style.backgroundSize="100% 100%";break;case"none":oDiv.style.backgroundSize="auto"}oImages[nKey].parentNode.replaceChild(oDiv,oImages[nKey])}}(window,document);
},{}],11:[function(require,module,exports){
/*! Select2 4.0.3 | https://github.com/select2/select2/blob/master/LICENSE.md */

(function(){if(jQuery&&jQuery.fn&&jQuery.fn.select2&&jQuery.fn.select2.amd)var e=jQuery.fn.select2.amd;return e.define("select2/i18n/fr",[],function(){return{errorLoading:function(){return"Les résultats ne peuvent pas être chargés."},inputTooLong:function(e){var t=e.input.length-e.maximum,n="Supprimez "+t+" caractère";return t!==1&&(n+="s"),n},inputTooShort:function(e){var t=e.minimum-e.input.length,n="Saisissez "+t+" caractère";return t!==1&&(n+="s"),n},loadingMore:function(){return"Chargement de résultats supplémentaires…"},maximumSelected:function(e){var t="Vous pouvez seulement sélectionner "+e.maximum+" élément";return e.maximum!==1&&(t+="s"),t},noResults:function(){return"Aucun résultat trouvé"},searching:function(){return"Recherche en cours…"}}}),{define:e.define,require:e.require}})();
},{}],12:[function(require,module,exports){
/*!
 * Select2 4.0.3
 * https://select2.github.io
 *
 * Released under the MIT license
 * https://github.com/select2/select2/blob/master/LICENSE.md
 */
(function (factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['jquery'], factory);
  } else if (typeof exports === 'object') {
    // Node/CommonJS
    factory(require('jquery'));
  } else {
    // Browser globals
    factory(jQuery);
  }
}(function (jQuery) {
  // This is needed so we can catch the AMD loader configuration and use it
  // The inner file should be wrapped (by `banner.start.js`) in a function that
  // returns the AMD loader references.
  var S2 =
(function () {
  // Restore the Select2 AMD loader so it can be used
  // Needed mostly in the language files, where the loader is not inserted
  if (jQuery && jQuery.fn && jQuery.fn.select2 && jQuery.fn.select2.amd) {
    var S2 = jQuery.fn.select2.amd;
  }
var S2;(function () { if (!S2 || !S2.requirejs) {
if (!S2) { S2 = {}; } else { require = S2; }
/**
 * @license almond 0.3.1 Copyright (c) 2011-2014, The Dojo Foundation All Rights Reserved.
 * Available via the MIT or new BSD license.
 * see: http://github.com/jrburke/almond for details
 */
//Going sloppy to avoid 'use strict' string cost, but strict practices should
//be followed.
/*jslint sloppy: true */
/*global setTimeout: false */

var requirejs, require, define;
(function (undef) {
    var main, req, makeMap, handlers,
        defined = {},
        waiting = {},
        config = {},
        defining = {},
        hasOwn = Object.prototype.hasOwnProperty,
        aps = [].slice,
        jsSuffixRegExp = /\.js$/;

    function hasProp(obj, prop) {
        return hasOwn.call(obj, prop);
    }

    /**
     * Given a relative module name, like ./something, normalize it to
     * a real name that can be mapped to a path.
     * @param {String} name the relative name
     * @param {String} baseName a real name that the name arg is relative
     * to.
     * @returns {String} normalized name
     */
    function normalize(name, baseName) {
        var nameParts, nameSegment, mapValue, foundMap, lastIndex,
            foundI, foundStarMap, starI, i, j, part,
            baseParts = baseName && baseName.split("/"),
            map = config.map,
            starMap = (map && map['*']) || {};

        //Adjust any relative paths.
        if (name && name.charAt(0) === ".") {
            //If have a base name, try to normalize against it,
            //otherwise, assume it is a top-level require that will
            //be relative to baseUrl in the end.
            if (baseName) {
                name = name.split('/');
                lastIndex = name.length - 1;

                // Node .js allowance:
                if (config.nodeIdCompat && jsSuffixRegExp.test(name[lastIndex])) {
                    name[lastIndex] = name[lastIndex].replace(jsSuffixRegExp, '');
                }

                //Lop off the last part of baseParts, so that . matches the
                //"directory" and not name of the baseName's module. For instance,
                //baseName of "one/two/three", maps to "one/two/three.js", but we
                //want the directory, "one/two" for this normalization.
                name = baseParts.slice(0, baseParts.length - 1).concat(name);

                //start trimDots
                for (i = 0; i < name.length; i += 1) {
                    part = name[i];
                    if (part === ".") {
                        name.splice(i, 1);
                        i -= 1;
                    } else if (part === "..") {
                        if (i === 1 && (name[2] === '..' || name[0] === '..')) {
                            //End of the line. Keep at least one non-dot
                            //path segment at the front so it can be mapped
                            //correctly to disk. Otherwise, there is likely
                            //no path mapping for a path starting with '..'.
                            //This can still fail, but catches the most reasonable
                            //uses of ..
                            break;
                        } else if (i > 0) {
                            name.splice(i - 1, 2);
                            i -= 2;
                        }
                    }
                }
                //end trimDots

                name = name.join("/");
            } else if (name.indexOf('./') === 0) {
                // No baseName, so this is ID is resolved relative
                // to baseUrl, pull off the leading dot.
                name = name.substring(2);
            }
        }

        //Apply map config if available.
        if ((baseParts || starMap) && map) {
            nameParts = name.split('/');

            for (i = nameParts.length; i > 0; i -= 1) {
                nameSegment = nameParts.slice(0, i).join("/");

                if (baseParts) {
                    //Find the longest baseName segment match in the config.
                    //So, do joins on the biggest to smallest lengths of baseParts.
                    for (j = baseParts.length; j > 0; j -= 1) {
                        mapValue = map[baseParts.slice(0, j).join('/')];

                        //baseName segment has  config, find if it has one for
                        //this name.
                        if (mapValue) {
                            mapValue = mapValue[nameSegment];
                            if (mapValue) {
                                //Match, update name to the new value.
                                foundMap = mapValue;
                                foundI = i;
                                break;
                            }
                        }
                    }
                }

                if (foundMap) {
                    break;
                }

                //Check for a star map match, but just hold on to it,
                //if there is a shorter segment match later in a matching
                //config, then favor over this star map.
                if (!foundStarMap && starMap && starMap[nameSegment]) {
                    foundStarMap = starMap[nameSegment];
                    starI = i;
                }
            }

            if (!foundMap && foundStarMap) {
                foundMap = foundStarMap;
                foundI = starI;
            }

            if (foundMap) {
                nameParts.splice(0, foundI, foundMap);
                name = nameParts.join('/');
            }
        }

        return name;
    }

    function makeRequire(relName, forceSync) {
        return function () {
            //A version of a require function that passes a moduleName
            //value for items that may need to
            //look up paths relative to the moduleName
            var args = aps.call(arguments, 0);

            //If first arg is not require('string'), and there is only
            //one arg, it is the array form without a callback. Insert
            //a null so that the following concat is correct.
            if (typeof args[0] !== 'string' && args.length === 1) {
                args.push(null);
            }
            return req.apply(undef, args.concat([relName, forceSync]));
        };
    }

    function makeNormalize(relName) {
        return function (name) {
            return normalize(name, relName);
        };
    }

    function makeLoad(depName) {
        return function (value) {
            defined[depName] = value;
        };
    }

    function callDep(name) {
        if (hasProp(waiting, name)) {
            var args = waiting[name];
            delete waiting[name];
            defining[name] = true;
            main.apply(undef, args);
        }

        if (!hasProp(defined, name) && !hasProp(defining, name)) {
            throw new Error('No ' + name);
        }
        return defined[name];
    }

    //Turns a plugin!resource to [plugin, resource]
    //with the plugin being undefined if the name
    //did not have a plugin prefix.
    function splitPrefix(name) {
        var prefix,
            index = name ? name.indexOf('!') : -1;
        if (index > -1) {
            prefix = name.substring(0, index);
            name = name.substring(index + 1, name.length);
        }
        return [prefix, name];
    }

    /**
     * Makes a name map, normalizing the name, and using a plugin
     * for normalization if necessary. Grabs a ref to plugin
     * too, as an optimization.
     */
    makeMap = function (name, relName) {
        var plugin,
            parts = splitPrefix(name),
            prefix = parts[0];

        name = parts[1];

        if (prefix) {
            prefix = normalize(prefix, relName);
            plugin = callDep(prefix);
        }

        //Normalize according
        if (prefix) {
            if (plugin && plugin.normalize) {
                name = plugin.normalize(name, makeNormalize(relName));
            } else {
                name = normalize(name, relName);
            }
        } else {
            name = normalize(name, relName);
            parts = splitPrefix(name);
            prefix = parts[0];
            name = parts[1];
            if (prefix) {
                plugin = callDep(prefix);
            }
        }

        //Using ridiculous property names for space reasons
        return {
            f: prefix ? prefix + '!' + name : name, //fullName
            n: name,
            pr: prefix,
            p: plugin
        };
    };

    function makeConfig(name) {
        return function () {
            return (config && config.config && config.config[name]) || {};
        };
    }

    handlers = {
        require: function (name) {
            return makeRequire(name);
        },
        exports: function (name) {
            var e = defined[name];
            if (typeof e !== 'undefined') {
                return e;
            } else {
                return (defined[name] = {});
            }
        },
        module: function (name) {
            return {
                id: name,
                uri: '',
                exports: defined[name],
                config: makeConfig(name)
            };
        }
    };

    main = function (name, deps, callback, relName) {
        var cjsModule, depName, ret, map, i,
            args = [],
            callbackType = typeof callback,
            usingExports;

        //Use name if no relName
        relName = relName || name;

        //Call the callback to define the module, if necessary.
        if (callbackType === 'undefined' || callbackType === 'function') {
            //Pull out the defined dependencies and pass the ordered
            //values to the callback.
            //Default to [require, exports, module] if no deps
            deps = !deps.length && callback.length ? ['require', 'exports', 'module'] : deps;
            for (i = 0; i < deps.length; i += 1) {
                map = makeMap(deps[i], relName);
                depName = map.f;

                //Fast path CommonJS standard dependencies.
                if (depName === "require") {
                    args[i] = handlers.require(name);
                } else if (depName === "exports") {
                    //CommonJS module spec 1.1
                    args[i] = handlers.exports(name);
                    usingExports = true;
                } else if (depName === "module") {
                    //CommonJS module spec 1.1
                    cjsModule = args[i] = handlers.module(name);
                } else if (hasProp(defined, depName) ||
                           hasProp(waiting, depName) ||
                           hasProp(defining, depName)) {
                    args[i] = callDep(depName);
                } else if (map.p) {
                    map.p.load(map.n, makeRequire(relName, true), makeLoad(depName), {});
                    args[i] = defined[depName];
                } else {
                    throw new Error(name + ' missing ' + depName);
                }
            }

            ret = callback ? callback.apply(defined[name], args) : undefined;

            if (name) {
                //If setting exports via "module" is in play,
                //favor that over return value and exports. After that,
                //favor a non-undefined return value over exports use.
                if (cjsModule && cjsModule.exports !== undef &&
                        cjsModule.exports !== defined[name]) {
                    defined[name] = cjsModule.exports;
                } else if (ret !== undef || !usingExports) {
                    //Use the return value from the function.
                    defined[name] = ret;
                }
            }
        } else if (name) {
            //May just be an object definition for the module. Only
            //worry about defining if have a module name.
            defined[name] = callback;
        }
    };

    requirejs = require = req = function (deps, callback, relName, forceSync, alt) {
        if (typeof deps === "string") {
            if (handlers[deps]) {
                //callback in this case is really relName
                return handlers[deps](callback);
            }
            //Just return the module wanted. In this scenario, the
            //deps arg is the module name, and second arg (if passed)
            //is just the relName.
            //Normalize module name, if it contains . or ..
            return callDep(makeMap(deps, callback).f);
        } else if (!deps.splice) {
            //deps is a config object, not an array.
            config = deps;
            if (config.deps) {
                req(config.deps, config.callback);
            }
            if (!callback) {
                return;
            }

            if (callback.splice) {
                //callback is an array, which means it is a dependency list.
                //Adjust args if there are dependencies
                deps = callback;
                callback = relName;
                relName = null;
            } else {
                deps = undef;
            }
        }

        //Support require(['a'])
        callback = callback || function () {};

        //If relName is a function, it is an errback handler,
        //so remove it.
        if (typeof relName === 'function') {
            relName = forceSync;
            forceSync = alt;
        }

        //Simulate async callback;
        if (forceSync) {
            main(undef, deps, callback, relName);
        } else {
            //Using a non-zero value because of concern for what old browsers
            //do, and latest browsers "upgrade" to 4 if lower value is used:
            //http://www.whatwg.org/specs/web-apps/current-work/multipage/timers.html#dom-windowtimers-settimeout:
            //If want a value immediately, use require('id') instead -- something
            //that works in almond on the global level, but not guaranteed and
            //unlikely to work in other AMD implementations.
            setTimeout(function () {
                main(undef, deps, callback, relName);
            }, 4);
        }

        return req;
    };

    /**
     * Just drops the config on the floor, but returns req in case
     * the config return value is used.
     */
    req.config = function (cfg) {
        return req(cfg);
    };

    /**
     * Expose module registry for debugging and tooling
     */
    requirejs._defined = defined;

    define = function (name, deps, callback) {
        if (typeof name !== 'string') {
            throw new Error('See almond README: incorrect module build, no module name');
        }

        //This module may not have dependencies
        if (!deps.splice) {
            //deps is not an array, so probably means
            //an object literal or factory function for
            //the value. Adjust args.
            callback = deps;
            deps = [];
        }

        if (!hasProp(defined, name) && !hasProp(waiting, name)) {
            waiting[name] = [name, deps, callback];
        }
    };

    define.amd = {
        jQuery: true
    };
}());

S2.requirejs = requirejs;S2.require = require;S2.define = define;
}
}());
S2.define("almond", function(){});

/* global jQuery:false, $:false */
S2.define('jquery',[],function () {
  var _$ = jQuery || $;

  if (_$ == null && console && console.error) {
    console.error(
      'Select2: An instance of jQuery or a jQuery-compatible library was not ' +
      'found. Make sure that you are including jQuery before Select2 on your ' +
      'web page.'
    );
  }

  return _$;
});

S2.define('select2/utils',[
  'jquery'
], function ($) {
  var Utils = {};

  Utils.Extend = function (ChildClass, SuperClass) {
    var __hasProp = {}.hasOwnProperty;

    function BaseConstructor () {
      this.constructor = ChildClass;
    }

    for (var key in SuperClass) {
      if (__hasProp.call(SuperClass, key)) {
        ChildClass[key] = SuperClass[key];
      }
    }

    BaseConstructor.prototype = SuperClass.prototype;
    ChildClass.prototype = new BaseConstructor();
    ChildClass.__super__ = SuperClass.prototype;

    return ChildClass;
  };

  function getMethods (theClass) {
    var proto = theClass.prototype;

    var methods = [];

    for (var methodName in proto) {
      var m = proto[methodName];

      if (typeof m !== 'function') {
        continue;
      }

      if (methodName === 'constructor') {
        continue;
      }

      methods.push(methodName);
    }

    return methods;
  }

  Utils.Decorate = function (SuperClass, DecoratorClass) {
    var decoratedMethods = getMethods(DecoratorClass);
    var superMethods = getMethods(SuperClass);

    function DecoratedClass () {
      var unshift = Array.prototype.unshift;

      var argCount = DecoratorClass.prototype.constructor.length;

      var calledConstructor = SuperClass.prototype.constructor;

      if (argCount > 0) {
        unshift.call(arguments, SuperClass.prototype.constructor);

        calledConstructor = DecoratorClass.prototype.constructor;
      }

      calledConstructor.apply(this, arguments);
    }

    DecoratorClass.displayName = SuperClass.displayName;

    function ctr () {
      this.constructor = DecoratedClass;
    }

    DecoratedClass.prototype = new ctr();

    for (var m = 0; m < superMethods.length; m++) {
        var superMethod = superMethods[m];

        DecoratedClass.prototype[superMethod] =
          SuperClass.prototype[superMethod];
    }

    var calledMethod = function (methodName) {
      // Stub out the original method if it's not decorating an actual method
      var originalMethod = function () {};

      if (methodName in DecoratedClass.prototype) {
        originalMethod = DecoratedClass.prototype[methodName];
      }

      var decoratedMethod = DecoratorClass.prototype[methodName];

      return function () {
        var unshift = Array.prototype.unshift;

        unshift.call(arguments, originalMethod);

        return decoratedMethod.apply(this, arguments);
      };
    };

    for (var d = 0; d < decoratedMethods.length; d++) {
      var decoratedMethod = decoratedMethods[d];

      DecoratedClass.prototype[decoratedMethod] = calledMethod(decoratedMethod);
    }

    return DecoratedClass;
  };

  var Observable = function () {
    this.listeners = {};
  };

  Observable.prototype.on = function (event, callback) {
    this.listeners = this.listeners || {};

    if (event in this.listeners) {
      this.listeners[event].push(callback);
    } else {
      this.listeners[event] = [callback];
    }
  };

  Observable.prototype.trigger = function (event) {
    var slice = Array.prototype.slice;
    var params = slice.call(arguments, 1);

    this.listeners = this.listeners || {};

    // Params should always come in as an array
    if (params == null) {
      params = [];
    }

    // If there are no arguments to the event, use a temporary object
    if (params.length === 0) {
      params.push({});
    }

    // Set the `_type` of the first object to the event
    params[0]._type = event;

    if (event in this.listeners) {
      this.invoke(this.listeners[event], slice.call(arguments, 1));
    }

    if ('*' in this.listeners) {
      this.invoke(this.listeners['*'], arguments);
    }
  };

  Observable.prototype.invoke = function (listeners, params) {
    for (var i = 0, len = listeners.length; i < len; i++) {
      listeners[i].apply(this, params);
    }
  };

  Utils.Observable = Observable;

  Utils.generateChars = function (length) {
    var chars = '';

    for (var i = 0; i < length; i++) {
      var randomChar = Math.floor(Math.random() * 36);
      chars += randomChar.toString(36);
    }

    return chars;
  };

  Utils.bind = function (func, context) {
    return function () {
      func.apply(context, arguments);
    };
  };

  Utils._convertData = function (data) {
    for (var originalKey in data) {
      var keys = originalKey.split('-');

      var dataLevel = data;

      if (keys.length === 1) {
        continue;
      }

      for (var k = 0; k < keys.length; k++) {
        var key = keys[k];

        // Lowercase the first letter
        // By default, dash-separated becomes camelCase
        key = key.substring(0, 1).toLowerCase() + key.substring(1);

        if (!(key in dataLevel)) {
          dataLevel[key] = {};
        }

        if (k == keys.length - 1) {
          dataLevel[key] = data[originalKey];
        }

        dataLevel = dataLevel[key];
      }

      delete data[originalKey];
    }

    return data;
  };

  Utils.hasScroll = function (index, el) {
    // Adapted from the function created by @ShadowScripter
    // and adapted by @BillBarry on the Stack Exchange Code Review website.
    // The original code can be found at
    // http://codereview.stackexchange.com/q/13338
    // and was designed to be used with the Sizzle selector engine.

    var $el = $(el);
    var overflowX = el.style.overflowX;
    var overflowY = el.style.overflowY;

    //Check both x and y declarations
    if (overflowX === overflowY &&
        (overflowY === 'hidden' || overflowY === 'visible')) {
      return false;
    }

    if (overflowX === 'scroll' || overflowY === 'scroll') {
      return true;
    }

    return ($el.innerHeight() < el.scrollHeight ||
      $el.innerWidth() < el.scrollWidth);
  };

  Utils.escapeMarkup = function (markup) {
    var replaceMap = {
      '\\': '&#92;',
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      '\'': '&#39;',
      '/': '&#47;'
    };

    // Do not try to escape the markup if it's not a string
    if (typeof markup !== 'string') {
      return markup;
    }

    return String(markup).replace(/[&<>"'\/\\]/g, function (match) {
      return replaceMap[match];
    });
  };

  // Append an array of jQuery nodes to a given element.
  Utils.appendMany = function ($element, $nodes) {
    // jQuery 1.7.x does not support $.fn.append() with an array
    // Fall back to a jQuery object collection using $.fn.add()
    if ($.fn.jquery.substr(0, 3) === '1.7') {
      var $jqNodes = $();

      $.map($nodes, function (node) {
        $jqNodes = $jqNodes.add(node);
      });

      $nodes = $jqNodes;
    }

    $element.append($nodes);
  };

  return Utils;
});

S2.define('select2/results',[
  'jquery',
  './utils'
], function ($, Utils) {
  function Results ($element, options, dataAdapter) {
    this.$element = $element;
    this.data = dataAdapter;
    this.options = options;

    Results.__super__.constructor.call(this);
  }

  Utils.Extend(Results, Utils.Observable);

  Results.prototype.render = function () {
    var $results = $(
      '<ul class="select2-results__options" role="tree"></ul>'
    );

    if (this.options.get('multiple')) {
      $results.attr('aria-multiselectable', 'true');
    }

    this.$results = $results;

    return $results;
  };

  Results.prototype.clear = function () {
    this.$results.empty();
  };

  Results.prototype.displayMessage = function (params) {
    var escapeMarkup = this.options.get('escapeMarkup');

    this.clear();
    this.hideLoading();

    var $message = $(
      '<li role="treeitem" aria-live="assertive"' +
      ' class="select2-results__option"></li>'
    );

    var message = this.options.get('translations').get(params.message);

    $message.append(
      escapeMarkup(
        message(params.args)
      )
    );

    $message[0].className += ' select2-results__message';

    this.$results.append($message);
  };

  Results.prototype.hideMessages = function () {
    this.$results.find('.select2-results__message').remove();
  };

  Results.prototype.append = function (data) {
    this.hideLoading();

    var $options = [];

    if (data.results == null || data.results.length === 0) {
      if (this.$results.children().length === 0) {
        this.trigger('results:message', {
          message: 'noResults'
        });
      }

      return;
    }

    data.results = this.sort(data.results);

    for (var d = 0; d < data.results.length; d++) {
      var item = data.results[d];

      var $option = this.option(item);

      $options.push($option);
    }

    this.$results.append($options);
  };

  Results.prototype.position = function ($results, $dropdown) {
    var $resultsContainer = $dropdown.find('.select2-results');
    $resultsContainer.append($results);
  };

  Results.prototype.sort = function (data) {
    var sorter = this.options.get('sorter');

    return sorter(data);
  };

  Results.prototype.highlightFirstItem = function () {
    var $options = this.$results
      .find('.select2-results__option[aria-selected]');

    var $selected = $options.filter('[aria-selected=true]');

    // Check if there are any selected options
    if ($selected.length > 0) {
      // If there are selected options, highlight the first
      $selected.first().trigger('mouseenter');
    } else {
      // If there are no selected options, highlight the first option
      // in the dropdown
      $options.first().trigger('mouseenter');
    }

    this.ensureHighlightVisible();
  };

  Results.prototype.setClasses = function () {
    var self = this;

    this.data.current(function (selected) {
      var selectedIds = $.map(selected, function (s) {
        return s.id.toString();
      });

      var $options = self.$results
        .find('.select2-results__option[aria-selected]');

      $options.each(function () {
        var $option = $(this);

        var item = $.data(this, 'data');

        // id needs to be converted to a string when comparing
        var id = '' + item.id;

        if ((item.element != null && item.element.selected) ||
            (item.element == null && $.inArray(id, selectedIds) > -1)) {
          $option.attr('aria-selected', 'true');
        } else {
          $option.attr('aria-selected', 'false');
        }
      });

    });
  };

  Results.prototype.showLoading = function (params) {
    this.hideLoading();

    var loadingMore = this.options.get('translations').get('searching');

    var loading = {
      disabled: true,
      loading: true,
      text: loadingMore(params)
    };
    var $loading = this.option(loading);
    $loading.className += ' loading-results';

    this.$results.prepend($loading);
  };

  Results.prototype.hideLoading = function () {
    this.$results.find('.loading-results').remove();
  };

  Results.prototype.option = function (data) {
    var option = document.createElement('li');
    option.className = 'select2-results__option';

    var attrs = {
      'role': 'treeitem',
      'aria-selected': 'false'
    };

    if (data.disabled) {
      delete attrs['aria-selected'];
      attrs['aria-disabled'] = 'true';
    }

    if (data.id == null) {
      delete attrs['aria-selected'];
    }

    if (data._resultId != null) {
      option.id = data._resultId;
    }

    if (data.title) {
      option.title = data.title;
    }

    if (data.children) {
      attrs.role = 'group';
      attrs['aria-label'] = data.text;
      delete attrs['aria-selected'];
    }

    for (var attr in attrs) {
      var val = attrs[attr];

      option.setAttribute(attr, val);
    }

    if (data.children) {
      var $option = $(option);

      var label = document.createElement('strong');
      label.className = 'select2-results__group';

      var $label = $(label);
      this.template(data, label);

      var $children = [];

      for (var c = 0; c < data.children.length; c++) {
        var child = data.children[c];

        var $child = this.option(child);

        $children.push($child);
      }

      var $childrenContainer = $('<ul></ul>', {
        'class': 'select2-results__options select2-results__options--nested'
      });

      $childrenContainer.append($children);

      $option.append(label);
      $option.append($childrenContainer);
    } else {
      this.template(data, option);
    }

    $.data(option, 'data', data);

    return option;
  };

  Results.prototype.bind = function (container, $container) {
    var self = this;

    var id = container.id + '-results';

    this.$results.attr('id', id);

    container.on('results:all', function (params) {
      self.clear();
      self.append(params.data);

      if (container.isOpen()) {
        self.setClasses();
        self.highlightFirstItem();
      }
    });

    container.on('results:append', function (params) {
      self.append(params.data);

      if (container.isOpen()) {
        self.setClasses();
      }
    });

    container.on('query', function (params) {
      self.hideMessages();
      self.showLoading(params);
    });

    container.on('select', function () {
      if (!container.isOpen()) {
        return;
      }

      self.setClasses();
      self.highlightFirstItem();
    });

    container.on('unselect', function () {
      if (!container.isOpen()) {
        return;
      }

      self.setClasses();
      self.highlightFirstItem();
    });

    container.on('open', function () {
      // When the dropdown is open, aria-expended="true"
      self.$results.attr('aria-expanded', 'true');
      self.$results.attr('aria-hidden', 'false');

      self.setClasses();
      self.ensureHighlightVisible();
    });

    container.on('close', function () {
      // When the dropdown is closed, aria-expended="false"
      self.$results.attr('aria-expanded', 'false');
      self.$results.attr('aria-hidden', 'true');
      self.$results.removeAttr('aria-activedescendant');
    });

    container.on('results:toggle', function () {
      var $highlighted = self.getHighlightedResults();

      if ($highlighted.length === 0) {
        return;
      }

      $highlighted.trigger('mouseup');
    });

    container.on('results:select', function () {
      var $highlighted = self.getHighlightedResults();

      if ($highlighted.length === 0) {
        return;
      }

      var data = $highlighted.data('data');

      if ($highlighted.attr('aria-selected') == 'true') {
        self.trigger('close', {});
      } else {
        self.trigger('select', {
          data: data
        });
      }
    });

    container.on('results:previous', function () {
      var $highlighted = self.getHighlightedResults();

      var $options = self.$results.find('[aria-selected]');

      var currentIndex = $options.index($highlighted);

      // If we are already at te top, don't move further
      if (currentIndex === 0) {
        return;
      }

      var nextIndex = currentIndex - 1;

      // If none are highlighted, highlight the first
      if ($highlighted.length === 0) {
        nextIndex = 0;
      }

      var $next = $options.eq(nextIndex);

      $next.trigger('mouseenter');

      var currentOffset = self.$results.offset().top;
      var nextTop = $next.offset().top;
      var nextOffset = self.$results.scrollTop() + (nextTop - currentOffset);

      if (nextIndex === 0) {
        self.$results.scrollTop(0);
      } else if (nextTop - currentOffset < 0) {
        self.$results.scrollTop(nextOffset);
      }
    });

    container.on('results:next', function () {
      var $highlighted = self.getHighlightedResults();

      var $options = self.$results.find('[aria-selected]');

      var currentIndex = $options.index($highlighted);

      var nextIndex = currentIndex + 1;

      // If we are at the last option, stay there
      if (nextIndex >= $options.length) {
        return;
      }

      var $next = $options.eq(nextIndex);

      $next.trigger('mouseenter');

      var currentOffset = self.$results.offset().top +
        self.$results.outerHeight(false);
      var nextBottom = $next.offset().top + $next.outerHeight(false);
      var nextOffset = self.$results.scrollTop() + nextBottom - currentOffset;

      if (nextIndex === 0) {
        self.$results.scrollTop(0);
      } else if (nextBottom > currentOffset) {
        self.$results.scrollTop(nextOffset);
      }
    });

    container.on('results:focus', function (params) {
      params.element.addClass('select2-results__option--highlighted');
    });

    container.on('results:message', function (params) {
      self.displayMessage(params);
    });

    if ($.fn.mousewheel) {
      this.$results.on('mousewheel', function (e) {
        var top = self.$results.scrollTop();

        var bottom = self.$results.get(0).scrollHeight - top + e.deltaY;

        var isAtTop = e.deltaY > 0 && top - e.deltaY <= 0;
        var isAtBottom = e.deltaY < 0 && bottom <= self.$results.height();

        if (isAtTop) {
          self.$results.scrollTop(0);

          e.preventDefault();
          e.stopPropagation();
        } else if (isAtBottom) {
          self.$results.scrollTop(
            self.$results.get(0).scrollHeight - self.$results.height()
          );

          e.preventDefault();
          e.stopPropagation();
        }
      });
    }

    this.$results.on('mouseup', '.select2-results__option[aria-selected]',
      function (evt) {
      var $this = $(this);

      var data = $this.data('data');

      if ($this.attr('aria-selected') === 'true') {
        if (self.options.get('multiple')) {
          self.trigger('unselect', {
            originalEvent: evt,
            data: data
          });
        } else {
          self.trigger('close', {});
        }

        return;
      }

      self.trigger('select', {
        originalEvent: evt,
        data: data
      });
    });

    this.$results.on('mouseenter', '.select2-results__option[aria-selected]',
      function (evt) {
      var data = $(this).data('data');

      self.getHighlightedResults()
          .removeClass('select2-results__option--highlighted');

      self.trigger('results:focus', {
        data: data,
        element: $(this)
      });
    });
  };

  Results.prototype.getHighlightedResults = function () {
    var $highlighted = this.$results
    .find('.select2-results__option--highlighted');

    return $highlighted;
  };

  Results.prototype.destroy = function () {
    this.$results.remove();
  };

  Results.prototype.ensureHighlightVisible = function () {
    var $highlighted = this.getHighlightedResults();

    if ($highlighted.length === 0) {
      return;
    }

    var $options = this.$results.find('[aria-selected]');

    var currentIndex = $options.index($highlighted);

    var currentOffset = this.$results.offset().top;
    var nextTop = $highlighted.offset().top;
    var nextOffset = this.$results.scrollTop() + (nextTop - currentOffset);

    var offsetDelta = nextTop - currentOffset;
    nextOffset -= $highlighted.outerHeight(false) * 2;

    if (currentIndex <= 2) {
      this.$results.scrollTop(0);
    } else if (offsetDelta > this.$results.outerHeight() || offsetDelta < 0) {
      this.$results.scrollTop(nextOffset);
    }
  };

  Results.prototype.template = function (result, container) {
    var template = this.options.get('templateResult');
    var escapeMarkup = this.options.get('escapeMarkup');

    var content = template(result, container);

    if (content == null) {
      container.style.display = 'none';
    } else if (typeof content === 'string') {
      container.innerHTML = escapeMarkup(content);
    } else {
      $(container).append(content);
    }
  };

  return Results;
});

S2.define('select2/keys',[

], function () {
  var KEYS = {
    BACKSPACE: 8,
    TAB: 9,
    ENTER: 13,
    SHIFT: 16,
    CTRL: 17,
    ALT: 18,
    ESC: 27,
    SPACE: 32,
    PAGE_UP: 33,
    PAGE_DOWN: 34,
    END: 35,
    HOME: 36,
    LEFT: 37,
    UP: 38,
    RIGHT: 39,
    DOWN: 40,
    DELETE: 46
  };

  return KEYS;
});

S2.define('select2/selection/base',[
  'jquery',
  '../utils',
  '../keys'
], function ($, Utils, KEYS) {
  function BaseSelection ($element, options) {
    this.$element = $element;
    this.options = options;

    BaseSelection.__super__.constructor.call(this);
  }

  Utils.Extend(BaseSelection, Utils.Observable);

  BaseSelection.prototype.render = function () {
    var $selection = $(
      '<span class="select2-selection" role="combobox" ' +
      ' aria-haspopup="true" aria-expanded="false">' +
      '</span>'
    );

    this._tabindex = 0;

    if (this.$element.data('old-tabindex') != null) {
      this._tabindex = this.$element.data('old-tabindex');
    } else if (this.$element.attr('tabindex') != null) {
      this._tabindex = this.$element.attr('tabindex');
    }

    $selection.attr('title', this.$element.attr('title'));
    $selection.attr('tabindex', this._tabindex);

    this.$selection = $selection;

    return $selection;
  };

  BaseSelection.prototype.bind = function (container, $container) {
    var self = this;

    var id = container.id + '-container';
    var resultsId = container.id + '-results';

    this.container = container;

    this.$selection.on('focus', function (evt) {
      self.trigger('focus', evt);
    });

    this.$selection.on('blur', function (evt) {
      self._handleBlur(evt);
    });

    this.$selection.on('keydown', function (evt) {
      self.trigger('keypress', evt);

      if (evt.which === KEYS.SPACE) {
        evt.preventDefault();
      }
    });

    container.on('results:focus', function (params) {
      self.$selection.attr('aria-activedescendant', params.data._resultId);
    });

    container.on('selection:update', function (params) {
      self.update(params.data);
    });

    container.on('open', function () {
      // When the dropdown is open, aria-expanded="true"
      self.$selection.attr('aria-expanded', 'true');
      self.$selection.attr('aria-owns', resultsId);

      self._attachCloseHandler(container);
    });

    container.on('close', function () {
      // When the dropdown is closed, aria-expanded="false"
      self.$selection.attr('aria-expanded', 'false');
      self.$selection.removeAttr('aria-activedescendant');
      self.$selection.removeAttr('aria-owns');

      self.$selection.focus();

      self._detachCloseHandler(container);
    });

    container.on('enable', function () {
      self.$selection.attr('tabindex', self._tabindex);
    });

    container.on('disable', function () {
      self.$selection.attr('tabindex', '-1');
    });
  };

  BaseSelection.prototype._handleBlur = function (evt) {
    var self = this;

    // This needs to be delayed as the active element is the body when the tab
    // key is pressed, possibly along with others.
    window.setTimeout(function () {
      // Don't trigger `blur` if the focus is still in the selection
      if (
        (document.activeElement == self.$selection[0]) ||
        ($.contains(self.$selection[0], document.activeElement))
      ) {
        return;
      }

      self.trigger('blur', evt);
    }, 1);
  };

  BaseSelection.prototype._attachCloseHandler = function (container) {
    var self = this;

    $(document.body).on('mousedown.select2.' + container.id, function (e) {
      var $target = $(e.target);

      var $select = $target.closest('.select2');

      var $all = $('.select2.select2-container--open');

      $all.each(function () {
        var $this = $(this);

        if (this == $select[0]) {
          return;
        }

        var $element = $this.data('element');

        $element.select2('close');
      });
    });
  };

  BaseSelection.prototype._detachCloseHandler = function (container) {
    $(document.body).off('mousedown.select2.' + container.id);
  };

  BaseSelection.prototype.position = function ($selection, $container) {
    var $selectionContainer = $container.find('.selection');
    $selectionContainer.append($selection);
  };

  BaseSelection.prototype.destroy = function () {
    this._detachCloseHandler(this.container);
  };

  BaseSelection.prototype.update = function (data) {
    throw new Error('The `update` method must be defined in child classes.');
  };

  return BaseSelection;
});

S2.define('select2/selection/single',[
  'jquery',
  './base',
  '../utils',
  '../keys'
], function ($, BaseSelection, Utils, KEYS) {
  function SingleSelection () {
    SingleSelection.__super__.constructor.apply(this, arguments);
  }

  Utils.Extend(SingleSelection, BaseSelection);

  SingleSelection.prototype.render = function () {
    var $selection = SingleSelection.__super__.render.call(this);

    $selection.addClass('select2-selection--single');

    $selection.html(
      '<span class="select2-selection__rendered"></span>' +
      '<span class="select2-selection__arrow" role="presentation">' +
        '<b role="presentation"></b>' +
      '</span>'
    );

    return $selection;
  };

  SingleSelection.prototype.bind = function (container, $container) {
    var self = this;

    SingleSelection.__super__.bind.apply(this, arguments);

    var id = container.id + '-container';

    this.$selection.find('.select2-selection__rendered').attr('id', id);
    this.$selection.attr('aria-labelledby', id);

    this.$selection.on('mousedown', function (evt) {
      // Only respond to left clicks
      if (evt.which !== 1) {
        return;
      }

      self.trigger('toggle', {
        originalEvent: evt
      });
    });

    this.$selection.on('focus', function (evt) {
      // User focuses on the container
    });

    this.$selection.on('blur', function (evt) {
      // User exits the container
    });

    container.on('focus', function (evt) {
      if (!container.isOpen()) {
        self.$selection.focus();
      }
    });

    container.on('selection:update', function (params) {
      self.update(params.data);
    });
  };

  SingleSelection.prototype.clear = function () {
    this.$selection.find('.select2-selection__rendered').empty();
  };

  SingleSelection.prototype.display = function (data, container) {
    var template = this.options.get('templateSelection');
    var escapeMarkup = this.options.get('escapeMarkup');

    return escapeMarkup(template(data, container));
  };

  SingleSelection.prototype.selectionContainer = function () {
    return $('<span></span>');
  };

  SingleSelection.prototype.update = function (data) {
    if (data.length === 0) {
      this.clear();
      return;
    }

    var selection = data[0];

    var $rendered = this.$selection.find('.select2-selection__rendered');
    var formatted = this.display(selection, $rendered);

    $rendered.empty().append(formatted);
    $rendered.prop('title', selection.title || selection.text);
  };

  return SingleSelection;
});

S2.define('select2/selection/multiple',[
  'jquery',
  './base',
  '../utils'
], function ($, BaseSelection, Utils) {
  function MultipleSelection ($element, options) {
    MultipleSelection.__super__.constructor.apply(this, arguments);
  }

  Utils.Extend(MultipleSelection, BaseSelection);

  MultipleSelection.prototype.render = function () {
    var $selection = MultipleSelection.__super__.render.call(this);

    $selection.addClass('select2-selection--multiple');

    $selection.html(
      '<ul class="select2-selection__rendered"></ul>'
    );

    return $selection;
  };

  MultipleSelection.prototype.bind = function (container, $container) {
    var self = this;

    MultipleSelection.__super__.bind.apply(this, arguments);

    this.$selection.on('click', function (evt) {
      self.trigger('toggle', {
        originalEvent: evt
      });
    });

    this.$selection.on(
      'click',
      '.select2-selection__choice__remove',
      function (evt) {
        // Ignore the event if it is disabled
        if (self.options.get('disabled')) {
          return;
        }

        var $remove = $(this);
        var $selection = $remove.parent();

        var data = $selection.data('data');

        self.trigger('unselect', {
          originalEvent: evt,
          data: data
        });
      }
    );
  };

  MultipleSelection.prototype.clear = function () {
    this.$selection.find('.select2-selection__rendered').empty();
  };

  MultipleSelection.prototype.display = function (data, container) {
    var template = this.options.get('templateSelection');
    var escapeMarkup = this.options.get('escapeMarkup');

    return escapeMarkup(template(data, container));
  };

  MultipleSelection.prototype.selectionContainer = function () {
    var $container = $(
      '<li class="select2-selection__choice">' +
        '<span class="select2-selection__choice__remove" role="presentation">' +
          '&times;' +
        '</span>' +
      '</li>'
    );

    return $container;
  };

  MultipleSelection.prototype.update = function (data) {
    this.clear();

    if (data.length === 0) {
      return;
    }

    var $selections = [];

    for (var d = 0; d < data.length; d++) {
      var selection = data[d];

      var $selection = this.selectionContainer();
      var formatted = this.display(selection, $selection);

      $selection.append(formatted);
      $selection.prop('title', selection.title || selection.text);

      $selection.data('data', selection);

      $selections.push($selection);
    }

    var $rendered = this.$selection.find('.select2-selection__rendered');

    Utils.appendMany($rendered, $selections);
  };

  return MultipleSelection;
});

S2.define('select2/selection/placeholder',[
  '../utils'
], function (Utils) {
  function Placeholder (decorated, $element, options) {
    this.placeholder = this.normalizePlaceholder(options.get('placeholder'));

    decorated.call(this, $element, options);
  }

  Placeholder.prototype.normalizePlaceholder = function (_, placeholder) {
    if (typeof placeholder === 'string') {
      placeholder = {
        id: '',
        text: placeholder
      };
    }

    return placeholder;
  };

  Placeholder.prototype.createPlaceholder = function (decorated, placeholder) {
    var $placeholder = this.selectionContainer();

    $placeholder.html(this.display(placeholder));
    $placeholder.addClass('select2-selection__placeholder')
                .removeClass('select2-selection__choice');

    return $placeholder;
  };

  Placeholder.prototype.update = function (decorated, data) {
    var singlePlaceholder = (
      data.length == 1 && data[0].id != this.placeholder.id
    );
    var multipleSelections = data.length > 1;

    if (multipleSelections || singlePlaceholder) {
      return decorated.call(this, data);
    }

    this.clear();

    var $placeholder = this.createPlaceholder(this.placeholder);

    this.$selection.find('.select2-selection__rendered').append($placeholder);
  };

  return Placeholder;
});

S2.define('select2/selection/allowClear',[
  'jquery',
  '../keys'
], function ($, KEYS) {
  function AllowClear () { }

  AllowClear.prototype.bind = function (decorated, container, $container) {
    var self = this;

    decorated.call(this, container, $container);

    if (this.placeholder == null) {
      if (this.options.get('debug') && window.console && console.error) {
        console.error(
          'Select2: The `allowClear` option should be used in combination ' +
          'with the `placeholder` option.'
        );
      }
    }

    this.$selection.on('mousedown', '.select2-selection__clear',
      function (evt) {
        self._handleClear(evt);
    });

    container.on('keypress', function (evt) {
      self._handleKeyboardClear(evt, container);
    });
  };

  AllowClear.prototype._handleClear = function (_, evt) {
    // Ignore the event if it is disabled
    if (this.options.get('disabled')) {
      return;
    }

    var $clear = this.$selection.find('.select2-selection__clear');

    // Ignore the event if nothing has been selected
    if ($clear.length === 0) {
      return;
    }

    evt.stopPropagation();

    var data = $clear.data('data');

    for (var d = 0; d < data.length; d++) {
      var unselectData = {
        data: data[d]
      };

      // Trigger the `unselect` event, so people can prevent it from being
      // cleared.
      this.trigger('unselect', unselectData);

      // If the event was prevented, don't clear it out.
      if (unselectData.prevented) {
        return;
      }
    }

    this.$element.val(this.placeholder.id).trigger('change');

    this.trigger('toggle', {});
  };

  AllowClear.prototype._handleKeyboardClear = function (_, evt, container) {
    if (container.isOpen()) {
      return;
    }

    if (evt.which == KEYS.DELETE || evt.which == KEYS.BACKSPACE) {
      this._handleClear(evt);
    }
  };

  AllowClear.prototype.update = function (decorated, data) {
    decorated.call(this, data);

    if (this.$selection.find('.select2-selection__placeholder').length > 0 ||
        data.length === 0) {
      return;
    }

    var $remove = $(
      '<span class="select2-selection__clear">' +
        '&times;' +
      '</span>'
    );
    $remove.data('data', data);

    this.$selection.find('.select2-selection__rendered').prepend($remove);
  };

  return AllowClear;
});

S2.define('select2/selection/search',[
  'jquery',
  '../utils',
  '../keys'
], function ($, Utils, KEYS) {
  function Search (decorated, $element, options) {
    decorated.call(this, $element, options);
  }

  Search.prototype.render = function (decorated) {
    var $search = $(
      '<li class="select2-search select2-search--inline">' +
        '<input class="select2-search__field" type="search" tabindex="-1"' +
        ' autocomplete="off" autocorrect="off" autocapitalize="off"' +
        ' spellcheck="false" role="textbox" aria-autocomplete="list" />' +
      '</li>'
    );

    this.$searchContainer = $search;
    this.$search = $search.find('input');

    var $rendered = decorated.call(this);

    this._transferTabIndex();

    return $rendered;
  };

  Search.prototype.bind = function (decorated, container, $container) {
    var self = this;

    decorated.call(this, container, $container);

    container.on('open', function () {
      self.$search.trigger('focus');
    });

    container.on('close', function () {
      self.$search.val('');
      self.$search.removeAttr('aria-activedescendant');
      self.$search.trigger('focus');
    });

    container.on('enable', function () {
      self.$search.prop('disabled', false);

      self._transferTabIndex();
    });

    container.on('disable', function () {
      self.$search.prop('disabled', true);
    });

    container.on('focus', function (evt) {
      self.$search.trigger('focus');
    });

    container.on('results:focus', function (params) {
      self.$search.attr('aria-activedescendant', params.id);
    });

    this.$selection.on('focusin', '.select2-search--inline', function (evt) {
      self.trigger('focus', evt);
    });

    this.$selection.on('focusout', '.select2-search--inline', function (evt) {
      self._handleBlur(evt);
    });

    this.$selection.on('keydown', '.select2-search--inline', function (evt) {
      evt.stopPropagation();

      self.trigger('keypress', evt);

      self._keyUpPrevented = evt.isDefaultPrevented();

      var key = evt.which;

      if (key === KEYS.BACKSPACE && self.$search.val() === '') {
        var $previousChoice = self.$searchContainer
          .prev('.select2-selection__choice');

        if ($previousChoice.length > 0) {
          var item = $previousChoice.data('data');

          self.searchRemoveChoice(item);

          evt.preventDefault();
        }
      }
    });

    // Try to detect the IE version should the `documentMode` property that
    // is stored on the document. This is only implemented in IE and is
    // slightly cleaner than doing a user agent check.
    // This property is not available in Edge, but Edge also doesn't have
    // this bug.
    var msie = document.documentMode;
    var disableInputEvents = msie && msie <= 11;

    // Workaround for browsers which do not support the `input` event
    // This will prevent double-triggering of events for browsers which support
    // both the `keyup` and `input` events.
    this.$selection.on(
      'input.searchcheck',
      '.select2-search--inline',
      function (evt) {
        // IE will trigger the `input` event when a placeholder is used on a
        // search box. To get around this issue, we are forced to ignore all
        // `input` events in IE and keep using `keyup`.
        if (disableInputEvents) {
          self.$selection.off('input.search input.searchcheck');
          return;
        }

        // Unbind the duplicated `keyup` event
        self.$selection.off('keyup.search');
      }
    );

    this.$selection.on(
      'keyup.search input.search',
      '.select2-search--inline',
      function (evt) {
        // IE will trigger the `input` event when a placeholder is used on a
        // search box. To get around this issue, we are forced to ignore all
        // `input` events in IE and keep using `keyup`.
        if (disableInputEvents && evt.type === 'input') {
          self.$selection.off('input.search input.searchcheck');
          return;
        }

        var key = evt.which;

        // We can freely ignore events from modifier keys
        if (key == KEYS.SHIFT || key == KEYS.CTRL || key == KEYS.ALT) {
          return;
        }

        // Tabbing will be handled during the `keydown` phase
        if (key == KEYS.TAB) {
          return;
        }

        self.handleSearch(evt);
      }
    );
  };

  /**
   * This method will transfer the tabindex attribute from the rendered
   * selection to the search box. This allows for the search box to be used as
   * the primary focus instead of the selection container.
   *
   * @private
   */
  Search.prototype._transferTabIndex = function (decorated) {
    this.$search.attr('tabindex', this.$selection.attr('tabindex'));
    this.$selection.attr('tabindex', '-1');
  };

  Search.prototype.createPlaceholder = function (decorated, placeholder) {
    this.$search.attr('placeholder', placeholder.text);
  };

  Search.prototype.update = function (decorated, data) {
    var searchHadFocus = this.$search[0] == document.activeElement;

    this.$search.attr('placeholder', '');

    decorated.call(this, data);

    this.$selection.find('.select2-selection__rendered')
                   .append(this.$searchContainer);

    this.resizeSearch();
    if (searchHadFocus) {
      this.$search.focus();
    }
  };

  Search.prototype.handleSearch = function () {
    this.resizeSearch();

    if (!this._keyUpPrevented) {
      var input = this.$search.val();

      this.trigger('query', {
        term: input
      });
    }

    this._keyUpPrevented = false;
  };

  Search.prototype.searchRemoveChoice = function (decorated, item) {
    this.trigger('unselect', {
      data: item
    });

    this.$search.val(item.text);
    this.handleSearch();
  };

  Search.prototype.resizeSearch = function () {
    this.$search.css('width', '25px');

    var width = '';

    if (this.$search.attr('placeholder') !== '') {
      width = this.$selection.find('.select2-selection__rendered').innerWidth();
    } else {
      var minimumWidth = this.$search.val().length + 1;

      width = (minimumWidth * 0.75) + 'em';
    }

    this.$search.css('width', width);
  };

  return Search;
});

S2.define('select2/selection/eventRelay',[
  'jquery'
], function ($) {
  function EventRelay () { }

  EventRelay.prototype.bind = function (decorated, container, $container) {
    var self = this;
    var relayEvents = [
      'open', 'opening',
      'close', 'closing',
      'select', 'selecting',
      'unselect', 'unselecting'
    ];

    var preventableEvents = ['opening', 'closing', 'selecting', 'unselecting'];

    decorated.call(this, container, $container);

    container.on('*', function (name, params) {
      // Ignore events that should not be relayed
      if ($.inArray(name, relayEvents) === -1) {
        return;
      }

      // The parameters should always be an object
      params = params || {};

      // Generate the jQuery event for the Select2 event
      var evt = $.Event('select2:' + name, {
        params: params
      });

      self.$element.trigger(evt);

      // Only handle preventable events if it was one
      if ($.inArray(name, preventableEvents) === -1) {
        return;
      }

      params.prevented = evt.isDefaultPrevented();
    });
  };

  return EventRelay;
});

S2.define('select2/translation',[
  'jquery',
  'require'
], function ($, require) {
  function Translation (dict) {
    this.dict = dict || {};
  }

  Translation.prototype.all = function () {
    return this.dict;
  };

  Translation.prototype.get = function (key) {
    return this.dict[key];
  };

  Translation.prototype.extend = function (translation) {
    this.dict = $.extend({}, translation.all(), this.dict);
  };

  // Static functions

  Translation._cache = {};

  Translation.loadPath = function (path) {
    if (!(path in Translation._cache)) {
      var translations = require(path);

      Translation._cache[path] = translations;
    }

    return new Translation(Translation._cache[path]);
  };

  return Translation;
});

S2.define('select2/diacritics',[

], function () {
  var diacritics = {
    '\u24B6': 'A',
    '\uFF21': 'A',
    '\u00C0': 'A',
    '\u00C1': 'A',
    '\u00C2': 'A',
    '\u1EA6': 'A',
    '\u1EA4': 'A',
    '\u1EAA': 'A',
    '\u1EA8': 'A',
    '\u00C3': 'A',
    '\u0100': 'A',
    '\u0102': 'A',
    '\u1EB0': 'A',
    '\u1EAE': 'A',
    '\u1EB4': 'A',
    '\u1EB2': 'A',
    '\u0226': 'A',
    '\u01E0': 'A',
    '\u00C4': 'A',
    '\u01DE': 'A',
    '\u1EA2': 'A',
    '\u00C5': 'A',
    '\u01FA': 'A',
    '\u01CD': 'A',
    '\u0200': 'A',
    '\u0202': 'A',
    '\u1EA0': 'A',
    '\u1EAC': 'A',
    '\u1EB6': 'A',
    '\u1E00': 'A',
    '\u0104': 'A',
    '\u023A': 'A',
    '\u2C6F': 'A',
    '\uA732': 'AA',
    '\u00C6': 'AE',
    '\u01FC': 'AE',
    '\u01E2': 'AE',
    '\uA734': 'AO',
    '\uA736': 'AU',
    '\uA738': 'AV',
    '\uA73A': 'AV',
    '\uA73C': 'AY',
    '\u24B7': 'B',
    '\uFF22': 'B',
    '\u1E02': 'B',
    '\u1E04': 'B',
    '\u1E06': 'B',
    '\u0243': 'B',
    '\u0182': 'B',
    '\u0181': 'B',
    '\u24B8': 'C',
    '\uFF23': 'C',
    '\u0106': 'C',
    '\u0108': 'C',
    '\u010A': 'C',
    '\u010C': 'C',
    '\u00C7': 'C',
    '\u1E08': 'C',
    '\u0187': 'C',
    '\u023B': 'C',
    '\uA73E': 'C',
    '\u24B9': 'D',
    '\uFF24': 'D',
    '\u1E0A': 'D',
    '\u010E': 'D',
    '\u1E0C': 'D',
    '\u1E10': 'D',
    '\u1E12': 'D',
    '\u1E0E': 'D',
    '\u0110': 'D',
    '\u018B': 'D',
    '\u018A': 'D',
    '\u0189': 'D',
    '\uA779': 'D',
    '\u01F1': 'DZ',
    '\u01C4': 'DZ',
    '\u01F2': 'Dz',
    '\u01C5': 'Dz',
    '\u24BA': 'E',
    '\uFF25': 'E',
    '\u00C8': 'E',
    '\u00C9': 'E',
    '\u00CA': 'E',
    '\u1EC0': 'E',
    '\u1EBE': 'E',
    '\u1EC4': 'E',
    '\u1EC2': 'E',
    '\u1EBC': 'E',
    '\u0112': 'E',
    '\u1E14': 'E',
    '\u1E16': 'E',
    '\u0114': 'E',
    '\u0116': 'E',
    '\u00CB': 'E',
    '\u1EBA': 'E',
    '\u011A': 'E',
    '\u0204': 'E',
    '\u0206': 'E',
    '\u1EB8': 'E',
    '\u1EC6': 'E',
    '\u0228': 'E',
    '\u1E1C': 'E',
    '\u0118': 'E',
    '\u1E18': 'E',
    '\u1E1A': 'E',
    '\u0190': 'E',
    '\u018E': 'E',
    '\u24BB': 'F',
    '\uFF26': 'F',
    '\u1E1E': 'F',
    '\u0191': 'F',
    '\uA77B': 'F',
    '\u24BC': 'G',
    '\uFF27': 'G',
    '\u01F4': 'G',
    '\u011C': 'G',
    '\u1E20': 'G',
    '\u011E': 'G',
    '\u0120': 'G',
    '\u01E6': 'G',
    '\u0122': 'G',
    '\u01E4': 'G',
    '\u0193': 'G',
    '\uA7A0': 'G',
    '\uA77D': 'G',
    '\uA77E': 'G',
    '\u24BD': 'H',
    '\uFF28': 'H',
    '\u0124': 'H',
    '\u1E22': 'H',
    '\u1E26': 'H',
    '\u021E': 'H',
    '\u1E24': 'H',
    '\u1E28': 'H',
    '\u1E2A': 'H',
    '\u0126': 'H',
    '\u2C67': 'H',
    '\u2C75': 'H',
    '\uA78D': 'H',
    '\u24BE': 'I',
    '\uFF29': 'I',
    '\u00CC': 'I',
    '\u00CD': 'I',
    '\u00CE': 'I',
    '\u0128': 'I',
    '\u012A': 'I',
    '\u012C': 'I',
    '\u0130': 'I',
    '\u00CF': 'I',
    '\u1E2E': 'I',
    '\u1EC8': 'I',
    '\u01CF': 'I',
    '\u0208': 'I',
    '\u020A': 'I',
    '\u1ECA': 'I',
    '\u012E': 'I',
    '\u1E2C': 'I',
    '\u0197': 'I',
    '\u24BF': 'J',
    '\uFF2A': 'J',
    '\u0134': 'J',
    '\u0248': 'J',
    '\u24C0': 'K',
    '\uFF2B': 'K',
    '\u1E30': 'K',
    '\u01E8': 'K',
    '\u1E32': 'K',
    '\u0136': 'K',
    '\u1E34': 'K',
    '\u0198': 'K',
    '\u2C69': 'K',
    '\uA740': 'K',
    '\uA742': 'K',
    '\uA744': 'K',
    '\uA7A2': 'K',
    '\u24C1': 'L',
    '\uFF2C': 'L',
    '\u013F': 'L',
    '\u0139': 'L',
    '\u013D': 'L',
    '\u1E36': 'L',
    '\u1E38': 'L',
    '\u013B': 'L',
    '\u1E3C': 'L',
    '\u1E3A': 'L',
    '\u0141': 'L',
    '\u023D': 'L',
    '\u2C62': 'L',
    '\u2C60': 'L',
    '\uA748': 'L',
    '\uA746': 'L',
    '\uA780': 'L',
    '\u01C7': 'LJ',
    '\u01C8': 'Lj',
    '\u24C2': 'M',
    '\uFF2D': 'M',
    '\u1E3E': 'M',
    '\u1E40': 'M',
    '\u1E42': 'M',
    '\u2C6E': 'M',
    '\u019C': 'M',
    '\u24C3': 'N',
    '\uFF2E': 'N',
    '\u01F8': 'N',
    '\u0143': 'N',
    '\u00D1': 'N',
    '\u1E44': 'N',
    '\u0147': 'N',
    '\u1E46': 'N',
    '\u0145': 'N',
    '\u1E4A': 'N',
    '\u1E48': 'N',
    '\u0220': 'N',
    '\u019D': 'N',
    '\uA790': 'N',
    '\uA7A4': 'N',
    '\u01CA': 'NJ',
    '\u01CB': 'Nj',
    '\u24C4': 'O',
    '\uFF2F': 'O',
    '\u00D2': 'O',
    '\u00D3': 'O',
    '\u00D4': 'O',
    '\u1ED2': 'O',
    '\u1ED0': 'O',
    '\u1ED6': 'O',
    '\u1ED4': 'O',
    '\u00D5': 'O',
    '\u1E4C': 'O',
    '\u022C': 'O',
    '\u1E4E': 'O',
    '\u014C': 'O',
    '\u1E50': 'O',
    '\u1E52': 'O',
    '\u014E': 'O',
    '\u022E': 'O',
    '\u0230': 'O',
    '\u00D6': 'O',
    '\u022A': 'O',
    '\u1ECE': 'O',
    '\u0150': 'O',
    '\u01D1': 'O',
    '\u020C': 'O',
    '\u020E': 'O',
    '\u01A0': 'O',
    '\u1EDC': 'O',
    '\u1EDA': 'O',
    '\u1EE0': 'O',
    '\u1EDE': 'O',
    '\u1EE2': 'O',
    '\u1ECC': 'O',
    '\u1ED8': 'O',
    '\u01EA': 'O',
    '\u01EC': 'O',
    '\u00D8': 'O',
    '\u01FE': 'O',
    '\u0186': 'O',
    '\u019F': 'O',
    '\uA74A': 'O',
    '\uA74C': 'O',
    '\u01A2': 'OI',
    '\uA74E': 'OO',
    '\u0222': 'OU',
    '\u24C5': 'P',
    '\uFF30': 'P',
    '\u1E54': 'P',
    '\u1E56': 'P',
    '\u01A4': 'P',
    '\u2C63': 'P',
    '\uA750': 'P',
    '\uA752': 'P',
    '\uA754': 'P',
    '\u24C6': 'Q',
    '\uFF31': 'Q',
    '\uA756': 'Q',
    '\uA758': 'Q',
    '\u024A': 'Q',
    '\u24C7': 'R',
    '\uFF32': 'R',
    '\u0154': 'R',
    '\u1E58': 'R',
    '\u0158': 'R',
    '\u0210': 'R',
    '\u0212': 'R',
    '\u1E5A': 'R',
    '\u1E5C': 'R',
    '\u0156': 'R',
    '\u1E5E': 'R',
    '\u024C': 'R',
    '\u2C64': 'R',
    '\uA75A': 'R',
    '\uA7A6': 'R',
    '\uA782': 'R',
    '\u24C8': 'S',
    '\uFF33': 'S',
    '\u1E9E': 'S',
    '\u015A': 'S',
    '\u1E64': 'S',
    '\u015C': 'S',
    '\u1E60': 'S',
    '\u0160': 'S',
    '\u1E66': 'S',
    '\u1E62': 'S',
    '\u1E68': 'S',
    '\u0218': 'S',
    '\u015E': 'S',
    '\u2C7E': 'S',
    '\uA7A8': 'S',
    '\uA784': 'S',
    '\u24C9': 'T',
    '\uFF34': 'T',
    '\u1E6A': 'T',
    '\u0164': 'T',
    '\u1E6C': 'T',
    '\u021A': 'T',
    '\u0162': 'T',
    '\u1E70': 'T',
    '\u1E6E': 'T',
    '\u0166': 'T',
    '\u01AC': 'T',
    '\u01AE': 'T',
    '\u023E': 'T',
    '\uA786': 'T',
    '\uA728': 'TZ',
    '\u24CA': 'U',
    '\uFF35': 'U',
    '\u00D9': 'U',
    '\u00DA': 'U',
    '\u00DB': 'U',
    '\u0168': 'U',
    '\u1E78': 'U',
    '\u016A': 'U',
    '\u1E7A': 'U',
    '\u016C': 'U',
    '\u00DC': 'U',
    '\u01DB': 'U',
    '\u01D7': 'U',
    '\u01D5': 'U',
    '\u01D9': 'U',
    '\u1EE6': 'U',
    '\u016E': 'U',
    '\u0170': 'U',
    '\u01D3': 'U',
    '\u0214': 'U',
    '\u0216': 'U',
    '\u01AF': 'U',
    '\u1EEA': 'U',
    '\u1EE8': 'U',
    '\u1EEE': 'U',
    '\u1EEC': 'U',
    '\u1EF0': 'U',
    '\u1EE4': 'U',
    '\u1E72': 'U',
    '\u0172': 'U',
    '\u1E76': 'U',
    '\u1E74': 'U',
    '\u0244': 'U',
    '\u24CB': 'V',
    '\uFF36': 'V',
    '\u1E7C': 'V',
    '\u1E7E': 'V',
    '\u01B2': 'V',
    '\uA75E': 'V',
    '\u0245': 'V',
    '\uA760': 'VY',
    '\u24CC': 'W',
    '\uFF37': 'W',
    '\u1E80': 'W',
    '\u1E82': 'W',
    '\u0174': 'W',
    '\u1E86': 'W',
    '\u1E84': 'W',
    '\u1E88': 'W',
    '\u2C72': 'W',
    '\u24CD': 'X',
    '\uFF38': 'X',
    '\u1E8A': 'X',
    '\u1E8C': 'X',
    '\u24CE': 'Y',
    '\uFF39': 'Y',
    '\u1EF2': 'Y',
    '\u00DD': 'Y',
    '\u0176': 'Y',
    '\u1EF8': 'Y',
    '\u0232': 'Y',
    '\u1E8E': 'Y',
    '\u0178': 'Y',
    '\u1EF6': 'Y',
    '\u1EF4': 'Y',
    '\u01B3': 'Y',
    '\u024E': 'Y',
    '\u1EFE': 'Y',
    '\u24CF': 'Z',
    '\uFF3A': 'Z',
    '\u0179': 'Z',
    '\u1E90': 'Z',
    '\u017B': 'Z',
    '\u017D': 'Z',
    '\u1E92': 'Z',
    '\u1E94': 'Z',
    '\u01B5': 'Z',
    '\u0224': 'Z',
    '\u2C7F': 'Z',
    '\u2C6B': 'Z',
    '\uA762': 'Z',
    '\u24D0': 'a',
    '\uFF41': 'a',
    '\u1E9A': 'a',
    '\u00E0': 'a',
    '\u00E1': 'a',
    '\u00E2': 'a',
    '\u1EA7': 'a',
    '\u1EA5': 'a',
    '\u1EAB': 'a',
    '\u1EA9': 'a',
    '\u00E3': 'a',
    '\u0101': 'a',
    '\u0103': 'a',
    '\u1EB1': 'a',
    '\u1EAF': 'a',
    '\u1EB5': 'a',
    '\u1EB3': 'a',
    '\u0227': 'a',
    '\u01E1': 'a',
    '\u00E4': 'a',
    '\u01DF': 'a',
    '\u1EA3': 'a',
    '\u00E5': 'a',
    '\u01FB': 'a',
    '\u01CE': 'a',
    '\u0201': 'a',
    '\u0203': 'a',
    '\u1EA1': 'a',
    '\u1EAD': 'a',
    '\u1EB7': 'a',
    '\u1E01': 'a',
    '\u0105': 'a',
    '\u2C65': 'a',
    '\u0250': 'a',
    '\uA733': 'aa',
    '\u00E6': 'ae',
    '\u01FD': 'ae',
    '\u01E3': 'ae',
    '\uA735': 'ao',
    '\uA737': 'au',
    '\uA739': 'av',
    '\uA73B': 'av',
    '\uA73D': 'ay',
    '\u24D1': 'b',
    '\uFF42': 'b',
    '\u1E03': 'b',
    '\u1E05': 'b',
    '\u1E07': 'b',
    '\u0180': 'b',
    '\u0183': 'b',
    '\u0253': 'b',
    '\u24D2': 'c',
    '\uFF43': 'c',
    '\u0107': 'c',
    '\u0109': 'c',
    '\u010B': 'c',
    '\u010D': 'c',
    '\u00E7': 'c',
    '\u1E09': 'c',
    '\u0188': 'c',
    '\u023C': 'c',
    '\uA73F': 'c',
    '\u2184': 'c',
    '\u24D3': 'd',
    '\uFF44': 'd',
    '\u1E0B': 'd',
    '\u010F': 'd',
    '\u1E0D': 'd',
    '\u1E11': 'd',
    '\u1E13': 'd',
    '\u1E0F': 'd',
    '\u0111': 'd',
    '\u018C': 'd',
    '\u0256': 'd',
    '\u0257': 'd',
    '\uA77A': 'd',
    '\u01F3': 'dz',
    '\u01C6': 'dz',
    '\u24D4': 'e',
    '\uFF45': 'e',
    '\u00E8': 'e',
    '\u00E9': 'e',
    '\u00EA': 'e',
    '\u1EC1': 'e',
    '\u1EBF': 'e',
    '\u1EC5': 'e',
    '\u1EC3': 'e',
    '\u1EBD': 'e',
    '\u0113': 'e',
    '\u1E15': 'e',
    '\u1E17': 'e',
    '\u0115': 'e',
    '\u0117': 'e',
    '\u00EB': 'e',
    '\u1EBB': 'e',
    '\u011B': 'e',
    '\u0205': 'e',
    '\u0207': 'e',
    '\u1EB9': 'e',
    '\u1EC7': 'e',
    '\u0229': 'e',
    '\u1E1D': 'e',
    '\u0119': 'e',
    '\u1E19': 'e',
    '\u1E1B': 'e',
    '\u0247': 'e',
    '\u025B': 'e',
    '\u01DD': 'e',
    '\u24D5': 'f',
    '\uFF46': 'f',
    '\u1E1F': 'f',
    '\u0192': 'f',
    '\uA77C': 'f',
    '\u24D6': 'g',
    '\uFF47': 'g',
    '\u01F5': 'g',
    '\u011D': 'g',
    '\u1E21': 'g',
    '\u011F': 'g',
    '\u0121': 'g',
    '\u01E7': 'g',
    '\u0123': 'g',
    '\u01E5': 'g',
    '\u0260': 'g',
    '\uA7A1': 'g',
    '\u1D79': 'g',
    '\uA77F': 'g',
    '\u24D7': 'h',
    '\uFF48': 'h',
    '\u0125': 'h',
    '\u1E23': 'h',
    '\u1E27': 'h',
    '\u021F': 'h',
    '\u1E25': 'h',
    '\u1E29': 'h',
    '\u1E2B': 'h',
    '\u1E96': 'h',
    '\u0127': 'h',
    '\u2C68': 'h',
    '\u2C76': 'h',
    '\u0265': 'h',
    '\u0195': 'hv',
    '\u24D8': 'i',
    '\uFF49': 'i',
    '\u00EC': 'i',
    '\u00ED': 'i',
    '\u00EE': 'i',
    '\u0129': 'i',
    '\u012B': 'i',
    '\u012D': 'i',
    '\u00EF': 'i',
    '\u1E2F': 'i',
    '\u1EC9': 'i',
    '\u01D0': 'i',
    '\u0209': 'i',
    '\u020B': 'i',
    '\u1ECB': 'i',
    '\u012F': 'i',
    '\u1E2D': 'i',
    '\u0268': 'i',
    '\u0131': 'i',
    '\u24D9': 'j',
    '\uFF4A': 'j',
    '\u0135': 'j',
    '\u01F0': 'j',
    '\u0249': 'j',
    '\u24DA': 'k',
    '\uFF4B': 'k',
    '\u1E31': 'k',
    '\u01E9': 'k',
    '\u1E33': 'k',
    '\u0137': 'k',
    '\u1E35': 'k',
    '\u0199': 'k',
    '\u2C6A': 'k',
    '\uA741': 'k',
    '\uA743': 'k',
    '\uA745': 'k',
    '\uA7A3': 'k',
    '\u24DB': 'l',
    '\uFF4C': 'l',
    '\u0140': 'l',
    '\u013A': 'l',
    '\u013E': 'l',
    '\u1E37': 'l',
    '\u1E39': 'l',
    '\u013C': 'l',
    '\u1E3D': 'l',
    '\u1E3B': 'l',
    '\u017F': 'l',
    '\u0142': 'l',
    '\u019A': 'l',
    '\u026B': 'l',
    '\u2C61': 'l',
    '\uA749': 'l',
    '\uA781': 'l',
    '\uA747': 'l',
    '\u01C9': 'lj',
    '\u24DC': 'm',
    '\uFF4D': 'm',
    '\u1E3F': 'm',
    '\u1E41': 'm',
    '\u1E43': 'm',
    '\u0271': 'm',
    '\u026F': 'm',
    '\u24DD': 'n',
    '\uFF4E': 'n',
    '\u01F9': 'n',
    '\u0144': 'n',
    '\u00F1': 'n',
    '\u1E45': 'n',
    '\u0148': 'n',
    '\u1E47': 'n',
    '\u0146': 'n',
    '\u1E4B': 'n',
    '\u1E49': 'n',
    '\u019E': 'n',
    '\u0272': 'n',
    '\u0149': 'n',
    '\uA791': 'n',
    '\uA7A5': 'n',
    '\u01CC': 'nj',
    '\u24DE': 'o',
    '\uFF4F': 'o',
    '\u00F2': 'o',
    '\u00F3': 'o',
    '\u00F4': 'o',
    '\u1ED3': 'o',
    '\u1ED1': 'o',
    '\u1ED7': 'o',
    '\u1ED5': 'o',
    '\u00F5': 'o',
    '\u1E4D': 'o',
    '\u022D': 'o',
    '\u1E4F': 'o',
    '\u014D': 'o',
    '\u1E51': 'o',
    '\u1E53': 'o',
    '\u014F': 'o',
    '\u022F': 'o',
    '\u0231': 'o',
    '\u00F6': 'o',
    '\u022B': 'o',
    '\u1ECF': 'o',
    '\u0151': 'o',
    '\u01D2': 'o',
    '\u020D': 'o',
    '\u020F': 'o',
    '\u01A1': 'o',
    '\u1EDD': 'o',
    '\u1EDB': 'o',
    '\u1EE1': 'o',
    '\u1EDF': 'o',
    '\u1EE3': 'o',
    '\u1ECD': 'o',
    '\u1ED9': 'o',
    '\u01EB': 'o',
    '\u01ED': 'o',
    '\u00F8': 'o',
    '\u01FF': 'o',
    '\u0254': 'o',
    '\uA74B': 'o',
    '\uA74D': 'o',
    '\u0275': 'o',
    '\u01A3': 'oi',
    '\u0223': 'ou',
    '\uA74F': 'oo',
    '\u24DF': 'p',
    '\uFF50': 'p',
    '\u1E55': 'p',
    '\u1E57': 'p',
    '\u01A5': 'p',
    '\u1D7D': 'p',
    '\uA751': 'p',
    '\uA753': 'p',
    '\uA755': 'p',
    '\u24E0': 'q',
    '\uFF51': 'q',
    '\u024B': 'q',
    '\uA757': 'q',
    '\uA759': 'q',
    '\u24E1': 'r',
    '\uFF52': 'r',
    '\u0155': 'r',
    '\u1E59': 'r',
    '\u0159': 'r',
    '\u0211': 'r',
    '\u0213': 'r',
    '\u1E5B': 'r',
    '\u1E5D': 'r',
    '\u0157': 'r',
    '\u1E5F': 'r',
    '\u024D': 'r',
    '\u027D': 'r',
    '\uA75B': 'r',
    '\uA7A7': 'r',
    '\uA783': 'r',
    '\u24E2': 's',
    '\uFF53': 's',
    '\u00DF': 's',
    '\u015B': 's',
    '\u1E65': 's',
    '\u015D': 's',
    '\u1E61': 's',
    '\u0161': 's',
    '\u1E67': 's',
    '\u1E63': 's',
    '\u1E69': 's',
    '\u0219': 's',
    '\u015F': 's',
    '\u023F': 's',
    '\uA7A9': 's',
    '\uA785': 's',
    '\u1E9B': 's',
    '\u24E3': 't',
    '\uFF54': 't',
    '\u1E6B': 't',
    '\u1E97': 't',
    '\u0165': 't',
    '\u1E6D': 't',
    '\u021B': 't',
    '\u0163': 't',
    '\u1E71': 't',
    '\u1E6F': 't',
    '\u0167': 't',
    '\u01AD': 't',
    '\u0288': 't',
    '\u2C66': 't',
    '\uA787': 't',
    '\uA729': 'tz',
    '\u24E4': 'u',
    '\uFF55': 'u',
    '\u00F9': 'u',
    '\u00FA': 'u',
    '\u00FB': 'u',
    '\u0169': 'u',
    '\u1E79': 'u',
    '\u016B': 'u',
    '\u1E7B': 'u',
    '\u016D': 'u',
    '\u00FC': 'u',
    '\u01DC': 'u',
    '\u01D8': 'u',
    '\u01D6': 'u',
    '\u01DA': 'u',
    '\u1EE7': 'u',
    '\u016F': 'u',
    '\u0171': 'u',
    '\u01D4': 'u',
    '\u0215': 'u',
    '\u0217': 'u',
    '\u01B0': 'u',
    '\u1EEB': 'u',
    '\u1EE9': 'u',
    '\u1EEF': 'u',
    '\u1EED': 'u',
    '\u1EF1': 'u',
    '\u1EE5': 'u',
    '\u1E73': 'u',
    '\u0173': 'u',
    '\u1E77': 'u',
    '\u1E75': 'u',
    '\u0289': 'u',
    '\u24E5': 'v',
    '\uFF56': 'v',
    '\u1E7D': 'v',
    '\u1E7F': 'v',
    '\u028B': 'v',
    '\uA75F': 'v',
    '\u028C': 'v',
    '\uA761': 'vy',
    '\u24E6': 'w',
    '\uFF57': 'w',
    '\u1E81': 'w',
    '\u1E83': 'w',
    '\u0175': 'w',
    '\u1E87': 'w',
    '\u1E85': 'w',
    '\u1E98': 'w',
    '\u1E89': 'w',
    '\u2C73': 'w',
    '\u24E7': 'x',
    '\uFF58': 'x',
    '\u1E8B': 'x',
    '\u1E8D': 'x',
    '\u24E8': 'y',
    '\uFF59': 'y',
    '\u1EF3': 'y',
    '\u00FD': 'y',
    '\u0177': 'y',
    '\u1EF9': 'y',
    '\u0233': 'y',
    '\u1E8F': 'y',
    '\u00FF': 'y',
    '\u1EF7': 'y',
    '\u1E99': 'y',
    '\u1EF5': 'y',
    '\u01B4': 'y',
    '\u024F': 'y',
    '\u1EFF': 'y',
    '\u24E9': 'z',
    '\uFF5A': 'z',
    '\u017A': 'z',
    '\u1E91': 'z',
    '\u017C': 'z',
    '\u017E': 'z',
    '\u1E93': 'z',
    '\u1E95': 'z',
    '\u01B6': 'z',
    '\u0225': 'z',
    '\u0240': 'z',
    '\u2C6C': 'z',
    '\uA763': 'z',
    '\u0386': '\u0391',
    '\u0388': '\u0395',
    '\u0389': '\u0397',
    '\u038A': '\u0399',
    '\u03AA': '\u0399',
    '\u038C': '\u039F',
    '\u038E': '\u03A5',
    '\u03AB': '\u03A5',
    '\u038F': '\u03A9',
    '\u03AC': '\u03B1',
    '\u03AD': '\u03B5',
    '\u03AE': '\u03B7',
    '\u03AF': '\u03B9',
    '\u03CA': '\u03B9',
    '\u0390': '\u03B9',
    '\u03CC': '\u03BF',
    '\u03CD': '\u03C5',
    '\u03CB': '\u03C5',
    '\u03B0': '\u03C5',
    '\u03C9': '\u03C9',
    '\u03C2': '\u03C3'
  };

  return diacritics;
});

S2.define('select2/data/base',[
  '../utils'
], function (Utils) {
  function BaseAdapter ($element, options) {
    BaseAdapter.__super__.constructor.call(this);
  }

  Utils.Extend(BaseAdapter, Utils.Observable);

  BaseAdapter.prototype.current = function (callback) {
    throw new Error('The `current` method must be defined in child classes.');
  };

  BaseAdapter.prototype.query = function (params, callback) {
    throw new Error('The `query` method must be defined in child classes.');
  };

  BaseAdapter.prototype.bind = function (container, $container) {
    // Can be implemented in subclasses
  };

  BaseAdapter.prototype.destroy = function () {
    // Can be implemented in subclasses
  };

  BaseAdapter.prototype.generateResultId = function (container, data) {
    var id = container.id + '-result-';

    id += Utils.generateChars(4);

    if (data.id != null) {
      id += '-' + data.id.toString();
    } else {
      id += '-' + Utils.generateChars(4);
    }
    return id;
  };

  return BaseAdapter;
});

S2.define('select2/data/select',[
  './base',
  '../utils',
  'jquery'
], function (BaseAdapter, Utils, $) {
  function SelectAdapter ($element, options) {
    this.$element = $element;
    this.options = options;

    SelectAdapter.__super__.constructor.call(this);
  }

  Utils.Extend(SelectAdapter, BaseAdapter);

  SelectAdapter.prototype.current = function (callback) {
    var data = [];
    var self = this;

    this.$element.find(':selected').each(function () {
      var $option = $(this);

      var option = self.item($option);

      data.push(option);
    });

    callback(data);
  };

  SelectAdapter.prototype.select = function (data) {
    var self = this;

    data.selected = true;

    // If data.element is a DOM node, use it instead
    if ($(data.element).is('option')) {
      data.element.selected = true;

      this.$element.trigger('change');

      return;
    }

    if (this.$element.prop('multiple')) {
      this.current(function (currentData) {
        var val = [];

        data = [data];
        data.push.apply(data, currentData);

        for (var d = 0; d < data.length; d++) {
          var id = data[d].id;

          if ($.inArray(id, val) === -1) {
            val.push(id);
          }
        }

        self.$element.val(val);
        self.$element.trigger('change');
      });
    } else {
      var val = data.id;

      this.$element.val(val);
      this.$element.trigger('change');
    }
  };

  SelectAdapter.prototype.unselect = function (data) {
    var self = this;

    if (!this.$element.prop('multiple')) {
      return;
    }

    data.selected = false;

    if ($(data.element).is('option')) {
      data.element.selected = false;

      this.$element.trigger('change');

      return;
    }

    this.current(function (currentData) {
      var val = [];

      for (var d = 0; d < currentData.length; d++) {
        var id = currentData[d].id;

        if (id !== data.id && $.inArray(id, val) === -1) {
          val.push(id);
        }
      }

      self.$element.val(val);

      self.$element.trigger('change');
    });
  };

  SelectAdapter.prototype.bind = function (container, $container) {
    var self = this;

    this.container = container;

    container.on('select', function (params) {
      self.select(params.data);
    });

    container.on('unselect', function (params) {
      self.unselect(params.data);
    });
  };

  SelectAdapter.prototype.destroy = function () {
    // Remove anything added to child elements
    this.$element.find('*').each(function () {
      // Remove any custom data set by Select2
      $.removeData(this, 'data');
    });
  };

  SelectAdapter.prototype.query = function (params, callback) {
    var data = [];
    var self = this;

    var $options = this.$element.children();

    $options.each(function () {
      var $option = $(this);

      if (!$option.is('option') && !$option.is('optgroup')) {
        return;
      }

      var option = self.item($option);

      var matches = self.matches(params, option);

      if (matches !== null) {
        data.push(matches);
      }
    });

    callback({
      results: data
    });
  };

  SelectAdapter.prototype.addOptions = function ($options) {
    Utils.appendMany(this.$element, $options);
  };

  SelectAdapter.prototype.option = function (data) {
    var option;

    if (data.children) {
      option = document.createElement('optgroup');
      option.label = data.text;
    } else {
      option = document.createElement('option');

      if (option.textContent !== undefined) {
        option.textContent = data.text;
      } else {
        option.innerText = data.text;
      }
    }

    if (data.id) {
      option.value = data.id;
    }

    if (data.disabled) {
      option.disabled = true;
    }

    if (data.selected) {
      option.selected = true;
    }

    if (data.title) {
      option.title = data.title;
    }

    var $option = $(option);

    var normalizedData = this._normalizeItem(data);
    normalizedData.element = option;

    // Override the option's data with the combined data
    $.data(option, 'data', normalizedData);

    return $option;
  };

  SelectAdapter.prototype.item = function ($option) {
    var data = {};

    data = $.data($option[0], 'data');

    if (data != null) {
      return data;
    }

    if ($option.is('option')) {
      data = {
        id: $option.val(),
        text: $option.text(),
        disabled: $option.prop('disabled'),
        selected: $option.prop('selected'),
        title: $option.prop('title')
      };
    } else if ($option.is('optgroup')) {
      data = {
        text: $option.prop('label'),
        children: [],
        title: $option.prop('title')
      };

      var $children = $option.children('option');
      var children = [];

      for (var c = 0; c < $children.length; c++) {
        var $child = $($children[c]);

        var child = this.item($child);

        children.push(child);
      }

      data.children = children;
    }

    data = this._normalizeItem(data);
    data.element = $option[0];

    $.data($option[0], 'data', data);

    return data;
  };

  SelectAdapter.prototype._normalizeItem = function (item) {
    if (!$.isPlainObject(item)) {
      item = {
        id: item,
        text: item
      };
    }

    item = $.extend({}, {
      text: ''
    }, item);

    var defaults = {
      selected: false,
      disabled: false
    };

    if (item.id != null) {
      item.id = item.id.toString();
    }

    if (item.text != null) {
      item.text = item.text.toString();
    }

    if (item._resultId == null && item.id && this.container != null) {
      item._resultId = this.generateResultId(this.container, item);
    }

    return $.extend({}, defaults, item);
  };

  SelectAdapter.prototype.matches = function (params, data) {
    var matcher = this.options.get('matcher');

    return matcher(params, data);
  };

  return SelectAdapter;
});

S2.define('select2/data/array',[
  './select',
  '../utils',
  'jquery'
], function (SelectAdapter, Utils, $) {
  function ArrayAdapter ($element, options) {
    var data = options.get('data') || [];

    ArrayAdapter.__super__.constructor.call(this, $element, options);

    this.addOptions(this.convertToOptions(data));
  }

  Utils.Extend(ArrayAdapter, SelectAdapter);

  ArrayAdapter.prototype.select = function (data) {
    var $option = this.$element.find('option').filter(function (i, elm) {
      return elm.value == data.id.toString();
    });

    if ($option.length === 0) {
      $option = this.option(data);

      this.addOptions($option);
    }

    ArrayAdapter.__super__.select.call(this, data);
  };

  ArrayAdapter.prototype.convertToOptions = function (data) {
    var self = this;

    var $existing = this.$element.find('option');
    var existingIds = $existing.map(function () {
      return self.item($(this)).id;
    }).get();

    var $options = [];

    // Filter out all items except for the one passed in the argument
    function onlyItem (item) {
      return function () {
        return $(this).val() == item.id;
      };
    }

    for (var d = 0; d < data.length; d++) {
      var item = this._normalizeItem(data[d]);

      // Skip items which were pre-loaded, only merge the data
      if ($.inArray(item.id, existingIds) >= 0) {
        var $existingOption = $existing.filter(onlyItem(item));

        var existingData = this.item($existingOption);
        var newData = $.extend(true, {}, item, existingData);

        var $newOption = this.option(newData);

        $existingOption.replaceWith($newOption);

        continue;
      }

      var $option = this.option(item);

      if (item.children) {
        var $children = this.convertToOptions(item.children);

        Utils.appendMany($option, $children);
      }

      $options.push($option);
    }

    return $options;
  };

  return ArrayAdapter;
});

S2.define('select2/data/ajax',[
  './array',
  '../utils',
  'jquery'
], function (ArrayAdapter, Utils, $) {
  function AjaxAdapter ($element, options) {
    this.ajaxOptions = this._applyDefaults(options.get('ajax'));

    if (this.ajaxOptions.processResults != null) {
      this.processResults = this.ajaxOptions.processResults;
    }

    AjaxAdapter.__super__.constructor.call(this, $element, options);
  }

  Utils.Extend(AjaxAdapter, ArrayAdapter);

  AjaxAdapter.prototype._applyDefaults = function (options) {
    var defaults = {
      data: function (params) {
        return $.extend({}, params, {
          q: params.term
        });
      },
      transport: function (params, success, failure) {
        var $request = $.ajax(params);

        $request.then(success);
        $request.fail(failure);

        return $request;
      }
    };

    return $.extend({}, defaults, options, true);
  };

  AjaxAdapter.prototype.processResults = function (results) {
    return results;
  };

  AjaxAdapter.prototype.query = function (params, callback) {
    var matches = [];
    var self = this;

    if (this._request != null) {
      // JSONP requests cannot always be aborted
      if ($.isFunction(this._request.abort)) {
        this._request.abort();
      }

      this._request = null;
    }

    var options = $.extend({
      type: 'GET'
    }, this.ajaxOptions);

    if (typeof options.url === 'function') {
      options.url = options.url.call(this.$element, params);
    }

    if (typeof options.data === 'function') {
      options.data = options.data.call(this.$element, params);
    }

    function request () {
      var $request = options.transport(options, function (data) {
        var results = self.processResults(data, params);

        if (self.options.get('debug') && window.console && console.error) {
          // Check to make sure that the response included a `results` key.
          if (!results || !results.results || !$.isArray(results.results)) {
            console.error(
              'Select2: The AJAX results did not return an array in the ' +
              '`results` key of the response.'
            );
          }
        }

        callback(results);
      }, function () {
        // Attempt to detect if a request was aborted
        // Only works if the transport exposes a status property
        if ($request.status && $request.status === '0') {
          return;
        }

        self.trigger('results:message', {
          message: 'errorLoading'
        });
      });

      self._request = $request;
    }

    if (this.ajaxOptions.delay && params.term != null) {
      if (this._queryTimeout) {
        window.clearTimeout(this._queryTimeout);
      }

      this._queryTimeout = window.setTimeout(request, this.ajaxOptions.delay);
    } else {
      request();
    }
  };

  return AjaxAdapter;
});

S2.define('select2/data/tags',[
  'jquery'
], function ($) {
  function Tags (decorated, $element, options) {
    var tags = options.get('tags');

    var createTag = options.get('createTag');

    if (createTag !== undefined) {
      this.createTag = createTag;
    }

    var insertTag = options.get('insertTag');

    if (insertTag !== undefined) {
        this.insertTag = insertTag;
    }

    decorated.call(this, $element, options);

    if ($.isArray(tags)) {
      for (var t = 0; t < tags.length; t++) {
        var tag = tags[t];
        var item = this._normalizeItem(tag);

        var $option = this.option(item);

        this.$element.append($option);
      }
    }
  }

  Tags.prototype.query = function (decorated, params, callback) {
    var self = this;

    this._removeOldTags();

    if (params.term == null || params.page != null) {
      decorated.call(this, params, callback);
      return;
    }

    function wrapper (obj, child) {
      var data = obj.results;

      for (var i = 0; i < data.length; i++) {
        var option = data[i];

        var checkChildren = (
          option.children != null &&
          !wrapper({
            results: option.children
          }, true)
        );

        var checkText = option.text === params.term;

        if (checkText || checkChildren) {
          if (child) {
            return false;
          }

          obj.data = data;
          callback(obj);

          return;
        }
      }

      if (child) {
        return true;
      }

      var tag = self.createTag(params);

      if (tag != null) {
        var $option = self.option(tag);
        $option.attr('data-select2-tag', true);

        self.addOptions([$option]);

        self.insertTag(data, tag);
      }

      obj.results = data;

      callback(obj);
    }

    decorated.call(this, params, wrapper);
  };

  Tags.prototype.createTag = function (decorated, params) {
    var term = $.trim(params.term);

    if (term === '') {
      return null;
    }

    return {
      id: term,
      text: term
    };
  };

  Tags.prototype.insertTag = function (_, data, tag) {
    data.unshift(tag);
  };

  Tags.prototype._removeOldTags = function (_) {
    var tag = this._lastTag;

    var $options = this.$element.find('option[data-select2-tag]');

    $options.each(function () {
      if (this.selected) {
        return;
      }

      $(this).remove();
    });
  };

  return Tags;
});

S2.define('select2/data/tokenizer',[
  'jquery'
], function ($) {
  function Tokenizer (decorated, $element, options) {
    var tokenizer = options.get('tokenizer');

    if (tokenizer !== undefined) {
      this.tokenizer = tokenizer;
    }

    decorated.call(this, $element, options);
  }

  Tokenizer.prototype.bind = function (decorated, container, $container) {
    decorated.call(this, container, $container);

    this.$search =  container.dropdown.$search || container.selection.$search ||
      $container.find('.select2-search__field');
  };

  Tokenizer.prototype.query = function (decorated, params, callback) {
    var self = this;

    function createAndSelect (data) {
      // Normalize the data object so we can use it for checks
      var item = self._normalizeItem(data);

      // Check if the data object already exists as a tag
      // Select it if it doesn't
      var $existingOptions = self.$element.find('option').filter(function () {
        return $(this).val() === item.id;
      });

      // If an existing option wasn't found for it, create the option
      if (!$existingOptions.length) {
        var $option = self.option(item);
        $option.attr('data-select2-tag', true);

        self._removeOldTags();
        self.addOptions([$option]);
      }

      // Select the item, now that we know there is an option for it
      select(item);
    }

    function select (data) {
      self.trigger('select', {
        data: data
      });
    }

    params.term = params.term || '';

    var tokenData = this.tokenizer(params, this.options, createAndSelect);

    if (tokenData.term !== params.term) {
      // Replace the search term if we have the search box
      if (this.$search.length) {
        this.$search.val(tokenData.term);
        this.$search.focus();
      }

      params.term = tokenData.term;
    }

    decorated.call(this, params, callback);
  };

  Tokenizer.prototype.tokenizer = function (_, params, options, callback) {
    var separators = options.get('tokenSeparators') || [];
    var term = params.term;
    var i = 0;

    var createTag = this.createTag || function (params) {
      return {
        id: params.term,
        text: params.term
      };
    };

    while (i < term.length) {
      var termChar = term[i];

      if ($.inArray(termChar, separators) === -1) {
        i++;

        continue;
      }

      var part = term.substr(0, i);
      var partParams = $.extend({}, params, {
        term: part
      });

      var data = createTag(partParams);

      if (data == null) {
        i++;
        continue;
      }

      callback(data);

      // Reset the term to not include the tokenized portion
      term = term.substr(i + 1) || '';
      i = 0;
    }

    return {
      term: term
    };
  };

  return Tokenizer;
});

S2.define('select2/data/minimumInputLength',[

], function () {
  function MinimumInputLength (decorated, $e, options) {
    this.minimumInputLength = options.get('minimumInputLength');

    decorated.call(this, $e, options);
  }

  MinimumInputLength.prototype.query = function (decorated, params, callback) {
    params.term = params.term || '';

    if (params.term.length < this.minimumInputLength) {
      this.trigger('results:message', {
        message: 'inputTooShort',
        args: {
          minimum: this.minimumInputLength,
          input: params.term,
          params: params
        }
      });

      return;
    }

    decorated.call(this, params, callback);
  };

  return MinimumInputLength;
});

S2.define('select2/data/maximumInputLength',[

], function () {
  function MaximumInputLength (decorated, $e, options) {
    this.maximumInputLength = options.get('maximumInputLength');

    decorated.call(this, $e, options);
  }

  MaximumInputLength.prototype.query = function (decorated, params, callback) {
    params.term = params.term || '';

    if (this.maximumInputLength > 0 &&
        params.term.length > this.maximumInputLength) {
      this.trigger('results:message', {
        message: 'inputTooLong',
        args: {
          maximum: this.maximumInputLength,
          input: params.term,
          params: params
        }
      });

      return;
    }

    decorated.call(this, params, callback);
  };

  return MaximumInputLength;
});

S2.define('select2/data/maximumSelectionLength',[

], function (){
  function MaximumSelectionLength (decorated, $e, options) {
    this.maximumSelectionLength = options.get('maximumSelectionLength');

    decorated.call(this, $e, options);
  }

  MaximumSelectionLength.prototype.query =
    function (decorated, params, callback) {
      var self = this;

      this.current(function (currentData) {
        var count = currentData != null ? currentData.length : 0;
        if (self.maximumSelectionLength > 0 &&
          count >= self.maximumSelectionLength) {
          self.trigger('results:message', {
            message: 'maximumSelected',
            args: {
              maximum: self.maximumSelectionLength
            }
          });
          return;
        }
        decorated.call(self, params, callback);
      });
  };

  return MaximumSelectionLength;
});

S2.define('select2/dropdown',[
  'jquery',
  './utils'
], function ($, Utils) {
  function Dropdown ($element, options) {
    this.$element = $element;
    this.options = options;

    Dropdown.__super__.constructor.call(this);
  }

  Utils.Extend(Dropdown, Utils.Observable);

  Dropdown.prototype.render = function () {
    var $dropdown = $(
      '<span class="select2-dropdown">' +
        '<span class="select2-results"></span>' +
      '</span>'
    );

    $dropdown.attr('dir', this.options.get('dir'));

    this.$dropdown = $dropdown;

    return $dropdown;
  };

  Dropdown.prototype.bind = function () {
    // Should be implemented in subclasses
  };

  Dropdown.prototype.position = function ($dropdown, $container) {
    // Should be implmented in subclasses
  };

  Dropdown.prototype.destroy = function () {
    // Remove the dropdown from the DOM
    this.$dropdown.remove();
  };

  return Dropdown;
});

S2.define('select2/dropdown/search',[
  'jquery',
  '../utils'
], function ($, Utils) {
  function Search () { }

  Search.prototype.render = function (decorated) {
    var $rendered = decorated.call(this);

    var $search = $(
      '<span class="select2-search select2-search--dropdown">' +
        '<input class="select2-search__field" type="search" tabindex="-1"' +
        ' autocomplete="off" autocorrect="off" autocapitalize="off"' +
        ' spellcheck="false" role="textbox" />' +
      '</span>'
    );

    this.$searchContainer = $search;
    this.$search = $search.find('input');

    $rendered.prepend($search);

    return $rendered;
  };

  Search.prototype.bind = function (decorated, container, $container) {
    var self = this;

    decorated.call(this, container, $container);

    this.$search.on('keydown', function (evt) {
      self.trigger('keypress', evt);

      self._keyUpPrevented = evt.isDefaultPrevented();
    });

    // Workaround for browsers which do not support the `input` event
    // This will prevent double-triggering of events for browsers which support
    // both the `keyup` and `input` events.
    this.$search.on('input', function (evt) {
      // Unbind the duplicated `keyup` event
      $(this).off('keyup');
    });

    this.$search.on('keyup input', function (evt) {
      self.handleSearch(evt);
    });

    container.on('open', function () {
      self.$search.attr('tabindex', 0);

      self.$search.focus();

      window.setTimeout(function () {
        self.$search.focus();
      }, 0);
    });

    container.on('close', function () {
      self.$search.attr('tabindex', -1);

      self.$search.val('');
    });

    container.on('focus', function () {
      if (container.isOpen()) {
        self.$search.focus();
      }
    });

    container.on('results:all', function (params) {
      if (params.query.term == null || params.query.term === '') {
        var showSearch = self.showSearch(params);

        if (showSearch) {
          self.$searchContainer.removeClass('select2-search--hide');
        } else {
          self.$searchContainer.addClass('select2-search--hide');
        }
      }
    });
  };

  Search.prototype.handleSearch = function (evt) {
    if (!this._keyUpPrevented) {
      var input = this.$search.val();

      this.trigger('query', {
        term: input
      });
    }

    this._keyUpPrevented = false;
  };

  Search.prototype.showSearch = function (_, params) {
    return true;
  };

  return Search;
});

S2.define('select2/dropdown/hidePlaceholder',[

], function () {
  function HidePlaceholder (decorated, $element, options, dataAdapter) {
    this.placeholder = this.normalizePlaceholder(options.get('placeholder'));

    decorated.call(this, $element, options, dataAdapter);
  }

  HidePlaceholder.prototype.append = function (decorated, data) {
    data.results = this.removePlaceholder(data.results);

    decorated.call(this, data);
  };

  HidePlaceholder.prototype.normalizePlaceholder = function (_, placeholder) {
    if (typeof placeholder === 'string') {
      placeholder = {
        id: '',
        text: placeholder
      };
    }

    return placeholder;
  };

  HidePlaceholder.prototype.removePlaceholder = function (_, data) {
    var modifiedData = data.slice(0);

    for (var d = data.length - 1; d >= 0; d--) {
      var item = data[d];

      if (this.placeholder.id === item.id) {
        modifiedData.splice(d, 1);
      }
    }

    return modifiedData;
  };

  return HidePlaceholder;
});

S2.define('select2/dropdown/infiniteScroll',[
  'jquery'
], function ($) {
  function InfiniteScroll (decorated, $element, options, dataAdapter) {
    this.lastParams = {};

    decorated.call(this, $element, options, dataAdapter);

    this.$loadingMore = this.createLoadingMore();
    this.loading = false;
  }

  InfiniteScroll.prototype.append = function (decorated, data) {
    this.$loadingMore.remove();
    this.loading = false;

    decorated.call(this, data);

    if (this.showLoadingMore(data)) {
      this.$results.append(this.$loadingMore);
    }
  };

  InfiniteScroll.prototype.bind = function (decorated, container, $container) {
    var self = this;

    decorated.call(this, container, $container);

    container.on('query', function (params) {
      self.lastParams = params;
      self.loading = true;
    });

    container.on('query:append', function (params) {
      self.lastParams = params;
      self.loading = true;
    });

    this.$results.on('scroll', function () {
      var isLoadMoreVisible = $.contains(
        document.documentElement,
        self.$loadingMore[0]
      );

      if (self.loading || !isLoadMoreVisible) {
        return;
      }

      var currentOffset = self.$results.offset().top +
        self.$results.outerHeight(false);
      var loadingMoreOffset = self.$loadingMore.offset().top +
        self.$loadingMore.outerHeight(false);

      if (currentOffset + 50 >= loadingMoreOffset) {
        self.loadMore();
      }
    });
  };

  InfiniteScroll.prototype.loadMore = function () {
    this.loading = true;

    var params = $.extend({}, {page: 1}, this.lastParams);

    params.page++;

    this.trigger('query:append', params);
  };

  InfiniteScroll.prototype.showLoadingMore = function (_, data) {
    return data.pagination && data.pagination.more;
  };

  InfiniteScroll.prototype.createLoadingMore = function () {
    var $option = $(
      '<li ' +
      'class="select2-results__option select2-results__option--load-more"' +
      'role="treeitem" aria-disabled="true"></li>'
    );

    var message = this.options.get('translations').get('loadingMore');

    $option.html(message(this.lastParams));

    return $option;
  };

  return InfiniteScroll;
});

S2.define('select2/dropdown/attachBody',[
  'jquery',
  '../utils'
], function ($, Utils) {
  function AttachBody (decorated, $element, options) {
    this.$dropdownParent = options.get('dropdownParent') || $(document.body);

    decorated.call(this, $element, options);
  }

  AttachBody.prototype.bind = function (decorated, container, $container) {
    var self = this;

    var setupResultsEvents = false;

    decorated.call(this, container, $container);

    container.on('open', function () {
      self._showDropdown();
      self._attachPositioningHandler(container);

      if (!setupResultsEvents) {
        setupResultsEvents = true;

        container.on('results:all', function () {
          self._positionDropdown();
          self._resizeDropdown();
        });

        container.on('results:append', function () {
          self._positionDropdown();
          self._resizeDropdown();
        });
      }
    });

    container.on('close', function () {
      self._hideDropdown();
      self._detachPositioningHandler(container);
    });

    this.$dropdownContainer.on('mousedown', function (evt) {
      evt.stopPropagation();
    });
  };

  AttachBody.prototype.destroy = function (decorated) {
    decorated.call(this);

    this.$dropdownContainer.remove();
  };

  AttachBody.prototype.position = function (decorated, $dropdown, $container) {
    // Clone all of the container classes
    $dropdown.attr('class', $container.attr('class'));

    $dropdown.removeClass('select2');
    $dropdown.addClass('select2-container--open');

    $dropdown.css({
      position: 'absolute',
      top: -999999
    });

    this.$container = $container;
  };

  AttachBody.prototype.render = function (decorated) {
    var $container = $('<span></span>');

    var $dropdown = decorated.call(this);
    $container.append($dropdown);

    this.$dropdownContainer = $container;

    return $container;
  };

  AttachBody.prototype._hideDropdown = function (decorated) {
    this.$dropdownContainer.detach();
  };

  AttachBody.prototype._attachPositioningHandler =
      function (decorated, container) {
    var self = this;

    var scrollEvent = 'scroll.select2.' + container.id;
    var resizeEvent = 'resize.select2.' + container.id;
    var orientationEvent = 'orientationchange.select2.' + container.id;

    var $watchers = this.$container.parents().filter(Utils.hasScroll);
    $watchers.each(function () {
      $(this).data('select2-scroll-position', {
        x: $(this).scrollLeft(),
        y: $(this).scrollTop()
      });
    });

    $watchers.on(scrollEvent, function (ev) {
      var position = $(this).data('select2-scroll-position');
      $(this).scrollTop(position.y);
    });

    $(window).on(scrollEvent + ' ' + resizeEvent + ' ' + orientationEvent,
      function (e) {
      self._positionDropdown();
      self._resizeDropdown();
    });
  };

  AttachBody.prototype._detachPositioningHandler =
      function (decorated, container) {
    var scrollEvent = 'scroll.select2.' + container.id;
    var resizeEvent = 'resize.select2.' + container.id;
    var orientationEvent = 'orientationchange.select2.' + container.id;

    var $watchers = this.$container.parents().filter(Utils.hasScroll);
    $watchers.off(scrollEvent);

    $(window).off(scrollEvent + ' ' + resizeEvent + ' ' + orientationEvent);
  };

  AttachBody.prototype._positionDropdown = function () {
    var $window = $(window);

    var isCurrentlyAbove = this.$dropdown.hasClass('select2-dropdown--above');
    var isCurrentlyBelow = this.$dropdown.hasClass('select2-dropdown--below');

    var newDirection = null;

    var offset = this.$container.offset();

    offset.bottom = offset.top + this.$container.outerHeight(false);

    var container = {
      height: this.$container.outerHeight(false)
    };

    container.top = offset.top;
    container.bottom = offset.top + container.height;

    var dropdown = {
      height: this.$dropdown.outerHeight(false)
    };

    var viewport = {
      top: $window.scrollTop(),
      bottom: $window.scrollTop() + $window.height()
    };

    var enoughRoomAbove = viewport.top < (offset.top - dropdown.height);
    var enoughRoomBelow = viewport.bottom > (offset.bottom + dropdown.height);

    var css = {
      left: offset.left,
      top: container.bottom
    };

    // Determine what the parent element is to use for calciulating the offset
    var $offsetParent = this.$dropdownParent;

    // For statically positoned elements, we need to get the element
    // that is determining the offset
    if ($offsetParent.css('position') === 'static') {
      $offsetParent = $offsetParent.offsetParent();
    }

    var parentOffset = $offsetParent.offset();

    css.top -= parentOffset.top;
    css.left -= parentOffset.left;

    if (!isCurrentlyAbove && !isCurrentlyBelow) {
      newDirection = 'below';
    }

    if (!enoughRoomBelow && enoughRoomAbove && !isCurrentlyAbove) {
      newDirection = 'above';
    } else if (!enoughRoomAbove && enoughRoomBelow && isCurrentlyAbove) {
      newDirection = 'below';
    }

    if (newDirection == 'above' ||
      (isCurrentlyAbove && newDirection !== 'below')) {
      css.top = container.top - parentOffset.top - dropdown.height;
    }

    if (newDirection != null) {
      this.$dropdown
        .removeClass('select2-dropdown--below select2-dropdown--above')
        .addClass('select2-dropdown--' + newDirection);
      this.$container
        .removeClass('select2-container--below select2-container--above')
        .addClass('select2-container--' + newDirection);
    }

    this.$dropdownContainer.css(css);
  };

  AttachBody.prototype._resizeDropdown = function () {
    var css = {
      width: this.$container.outerWidth(false) + 'px'
    };

    if (this.options.get('dropdownAutoWidth')) {
      css.minWidth = css.width;
      css.position = 'relative';
      css.width = 'auto';
    }

    this.$dropdown.css(css);
  };

  AttachBody.prototype._showDropdown = function (decorated) {
    this.$dropdownContainer.appendTo(this.$dropdownParent);

    this._positionDropdown();
    this._resizeDropdown();
  };

  return AttachBody;
});

S2.define('select2/dropdown/minimumResultsForSearch',[

], function () {
  function countResults (data) {
    var count = 0;

    for (var d = 0; d < data.length; d++) {
      var item = data[d];

      if (item.children) {
        count += countResults(item.children);
      } else {
        count++;
      }
    }

    return count;
  }

  function MinimumResultsForSearch (decorated, $element, options, dataAdapter) {
    this.minimumResultsForSearch = options.get('minimumResultsForSearch');

    if (this.minimumResultsForSearch < 0) {
      this.minimumResultsForSearch = Infinity;
    }

    decorated.call(this, $element, options, dataAdapter);
  }

  MinimumResultsForSearch.prototype.showSearch = function (decorated, params) {
    if (countResults(params.data.results) < this.minimumResultsForSearch) {
      return false;
    }

    return decorated.call(this, params);
  };

  return MinimumResultsForSearch;
});

S2.define('select2/dropdown/selectOnClose',[

], function () {
  function SelectOnClose () { }

  SelectOnClose.prototype.bind = function (decorated, container, $container) {
    var self = this;

    decorated.call(this, container, $container);

    container.on('close', function (params) {
      self._handleSelectOnClose(params);
    });
  };

  SelectOnClose.prototype._handleSelectOnClose = function (_, params) {
    if (params && params.originalSelect2Event != null) {
      var event = params.originalSelect2Event;

      // Don't select an item if the close event was triggered from a select or
      // unselect event
      if (event._type === 'select' || event._type === 'unselect') {
        return;
      }
    }

    var $highlightedResults = this.getHighlightedResults();

    // Only select highlighted results
    if ($highlightedResults.length < 1) {
      return;
    }

    var data = $highlightedResults.data('data');

    // Don't re-select already selected resulte
    if (
      (data.element != null && data.element.selected) ||
      (data.element == null && data.selected)
    ) {
      return;
    }

    this.trigger('select', {
        data: data
    });
  };

  return SelectOnClose;
});

S2.define('select2/dropdown/closeOnSelect',[

], function () {
  function CloseOnSelect () { }

  CloseOnSelect.prototype.bind = function (decorated, container, $container) {
    var self = this;

    decorated.call(this, container, $container);

    container.on('select', function (evt) {
      self._selectTriggered(evt);
    });

    container.on('unselect', function (evt) {
      self._selectTriggered(evt);
    });
  };

  CloseOnSelect.prototype._selectTriggered = function (_, evt) {
    var originalEvent = evt.originalEvent;

    // Don't close if the control key is being held
    if (originalEvent && originalEvent.ctrlKey) {
      return;
    }

    this.trigger('close', {
      originalEvent: originalEvent,
      originalSelect2Event: evt
    });
  };

  return CloseOnSelect;
});

S2.define('select2/i18n/en',[],function () {
  // English
  return {
    errorLoading: function () {
      return 'The results could not be loaded.';
    },
    inputTooLong: function (args) {
      var overChars = args.input.length - args.maximum;

      var message = 'Please delete ' + overChars + ' character';

      if (overChars != 1) {
        message += 's';
      }

      return message;
    },
    inputTooShort: function (args) {
      var remainingChars = args.minimum - args.input.length;

      var message = 'Please enter ' + remainingChars + ' or more characters';

      return message;
    },
    loadingMore: function () {
      return 'Loading more results…';
    },
    maximumSelected: function (args) {
      var message = 'You can only select ' + args.maximum + ' item';

      if (args.maximum != 1) {
        message += 's';
      }

      return message;
    },
    noResults: function () {
      return 'No results found';
    },
    searching: function () {
      return 'Searching…';
    }
  };
});

S2.define('select2/defaults',[
  'jquery',
  'require',

  './results',

  './selection/single',
  './selection/multiple',
  './selection/placeholder',
  './selection/allowClear',
  './selection/search',
  './selection/eventRelay',

  './utils',
  './translation',
  './diacritics',

  './data/select',
  './data/array',
  './data/ajax',
  './data/tags',
  './data/tokenizer',
  './data/minimumInputLength',
  './data/maximumInputLength',
  './data/maximumSelectionLength',

  './dropdown',
  './dropdown/search',
  './dropdown/hidePlaceholder',
  './dropdown/infiniteScroll',
  './dropdown/attachBody',
  './dropdown/minimumResultsForSearch',
  './dropdown/selectOnClose',
  './dropdown/closeOnSelect',

  './i18n/en'
], function ($, require,

             ResultsList,

             SingleSelection, MultipleSelection, Placeholder, AllowClear,
             SelectionSearch, EventRelay,

             Utils, Translation, DIACRITICS,

             SelectData, ArrayData, AjaxData, Tags, Tokenizer,
             MinimumInputLength, MaximumInputLength, MaximumSelectionLength,

             Dropdown, DropdownSearch, HidePlaceholder, InfiniteScroll,
             AttachBody, MinimumResultsForSearch, SelectOnClose, CloseOnSelect,

             EnglishTranslation) {
  function Defaults () {
    this.reset();
  }

  Defaults.prototype.apply = function (options) {
    options = $.extend(true, {}, this.defaults, options);

    if (options.dataAdapter == null) {
      if (options.ajax != null) {
        options.dataAdapter = AjaxData;
      } else if (options.data != null) {
        options.dataAdapter = ArrayData;
      } else {
        options.dataAdapter = SelectData;
      }

      if (options.minimumInputLength > 0) {
        options.dataAdapter = Utils.Decorate(
          options.dataAdapter,
          MinimumInputLength
        );
      }

      if (options.maximumInputLength > 0) {
        options.dataAdapter = Utils.Decorate(
          options.dataAdapter,
          MaximumInputLength
        );
      }

      if (options.maximumSelectionLength > 0) {
        options.dataAdapter = Utils.Decorate(
          options.dataAdapter,
          MaximumSelectionLength
        );
      }

      if (options.tags) {
        options.dataAdapter = Utils.Decorate(options.dataAdapter, Tags);
      }

      if (options.tokenSeparators != null || options.tokenizer != null) {
        options.dataAdapter = Utils.Decorate(
          options.dataAdapter,
          Tokenizer
        );
      }

      if (options.query != null) {
        var Query = require(options.amdBase + 'compat/query');

        options.dataAdapter = Utils.Decorate(
          options.dataAdapter,
          Query
        );
      }

      if (options.initSelection != null) {
        var InitSelection = require(options.amdBase + 'compat/initSelection');

        options.dataAdapter = Utils.Decorate(
          options.dataAdapter,
          InitSelection
        );
      }
    }

    if (options.resultsAdapter == null) {
      options.resultsAdapter = ResultsList;

      if (options.ajax != null) {
        options.resultsAdapter = Utils.Decorate(
          options.resultsAdapter,
          InfiniteScroll
        );
      }

      if (options.placeholder != null) {
        options.resultsAdapter = Utils.Decorate(
          options.resultsAdapter,
          HidePlaceholder
        );
      }

      if (options.selectOnClose) {
        options.resultsAdapter = Utils.Decorate(
          options.resultsAdapter,
          SelectOnClose
        );
      }
    }

    if (options.dropdownAdapter == null) {
      if (options.multiple) {
        options.dropdownAdapter = Dropdown;
      } else {
        var SearchableDropdown = Utils.Decorate(Dropdown, DropdownSearch);

        options.dropdownAdapter = SearchableDropdown;
      }

      if (options.minimumResultsForSearch !== 0) {
        options.dropdownAdapter = Utils.Decorate(
          options.dropdownAdapter,
          MinimumResultsForSearch
        );
      }

      if (options.closeOnSelect) {
        options.dropdownAdapter = Utils.Decorate(
          options.dropdownAdapter,
          CloseOnSelect
        );
      }

      if (
        options.dropdownCssClass != null ||
        options.dropdownCss != null ||
        options.adaptDropdownCssClass != null
      ) {
        var DropdownCSS = require(options.amdBase + 'compat/dropdownCss');

        options.dropdownAdapter = Utils.Decorate(
          options.dropdownAdapter,
          DropdownCSS
        );
      }

      options.dropdownAdapter = Utils.Decorate(
        options.dropdownAdapter,
        AttachBody
      );
    }

    if (options.selectionAdapter == null) {
      if (options.multiple) {
        options.selectionAdapter = MultipleSelection;
      } else {
        options.selectionAdapter = SingleSelection;
      }

      // Add the placeholder mixin if a placeholder was specified
      if (options.placeholder != null) {
        options.selectionAdapter = Utils.Decorate(
          options.selectionAdapter,
          Placeholder
        );
      }

      if (options.allowClear) {
        options.selectionAdapter = Utils.Decorate(
          options.selectionAdapter,
          AllowClear
        );
      }

      if (options.multiple) {
        options.selectionAdapter = Utils.Decorate(
          options.selectionAdapter,
          SelectionSearch
        );
      }

      if (
        options.containerCssClass != null ||
        options.containerCss != null ||
        options.adaptContainerCssClass != null
      ) {
        var ContainerCSS = require(options.amdBase + 'compat/containerCss');

        options.selectionAdapter = Utils.Decorate(
          options.selectionAdapter,
          ContainerCSS
        );
      }

      options.selectionAdapter = Utils.Decorate(
        options.selectionAdapter,
        EventRelay
      );
    }

    if (typeof options.language === 'string') {
      // Check if the language is specified with a region
      if (options.language.indexOf('-') > 0) {
        // Extract the region information if it is included
        var languageParts = options.language.split('-');
        var baseLanguage = languageParts[0];

        options.language = [options.language, baseLanguage];
      } else {
        options.language = [options.language];
      }
    }

    if ($.isArray(options.language)) {
      var languages = new Translation();
      options.language.push('en');

      var languageNames = options.language;

      for (var l = 0; l < languageNames.length; l++) {
        var name = languageNames[l];
        var language = {};

        try {
          // Try to load it with the original name
          language = Translation.loadPath(name);
        } catch (e) {
          try {
            // If we couldn't load it, check if it wasn't the full path
            name = this.defaults.amdLanguageBase + name;
            language = Translation.loadPath(name);
          } catch (ex) {
            // The translation could not be loaded at all. Sometimes this is
            // because of a configuration problem, other times this can be
            // because of how Select2 helps load all possible translation files.
            if (options.debug && window.console && console.warn) {
              console.warn(
                'Select2: The language file for "' + name + '" could not be ' +
                'automatically loaded. A fallback will be used instead.'
              );
            }

            continue;
          }
        }

        languages.extend(language);
      }

      options.translations = languages;
    } else {
      var baseTranslation = Translation.loadPath(
        this.defaults.amdLanguageBase + 'en'
      );
      var customTranslation = new Translation(options.language);

      customTranslation.extend(baseTranslation);

      options.translations = customTranslation;
    }

    return options;
  };

  Defaults.prototype.reset = function () {
    function stripDiacritics (text) {
      // Used 'uni range + named function' from http://jsperf.com/diacritics/18
      function match(a) {
        return DIACRITICS[a] || a;
      }

      return text.replace(/[^\u0000-\u007E]/g, match);
    }

    function matcher (params, data) {
      // Always return the object if there is nothing to compare
      if ($.trim(params.term) === '') {
        return data;
      }

      // Do a recursive check for options with children
      if (data.children && data.children.length > 0) {
        // Clone the data object if there are children
        // This is required as we modify the object to remove any non-matches
        var match = $.extend(true, {}, data);

        // Check each child of the option
        for (var c = data.children.length - 1; c >= 0; c--) {
          var child = data.children[c];

          var matches = matcher(params, child);

          // If there wasn't a match, remove the object in the array
          if (matches == null) {
            match.children.splice(c, 1);
          }
        }

        // If any children matched, return the new object
        if (match.children.length > 0) {
          return match;
        }

        // If there were no matching children, check just the plain object
        return matcher(params, match);
      }

      var original = stripDiacritics(data.text).toUpperCase();
      var term = stripDiacritics(params.term).toUpperCase();

      // Check if the text contains the term
      if (original.indexOf(term) > -1) {
        return data;
      }

      // If it doesn't contain the term, don't return anything
      return null;
    }

    this.defaults = {
      amdBase: './',
      amdLanguageBase: './i18n/',
      closeOnSelect: true,
      debug: false,
      dropdownAutoWidth: false,
      escapeMarkup: Utils.escapeMarkup,
      language: EnglishTranslation,
      matcher: matcher,
      minimumInputLength: 0,
      maximumInputLength: 0,
      maximumSelectionLength: 0,
      minimumResultsForSearch: 0,
      selectOnClose: false,
      sorter: function (data) {
        return data;
      },
      templateResult: function (result) {
        return result.text;
      },
      templateSelection: function (selection) {
        return selection.text;
      },
      theme: 'default',
      width: 'resolve'
    };
  };

  Defaults.prototype.set = function (key, value) {
    var camelKey = $.camelCase(key);

    var data = {};
    data[camelKey] = value;

    var convertedData = Utils._convertData(data);

    $.extend(this.defaults, convertedData);
  };

  var defaults = new Defaults();

  return defaults;
});

S2.define('select2/options',[
  'require',
  'jquery',
  './defaults',
  './utils'
], function (require, $, Defaults, Utils) {
  function Options (options, $element) {
    this.options = options;

    if ($element != null) {
      this.fromElement($element);
    }

    this.options = Defaults.apply(this.options);

    if ($element && $element.is('input')) {
      var InputCompat = require(this.get('amdBase') + 'compat/inputData');

      this.options.dataAdapter = Utils.Decorate(
        this.options.dataAdapter,
        InputCompat
      );
    }
  }

  Options.prototype.fromElement = function ($e) {
    var excludedData = ['select2'];

    if (this.options.multiple == null) {
      this.options.multiple = $e.prop('multiple');
    }

    if (this.options.disabled == null) {
      this.options.disabled = $e.prop('disabled');
    }

    if (this.options.language == null) {
      if ($e.prop('lang')) {
        this.options.language = $e.prop('lang').toLowerCase();
      } else if ($e.closest('[lang]').prop('lang')) {
        this.options.language = $e.closest('[lang]').prop('lang');
      }
    }

    if (this.options.dir == null) {
      if ($e.prop('dir')) {
        this.options.dir = $e.prop('dir');
      } else if ($e.closest('[dir]').prop('dir')) {
        this.options.dir = $e.closest('[dir]').prop('dir');
      } else {
        this.options.dir = 'ltr';
      }
    }

    $e.prop('disabled', this.options.disabled);
    $e.prop('multiple', this.options.multiple);

    if ($e.data('select2Tags')) {
      if (this.options.debug && window.console && console.warn) {
        console.warn(
          'Select2: The `data-select2-tags` attribute has been changed to ' +
          'use the `data-data` and `data-tags="true"` attributes and will be ' +
          'removed in future versions of Select2.'
        );
      }

      $e.data('data', $e.data('select2Tags'));
      $e.data('tags', true);
    }

    if ($e.data('ajaxUrl')) {
      if (this.options.debug && window.console && console.warn) {
        console.warn(
          'Select2: The `data-ajax-url` attribute has been changed to ' +
          '`data-ajax--url` and support for the old attribute will be removed' +
          ' in future versions of Select2.'
        );
      }

      $e.attr('ajax--url', $e.data('ajaxUrl'));
      $e.data('ajax--url', $e.data('ajaxUrl'));
    }

    var dataset = {};

    // Prefer the element's `dataset` attribute if it exists
    // jQuery 1.x does not correctly handle data attributes with multiple dashes
    if ($.fn.jquery && $.fn.jquery.substr(0, 2) == '1.' && $e[0].dataset) {
      dataset = $.extend(true, {}, $e[0].dataset, $e.data());
    } else {
      dataset = $e.data();
    }

    var data = $.extend(true, {}, dataset);

    data = Utils._convertData(data);

    for (var key in data) {
      if ($.inArray(key, excludedData) > -1) {
        continue;
      }

      if ($.isPlainObject(this.options[key])) {
        $.extend(this.options[key], data[key]);
      } else {
        this.options[key] = data[key];
      }
    }

    return this;
  };

  Options.prototype.get = function (key) {
    return this.options[key];
  };

  Options.prototype.set = function (key, val) {
    this.options[key] = val;
  };

  return Options;
});

S2.define('select2/core',[
  'jquery',
  './options',
  './utils',
  './keys'
], function ($, Options, Utils, KEYS) {
  var Select2 = function ($element, options) {
    if ($element.data('select2') != null) {
      $element.data('select2').destroy();
    }

    this.$element = $element;

    this.id = this._generateId($element);

    options = options || {};

    this.options = new Options(options, $element);

    Select2.__super__.constructor.call(this);

    // Set up the tabindex

    var tabindex = $element.attr('tabindex') || 0;
    $element.data('old-tabindex', tabindex);
    $element.attr('tabindex', '-1');

    // Set up containers and adapters

    var DataAdapter = this.options.get('dataAdapter');
    this.dataAdapter = new DataAdapter($element, this.options);

    var $container = this.render();

    this._placeContainer($container);

    var SelectionAdapter = this.options.get('selectionAdapter');
    this.selection = new SelectionAdapter($element, this.options);
    this.$selection = this.selection.render();

    this.selection.position(this.$selection, $container);

    var DropdownAdapter = this.options.get('dropdownAdapter');
    this.dropdown = new DropdownAdapter($element, this.options);
    this.$dropdown = this.dropdown.render();

    this.dropdown.position(this.$dropdown, $container);

    var ResultsAdapter = this.options.get('resultsAdapter');
    this.results = new ResultsAdapter($element, this.options, this.dataAdapter);
    this.$results = this.results.render();

    this.results.position(this.$results, this.$dropdown);

    // Bind events

    var self = this;

    // Bind the container to all of the adapters
    this._bindAdapters();

    // Register any DOM event handlers
    this._registerDomEvents();

    // Register any internal event handlers
    this._registerDataEvents();
    this._registerSelectionEvents();
    this._registerDropdownEvents();
    this._registerResultsEvents();
    this._registerEvents();

    // Set the initial state
    this.dataAdapter.current(function (initialData) {
      self.trigger('selection:update', {
        data: initialData
      });
    });

    // Hide the original select
    $element.addClass('select2-hidden-accessible');
    $element.attr('aria-hidden', 'true');

    // Synchronize any monitored attributes
    this._syncAttributes();

    $element.data('select2', this);
  };

  Utils.Extend(Select2, Utils.Observable);

  Select2.prototype._generateId = function ($element) {
    var id = '';

    if ($element.attr('id') != null) {
      id = $element.attr('id');
    } else if ($element.attr('name') != null) {
      id = $element.attr('name') + '-' + Utils.generateChars(2);
    } else {
      id = Utils.generateChars(4);
    }

    id = id.replace(/(:|\.|\[|\]|,)/g, '');
    id = 'select2-' + id;

    return id;
  };

  Select2.prototype._placeContainer = function ($container) {
    $container.insertAfter(this.$element);

    var width = this._resolveWidth(this.$element, this.options.get('width'));

    if (width != null) {
      $container.css('width', width);
    }
  };

  Select2.prototype._resolveWidth = function ($element, method) {
    var WIDTH = /^width:(([-+]?([0-9]*\.)?[0-9]+)(px|em|ex|%|in|cm|mm|pt|pc))/i;

    if (method == 'resolve') {
      var styleWidth = this._resolveWidth($element, 'style');

      if (styleWidth != null) {
        return styleWidth;
      }

      return this._resolveWidth($element, 'element');
    }

    if (method == 'element') {
      var elementWidth = $element.outerWidth(false);

      if (elementWidth <= 0) {
        return 'auto';
      }

      return elementWidth + 'px';
    }

    if (method == 'style') {
      var style = $element.attr('style');

      if (typeof(style) !== 'string') {
        return null;
      }

      var attrs = style.split(';');

      for (var i = 0, l = attrs.length; i < l; i = i + 1) {
        var attr = attrs[i].replace(/\s/g, '');
        var matches = attr.match(WIDTH);

        if (matches !== null && matches.length >= 1) {
          return matches[1];
        }
      }

      return null;
    }

    return method;
  };

  Select2.prototype._bindAdapters = function () {
    this.dataAdapter.bind(this, this.$container);
    this.selection.bind(this, this.$container);

    this.dropdown.bind(this, this.$container);
    this.results.bind(this, this.$container);
  };

  Select2.prototype._registerDomEvents = function () {
    var self = this;

    this.$element.on('change.select2', function () {
      self.dataAdapter.current(function (data) {
        self.trigger('selection:update', {
          data: data
        });
      });
    });

    this.$element.on('focus.select2', function (evt) {
      self.trigger('focus', evt);
    });

    this._syncA = Utils.bind(this._syncAttributes, this);
    this._syncS = Utils.bind(this._syncSubtree, this);

    if (this.$element[0].attachEvent) {
      this.$element[0].attachEvent('onpropertychange', this._syncA);
    }

    var observer = window.MutationObserver ||
      window.WebKitMutationObserver ||
      window.MozMutationObserver
    ;

    if (observer != null) {
      this._observer = new observer(function (mutations) {
        $.each(mutations, self._syncA);
        $.each(mutations, self._syncS);
      });
      this._observer.observe(this.$element[0], {
        attributes: true,
        childList: true,
        subtree: false
      });
    } else if (this.$element[0].addEventListener) {
      this.$element[0].addEventListener(
        'DOMAttrModified',
        self._syncA,
        false
      );
      this.$element[0].addEventListener(
        'DOMNodeInserted',
        self._syncS,
        false
      );
      this.$element[0].addEventListener(
        'DOMNodeRemoved',
        self._syncS,
        false
      );
    }
  };

  Select2.prototype._registerDataEvents = function () {
    var self = this;

    this.dataAdapter.on('*', function (name, params) {
      self.trigger(name, params);
    });
  };

  Select2.prototype._registerSelectionEvents = function () {
    var self = this;
    var nonRelayEvents = ['toggle', 'focus'];

    this.selection.on('toggle', function () {
      self.toggleDropdown();
    });

    this.selection.on('focus', function (params) {
      self.focus(params);
    });

    this.selection.on('*', function (name, params) {
      if ($.inArray(name, nonRelayEvents) !== -1) {
        return;
      }

      self.trigger(name, params);
    });
  };

  Select2.prototype._registerDropdownEvents = function () {
    var self = this;

    this.dropdown.on('*', function (name, params) {
      self.trigger(name, params);
    });
  };

  Select2.prototype._registerResultsEvents = function () {
    var self = this;

    this.results.on('*', function (name, params) {
      self.trigger(name, params);
    });
  };

  Select2.prototype._registerEvents = function () {
    var self = this;

    this.on('open', function () {
      self.$container.addClass('select2-container--open');
    });

    this.on('close', function () {
      self.$container.removeClass('select2-container--open');
    });

    this.on('enable', function () {
      self.$container.removeClass('select2-container--disabled');
    });

    this.on('disable', function () {
      self.$container.addClass('select2-container--disabled');
    });

    this.on('blur', function () {
      self.$container.removeClass('select2-container--focus');
    });

    this.on('query', function (params) {
      if (!self.isOpen()) {
        self.trigger('open', {});
      }

      this.dataAdapter.query(params, function (data) {
        self.trigger('results:all', {
          data: data,
          query: params
        });
      });
    });

    this.on('query:append', function (params) {
      this.dataAdapter.query(params, function (data) {
        self.trigger('results:append', {
          data: data,
          query: params
        });
      });
    });

    this.on('keypress', function (evt) {
      var key = evt.which;

      if (self.isOpen()) {
        if (key === KEYS.ESC || key === KEYS.TAB ||
            (key === KEYS.UP && evt.altKey)) {
          self.close();

          evt.preventDefault();
        } else if (key === KEYS.ENTER) {
          self.trigger('results:select', {});

          evt.preventDefault();
        } else if ((key === KEYS.SPACE && evt.ctrlKey)) {
          self.trigger('results:toggle', {});

          evt.preventDefault();
        } else if (key === KEYS.UP) {
          self.trigger('results:previous', {});

          evt.preventDefault();
        } else if (key === KEYS.DOWN) {
          self.trigger('results:next', {});

          evt.preventDefault();
        }
      } else {
        if (key === KEYS.ENTER || key === KEYS.SPACE ||
            (key === KEYS.DOWN && evt.altKey)) {
          self.open();

          evt.preventDefault();
        }
      }
    });
  };

  Select2.prototype._syncAttributes = function () {
    this.options.set('disabled', this.$element.prop('disabled'));

    if (this.options.get('disabled')) {
      if (this.isOpen()) {
        this.close();
      }

      this.trigger('disable', {});
    } else {
      this.trigger('enable', {});
    }
  };

  Select2.prototype._syncSubtree = function (evt, mutations) {
    var changed = false;
    var self = this;

    // Ignore any mutation events raised for elements that aren't options or
    // optgroups. This handles the case when the select element is destroyed
    if (
      evt && evt.target && (
        evt.target.nodeName !== 'OPTION' && evt.target.nodeName !== 'OPTGROUP'
      )
    ) {
      return;
    }

    if (!mutations) {
      // If mutation events aren't supported, then we can only assume that the
      // change affected the selections
      changed = true;
    } else if (mutations.addedNodes && mutations.addedNodes.length > 0) {
      for (var n = 0; n < mutations.addedNodes.length; n++) {
        var node = mutations.addedNodes[n];

        if (node.selected) {
          changed = true;
        }
      }
    } else if (mutations.removedNodes && mutations.removedNodes.length > 0) {
      changed = true;
    }

    // Only re-pull the data if we think there is a change
    if (changed) {
      this.dataAdapter.current(function (currentData) {
        self.trigger('selection:update', {
          data: currentData
        });
      });
    }
  };

  /**
   * Override the trigger method to automatically trigger pre-events when
   * there are events that can be prevented.
   */
  Select2.prototype.trigger = function (name, args) {
    var actualTrigger = Select2.__super__.trigger;
    var preTriggerMap = {
      'open': 'opening',
      'close': 'closing',
      'select': 'selecting',
      'unselect': 'unselecting'
    };

    if (args === undefined) {
      args = {};
    }

    if (name in preTriggerMap) {
      var preTriggerName = preTriggerMap[name];
      var preTriggerArgs = {
        prevented: false,
        name: name,
        args: args
      };

      actualTrigger.call(this, preTriggerName, preTriggerArgs);

      if (preTriggerArgs.prevented) {
        args.prevented = true;

        return;
      }
    }

    actualTrigger.call(this, name, args);
  };

  Select2.prototype.toggleDropdown = function () {
    if (this.options.get('disabled')) {
      return;
    }

    if (this.isOpen()) {
      this.close();
    } else {
      this.open();
    }
  };

  Select2.prototype.open = function () {
    if (this.isOpen()) {
      return;
    }

    this.trigger('query', {});
  };

  Select2.prototype.close = function () {
    if (!this.isOpen()) {
      return;
    }

    this.trigger('close', {});
  };

  Select2.prototype.isOpen = function () {
    return this.$container.hasClass('select2-container--open');
  };

  Select2.prototype.hasFocus = function () {
    return this.$container.hasClass('select2-container--focus');
  };

  Select2.prototype.focus = function (data) {
    // No need to re-trigger focus events if we are already focused
    if (this.hasFocus()) {
      return;
    }

    this.$container.addClass('select2-container--focus');
    this.trigger('focus', {});
  };

  Select2.prototype.enable = function (args) {
    if (this.options.get('debug') && window.console && console.warn) {
      console.warn(
        'Select2: The `select2("enable")` method has been deprecated and will' +
        ' be removed in later Select2 versions. Use $element.prop("disabled")' +
        ' instead.'
      );
    }

    if (args == null || args.length === 0) {
      args = [true];
    }

    var disabled = !args[0];

    this.$element.prop('disabled', disabled);
  };

  Select2.prototype.data = function () {
    if (this.options.get('debug') &&
        arguments.length > 0 && window.console && console.warn) {
      console.warn(
        'Select2: Data can no longer be set using `select2("data")`. You ' +
        'should consider setting the value instead using `$element.val()`.'
      );
    }

    var data = [];

    this.dataAdapter.current(function (currentData) {
      data = currentData;
    });

    return data;
  };

  Select2.prototype.val = function (args) {
    if (this.options.get('debug') && window.console && console.warn) {
      console.warn(
        'Select2: The `select2("val")` method has been deprecated and will be' +
        ' removed in later Select2 versions. Use $element.val() instead.'
      );
    }

    if (args == null || args.length === 0) {
      return this.$element.val();
    }

    var newVal = args[0];

    if ($.isArray(newVal)) {
      newVal = $.map(newVal, function (obj) {
        return obj.toString();
      });
    }

    this.$element.val(newVal).trigger('change');
  };

  Select2.prototype.destroy = function () {
    this.$container.remove();

    if (this.$element[0].detachEvent) {
      this.$element[0].detachEvent('onpropertychange', this._syncA);
    }

    if (this._observer != null) {
      this._observer.disconnect();
      this._observer = null;
    } else if (this.$element[0].removeEventListener) {
      this.$element[0]
        .removeEventListener('DOMAttrModified', this._syncA, false);
      this.$element[0]
        .removeEventListener('DOMNodeInserted', this._syncS, false);
      this.$element[0]
        .removeEventListener('DOMNodeRemoved', this._syncS, false);
    }

    this._syncA = null;
    this._syncS = null;

    this.$element.off('.select2');
    this.$element.attr('tabindex', this.$element.data('old-tabindex'));

    this.$element.removeClass('select2-hidden-accessible');
    this.$element.attr('aria-hidden', 'false');
    this.$element.removeData('select2');

    this.dataAdapter.destroy();
    this.selection.destroy();
    this.dropdown.destroy();
    this.results.destroy();

    this.dataAdapter = null;
    this.selection = null;
    this.dropdown = null;
    this.results = null;
  };

  Select2.prototype.render = function () {
    var $container = $(
      '<span class="select2 select2-container">' +
        '<span class="selection"></span>' +
        '<span class="dropdown-wrapper" aria-hidden="true"></span>' +
      '</span>'
    );

    $container.attr('dir', this.options.get('dir'));

    this.$container = $container;

    this.$container.addClass('select2-container--' + this.options.get('theme'));

    $container.data('element', this.$element);

    return $container;
  };

  return Select2;
});

S2.define('jquery-mousewheel',[
  'jquery'
], function ($) {
  // Used to shim jQuery.mousewheel for non-full builds.
  return $;
});

S2.define('jquery.select2',[
  'jquery',
  'jquery-mousewheel',

  './select2/core',
  './select2/defaults'
], function ($, _, Select2, Defaults) {
  if ($.fn.select2 == null) {
    // All methods that should return the element
    var thisMethods = ['open', 'close', 'destroy'];

    $.fn.select2 = function (options) {
      options = options || {};

      if (typeof options === 'object') {
        this.each(function () {
          var instanceOptions = $.extend(true, {}, options);

          var instance = new Select2($(this), instanceOptions);
        });

        return this;
      } else if (typeof options === 'string') {
        var ret;
        var args = Array.prototype.slice.call(arguments, 1);

        this.each(function () {
          var instance = $(this).data('select2');

          if (instance == null && window.console && console.error) {
            console.error(
              'The select2(\'' + options + '\') method was called on an ' +
              'element that is not using Select2.'
            );
          }

          ret = instance[options].apply(instance, args);
        });

        // Check if we should be returning `this`
        if ($.inArray(options, thisMethods) > -1) {
          return this;
        }

        return ret;
      } else {
        throw new Error('Invalid arguments for Select2: ' + options);
      }
    };
  }

  if ($.fn.select2.defaults == null) {
    $.fn.select2.defaults = Defaults;
  }

  return Select2;
});

  // Return the AMD loader configuration so it can be used outside of this file
  return {
    define: S2.define,
    require: S2.require
  };
}());

  // Autoload the jQuery bindings
  // We know that all of the modules exist above this, so we're safe
  var select2 = S2.require('jquery.select2');

  // Hold the AMD module references on the jQuery function that was just loaded
  // This allows Select2 to use the internal loader outside of this file, such
  // as in the language files.
  jQuery.fn.select2.amd = S2;

  // Return the Select2 instance for anyone who is importing it.
  return select2;
}));

},{"jquery":9}],13:[function(require,module,exports){
/*
     _ _      _       _
 ___| (_) ___| | __  (_)___
/ __| | |/ __| |/ /  | / __|
\__ \ | | (__|   < _ | \__ \
|___/_|_|\___|_|\_(_)/ |___/
                   |__/

 Version: 1.8.1
  Author: Ken Wheeler
 Website: http://kenwheeler.github.io
    Docs: http://kenwheeler.github.io/slick
    Repo: http://github.com/kenwheeler/slick
  Issues: http://github.com/kenwheeler/slick/issues

 */
/* global window, document, define, jQuery, setInterval, clearInterval */
;(function(factory) {
    'use strict';
    if (typeof define === 'function' && define.amd) {
        define(['jquery'], factory);
    } else if (typeof exports !== 'undefined') {
        module.exports = factory(require('jquery'));
    } else {
        factory(jQuery);
    }

}(function($) {
    'use strict';
    var Slick = window.Slick || {};

    Slick = (function() {

        var instanceUid = 0;

        function Slick(element, settings) {

            var _ = this, dataSettings;

            _.defaults = {
                accessibility: true,
                adaptiveHeight: false,
                appendArrows: $(element),
                appendDots: $(element),
                arrows: true,
                asNavFor: null,
                prevArrow: '<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',
                nextArrow: '<button class="slick-next" aria-label="Next" type="button">Next</button>',
                autoplay: false,
                autoplaySpeed: 3000,
                centerMode: false,
                centerPadding: '50px',
                cssEase: 'ease',
                customPaging: function(slider, i) {
                    return $('<button type="button" />').text(i + 1);
                },
                dots: false,
                dotsClass: 'slick-dots',
                draggable: true,
                easing: 'linear',
                edgeFriction: 0.35,
                fade: false,
                focusOnSelect: false,
                focusOnChange: false,
                infinite: true,
                initialSlide: 0,
                lazyLoad: 'ondemand',
                mobileFirst: false,
                pauseOnHover: true,
                pauseOnFocus: true,
                pauseOnDotsHover: false,
                respondTo: 'window',
                responsive: null,
                rows: 1,
                rtl: false,
                slide: '',
                slidesPerRow: 1,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 500,
                swipe: true,
                swipeToSlide: false,
                touchMove: true,
                touchThreshold: 5,
                useCSS: true,
                useTransform: true,
                variableWidth: false,
                vertical: false,
                verticalSwiping: false,
                waitForAnimate: true,
                zIndex: 1000
            };

            _.initials = {
                animating: false,
                dragging: false,
                autoPlayTimer: null,
                currentDirection: 0,
                currentLeft: null,
                currentSlide: 0,
                direction: 1,
                $dots: null,
                listWidth: null,
                listHeight: null,
                loadIndex: 0,
                $nextArrow: null,
                $prevArrow: null,
                scrolling: false,
                slideCount: null,
                slideWidth: null,
                $slideTrack: null,
                $slides: null,
                sliding: false,
                slideOffset: 0,
                swipeLeft: null,
                swiping: false,
                $list: null,
                touchObject: {},
                transformsEnabled: false,
                unslicked: false
            };

            $.extend(_, _.initials);

            _.activeBreakpoint = null;
            _.animType = null;
            _.animProp = null;
            _.breakpoints = [];
            _.breakpointSettings = [];
            _.cssTransitions = false;
            _.focussed = false;
            _.interrupted = false;
            _.hidden = 'hidden';
            _.paused = true;
            _.positionProp = null;
            _.respondTo = null;
            _.rowCount = 1;
            _.shouldClick = true;
            _.$slider = $(element);
            _.$slidesCache = null;
            _.transformType = null;
            _.transitionType = null;
            _.visibilityChange = 'visibilitychange';
            _.windowWidth = 0;
            _.windowTimer = null;

            dataSettings = $(element).data('slick') || {};

            _.options = $.extend({}, _.defaults, settings, dataSettings);

            _.currentSlide = _.options.initialSlide;

            _.originalSettings = _.options;

            if (typeof document.mozHidden !== 'undefined') {
                _.hidden = 'mozHidden';
                _.visibilityChange = 'mozvisibilitychange';
            } else if (typeof document.webkitHidden !== 'undefined') {
                _.hidden = 'webkitHidden';
                _.visibilityChange = 'webkitvisibilitychange';
            }

            _.autoPlay = $.proxy(_.autoPlay, _);
            _.autoPlayClear = $.proxy(_.autoPlayClear, _);
            _.autoPlayIterator = $.proxy(_.autoPlayIterator, _);
            _.changeSlide = $.proxy(_.changeSlide, _);
            _.clickHandler = $.proxy(_.clickHandler, _);
            _.selectHandler = $.proxy(_.selectHandler, _);
            _.setPosition = $.proxy(_.setPosition, _);
            _.swipeHandler = $.proxy(_.swipeHandler, _);
            _.dragHandler = $.proxy(_.dragHandler, _);
            _.keyHandler = $.proxy(_.keyHandler, _);

            _.instanceUid = instanceUid++;

            // A simple way to check for HTML strings
            // Strict HTML recognition (must start with <)
            // Extracted from jQuery v1.11 source
            _.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/;


            _.registerBreakpoints();
            _.init(true);

        }

        return Slick;

    }());

    Slick.prototype.activateADA = function() {
        var _ = this;

        _.$slideTrack.find('.slick-active').attr({
            'aria-hidden': 'false'
        }).find('a, input, button, select').attr({
            'tabindex': '0'
        });

    };

    Slick.prototype.addSlide = Slick.prototype.slickAdd = function(markup, index, addBefore) {

        var _ = this;

        if (typeof(index) === 'boolean') {
            addBefore = index;
            index = null;
        } else if (index < 0 || (index >= _.slideCount)) {
            return false;
        }

        _.unload();

        if (typeof(index) === 'number') {
            if (index === 0 && _.$slides.length === 0) {
                $(markup).appendTo(_.$slideTrack);
            } else if (addBefore) {
                $(markup).insertBefore(_.$slides.eq(index));
            } else {
                $(markup).insertAfter(_.$slides.eq(index));
            }
        } else {
            if (addBefore === true) {
                $(markup).prependTo(_.$slideTrack);
            } else {
                $(markup).appendTo(_.$slideTrack);
            }
        }

        _.$slides = _.$slideTrack.children(this.options.slide);

        _.$slideTrack.children(this.options.slide).detach();

        _.$slideTrack.append(_.$slides);

        _.$slides.each(function(index, element) {
            $(element).attr('data-slick-index', index);
        });

        _.$slidesCache = _.$slides;

        _.reinit();

    };

    Slick.prototype.animateHeight = function() {
        var _ = this;
        if (_.options.slidesToShow === 1 && _.options.adaptiveHeight === true && _.options.vertical === false) {
            var targetHeight = _.$slides.eq(_.currentSlide).outerHeight(true);
            _.$list.animate({
                height: targetHeight
            }, _.options.speed);
        }
    };

    Slick.prototype.animateSlide = function(targetLeft, callback) {

        var animProps = {},
            _ = this;

        _.animateHeight();

        if (_.options.rtl === true && _.options.vertical === false) {
            targetLeft = -targetLeft;
        }
        if (_.transformsEnabled === false) {
            if (_.options.vertical === false) {
                _.$slideTrack.animate({
                    left: targetLeft
                }, _.options.speed, _.options.easing, callback);
            } else {
                _.$slideTrack.animate({
                    top: targetLeft
                }, _.options.speed, _.options.easing, callback);
            }

        } else {

            if (_.cssTransitions === false) {
                if (_.options.rtl === true) {
                    _.currentLeft = -(_.currentLeft);
                }
                $({
                    animStart: _.currentLeft
                }).animate({
                    animStart: targetLeft
                }, {
                    duration: _.options.speed,
                    easing: _.options.easing,
                    step: function(now) {
                        now = Math.ceil(now);
                        if (_.options.vertical === false) {
                            animProps[_.animType] = 'translate(' +
                                now + 'px, 0px)';
                            _.$slideTrack.css(animProps);
                        } else {
                            animProps[_.animType] = 'translate(0px,' +
                                now + 'px)';
                            _.$slideTrack.css(animProps);
                        }
                    },
                    complete: function() {
                        if (callback) {
                            callback.call();
                        }
                    }
                });

            } else {

                _.applyTransition();
                targetLeft = Math.ceil(targetLeft);

                if (_.options.vertical === false) {
                    animProps[_.animType] = 'translate3d(' + targetLeft + 'px, 0px, 0px)';
                } else {
                    animProps[_.animType] = 'translate3d(0px,' + targetLeft + 'px, 0px)';
                }
                _.$slideTrack.css(animProps);

                if (callback) {
                    setTimeout(function() {

                        _.disableTransition();

                        callback.call();
                    }, _.options.speed);
                }

            }

        }

    };

    Slick.prototype.getNavTarget = function() {

        var _ = this,
            asNavFor = _.options.asNavFor;

        if ( asNavFor && asNavFor !== null ) {
            asNavFor = $(asNavFor).not(_.$slider);
        }

        return asNavFor;

    };

    Slick.prototype.asNavFor = function(index) {

        var _ = this,
            asNavFor = _.getNavTarget();

        if ( asNavFor !== null && typeof asNavFor === 'object' ) {
            asNavFor.each(function() {
                var target = $(this).slick('getSlick');
                if(!target.unslicked) {
                    target.slideHandler(index, true);
                }
            });
        }

    };

    Slick.prototype.applyTransition = function(slide) {

        var _ = this,
            transition = {};

        if (_.options.fade === false) {
            transition[_.transitionType] = _.transformType + ' ' + _.options.speed + 'ms ' + _.options.cssEase;
        } else {
            transition[_.transitionType] = 'opacity ' + _.options.speed + 'ms ' + _.options.cssEase;
        }

        if (_.options.fade === false) {
            _.$slideTrack.css(transition);
        } else {
            _.$slides.eq(slide).css(transition);
        }

    };

    Slick.prototype.autoPlay = function() {

        var _ = this;

        _.autoPlayClear();

        if ( _.slideCount > _.options.slidesToShow ) {
            _.autoPlayTimer = setInterval( _.autoPlayIterator, _.options.autoplaySpeed );
        }

    };

    Slick.prototype.autoPlayClear = function() {

        var _ = this;

        if (_.autoPlayTimer) {
            clearInterval(_.autoPlayTimer);
        }

    };

    Slick.prototype.autoPlayIterator = function() {

        var _ = this,
            slideTo = _.currentSlide + _.options.slidesToScroll;

        if ( !_.paused && !_.interrupted && !_.focussed ) {

            if ( _.options.infinite === false ) {

                if ( _.direction === 1 && ( _.currentSlide + 1 ) === ( _.slideCount - 1 )) {
                    _.direction = 0;
                }

                else if ( _.direction === 0 ) {

                    slideTo = _.currentSlide - _.options.slidesToScroll;

                    if ( _.currentSlide - 1 === 0 ) {
                        _.direction = 1;
                    }

                }

            }

            _.slideHandler( slideTo );

        }

    };

    Slick.prototype.buildArrows = function() {

        var _ = this;

        if (_.options.arrows === true ) {

            _.$prevArrow = $(_.options.prevArrow).addClass('slick-arrow');
            _.$nextArrow = $(_.options.nextArrow).addClass('slick-arrow');

            if( _.slideCount > _.options.slidesToShow ) {

                _.$prevArrow.removeClass('slick-hidden').removeAttr('aria-hidden tabindex');
                _.$nextArrow.removeClass('slick-hidden').removeAttr('aria-hidden tabindex');

                if (_.htmlExpr.test(_.options.prevArrow)) {
                    _.$prevArrow.prependTo(_.options.appendArrows);
                }

                if (_.htmlExpr.test(_.options.nextArrow)) {
                    _.$nextArrow.appendTo(_.options.appendArrows);
                }

                if (_.options.infinite !== true) {
                    _.$prevArrow
                        .addClass('slick-disabled')
                        .attr('aria-disabled', 'true');
                }

            } else {

                _.$prevArrow.add( _.$nextArrow )

                    .addClass('slick-hidden')
                    .attr({
                        'aria-disabled': 'true',
                        'tabindex': '-1'
                    });

            }

        }

    };

    Slick.prototype.buildDots = function() {

        var _ = this,
            i, dot;

        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {

            _.$slider.addClass('slick-dotted');

            dot = $('<ul />').addClass(_.options.dotsClass);

            for (i = 0; i <= _.getDotCount(); i += 1) {
                dot.append($('<li />').append(_.options.customPaging.call(this, _, i)));
            }

            _.$dots = dot.appendTo(_.options.appendDots);

            _.$dots.find('li').first().addClass('slick-active');

        }

    };

    Slick.prototype.buildOut = function() {

        var _ = this;

        _.$slides =
            _.$slider
                .children( _.options.slide + ':not(.slick-cloned)')
                .addClass('slick-slide');

        _.slideCount = _.$slides.length;

        _.$slides.each(function(index, element) {
            $(element)
                .attr('data-slick-index', index)
                .data('originalStyling', $(element).attr('style') || '');
        });

        _.$slider.addClass('slick-slider');

        _.$slideTrack = (_.slideCount === 0) ?
            $('<div class="slick-track"/>').appendTo(_.$slider) :
            _.$slides.wrapAll('<div class="slick-track"/>').parent();

        _.$list = _.$slideTrack.wrap(
            '<div class="slick-list"/>').parent();
        _.$slideTrack.css('opacity', 0);

        if (_.options.centerMode === true || _.options.swipeToSlide === true) {
            _.options.slidesToScroll = 1;
        }

        $('img[data-lazy]', _.$slider).not('[src]').addClass('slick-loading');

        _.setupInfinite();

        _.buildArrows();

        _.buildDots();

        _.updateDots();


        _.setSlideClasses(typeof _.currentSlide === 'number' ? _.currentSlide : 0);

        if (_.options.draggable === true) {
            _.$list.addClass('draggable');
        }

    };

    Slick.prototype.buildRows = function() {

        var _ = this, a, b, c, newSlides, numOfSlides, originalSlides,slidesPerSection;

        newSlides = document.createDocumentFragment();
        originalSlides = _.$slider.children();

        if(_.options.rows > 0) {

            slidesPerSection = _.options.slidesPerRow * _.options.rows;
            numOfSlides = Math.ceil(
                originalSlides.length / slidesPerSection
            );

            for(a = 0; a < numOfSlides; a++){
                var slide = document.createElement('div');
                for(b = 0; b < _.options.rows; b++) {
                    var row = document.createElement('div');
                    for(c = 0; c < _.options.slidesPerRow; c++) {
                        var target = (a * slidesPerSection + ((b * _.options.slidesPerRow) + c));
                        if (originalSlides.get(target)) {
                            row.appendChild(originalSlides.get(target));
                        }
                    }
                    slide.appendChild(row);
                }
                newSlides.appendChild(slide);
            }

            _.$slider.empty().append(newSlides);
            _.$slider.children().children().children()
                .css({
                    'width':(100 / _.options.slidesPerRow) + '%',
                    'display': 'inline-block'
                });

        }

    };

    Slick.prototype.checkResponsive = function(initial, forceUpdate) {

        var _ = this,
            breakpoint, targetBreakpoint, respondToWidth, triggerBreakpoint = false;
        var sliderWidth = _.$slider.width();
        var windowWidth = window.innerWidth || $(window).width();

        if (_.respondTo === 'window') {
            respondToWidth = windowWidth;
        } else if (_.respondTo === 'slider') {
            respondToWidth = sliderWidth;
        } else if (_.respondTo === 'min') {
            respondToWidth = Math.min(windowWidth, sliderWidth);
        }

        if ( _.options.responsive &&
            _.options.responsive.length &&
            _.options.responsive !== null) {

            targetBreakpoint = null;

            for (breakpoint in _.breakpoints) {
                if (_.breakpoints.hasOwnProperty(breakpoint)) {
                    if (_.originalSettings.mobileFirst === false) {
                        if (respondToWidth < _.breakpoints[breakpoint]) {
                            targetBreakpoint = _.breakpoints[breakpoint];
                        }
                    } else {
                        if (respondToWidth > _.breakpoints[breakpoint]) {
                            targetBreakpoint = _.breakpoints[breakpoint];
                        }
                    }
                }
            }

            if (targetBreakpoint !== null) {
                if (_.activeBreakpoint !== null) {
                    if (targetBreakpoint !== _.activeBreakpoint || forceUpdate) {
                        _.activeBreakpoint =
                            targetBreakpoint;
                        if (_.breakpointSettings[targetBreakpoint] === 'unslick') {
                            _.unslick(targetBreakpoint);
                        } else {
                            _.options = $.extend({}, _.originalSettings,
                                _.breakpointSettings[
                                    targetBreakpoint]);
                            if (initial === true) {
                                _.currentSlide = _.options.initialSlide;
                            }
                            _.refresh(initial);
                        }
                        triggerBreakpoint = targetBreakpoint;
                    }
                } else {
                    _.activeBreakpoint = targetBreakpoint;
                    if (_.breakpointSettings[targetBreakpoint] === 'unslick') {
                        _.unslick(targetBreakpoint);
                    } else {
                        _.options = $.extend({}, _.originalSettings,
                            _.breakpointSettings[
                                targetBreakpoint]);
                        if (initial === true) {
                            _.currentSlide = _.options.initialSlide;
                        }
                        _.refresh(initial);
                    }
                    triggerBreakpoint = targetBreakpoint;
                }
            } else {
                if (_.activeBreakpoint !== null) {
                    _.activeBreakpoint = null;
                    _.options = _.originalSettings;
                    if (initial === true) {
                        _.currentSlide = _.options.initialSlide;
                    }
                    _.refresh(initial);
                    triggerBreakpoint = targetBreakpoint;
                }
            }

            // only trigger breakpoints during an actual break. not on initialize.
            if( !initial && triggerBreakpoint !== false ) {
                _.$slider.trigger('breakpoint', [_, triggerBreakpoint]);
            }
        }

    };

    Slick.prototype.changeSlide = function(event, dontAnimate) {

        var _ = this,
            $target = $(event.currentTarget),
            indexOffset, slideOffset, unevenOffset;

        // If target is a link, prevent default action.
        if($target.is('a')) {
            event.preventDefault();
        }

        // If target is not the <li> element (ie: a child), find the <li>.
        if(!$target.is('li')) {
            $target = $target.closest('li');
        }

        unevenOffset = (_.slideCount % _.options.slidesToScroll !== 0);
        indexOffset = unevenOffset ? 0 : (_.slideCount - _.currentSlide) % _.options.slidesToScroll;

        switch (event.data.message) {

            case 'previous':
                slideOffset = indexOffset === 0 ? _.options.slidesToScroll : _.options.slidesToShow - indexOffset;
                if (_.slideCount > _.options.slidesToShow) {
                    _.slideHandler(_.currentSlide - slideOffset, false, dontAnimate);
                }
                break;

            case 'next':
                slideOffset = indexOffset === 0 ? _.options.slidesToScroll : indexOffset;
                if (_.slideCount > _.options.slidesToShow) {
                    _.slideHandler(_.currentSlide + slideOffset, false, dontAnimate);
                }
                break;

            case 'index':
                var index = event.data.index === 0 ? 0 :
                    event.data.index || $target.index() * _.options.slidesToScroll;

                _.slideHandler(_.checkNavigable(index), false, dontAnimate);
                $target.children().trigger('focus');
                break;

            default:
                return;
        }

    };

    Slick.prototype.checkNavigable = function(index) {

        var _ = this,
            navigables, prevNavigable;

        navigables = _.getNavigableIndexes();
        prevNavigable = 0;
        if (index > navigables[navigables.length - 1]) {
            index = navigables[navigables.length - 1];
        } else {
            for (var n in navigables) {
                if (index < navigables[n]) {
                    index = prevNavigable;
                    break;
                }
                prevNavigable = navigables[n];
            }
        }

        return index;
    };

    Slick.prototype.cleanUpEvents = function() {

        var _ = this;

        if (_.options.dots && _.$dots !== null) {

            $('li', _.$dots)
                .off('click.slick', _.changeSlide)
                .off('mouseenter.slick', $.proxy(_.interrupt, _, true))
                .off('mouseleave.slick', $.proxy(_.interrupt, _, false));

            if (_.options.accessibility === true) {
                _.$dots.off('keydown.slick', _.keyHandler);
            }
        }

        _.$slider.off('focus.slick blur.slick');

        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
            _.$prevArrow && _.$prevArrow.off('click.slick', _.changeSlide);
            _.$nextArrow && _.$nextArrow.off('click.slick', _.changeSlide);

            if (_.options.accessibility === true) {
                _.$prevArrow && _.$prevArrow.off('keydown.slick', _.keyHandler);
                _.$nextArrow && _.$nextArrow.off('keydown.slick', _.keyHandler);
            }
        }

        _.$list.off('touchstart.slick mousedown.slick', _.swipeHandler);
        _.$list.off('touchmove.slick mousemove.slick', _.swipeHandler);
        _.$list.off('touchend.slick mouseup.slick', _.swipeHandler);
        _.$list.off('touchcancel.slick mouseleave.slick', _.swipeHandler);

        _.$list.off('click.slick', _.clickHandler);

        $(document).off(_.visibilityChange, _.visibility);

        _.cleanUpSlideEvents();

        if (_.options.accessibility === true) {
            _.$list.off('keydown.slick', _.keyHandler);
        }

        if (_.options.focusOnSelect === true) {
            $(_.$slideTrack).children().off('click.slick', _.selectHandler);
        }

        $(window).off('orientationchange.slick.slick-' + _.instanceUid, _.orientationChange);

        $(window).off('resize.slick.slick-' + _.instanceUid, _.resize);

        $('[draggable!=true]', _.$slideTrack).off('dragstart', _.preventDefault);

        $(window).off('load.slick.slick-' + _.instanceUid, _.setPosition);

    };

    Slick.prototype.cleanUpSlideEvents = function() {

        var _ = this;

        _.$list.off('mouseenter.slick', $.proxy(_.interrupt, _, true));
        _.$list.off('mouseleave.slick', $.proxy(_.interrupt, _, false));

    };

    Slick.prototype.cleanUpRows = function() {

        var _ = this, originalSlides;

        if(_.options.rows > 0) {
            originalSlides = _.$slides.children().children();
            originalSlides.removeAttr('style');
            _.$slider.empty().append(originalSlides);
        }

    };

    Slick.prototype.clickHandler = function(event) {

        var _ = this;

        if (_.shouldClick === false) {
            event.stopImmediatePropagation();
            event.stopPropagation();
            event.preventDefault();
        }

    };

    Slick.prototype.destroy = function(refresh) {

        var _ = this;

        _.autoPlayClear();

        _.touchObject = {};

        _.cleanUpEvents();

        $('.slick-cloned', _.$slider).detach();

        if (_.$dots) {
            _.$dots.remove();
        }

        if ( _.$prevArrow && _.$prevArrow.length ) {

            _.$prevArrow
                .removeClass('slick-disabled slick-arrow slick-hidden')
                .removeAttr('aria-hidden aria-disabled tabindex')
                .css('display','');

            if ( _.htmlExpr.test( _.options.prevArrow )) {
                _.$prevArrow.remove();
            }
        }

        if ( _.$nextArrow && _.$nextArrow.length ) {

            _.$nextArrow
                .removeClass('slick-disabled slick-arrow slick-hidden')
                .removeAttr('aria-hidden aria-disabled tabindex')
                .css('display','');

            if ( _.htmlExpr.test( _.options.nextArrow )) {
                _.$nextArrow.remove();
            }
        }


        if (_.$slides) {

            _.$slides
                .removeClass('slick-slide slick-active slick-center slick-visible slick-current')
                .removeAttr('aria-hidden')
                .removeAttr('data-slick-index')
                .each(function(){
                    $(this).attr('style', $(this).data('originalStyling'));
                });

            _.$slideTrack.children(this.options.slide).detach();

            _.$slideTrack.detach();

            _.$list.detach();

            _.$slider.append(_.$slides);
        }

        _.cleanUpRows();

        _.$slider.removeClass('slick-slider');
        _.$slider.removeClass('slick-initialized');
        _.$slider.removeClass('slick-dotted');

        _.unslicked = true;

        if(!refresh) {
            _.$slider.trigger('destroy', [_]);
        }

    };

    Slick.prototype.disableTransition = function(slide) {

        var _ = this,
            transition = {};

        transition[_.transitionType] = '';

        if (_.options.fade === false) {
            _.$slideTrack.css(transition);
        } else {
            _.$slides.eq(slide).css(transition);
        }

    };

    Slick.prototype.fadeSlide = function(slideIndex, callback) {

        var _ = this;

        if (_.cssTransitions === false) {

            _.$slides.eq(slideIndex).css({
                zIndex: _.options.zIndex
            });

            _.$slides.eq(slideIndex).animate({
                opacity: 1
            }, _.options.speed, _.options.easing, callback);

        } else {

            _.applyTransition(slideIndex);

            _.$slides.eq(slideIndex).css({
                opacity: 1,
                zIndex: _.options.zIndex
            });

            if (callback) {
                setTimeout(function() {

                    _.disableTransition(slideIndex);

                    callback.call();
                }, _.options.speed);
            }

        }

    };

    Slick.prototype.fadeSlideOut = function(slideIndex) {

        var _ = this;

        if (_.cssTransitions === false) {

            _.$slides.eq(slideIndex).animate({
                opacity: 0,
                zIndex: _.options.zIndex - 2
            }, _.options.speed, _.options.easing);

        } else {

            _.applyTransition(slideIndex);

            _.$slides.eq(slideIndex).css({
                opacity: 0,
                zIndex: _.options.zIndex - 2
            });

        }

    };

    Slick.prototype.filterSlides = Slick.prototype.slickFilter = function(filter) {

        var _ = this;

        if (filter !== null) {

            _.$slidesCache = _.$slides;

            _.unload();

            _.$slideTrack.children(this.options.slide).detach();

            _.$slidesCache.filter(filter).appendTo(_.$slideTrack);

            _.reinit();

        }

    };

    Slick.prototype.focusHandler = function() {

        var _ = this;

        _.$slider
            .off('focus.slick blur.slick')
            .on('focus.slick blur.slick', '*', function(event) {

            event.stopImmediatePropagation();
            var $sf = $(this);

            setTimeout(function() {

                if( _.options.pauseOnFocus ) {
                    _.focussed = $sf.is(':focus');
                    _.autoPlay();
                }

            }, 0);

        });
    };

    Slick.prototype.getCurrent = Slick.prototype.slickCurrentSlide = function() {

        var _ = this;
        return _.currentSlide;

    };

    Slick.prototype.getDotCount = function() {

        var _ = this;

        var breakPoint = 0;
        var counter = 0;
        var pagerQty = 0;

        if (_.options.infinite === true) {
            if (_.slideCount <= _.options.slidesToShow) {
                 ++pagerQty;
            } else {
                while (breakPoint < _.slideCount) {
                    ++pagerQty;
                    breakPoint = counter + _.options.slidesToScroll;
                    counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
                }
            }
        } else if (_.options.centerMode === true) {
            pagerQty = _.slideCount;
        } else if(!_.options.asNavFor) {
            pagerQty = 1 + Math.ceil((_.slideCount - _.options.slidesToShow) / _.options.slidesToScroll);
        }else {
            while (breakPoint < _.slideCount) {
                ++pagerQty;
                breakPoint = counter + _.options.slidesToScroll;
                counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
            }
        }

        return pagerQty - 1;

    };

    Slick.prototype.getLeft = function(slideIndex) {

        var _ = this,
            targetLeft,
            verticalHeight,
            verticalOffset = 0,
            targetSlide,
            coef;

        _.slideOffset = 0;
        verticalHeight = _.$slides.first().outerHeight(true);

        if (_.options.infinite === true) {
            if (_.slideCount > _.options.slidesToShow) {
                _.slideOffset = (_.slideWidth * _.options.slidesToShow) * -1;
                coef = -1

                if (_.options.vertical === true && _.options.centerMode === true) {
                    if (_.options.slidesToShow === 2) {
                        coef = -1.5;
                    } else if (_.options.slidesToShow === 1) {
                        coef = -2
                    }
                }
                verticalOffset = (verticalHeight * _.options.slidesToShow) * coef;
            }
            if (_.slideCount % _.options.slidesToScroll !== 0) {
                if (slideIndex + _.options.slidesToScroll > _.slideCount && _.slideCount > _.options.slidesToShow) {
                    if (slideIndex > _.slideCount) {
                        _.slideOffset = ((_.options.slidesToShow - (slideIndex - _.slideCount)) * _.slideWidth) * -1;
                        verticalOffset = ((_.options.slidesToShow - (slideIndex - _.slideCount)) * verticalHeight) * -1;
                    } else {
                        _.slideOffset = ((_.slideCount % _.options.slidesToScroll) * _.slideWidth) * -1;
                        verticalOffset = ((_.slideCount % _.options.slidesToScroll) * verticalHeight) * -1;
                    }
                }
            }
        } else {
            if (slideIndex + _.options.slidesToShow > _.slideCount) {
                _.slideOffset = ((slideIndex + _.options.slidesToShow) - _.slideCount) * _.slideWidth;
                verticalOffset = ((slideIndex + _.options.slidesToShow) - _.slideCount) * verticalHeight;
            }
        }

        if (_.slideCount <= _.options.slidesToShow) {
            _.slideOffset = 0;
            verticalOffset = 0;
        }

        if (_.options.centerMode === true && _.slideCount <= _.options.slidesToShow) {
            _.slideOffset = ((_.slideWidth * Math.floor(_.options.slidesToShow)) / 2) - ((_.slideWidth * _.slideCount) / 2);
        } else if (_.options.centerMode === true && _.options.infinite === true) {
            _.slideOffset += _.slideWidth * Math.floor(_.options.slidesToShow / 2) - _.slideWidth;
        } else if (_.options.centerMode === true) {
            _.slideOffset = 0;
            _.slideOffset += _.slideWidth * Math.floor(_.options.slidesToShow / 2);
        }

        if (_.options.vertical === false) {
            targetLeft = ((slideIndex * _.slideWidth) * -1) + _.slideOffset;
        } else {
            targetLeft = ((slideIndex * verticalHeight) * -1) + verticalOffset;
        }

        if (_.options.variableWidth === true) {

            if (_.slideCount <= _.options.slidesToShow || _.options.infinite === false) {
                targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex);
            } else {
                targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex + _.options.slidesToShow);
            }

            if (_.options.rtl === true) {
                if (targetSlide[0]) {
                    targetLeft = (_.$slideTrack.width() - targetSlide[0].offsetLeft - targetSlide.width()) * -1;
                } else {
                    targetLeft =  0;
                }
            } else {
                targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0;
            }

            if (_.options.centerMode === true) {
                if (_.slideCount <= _.options.slidesToShow || _.options.infinite === false) {
                    targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex);
                } else {
                    targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex + _.options.slidesToShow + 1);
                }

                if (_.options.rtl === true) {
                    if (targetSlide[0]) {
                        targetLeft = (_.$slideTrack.width() - targetSlide[0].offsetLeft - targetSlide.width()) * -1;
                    } else {
                        targetLeft =  0;
                    }
                } else {
                    targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0;
                }

                targetLeft += (_.$list.width() - targetSlide.outerWidth()) / 2;
            }
        }

        return targetLeft;

    };

    Slick.prototype.getOption = Slick.prototype.slickGetOption = function(option) {

        var _ = this;

        return _.options[option];

    };

    Slick.prototype.getNavigableIndexes = function() {

        var _ = this,
            breakPoint = 0,
            counter = 0,
            indexes = [],
            max;

        if (_.options.infinite === false) {
            max = _.slideCount;
        } else {
            breakPoint = _.options.slidesToScroll * -1;
            counter = _.options.slidesToScroll * -1;
            max = _.slideCount * 2;
        }

        while (breakPoint < max) {
            indexes.push(breakPoint);
            breakPoint = counter + _.options.slidesToScroll;
            counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
        }

        return indexes;

    };

    Slick.prototype.getSlick = function() {

        return this;

    };

    Slick.prototype.getSlideCount = function() {

        var _ = this,
            slidesTraversed, swipedSlide, centerOffset;

        centerOffset = _.options.centerMode === true ? _.slideWidth * Math.floor(_.options.slidesToShow / 2) : 0;

        if (_.options.swipeToSlide === true) {
            _.$slideTrack.find('.slick-slide').each(function(index, slide) {
                if (slide.offsetLeft - centerOffset + ($(slide).outerWidth() / 2) > (_.swipeLeft * -1)) {
                    swipedSlide = slide;
                    return false;
                }
            });

            slidesTraversed = Math.abs($(swipedSlide).attr('data-slick-index') - _.currentSlide) || 1;

            return slidesTraversed;

        } else {
            return _.options.slidesToScroll;
        }

    };

    Slick.prototype.goTo = Slick.prototype.slickGoTo = function(slide, dontAnimate) {

        var _ = this;

        _.changeSlide({
            data: {
                message: 'index',
                index: parseInt(slide)
            }
        }, dontAnimate);

    };

    Slick.prototype.init = function(creation) {

        var _ = this;

        if (!$(_.$slider).hasClass('slick-initialized')) {

            $(_.$slider).addClass('slick-initialized');

            _.buildRows();
            _.buildOut();
            _.setProps();
            _.startLoad();
            _.loadSlider();
            _.initializeEvents();
            _.updateArrows();
            _.updateDots();
            _.checkResponsive(true);
            _.focusHandler();

        }

        if (creation) {
            _.$slider.trigger('init', [_]);
        }

        if (_.options.accessibility === true) {
            _.initADA();
        }

        if ( _.options.autoplay ) {

            _.paused = false;
            _.autoPlay();

        }

    };

    Slick.prototype.initADA = function() {
        var _ = this,
                numDotGroups = Math.ceil(_.slideCount / _.options.slidesToShow),
                tabControlIndexes = _.getNavigableIndexes().filter(function(val) {
                    return (val >= 0) && (val < _.slideCount);
                });

        _.$slides.add(_.$slideTrack.find('.slick-cloned')).attr({
            'aria-hidden': 'true',
            'tabindex': '-1'
        }).find('a, input, button, select').attr({
            'tabindex': '-1'
        });

        if (_.$dots !== null) {
            _.$slides.not(_.$slideTrack.find('.slick-cloned')).each(function(i) {
                var slideControlIndex = tabControlIndexes.indexOf(i);

                $(this).attr({
                    'role': 'tabpanel',
                    'id': 'slick-slide' + _.instanceUid + i,
                    'tabindex': -1
                });

                if (slideControlIndex !== -1) {
                   var ariaButtonControl = 'slick-slide-control' + _.instanceUid + slideControlIndex
                   if ($('#' + ariaButtonControl).length) {
                     $(this).attr({
                         'aria-describedby': ariaButtonControl
                     });
                   }
                }
            });

            _.$dots.attr('role', 'tablist').find('li').each(function(i) {
                var mappedSlideIndex = tabControlIndexes[i];

                $(this).attr({
                    'role': 'presentation'
                });

                $(this).find('button').first().attr({
                    'role': 'tab',
                    'id': 'slick-slide-control' + _.instanceUid + i,
                    'aria-controls': 'slick-slide' + _.instanceUid + mappedSlideIndex,
                    'aria-label': (i + 1) + ' of ' + numDotGroups,
                    'aria-selected': null,
                    'tabindex': '-1'
                });

            }).eq(_.currentSlide).find('button').attr({
                'aria-selected': 'true',
                'tabindex': '0'
            }).end();
        }

        for (var i=_.currentSlide, max=i+_.options.slidesToShow; i < max; i++) {
          if (_.options.focusOnChange) {
            _.$slides.eq(i).attr({'tabindex': '0'});
          } else {
            _.$slides.eq(i).removeAttr('tabindex');
          }
        }

        _.activateADA();

    };

    Slick.prototype.initArrowEvents = function() {

        var _ = this;

        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
            _.$prevArrow
               .off('click.slick')
               .on('click.slick', {
                    message: 'previous'
               }, _.changeSlide);
            _.$nextArrow
               .off('click.slick')
               .on('click.slick', {
                    message: 'next'
               }, _.changeSlide);

            if (_.options.accessibility === true) {
                _.$prevArrow.on('keydown.slick', _.keyHandler);
                _.$nextArrow.on('keydown.slick', _.keyHandler);
            }
        }

    };

    Slick.prototype.initDotEvents = function() {

        var _ = this;

        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {
            $('li', _.$dots).on('click.slick', {
                message: 'index'
            }, _.changeSlide);

            if (_.options.accessibility === true) {
                _.$dots.on('keydown.slick', _.keyHandler);
            }
        }

        if (_.options.dots === true && _.options.pauseOnDotsHover === true && _.slideCount > _.options.slidesToShow) {

            $('li', _.$dots)
                .on('mouseenter.slick', $.proxy(_.interrupt, _, true))
                .on('mouseleave.slick', $.proxy(_.interrupt, _, false));

        }

    };

    Slick.prototype.initSlideEvents = function() {

        var _ = this;

        if ( _.options.pauseOnHover ) {

            _.$list.on('mouseenter.slick', $.proxy(_.interrupt, _, true));
            _.$list.on('mouseleave.slick', $.proxy(_.interrupt, _, false));

        }

    };

    Slick.prototype.initializeEvents = function() {

        var _ = this;

        _.initArrowEvents();

        _.initDotEvents();
        _.initSlideEvents();

        _.$list.on('touchstart.slick mousedown.slick', {
            action: 'start'
        }, _.swipeHandler);
        _.$list.on('touchmove.slick mousemove.slick', {
            action: 'move'
        }, _.swipeHandler);
        _.$list.on('touchend.slick mouseup.slick', {
            action: 'end'
        }, _.swipeHandler);
        _.$list.on('touchcancel.slick mouseleave.slick', {
            action: 'end'
        }, _.swipeHandler);

        _.$list.on('click.slick', _.clickHandler);

        $(document).on(_.visibilityChange, $.proxy(_.visibility, _));

        if (_.options.accessibility === true) {
            _.$list.on('keydown.slick', _.keyHandler);
        }

        if (_.options.focusOnSelect === true) {
            $(_.$slideTrack).children().on('click.slick', _.selectHandler);
        }

        $(window).on('orientationchange.slick.slick-' + _.instanceUid, $.proxy(_.orientationChange, _));

        $(window).on('resize.slick.slick-' + _.instanceUid, $.proxy(_.resize, _));

        $('[draggable!=true]', _.$slideTrack).on('dragstart', _.preventDefault);

        $(window).on('load.slick.slick-' + _.instanceUid, _.setPosition);
        $(_.setPosition);

    };

    Slick.prototype.initUI = function() {

        var _ = this;

        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {

            _.$prevArrow.show();
            _.$nextArrow.show();

        }

        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {

            _.$dots.show();

        }

    };

    Slick.prototype.keyHandler = function(event) {

        var _ = this;
         //Dont slide if the cursor is inside the form fields and arrow keys are pressed
        if(!event.target.tagName.match('TEXTAREA|INPUT|SELECT')) {
            if (event.keyCode === 37 && _.options.accessibility === true) {
                _.changeSlide({
                    data: {
                        message: _.options.rtl === true ? 'next' :  'previous'
                    }
                });
            } else if (event.keyCode === 39 && _.options.accessibility === true) {
                _.changeSlide({
                    data: {
                        message: _.options.rtl === true ? 'previous' : 'next'
                    }
                });
            }
        }

    };

    Slick.prototype.lazyLoad = function() {

        var _ = this,
            loadRange, cloneRange, rangeStart, rangeEnd;

        function loadImages(imagesScope) {

            $('img[data-lazy]', imagesScope).each(function() {

                var image = $(this),
                    imageSource = $(this).attr('data-lazy'),
                    imageSrcSet = $(this).attr('data-srcset'),
                    imageSizes  = $(this).attr('data-sizes') || _.$slider.attr('data-sizes'),
                    imageToLoad = document.createElement('img');

                imageToLoad.onload = function() {

                    image
                        .animate({ opacity: 0 }, 100, function() {

                            if (imageSrcSet) {
                                image
                                    .attr('srcset', imageSrcSet );

                                if (imageSizes) {
                                    image
                                        .attr('sizes', imageSizes );
                                }
                            }

                            image
                                .attr('src', imageSource)
                                .animate({ opacity: 1 }, 200, function() {
                                    image
                                        .removeAttr('data-lazy data-srcset data-sizes')
                                        .removeClass('slick-loading');
                                });
                            _.$slider.trigger('lazyLoaded', [_, image, imageSource]);
                        });

                };

                imageToLoad.onerror = function() {

                    image
                        .removeAttr( 'data-lazy' )
                        .removeClass( 'slick-loading' )
                        .addClass( 'slick-lazyload-error' );

                    _.$slider.trigger('lazyLoadError', [ _, image, imageSource ]);

                };

                imageToLoad.src = imageSource;

            });

        }

        if (_.options.centerMode === true) {
            if (_.options.infinite === true) {
                rangeStart = _.currentSlide + (_.options.slidesToShow / 2 + 1);
                rangeEnd = rangeStart + _.options.slidesToShow + 2;
            } else {
                rangeStart = Math.max(0, _.currentSlide - (_.options.slidesToShow / 2 + 1));
                rangeEnd = 2 + (_.options.slidesToShow / 2 + 1) + _.currentSlide;
            }
        } else {
            rangeStart = _.options.infinite ? _.options.slidesToShow + _.currentSlide : _.currentSlide;
            rangeEnd = Math.ceil(rangeStart + _.options.slidesToShow);
            if (_.options.fade === true) {
                if (rangeStart > 0) rangeStart--;
                if (rangeEnd <= _.slideCount) rangeEnd++;
            }
        }

        loadRange = _.$slider.find('.slick-slide').slice(rangeStart, rangeEnd);

        if (_.options.lazyLoad === 'anticipated') {
            var prevSlide = rangeStart - 1,
                nextSlide = rangeEnd,
                $slides = _.$slider.find('.slick-slide');

            for (var i = 0; i < _.options.slidesToScroll; i++) {
                if (prevSlide < 0) prevSlide = _.slideCount - 1;
                loadRange = loadRange.add($slides.eq(prevSlide));
                loadRange = loadRange.add($slides.eq(nextSlide));
                prevSlide--;
                nextSlide++;
            }
        }

        loadImages(loadRange);

        if (_.slideCount <= _.options.slidesToShow) {
            cloneRange = _.$slider.find('.slick-slide');
            loadImages(cloneRange);
        } else
        if (_.currentSlide >= _.slideCount - _.options.slidesToShow) {
            cloneRange = _.$slider.find('.slick-cloned').slice(0, _.options.slidesToShow);
            loadImages(cloneRange);
        } else if (_.currentSlide === 0) {
            cloneRange = _.$slider.find('.slick-cloned').slice(_.options.slidesToShow * -1);
            loadImages(cloneRange);
        }

    };

    Slick.prototype.loadSlider = function() {

        var _ = this;

        _.setPosition();

        _.$slideTrack.css({
            opacity: 1
        });

        _.$slider.removeClass('slick-loading');

        _.initUI();

        if (_.options.lazyLoad === 'progressive') {
            _.progressiveLazyLoad();
        }

    };

    Slick.prototype.next = Slick.prototype.slickNext = function() {

        var _ = this;

        _.changeSlide({
            data: {
                message: 'next'
            }
        });

    };

    Slick.prototype.orientationChange = function() {

        var _ = this;

        _.checkResponsive();
        _.setPosition();

    };

    Slick.prototype.pause = Slick.prototype.slickPause = function() {

        var _ = this;

        _.autoPlayClear();
        _.paused = true;

    };

    Slick.prototype.play = Slick.prototype.slickPlay = function() {

        var _ = this;

        _.autoPlay();
        _.options.autoplay = true;
        _.paused = false;
        _.focussed = false;
        _.interrupted = false;

    };

    Slick.prototype.postSlide = function(index) {

        var _ = this;

        if( !_.unslicked ) {

            _.$slider.trigger('afterChange', [_, index]);

            _.animating = false;

            if (_.slideCount > _.options.slidesToShow) {
                _.setPosition();
            }

            _.swipeLeft = null;

            if ( _.options.autoplay ) {
                _.autoPlay();
            }

            if (_.options.accessibility === true) {
                _.initADA();

                if (_.options.focusOnChange) {
                    var $currentSlide = $(_.$slides.get(_.currentSlide));
                    $currentSlide.attr('tabindex', 0).focus();
                }
            }

        }

    };

    Slick.prototype.prev = Slick.prototype.slickPrev = function() {

        var _ = this;

        _.changeSlide({
            data: {
                message: 'previous'
            }
        });

    };

    Slick.prototype.preventDefault = function(event) {

        event.preventDefault();

    };

    Slick.prototype.progressiveLazyLoad = function( tryCount ) {

        tryCount = tryCount || 1;

        var _ = this,
            $imgsToLoad = $( 'img[data-lazy]', _.$slider ),
            image,
            imageSource,
            imageSrcSet,
            imageSizes,
            imageToLoad;

        if ( $imgsToLoad.length ) {

            image = $imgsToLoad.first();
            imageSource = image.attr('data-lazy');
            imageSrcSet = image.attr('data-srcset');
            imageSizes  = image.attr('data-sizes') || _.$slider.attr('data-sizes');
            imageToLoad = document.createElement('img');

            imageToLoad.onload = function() {

                if (imageSrcSet) {
                    image
                        .attr('srcset', imageSrcSet );

                    if (imageSizes) {
                        image
                            .attr('sizes', imageSizes );
                    }
                }

                image
                    .attr( 'src', imageSource )
                    .removeAttr('data-lazy data-srcset data-sizes')
                    .removeClass('slick-loading');

                if ( _.options.adaptiveHeight === true ) {
                    _.setPosition();
                }

                _.$slider.trigger('lazyLoaded', [ _, image, imageSource ]);
                _.progressiveLazyLoad();

            };

            imageToLoad.onerror = function() {

                if ( tryCount < 3 ) {

                    /**
                     * try to load the image 3 times,
                     * leave a slight delay so we don't get
                     * servers blocking the request.
                     */
                    setTimeout( function() {
                        _.progressiveLazyLoad( tryCount + 1 );
                    }, 500 );

                } else {

                    image
                        .removeAttr( 'data-lazy' )
                        .removeClass( 'slick-loading' )
                        .addClass( 'slick-lazyload-error' );

                    _.$slider.trigger('lazyLoadError', [ _, image, imageSource ]);

                    _.progressiveLazyLoad();

                }

            };

            imageToLoad.src = imageSource;

        } else {

            _.$slider.trigger('allImagesLoaded', [ _ ]);

        }

    };

    Slick.prototype.refresh = function( initializing ) {

        var _ = this, currentSlide, lastVisibleIndex;

        lastVisibleIndex = _.slideCount - _.options.slidesToShow;

        // in non-infinite sliders, we don't want to go past the
        // last visible index.
        if( !_.options.infinite && ( _.currentSlide > lastVisibleIndex )) {
            _.currentSlide = lastVisibleIndex;
        }

        // if less slides than to show, go to start.
        if ( _.slideCount <= _.options.slidesToShow ) {
            _.currentSlide = 0;

        }

        currentSlide = _.currentSlide;

        _.destroy(true);

        $.extend(_, _.initials, { currentSlide: currentSlide });

        _.init();

        if( !initializing ) {

            _.changeSlide({
                data: {
                    message: 'index',
                    index: currentSlide
                }
            }, false);

        }

    };

    Slick.prototype.registerBreakpoints = function() {

        var _ = this, breakpoint, currentBreakpoint, l,
            responsiveSettings = _.options.responsive || null;

        if ( $.type(responsiveSettings) === 'array' && responsiveSettings.length ) {

            _.respondTo = _.options.respondTo || 'window';

            for ( breakpoint in responsiveSettings ) {

                l = _.breakpoints.length-1;

                if (responsiveSettings.hasOwnProperty(breakpoint)) {
                    currentBreakpoint = responsiveSettings[breakpoint].breakpoint;

                    // loop through the breakpoints and cut out any existing
                    // ones with the same breakpoint number, we don't want dupes.
                    while( l >= 0 ) {
                        if( _.breakpoints[l] && _.breakpoints[l] === currentBreakpoint ) {
                            _.breakpoints.splice(l,1);
                        }
                        l--;
                    }

                    _.breakpoints.push(currentBreakpoint);
                    _.breakpointSettings[currentBreakpoint] = responsiveSettings[breakpoint].settings;

                }

            }

            _.breakpoints.sort(function(a, b) {
                return ( _.options.mobileFirst ) ? a-b : b-a;
            });

        }

    };

    Slick.prototype.reinit = function() {

        var _ = this;

        _.$slides =
            _.$slideTrack
                .children(_.options.slide)
                .addClass('slick-slide');

        _.slideCount = _.$slides.length;

        if (_.currentSlide >= _.slideCount && _.currentSlide !== 0) {
            _.currentSlide = _.currentSlide - _.options.slidesToScroll;
        }

        if (_.slideCount <= _.options.slidesToShow) {
            _.currentSlide = 0;
        }

        _.registerBreakpoints();

        _.setProps();
        _.setupInfinite();
        _.buildArrows();
        _.updateArrows();
        _.initArrowEvents();
        _.buildDots();
        _.updateDots();
        _.initDotEvents();
        _.cleanUpSlideEvents();
        _.initSlideEvents();

        _.checkResponsive(false, true);

        if (_.options.focusOnSelect === true) {
            $(_.$slideTrack).children().on('click.slick', _.selectHandler);
        }

        _.setSlideClasses(typeof _.currentSlide === 'number' ? _.currentSlide : 0);

        _.setPosition();
        _.focusHandler();

        _.paused = !_.options.autoplay;
        _.autoPlay();

        _.$slider.trigger('reInit', [_]);

    };

    Slick.prototype.resize = function() {

        var _ = this;

        if ($(window).width() !== _.windowWidth) {
            clearTimeout(_.windowDelay);
            _.windowDelay = window.setTimeout(function() {
                _.windowWidth = $(window).width();
                _.checkResponsive();
                if( !_.unslicked ) { _.setPosition(); }
            }, 50);
        }
    };

    Slick.prototype.removeSlide = Slick.prototype.slickRemove = function(index, removeBefore, removeAll) {

        var _ = this;

        if (typeof(index) === 'boolean') {
            removeBefore = index;
            index = removeBefore === true ? 0 : _.slideCount - 1;
        } else {
            index = removeBefore === true ? --index : index;
        }

        if (_.slideCount < 1 || index < 0 || index > _.slideCount - 1) {
            return false;
        }

        _.unload();

        if (removeAll === true) {
            _.$slideTrack.children().remove();
        } else {
            _.$slideTrack.children(this.options.slide).eq(index).remove();
        }

        _.$slides = _.$slideTrack.children(this.options.slide);

        _.$slideTrack.children(this.options.slide).detach();

        _.$slideTrack.append(_.$slides);

        _.$slidesCache = _.$slides;

        _.reinit();

    };

    Slick.prototype.setCSS = function(position) {

        var _ = this,
            positionProps = {},
            x, y;

        if (_.options.rtl === true) {
            position = -position;
        }
        x = _.positionProp == 'left' ? Math.ceil(position) + 'px' : '0px';
        y = _.positionProp == 'top' ? Math.ceil(position) + 'px' : '0px';

        positionProps[_.positionProp] = position;

        if (_.transformsEnabled === false) {
            _.$slideTrack.css(positionProps);
        } else {
            positionProps = {};
            if (_.cssTransitions === false) {
                positionProps[_.animType] = 'translate(' + x + ', ' + y + ')';
                _.$slideTrack.css(positionProps);
            } else {
                positionProps[_.animType] = 'translate3d(' + x + ', ' + y + ', 0px)';
                _.$slideTrack.css(positionProps);
            }
        }

    };

    Slick.prototype.setDimensions = function() {

        var _ = this;

        if (_.options.vertical === false) {
            if (_.options.centerMode === true) {
                _.$list.css({
                    padding: ('0px ' + _.options.centerPadding)
                });
            }
        } else {
            _.$list.height(_.$slides.first().outerHeight(true) * _.options.slidesToShow);
            if (_.options.centerMode === true) {
                _.$list.css({
                    padding: (_.options.centerPadding + ' 0px')
                });
            }
        }

        _.listWidth = _.$list.width();
        _.listHeight = _.$list.height();


        if (_.options.vertical === false && _.options.variableWidth === false) {
            _.slideWidth = Math.ceil(_.listWidth / _.options.slidesToShow);
            _.$slideTrack.width(Math.ceil((_.slideWidth * _.$slideTrack.children('.slick-slide').length)));

        } else if (_.options.variableWidth === true) {
            _.$slideTrack.width(5000 * _.slideCount);
        } else {
            _.slideWidth = Math.ceil(_.listWidth);
            _.$slideTrack.height(Math.ceil((_.$slides.first().outerHeight(true) * _.$slideTrack.children('.slick-slide').length)));
        }

        var offset = _.$slides.first().outerWidth(true) - _.$slides.first().width();
        if (_.options.variableWidth === false) _.$slideTrack.children('.slick-slide').width(_.slideWidth - offset);

    };

    Slick.prototype.setFade = function() {

        var _ = this,
            targetLeft;

        _.$slides.each(function(index, element) {
            targetLeft = (_.slideWidth * index) * -1;
            if (_.options.rtl === true) {
                $(element).css({
                    position: 'relative',
                    right: targetLeft,
                    top: 0,
                    zIndex: _.options.zIndex - 2,
                    opacity: 0
                });
            } else {
                $(element).css({
                    position: 'relative',
                    left: targetLeft,
                    top: 0,
                    zIndex: _.options.zIndex - 2,
                    opacity: 0
                });
            }
        });

        _.$slides.eq(_.currentSlide).css({
            zIndex: _.options.zIndex - 1,
            opacity: 1
        });

    };

    Slick.prototype.setHeight = function() {

        var _ = this;

        if (_.options.slidesToShow === 1 && _.options.adaptiveHeight === true && _.options.vertical === false) {
            var targetHeight = _.$slides.eq(_.currentSlide).outerHeight(true);
            _.$list.css('height', targetHeight);
        }

    };

    Slick.prototype.setOption =
    Slick.prototype.slickSetOption = function() {

        /**
         * accepts arguments in format of:
         *
         *  - for changing a single option's value:
         *     .slick("setOption", option, value, refresh )
         *
         *  - for changing a set of responsive options:
         *     .slick("setOption", 'responsive', [{}, ...], refresh )
         *
         *  - for updating multiple values at once (not responsive)
         *     .slick("setOption", { 'option': value, ... }, refresh )
         */

        var _ = this, l, item, option, value, refresh = false, type;

        if( $.type( arguments[0] ) === 'object' ) {

            option =  arguments[0];
            refresh = arguments[1];
            type = 'multiple';

        } else if ( $.type( arguments[0] ) === 'string' ) {

            option =  arguments[0];
            value = arguments[1];
            refresh = arguments[2];

            if ( arguments[0] === 'responsive' && $.type( arguments[1] ) === 'array' ) {

                type = 'responsive';

            } else if ( typeof arguments[1] !== 'undefined' ) {

                type = 'single';

            }

        }

        if ( type === 'single' ) {

            _.options[option] = value;


        } else if ( type === 'multiple' ) {

            $.each( option , function( opt, val ) {

                _.options[opt] = val;

            });


        } else if ( type === 'responsive' ) {

            for ( item in value ) {

                if( $.type( _.options.responsive ) !== 'array' ) {

                    _.options.responsive = [ value[item] ];

                } else {

                    l = _.options.responsive.length-1;

                    // loop through the responsive object and splice out duplicates.
                    while( l >= 0 ) {

                        if( _.options.responsive[l].breakpoint === value[item].breakpoint ) {

                            _.options.responsive.splice(l,1);

                        }

                        l--;

                    }

                    _.options.responsive.push( value[item] );

                }

            }

        }

        if ( refresh ) {

            _.unload();
            _.reinit();

        }

    };

    Slick.prototype.setPosition = function() {

        var _ = this;

        _.setDimensions();

        _.setHeight();

        if (_.options.fade === false) {
            _.setCSS(_.getLeft(_.currentSlide));
        } else {
            _.setFade();
        }

        _.$slider.trigger('setPosition', [_]);

    };

    Slick.prototype.setProps = function() {

        var _ = this,
            bodyStyle = document.body.style;

        _.positionProp = _.options.vertical === true ? 'top' : 'left';

        if (_.positionProp === 'top') {
            _.$slider.addClass('slick-vertical');
        } else {
            _.$slider.removeClass('slick-vertical');
        }

        if (bodyStyle.WebkitTransition !== undefined ||
            bodyStyle.MozTransition !== undefined ||
            bodyStyle.msTransition !== undefined) {
            if (_.options.useCSS === true) {
                _.cssTransitions = true;
            }
        }

        if ( _.options.fade ) {
            if ( typeof _.options.zIndex === 'number' ) {
                if( _.options.zIndex < 3 ) {
                    _.options.zIndex = 3;
                }
            } else {
                _.options.zIndex = _.defaults.zIndex;
            }
        }

        if (bodyStyle.OTransform !== undefined) {
            _.animType = 'OTransform';
            _.transformType = '-o-transform';
            _.transitionType = 'OTransition';
            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.webkitPerspective === undefined) _.animType = false;
        }
        if (bodyStyle.MozTransform !== undefined) {
            _.animType = 'MozTransform';
            _.transformType = '-moz-transform';
            _.transitionType = 'MozTransition';
            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.MozPerspective === undefined) _.animType = false;
        }
        if (bodyStyle.webkitTransform !== undefined) {
            _.animType = 'webkitTransform';
            _.transformType = '-webkit-transform';
            _.transitionType = 'webkitTransition';
            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.webkitPerspective === undefined) _.animType = false;
        }
        if (bodyStyle.msTransform !== undefined) {
            _.animType = 'msTransform';
            _.transformType = '-ms-transform';
            _.transitionType = 'msTransition';
            if (bodyStyle.msTransform === undefined) _.animType = false;
        }
        if (bodyStyle.transform !== undefined && _.animType !== false) {
            _.animType = 'transform';
            _.transformType = 'transform';
            _.transitionType = 'transition';
        }
        _.transformsEnabled = _.options.useTransform && (_.animType !== null && _.animType !== false);
    };


    Slick.prototype.setSlideClasses = function(index) {

        var _ = this,
            centerOffset, allSlides, indexOffset, remainder;

        allSlides = _.$slider
            .find('.slick-slide')
            .removeClass('slick-active slick-center slick-current')
            .attr('aria-hidden', 'true');

        _.$slides
            .eq(index)
            .addClass('slick-current');

        if (_.options.centerMode === true) {

            var evenCoef = _.options.slidesToShow % 2 === 0 ? 1 : 0;

            centerOffset = Math.floor(_.options.slidesToShow / 2);

            if (_.options.infinite === true) {

                if (index >= centerOffset && index <= (_.slideCount - 1) - centerOffset) {
                    _.$slides
                        .slice(index - centerOffset + evenCoef, index + centerOffset + 1)
                        .addClass('slick-active')
                        .attr('aria-hidden', 'false');

                } else {

                    indexOffset = _.options.slidesToShow + index;
                    allSlides
                        .slice(indexOffset - centerOffset + 1 + evenCoef, indexOffset + centerOffset + 2)
                        .addClass('slick-active')
                        .attr('aria-hidden', 'false');

                }

                if (index === 0) {

                    allSlides
                        .eq(allSlides.length - 1 - _.options.slidesToShow)
                        .addClass('slick-center');

                } else if (index === _.slideCount - 1) {

                    allSlides
                        .eq(_.options.slidesToShow)
                        .addClass('slick-center');

                }

            }

            _.$slides
                .eq(index)
                .addClass('slick-center');

        } else {

            if (index >= 0 && index <= (_.slideCount - _.options.slidesToShow)) {

                _.$slides
                    .slice(index, index + _.options.slidesToShow)
                    .addClass('slick-active')
                    .attr('aria-hidden', 'false');

            } else if (allSlides.length <= _.options.slidesToShow) {

                allSlides
                    .addClass('slick-active')
                    .attr('aria-hidden', 'false');

            } else {

                remainder = _.slideCount % _.options.slidesToShow;
                indexOffset = _.options.infinite === true ? _.options.slidesToShow + index : index;

                if (_.options.slidesToShow == _.options.slidesToScroll && (_.slideCount - index) < _.options.slidesToShow) {

                    allSlides
                        .slice(indexOffset - (_.options.slidesToShow - remainder), indexOffset + remainder)
                        .addClass('slick-active')
                        .attr('aria-hidden', 'false');

                } else {

                    allSlides
                        .slice(indexOffset, indexOffset + _.options.slidesToShow)
                        .addClass('slick-active')
                        .attr('aria-hidden', 'false');

                }

            }

        }

        if (_.options.lazyLoad === 'ondemand' || _.options.lazyLoad === 'anticipated') {
            _.lazyLoad();
        }
    };

    Slick.prototype.setupInfinite = function() {

        var _ = this,
            i, slideIndex, infiniteCount;

        if (_.options.fade === true) {
            _.options.centerMode = false;
        }

        if (_.options.infinite === true && _.options.fade === false) {

            slideIndex = null;

            if (_.slideCount > _.options.slidesToShow) {

                if (_.options.centerMode === true) {
                    infiniteCount = _.options.slidesToShow + 1;
                } else {
                    infiniteCount = _.options.slidesToShow;
                }

                for (i = _.slideCount; i > (_.slideCount -
                        infiniteCount); i -= 1) {
                    slideIndex = i - 1;
                    $(_.$slides[slideIndex]).clone(true).attr('id', '')
                        .attr('data-slick-index', slideIndex - _.slideCount)
                        .prependTo(_.$slideTrack).addClass('slick-cloned');
                }
                for (i = 0; i < infiniteCount  + _.slideCount; i += 1) {
                    slideIndex = i;
                    $(_.$slides[slideIndex]).clone(true).attr('id', '')
                        .attr('data-slick-index', slideIndex + _.slideCount)
                        .appendTo(_.$slideTrack).addClass('slick-cloned');
                }
                _.$slideTrack.find('.slick-cloned').find('[id]').each(function() {
                    $(this).attr('id', '');
                });

            }

        }

    };

    Slick.prototype.interrupt = function( toggle ) {

        var _ = this;

        if( !toggle ) {
            _.autoPlay();
        }
        _.interrupted = toggle;

    };

    Slick.prototype.selectHandler = function(event) {

        var _ = this;

        var targetElement =
            $(event.target).is('.slick-slide') ?
                $(event.target) :
                $(event.target).parents('.slick-slide');

        var index = parseInt(targetElement.attr('data-slick-index'));

        if (!index) index = 0;

        if (_.slideCount <= _.options.slidesToShow) {

            _.slideHandler(index, false, true);
            return;

        }

        _.slideHandler(index);

    };

    Slick.prototype.slideHandler = function(index, sync, dontAnimate) {

        var targetSlide, animSlide, oldSlide, slideLeft, targetLeft = null,
            _ = this, navTarget;

        sync = sync || false;

        if (_.animating === true && _.options.waitForAnimate === true) {
            return;
        }

        if (_.options.fade === true && _.currentSlide === index) {
            return;
        }

        if (sync === false) {
            _.asNavFor(index);
        }

        targetSlide = index;
        targetLeft = _.getLeft(targetSlide);
        slideLeft = _.getLeft(_.currentSlide);

        _.currentLeft = _.swipeLeft === null ? slideLeft : _.swipeLeft;

        if (_.options.infinite === false && _.options.centerMode === false && (index < 0 || index > _.getDotCount() * _.options.slidesToScroll)) {
            if (_.options.fade === false) {
                targetSlide = _.currentSlide;
                if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) {
                    _.animateSlide(slideLeft, function() {
                        _.postSlide(targetSlide);
                    });
                } else {
                    _.postSlide(targetSlide);
                }
            }
            return;
        } else if (_.options.infinite === false && _.options.centerMode === true && (index < 0 || index > (_.slideCount - _.options.slidesToScroll))) {
            if (_.options.fade === false) {
                targetSlide = _.currentSlide;
                if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) {
                    _.animateSlide(slideLeft, function() {
                        _.postSlide(targetSlide);
                    });
                } else {
                    _.postSlide(targetSlide);
                }
            }
            return;
        }

        if ( _.options.autoplay ) {
            clearInterval(_.autoPlayTimer);
        }

        if (targetSlide < 0) {
            if (_.slideCount % _.options.slidesToScroll !== 0) {
                animSlide = _.slideCount - (_.slideCount % _.options.slidesToScroll);
            } else {
                animSlide = _.slideCount + targetSlide;
            }
        } else if (targetSlide >= _.slideCount) {
            if (_.slideCount % _.options.slidesToScroll !== 0) {
                animSlide = 0;
            } else {
                animSlide = targetSlide - _.slideCount;
            }
        } else {
            animSlide = targetSlide;
        }

        _.animating = true;

        _.$slider.trigger('beforeChange', [_, _.currentSlide, animSlide]);

        oldSlide = _.currentSlide;
        _.currentSlide = animSlide;

        _.setSlideClasses(_.currentSlide);

        if ( _.options.asNavFor ) {

            navTarget = _.getNavTarget();
            navTarget = navTarget.slick('getSlick');

            if ( navTarget.slideCount <= navTarget.options.slidesToShow ) {
                navTarget.setSlideClasses(_.currentSlide);
            }

        }

        _.updateDots();
        _.updateArrows();

        if (_.options.fade === true) {
            if (dontAnimate !== true) {

                _.fadeSlideOut(oldSlide);

                _.fadeSlide(animSlide, function() {
                    _.postSlide(animSlide);
                });

            } else {
                _.postSlide(animSlide);
            }
            _.animateHeight();
            return;
        }

        if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) {
            _.animateSlide(targetLeft, function() {
                _.postSlide(animSlide);
            });
        } else {
            _.postSlide(animSlide);
        }

    };

    Slick.prototype.startLoad = function() {

        var _ = this;

        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {

            _.$prevArrow.hide();
            _.$nextArrow.hide();

        }

        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {

            _.$dots.hide();

        }

        _.$slider.addClass('slick-loading');

    };

    Slick.prototype.swipeDirection = function() {

        var xDist, yDist, r, swipeAngle, _ = this;

        xDist = _.touchObject.startX - _.touchObject.curX;
        yDist = _.touchObject.startY - _.touchObject.curY;
        r = Math.atan2(yDist, xDist);

        swipeAngle = Math.round(r * 180 / Math.PI);
        if (swipeAngle < 0) {
            swipeAngle = 360 - Math.abs(swipeAngle);
        }

        if ((swipeAngle <= 45) && (swipeAngle >= 0)) {
            return (_.options.rtl === false ? 'left' : 'right');
        }
        if ((swipeAngle <= 360) && (swipeAngle >= 315)) {
            return (_.options.rtl === false ? 'left' : 'right');
        }
        if ((swipeAngle >= 135) && (swipeAngle <= 225)) {
            return (_.options.rtl === false ? 'right' : 'left');
        }
        if (_.options.verticalSwiping === true) {
            if ((swipeAngle >= 35) && (swipeAngle <= 135)) {
                return 'down';
            } else {
                return 'up';
            }
        }

        return 'vertical';

    };

    Slick.prototype.swipeEnd = function(event) {

        var _ = this,
            slideCount,
            direction;

        _.dragging = false;
        _.swiping = false;

        if (_.scrolling) {
            _.scrolling = false;
            return false;
        }

        _.interrupted = false;
        _.shouldClick = ( _.touchObject.swipeLength > 10 ) ? false : true;

        if ( _.touchObject.curX === undefined ) {
            return false;
        }

        if ( _.touchObject.edgeHit === true ) {
            _.$slider.trigger('edge', [_, _.swipeDirection() ]);
        }

        if ( _.touchObject.swipeLength >= _.touchObject.minSwipe ) {

            direction = _.swipeDirection();

            switch ( direction ) {

                case 'left':
                case 'down':

                    slideCount =
                        _.options.swipeToSlide ?
                            _.checkNavigable( _.currentSlide + _.getSlideCount() ) :
                            _.currentSlide + _.getSlideCount();

                    _.currentDirection = 0;

                    break;

                case 'right':
                case 'up':

                    slideCount =
                        _.options.swipeToSlide ?
                            _.checkNavigable( _.currentSlide - _.getSlideCount() ) :
                            _.currentSlide - _.getSlideCount();

                    _.currentDirection = 1;

                    break;

                default:


            }

            if( direction != 'vertical' ) {

                _.slideHandler( slideCount );
                _.touchObject = {};
                _.$slider.trigger('swipe', [_, direction ]);

            }

        } else {

            if ( _.touchObject.startX !== _.touchObject.curX ) {

                _.slideHandler( _.currentSlide );
                _.touchObject = {};

            }

        }

    };

    Slick.prototype.swipeHandler = function(event) {

        var _ = this;

        if ((_.options.swipe === false) || ('ontouchend' in document && _.options.swipe === false)) {
            return;
        } else if (_.options.draggable === false && event.type.indexOf('mouse') !== -1) {
            return;
        }

        _.touchObject.fingerCount = event.originalEvent && event.originalEvent.touches !== undefined ?
            event.originalEvent.touches.length : 1;

        _.touchObject.minSwipe = _.listWidth / _.options
            .touchThreshold;

        if (_.options.verticalSwiping === true) {
            _.touchObject.minSwipe = _.listHeight / _.options
                .touchThreshold;
        }

        switch (event.data.action) {

            case 'start':
                _.swipeStart(event);
                break;

            case 'move':
                _.swipeMove(event);
                break;

            case 'end':
                _.swipeEnd(event);
                break;

        }

    };

    Slick.prototype.swipeMove = function(event) {

        var _ = this,
            edgeWasHit = false,
            curLeft, swipeDirection, swipeLength, positionOffset, touches, verticalSwipeLength;

        touches = event.originalEvent !== undefined ? event.originalEvent.touches : null;

        if (!_.dragging || _.scrolling || touches && touches.length !== 1) {
            return false;
        }

        curLeft = _.getLeft(_.currentSlide);

        _.touchObject.curX = touches !== undefined ? touches[0].pageX : event.clientX;
        _.touchObject.curY = touches !== undefined ? touches[0].pageY : event.clientY;

        _.touchObject.swipeLength = Math.round(Math.sqrt(
            Math.pow(_.touchObject.curX - _.touchObject.startX, 2)));

        verticalSwipeLength = Math.round(Math.sqrt(
            Math.pow(_.touchObject.curY - _.touchObject.startY, 2)));

        if (!_.options.verticalSwiping && !_.swiping && verticalSwipeLength > 4) {
            _.scrolling = true;
            return false;
        }

        if (_.options.verticalSwiping === true) {
            _.touchObject.swipeLength = verticalSwipeLength;
        }

        swipeDirection = _.swipeDirection();

        if (event.originalEvent !== undefined && _.touchObject.swipeLength > 4) {
            _.swiping = true;
            event.preventDefault();
        }

        positionOffset = (_.options.rtl === false ? 1 : -1) * (_.touchObject.curX > _.touchObject.startX ? 1 : -1);
        if (_.options.verticalSwiping === true) {
            positionOffset = _.touchObject.curY > _.touchObject.startY ? 1 : -1;
        }


        swipeLength = _.touchObject.swipeLength;

        _.touchObject.edgeHit = false;

        if (_.options.infinite === false) {
            if ((_.currentSlide === 0 && swipeDirection === 'right') || (_.currentSlide >= _.getDotCount() && swipeDirection === 'left')) {
                swipeLength = _.touchObject.swipeLength * _.options.edgeFriction;
                _.touchObject.edgeHit = true;
            }
        }

        if (_.options.vertical === false) {
            _.swipeLeft = curLeft + swipeLength * positionOffset;
        } else {
            _.swipeLeft = curLeft + (swipeLength * (_.$list.height() / _.listWidth)) * positionOffset;
        }
        if (_.options.verticalSwiping === true) {
            _.swipeLeft = curLeft + swipeLength * positionOffset;
        }

        if (_.options.fade === true || _.options.touchMove === false) {
            return false;
        }

        if (_.animating === true) {
            _.swipeLeft = null;
            return false;
        }

        _.setCSS(_.swipeLeft);

    };

    Slick.prototype.swipeStart = function(event) {

        var _ = this,
            touches;

        _.interrupted = true;

        if (_.touchObject.fingerCount !== 1 || _.slideCount <= _.options.slidesToShow) {
            _.touchObject = {};
            return false;
        }

        if (event.originalEvent !== undefined && event.originalEvent.touches !== undefined) {
            touches = event.originalEvent.touches[0];
        }

        _.touchObject.startX = _.touchObject.curX = touches !== undefined ? touches.pageX : event.clientX;
        _.touchObject.startY = _.touchObject.curY = touches !== undefined ? touches.pageY : event.clientY;

        _.dragging = true;

    };

    Slick.prototype.unfilterSlides = Slick.prototype.slickUnfilter = function() {

        var _ = this;

        if (_.$slidesCache !== null) {

            _.unload();

            _.$slideTrack.children(this.options.slide).detach();

            _.$slidesCache.appendTo(_.$slideTrack);

            _.reinit();

        }

    };

    Slick.prototype.unload = function() {

        var _ = this;

        $('.slick-cloned', _.$slider).remove();

        if (_.$dots) {
            _.$dots.remove();
        }

        if (_.$prevArrow && _.htmlExpr.test(_.options.prevArrow)) {
            _.$prevArrow.remove();
        }

        if (_.$nextArrow && _.htmlExpr.test(_.options.nextArrow)) {
            _.$nextArrow.remove();
        }

        _.$slides
            .removeClass('slick-slide slick-active slick-visible slick-current')
            .attr('aria-hidden', 'true')
            .css('width', '');

    };

    Slick.prototype.unslick = function(fromBreakpoint) {

        var _ = this;
        _.$slider.trigger('unslick', [_, fromBreakpoint]);
        _.destroy();

    };

    Slick.prototype.updateArrows = function() {

        var _ = this,
            centerOffset;

        centerOffset = Math.floor(_.options.slidesToShow / 2);

        if ( _.options.arrows === true &&
            _.slideCount > _.options.slidesToShow &&
            !_.options.infinite ) {

            _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
            _.$nextArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');

            if (_.currentSlide === 0) {

                _.$prevArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
                _.$nextArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');

            } else if (_.currentSlide >= _.slideCount - _.options.slidesToShow && _.options.centerMode === false) {

                _.$nextArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
                _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');

            } else if (_.currentSlide >= _.slideCount - 1 && _.options.centerMode === true) {

                _.$nextArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
                _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');

            }

        }

    };

    Slick.prototype.updateDots = function() {

        var _ = this;

        if (_.$dots !== null) {

            _.$dots
                .find('li')
                    .removeClass('slick-active')
                    .end();

            _.$dots
                .find('li')
                .eq(Math.floor(_.currentSlide / _.options.slidesToScroll))
                .addClass('slick-active');

        }

    };

    Slick.prototype.visibility = function() {

        var _ = this;

        if ( _.options.autoplay ) {

            if ( document[_.hidden] ) {

                _.interrupted = true;

            } else {

                _.interrupted = false;

            }

        }

    };

    $.fn.slick = function() {
        var _ = this,
            opt = arguments[0],
            args = Array.prototype.slice.call(arguments, 1),
            l = _.length,
            i,
            ret;
        for (i = 0; i < l; i++) {
            if (typeof opt == 'object' || typeof opt == 'undefined')
                _[i].slick = new Slick(_[i], opt);
            else
                ret = _[i].slick[opt].apply(_[i].slick, args);
            if (typeof ret != 'undefined') return ret;
        }
        return _;
    };

}));

},{"jquery":9}],14:[function(require,module,exports){
(function(module) {
    'use strict';

    module.exports.is_uri = is_iri;
    module.exports.is_http_uri = is_http_iri;
    module.exports.is_https_uri = is_https_iri;
    module.exports.is_web_uri = is_web_iri;
    // Create aliases
    module.exports.isUri = is_iri;
    module.exports.isHttpUri = is_http_iri;
    module.exports.isHttpsUri = is_https_iri;
    module.exports.isWebUri = is_web_iri;


    // private function
    // internal URI spitter method - direct from RFC 3986
    var splitUri = function(uri) {
        var splitted = uri.match(/(?:([^:\/?#]+):)?(?:\/\/([^\/?#]*))?([^?#]*)(?:\?([^#]*))?(?:#(.*))?/);
        return splitted;
    };

    function is_iri(value) {
        if (!value) {
            return;
        }

        // check for illegal characters
        if (/[^a-z0-9\:\/\?\#\[\]\@\!\$\&\'\(\)\*\+\,\;\=\.\-\_\~\%]/i.test(value)) return;

        // check for hex escapes that aren't complete
        if (/%[^0-9a-f]/i.test(value)) return;
        if (/%[0-9a-f](:?[^0-9a-f]|$)/i.test(value)) return;

        var splitted = [];
        var scheme = '';
        var authority = '';
        var path = '';
        var query = '';
        var fragment = '';
        var out = '';

        // from RFC 3986
        splitted = splitUri(value);
        scheme = splitted[1]; 
        authority = splitted[2];
        path = splitted[3];
        query = splitted[4];
        fragment = splitted[5];

        // scheme and path are required, though the path can be empty
        if (!(scheme && scheme.length && path.length >= 0)) return;

        // if authority is present, the path must be empty or begin with a /
        if (authority && authority.length) {
            if (!(path.length === 0 || /^\//.test(path))) return;
        } else {
            // if authority is not present, the path must not start with //
            if (/^\/\//.test(path)) return;
        }

        // scheme must begin with a letter, then consist of letters, digits, +, ., or -
        if (!/^[a-z][a-z0-9\+\-\.]*$/.test(scheme.toLowerCase()))  return;

        // re-assemble the URL per section 5.3 in RFC 3986
        out += scheme + ':';
        if (authority && authority.length) {
            out += '//' + authority;
        }

        out += path;

        if (query && query.length) {
            out += '?' + query;
        }

        if (fragment && fragment.length) {
            out += '#' + fragment;
        }

        return out;
    }

    function is_http_iri(value, allowHttps) {
        if (!is_iri(value)) {
            return;
        }

        var splitted = [];
        var scheme = '';
        var authority = '';
        var path = '';
        var port = '';
        var query = '';
        var fragment = '';
        var out = '';

        // from RFC 3986
        splitted = splitUri(value);
        scheme = splitted[1]; 
        authority = splitted[2];
        path = splitted[3];
        query = splitted[4];
        fragment = splitted[5];

        if (!scheme)  return;

        if(allowHttps) {
            if (scheme.toLowerCase() != 'https') return;
        } else {
            if (scheme.toLowerCase() != 'http') return;
        }

        // fully-qualified URIs must have an authority section that is
        // a valid host
        if (!authority) {
            return;
        }

        // enable port component
        if (/:(\d+)$/.test(authority)) {
            port = authority.match(/:(\d+)$/)[0];
            authority = authority.replace(/:\d+$/, '');
        }

        out += scheme + ':';
        out += '//' + authority;
        
        if (port) {
            out += port;
        }
        
        out += path;
        
        if(query && query.length){
            out += '?' + query;
        }

        if(fragment && fragment.length){
            out += '#' + fragment;
        }
        
        return out;
    }

    function is_https_iri(value) {
        return is_http_iri(value, true);
    }

    function is_web_iri(value) {
        return (is_http_iri(value) || is_https_iri(value));
    }

})(module);

},{}],15:[function(require,module,exports){
/**
 * what-input - A global utility for tracking the current input method (mouse, keyboard or touch).
 * @version v4.3.1
 * @link https://github.com/ten1seven/what-input
 * @license MIT
 */
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("whatInput", [], factory);
	else if(typeof exports === 'object')
		exports["whatInput"] = factory();
	else
		root["whatInput"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports) {

	'use strict';

	module.exports = function () {
	  /*
	   * variables
	   */

	  // last used input type
	  var currentInput = 'initial';

	  // last used input intent
	  var currentIntent = null;

	  // cache document.documentElement
	  var doc = document.documentElement;

	  // form input types
	  var formInputs = ['input', 'select', 'textarea'];

	  var functionList = [];

	  // list of modifier keys commonly used with the mouse and
	  // can be safely ignored to prevent false keyboard detection
	  var ignoreMap = [16, // shift
	  17, // control
	  18, // alt
	  91, // Windows key / left Apple cmd
	  93 // Windows menu / right Apple cmd
	  ];

	  // list of keys for which we change intent even for form inputs
	  var changeIntentMap = [9 // tab
	  ];

	  // mapping of events to input types
	  var inputMap = {
	    keydown: 'keyboard',
	    keyup: 'keyboard',
	    mousedown: 'mouse',
	    mousemove: 'mouse',
	    MSPointerDown: 'pointer',
	    MSPointerMove: 'pointer',
	    pointerdown: 'pointer',
	    pointermove: 'pointer',
	    touchstart: 'touch'
	  };

	  // array of all used input types
	  var inputTypes = [];

	  // boolean: true if touch buffer is active
	  var isBuffering = false;

	  // boolean: true if the page is being scrolled
	  var isScrolling = false;

	  // store current mouse position
	  var mousePos = {
	    x: null,
	    y: null
	  };

	  // map of IE 10 pointer events
	  var pointerMap = {
	    2: 'touch',
	    3: 'touch', // treat pen like touch
	    4: 'mouse'
	  };

	  var supportsPassive = false;

	  try {
	    var opts = Object.defineProperty({}, 'passive', {
	      get: function get() {
	        supportsPassive = true;
	      }
	    });

	    window.addEventListener('test', null, opts);
	  } catch (e) {}

	  /*
	   * set up
	   */

	  var setUp = function setUp() {
	    // add correct mouse wheel event mapping to `inputMap`
	    inputMap[detectWheel()] = 'mouse';

	    addListeners();
	    setInput();
	  };

	  /*
	   * events
	   */

	  var addListeners = function addListeners() {
	    // `pointermove`, `MSPointerMove`, `mousemove` and mouse wheel event binding
	    // can only demonstrate potential, but not actual, interaction
	    // and are treated separately
	    var options = supportsPassive ? { passive: true } : false;

	    // pointer events (mouse, pen, touch)
	    if (window.PointerEvent) {
	      doc.addEventListener('pointerdown', updateInput);
	      doc.addEventListener('pointermove', setIntent);
	    } else if (window.MSPointerEvent) {
	      doc.addEventListener('MSPointerDown', updateInput);
	      doc.addEventListener('MSPointerMove', setIntent);
	    } else {
	      // mouse events
	      doc.addEventListener('mousedown', updateInput);
	      doc.addEventListener('mousemove', setIntent);

	      // touch events
	      if ('ontouchstart' in window) {
	        doc.addEventListener('touchstart', touchBuffer, options);
	        doc.addEventListener('touchend', touchBuffer);
	      }
	    }

	    // mouse wheel
	    doc.addEventListener(detectWheel(), setIntent, options);

	    // keyboard events
	    doc.addEventListener('keydown', updateInput);
	    doc.addEventListener('keyup', updateInput);
	  };

	  // checks conditions before updating new input
	  var updateInput = function updateInput(event) {
	    // only execute if the touch buffer timer isn't running
	    if (!isBuffering) {
	      var eventKey = event.which;
	      var value = inputMap[event.type];
	      if (value === 'pointer') value = pointerType(event);

	      if (currentInput !== value || currentIntent !== value) {
	        var activeElem = document.activeElement;
	        var activeInput = false;
	        var notFormInput = activeElem && activeElem.nodeName && formInputs.indexOf(activeElem.nodeName.toLowerCase()) === -1;

	        if (notFormInput || changeIntentMap.indexOf(eventKey) !== -1) {
	          activeInput = true;
	        }

	        if (value === 'touch' ||
	        // ignore mouse modifier keys
	        value === 'mouse' ||
	        // don't switch if the current element is a form input
	        value === 'keyboard' && eventKey && activeInput && ignoreMap.indexOf(eventKey) === -1) {
	          // set the current and catch-all variable
	          currentInput = currentIntent = value;

	          setInput();
	        }
	      }
	    }
	  };

	  // updates the doc and `inputTypes` array with new input
	  var setInput = function setInput() {
	    doc.setAttribute('data-whatinput', currentInput);
	    doc.setAttribute('data-whatintent', currentInput);

	    if (inputTypes.indexOf(currentInput) === -1) {
	      inputTypes.push(currentInput);
	      doc.className += ' whatinput-types-' + currentInput;
	    }

	    fireFunctions('input');
	  };

	  // updates input intent for `mousemove` and `pointermove`
	  var setIntent = function setIntent(event) {
	    // test to see if `mousemove` happened relative to the screen
	    // to detect scrolling versus mousemove
	    if (mousePos['x'] !== event.screenX || mousePos['y'] !== event.screenY) {
	      isScrolling = false;

	      mousePos['x'] = event.screenX;
	      mousePos['y'] = event.screenY;
	    } else {
	      isScrolling = true;
	    }

	    // only execute if the touch buffer timer isn't running
	    // or scrolling isn't happening
	    if (!isBuffering && !isScrolling) {
	      var value = inputMap[event.type];
	      if (value === 'pointer') value = pointerType(event);

	      if (currentIntent !== value) {
	        currentIntent = value;

	        doc.setAttribute('data-whatintent', currentIntent);

	        fireFunctions('intent');
	      }
	    }
	  };

	  // buffers touch events because they frequently also fire mouse events
	  var touchBuffer = function touchBuffer(event) {
	    if (event.type === 'touchstart') {
	      isBuffering = false;

	      // set the current input
	      updateInput(event);
	    } else {
	      isBuffering = true;
	    }
	  };

	  var fireFunctions = function fireFunctions(type) {
	    for (var i = 0, len = functionList.length; i < len; i++) {
	      if (functionList[i].type === type) {
	        functionList[i].fn.call(undefined, currentIntent);
	      }
	    }
	  };

	  /*
	   * utilities
	   */

	  var pointerType = function pointerType(event) {
	    if (typeof event.pointerType === 'number') {
	      return pointerMap[event.pointerType];
	    } else {
	      // treat pen like touch
	      return event.pointerType === 'pen' ? 'touch' : event.pointerType;
	    }
	  };

	  // detect version of mouse wheel event to use
	  // via https://developer.mozilla.org/en-US/docs/Web/Events/wheel
	  var detectWheel = function detectWheel() {
	    var wheelType = void 0;

	    // Modern browsers support "wheel"
	    if ('onwheel' in document.createElement('div')) {
	      wheelType = 'wheel';
	    } else {
	      // Webkit and IE support at least "mousewheel"
	      // or assume that remaining browsers are older Firefox
	      wheelType = document.onmousewheel !== undefined ? 'mousewheel' : 'DOMMouseScroll';
	    }

	    return wheelType;
	  };

	  var objPos = function objPos(match) {
	    for (var i = 0, len = functionList.length; i < len; i++) {
	      if (functionList[i].fn === match) {
	        return i;
	      }
	    }
	  };

	  /*
	   * init
	   */

	  // don't start script unless browser cuts the mustard
	  // (also passes if polyfills are used)
	  if ('addEventListener' in window && Array.prototype.indexOf) {
	    setUp();
	  }

	  /*
	   * api
	   */

	  return {
	    // returns string: the current input type
	    // opt: 'loose'|'strict'
	    // 'strict' (default): returns the same value as the `data-whatinput` attribute
	    // 'loose': includes `data-whatintent` value if it's more current than `data-whatinput`
	    ask: function ask(opt) {
	      return opt === 'loose' ? currentIntent : currentInput;
	    },

	    // returns array: all the detected input types
	    types: function types() {
	      return inputTypes;
	    },

	    // overwrites ignored keys with provided array
	    ignoreKeys: function ignoreKeys(arr) {
	      ignoreMap = arr;
	    },

	    // attach functions to input and intent "events"
	    // funct: function to fire on change
	    // eventType: 'input'|'intent'
	    registerOnChange: function registerOnChange(fn, eventType) {
	      functionList.push({
	        fn: fn,
	        type: eventType || 'input'
	      });
	    },

	    unRegisterOnChange: function unRegisterOnChange(fn) {
	      var position = objPos(fn);

	      if (position) {
	        functionList.splice(position, 1);
	      }
	    }
	  };
	}();

/***/ }
/******/ ])
});
;
},{}]},{},[1]);
